
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire0c78"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire0c78"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("e7LDe", function(module, exports) {
module.exports = JSON.parse('{"Aacute":"\xc1","aacute":"\xe1","Abreve":"\u0102","abreve":"\u0103","ac":"\u223E","acd":"\u223F","acE":"\u223E\u0333","Acirc":"\xc2","acirc":"\xe2","acute":"\xb4","Acy":"\u0410","acy":"\u0430","AElig":"\xc6","aelig":"\xe6","af":"\u2061","Afr":"\uD835\uDD04","afr":"\uD835\uDD1E","Agrave":"\xc0","agrave":"\xe0","alefsym":"\u2135","aleph":"\u2135","Alpha":"\u0391","alpha":"\u03B1","Amacr":"\u0100","amacr":"\u0101","amalg":"\u2A3F","amp":"&","AMP":"&","andand":"\u2A55","And":"\u2A53","and":"\u2227","andd":"\u2A5C","andslope":"\u2A58","andv":"\u2A5A","ang":"\u2220","ange":"\u29A4","angle":"\u2220","angmsdaa":"\u29A8","angmsdab":"\u29A9","angmsdac":"\u29AA","angmsdad":"\u29AB","angmsdae":"\u29AC","angmsdaf":"\u29AD","angmsdag":"\u29AE","angmsdah":"\u29AF","angmsd":"\u2221","angrt":"\u221F","angrtvb":"\u22BE","angrtvbd":"\u299D","angsph":"\u2222","angst":"\xc5","angzarr":"\u237C","Aogon":"\u0104","aogon":"\u0105","Aopf":"\uD835\uDD38","aopf":"\uD835\uDD52","apacir":"\u2A6F","ap":"\u2248","apE":"\u2A70","ape":"\u224A","apid":"\u224B","apos":"\'","ApplyFunction":"\u2061","approx":"\u2248","approxeq":"\u224A","Aring":"\xc5","aring":"\xe5","Ascr":"\uD835\uDC9C","ascr":"\uD835\uDCB6","Assign":"\u2254","ast":"*","asymp":"\u2248","asympeq":"\u224D","Atilde":"\xc3","atilde":"\xe3","Auml":"\xc4","auml":"\xe4","awconint":"\u2233","awint":"\u2A11","backcong":"\u224C","backepsilon":"\u03F6","backprime":"\u2035","backsim":"\u223D","backsimeq":"\u22CD","Backslash":"\u2216","Barv":"\u2AE7","barvee":"\u22BD","barwed":"\u2305","Barwed":"\u2306","barwedge":"\u2305","bbrk":"\u23B5","bbrktbrk":"\u23B6","bcong":"\u224C","Bcy":"\u0411","bcy":"\u0431","bdquo":"\u201E","becaus":"\u2235","because":"\u2235","Because":"\u2235","bemptyv":"\u29B0","bepsi":"\u03F6","bernou":"\u212C","Bernoullis":"\u212C","Beta":"\u0392","beta":"\u03B2","beth":"\u2136","between":"\u226C","Bfr":"\uD835\uDD05","bfr":"\uD835\uDD1F","bigcap":"\u22C2","bigcirc":"\u25EF","bigcup":"\u22C3","bigodot":"\u2A00","bigoplus":"\u2A01","bigotimes":"\u2A02","bigsqcup":"\u2A06","bigstar":"\u2605","bigtriangledown":"\u25BD","bigtriangleup":"\u25B3","biguplus":"\u2A04","bigvee":"\u22C1","bigwedge":"\u22C0","bkarow":"\u290D","blacklozenge":"\u29EB","blacksquare":"\u25AA","blacktriangle":"\u25B4","blacktriangledown":"\u25BE","blacktriangleleft":"\u25C2","blacktriangleright":"\u25B8","blank":"\u2423","blk12":"\u2592","blk14":"\u2591","blk34":"\u2593","block":"\u2588","bne":"=\u20E5","bnequiv":"\u2261\u20E5","bNot":"\u2AED","bnot":"\u2310","Bopf":"\uD835\uDD39","bopf":"\uD835\uDD53","bot":"\u22A5","bottom":"\u22A5","bowtie":"\u22C8","boxbox":"\u29C9","boxdl":"\u2510","boxdL":"\u2555","boxDl":"\u2556","boxDL":"\u2557","boxdr":"\u250C","boxdR":"\u2552","boxDr":"\u2553","boxDR":"\u2554","boxh":"\u2500","boxH":"\u2550","boxhd":"\u252C","boxHd":"\u2564","boxhD":"\u2565","boxHD":"\u2566","boxhu":"\u2534","boxHu":"\u2567","boxhU":"\u2568","boxHU":"\u2569","boxminus":"\u229F","boxplus":"\u229E","boxtimes":"\u22A0","boxul":"\u2518","boxuL":"\u255B","boxUl":"\u255C","boxUL":"\u255D","boxur":"\u2514","boxuR":"\u2558","boxUr":"\u2559","boxUR":"\u255A","boxv":"\u2502","boxV":"\u2551","boxvh":"\u253C","boxvH":"\u256A","boxVh":"\u256B","boxVH":"\u256C","boxvl":"\u2524","boxvL":"\u2561","boxVl":"\u2562","boxVL":"\u2563","boxvr":"\u251C","boxvR":"\u255E","boxVr":"\u255F","boxVR":"\u2560","bprime":"\u2035","breve":"\u02D8","Breve":"\u02D8","brvbar":"\xa6","bscr":"\uD835\uDCB7","Bscr":"\u212C","bsemi":"\u204F","bsim":"\u223D","bsime":"\u22CD","bsolb":"\u29C5","bsol":"\\\\","bsolhsub":"\u27C8","bull":"\u2022","bullet":"\u2022","bump":"\u224E","bumpE":"\u2AAE","bumpe":"\u224F","Bumpeq":"\u224E","bumpeq":"\u224F","Cacute":"\u0106","cacute":"\u0107","capand":"\u2A44","capbrcup":"\u2A49","capcap":"\u2A4B","cap":"\u2229","Cap":"\u22D2","capcup":"\u2A47","capdot":"\u2A40","CapitalDifferentialD":"\u2145","caps":"\u2229\uFE00","caret":"\u2041","caron":"\u02C7","Cayleys":"\u212D","ccaps":"\u2A4D","Ccaron":"\u010C","ccaron":"\u010D","Ccedil":"\xc7","ccedil":"\xe7","Ccirc":"\u0108","ccirc":"\u0109","Cconint":"\u2230","ccups":"\u2A4C","ccupssm":"\u2A50","Cdot":"\u010A","cdot":"\u010B","cedil":"\xb8","Cedilla":"\xb8","cemptyv":"\u29B2","cent":"\xa2","centerdot":"\xb7","CenterDot":"\xb7","cfr":"\uD835\uDD20","Cfr":"\u212D","CHcy":"\u0427","chcy":"\u0447","check":"\u2713","checkmark":"\u2713","Chi":"\u03A7","chi":"\u03C7","circ":"\u02C6","circeq":"\u2257","circlearrowleft":"\u21BA","circlearrowright":"\u21BB","circledast":"\u229B","circledcirc":"\u229A","circleddash":"\u229D","CircleDot":"\u2299","circledR":"\xae","circledS":"\u24C8","CircleMinus":"\u2296","CirclePlus":"\u2295","CircleTimes":"\u2297","cir":"\u25CB","cirE":"\u29C3","cire":"\u2257","cirfnint":"\u2A10","cirmid":"\u2AEF","cirscir":"\u29C2","ClockwiseContourIntegral":"\u2232","CloseCurlyDoubleQuote":"\u201D","CloseCurlyQuote":"\u2019","clubs":"\u2663","clubsuit":"\u2663","colon":":","Colon":"\u2237","Colone":"\u2A74","colone":"\u2254","coloneq":"\u2254","comma":",","commat":"@","comp":"\u2201","compfn":"\u2218","complement":"\u2201","complexes":"\u2102","cong":"\u2245","congdot":"\u2A6D","Congruent":"\u2261","conint":"\u222E","Conint":"\u222F","ContourIntegral":"\u222E","copf":"\uD835\uDD54","Copf":"\u2102","coprod":"\u2210","Coproduct":"\u2210","copy":"\xa9","COPY":"\xa9","copysr":"\u2117","CounterClockwiseContourIntegral":"\u2233","crarr":"\u21B5","cross":"\u2717","Cross":"\u2A2F","Cscr":"\uD835\uDC9E","cscr":"\uD835\uDCB8","csub":"\u2ACF","csube":"\u2AD1","csup":"\u2AD0","csupe":"\u2AD2","ctdot":"\u22EF","cudarrl":"\u2938","cudarrr":"\u2935","cuepr":"\u22DE","cuesc":"\u22DF","cularr":"\u21B6","cularrp":"\u293D","cupbrcap":"\u2A48","cupcap":"\u2A46","CupCap":"\u224D","cup":"\u222A","Cup":"\u22D3","cupcup":"\u2A4A","cupdot":"\u228D","cupor":"\u2A45","cups":"\u222A\uFE00","curarr":"\u21B7","curarrm":"\u293C","curlyeqprec":"\u22DE","curlyeqsucc":"\u22DF","curlyvee":"\u22CE","curlywedge":"\u22CF","curren":"\xa4","curvearrowleft":"\u21B6","curvearrowright":"\u21B7","cuvee":"\u22CE","cuwed":"\u22CF","cwconint":"\u2232","cwint":"\u2231","cylcty":"\u232D","dagger":"\u2020","Dagger":"\u2021","daleth":"\u2138","darr":"\u2193","Darr":"\u21A1","dArr":"\u21D3","dash":"\u2010","Dashv":"\u2AE4","dashv":"\u22A3","dbkarow":"\u290F","dblac":"\u02DD","Dcaron":"\u010E","dcaron":"\u010F","Dcy":"\u0414","dcy":"\u0434","ddagger":"\u2021","ddarr":"\u21CA","DD":"\u2145","dd":"\u2146","DDotrahd":"\u2911","ddotseq":"\u2A77","deg":"\xb0","Del":"\u2207","Delta":"\u0394","delta":"\u03B4","demptyv":"\u29B1","dfisht":"\u297F","Dfr":"\uD835\uDD07","dfr":"\uD835\uDD21","dHar":"\u2965","dharl":"\u21C3","dharr":"\u21C2","DiacriticalAcute":"\xb4","DiacriticalDot":"\u02D9","DiacriticalDoubleAcute":"\u02DD","DiacriticalGrave":"`","DiacriticalTilde":"\u02DC","diam":"\u22C4","diamond":"\u22C4","Diamond":"\u22C4","diamondsuit":"\u2666","diams":"\u2666","die":"\xa8","DifferentialD":"\u2146","digamma":"\u03DD","disin":"\u22F2","div":"\xf7","divide":"\xf7","divideontimes":"\u22C7","divonx":"\u22C7","DJcy":"\u0402","djcy":"\u0452","dlcorn":"\u231E","dlcrop":"\u230D","dollar":"$","Dopf":"\uD835\uDD3B","dopf":"\uD835\uDD55","Dot":"\xa8","dot":"\u02D9","DotDot":"\u20DC","doteq":"\u2250","doteqdot":"\u2251","DotEqual":"\u2250","dotminus":"\u2238","dotplus":"\u2214","dotsquare":"\u22A1","doublebarwedge":"\u2306","DoubleContourIntegral":"\u222F","DoubleDot":"\xa8","DoubleDownArrow":"\u21D3","DoubleLeftArrow":"\u21D0","DoubleLeftRightArrow":"\u21D4","DoubleLeftTee":"\u2AE4","DoubleLongLeftArrow":"\u27F8","DoubleLongLeftRightArrow":"\u27FA","DoubleLongRightArrow":"\u27F9","DoubleRightArrow":"\u21D2","DoubleRightTee":"\u22A8","DoubleUpArrow":"\u21D1","DoubleUpDownArrow":"\u21D5","DoubleVerticalBar":"\u2225","DownArrowBar":"\u2913","downarrow":"\u2193","DownArrow":"\u2193","Downarrow":"\u21D3","DownArrowUpArrow":"\u21F5","DownBreve":"\u0311","downdownarrows":"\u21CA","downharpoonleft":"\u21C3","downharpoonright":"\u21C2","DownLeftRightVector":"\u2950","DownLeftTeeVector":"\u295E","DownLeftVectorBar":"\u2956","DownLeftVector":"\u21BD","DownRightTeeVector":"\u295F","DownRightVectorBar":"\u2957","DownRightVector":"\u21C1","DownTeeArrow":"\u21A7","DownTee":"\u22A4","drbkarow":"\u2910","drcorn":"\u231F","drcrop":"\u230C","Dscr":"\uD835\uDC9F","dscr":"\uD835\uDCB9","DScy":"\u0405","dscy":"\u0455","dsol":"\u29F6","Dstrok":"\u0110","dstrok":"\u0111","dtdot":"\u22F1","dtri":"\u25BF","dtrif":"\u25BE","duarr":"\u21F5","duhar":"\u296F","dwangle":"\u29A6","DZcy":"\u040F","dzcy":"\u045F","dzigrarr":"\u27FF","Eacute":"\xc9","eacute":"\xe9","easter":"\u2A6E","Ecaron":"\u011A","ecaron":"\u011B","Ecirc":"\xca","ecirc":"\xea","ecir":"\u2256","ecolon":"\u2255","Ecy":"\u042D","ecy":"\u044D","eDDot":"\u2A77","Edot":"\u0116","edot":"\u0117","eDot":"\u2251","ee":"\u2147","efDot":"\u2252","Efr":"\uD835\uDD08","efr":"\uD835\uDD22","eg":"\u2A9A","Egrave":"\xc8","egrave":"\xe8","egs":"\u2A96","egsdot":"\u2A98","el":"\u2A99","Element":"\u2208","elinters":"\u23E7","ell":"\u2113","els":"\u2A95","elsdot":"\u2A97","Emacr":"\u0112","emacr":"\u0113","empty":"\u2205","emptyset":"\u2205","EmptySmallSquare":"\u25FB","emptyv":"\u2205","EmptyVerySmallSquare":"\u25AB","emsp13":"\u2004","emsp14":"\u2005","emsp":"\u2003","ENG":"\u014A","eng":"\u014B","ensp":"\u2002","Eogon":"\u0118","eogon":"\u0119","Eopf":"\uD835\uDD3C","eopf":"\uD835\uDD56","epar":"\u22D5","eparsl":"\u29E3","eplus":"\u2A71","epsi":"\u03B5","Epsilon":"\u0395","epsilon":"\u03B5","epsiv":"\u03F5","eqcirc":"\u2256","eqcolon":"\u2255","eqsim":"\u2242","eqslantgtr":"\u2A96","eqslantless":"\u2A95","Equal":"\u2A75","equals":"=","EqualTilde":"\u2242","equest":"\u225F","Equilibrium":"\u21CC","equiv":"\u2261","equivDD":"\u2A78","eqvparsl":"\u29E5","erarr":"\u2971","erDot":"\u2253","escr":"\u212F","Escr":"\u2130","esdot":"\u2250","Esim":"\u2A73","esim":"\u2242","Eta":"\u0397","eta":"\u03B7","ETH":"\xd0","eth":"\xf0","Euml":"\xcb","euml":"\xeb","euro":"\u20AC","excl":"!","exist":"\u2203","Exists":"\u2203","expectation":"\u2130","exponentiale":"\u2147","ExponentialE":"\u2147","fallingdotseq":"\u2252","Fcy":"\u0424","fcy":"\u0444","female":"\u2640","ffilig":"\uFB03","fflig":"\uFB00","ffllig":"\uFB04","Ffr":"\uD835\uDD09","ffr":"\uD835\uDD23","filig":"\uFB01","FilledSmallSquare":"\u25FC","FilledVerySmallSquare":"\u25AA","fjlig":"fj","flat":"\u266D","fllig":"\uFB02","fltns":"\u25B1","fnof":"\u0192","Fopf":"\uD835\uDD3D","fopf":"\uD835\uDD57","forall":"\u2200","ForAll":"\u2200","fork":"\u22D4","forkv":"\u2AD9","Fouriertrf":"\u2131","fpartint":"\u2A0D","frac12":"\xbd","frac13":"\u2153","frac14":"\xbc","frac15":"\u2155","frac16":"\u2159","frac18":"\u215B","frac23":"\u2154","frac25":"\u2156","frac34":"\xbe","frac35":"\u2157","frac38":"\u215C","frac45":"\u2158","frac56":"\u215A","frac58":"\u215D","frac78":"\u215E","frasl":"\u2044","frown":"\u2322","fscr":"\uD835\uDCBB","Fscr":"\u2131","gacute":"\u01F5","Gamma":"\u0393","gamma":"\u03B3","Gammad":"\u03DC","gammad":"\u03DD","gap":"\u2A86","Gbreve":"\u011E","gbreve":"\u011F","Gcedil":"\u0122","Gcirc":"\u011C","gcirc":"\u011D","Gcy":"\u0413","gcy":"\u0433","Gdot":"\u0120","gdot":"\u0121","ge":"\u2265","gE":"\u2267","gEl":"\u2A8C","gel":"\u22DB","geq":"\u2265","geqq":"\u2267","geqslant":"\u2A7E","gescc":"\u2AA9","ges":"\u2A7E","gesdot":"\u2A80","gesdoto":"\u2A82","gesdotol":"\u2A84","gesl":"\u22DB\uFE00","gesles":"\u2A94","Gfr":"\uD835\uDD0A","gfr":"\uD835\uDD24","gg":"\u226B","Gg":"\u22D9","ggg":"\u22D9","gimel":"\u2137","GJcy":"\u0403","gjcy":"\u0453","gla":"\u2AA5","gl":"\u2277","glE":"\u2A92","glj":"\u2AA4","gnap":"\u2A8A","gnapprox":"\u2A8A","gne":"\u2A88","gnE":"\u2269","gneq":"\u2A88","gneqq":"\u2269","gnsim":"\u22E7","Gopf":"\uD835\uDD3E","gopf":"\uD835\uDD58","grave":"`","GreaterEqual":"\u2265","GreaterEqualLess":"\u22DB","GreaterFullEqual":"\u2267","GreaterGreater":"\u2AA2","GreaterLess":"\u2277","GreaterSlantEqual":"\u2A7E","GreaterTilde":"\u2273","Gscr":"\uD835\uDCA2","gscr":"\u210A","gsim":"\u2273","gsime":"\u2A8E","gsiml":"\u2A90","gtcc":"\u2AA7","gtcir":"\u2A7A","gt":">","GT":">","Gt":"\u226B","gtdot":"\u22D7","gtlPar":"\u2995","gtquest":"\u2A7C","gtrapprox":"\u2A86","gtrarr":"\u2978","gtrdot":"\u22D7","gtreqless":"\u22DB","gtreqqless":"\u2A8C","gtrless":"\u2277","gtrsim":"\u2273","gvertneqq":"\u2269\uFE00","gvnE":"\u2269\uFE00","Hacek":"\u02C7","hairsp":"\u200A","half":"\xbd","hamilt":"\u210B","HARDcy":"\u042A","hardcy":"\u044A","harrcir":"\u2948","harr":"\u2194","hArr":"\u21D4","harrw":"\u21AD","Hat":"^","hbar":"\u210F","Hcirc":"\u0124","hcirc":"\u0125","hearts":"\u2665","heartsuit":"\u2665","hellip":"\u2026","hercon":"\u22B9","hfr":"\uD835\uDD25","Hfr":"\u210C","HilbertSpace":"\u210B","hksearow":"\u2925","hkswarow":"\u2926","hoarr":"\u21FF","homtht":"\u223B","hookleftarrow":"\u21A9","hookrightarrow":"\u21AA","hopf":"\uD835\uDD59","Hopf":"\u210D","horbar":"\u2015","HorizontalLine":"\u2500","hscr":"\uD835\uDCBD","Hscr":"\u210B","hslash":"\u210F","Hstrok":"\u0126","hstrok":"\u0127","HumpDownHump":"\u224E","HumpEqual":"\u224F","hybull":"\u2043","hyphen":"\u2010","Iacute":"\xcd","iacute":"\xed","ic":"\u2063","Icirc":"\xce","icirc":"\xee","Icy":"\u0418","icy":"\u0438","Idot":"\u0130","IEcy":"\u0415","iecy":"\u0435","iexcl":"\xa1","iff":"\u21D4","ifr":"\uD835\uDD26","Ifr":"\u2111","Igrave":"\xcc","igrave":"\xec","ii":"\u2148","iiiint":"\u2A0C","iiint":"\u222D","iinfin":"\u29DC","iiota":"\u2129","IJlig":"\u0132","ijlig":"\u0133","Imacr":"\u012A","imacr":"\u012B","image":"\u2111","ImaginaryI":"\u2148","imagline":"\u2110","imagpart":"\u2111","imath":"\u0131","Im":"\u2111","imof":"\u22B7","imped":"\u01B5","Implies":"\u21D2","incare":"\u2105","in":"\u2208","infin":"\u221E","infintie":"\u29DD","inodot":"\u0131","intcal":"\u22BA","int":"\u222B","Int":"\u222C","integers":"\u2124","Integral":"\u222B","intercal":"\u22BA","Intersection":"\u22C2","intlarhk":"\u2A17","intprod":"\u2A3C","InvisibleComma":"\u2063","InvisibleTimes":"\u2062","IOcy":"\u0401","iocy":"\u0451","Iogon":"\u012E","iogon":"\u012F","Iopf":"\uD835\uDD40","iopf":"\uD835\uDD5A","Iota":"\u0399","iota":"\u03B9","iprod":"\u2A3C","iquest":"\xbf","iscr":"\uD835\uDCBE","Iscr":"\u2110","isin":"\u2208","isindot":"\u22F5","isinE":"\u22F9","isins":"\u22F4","isinsv":"\u22F3","isinv":"\u2208","it":"\u2062","Itilde":"\u0128","itilde":"\u0129","Iukcy":"\u0406","iukcy":"\u0456","Iuml":"\xcf","iuml":"\xef","Jcirc":"\u0134","jcirc":"\u0135","Jcy":"\u0419","jcy":"\u0439","Jfr":"\uD835\uDD0D","jfr":"\uD835\uDD27","jmath":"\u0237","Jopf":"\uD835\uDD41","jopf":"\uD835\uDD5B","Jscr":"\uD835\uDCA5","jscr":"\uD835\uDCBF","Jsercy":"\u0408","jsercy":"\u0458","Jukcy":"\u0404","jukcy":"\u0454","Kappa":"\u039A","kappa":"\u03BA","kappav":"\u03F0","Kcedil":"\u0136","kcedil":"\u0137","Kcy":"\u041A","kcy":"\u043A","Kfr":"\uD835\uDD0E","kfr":"\uD835\uDD28","kgreen":"\u0138","KHcy":"\u0425","khcy":"\u0445","KJcy":"\u040C","kjcy":"\u045C","Kopf":"\uD835\uDD42","kopf":"\uD835\uDD5C","Kscr":"\uD835\uDCA6","kscr":"\uD835\uDCC0","lAarr":"\u21DA","Lacute":"\u0139","lacute":"\u013A","laemptyv":"\u29B4","lagran":"\u2112","Lambda":"\u039B","lambda":"\u03BB","lang":"\u27E8","Lang":"\u27EA","langd":"\u2991","langle":"\u27E8","lap":"\u2A85","Laplacetrf":"\u2112","laquo":"\xab","larrb":"\u21E4","larrbfs":"\u291F","larr":"\u2190","Larr":"\u219E","lArr":"\u21D0","larrfs":"\u291D","larrhk":"\u21A9","larrlp":"\u21AB","larrpl":"\u2939","larrsim":"\u2973","larrtl":"\u21A2","latail":"\u2919","lAtail":"\u291B","lat":"\u2AAB","late":"\u2AAD","lates":"\u2AAD\uFE00","lbarr":"\u290C","lBarr":"\u290E","lbbrk":"\u2772","lbrace":"{","lbrack":"[","lbrke":"\u298B","lbrksld":"\u298F","lbrkslu":"\u298D","Lcaron":"\u013D","lcaron":"\u013E","Lcedil":"\u013B","lcedil":"\u013C","lceil":"\u2308","lcub":"{","Lcy":"\u041B","lcy":"\u043B","ldca":"\u2936","ldquo":"\u201C","ldquor":"\u201E","ldrdhar":"\u2967","ldrushar":"\u294B","ldsh":"\u21B2","le":"\u2264","lE":"\u2266","LeftAngleBracket":"\u27E8","LeftArrowBar":"\u21E4","leftarrow":"\u2190","LeftArrow":"\u2190","Leftarrow":"\u21D0","LeftArrowRightArrow":"\u21C6","leftarrowtail":"\u21A2","LeftCeiling":"\u2308","LeftDoubleBracket":"\u27E6","LeftDownTeeVector":"\u2961","LeftDownVectorBar":"\u2959","LeftDownVector":"\u21C3","LeftFloor":"\u230A","leftharpoondown":"\u21BD","leftharpoonup":"\u21BC","leftleftarrows":"\u21C7","leftrightarrow":"\u2194","LeftRightArrow":"\u2194","Leftrightarrow":"\u21D4","leftrightarrows":"\u21C6","leftrightharpoons":"\u21CB","leftrightsquigarrow":"\u21AD","LeftRightVector":"\u294E","LeftTeeArrow":"\u21A4","LeftTee":"\u22A3","LeftTeeVector":"\u295A","leftthreetimes":"\u22CB","LeftTriangleBar":"\u29CF","LeftTriangle":"\u22B2","LeftTriangleEqual":"\u22B4","LeftUpDownVector":"\u2951","LeftUpTeeVector":"\u2960","LeftUpVectorBar":"\u2958","LeftUpVector":"\u21BF","LeftVectorBar":"\u2952","LeftVector":"\u21BC","lEg":"\u2A8B","leg":"\u22DA","leq":"\u2264","leqq":"\u2266","leqslant":"\u2A7D","lescc":"\u2AA8","les":"\u2A7D","lesdot":"\u2A7F","lesdoto":"\u2A81","lesdotor":"\u2A83","lesg":"\u22DA\uFE00","lesges":"\u2A93","lessapprox":"\u2A85","lessdot":"\u22D6","lesseqgtr":"\u22DA","lesseqqgtr":"\u2A8B","LessEqualGreater":"\u22DA","LessFullEqual":"\u2266","LessGreater":"\u2276","lessgtr":"\u2276","LessLess":"\u2AA1","lesssim":"\u2272","LessSlantEqual":"\u2A7D","LessTilde":"\u2272","lfisht":"\u297C","lfloor":"\u230A","Lfr":"\uD835\uDD0F","lfr":"\uD835\uDD29","lg":"\u2276","lgE":"\u2A91","lHar":"\u2962","lhard":"\u21BD","lharu":"\u21BC","lharul":"\u296A","lhblk":"\u2584","LJcy":"\u0409","ljcy":"\u0459","llarr":"\u21C7","ll":"\u226A","Ll":"\u22D8","llcorner":"\u231E","Lleftarrow":"\u21DA","llhard":"\u296B","lltri":"\u25FA","Lmidot":"\u013F","lmidot":"\u0140","lmoustache":"\u23B0","lmoust":"\u23B0","lnap":"\u2A89","lnapprox":"\u2A89","lne":"\u2A87","lnE":"\u2268","lneq":"\u2A87","lneqq":"\u2268","lnsim":"\u22E6","loang":"\u27EC","loarr":"\u21FD","lobrk":"\u27E6","longleftarrow":"\u27F5","LongLeftArrow":"\u27F5","Longleftarrow":"\u27F8","longleftrightarrow":"\u27F7","LongLeftRightArrow":"\u27F7","Longleftrightarrow":"\u27FA","longmapsto":"\u27FC","longrightarrow":"\u27F6","LongRightArrow":"\u27F6","Longrightarrow":"\u27F9","looparrowleft":"\u21AB","looparrowright":"\u21AC","lopar":"\u2985","Lopf":"\uD835\uDD43","lopf":"\uD835\uDD5D","loplus":"\u2A2D","lotimes":"\u2A34","lowast":"\u2217","lowbar":"_","LowerLeftArrow":"\u2199","LowerRightArrow":"\u2198","loz":"\u25CA","lozenge":"\u25CA","lozf":"\u29EB","lpar":"(","lparlt":"\u2993","lrarr":"\u21C6","lrcorner":"\u231F","lrhar":"\u21CB","lrhard":"\u296D","lrm":"\u200E","lrtri":"\u22BF","lsaquo":"\u2039","lscr":"\uD835\uDCC1","Lscr":"\u2112","lsh":"\u21B0","Lsh":"\u21B0","lsim":"\u2272","lsime":"\u2A8D","lsimg":"\u2A8F","lsqb":"[","lsquo":"\u2018","lsquor":"\u201A","Lstrok":"\u0141","lstrok":"\u0142","ltcc":"\u2AA6","ltcir":"\u2A79","lt":"<","LT":"<","Lt":"\u226A","ltdot":"\u22D6","lthree":"\u22CB","ltimes":"\u22C9","ltlarr":"\u2976","ltquest":"\u2A7B","ltri":"\u25C3","ltrie":"\u22B4","ltrif":"\u25C2","ltrPar":"\u2996","lurdshar":"\u294A","luruhar":"\u2966","lvertneqq":"\u2268\uFE00","lvnE":"\u2268\uFE00","macr":"\xaf","male":"\u2642","malt":"\u2720","maltese":"\u2720","Map":"\u2905","map":"\u21A6","mapsto":"\u21A6","mapstodown":"\u21A7","mapstoleft":"\u21A4","mapstoup":"\u21A5","marker":"\u25AE","mcomma":"\u2A29","Mcy":"\u041C","mcy":"\u043C","mdash":"\u2014","mDDot":"\u223A","measuredangle":"\u2221","MediumSpace":"\u205F","Mellintrf":"\u2133","Mfr":"\uD835\uDD10","mfr":"\uD835\uDD2A","mho":"\u2127","micro":"\xb5","midast":"*","midcir":"\u2AF0","mid":"\u2223","middot":"\xb7","minusb":"\u229F","minus":"\u2212","minusd":"\u2238","minusdu":"\u2A2A","MinusPlus":"\u2213","mlcp":"\u2ADB","mldr":"\u2026","mnplus":"\u2213","models":"\u22A7","Mopf":"\uD835\uDD44","mopf":"\uD835\uDD5E","mp":"\u2213","mscr":"\uD835\uDCC2","Mscr":"\u2133","mstpos":"\u223E","Mu":"\u039C","mu":"\u03BC","multimap":"\u22B8","mumap":"\u22B8","nabla":"\u2207","Nacute":"\u0143","nacute":"\u0144","nang":"\u2220\u20D2","nap":"\u2249","napE":"\u2A70\u0338","napid":"\u224B\u0338","napos":"\u0149","napprox":"\u2249","natural":"\u266E","naturals":"\u2115","natur":"\u266E","nbsp":"\xa0","nbump":"\u224E\u0338","nbumpe":"\u224F\u0338","ncap":"\u2A43","Ncaron":"\u0147","ncaron":"\u0148","Ncedil":"\u0145","ncedil":"\u0146","ncong":"\u2247","ncongdot":"\u2A6D\u0338","ncup":"\u2A42","Ncy":"\u041D","ncy":"\u043D","ndash":"\u2013","nearhk":"\u2924","nearr":"\u2197","neArr":"\u21D7","nearrow":"\u2197","ne":"\u2260","nedot":"\u2250\u0338","NegativeMediumSpace":"\u200B","NegativeThickSpace":"\u200B","NegativeThinSpace":"\u200B","NegativeVeryThinSpace":"\u200B","nequiv":"\u2262","nesear":"\u2928","nesim":"\u2242\u0338","NestedGreaterGreater":"\u226B","NestedLessLess":"\u226A","NewLine":"\\n","nexist":"\u2204","nexists":"\u2204","Nfr":"\uD835\uDD11","nfr":"\uD835\uDD2B","ngE":"\u2267\u0338","nge":"\u2271","ngeq":"\u2271","ngeqq":"\u2267\u0338","ngeqslant":"\u2A7E\u0338","nges":"\u2A7E\u0338","nGg":"\u22D9\u0338","ngsim":"\u2275","nGt":"\u226B\u20D2","ngt":"\u226F","ngtr":"\u226F","nGtv":"\u226B\u0338","nharr":"\u21AE","nhArr":"\u21CE","nhpar":"\u2AF2","ni":"\u220B","nis":"\u22FC","nisd":"\u22FA","niv":"\u220B","NJcy":"\u040A","njcy":"\u045A","nlarr":"\u219A","nlArr":"\u21CD","nldr":"\u2025","nlE":"\u2266\u0338","nle":"\u2270","nleftarrow":"\u219A","nLeftarrow":"\u21CD","nleftrightarrow":"\u21AE","nLeftrightarrow":"\u21CE","nleq":"\u2270","nleqq":"\u2266\u0338","nleqslant":"\u2A7D\u0338","nles":"\u2A7D\u0338","nless":"\u226E","nLl":"\u22D8\u0338","nlsim":"\u2274","nLt":"\u226A\u20D2","nlt":"\u226E","nltri":"\u22EA","nltrie":"\u22EC","nLtv":"\u226A\u0338","nmid":"\u2224","NoBreak":"\u2060","NonBreakingSpace":"\xa0","nopf":"\uD835\uDD5F","Nopf":"\u2115","Not":"\u2AEC","not":"\xac","NotCongruent":"\u2262","NotCupCap":"\u226D","NotDoubleVerticalBar":"\u2226","NotElement":"\u2209","NotEqual":"\u2260","NotEqualTilde":"\u2242\u0338","NotExists":"\u2204","NotGreater":"\u226F","NotGreaterEqual":"\u2271","NotGreaterFullEqual":"\u2267\u0338","NotGreaterGreater":"\u226B\u0338","NotGreaterLess":"\u2279","NotGreaterSlantEqual":"\u2A7E\u0338","NotGreaterTilde":"\u2275","NotHumpDownHump":"\u224E\u0338","NotHumpEqual":"\u224F\u0338","notin":"\u2209","notindot":"\u22F5\u0338","notinE":"\u22F9\u0338","notinva":"\u2209","notinvb":"\u22F7","notinvc":"\u22F6","NotLeftTriangleBar":"\u29CF\u0338","NotLeftTriangle":"\u22EA","NotLeftTriangleEqual":"\u22EC","NotLess":"\u226E","NotLessEqual":"\u2270","NotLessGreater":"\u2278","NotLessLess":"\u226A\u0338","NotLessSlantEqual":"\u2A7D\u0338","NotLessTilde":"\u2274","NotNestedGreaterGreater":"\u2AA2\u0338","NotNestedLessLess":"\u2AA1\u0338","notni":"\u220C","notniva":"\u220C","notnivb":"\u22FE","notnivc":"\u22FD","NotPrecedes":"\u2280","NotPrecedesEqual":"\u2AAF\u0338","NotPrecedesSlantEqual":"\u22E0","NotReverseElement":"\u220C","NotRightTriangleBar":"\u29D0\u0338","NotRightTriangle":"\u22EB","NotRightTriangleEqual":"\u22ED","NotSquareSubset":"\u228F\u0338","NotSquareSubsetEqual":"\u22E2","NotSquareSuperset":"\u2290\u0338","NotSquareSupersetEqual":"\u22E3","NotSubset":"\u2282\u20D2","NotSubsetEqual":"\u2288","NotSucceeds":"\u2281","NotSucceedsEqual":"\u2AB0\u0338","NotSucceedsSlantEqual":"\u22E1","NotSucceedsTilde":"\u227F\u0338","NotSuperset":"\u2283\u20D2","NotSupersetEqual":"\u2289","NotTilde":"\u2241","NotTildeEqual":"\u2244","NotTildeFullEqual":"\u2247","NotTildeTilde":"\u2249","NotVerticalBar":"\u2224","nparallel":"\u2226","npar":"\u2226","nparsl":"\u2AFD\u20E5","npart":"\u2202\u0338","npolint":"\u2A14","npr":"\u2280","nprcue":"\u22E0","nprec":"\u2280","npreceq":"\u2AAF\u0338","npre":"\u2AAF\u0338","nrarrc":"\u2933\u0338","nrarr":"\u219B","nrArr":"\u21CF","nrarrw":"\u219D\u0338","nrightarrow":"\u219B","nRightarrow":"\u21CF","nrtri":"\u22EB","nrtrie":"\u22ED","nsc":"\u2281","nsccue":"\u22E1","nsce":"\u2AB0\u0338","Nscr":"\uD835\uDCA9","nscr":"\uD835\uDCC3","nshortmid":"\u2224","nshortparallel":"\u2226","nsim":"\u2241","nsime":"\u2244","nsimeq":"\u2244","nsmid":"\u2224","nspar":"\u2226","nsqsube":"\u22E2","nsqsupe":"\u22E3","nsub":"\u2284","nsubE":"\u2AC5\u0338","nsube":"\u2288","nsubset":"\u2282\u20D2","nsubseteq":"\u2288","nsubseteqq":"\u2AC5\u0338","nsucc":"\u2281","nsucceq":"\u2AB0\u0338","nsup":"\u2285","nsupE":"\u2AC6\u0338","nsupe":"\u2289","nsupset":"\u2283\u20D2","nsupseteq":"\u2289","nsupseteqq":"\u2AC6\u0338","ntgl":"\u2279","Ntilde":"\xd1","ntilde":"\xf1","ntlg":"\u2278","ntriangleleft":"\u22EA","ntrianglelefteq":"\u22EC","ntriangleright":"\u22EB","ntrianglerighteq":"\u22ED","Nu":"\u039D","nu":"\u03BD","num":"#","numero":"\u2116","numsp":"\u2007","nvap":"\u224D\u20D2","nvdash":"\u22AC","nvDash":"\u22AD","nVdash":"\u22AE","nVDash":"\u22AF","nvge":"\u2265\u20D2","nvgt":">\u20D2","nvHarr":"\u2904","nvinfin":"\u29DE","nvlArr":"\u2902","nvle":"\u2264\u20D2","nvlt":"<\u20D2","nvltrie":"\u22B4\u20D2","nvrArr":"\u2903","nvrtrie":"\u22B5\u20D2","nvsim":"\u223C\u20D2","nwarhk":"\u2923","nwarr":"\u2196","nwArr":"\u21D6","nwarrow":"\u2196","nwnear":"\u2927","Oacute":"\xd3","oacute":"\xf3","oast":"\u229B","Ocirc":"\xd4","ocirc":"\xf4","ocir":"\u229A","Ocy":"\u041E","ocy":"\u043E","odash":"\u229D","Odblac":"\u0150","odblac":"\u0151","odiv":"\u2A38","odot":"\u2299","odsold":"\u29BC","OElig":"\u0152","oelig":"\u0153","ofcir":"\u29BF","Ofr":"\uD835\uDD12","ofr":"\uD835\uDD2C","ogon":"\u02DB","Ograve":"\xd2","ograve":"\xf2","ogt":"\u29C1","ohbar":"\u29B5","ohm":"\u03A9","oint":"\u222E","olarr":"\u21BA","olcir":"\u29BE","olcross":"\u29BB","oline":"\u203E","olt":"\u29C0","Omacr":"\u014C","omacr":"\u014D","Omega":"\u03A9","omega":"\u03C9","Omicron":"\u039F","omicron":"\u03BF","omid":"\u29B6","ominus":"\u2296","Oopf":"\uD835\uDD46","oopf":"\uD835\uDD60","opar":"\u29B7","OpenCurlyDoubleQuote":"\u201C","OpenCurlyQuote":"\u2018","operp":"\u29B9","oplus":"\u2295","orarr":"\u21BB","Or":"\u2A54","or":"\u2228","ord":"\u2A5D","order":"\u2134","orderof":"\u2134","ordf":"\xaa","ordm":"\xba","origof":"\u22B6","oror":"\u2A56","orslope":"\u2A57","orv":"\u2A5B","oS":"\u24C8","Oscr":"\uD835\uDCAA","oscr":"\u2134","Oslash":"\xd8","oslash":"\xf8","osol":"\u2298","Otilde":"\xd5","otilde":"\xf5","otimesas":"\u2A36","Otimes":"\u2A37","otimes":"\u2297","Ouml":"\xd6","ouml":"\xf6","ovbar":"\u233D","OverBar":"\u203E","OverBrace":"\u23DE","OverBracket":"\u23B4","OverParenthesis":"\u23DC","para":"\xb6","parallel":"\u2225","par":"\u2225","parsim":"\u2AF3","parsl":"\u2AFD","part":"\u2202","PartialD":"\u2202","Pcy":"\u041F","pcy":"\u043F","percnt":"%","period":".","permil":"\u2030","perp":"\u22A5","pertenk":"\u2031","Pfr":"\uD835\uDD13","pfr":"\uD835\uDD2D","Phi":"\u03A6","phi":"\u03C6","phiv":"\u03D5","phmmat":"\u2133","phone":"\u260E","Pi":"\u03A0","pi":"\u03C0","pitchfork":"\u22D4","piv":"\u03D6","planck":"\u210F","planckh":"\u210E","plankv":"\u210F","plusacir":"\u2A23","plusb":"\u229E","pluscir":"\u2A22","plus":"+","plusdo":"\u2214","plusdu":"\u2A25","pluse":"\u2A72","PlusMinus":"\xb1","plusmn":"\xb1","plussim":"\u2A26","plustwo":"\u2A27","pm":"\xb1","Poincareplane":"\u210C","pointint":"\u2A15","popf":"\uD835\uDD61","Popf":"\u2119","pound":"\xa3","prap":"\u2AB7","Pr":"\u2ABB","pr":"\u227A","prcue":"\u227C","precapprox":"\u2AB7","prec":"\u227A","preccurlyeq":"\u227C","Precedes":"\u227A","PrecedesEqual":"\u2AAF","PrecedesSlantEqual":"\u227C","PrecedesTilde":"\u227E","preceq":"\u2AAF","precnapprox":"\u2AB9","precneqq":"\u2AB5","precnsim":"\u22E8","pre":"\u2AAF","prE":"\u2AB3","precsim":"\u227E","prime":"\u2032","Prime":"\u2033","primes":"\u2119","prnap":"\u2AB9","prnE":"\u2AB5","prnsim":"\u22E8","prod":"\u220F","Product":"\u220F","profalar":"\u232E","profline":"\u2312","profsurf":"\u2313","prop":"\u221D","Proportional":"\u221D","Proportion":"\u2237","propto":"\u221D","prsim":"\u227E","prurel":"\u22B0","Pscr":"\uD835\uDCAB","pscr":"\uD835\uDCC5","Psi":"\u03A8","psi":"\u03C8","puncsp":"\u2008","Qfr":"\uD835\uDD14","qfr":"\uD835\uDD2E","qint":"\u2A0C","qopf":"\uD835\uDD62","Qopf":"\u211A","qprime":"\u2057","Qscr":"\uD835\uDCAC","qscr":"\uD835\uDCC6","quaternions":"\u210D","quatint":"\u2A16","quest":"?","questeq":"\u225F","quot":"\\"","QUOT":"\\"","rAarr":"\u21DB","race":"\u223D\u0331","Racute":"\u0154","racute":"\u0155","radic":"\u221A","raemptyv":"\u29B3","rang":"\u27E9","Rang":"\u27EB","rangd":"\u2992","range":"\u29A5","rangle":"\u27E9","raquo":"\xbb","rarrap":"\u2975","rarrb":"\u21E5","rarrbfs":"\u2920","rarrc":"\u2933","rarr":"\u2192","Rarr":"\u21A0","rArr":"\u21D2","rarrfs":"\u291E","rarrhk":"\u21AA","rarrlp":"\u21AC","rarrpl":"\u2945","rarrsim":"\u2974","Rarrtl":"\u2916","rarrtl":"\u21A3","rarrw":"\u219D","ratail":"\u291A","rAtail":"\u291C","ratio":"\u2236","rationals":"\u211A","rbarr":"\u290D","rBarr":"\u290F","RBarr":"\u2910","rbbrk":"\u2773","rbrace":"}","rbrack":"]","rbrke":"\u298C","rbrksld":"\u298E","rbrkslu":"\u2990","Rcaron":"\u0158","rcaron":"\u0159","Rcedil":"\u0156","rcedil":"\u0157","rceil":"\u2309","rcub":"}","Rcy":"\u0420","rcy":"\u0440","rdca":"\u2937","rdldhar":"\u2969","rdquo":"\u201D","rdquor":"\u201D","rdsh":"\u21B3","real":"\u211C","realine":"\u211B","realpart":"\u211C","reals":"\u211D","Re":"\u211C","rect":"\u25AD","reg":"\xae","REG":"\xae","ReverseElement":"\u220B","ReverseEquilibrium":"\u21CB","ReverseUpEquilibrium":"\u296F","rfisht":"\u297D","rfloor":"\u230B","rfr":"\uD835\uDD2F","Rfr":"\u211C","rHar":"\u2964","rhard":"\u21C1","rharu":"\u21C0","rharul":"\u296C","Rho":"\u03A1","rho":"\u03C1","rhov":"\u03F1","RightAngleBracket":"\u27E9","RightArrowBar":"\u21E5","rightarrow":"\u2192","RightArrow":"\u2192","Rightarrow":"\u21D2","RightArrowLeftArrow":"\u21C4","rightarrowtail":"\u21A3","RightCeiling":"\u2309","RightDoubleBracket":"\u27E7","RightDownTeeVector":"\u295D","RightDownVectorBar":"\u2955","RightDownVector":"\u21C2","RightFloor":"\u230B","rightharpoondown":"\u21C1","rightharpoonup":"\u21C0","rightleftarrows":"\u21C4","rightleftharpoons":"\u21CC","rightrightarrows":"\u21C9","rightsquigarrow":"\u219D","RightTeeArrow":"\u21A6","RightTee":"\u22A2","RightTeeVector":"\u295B","rightthreetimes":"\u22CC","RightTriangleBar":"\u29D0","RightTriangle":"\u22B3","RightTriangleEqual":"\u22B5","RightUpDownVector":"\u294F","RightUpTeeVector":"\u295C","RightUpVectorBar":"\u2954","RightUpVector":"\u21BE","RightVectorBar":"\u2953","RightVector":"\u21C0","ring":"\u02DA","risingdotseq":"\u2253","rlarr":"\u21C4","rlhar":"\u21CC","rlm":"\u200F","rmoustache":"\u23B1","rmoust":"\u23B1","rnmid":"\u2AEE","roang":"\u27ED","roarr":"\u21FE","robrk":"\u27E7","ropar":"\u2986","ropf":"\uD835\uDD63","Ropf":"\u211D","roplus":"\u2A2E","rotimes":"\u2A35","RoundImplies":"\u2970","rpar":")","rpargt":"\u2994","rppolint":"\u2A12","rrarr":"\u21C9","Rrightarrow":"\u21DB","rsaquo":"\u203A","rscr":"\uD835\uDCC7","Rscr":"\u211B","rsh":"\u21B1","Rsh":"\u21B1","rsqb":"]","rsquo":"\u2019","rsquor":"\u2019","rthree":"\u22CC","rtimes":"\u22CA","rtri":"\u25B9","rtrie":"\u22B5","rtrif":"\u25B8","rtriltri":"\u29CE","RuleDelayed":"\u29F4","ruluhar":"\u2968","rx":"\u211E","Sacute":"\u015A","sacute":"\u015B","sbquo":"\u201A","scap":"\u2AB8","Scaron":"\u0160","scaron":"\u0161","Sc":"\u2ABC","sc":"\u227B","sccue":"\u227D","sce":"\u2AB0","scE":"\u2AB4","Scedil":"\u015E","scedil":"\u015F","Scirc":"\u015C","scirc":"\u015D","scnap":"\u2ABA","scnE":"\u2AB6","scnsim":"\u22E9","scpolint":"\u2A13","scsim":"\u227F","Scy":"\u0421","scy":"\u0441","sdotb":"\u22A1","sdot":"\u22C5","sdote":"\u2A66","searhk":"\u2925","searr":"\u2198","seArr":"\u21D8","searrow":"\u2198","sect":"\xa7","semi":";","seswar":"\u2929","setminus":"\u2216","setmn":"\u2216","sext":"\u2736","Sfr":"\uD835\uDD16","sfr":"\uD835\uDD30","sfrown":"\u2322","sharp":"\u266F","SHCHcy":"\u0429","shchcy":"\u0449","SHcy":"\u0428","shcy":"\u0448","ShortDownArrow":"\u2193","ShortLeftArrow":"\u2190","shortmid":"\u2223","shortparallel":"\u2225","ShortRightArrow":"\u2192","ShortUpArrow":"\u2191","shy":"\xad","Sigma":"\u03A3","sigma":"\u03C3","sigmaf":"\u03C2","sigmav":"\u03C2","sim":"\u223C","simdot":"\u2A6A","sime":"\u2243","simeq":"\u2243","simg":"\u2A9E","simgE":"\u2AA0","siml":"\u2A9D","simlE":"\u2A9F","simne":"\u2246","simplus":"\u2A24","simrarr":"\u2972","slarr":"\u2190","SmallCircle":"\u2218","smallsetminus":"\u2216","smashp":"\u2A33","smeparsl":"\u29E4","smid":"\u2223","smile":"\u2323","smt":"\u2AAA","smte":"\u2AAC","smtes":"\u2AAC\uFE00","SOFTcy":"\u042C","softcy":"\u044C","solbar":"\u233F","solb":"\u29C4","sol":"/","Sopf":"\uD835\uDD4A","sopf":"\uD835\uDD64","spades":"\u2660","spadesuit":"\u2660","spar":"\u2225","sqcap":"\u2293","sqcaps":"\u2293\uFE00","sqcup":"\u2294","sqcups":"\u2294\uFE00","Sqrt":"\u221A","sqsub":"\u228F","sqsube":"\u2291","sqsubset":"\u228F","sqsubseteq":"\u2291","sqsup":"\u2290","sqsupe":"\u2292","sqsupset":"\u2290","sqsupseteq":"\u2292","square":"\u25A1","Square":"\u25A1","SquareIntersection":"\u2293","SquareSubset":"\u228F","SquareSubsetEqual":"\u2291","SquareSuperset":"\u2290","SquareSupersetEqual":"\u2292","SquareUnion":"\u2294","squarf":"\u25AA","squ":"\u25A1","squf":"\u25AA","srarr":"\u2192","Sscr":"\uD835\uDCAE","sscr":"\uD835\uDCC8","ssetmn":"\u2216","ssmile":"\u2323","sstarf":"\u22C6","Star":"\u22C6","star":"\u2606","starf":"\u2605","straightepsilon":"\u03F5","straightphi":"\u03D5","strns":"\xaf","sub":"\u2282","Sub":"\u22D0","subdot":"\u2ABD","subE":"\u2AC5","sube":"\u2286","subedot":"\u2AC3","submult":"\u2AC1","subnE":"\u2ACB","subne":"\u228A","subplus":"\u2ABF","subrarr":"\u2979","subset":"\u2282","Subset":"\u22D0","subseteq":"\u2286","subseteqq":"\u2AC5","SubsetEqual":"\u2286","subsetneq":"\u228A","subsetneqq":"\u2ACB","subsim":"\u2AC7","subsub":"\u2AD5","subsup":"\u2AD3","succapprox":"\u2AB8","succ":"\u227B","succcurlyeq":"\u227D","Succeeds":"\u227B","SucceedsEqual":"\u2AB0","SucceedsSlantEqual":"\u227D","SucceedsTilde":"\u227F","succeq":"\u2AB0","succnapprox":"\u2ABA","succneqq":"\u2AB6","succnsim":"\u22E9","succsim":"\u227F","SuchThat":"\u220B","sum":"\u2211","Sum":"\u2211","sung":"\u266A","sup1":"\xb9","sup2":"\xb2","sup3":"\xb3","sup":"\u2283","Sup":"\u22D1","supdot":"\u2ABE","supdsub":"\u2AD8","supE":"\u2AC6","supe":"\u2287","supedot":"\u2AC4","Superset":"\u2283","SupersetEqual":"\u2287","suphsol":"\u27C9","suphsub":"\u2AD7","suplarr":"\u297B","supmult":"\u2AC2","supnE":"\u2ACC","supne":"\u228B","supplus":"\u2AC0","supset":"\u2283","Supset":"\u22D1","supseteq":"\u2287","supseteqq":"\u2AC6","supsetneq":"\u228B","supsetneqq":"\u2ACC","supsim":"\u2AC8","supsub":"\u2AD4","supsup":"\u2AD6","swarhk":"\u2926","swarr":"\u2199","swArr":"\u21D9","swarrow":"\u2199","swnwar":"\u292A","szlig":"\xdf","Tab":"\\t","target":"\u2316","Tau":"\u03A4","tau":"\u03C4","tbrk":"\u23B4","Tcaron":"\u0164","tcaron":"\u0165","Tcedil":"\u0162","tcedil":"\u0163","Tcy":"\u0422","tcy":"\u0442","tdot":"\u20DB","telrec":"\u2315","Tfr":"\uD835\uDD17","tfr":"\uD835\uDD31","there4":"\u2234","therefore":"\u2234","Therefore":"\u2234","Theta":"\u0398","theta":"\u03B8","thetasym":"\u03D1","thetav":"\u03D1","thickapprox":"\u2248","thicksim":"\u223C","ThickSpace":"\u205F\u200A","ThinSpace":"\u2009","thinsp":"\u2009","thkap":"\u2248","thksim":"\u223C","THORN":"\xde","thorn":"\xfe","tilde":"\u02DC","Tilde":"\u223C","TildeEqual":"\u2243","TildeFullEqual":"\u2245","TildeTilde":"\u2248","timesbar":"\u2A31","timesb":"\u22A0","times":"\xd7","timesd":"\u2A30","tint":"\u222D","toea":"\u2928","topbot":"\u2336","topcir":"\u2AF1","top":"\u22A4","Topf":"\uD835\uDD4B","topf":"\uD835\uDD65","topfork":"\u2ADA","tosa":"\u2929","tprime":"\u2034","trade":"\u2122","TRADE":"\u2122","triangle":"\u25B5","triangledown":"\u25BF","triangleleft":"\u25C3","trianglelefteq":"\u22B4","triangleq":"\u225C","triangleright":"\u25B9","trianglerighteq":"\u22B5","tridot":"\u25EC","trie":"\u225C","triminus":"\u2A3A","TripleDot":"\u20DB","triplus":"\u2A39","trisb":"\u29CD","tritime":"\u2A3B","trpezium":"\u23E2","Tscr":"\uD835\uDCAF","tscr":"\uD835\uDCC9","TScy":"\u0426","tscy":"\u0446","TSHcy":"\u040B","tshcy":"\u045B","Tstrok":"\u0166","tstrok":"\u0167","twixt":"\u226C","twoheadleftarrow":"\u219E","twoheadrightarrow":"\u21A0","Uacute":"\xda","uacute":"\xfa","uarr":"\u2191","Uarr":"\u219F","uArr":"\u21D1","Uarrocir":"\u2949","Ubrcy":"\u040E","ubrcy":"\u045E","Ubreve":"\u016C","ubreve":"\u016D","Ucirc":"\xdb","ucirc":"\xfb","Ucy":"\u0423","ucy":"\u0443","udarr":"\u21C5","Udblac":"\u0170","udblac":"\u0171","udhar":"\u296E","ufisht":"\u297E","Ufr":"\uD835\uDD18","ufr":"\uD835\uDD32","Ugrave":"\xd9","ugrave":"\xf9","uHar":"\u2963","uharl":"\u21BF","uharr":"\u21BE","uhblk":"\u2580","ulcorn":"\u231C","ulcorner":"\u231C","ulcrop":"\u230F","ultri":"\u25F8","Umacr":"\u016A","umacr":"\u016B","uml":"\xa8","UnderBar":"_","UnderBrace":"\u23DF","UnderBracket":"\u23B5","UnderParenthesis":"\u23DD","Union":"\u22C3","UnionPlus":"\u228E","Uogon":"\u0172","uogon":"\u0173","Uopf":"\uD835\uDD4C","uopf":"\uD835\uDD66","UpArrowBar":"\u2912","uparrow":"\u2191","UpArrow":"\u2191","Uparrow":"\u21D1","UpArrowDownArrow":"\u21C5","updownarrow":"\u2195","UpDownArrow":"\u2195","Updownarrow":"\u21D5","UpEquilibrium":"\u296E","upharpoonleft":"\u21BF","upharpoonright":"\u21BE","uplus":"\u228E","UpperLeftArrow":"\u2196","UpperRightArrow":"\u2197","upsi":"\u03C5","Upsi":"\u03D2","upsih":"\u03D2","Upsilon":"\u03A5","upsilon":"\u03C5","UpTeeArrow":"\u21A5","UpTee":"\u22A5","upuparrows":"\u21C8","urcorn":"\u231D","urcorner":"\u231D","urcrop":"\u230E","Uring":"\u016E","uring":"\u016F","urtri":"\u25F9","Uscr":"\uD835\uDCB0","uscr":"\uD835\uDCCA","utdot":"\u22F0","Utilde":"\u0168","utilde":"\u0169","utri":"\u25B5","utrif":"\u25B4","uuarr":"\u21C8","Uuml":"\xdc","uuml":"\xfc","uwangle":"\u29A7","vangrt":"\u299C","varepsilon":"\u03F5","varkappa":"\u03F0","varnothing":"\u2205","varphi":"\u03D5","varpi":"\u03D6","varpropto":"\u221D","varr":"\u2195","vArr":"\u21D5","varrho":"\u03F1","varsigma":"\u03C2","varsubsetneq":"\u228A\uFE00","varsubsetneqq":"\u2ACB\uFE00","varsupsetneq":"\u228B\uFE00","varsupsetneqq":"\u2ACC\uFE00","vartheta":"\u03D1","vartriangleleft":"\u22B2","vartriangleright":"\u22B3","vBar":"\u2AE8","Vbar":"\u2AEB","vBarv":"\u2AE9","Vcy":"\u0412","vcy":"\u0432","vdash":"\u22A2","vDash":"\u22A8","Vdash":"\u22A9","VDash":"\u22AB","Vdashl":"\u2AE6","veebar":"\u22BB","vee":"\u2228","Vee":"\u22C1","veeeq":"\u225A","vellip":"\u22EE","verbar":"|","Verbar":"\u2016","vert":"|","Vert":"\u2016","VerticalBar":"\u2223","VerticalLine":"|","VerticalSeparator":"\u2758","VerticalTilde":"\u2240","VeryThinSpace":"\u200A","Vfr":"\uD835\uDD19","vfr":"\uD835\uDD33","vltri":"\u22B2","vnsub":"\u2282\u20D2","vnsup":"\u2283\u20D2","Vopf":"\uD835\uDD4D","vopf":"\uD835\uDD67","vprop":"\u221D","vrtri":"\u22B3","Vscr":"\uD835\uDCB1","vscr":"\uD835\uDCCB","vsubnE":"\u2ACB\uFE00","vsubne":"\u228A\uFE00","vsupnE":"\u2ACC\uFE00","vsupne":"\u228B\uFE00","Vvdash":"\u22AA","vzigzag":"\u299A","Wcirc":"\u0174","wcirc":"\u0175","wedbar":"\u2A5F","wedge":"\u2227","Wedge":"\u22C0","wedgeq":"\u2259","weierp":"\u2118","Wfr":"\uD835\uDD1A","wfr":"\uD835\uDD34","Wopf":"\uD835\uDD4E","wopf":"\uD835\uDD68","wp":"\u2118","wr":"\u2240","wreath":"\u2240","Wscr":"\uD835\uDCB2","wscr":"\uD835\uDCCC","xcap":"\u22C2","xcirc":"\u25EF","xcup":"\u22C3","xdtri":"\u25BD","Xfr":"\uD835\uDD1B","xfr":"\uD835\uDD35","xharr":"\u27F7","xhArr":"\u27FA","Xi":"\u039E","xi":"\u03BE","xlarr":"\u27F5","xlArr":"\u27F8","xmap":"\u27FC","xnis":"\u22FB","xodot":"\u2A00","Xopf":"\uD835\uDD4F","xopf":"\uD835\uDD69","xoplus":"\u2A01","xotime":"\u2A02","xrarr":"\u27F6","xrArr":"\u27F9","Xscr":"\uD835\uDCB3","xscr":"\uD835\uDCCD","xsqcup":"\u2A06","xuplus":"\u2A04","xutri":"\u25B3","xvee":"\u22C1","xwedge":"\u22C0","Yacute":"\xdd","yacute":"\xfd","YAcy":"\u042F","yacy":"\u044F","Ycirc":"\u0176","ycirc":"\u0177","Ycy":"\u042B","ycy":"\u044B","yen":"\xa5","Yfr":"\uD835\uDD1C","yfr":"\uD835\uDD36","YIcy":"\u0407","yicy":"\u0457","Yopf":"\uD835\uDD50","yopf":"\uD835\uDD6A","Yscr":"\uD835\uDCB4","yscr":"\uD835\uDCCE","YUcy":"\u042E","yucy":"\u044E","yuml":"\xff","Yuml":"\u0178","Zacute":"\u0179","zacute":"\u017A","Zcaron":"\u017D","zcaron":"\u017E","Zcy":"\u0417","zcy":"\u0437","Zdot":"\u017B","zdot":"\u017C","zeetrf":"\u2128","ZeroWidthSpace":"\u200B","Zeta":"\u0396","zeta":"\u03B6","zfr":"\uD835\uDD37","Zfr":"\u2128","ZHcy":"\u0416","zhcy":"\u0436","zigrarr":"\u21DD","zopf":"\uD835\uDD6B","Zopf":"\u2124","Zscr":"\uD835\uDCB5","zscr":"\uD835\uDCCF","zwj":"\u200D","zwnj":"\u200C"}');

});

parcelRegister("fYhBh", function(module, exports) {
module.exports = JSON.parse('{"Aacute":"\xc1","aacute":"\xe1","Acirc":"\xc2","acirc":"\xe2","acute":"\xb4","AElig":"\xc6","aelig":"\xe6","Agrave":"\xc0","agrave":"\xe0","amp":"&","AMP":"&","Aring":"\xc5","aring":"\xe5","Atilde":"\xc3","atilde":"\xe3","Auml":"\xc4","auml":"\xe4","brvbar":"\xa6","Ccedil":"\xc7","ccedil":"\xe7","cedil":"\xb8","cent":"\xa2","copy":"\xa9","COPY":"\xa9","curren":"\xa4","deg":"\xb0","divide":"\xf7","Eacute":"\xc9","eacute":"\xe9","Ecirc":"\xca","ecirc":"\xea","Egrave":"\xc8","egrave":"\xe8","ETH":"\xd0","eth":"\xf0","Euml":"\xcb","euml":"\xeb","frac12":"\xbd","frac14":"\xbc","frac34":"\xbe","gt":">","GT":">","Iacute":"\xcd","iacute":"\xed","Icirc":"\xce","icirc":"\xee","iexcl":"\xa1","Igrave":"\xcc","igrave":"\xec","iquest":"\xbf","Iuml":"\xcf","iuml":"\xef","laquo":"\xab","lt":"<","LT":"<","macr":"\xaf","micro":"\xb5","middot":"\xb7","nbsp":"\xa0","not":"\xac","Ntilde":"\xd1","ntilde":"\xf1","Oacute":"\xd3","oacute":"\xf3","Ocirc":"\xd4","ocirc":"\xf4","Ograve":"\xd2","ograve":"\xf2","ordf":"\xaa","ordm":"\xba","Oslash":"\xd8","oslash":"\xf8","Otilde":"\xd5","otilde":"\xf5","Ouml":"\xd6","ouml":"\xf6","para":"\xb6","plusmn":"\xb1","pound":"\xa3","quot":"\\"","QUOT":"\\"","raquo":"\xbb","reg":"\xae","REG":"\xae","sect":"\xa7","shy":"\xad","sup1":"\xb9","sup2":"\xb2","sup3":"\xb3","szlig":"\xdf","THORN":"\xde","thorn":"\xfe","times":"\xd7","Uacute":"\xda","uacute":"\xfa","Ucirc":"\xdb","ucirc":"\xfb","Ugrave":"\xd9","ugrave":"\xf9","uml":"\xa8","Uuml":"\xdc","uuml":"\xfc","Yacute":"\xdd","yacute":"\xfd","yen":"\xa5","yuml":"\xff"}');

});

parcelRegister("bXxzr", function(module, exports) {
module.exports = JSON.parse('{"amp":"&","apos":"\'","gt":">","lt":"<","quot":"\\""}');

});

parcelRegister("jAuaA", function(module, exports) {
"use strict";
var $e428c837b1e87721$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $e428c837b1e87721$var$decode_json_1 = $e428c837b1e87721$var$__importDefault((parcelRequire("arjpB")));
// Adapted from https://github.com/mathiasbynens/he/blob/master/src/he.js#L94-L119
var $e428c837b1e87721$var$fromCodePoint = // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
String.fromCodePoint || function(codePoint) {
    var output = "";
    if (codePoint > 0xffff) {
        codePoint -= 0x10000;
        output += String.fromCharCode(codePoint >>> 10 & 0x3ff | 0xd800);
        codePoint = 0xdc00 | codePoint & 0x3ff;
    }
    output += String.fromCharCode(codePoint);
    return output;
};
function $e428c837b1e87721$var$decodeCodePoint(codePoint) {
    if (codePoint >= 0xd800 && codePoint <= 0xdfff || codePoint > 0x10ffff) return "\uFFFD";
    if (codePoint in $e428c837b1e87721$var$decode_json_1.default) codePoint = $e428c837b1e87721$var$decode_json_1.default[codePoint];
    return $e428c837b1e87721$var$fromCodePoint(codePoint);
}
module.exports.default = $e428c837b1e87721$var$decodeCodePoint;

});
parcelRegister("arjpB", function(module, exports) {
module.exports = JSON.parse('{"0":65533,"128":8364,"130":8218,"131":402,"132":8222,"133":8230,"134":8224,"135":8225,"136":710,"137":8240,"138":352,"139":8249,"140":338,"142":381,"145":8216,"146":8217,"147":8220,"148":8221,"149":8226,"150":8211,"151":8212,"152":732,"153":8482,"154":353,"155":8250,"156":339,"158":382,"159":376}');

});


parcelRegister("9CiNR", function(module, exports) {

$parcel$export(module.exports, "convert2nimn", () => $70063f94e6c64de4$export$fa981bbccf843781, (v) => $70063f94e6c64de4$export$fa981bbccf843781 = v);
var $70063f94e6c64de4$export$fa981bbccf843781;
"use strict";
const $70063f94e6c64de4$var$char = function(a) {
    return String.fromCharCode(a);
};
const $70063f94e6c64de4$var$chars = {
    nilChar: $70063f94e6c64de4$var$char(176),
    missingChar: $70063f94e6c64de4$var$char(201),
    nilPremitive: $70063f94e6c64de4$var$char(175),
    missingPremitive: $70063f94e6c64de4$var$char(200),
    emptyChar: $70063f94e6c64de4$var$char(178),
    emptyValue: $70063f94e6c64de4$var$char(177),
    boundryChar: $70063f94e6c64de4$var$char(179),
    objStart: $70063f94e6c64de4$var$char(198),
    arrStart: $70063f94e6c64de4$var$char(204),
    arrayEnd: $70063f94e6c64de4$var$char(185)
};
const $70063f94e6c64de4$var$charsArr = [
    $70063f94e6c64de4$var$chars.nilChar,
    $70063f94e6c64de4$var$chars.nilPremitive,
    $70063f94e6c64de4$var$chars.missingChar,
    $70063f94e6c64de4$var$chars.missingPremitive,
    $70063f94e6c64de4$var$chars.boundryChar,
    $70063f94e6c64de4$var$chars.emptyChar,
    $70063f94e6c64de4$var$chars.emptyValue,
    $70063f94e6c64de4$var$chars.arrayEnd,
    $70063f94e6c64de4$var$chars.objStart,
    $70063f94e6c64de4$var$chars.arrStart
];
const $70063f94e6c64de4$var$_e = function(node, e_schema, options) {
    if (typeof e_schema === "string") {
        //premitive
        if (node && node[0] && node[0].val !== undefined) return $70063f94e6c64de4$var$getValue(node[0].val, e_schema);
        else return $70063f94e6c64de4$var$getValue(node, e_schema);
    } else {
        const hasValidData = $70063f94e6c64de4$var$hasData(node);
        if (hasValidData === true) {
            let str = "";
            if (Array.isArray(e_schema)) {
                //attributes can't be repeated. hence check in children tags only
                str += $70063f94e6c64de4$var$chars.arrStart;
                const itemSchema = e_schema[0];
                //var itemSchemaType = itemSchema;
                const arr_len = node.length;
                if (typeof itemSchema === "string") for(let arr_i = 0; arr_i < arr_len; arr_i++){
                    const r = $70063f94e6c64de4$var$getValue(node[arr_i].val, itemSchema);
                    str = $70063f94e6c64de4$var$processValue(str, r);
                }
                else for(let arr_i = 0; arr_i < arr_len; arr_i++){
                    const r = $70063f94e6c64de4$var$_e(node[arr_i], itemSchema, options);
                    str = $70063f94e6c64de4$var$processValue(str, r);
                }
                str += $70063f94e6c64de4$var$chars.arrayEnd; //indicates that next item is not array item
            } else {
                //object
                str += $70063f94e6c64de4$var$chars.objStart;
                const keys = Object.keys(e_schema);
                if (Array.isArray(node)) node = node[0];
                for(let i in keys){
                    const key = keys[i];
                    //a property defined in schema can be present either in attrsMap or children tags
                    //options.textNodeName will not present in both maps, take it's value from val
                    //options.attrNodeName will be present in attrsMap
                    let r;
                    if (!options.ignoreAttributes && node.attrsMap && node.attrsMap[key]) r = $70063f94e6c64de4$var$_e(node.attrsMap[key], e_schema[key], options);
                    else if (key === options.textNodeName) r = $70063f94e6c64de4$var$_e(node.val, e_schema[key], options);
                    else r = $70063f94e6c64de4$var$_e(node.child[key], e_schema[key], options);
                    str = $70063f94e6c64de4$var$processValue(str, r);
                }
            }
            return str;
        } else return hasValidData;
    }
};
const $70063f94e6c64de4$var$getValue = function(a /*, type*/ ) {
    switch(a){
        case undefined:
            return $70063f94e6c64de4$var$chars.missingPremitive;
        case null:
            return $70063f94e6c64de4$var$chars.nilPremitive;
        case "":
            return $70063f94e6c64de4$var$chars.emptyValue;
        default:
            return a;
    }
};
const $70063f94e6c64de4$var$processValue = function(str, r) {
    if (!$70063f94e6c64de4$var$isAppChar(r[0]) && !$70063f94e6c64de4$var$isAppChar(str[str.length - 1])) str += $70063f94e6c64de4$var$chars.boundryChar;
    return str + r;
};
const $70063f94e6c64de4$var$isAppChar = function(ch) {
    return $70063f94e6c64de4$var$charsArr.indexOf(ch) !== -1;
};
function $70063f94e6c64de4$var$hasData(jObj) {
    if (jObj === undefined) return $70063f94e6c64de4$var$chars.missingChar;
    else if (jObj === null) return $70063f94e6c64de4$var$chars.nilChar;
    else if (jObj.child && Object.keys(jObj.child).length === 0 && (!jObj.attrsMap || Object.keys(jObj.attrsMap).length === 0)) return $70063f94e6c64de4$var$chars.emptyChar;
    else return true;
}

var $21YsA = parcelRequire("21YsA");

var $l8rQG = parcelRequire("l8rQG");
var $70063f94e6c64de4$require$buildOptions = $l8rQG.buildOptions;
const $70063f94e6c64de4$var$convert2nimn = function(node, e_schema, options) {
    options = $70063f94e6c64de4$require$buildOptions(options, $21YsA.defaultOptions, $21YsA.props);
    return $70063f94e6c64de4$var$_e(node, e_schema, options);
};
$70063f94e6c64de4$export$fa981bbccf843781 = $70063f94e6c64de4$var$convert2nimn;

});
parcelRegister("21YsA", function(module, exports) {

$parcel$export(module.exports, "defaultOptions", () => $17aa92e58750223a$export$ba43bf67f3d48107, (v) => $17aa92e58750223a$export$ba43bf67f3d48107 = v);
$parcel$export(module.exports, "props", () => $17aa92e58750223a$export$8128bb6492cf3de7, (v) => $17aa92e58750223a$export$8128bb6492cf3de7 = v);
$parcel$export(module.exports, "getTraversalObj", () => $17aa92e58750223a$export$2ca3eb0a2f8a693a, (v) => $17aa92e58750223a$export$2ca3eb0a2f8a693a = v);
var $17aa92e58750223a$export$ba43bf67f3d48107;
var $17aa92e58750223a$export$8128bb6492cf3de7;
var $17aa92e58750223a$export$2ca3eb0a2f8a693a;
"use strict";

var $l8rQG = parcelRequire("l8rQG");

var $l8rQG = parcelRequire("l8rQG");
var $17aa92e58750223a$require$buildOptions = $l8rQG.buildOptions;

var $ji8Zv = parcelRequire("ji8Zv");
const $17aa92e58750223a$var$regx = "<((!\\[CDATA\\[([\\s\\S]*?)(]]>))|((NAME:)?(NAME))([^>]*)>|((\\/)(NAME)\\s*>))([^<]*)".replace(/NAME/g, $l8rQG.nameRegexp);
//const tagsRegx = new RegExp("<(\\/?[\\w:\\-\._]+)([^>]*)>(\\s*"+cdataRegx+")*([^<]+)?","g");
//const tagsRegx = new RegExp("<(\\/?)((\\w*:)?([\\w:\\-\._]+))([^>]*)>([^<]*)("+cdataRegx+"([^<]*))*([^<]+)?","g");
//polyfill
if (!Number.parseInt && window.parseInt) Number.parseInt = window.parseInt;
if (!Number.parseFloat && window.parseFloat) Number.parseFloat = window.parseFloat;
const $17aa92e58750223a$var$defaultOptions = {
    attributeNamePrefix: "@_",
    attrNodeName: false,
    textNodeName: "#text",
    ignoreAttributes: true,
    ignoreNameSpace: false,
    allowBooleanAttributes: false,
    //ignoreRootElement : false,
    parseNodeValue: true,
    parseAttributeValue: false,
    arrayMode: false,
    trimValues: true,
    cdataTagName: false,
    cdataPositionChar: "\\c",
    tagValueProcessor: function(a, tagName) {
        return a;
    },
    attrValueProcessor: function(a, attrName) {
        return a;
    },
    stopNodes: []
};
$17aa92e58750223a$export$ba43bf67f3d48107 = $17aa92e58750223a$var$defaultOptions;
const $17aa92e58750223a$var$props = [
    "attributeNamePrefix",
    "attrNodeName",
    "textNodeName",
    "ignoreAttributes",
    "ignoreNameSpace",
    "allowBooleanAttributes",
    "parseNodeValue",
    "parseAttributeValue",
    "arrayMode",
    "trimValues",
    "cdataTagName",
    "cdataPositionChar",
    "tagValueProcessor",
    "attrValueProcessor",
    "parseTrueNumberOnly",
    "stopNodes"
];
$17aa92e58750223a$export$8128bb6492cf3de7 = $17aa92e58750223a$var$props;
/**
 * Trim -> valueProcessor -> parse value
 * @param {string} tagName
 * @param {string} val
 * @param {object} options
 */ function $17aa92e58750223a$var$processTagValue(tagName, val, options) {
    if (val) {
        if (options.trimValues) val = val.trim();
        val = options.tagValueProcessor(val, tagName);
        val = $17aa92e58750223a$var$parseValue(val, options.parseNodeValue, options.parseTrueNumberOnly);
    }
    return val;
}
function $17aa92e58750223a$var$resolveNameSpace(tagname, options) {
    if (options.ignoreNameSpace) {
        const tags = tagname.split(":");
        const prefix = tagname.charAt(0) === "/" ? "/" : "";
        if (tags[0] === "xmlns") return "";
        if (tags.length === 2) tagname = prefix + tags[1];
    }
    return tagname;
}
function $17aa92e58750223a$var$parseValue(val, shouldParse, parseTrueNumberOnly) {
    if (shouldParse && typeof val === "string") {
        let parsed;
        if (val.trim() === "" || isNaN(val)) parsed = val === "true" ? true : val === "false" ? false : val;
        else {
            if (val.indexOf("0x") !== -1) //support hexa decimal
            parsed = Number.parseInt(val, 16);
            else if (val.indexOf(".") !== -1) {
                parsed = Number.parseFloat(val);
                val = val.replace(/\.?0+$/, "");
            } else parsed = Number.parseInt(val, 10);
            if (parseTrueNumberOnly) parsed = String(parsed) === val ? parsed : val;
        }
        return parsed;
    } else {
        if ($l8rQG.isExist(val)) return val;
        else return "";
    }
}
//TODO: change regex to capture NS
//const attrsRegx = new RegExp("([\\w\\-\\.\\:]+)\\s*=\\s*(['\"])((.|\n)*?)\\2","gm");
const $17aa92e58750223a$var$attrsRegx = new RegExp("([^\\s=]+)\\s*(=\\s*(['\"])(.*?)\\3)?", "g");
function $17aa92e58750223a$var$buildAttributesMap(attrStr, options) {
    if (!options.ignoreAttributes && typeof attrStr === "string") {
        attrStr = attrStr.replace(/\r?\n/g, " ");
        //attrStr = attrStr || attrStr.trim();
        const matches = $l8rQG.getAllMatches(attrStr, $17aa92e58750223a$var$attrsRegx);
        const len = matches.length; //don't make it inline
        const attrs = {};
        for(let i = 0; i < len; i++){
            const attrName = $17aa92e58750223a$var$resolveNameSpace(matches[i][1], options);
            if (attrName.length) {
                if (matches[i][4] !== undefined) {
                    if (options.trimValues) matches[i][4] = matches[i][4].trim();
                    matches[i][4] = options.attrValueProcessor(matches[i][4], attrName);
                    attrs[options.attributeNamePrefix + attrName] = $17aa92e58750223a$var$parseValue(matches[i][4], options.parseAttributeValue, options.parseTrueNumberOnly);
                } else if (options.allowBooleanAttributes) attrs[options.attributeNamePrefix + attrName] = true;
            }
        }
        if (!Object.keys(attrs).length) return;
        if (options.attrNodeName) {
            const attrCollection = {};
            attrCollection[options.attrNodeName] = attrs;
            return attrCollection;
        }
        return attrs;
    }
}
const $17aa92e58750223a$var$getTraversalObj = function(xmlData, options) {
    xmlData = xmlData.replace(/\r\n?/g, "\n");
    options = $17aa92e58750223a$require$buildOptions(options, $17aa92e58750223a$var$defaultOptions, $17aa92e58750223a$var$props);
    const xmlObj = new $ji8Zv("!xml");
    let currentNode = xmlObj;
    let textData = "";
    //function match(xmlData){
    for(let i = 0; i < xmlData.length; i++){
        const ch = xmlData[i];
        if (ch === "<") {
            if (xmlData[i + 1] === "/") {
                const closeIndex = $17aa92e58750223a$var$findClosingIndex(xmlData, ">", i, "Closing Tag is not closed.");
                let tagName = xmlData.substring(i + 2, closeIndex).trim();
                if (options.ignoreNameSpace) {
                    const colonIndex = tagName.indexOf(":");
                    if (colonIndex !== -1) tagName = tagName.substr(colonIndex + 1);
                }
                /* if (currentNode.parent) {
          currentNode.parent.val = util.getValue(currentNode.parent.val) + '' + processTagValue2(tagName, textData , options);
        } */ if (currentNode) {
                    if (currentNode.val) currentNode.val = $l8rQG.getValue(currentNode.val) + "" + $17aa92e58750223a$var$processTagValue(tagName, textData, options);
                    else currentNode.val = $17aa92e58750223a$var$processTagValue(tagName, textData, options);
                }
                if (options.stopNodes.length && options.stopNodes.includes(currentNode.tagname)) {
                    currentNode.child = [];
                    if (currentNode.attrsMap == undefined) currentNode.attrsMap = {};
                    currentNode.val = xmlData.substr(currentNode.startIndex + 1, i - currentNode.startIndex - 1);
                }
                currentNode = currentNode.parent;
                textData = "";
                i = closeIndex;
            } else if (xmlData[i + 1] === "?") i = $17aa92e58750223a$var$findClosingIndex(xmlData, "?>", i, "Pi Tag is not closed.");
            else if (xmlData.substr(i + 1, 3) === "!--") i = $17aa92e58750223a$var$findClosingIndex(xmlData, "-->", i, "Comment is not closed.");
            else if (xmlData.substr(i + 1, 2) === "!D") {
                const closeIndex = $17aa92e58750223a$var$findClosingIndex(xmlData, ">", i, "DOCTYPE is not closed.");
                const tagExp = xmlData.substring(i, closeIndex);
                if (tagExp.indexOf("[") >= 0) i = xmlData.indexOf("]>", i) + 1;
                else i = closeIndex;
            } else if (xmlData.substr(i + 1, 2) === "![") {
                const closeIndex = $17aa92e58750223a$var$findClosingIndex(xmlData, "]]>", i, "CDATA is not closed.") - 2;
                const tagExp = xmlData.substring(i + 9, closeIndex);
                //considerations
                //1. CDATA will always have parent node
                //2. A tag with CDATA is not a leaf node so it's value would be string type.
                if (textData) {
                    currentNode.val = $l8rQG.getValue(currentNode.val) + "" + $17aa92e58750223a$var$processTagValue(currentNode.tagname, textData, options);
                    textData = "";
                }
                if (options.cdataTagName) {
                    //add cdata node
                    const childNode = new $ji8Zv(options.cdataTagName, currentNode, tagExp);
                    currentNode.addChild(childNode);
                    //for backtracking
                    currentNode.val = $l8rQG.getValue(currentNode.val) + options.cdataPositionChar;
                    //add rest value to parent node
                    if (tagExp) childNode.val = tagExp;
                } else currentNode.val = (currentNode.val || "") + (tagExp || "");
                i = closeIndex + 2;
            } else {
                const result = $17aa92e58750223a$var$closingIndexForOpeningTag(xmlData, i + 1);
                let tagExp = result.data;
                const closeIndex = result.index;
                const separatorIndex = tagExp.indexOf(" ");
                let tagName = tagExp;
                let shouldBuildAttributesMap = true;
                if (separatorIndex !== -1) {
                    tagName = tagExp.substr(0, separatorIndex).replace(/\s\s*$/, "");
                    tagExp = tagExp.substr(separatorIndex + 1);
                }
                if (options.ignoreNameSpace) {
                    const colonIndex = tagName.indexOf(":");
                    if (colonIndex !== -1) {
                        tagName = tagName.substr(colonIndex + 1);
                        shouldBuildAttributesMap = tagName !== result.data.substr(colonIndex + 1);
                    }
                }
                //save text to parent node
                if (currentNode && textData) {
                    if (currentNode.tagname !== "!xml") currentNode.val = $l8rQG.getValue(currentNode.val) + "" + $17aa92e58750223a$var$processTagValue(currentNode.tagname, textData, options);
                }
                if (tagExp.length > 0 && tagExp.lastIndexOf("/") === tagExp.length - 1) {
                    if (tagName[tagName.length - 1] === "/") {
                        tagName = tagName.substr(0, tagName.length - 1);
                        tagExp = tagName;
                    } else tagExp = tagExp.substr(0, tagExp.length - 1);
                    const childNode = new $ji8Zv(tagName, currentNode, "");
                    if (tagName !== tagExp) childNode.attrsMap = $17aa92e58750223a$var$buildAttributesMap(tagExp, options);
                    currentNode.addChild(childNode);
                } else {
                    const childNode = new $ji8Zv(tagName, currentNode);
                    if (options.stopNodes.length && options.stopNodes.includes(childNode.tagname)) childNode.startIndex = closeIndex;
                    if (tagName !== tagExp && shouldBuildAttributesMap) childNode.attrsMap = $17aa92e58750223a$var$buildAttributesMap(tagExp, options);
                    currentNode.addChild(childNode);
                    currentNode = childNode;
                }
                textData = "";
                i = closeIndex;
            }
        } else textData += xmlData[i];
    }
    return xmlObj;
};
function $17aa92e58750223a$var$closingIndexForOpeningTag(data, i) {
    let attrBoundary;
    let tagExp = "";
    for(let index = i; index < data.length; index++){
        let ch = data[index];
        if (attrBoundary) {
            if (ch === attrBoundary) attrBoundary = ""; //reset
        } else if (ch === '"' || ch === "'") attrBoundary = ch;
        else if (ch === ">") return {
            data: tagExp,
            index: index
        };
        else if (ch === "	") ch = " ";
        tagExp += ch;
    }
}
function $17aa92e58750223a$var$findClosingIndex(xmlData, str, i, errMsg) {
    const closingIndex = xmlData.indexOf(str, i);
    if (closingIndex === -1) throw new Error(errMsg);
    else return closingIndex + str.length - 1;
}
$17aa92e58750223a$export$2ca3eb0a2f8a693a = $17aa92e58750223a$var$getTraversalObj;

});
parcelRegister("l8rQG", function(module, exports) {

$parcel$export(module.exports, "isExist", () => $f62ff286a4f745fa$export$a5edf3f35b6dd392, (v) => $f62ff286a4f745fa$export$a5edf3f35b6dd392 = v);
$parcel$export(module.exports, "isEmptyObject", () => $f62ff286a4f745fa$export$83b788b1a3698c03, (v) => $f62ff286a4f745fa$export$83b788b1a3698c03 = v);
$parcel$export(module.exports, "merge", () => $f62ff286a4f745fa$export$4950aa0f605343fb, (v) => $f62ff286a4f745fa$export$4950aa0f605343fb = v);
$parcel$export(module.exports, "getValue", () => $f62ff286a4f745fa$export$bf7199a9ebcb84a9, (v) => $f62ff286a4f745fa$export$bf7199a9ebcb84a9 = v);
$parcel$export(module.exports, "buildOptions", () => $f62ff286a4f745fa$export$ecbd7d678ac4909b, (v) => $f62ff286a4f745fa$export$ecbd7d678ac4909b = v);
$parcel$export(module.exports, "isTagNameInArrayMode", () => $f62ff286a4f745fa$export$fd3b6180ca5b0284, (v) => $f62ff286a4f745fa$export$fd3b6180ca5b0284 = v);
$parcel$export(module.exports, "isName", () => $f62ff286a4f745fa$export$998d7ff9801e90bb, (v) => $f62ff286a4f745fa$export$998d7ff9801e90bb = v);
$parcel$export(module.exports, "getAllMatches", () => $f62ff286a4f745fa$export$aaa9734c55cb7a19, (v) => $f62ff286a4f745fa$export$aaa9734c55cb7a19 = v);
$parcel$export(module.exports, "nameRegexp", () => $f62ff286a4f745fa$export$e8f2644f7085b4b1, (v) => $f62ff286a4f745fa$export$e8f2644f7085b4b1 = v);
var $f62ff286a4f745fa$export$a5edf3f35b6dd392;
var $f62ff286a4f745fa$export$83b788b1a3698c03;
/**
 * Copy all the properties of a into b.
 * @param {*} target
 * @param {*} a
 */ var $f62ff286a4f745fa$export$4950aa0f605343fb;
/* exports.merge =function (b,a){
  return Object.assign(b,a);
} */ var $f62ff286a4f745fa$export$bf7199a9ebcb84a9;
// const fakeCall = function(a) {return a;};
// const fakeCallNoReturn = function() {};
var $f62ff286a4f745fa$export$ecbd7d678ac4909b;
/**
 * Check if a tag name should be treated as array
 *
 * @param tagName the node tagname
 * @param arrayMode the array mode option
 * @param parentTagName the parent tag name
 * @returns {boolean} true if node should be parsed as array
 */ var $f62ff286a4f745fa$export$fd3b6180ca5b0284;
var $f62ff286a4f745fa$export$998d7ff9801e90bb;
var $f62ff286a4f745fa$export$aaa9734c55cb7a19;
var $f62ff286a4f745fa$export$e8f2644f7085b4b1;
"use strict";
const $f62ff286a4f745fa$var$nameStartChar = ":A-Za-z_\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD";
const $f62ff286a4f745fa$var$nameChar = $f62ff286a4f745fa$var$nameStartChar + "\\-.\\d\\u00B7\\u0300-\\u036F\\u203F-\\u2040";
const $f62ff286a4f745fa$var$nameRegexp = "[" + $f62ff286a4f745fa$var$nameStartChar + "][" + $f62ff286a4f745fa$var$nameChar + "]*";
const $f62ff286a4f745fa$var$regexName = new RegExp("^" + $f62ff286a4f745fa$var$nameRegexp + "$");
const $f62ff286a4f745fa$var$getAllMatches = function(string, regex) {
    const matches = [];
    let match = regex.exec(string);
    while(match){
        const allmatches = [];
        const len = match.length;
        for(let index = 0; index < len; index++)allmatches.push(match[index]);
        matches.push(allmatches);
        match = regex.exec(string);
    }
    return matches;
};
const $f62ff286a4f745fa$var$isName = function(string) {
    const match = $f62ff286a4f745fa$var$regexName.exec(string);
    return !(match === null || typeof match === "undefined");
};
$f62ff286a4f745fa$export$a5edf3f35b6dd392 = function(v) {
    return typeof v !== "undefined";
};
$f62ff286a4f745fa$export$83b788b1a3698c03 = function(obj) {
    return Object.keys(obj).length === 0;
};
$f62ff286a4f745fa$export$4950aa0f605343fb = function(target, a, arrayMode) {
    if (a) {
        const keys = Object.keys(a); // will return an array of own properties
        const len = keys.length; //don't make it inline
        for(let i = 0; i < len; i++)if (arrayMode === "strict") target[keys[i]] = [
            a[keys[i]]
        ];
        else target[keys[i]] = a[keys[i]];
    }
};
$f62ff286a4f745fa$export$bf7199a9ebcb84a9 = function(v) {
    if ($f62ff286a4f745fa$export$a5edf3f35b6dd392(v)) return v;
    else return "";
};
$f62ff286a4f745fa$export$ecbd7d678ac4909b = function(options, defaultOptions, props) {
    var newOptions = {};
    if (!options) return defaultOptions; //if there are not options
    for(let i = 0; i < props.length; i++)if (options[props[i]] !== undefined) newOptions[props[i]] = options[props[i]];
    else newOptions[props[i]] = defaultOptions[props[i]];
    return newOptions;
};
$f62ff286a4f745fa$export$fd3b6180ca5b0284 = function(tagName, arrayMode, parentTagName) {
    if (arrayMode === false) return false;
    else if (arrayMode instanceof RegExp) return arrayMode.test(tagName);
    else if (typeof arrayMode === "function") return !!arrayMode(tagName, parentTagName);
    return arrayMode === "strict";
};
$f62ff286a4f745fa$export$998d7ff9801e90bb = $f62ff286a4f745fa$var$isName;
$f62ff286a4f745fa$export$aaa9734c55cb7a19 = $f62ff286a4f745fa$var$getAllMatches;
$f62ff286a4f745fa$export$e8f2644f7085b4b1 = $f62ff286a4f745fa$var$nameRegexp;

});

parcelRegister("ji8Zv", function(module, exports) {
"use strict";
module.exports = function(tagname, parent, val) {
    this.tagname = tagname;
    this.parent = parent;
    this.child = {}; //child tags
    this.attrsMap = {}; //attributes map
    this.val = val; //text only
    this.addChild = function(child) {
        if (Array.isArray(this.child[child.tagname])) //already presents
        this.child[child.tagname].push(child);
        else this.child[child.tagname] = [
            child
        ];
    };
};

});



parcelRegister("ajMmB", function(module, exports) {

$parcel$export(module.exports, "convertToJsonString", () => $783131c068b59ec2$export$54ffaacfc0931fb0, (v) => $783131c068b59ec2$export$54ffaacfc0931fb0 = v);
var $783131c068b59ec2$export$54ffaacfc0931fb0;
"use strict";

var $l8rQG = parcelRequire("l8rQG");

var $l8rQG = parcelRequire("l8rQG");
var $783131c068b59ec2$require$buildOptions = $l8rQG.buildOptions;

var $21YsA = parcelRequire("21YsA");
//TODO: do it later
const $783131c068b59ec2$var$convertToJsonString = function(node, options) {
    options = $783131c068b59ec2$require$buildOptions(options, $21YsA.defaultOptions, $21YsA.props);
    options.indentBy = options.indentBy || "";
    return $783131c068b59ec2$var$_cToJsonStr(node, options, 0);
};
const $783131c068b59ec2$var$_cToJsonStr = function(node, options, level) {
    let jObj = "{";
    //traver through all the children
    const keys = Object.keys(node.child);
    for(let index = 0; index < keys.length; index++){
        var tagname = keys[index];
        if (node.child[tagname] && node.child[tagname].length > 1) {
            jObj += '"' + tagname + '" : [ ';
            for(var tag in node.child[tagname])jObj += $783131c068b59ec2$var$_cToJsonStr(node.child[tagname][tag], options) + " , ";
            jObj = jObj.substr(0, jObj.length - 1) + " ] "; //remove extra comma in last
        } else jObj += '"' + tagname + '" : ' + $783131c068b59ec2$var$_cToJsonStr(node.child[tagname][0], options) + " ,";
    }
    $l8rQG.merge(jObj, node.attrsMap);
    //add attrsMap as new children
    if ($l8rQG.isEmptyObject(jObj)) return $l8rQG.isExist(node.val) ? node.val : "";
    else {
        if ($l8rQG.isExist(node.val)) {
            if (!(typeof node.val === "string" && (node.val === "" || node.val === options.cdataPositionChar))) jObj += '"' + options.textNodeName + '" : ' + $783131c068b59ec2$var$stringval(node.val);
        }
    }
    //add value
    if (jObj[jObj.length - 1] === ",") jObj = jObj.substr(0, jObj.length - 2);
    return jObj + "}";
};
function $783131c068b59ec2$var$stringval(v) {
    if (v === true || v === false || !isNaN(v)) return v;
    else return '"' + v + '"';
}
function $783131c068b59ec2$var$indentate(options, level) {
    return options.indentBy.repeat(level);
}
$783131c068b59ec2$export$54ffaacfc0931fb0 = $783131c068b59ec2$var$convertToJsonString;

});

parcelRegister("gnljR", function(module, exports) {
"use strict";

var $l8rQG = parcelRequire("l8rQG");
var $bebf54e7096383a5$require$buildOptions = $l8rQG.buildOptions;
const $bebf54e7096383a5$var$defaultOptions = {
    attributeNamePrefix: "@_",
    attrNodeName: false,
    textNodeName: "#text",
    ignoreAttributes: true,
    cdataTagName: false,
    cdataPositionChar: "\\c",
    format: false,
    indentBy: "  ",
    supressEmptyNode: false,
    tagValueProcessor: function(a) {
        return a;
    },
    attrValueProcessor: function(a) {
        return a;
    }
};
const $bebf54e7096383a5$var$props = [
    "attributeNamePrefix",
    "attrNodeName",
    "textNodeName",
    "ignoreAttributes",
    "cdataTagName",
    "cdataPositionChar",
    "format",
    "indentBy",
    "supressEmptyNode",
    "tagValueProcessor",
    "attrValueProcessor"
];
function $bebf54e7096383a5$var$Parser(options) {
    this.options = $bebf54e7096383a5$require$buildOptions(options, $bebf54e7096383a5$var$defaultOptions, $bebf54e7096383a5$var$props);
    if (this.options.ignoreAttributes || this.options.attrNodeName) this.isAttribute = function() {
        return false;
    };
    else {
        this.attrPrefixLen = this.options.attributeNamePrefix.length;
        this.isAttribute = $bebf54e7096383a5$var$isAttribute;
    }
    if (this.options.cdataTagName) this.isCDATA = $bebf54e7096383a5$var$isCDATA;
    else this.isCDATA = function() {
        return false;
    };
    this.replaceCDATAstr = $bebf54e7096383a5$var$replaceCDATAstr;
    this.replaceCDATAarr = $bebf54e7096383a5$var$replaceCDATAarr;
    if (this.options.format) {
        this.indentate = $bebf54e7096383a5$var$indentate;
        this.tagEndChar = ">\n";
        this.newLine = "\n";
    } else {
        this.indentate = function() {
            return "";
        };
        this.tagEndChar = ">";
        this.newLine = "";
    }
    if (this.options.supressEmptyNode) {
        this.buildTextNode = $bebf54e7096383a5$var$buildEmptyTextNode;
        this.buildObjNode = $bebf54e7096383a5$var$buildEmptyObjNode;
    } else {
        this.buildTextNode = $bebf54e7096383a5$var$buildTextValNode;
        this.buildObjNode = $bebf54e7096383a5$var$buildObjectNode;
    }
    this.buildTextValNode = $bebf54e7096383a5$var$buildTextValNode;
    this.buildObjectNode = $bebf54e7096383a5$var$buildObjectNode;
}
$bebf54e7096383a5$var$Parser.prototype.parse = function(jObj) {
    return this.j2x(jObj, 0).val;
};
$bebf54e7096383a5$var$Parser.prototype.j2x = function(jObj, level) {
    let attrStr = "";
    let val = "";
    const keys = Object.keys(jObj);
    const len = keys.length;
    for(let i = 0; i < len; i++){
        const key = keys[i];
        if (typeof jObj[key] === "undefined") ;
        else if (jObj[key] === null) val += this.indentate(level) + "<" + key + "/" + this.tagEndChar;
        else if (jObj[key] instanceof Date) val += this.buildTextNode(jObj[key], key, "", level);
        else if (typeof jObj[key] !== "object") {
            //premitive type
            const attr = this.isAttribute(key);
            if (attr) attrStr += " " + attr + '="' + this.options.attrValueProcessor("" + jObj[key]) + '"';
            else if (this.isCDATA(key)) {
                if (jObj[this.options.textNodeName]) val += this.replaceCDATAstr(jObj[this.options.textNodeName], jObj[key]);
                else val += this.replaceCDATAstr("", jObj[key]);
            } else //tag value
            if (key === this.options.textNodeName) {
                if (jObj[this.options.cdataTagName]) ;
                else val += this.options.tagValueProcessor("" + jObj[key]);
            } else val += this.buildTextNode(jObj[key], key, "", level);
        } else if (Array.isArray(jObj[key])) {
            //repeated nodes
            if (this.isCDATA(key)) {
                val += this.indentate(level);
                if (jObj[this.options.textNodeName]) val += this.replaceCDATAarr(jObj[this.options.textNodeName], jObj[key]);
                else val += this.replaceCDATAarr("", jObj[key]);
            } else {
                //nested nodes
                const arrLen = jObj[key].length;
                for(let j = 0; j < arrLen; j++){
                    const item = jObj[key][j];
                    if (typeof item === "undefined") ;
                    else if (item === null) val += this.indentate(level) + "<" + key + "/" + this.tagEndChar;
                    else if (typeof item === "object") {
                        const result = this.j2x(item, level + 1);
                        val += this.buildObjNode(result.val, key, result.attrStr, level);
                    } else val += this.buildTextNode(item, key, "", level);
                }
            }
        } else //nested node
        if (this.options.attrNodeName && key === this.options.attrNodeName) {
            const Ks = Object.keys(jObj[key]);
            const L = Ks.length;
            for(let j = 0; j < L; j++)attrStr += " " + Ks[j] + '="' + this.options.attrValueProcessor("" + jObj[key][Ks[j]]) + '"';
        } else {
            const result = this.j2x(jObj[key], level + 1);
            val += this.buildObjNode(result.val, key, result.attrStr, level);
        }
    }
    return {
        attrStr: attrStr,
        val: val
    };
};
function $bebf54e7096383a5$var$replaceCDATAstr(str, cdata) {
    str = this.options.tagValueProcessor("" + str);
    if (this.options.cdataPositionChar === "" || str === "") return str + "<![CDATA[" + cdata + "]]" + this.tagEndChar;
    else return str.replace(this.options.cdataPositionChar, "<![CDATA[" + cdata + "]]" + this.tagEndChar);
}
function $bebf54e7096383a5$var$replaceCDATAarr(str, cdata) {
    str = this.options.tagValueProcessor("" + str);
    if (this.options.cdataPositionChar === "" || str === "") return str + "<![CDATA[" + cdata.join("]]><![CDATA[") + "]]" + this.tagEndChar;
    else {
        for(let v in cdata)str = str.replace(this.options.cdataPositionChar, "<![CDATA[" + cdata[v] + "]]>");
        return str + this.newLine;
    }
}
function $bebf54e7096383a5$var$buildObjectNode(val, key, attrStr, level) {
    if (attrStr && !val.includes("<")) return this.indentate(level) + "<" + key + attrStr + ">" + val + //+ this.newLine
    // + this.indentate(level)
    "</" + key + this.tagEndChar;
    else return this.indentate(level) + "<" + key + attrStr + this.tagEndChar + val + //+ this.newLine
    this.indentate(level) + "</" + key + this.tagEndChar;
}
function $bebf54e7096383a5$var$buildEmptyObjNode(val, key, attrStr, level) {
    if (val !== "") return this.buildObjectNode(val, key, attrStr, level);
    else return this.indentate(level) + "<" + key + attrStr + "/" + this.tagEndChar;
}
function $bebf54e7096383a5$var$buildTextValNode(val, key, attrStr, level) {
    return this.indentate(level) + "<" + key + attrStr + ">" + this.options.tagValueProcessor(val) + "</" + key + this.tagEndChar;
}
function $bebf54e7096383a5$var$buildEmptyTextNode(val, key, attrStr, level) {
    if (val !== "") return this.buildTextValNode(val, key, attrStr, level);
    else return this.indentate(level) + "<" + key + attrStr + "/" + this.tagEndChar;
}
function $bebf54e7096383a5$var$indentate(level) {
    return this.options.indentBy.repeat(level);
}
function $bebf54e7096383a5$var$isAttribute(name /*, options*/ ) {
    if (name.startsWith(this.options.attributeNamePrefix)) return name.substr(this.attrPrefixLen);
    else return false;
}
function $bebf54e7096383a5$var$isCDATA(name) {
    return name === this.options.cdataTagName;
}
//formatting
//indentation
//\n after each closing or self closing tag
module.exports = $bebf54e7096383a5$var$Parser;

});

parcelRegister("dZNvx", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Sha256 = void 0;

var $jLgwE = parcelRequire("jLgwE");

var $iS0p3 = parcelRequire("iS0p3");

var $hMqoc = parcelRequire("hMqoc");

var $ev7Sh = parcelRequire("ev7Sh");

var $5J2Ch = parcelRequire("5J2Ch");

var $b3AtY = parcelRequire("b3AtY");
var $a30760100f159708$var$Sha256 = /** @class */ function() {
    function Sha256(secret) {
        if ((0, $ev7Sh.supportsWebCrypto)((0, $b3AtY.locateWindow)())) this.hash = new $iS0p3.Sha256(secret);
        else if ((0, $5J2Ch.isMsWindow)((0, $b3AtY.locateWindow)())) this.hash = new $jLgwE.Sha256(secret);
        else this.hash = new $hMqoc.Sha256(secret);
    }
    Sha256.prototype.update = function(data, encoding) {
        this.hash.update(data, encoding);
    };
    Sha256.prototype.digest = function() {
        return this.hash.digest();
    };
    return Sha256;
}();
module.exports.Sha256 = $a30760100f159708$var$Sha256;

});
parcelRegister("jLgwE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Sha256 = void 0;

var $5W33V = parcelRequire("5W33V");

var $HuE2p = parcelRequire("HuE2p");

var $iqmfT = parcelRequire("iqmfT");

var $b3AtY = parcelRequire("b3AtY");
var $e62f39bfe4c4c07c$var$Sha256 = /** @class */ function() {
    function Sha256(secret) {
        if (secret) {
            this.operation = $e62f39bfe4c4c07c$var$getKeyPromise(secret).then(function(keyData) {
                return (0, $b3AtY.locateWindow)().msCrypto.subtle.sign($HuE2p.SHA_256_HMAC_ALGO, keyData);
            });
            this.operation.catch(function() {});
        } else this.operation = Promise.resolve((0, $b3AtY.locateWindow)().msCrypto.subtle.digest("SHA-256"));
    }
    Sha256.prototype.update = function(toHash) {
        var _this = this;
        if ((0, $5W33V.isEmptyData)(toHash)) return;
        this.operation = this.operation.then(function(operation) {
            operation.onerror = function() {
                _this.operation = Promise.reject(new Error("Error encountered updating hash"));
            };
            operation.process($e62f39bfe4c4c07c$var$toArrayBufferView(toHash));
            return operation;
        });
        this.operation.catch(function() {});
    };
    Sha256.prototype.digest = function() {
        return this.operation.then(function(operation) {
            return new Promise(function(resolve, reject) {
                operation.onerror = function() {
                    reject(new Error("Error encountered finalizing hash"));
                };
                operation.oncomplete = function() {
                    if (operation.result) resolve(new Uint8Array(operation.result));
                    reject(new Error("Error encountered finalizing hash"));
                };
                operation.finish();
            });
        });
    };
    return Sha256;
}();
module.exports.Sha256 = $e62f39bfe4c4c07c$var$Sha256;
function $e62f39bfe4c4c07c$var$getKeyPromise(secret) {
    return new Promise(function(resolve, reject) {
        var keyOperation = (0, $b3AtY.locateWindow)().msCrypto.subtle.importKey("raw", $e62f39bfe4c4c07c$var$toArrayBufferView(secret), $HuE2p.SHA_256_HMAC_ALGO, false, [
            "sign"
        ]);
        keyOperation.oncomplete = function() {
            if (keyOperation.result) resolve(keyOperation.result);
            reject(new Error("ImportKey completed without importing key."));
        };
        keyOperation.onerror = function() {
            reject(new Error("ImportKey failed to import key."));
        };
    });
}
function $e62f39bfe4c4c07c$var$toArrayBufferView(data) {
    if (typeof data === "string") return (0, $iqmfT.fromUtf8)(data);
    if (ArrayBuffer.isView(data)) return new Uint8Array(data.buffer, data.byteOffset, data.byteLength / Uint8Array.BYTES_PER_ELEMENT);
    return new Uint8Array(data);
}

});
parcelRegister("5W33V", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isEmptyData = void 0;
function $4524bea7fa1c3c18$var$isEmptyData(data) {
    if (typeof data === "string") return data.length === 0;
    return data.byteLength === 0;
}
module.exports.isEmptyData = $4524bea7fa1c3c18$var$isEmptyData;

});

parcelRegister("HuE2p", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.EMPTY_DATA_SHA_256 = module.exports.SHA_256_HMAC_ALGO = module.exports.SHA_256_HASH = void 0;
module.exports.SHA_256_HASH = {
    name: "SHA-256"
};
module.exports.SHA_256_HMAC_ALGO = {
    name: "HMAC",
    hash: module.exports.SHA_256_HASH
};
module.exports.EMPTY_DATA_SHA_256 = new Uint8Array([
    227,
    176,
    196,
    66,
    152,
    252,
    28,
    20,
    154,
    251,
    244,
    200,
    153,
    111,
    185,
    36,
    39,
    174,
    65,
    228,
    100,
    155,
    147,
    76,
    164,
    149,
    153,
    27,
    120,
    82,
    184,
    85
]);

});

parcelRegister("iqmfT", function(module, exports) {

$parcel$export(module.exports, "fromUtf8", () => $d69beb215036a813$export$c7c5cef950a4d2fc);
$parcel$export(module.exports, "toUtf8", () => $d69beb215036a813$export$b4b216764bb846eb);

var $krfVd = parcelRequire("krfVd");

var $3lZTG = parcelRequire("3lZTG");
var $d69beb215036a813$export$c7c5cef950a4d2fc = function(input) {
    return typeof TextEncoder === "function" ? (0, $3lZTG.fromUtf8)(input) : (0, $krfVd.fromUtf8)(input);
};
var $d69beb215036a813$export$b4b216764bb846eb = function(input) {
    return typeof TextDecoder === "function" ? (0, $3lZTG.toUtf8)(input) : (0, $krfVd.toUtf8)(input);
};

});
parcelRegister("krfVd", function(module, exports) {

$parcel$export(module.exports, "fromUtf8", () => $ee12ae0367269f41$export$c7c5cef950a4d2fc);
$parcel$export(module.exports, "toUtf8", () => $ee12ae0367269f41$export$b4b216764bb846eb);
var $ee12ae0367269f41$export$c7c5cef950a4d2fc = function(input) {
    var bytes = [];
    for(var i = 0, len = input.length; i < len; i++){
        var value = input.charCodeAt(i);
        if (value < 0x80) bytes.push(value);
        else if (value < 0x800) bytes.push(value >> 6 | 192, value & 63 | 128);
        else if (i + 1 < input.length && (value & 0xfc00) === 0xd800 && (input.charCodeAt(i + 1) & 0xfc00) === 0xdc00) {
            var surrogatePair = 0x10000 + ((value & 1023) << 10) + (input.charCodeAt(++i) & 1023);
            bytes.push(surrogatePair >> 18 | 240, surrogatePair >> 12 & 63 | 128, surrogatePair >> 6 & 63 | 128, surrogatePair & 63 | 128);
        } else bytes.push(value >> 12 | 224, value >> 6 & 63 | 128, value & 63 | 128);
    }
    return Uint8Array.from(bytes);
};
var $ee12ae0367269f41$export$b4b216764bb846eb = function(input) {
    var decoded = "";
    for(var i = 0, len = input.length; i < len; i++){
        var byte = input[i];
        if (byte < 0x80) decoded += String.fromCharCode(byte);
        else if (192 <= byte && byte < 224) {
            var nextByte = input[++i];
            decoded += String.fromCharCode((byte & 31) << 6 | nextByte & 63);
        } else if (240 <= byte && byte < 365) {
            var surrogatePair = [
                byte,
                input[++i],
                input[++i],
                input[++i]
            ];
            var encoded = "%" + surrogatePair.map(function(byteValue) {
                return byteValue.toString(16);
            }).join("%");
            decoded += decodeURIComponent(encoded);
        } else decoded += String.fromCharCode((byte & 15) << 12 | (input[++i] & 63) << 6 | input[++i] & 63);
    }
    return decoded;
};

});

parcelRegister("3lZTG", function(module, exports) {

$parcel$export(module.exports, "fromUtf8", () => $271358b93759ea16$export$c7c5cef950a4d2fc);
$parcel$export(module.exports, "toUtf8", () => $271358b93759ea16$export$b4b216764bb846eb);
function $271358b93759ea16$export$c7c5cef950a4d2fc(input) {
    return new TextEncoder().encode(input);
}
function $271358b93759ea16$export$b4b216764bb846eb(input) {
    return new TextDecoder("utf-8").decode(input);
}

});


parcelRegister("b3AtY", function(module, exports) {

$parcel$export(module.exports, "locateWindow", () => $80cc462e9f5bf099$export$2a77db4d0e0dd1ff);
var $80cc462e9f5bf099$var$fallbackWindow = {};
function $80cc462e9f5bf099$export$2a77db4d0e0dd1ff() {
    if (typeof window !== "undefined") return window;
    else if (typeof self !== "undefined") return self;
    return $80cc462e9f5bf099$var$fallbackWindow;
}

});


parcelRegister("iS0p3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Sha256 = void 0;

var $8XVZm = parcelRequire("8XVZm");

var $HuE2p = parcelRequire("HuE2p");

var $b3AtY = parcelRequire("b3AtY");
var $dbcd95333c2a53f2$var$Sha256 = /** @class */ function() {
    function Sha256(secret) {
        this.toHash = new Uint8Array(0);
        if (secret !== void 0) {
            this.key = new Promise(function(resolve, reject) {
                (0, $b3AtY.locateWindow)().crypto.subtle.importKey("raw", (0, $8XVZm.convertToBuffer)(secret), $HuE2p.SHA_256_HMAC_ALGO, false, [
                    "sign"
                ]).then(resolve, reject);
            });
            this.key.catch(function() {});
        }
    }
    Sha256.prototype.update = function(data) {
        if ((0, $8XVZm.isEmptyData)(data)) return;
        var update = (0, $8XVZm.convertToBuffer)(data);
        var typedArray = new Uint8Array(this.toHash.byteLength + update.byteLength);
        typedArray.set(this.toHash, 0);
        typedArray.set(update, this.toHash.byteLength);
        this.toHash = typedArray;
    };
    Sha256.prototype.digest = function() {
        var _this = this;
        if (this.key) return this.key.then(function(key) {
            return (0, $b3AtY.locateWindow)().crypto.subtle.sign($HuE2p.SHA_256_HMAC_ALGO, key, _this.toHash).then(function(data) {
                return new Uint8Array(data);
            });
        });
        if ((0, $8XVZm.isEmptyData)(this.toHash)) return Promise.resolve($HuE2p.EMPTY_DATA_SHA_256);
        return Promise.resolve().then(function() {
            return (0, $b3AtY.locateWindow)().crypto.subtle.digest($HuE2p.SHA_256_HASH, _this.toHash);
        }).then(function(data) {
            return Promise.resolve(new Uint8Array(data));
        });
    };
    return Sha256;
}();
module.exports.Sha256 = $dbcd95333c2a53f2$var$Sha256;

});
parcelRegister("8XVZm", function(module, exports) {
"use strict";
// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.uint32ArrayFrom = module.exports.numToUint8 = module.exports.isEmptyData = module.exports.convertToBuffer = void 0;

var $j519d = parcelRequire("j519d");
Object.defineProperty(module.exports, "convertToBuffer", {
    enumerable: true,
    get: function() {
        return $j519d.convertToBuffer;
    }
});

var $7aVm5 = parcelRequire("7aVm5");
Object.defineProperty(module.exports, "isEmptyData", {
    enumerable: true,
    get: function() {
        return $7aVm5.isEmptyData;
    }
});

var $lBxdf = parcelRequire("lBxdf");
Object.defineProperty(module.exports, "numToUint8", {
    enumerable: true,
    get: function() {
        return $lBxdf.numToUint8;
    }
});

var $3vXlk = parcelRequire("3vXlk");
Object.defineProperty(module.exports, "uint32ArrayFrom", {
    enumerable: true,
    get: function() {
        return $3vXlk.uint32ArrayFrom;
    }
});

});
parcelRegister("j519d", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $de3f5fda7f197684$require$Buffer = $6ZWSX.Buffer;
"use strict";
// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.convertToBuffer = void 0;

var $iqmfT = parcelRequire("iqmfT");
// Quick polyfill
var $de3f5fda7f197684$var$fromUtf8 = typeof $de3f5fda7f197684$require$Buffer !== "undefined" && $de3f5fda7f197684$require$Buffer.from ? function(input) {
    return $de3f5fda7f197684$require$Buffer.from(input, "utf8");
} : $iqmfT.fromUtf8;
function $de3f5fda7f197684$var$convertToBuffer(data) {
    // Already a Uint8, do nothing
    if (data instanceof Uint8Array) return data;
    if (typeof data === "string") return $de3f5fda7f197684$var$fromUtf8(data);
    if (ArrayBuffer.isView(data)) return new Uint8Array(data.buffer, data.byteOffset, data.byteLength / Uint8Array.BYTES_PER_ELEMENT);
    return new Uint8Array(data);
}
module.exports.convertToBuffer = $de3f5fda7f197684$var$convertToBuffer;

});
parcelRegister("6ZWSX", function(module, exports) {

$parcel$export(module.exports, "Buffer", () => $51861dfc7ca9d588$export$a143d493d941bafc, (v) => $51861dfc7ca9d588$export$a143d493d941bafc = v);
$parcel$export(module.exports, "INSPECT_MAX_BYTES", () => $51861dfc7ca9d588$export$f99ded8fe4b79145, (v) => $51861dfc7ca9d588$export$f99ded8fe4b79145 = v);
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $51861dfc7ca9d588$export$a143d493d941bafc;
var $51861dfc7ca9d588$export$e4cf37d7f6fb9e0a;
var $51861dfc7ca9d588$export$f99ded8fe4b79145;
var $51861dfc7ca9d588$export$599f31c3813fae4d;
"use strict";

var $kuxul = parcelRequire("kuxul");

var $9NvM5 = parcelRequire("9NvM5");
const $51861dfc7ca9d588$var$customInspectSymbol = typeof Symbol === "function" && typeof Symbol["for"] === "function" // eslint-disable-line dot-notation
 ? Symbol["for"]("nodejs.util.inspect.custom") // eslint-disable-line dot-notation
 : null;
$51861dfc7ca9d588$export$a143d493d941bafc = $51861dfc7ca9d588$var$Buffer;
$51861dfc7ca9d588$export$e4cf37d7f6fb9e0a = $51861dfc7ca9d588$var$SlowBuffer;
$51861dfc7ca9d588$export$f99ded8fe4b79145 = 50;
const $51861dfc7ca9d588$var$K_MAX_LENGTH = 0x7fffffff;
$51861dfc7ca9d588$export$599f31c3813fae4d = $51861dfc7ca9d588$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $51861dfc7ca9d588$var$Buffer.TYPED_ARRAY_SUPPORT = $51861dfc7ca9d588$var$typedArraySupport();
if (!$51861dfc7ca9d588$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== "undefined" && typeof console.error === "function") console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $51861dfc7ca9d588$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($51861dfc7ca9d588$var$Buffer.prototype, "parent", {
    enumerable: true,
    get: function() {
        if (!$51861dfc7ca9d588$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($51861dfc7ca9d588$var$Buffer.prototype, "offset", {
    enumerable: true,
    get: function() {
        if (!$51861dfc7ca9d588$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $51861dfc7ca9d588$var$createBuffer(length) {
    if (length > $51861dfc7ca9d588$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $51861dfc7ca9d588$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $51861dfc7ca9d588$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === "number") {
        if (typeof encodingOrOffset === "string") throw new TypeError('The "string" argument must be of type string. Received type number');
        return $51861dfc7ca9d588$var$allocUnsafe(arg);
    }
    return $51861dfc7ca9d588$var$from(arg, encodingOrOffset, length);
}
$51861dfc7ca9d588$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $51861dfc7ca9d588$var$from(value, encodingOrOffset, length) {
    if (typeof value === "string") return $51861dfc7ca9d588$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $51861dfc7ca9d588$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($51861dfc7ca9d588$var$isInstance(value, ArrayBuffer) || value && $51861dfc7ca9d588$var$isInstance(value.buffer, ArrayBuffer)) return $51861dfc7ca9d588$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== "undefined" && ($51861dfc7ca9d588$var$isInstance(value, SharedArrayBuffer) || value && $51861dfc7ca9d588$var$isInstance(value.buffer, SharedArrayBuffer))) return $51861dfc7ca9d588$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === "number") throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $51861dfc7ca9d588$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $51861dfc7ca9d588$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== "undefined" && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === "function") return $51861dfc7ca9d588$var$Buffer.from(value[Symbol.toPrimitive]("string"), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $51861dfc7ca9d588$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $51861dfc7ca9d588$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($51861dfc7ca9d588$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($51861dfc7ca9d588$var$Buffer, Uint8Array);
function $51861dfc7ca9d588$var$assertSize(size) {
    if (typeof size !== "number") throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $51861dfc7ca9d588$var$alloc(size, fill, encoding) {
    $51861dfc7ca9d588$var$assertSize(size);
    if (size <= 0) return $51861dfc7ca9d588$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === "string" ? $51861dfc7ca9d588$var$createBuffer(size).fill(fill, encoding) : $51861dfc7ca9d588$var$createBuffer(size).fill(fill);
    return $51861dfc7ca9d588$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $51861dfc7ca9d588$var$Buffer.alloc = function(size, fill, encoding) {
    return $51861dfc7ca9d588$var$alloc(size, fill, encoding);
};
function $51861dfc7ca9d588$var$allocUnsafe(size) {
    $51861dfc7ca9d588$var$assertSize(size);
    return $51861dfc7ca9d588$var$createBuffer(size < 0 ? 0 : $51861dfc7ca9d588$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $51861dfc7ca9d588$var$Buffer.allocUnsafe = function(size) {
    return $51861dfc7ca9d588$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $51861dfc7ca9d588$var$Buffer.allocUnsafeSlow = function(size) {
    return $51861dfc7ca9d588$var$allocUnsafe(size);
};
function $51861dfc7ca9d588$var$fromString(string, encoding) {
    if (typeof encoding !== "string" || encoding === "") encoding = "utf8";
    if (!$51861dfc7ca9d588$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
    const length = $51861dfc7ca9d588$var$byteLength(string, encoding) | 0;
    let buf = $51861dfc7ca9d588$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $51861dfc7ca9d588$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $51861dfc7ca9d588$var$checked(array.length) | 0;
    const buf = $51861dfc7ca9d588$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $51861dfc7ca9d588$var$fromArrayView(arrayView) {
    if ($51861dfc7ca9d588$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $51861dfc7ca9d588$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $51861dfc7ca9d588$var$fromArrayLike(arrayView);
}
function $51861dfc7ca9d588$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $51861dfc7ca9d588$var$Buffer.prototype);
    return buf;
}
function $51861dfc7ca9d588$var$fromObject(obj) {
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(obj)) {
        const len = $51861dfc7ca9d588$var$checked(obj.length) | 0;
        const buf = $51861dfc7ca9d588$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== "number" || $51861dfc7ca9d588$var$numberIsNaN(obj.length)) return $51861dfc7ca9d588$var$createBuffer(0);
        return $51861dfc7ca9d588$var$fromArrayLike(obj);
    }
    if (obj.type === "Buffer" && Array.isArray(obj.data)) return $51861dfc7ca9d588$var$fromArrayLike(obj.data);
}
function $51861dfc7ca9d588$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $51861dfc7ca9d588$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $51861dfc7ca9d588$var$K_MAX_LENGTH.toString(16) + " bytes");
    return length | 0;
}
function $51861dfc7ca9d588$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $51861dfc7ca9d588$var$Buffer.alloc(+length);
}
$51861dfc7ca9d588$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $51861dfc7ca9d588$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$51861dfc7ca9d588$var$Buffer.compare = function compare(a, b) {
    if ($51861dfc7ca9d588$var$isInstance(a, Uint8Array)) a = $51861dfc7ca9d588$var$Buffer.from(a, a.offset, a.byteLength);
    if ($51861dfc7ca9d588$var$isInstance(b, Uint8Array)) b = $51861dfc7ca9d588$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(a) || !$51861dfc7ca9d588$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$51861dfc7ca9d588$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "latin1":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return true;
        default:
            return false;
    }
};
$51861dfc7ca9d588$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $51861dfc7ca9d588$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $51861dfc7ca9d588$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($51861dfc7ca9d588$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) buf = $51861dfc7ca9d588$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $51861dfc7ca9d588$var$byteLength(string, encoding) {
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $51861dfc7ca9d588$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== "string") throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case "ascii":
        case "latin1":
        case "binary":
            return len;
        case "utf8":
        case "utf-8":
            return $51861dfc7ca9d588$var$utf8ToBytes(string).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return len * 2;
        case "hex":
            return len >>> 1;
        case "base64":
            return $51861dfc7ca9d588$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $51861dfc7ca9d588$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
}
$51861dfc7ca9d588$var$Buffer.byteLength = $51861dfc7ca9d588$var$byteLength;
function $51861dfc7ca9d588$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return "";
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return "";
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return "";
    if (!encoding) encoding = "utf8";
    while(true)switch(encoding){
        case "hex":
            return $51861dfc7ca9d588$var$hexSlice(this, start, end);
        case "utf8":
        case "utf-8":
            return $51861dfc7ca9d588$var$utf8Slice(this, start, end);
        case "ascii":
            return $51861dfc7ca9d588$var$asciiSlice(this, start, end);
        case "latin1":
        case "binary":
            return $51861dfc7ca9d588$var$latin1Slice(this, start, end);
        case "base64":
            return $51861dfc7ca9d588$var$base64Slice(this, start, end);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $51861dfc7ca9d588$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = (encoding + "").toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$51861dfc7ca9d588$var$Buffer.prototype._isBuffer = true;
function $51861dfc7ca9d588$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$51861dfc7ca9d588$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
    for(let i = 0; i < len; i += 2)$51861dfc7ca9d588$var$swap(this, i, i + 1);
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
    for(let i = 0; i < len; i += 4){
        $51861dfc7ca9d588$var$swap(this, i, i + 3);
        $51861dfc7ca9d588$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
    for(let i = 0; i < len; i += 8){
        $51861dfc7ca9d588$var$swap(this, i, i + 7);
        $51861dfc7ca9d588$var$swap(this, i + 1, i + 6);
        $51861dfc7ca9d588$var$swap(this, i + 2, i + 5);
        $51861dfc7ca9d588$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return "";
    if (arguments.length === 0) return $51861dfc7ca9d588$var$utf8Slice(this, 0, length);
    return $51861dfc7ca9d588$var$slowToString.apply(this, arguments);
};
$51861dfc7ca9d588$var$Buffer.prototype.toLocaleString = $51861dfc7ca9d588$var$Buffer.prototype.toString;
$51861dfc7ca9d588$var$Buffer.prototype.equals = function equals(b) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(b)) throw new TypeError("Argument must be a Buffer");
    if (this === b) return true;
    return $51861dfc7ca9d588$var$Buffer.compare(this, b) === 0;
};
$51861dfc7ca9d588$var$Buffer.prototype.inspect = function inspect() {
    let str = "";
    const max = $51861dfc7ca9d588$export$f99ded8fe4b79145;
    str = this.toString("hex", 0, max).replace(/(.{2})/g, "$1 ").trim();
    if (this.length > max) str += " ... ";
    return "<Buffer " + str + ">";
};
if ($51861dfc7ca9d588$var$customInspectSymbol) $51861dfc7ca9d588$var$Buffer.prototype[$51861dfc7ca9d588$var$customInspectSymbol] = $51861dfc7ca9d588$var$Buffer.prototype.inspect;
$51861dfc7ca9d588$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($51861dfc7ca9d588$var$isInstance(target, Uint8Array)) target = $51861dfc7ca9d588$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError("out of range index");
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $51861dfc7ca9d588$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === "string") {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($51861dfc7ca9d588$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === "string") val = $51861dfc7ca9d588$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $51861dfc7ca9d588$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === "number") {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === "function") {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $51861dfc7ca9d588$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError("val must be string, number or Buffer");
}
function $51861dfc7ca9d588$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === "ucs2" || encoding === "ucs-2" || encoding === "utf16le" || encoding === "utf-16le") {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$51861dfc7ca9d588$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$51861dfc7ca9d588$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $51861dfc7ca9d588$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$51861dfc7ca9d588$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $51861dfc7ca9d588$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $51861dfc7ca9d588$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($51861dfc7ca9d588$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $51861dfc7ca9d588$var$utf8Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $51861dfc7ca9d588$var$asciiWrite(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$asciiToBytes(string), buf, offset, length);
}
function $51861dfc7ca9d588$var$base64Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$base64ToBytes(string), buf, offset, length);
}
function $51861dfc7ca9d588$var$ucs2Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$51861dfc7ca9d588$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = "utf8";
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === "string") {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = "utf8";
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError("Attempt to write outside buffer bounds");
    if (!encoding) encoding = "utf8";
    let loweredCase = false;
    for(;;)switch(encoding){
        case "hex":
            return $51861dfc7ca9d588$var$hexWrite(this, string, offset, length);
        case "utf8":
        case "utf-8":
            return $51861dfc7ca9d588$var$utf8Write(this, string, offset, length);
        case "ascii":
        case "latin1":
        case "binary":
            return $51861dfc7ca9d588$var$asciiWrite(this, string, offset, length);
        case "base64":
            // Warning: maxLength not taken into account in base64Write
            return $51861dfc7ca9d588$var$base64Write(this, string, offset, length);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $51861dfc7ca9d588$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
};
$51861dfc7ca9d588$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: "Buffer",
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $51861dfc7ca9d588$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $kuxul.fromByteArray(buf);
    else return $kuxul.fromByteArray(buf.slice(start, end));
}
function $51861dfc7ca9d588$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $51861dfc7ca9d588$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $51861dfc7ca9d588$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = "";
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $51861dfc7ca9d588$var$asciiSlice(buf, start, end) {
    let ret = "";
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $51861dfc7ca9d588$var$latin1Slice(buf, start, end) {
    let ret = "";
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $51861dfc7ca9d588$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = "";
    for(let i = start; i < end; ++i)out += $51861dfc7ca9d588$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $51861dfc7ca9d588$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = "";
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$51861dfc7ca9d588$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $51861dfc7ca9d588$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $51861dfc7ca9d588$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError("offset is not uint");
    if (offset + ext > length) throw new RangeError("Trying to access beyond buffer length");
}
$51861dfc7ca9d588$var$Buffer.prototype.readUintLE = $51861dfc7ca9d588$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUintBE = $51861dfc7ca9d588$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint8 = $51861dfc7ca9d588$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint16LE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint16BE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint32LE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint32BE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$51861dfc7ca9d588$var$Buffer.prototype.readBigUInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$51861dfc7ca9d588$var$Buffer.prototype.readBigUInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$51861dfc7ca9d588$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$51861dfc7ca9d588$var$Buffer.prototype.readBigInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$51861dfc7ca9d588$var$Buffer.prototype.readBigInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$51861dfc7ca9d588$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return $9NvM5.read(this, offset, true, 23, 4);
};
$51861dfc7ca9d588$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return $9NvM5.read(this, offset, false, 23, 4);
};
$51861dfc7ca9d588$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 8, this.length);
    return $9NvM5.read(this, offset, true, 52, 8);
};
$51861dfc7ca9d588$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 8, this.length);
    return $9NvM5.read(this, offset, false, 52, 8);
};
function $51861dfc7ca9d588$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
}
$51861dfc7ca9d588$var$Buffer.prototype.writeUintLE = $51861dfc7ca9d588$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUintBE = $51861dfc7ca9d588$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint8 = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint16LE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint16BE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint32LE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint32BE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $51861dfc7ca9d588$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $51861dfc7ca9d588$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeBigUInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeBigUInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeBigInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64LE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeBigInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64BE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
function $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
    if (offset < 0) throw new RangeError("Index out of range");
}
function $51861dfc7ca9d588$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $9NvM5.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeFloat(this, value, offset, true, noAssert);
};
$51861dfc7ca9d588$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeFloat(this, value, offset, false, noAssert);
};
function $51861dfc7ca9d588$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $9NvM5.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeDouble(this, value, offset, true, noAssert);
};
$51861dfc7ca9d588$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$51861dfc7ca9d588$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(target)) throw new TypeError("argument should be a Buffer");
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError("targetStart out of bounds");
    if (start < 0 || start >= this.length) throw new RangeError("Index out of range");
    if (end < 0) throw new RangeError("sourceEnd out of bounds");
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === "function") // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$51861dfc7ca9d588$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === "string") {
        if (typeof start === "string") {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === "string") {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== "string") throw new TypeError("encoding must be a string");
        if (typeof encoding === "string" && !$51861dfc7ca9d588$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === "utf8" && code < 128 || encoding === "latin1") // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === "number") val = val & 255;
    else if (typeof val === "boolean") val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError("Out of range index");
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === "number") for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $51861dfc7ca9d588$var$Buffer.isBuffer(val) ? val : $51861dfc7ca9d588$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $51861dfc7ca9d588$var$errors = {};
function $51861dfc7ca9d588$var$E(sym, getMessage, Base) {
    $51861dfc7ca9d588$var$errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, "message", {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, "code", {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
$51861dfc7ca9d588$var$E("ERR_BUFFER_OUT_OF_BOUNDS", function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return "Attempt to access memory outside buffer bounds";
}, RangeError);
$51861dfc7ca9d588$var$E("ERR_INVALID_ARG_TYPE", function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$51861dfc7ca9d588$var$E("ERR_OUT_OF_RANGE", function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $51861dfc7ca9d588$var$addNumericalSeparator(String(input));
    else if (typeof input === "bigint") {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $51861dfc7ca9d588$var$addNumericalSeparator(received);
        received += "n";
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $51861dfc7ca9d588$var$addNumericalSeparator(val) {
    let res = "";
    let i = val.length;
    const start = val[0] === "-" ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $51861dfc7ca9d588$var$checkBounds(buf, offset, byteLength) {
    $51861dfc7ca9d588$var$validateNumber(offset, "offset");
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $51861dfc7ca9d588$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === "bigint" ? "n" : "";
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE("value", range, value);
    }
    $51861dfc7ca9d588$var$checkBounds(buf, offset, byteLength);
}
function $51861dfc7ca9d588$var$validateNumber(value, name) {
    if (typeof value !== "number") throw new $51861dfc7ca9d588$var$errors.ERR_INVALID_ARG_TYPE(name, "number", value);
}
function $51861dfc7ca9d588$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $51861dfc7ca9d588$var$validateNumber(value, type);
        throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE(type || "offset", "an integer", value);
    }
    if (length < 0) throw new $51861dfc7ca9d588$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE(type || "offset", `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $51861dfc7ca9d588$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $51861dfc7ca9d588$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split("=")[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($51861dfc7ca9d588$var$INVALID_BASE64_RE, "");
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return "";
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + "=";
    return str;
}
function $51861dfc7ca9d588$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error("Invalid code point");
    }
    return bytes;
}
function $51861dfc7ca9d588$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $51861dfc7ca9d588$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $51861dfc7ca9d588$var$base64ToBytes(str) {
    return $kuxul.toByteArray($51861dfc7ca9d588$var$base64clean(str));
}
function $51861dfc7ca9d588$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $51861dfc7ca9d588$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $51861dfc7ca9d588$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $51861dfc7ca9d588$var$hexSliceLookupTable = function() {
    const alphabet = "0123456789abcdef";
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $51861dfc7ca9d588$var$defineBigIntMethod(fn) {
    return typeof BigInt === "undefined" ? $51861dfc7ca9d588$var$BufferBigIntNotDefined : fn;
}
function $51861dfc7ca9d588$var$BufferBigIntNotDefined() {
    throw new Error("BigInt not supported");
}

});
parcelRegister("kuxul", function(module, exports) {

$parcel$export(module.exports, "toByteArray", () => $eeb0961446aae8e3$export$d622b2ad8d90c771, (v) => $eeb0961446aae8e3$export$d622b2ad8d90c771 = v);
$parcel$export(module.exports, "fromByteArray", () => $eeb0961446aae8e3$export$6100ba28696e12de, (v) => $eeb0961446aae8e3$export$6100ba28696e12de = v);
var $eeb0961446aae8e3$export$a48f0734ac7c2329;
var $eeb0961446aae8e3$export$d622b2ad8d90c771;
var $eeb0961446aae8e3$export$6100ba28696e12de;
"use strict";
$eeb0961446aae8e3$export$a48f0734ac7c2329 = $eeb0961446aae8e3$var$byteLength;
$eeb0961446aae8e3$export$d622b2ad8d90c771 = $eeb0961446aae8e3$var$toByteArray;
$eeb0961446aae8e3$export$6100ba28696e12de = $eeb0961446aae8e3$var$fromByteArray;
var $eeb0961446aae8e3$var$lookup = [];
var $eeb0961446aae8e3$var$revLookup = [];
var $eeb0961446aae8e3$var$Arr = typeof Uint8Array !== "undefined" ? Uint8Array : Array;
var $eeb0961446aae8e3$var$code = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
for(var $eeb0961446aae8e3$var$i = 0, $eeb0961446aae8e3$var$len = $eeb0961446aae8e3$var$code.length; $eeb0961446aae8e3$var$i < $eeb0961446aae8e3$var$len; ++$eeb0961446aae8e3$var$i){
    $eeb0961446aae8e3$var$lookup[$eeb0961446aae8e3$var$i] = $eeb0961446aae8e3$var$code[$eeb0961446aae8e3$var$i];
    $eeb0961446aae8e3$var$revLookup[$eeb0961446aae8e3$var$code.charCodeAt($eeb0961446aae8e3$var$i)] = $eeb0961446aae8e3$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$eeb0961446aae8e3$var$revLookup["-".charCodeAt(0)] = 62;
$eeb0961446aae8e3$var$revLookup["_".charCodeAt(0)] = 63;
function $eeb0961446aae8e3$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf("=");
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $eeb0961446aae8e3$var$byteLength(b64) {
    var lens = $eeb0961446aae8e3$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $eeb0961446aae8e3$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $eeb0961446aae8e3$var$toByteArray(b64) {
    var tmp;
    var lens = $eeb0961446aae8e3$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $eeb0961446aae8e3$var$Arr($eeb0961446aae8e3$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 18 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 2 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 10 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $eeb0961446aae8e3$var$tripletToBase64(num) {
    return $eeb0961446aae8e3$var$lookup[num >> 18 & 0x3F] + $eeb0961446aae8e3$var$lookup[num >> 12 & 0x3F] + $eeb0961446aae8e3$var$lookup[num >> 6 & 0x3F] + $eeb0961446aae8e3$var$lookup[num & 0x3F];
}
function $eeb0961446aae8e3$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($eeb0961446aae8e3$var$tripletToBase64(tmp));
    }
    return output.join("");
}
function $eeb0961446aae8e3$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($eeb0961446aae8e3$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($eeb0961446aae8e3$var$lookup[tmp >> 2] + $eeb0961446aae8e3$var$lookup[tmp << 4 & 0x3F] + "==");
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($eeb0961446aae8e3$var$lookup[tmp >> 10] + $eeb0961446aae8e3$var$lookup[tmp >> 4 & 0x3F] + $eeb0961446aae8e3$var$lookup[tmp << 2 & 0x3F] + "=");
    }
    return parts.join("");
}

});

parcelRegister("9NvM5", function(module, exports) {

$parcel$export(module.exports, "read", () => $7221566bd4d49f44$export$aafa59e2e03f2942, (v) => $7221566bd4d49f44$export$aafa59e2e03f2942 = v);
$parcel$export(module.exports, "write", () => $7221566bd4d49f44$export$68d8715fc104d294, (v) => $7221566bd4d49f44$export$68d8715fc104d294 = v);
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $7221566bd4d49f44$export$aafa59e2e03f2942;
var $7221566bd4d49f44$export$68d8715fc104d294;
$7221566bd4d49f44$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$7221566bd4d49f44$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};

});



parcelRegister("7aVm5", function(module, exports) {
"use strict";
// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isEmptyData = void 0;
function $5395f51d1bf94cce$var$isEmptyData(data) {
    if (typeof data === "string") return data.length === 0;
    return data.byteLength === 0;
}
module.exports.isEmptyData = $5395f51d1bf94cce$var$isEmptyData;

});

parcelRegister("lBxdf", function(module, exports) {
"use strict";
// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.numToUint8 = void 0;
function $fba6d101f936c0d0$var$numToUint8(num) {
    return new Uint8Array([
        (num & 0xff000000) >> 24,
        (num & 0x00ff0000) >> 16,
        (num & 0x0000ff00) >> 8,
        num & 0x000000ff
    ]);
}
module.exports.numToUint8 = $fba6d101f936c0d0$var$numToUint8;

});

parcelRegister("3vXlk", function(module, exports) {
"use strict";
// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.uint32ArrayFrom = void 0;
// IE 11 does not support Array.from, so we do it manually
function $28f24c9fc7bfd47c$var$uint32ArrayFrom(a_lookUpTable) {
    if (!Uint32Array.from) {
        var return_array = new Uint32Array(a_lookUpTable.length);
        var a_index = 0;
        while(a_index < a_lookUpTable.length){
            return_array[a_index] = a_lookUpTable[a_index];
            a_index += 1;
        }
        return return_array;
    }
    return Uint32Array.from(a_lookUpTable);
}
module.exports.uint32ArrayFrom = $28f24c9fc7bfd47c$var$uint32ArrayFrom;

});



parcelRegister("hMqoc", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $hOJwo = parcelRequire("hOJwo");

(0, $hOJwo.__exportStar)((parcelRequire("5PPry")), module.exports);

});
parcelRegister("hOJwo", function(module, exports) {

$parcel$export(module.exports, "__awaiter", () => $cf8a6ac5d624fdcb$export$1050f835b63b671e);
$parcel$export(module.exports, "__generator", () => $cf8a6ac5d624fdcb$export$67ebef60e6f28a6);
$parcel$export(module.exports, "__exportStar", () => $cf8a6ac5d624fdcb$export$f33643c0debef087);
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $cf8a6ac5d624fdcb$var$extendStatics = function(d, b) {
    $cf8a6ac5d624fdcb$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $cf8a6ac5d624fdcb$var$extendStatics(d, b);
};
function $cf8a6ac5d624fdcb$export$a8ba968b8961cb8a(d, b) {
    $cf8a6ac5d624fdcb$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $cf8a6ac5d624fdcb$export$18ce0697a983be9b = function() {
    $cf8a6ac5d624fdcb$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $cf8a6ac5d624fdcb$export$18ce0697a983be9b.apply(this, arguments);
};
function $cf8a6ac5d624fdcb$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $cf8a6ac5d624fdcb$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $cf8a6ac5d624fdcb$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $cf8a6ac5d624fdcb$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $cf8a6ac5d624fdcb$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $cf8a6ac5d624fdcb$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function $cf8a6ac5d624fdcb$export$45d3717a4c69092e(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function $cf8a6ac5d624fdcb$export$f33643c0debef087(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function $cf8a6ac5d624fdcb$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $cf8a6ac5d624fdcb$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $cf8a6ac5d624fdcb$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($cf8a6ac5d624fdcb$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $cf8a6ac5d624fdcb$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $cf8a6ac5d624fdcb$export$10c90e4f7922046c(v) {
    return this instanceof $cf8a6ac5d624fdcb$export$10c90e4f7922046c ? (this.v = v, this) : new $cf8a6ac5d624fdcb$export$10c90e4f7922046c(v);
}
function $cf8a6ac5d624fdcb$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $cf8a6ac5d624fdcb$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $cf8a6ac5d624fdcb$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $cf8a6ac5d624fdcb$export$10c90e4f7922046c(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function $cf8a6ac5d624fdcb$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $cf8a6ac5d624fdcb$export$19a8beecd37a4c45 === "function" ? $cf8a6ac5d624fdcb$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $cf8a6ac5d624fdcb$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function $cf8a6ac5d624fdcb$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function $cf8a6ac5d624fdcb$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $cf8a6ac5d624fdcb$export$d5dcaf168c640c35(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function $cf8a6ac5d624fdcb$export$d40a35129aaff81f(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}

});

parcelRegister("5PPry", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Sha256 = void 0;

var $hOJwo = parcelRequire("hOJwo");

var $1c8c5 = parcelRequire("1c8c5");

var $kr8mE = parcelRequire("kr8mE");

var $8XVZm = parcelRequire("8XVZm");
var $43f99ec25bf03fdb$var$Sha256 = /** @class */ function() {
    function Sha256(secret) {
        this.hash = new $kr8mE.RawSha256();
        if (secret) {
            this.outer = new $kr8mE.RawSha256();
            var inner = $43f99ec25bf03fdb$var$bufferFromSecret(secret);
            var outer = new Uint8Array($1c8c5.BLOCK_SIZE);
            outer.set(inner);
            for(var i = 0; i < $1c8c5.BLOCK_SIZE; i++){
                inner[i] ^= 0x36;
                outer[i] ^= 0x5c;
            }
            this.hash.update(inner);
            this.outer.update(outer);
            // overwrite the copied key in memory
            for(var i = 0; i < inner.byteLength; i++)inner[i] = 0;
        }
    }
    Sha256.prototype.update = function(toHash) {
        if ((0, $8XVZm.isEmptyData)(toHash) || this.error) return;
        try {
            this.hash.update((0, $8XVZm.convertToBuffer)(toHash));
        } catch (e) {
            this.error = e;
        }
    };
    /* This synchronous method keeps compatibility
     * with the v2 aws-sdk.
     */ Sha256.prototype.digestSync = function() {
        if (this.error) throw this.error;
        if (this.outer) {
            if (!this.outer.finished) this.outer.update(this.hash.digest());
            return this.outer.digest();
        }
        return this.hash.digest();
    };
    /* The underlying digest method here is synchronous.
     * To keep the same interface with the other hash functions
     * the default is to expose this as an async method.
     * However, it can sometimes be useful to have a sync method.
     */ Sha256.prototype.digest = function() {
        return (0, $hOJwo.__awaiter)(this, void 0, void 0, function() {
            return (0, $hOJwo.__generator)(this, function(_a) {
                return [
                    2 /*return*/ ,
                    this.digestSync()
                ];
            });
        });
    };
    return Sha256;
}();
module.exports.Sha256 = $43f99ec25bf03fdb$var$Sha256;
function $43f99ec25bf03fdb$var$bufferFromSecret(secret) {
    var input = (0, $8XVZm.convertToBuffer)(secret);
    if (input.byteLength > $1c8c5.BLOCK_SIZE) {
        var bufferHash = new $kr8mE.RawSha256();
        bufferHash.update(input);
        input = bufferHash.digest();
    }
    var buffer = new Uint8Array($1c8c5.BLOCK_SIZE);
    buffer.set(input);
    return buffer;
}

});
parcelRegister("1c8c5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MAX_HASHABLE_LENGTH = module.exports.INIT = module.exports.KEY = module.exports.DIGEST_LENGTH = module.exports.BLOCK_SIZE = void 0;
/**
 * @internal
 */ module.exports.BLOCK_SIZE = 64;
/**
 * @internal
 */ module.exports.DIGEST_LENGTH = 32;
/**
 * @internal
 */ module.exports.KEY = new Uint32Array([
    0x428a2f98,
    0x71374491,
    0xb5c0fbcf,
    0xe9b5dba5,
    0x3956c25b,
    0x59f111f1,
    0x923f82a4,
    0xab1c5ed5,
    0xd807aa98,
    0x12835b01,
    0x243185be,
    0x550c7dc3,
    0x72be5d74,
    0x80deb1fe,
    0x9bdc06a7,
    0xc19bf174,
    0xe49b69c1,
    0xefbe4786,
    0x0fc19dc6,
    0x240ca1cc,
    0x2de92c6f,
    0x4a7484aa,
    0x5cb0a9dc,
    0x76f988da,
    0x983e5152,
    0xa831c66d,
    0xb00327c8,
    0xbf597fc7,
    0xc6e00bf3,
    0xd5a79147,
    0x06ca6351,
    0x14292967,
    0x27b70a85,
    0x2e1b2138,
    0x4d2c6dfc,
    0x53380d13,
    0x650a7354,
    0x766a0abb,
    0x81c2c92e,
    0x92722c85,
    0xa2bfe8a1,
    0xa81a664b,
    0xc24b8b70,
    0xc76c51a3,
    0xd192e819,
    0xd6990624,
    0xf40e3585,
    0x106aa070,
    0x19a4c116,
    0x1e376c08,
    0x2748774c,
    0x34b0bcb5,
    0x391c0cb3,
    0x4ed8aa4a,
    0x5b9cca4f,
    0x682e6ff3,
    0x748f82ee,
    0x78a5636f,
    0x84c87814,
    0x8cc70208,
    0x90befffa,
    0xa4506ceb,
    0xbef9a3f7,
    0xc67178f2
]);
/**
 * @internal
 */ module.exports.INIT = [
    0x6a09e667,
    0xbb67ae85,
    0x3c6ef372,
    0xa54ff53a,
    0x510e527f,
    0x9b05688c,
    0x1f83d9ab,
    0x5be0cd19
];
/**
 * @internal
 */ module.exports.MAX_HASHABLE_LENGTH = Math.pow(2, 53) - 1;

});

parcelRegister("kr8mE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RawSha256 = void 0;

var $1c8c5 = parcelRequire("1c8c5");
/**
 * @internal
 */ var $ee0cd14483f8bfb8$var$RawSha256 = /** @class */ function() {
    function RawSha256() {
        this.state = Int32Array.from($1c8c5.INIT);
        this.temp = new Int32Array(64);
        this.buffer = new Uint8Array(64);
        this.bufferLength = 0;
        this.bytesHashed = 0;
        /**
         * @internal
         */ this.finished = false;
    }
    RawSha256.prototype.update = function(data) {
        if (this.finished) throw new Error("Attempted to update an already finished hash.");
        var position = 0;
        var byteLength = data.byteLength;
        this.bytesHashed += byteLength;
        if (this.bytesHashed * 8 > $1c8c5.MAX_HASHABLE_LENGTH) throw new Error("Cannot hash more than 2^53 - 1 bits");
        while(byteLength > 0){
            this.buffer[this.bufferLength++] = data[position++];
            byteLength--;
            if (this.bufferLength === $1c8c5.BLOCK_SIZE) {
                this.hashBuffer();
                this.bufferLength = 0;
            }
        }
    };
    RawSha256.prototype.digest = function() {
        if (!this.finished) {
            var bitsHashed = this.bytesHashed * 8;
            var bufferView = new DataView(this.buffer.buffer, this.buffer.byteOffset, this.buffer.byteLength);
            var undecoratedLength = this.bufferLength;
            bufferView.setUint8(this.bufferLength++, 0x80);
            // Ensure the final block has enough room for the hashed length
            if (undecoratedLength % $1c8c5.BLOCK_SIZE >= $1c8c5.BLOCK_SIZE - 8) {
                for(var i = this.bufferLength; i < $1c8c5.BLOCK_SIZE; i++)bufferView.setUint8(i, 0);
                this.hashBuffer();
                this.bufferLength = 0;
            }
            for(var i = this.bufferLength; i < $1c8c5.BLOCK_SIZE - 8; i++)bufferView.setUint8(i, 0);
            bufferView.setUint32($1c8c5.BLOCK_SIZE - 8, Math.floor(bitsHashed / 0x100000000), true);
            bufferView.setUint32($1c8c5.BLOCK_SIZE - 4, bitsHashed);
            this.hashBuffer();
            this.finished = true;
        }
        // The value in state is little-endian rather than big-endian, so flip
        // each word into a new Uint8Array
        var out = new Uint8Array($1c8c5.DIGEST_LENGTH);
        for(var i = 0; i < 8; i++){
            out[i * 4] = this.state[i] >>> 24 & 0xff;
            out[i * 4 + 1] = this.state[i] >>> 16 & 0xff;
            out[i * 4 + 2] = this.state[i] >>> 8 & 0xff;
            out[i * 4 + 3] = this.state[i] >>> 0 & 0xff;
        }
        return out;
    };
    RawSha256.prototype.hashBuffer = function() {
        var _a = this, buffer = _a.buffer, state = _a.state;
        var state0 = state[0], state1 = state[1], state2 = state[2], state3 = state[3], state4 = state[4], state5 = state[5], state6 = state[6], state7 = state[7];
        for(var i = 0; i < $1c8c5.BLOCK_SIZE; i++){
            if (i < 16) this.temp[i] = (buffer[i * 4] & 0xff) << 24 | (buffer[i * 4 + 1] & 0xff) << 16 | (buffer[i * 4 + 2] & 0xff) << 8 | buffer[i * 4 + 3] & 0xff;
            else {
                var u = this.temp[i - 2];
                var t1_1 = (u >>> 17 | u << 15) ^ (u >>> 19 | u << 13) ^ u >>> 10;
                u = this.temp[i - 15];
                var t2_1 = (u >>> 7 | u << 25) ^ (u >>> 18 | u << 14) ^ u >>> 3;
                this.temp[i] = (t1_1 + this.temp[i - 7] | 0) + (t2_1 + this.temp[i - 16] | 0);
            }
            var t1 = (((state4 >>> 6 | state4 << 26) ^ (state4 >>> 11 | state4 << 21) ^ (state4 >>> 25 | state4 << 7)) + (state4 & state5 ^ ~state4 & state6) | 0) + (state7 + ($1c8c5.KEY[i] + this.temp[i] | 0) | 0) | 0;
            var t2 = ((state0 >>> 2 | state0 << 30) ^ (state0 >>> 13 | state0 << 19) ^ (state0 >>> 22 | state0 << 10)) + (state0 & state1 ^ state0 & state2 ^ state1 & state2) | 0;
            state7 = state6;
            state6 = state5;
            state5 = state4;
            state4 = state3 + t1 | 0;
            state3 = state2;
            state2 = state1;
            state1 = state0;
            state0 = t1 + t2 | 0;
        }
        state[0] += state0;
        state[1] += state1;
        state[2] += state2;
        state[3] += state3;
        state[4] += state4;
        state[5] += state5;
        state[6] += state6;
        state[7] += state7;
    };
    return RawSha256;
}();
module.exports.RawSha256 = $ee0cd14483f8bfb8$var$RawSha256;

});



parcelRegister("ev7Sh", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $kzTHY = parcelRequire("kzTHY");

(0, $kzTHY.__exportStar)((parcelRequire("kxobH")), module.exports);

});
parcelRegister("kzTHY", function(module, exports) {

$parcel$export(module.exports, "__awaiter", () => $efb24a0743932879$export$1050f835b63b671e);
$parcel$export(module.exports, "__generator", () => $efb24a0743932879$export$67ebef60e6f28a6);
$parcel$export(module.exports, "__exportStar", () => $efb24a0743932879$export$f33643c0debef087);
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $efb24a0743932879$var$extendStatics = function(d, b) {
    $efb24a0743932879$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $efb24a0743932879$var$extendStatics(d, b);
};
function $efb24a0743932879$export$a8ba968b8961cb8a(d, b) {
    $efb24a0743932879$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $efb24a0743932879$export$18ce0697a983be9b = function() {
    $efb24a0743932879$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $efb24a0743932879$export$18ce0697a983be9b.apply(this, arguments);
};
function $efb24a0743932879$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $efb24a0743932879$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $efb24a0743932879$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $efb24a0743932879$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $efb24a0743932879$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $efb24a0743932879$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function $efb24a0743932879$export$45d3717a4c69092e(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function $efb24a0743932879$export$f33643c0debef087(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function $efb24a0743932879$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $efb24a0743932879$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $efb24a0743932879$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($efb24a0743932879$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $efb24a0743932879$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $efb24a0743932879$export$10c90e4f7922046c(v) {
    return this instanceof $efb24a0743932879$export$10c90e4f7922046c ? (this.v = v, this) : new $efb24a0743932879$export$10c90e4f7922046c(v);
}
function $efb24a0743932879$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $efb24a0743932879$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $efb24a0743932879$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $efb24a0743932879$export$10c90e4f7922046c(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function $efb24a0743932879$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $efb24a0743932879$export$19a8beecd37a4c45 === "function" ? $efb24a0743932879$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $efb24a0743932879$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function $efb24a0743932879$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function $efb24a0743932879$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $efb24a0743932879$export$d5dcaf168c640c35(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function $efb24a0743932879$export$d40a35129aaff81f(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}

});

parcelRegister("kxobH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.supportsZeroByteGCM = module.exports.supportsSubtleCrypto = module.exports.supportsSecureRandom = module.exports.supportsWebCrypto = void 0;

var $kzTHY = parcelRequire("kzTHY");
var $ef39a6e4a29d7d1f$var$subtleCryptoMethods = [
    "decrypt",
    "digest",
    "encrypt",
    "exportKey",
    "generateKey",
    "importKey",
    "sign",
    "verify"
];
function $ef39a6e4a29d7d1f$var$supportsWebCrypto(window) {
    if ($ef39a6e4a29d7d1f$var$supportsSecureRandom(window) && typeof window.crypto.subtle === "object") {
        var subtle = window.crypto.subtle;
        return $ef39a6e4a29d7d1f$var$supportsSubtleCrypto(subtle);
    }
    return false;
}
module.exports.supportsWebCrypto = $ef39a6e4a29d7d1f$var$supportsWebCrypto;
function $ef39a6e4a29d7d1f$var$supportsSecureRandom(window) {
    if (typeof window === "object" && typeof window.crypto === "object") {
        var getRandomValues = window.crypto.getRandomValues;
        return typeof getRandomValues === "function";
    }
    return false;
}
module.exports.supportsSecureRandom = $ef39a6e4a29d7d1f$var$supportsSecureRandom;
function $ef39a6e4a29d7d1f$var$supportsSubtleCrypto(subtle) {
    return subtle && $ef39a6e4a29d7d1f$var$subtleCryptoMethods.every(function(methodName) {
        return typeof subtle[methodName] === "function";
    });
}
module.exports.supportsSubtleCrypto = $ef39a6e4a29d7d1f$var$supportsSubtleCrypto;
function $ef39a6e4a29d7d1f$var$supportsZeroByteGCM(subtle) {
    return (0, $kzTHY.__awaiter)(this, void 0, void 0, function() {
        var key, zeroByteAuthTag, _a;
        return (0, $kzTHY.__generator)(this, function(_b) {
            switch(_b.label){
                case 0:
                    if (!$ef39a6e4a29d7d1f$var$supportsSubtleCrypto(subtle)) return [
                        2 /*return*/ ,
                        false
                    ];
                    _b.label = 1;
                case 1:
                    _b.trys.push([
                        1,
                        4,
                        ,
                        5
                    ]);
                    return [
                        4 /*yield*/ ,
                        subtle.generateKey({
                            name: "AES-GCM",
                            length: 128
                        }, false, [
                            "encrypt"
                        ])
                    ];
                case 2:
                    key = _b.sent();
                    return [
                        4 /*yield*/ ,
                        subtle.encrypt({
                            name: "AES-GCM",
                            iv: new Uint8Array(Array(12)),
                            additionalData: new Uint8Array(Array(16)),
                            tagLength: 128
                        }, key, new Uint8Array(0))
                    ];
                case 3:
                    zeroByteAuthTag = _b.sent();
                    return [
                        2 /*return*/ ,
                        zeroByteAuthTag.byteLength === 16
                    ];
                case 4:
                    _a = _b.sent();
                    return [
                        2 /*return*/ ,
                        false
                    ];
                case 5:
                    return [
                        2 /*return*/ 
                    ];
            }
        });
    });
}
module.exports.supportsZeroByteGCM = $ef39a6e4a29d7d1f$var$supportsZeroByteGCM;

});


parcelRegister("5J2Ch", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $eQfwo = parcelRequire("eQfwo");

(0, $eQfwo.__exportStar)((parcelRequire("eMy2l")), module.exports);

(0, $eQfwo.__exportStar)((parcelRequire("inKXX")), module.exports);

(0, $eQfwo.__exportStar)((parcelRequire("cNnlx")), module.exports);

(0, $eQfwo.__exportStar)((parcelRequire("8ShfB")), module.exports);

(0, $eQfwo.__exportStar)((parcelRequire("5zgQn")), module.exports);

});
parcelRegister("eQfwo", function(module, exports) {

$parcel$export(module.exports, "__exportStar", () => $ace1f64193e2e0e6$export$f33643c0debef087);
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $ace1f64193e2e0e6$var$extendStatics = function(d, b) {
    $ace1f64193e2e0e6$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $ace1f64193e2e0e6$var$extendStatics(d, b);
};
function $ace1f64193e2e0e6$export$a8ba968b8961cb8a(d, b) {
    $ace1f64193e2e0e6$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $ace1f64193e2e0e6$export$18ce0697a983be9b = function() {
    $ace1f64193e2e0e6$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $ace1f64193e2e0e6$export$18ce0697a983be9b.apply(this, arguments);
};
function $ace1f64193e2e0e6$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $ace1f64193e2e0e6$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $ace1f64193e2e0e6$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $ace1f64193e2e0e6$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $ace1f64193e2e0e6$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $ace1f64193e2e0e6$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function $ace1f64193e2e0e6$export$45d3717a4c69092e(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function $ace1f64193e2e0e6$export$f33643c0debef087(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function $ace1f64193e2e0e6$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $ace1f64193e2e0e6$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $ace1f64193e2e0e6$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($ace1f64193e2e0e6$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $ace1f64193e2e0e6$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $ace1f64193e2e0e6$export$10c90e4f7922046c(v) {
    return this instanceof $ace1f64193e2e0e6$export$10c90e4f7922046c ? (this.v = v, this) : new $ace1f64193e2e0e6$export$10c90e4f7922046c(v);
}
function $ace1f64193e2e0e6$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $ace1f64193e2e0e6$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $ace1f64193e2e0e6$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $ace1f64193e2e0e6$export$10c90e4f7922046c(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function $ace1f64193e2e0e6$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $ace1f64193e2e0e6$export$19a8beecd37a4c45 === "function" ? $ace1f64193e2e0e6$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $ace1f64193e2e0e6$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function $ace1f64193e2e0e6$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function $ace1f64193e2e0e6$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $ace1f64193e2e0e6$export$d5dcaf168c640c35(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function $ace1f64193e2e0e6$export$d40a35129aaff81f(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}

});

parcelRegister("eMy2l", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("inKXX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("cNnlx", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("8ShfB", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("5zgQn", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isMsWindow = void 0;
var $40dd49703035fb84$var$msSubtleCryptoMethods = [
    "decrypt",
    "digest",
    "encrypt",
    "exportKey",
    "generateKey",
    "importKey",
    "sign",
    "verify"
];
function $40dd49703035fb84$var$quacksLikeAnMsWindow(window) {
    return "MSInputMethodContext" in window && "msCrypto" in window;
}
/**
 * Determines if the provided window is (or is like) the window object one would
 * expect to encounter in Internet Explorer 11.
 */ function $40dd49703035fb84$var$isMsWindow(window) {
    if ($40dd49703035fb84$var$quacksLikeAnMsWindow(window) && window.msCrypto.subtle !== undefined) {
        var _a = window.msCrypto, getRandomValues = _a.getRandomValues, subtle_1 = _a.subtle;
        return $40dd49703035fb84$var$msSubtleCryptoMethods.map(function(methodName) {
            return subtle_1[methodName];
        }).concat(getRandomValues).every(function(method) {
            return typeof method === "function";
        });
    }
    return false;
}
module.exports.isMsWindow = $40dd49703035fb84$var$isMsWindow;

});



/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol */ var $5c96a02c592fcff1$var$extendStatics = function(d, b) {
    $5c96a02c592fcff1$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $5c96a02c592fcff1$var$extendStatics(d, b);
};
function $5c96a02c592fcff1$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $5c96a02c592fcff1$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $5c96a02c592fcff1$export$18ce0697a983be9b = function() {
    $5c96a02c592fcff1$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $5c96a02c592fcff1$export$18ce0697a983be9b.apply(this, arguments);
};
function $5c96a02c592fcff1$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $5c96a02c592fcff1$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $5c96a02c592fcff1$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $5c96a02c592fcff1$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $5c96a02c592fcff1$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $5c96a02c592fcff1$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $5c96a02c592fcff1$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $5c96a02c592fcff1$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $5c96a02c592fcff1$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $5c96a02c592fcff1$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $5c96a02c592fcff1$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $5c96a02c592fcff1$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $5c96a02c592fcff1$export$45d3717a4c69092e(o, m, p);
}
function $5c96a02c592fcff1$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $5c96a02c592fcff1$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $5c96a02c592fcff1$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($5c96a02c592fcff1$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $5c96a02c592fcff1$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $5c96a02c592fcff1$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $5c96a02c592fcff1$export$10c90e4f7922046c(v) {
    return this instanceof $5c96a02c592fcff1$export$10c90e4f7922046c ? (this.v = v, this) : new $5c96a02c592fcff1$export$10c90e4f7922046c(v);
}
function $5c96a02c592fcff1$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $5c96a02c592fcff1$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $5c96a02c592fcff1$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $5c96a02c592fcff1$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $5c96a02c592fcff1$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $5c96a02c592fcff1$export$19a8beecd37a4c45 === "function" ? $5c96a02c592fcff1$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $5c96a02c592fcff1$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $5c96a02c592fcff1$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function $5c96a02c592fcff1$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $5c96a02c592fcff1$export$45d3717a4c69092e(result, mod, k);
    }
    $5c96a02c592fcff1$var$__setModuleDefault(result, mod);
    return result;
}
function $5c96a02c592fcff1$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $5c96a02c592fcff1$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $5c96a02c592fcff1$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $5c96a02c592fcff1$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $5c96a02c592fcff1$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $5c96a02c592fcff1$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $5c96a02c592fcff1$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $5c96a02c592fcff1$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    function next() {
        while(env.stack.length){
            var rec = env.stack.pop();
            try {
                var result = rec.dispose && rec.dispose.call(rec.value);
                if (rec.async) return Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } catch (e) {
                fail(e);
            }
        }
        if (env.hasError) throw env.error;
    }
    return next();
}
var $5c96a02c592fcff1$export$2e2bcd8739ae039 = {
    __extends: $5c96a02c592fcff1$export$a8ba968b8961cb8a,
    __assign: $5c96a02c592fcff1$export$18ce0697a983be9b,
    __rest: $5c96a02c592fcff1$export$3c9a16f847548506,
    __decorate: $5c96a02c592fcff1$export$29e00dfd3077644b,
    __param: $5c96a02c592fcff1$export$d5ad3fd78186038f,
    __metadata: $5c96a02c592fcff1$export$f1db080c865becb9,
    __awaiter: $5c96a02c592fcff1$export$1050f835b63b671e,
    __generator: $5c96a02c592fcff1$export$67ebef60e6f28a6,
    __createBinding: $5c96a02c592fcff1$export$45d3717a4c69092e,
    __exportStar: $5c96a02c592fcff1$export$f33643c0debef087,
    __values: $5c96a02c592fcff1$export$19a8beecd37a4c45,
    __read: $5c96a02c592fcff1$export$8d051b38c9118094,
    __spread: $5c96a02c592fcff1$export$afc72e2116322959,
    __spreadArrays: $5c96a02c592fcff1$export$6388937ca91ccae8,
    __spreadArray: $5c96a02c592fcff1$export$1216008129fb82ed,
    __await: $5c96a02c592fcff1$export$10c90e4f7922046c,
    __asyncGenerator: $5c96a02c592fcff1$export$e427f37a30a4de9b,
    __asyncDelegator: $5c96a02c592fcff1$export$bbd80228419bb833,
    __asyncValues: $5c96a02c592fcff1$export$e3b29a3d6162315f,
    __makeTemplateObject: $5c96a02c592fcff1$export$4fb47efe1390b86f,
    __importStar: $5c96a02c592fcff1$export$c21735bcef00d192,
    __importDefault: $5c96a02c592fcff1$export$da59b14a69baef04,
    __classPrivateFieldGet: $5c96a02c592fcff1$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $5c96a02c592fcff1$export$d40a35129aaff81f,
    __classPrivateFieldIn: $5c96a02c592fcff1$export$81fdc39f203e4e04,
    __addDisposableResource: $5c96a02c592fcff1$export$88ac25d8e944e405,
    __disposeResources: $5c96a02c592fcff1$export$8f076105dc360e92
};



var $19e84af27fc3f63f$export$d10196e291075f95 = function(options, deserializer) {
    return function(next, context) {
        return function(args) {
            return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
                var response, parsed, error_1;
                return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            return [
                                4,
                                next(args)
                            ];
                        case 1:
                            response = _a.sent().response;
                            _a.label = 2;
                        case 2:
                            _a.trys.push([
                                2,
                                4,
                                ,
                                5
                            ]);
                            return [
                                4,
                                deserializer(response, options)
                            ];
                        case 3:
                            parsed = _a.sent();
                            return [
                                2,
                                {
                                    response: response,
                                    output: parsed
                                }
                            ];
                        case 4:
                            error_1 = _a.sent();
                            throw Object.assign(error_1, {
                                $response: response
                            });
                        case 5:
                            return [
                                2
                            ];
                    }
                });
            });
        };
    };
};




var $6b220809dcba5b5c$export$125a23d36094c5de = function(options, serializer) {
    return function(next, context) {
        return function(args) {
            return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
                var request;
                return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            return [
                                4,
                                serializer(args.input, options)
                            ];
                        case 1:
                            request = _a.sent();
                            return [
                                2,
                                next((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, args), {
                                    request: request
                                }))
                            ];
                    }
                });
            });
        };
    };
};


var $eefacaa18209bd27$export$f5d82b333b4f39c9 = {
    name: "deserializerMiddleware",
    step: "deserialize",
    tags: [
        "DESERIALIZER"
    ],
    override: true
};
var $eefacaa18209bd27$export$1bd449976e9c484d = {
    name: "serializerMiddleware",
    step: "serialize",
    tags: [
        "SERIALIZER"
    ],
    override: true
};
function $eefacaa18209bd27$export$53fdc69654553fd4(config, serializer, deserializer) {
    return {
        applyToStack: function(commandStack) {
            commandStack.add((0, $19e84af27fc3f63f$export$d10196e291075f95)(config, deserializer), $eefacaa18209bd27$export$f5d82b333b4f39c9);
            commandStack.add((0, $6b220809dcba5b5c$export$125a23d36094c5de)(config, serializer), $eefacaa18209bd27$export$1bd449976e9c484d);
        }
    };
}






var $7aaf9f56bf651a48$export$73604a93307363d8 = function() {
    var absoluteEntries = [];
    var relativeEntries = [];
    var entriesNameSet = new Set();
    var sort = function(entries) {
        return entries.sort(function(a, b) {
            return $7aaf9f56bf651a48$var$stepWeights[b.step] - $7aaf9f56bf651a48$var$stepWeights[a.step] || $7aaf9f56bf651a48$var$priorityWeights[b.priority || "normal"] - $7aaf9f56bf651a48$var$priorityWeights[a.priority || "normal"];
        });
    };
    var removeByName = function(toRemove) {
        var isRemoved = false;
        var filterCb = function(entry) {
            if (entry.name && entry.name === toRemove) {
                isRemoved = true;
                entriesNameSet.delete(toRemove);
                return false;
            }
            return true;
        };
        absoluteEntries = absoluteEntries.filter(filterCb);
        relativeEntries = relativeEntries.filter(filterCb);
        return isRemoved;
    };
    var removeByReference = function(toRemove) {
        var isRemoved = false;
        var filterCb = function(entry) {
            if (entry.middleware === toRemove) {
                isRemoved = true;
                if (entry.name) entriesNameSet.delete(entry.name);
                return false;
            }
            return true;
        };
        absoluteEntries = absoluteEntries.filter(filterCb);
        relativeEntries = relativeEntries.filter(filterCb);
        return isRemoved;
    };
    var cloneTo = function(toStack) {
        absoluteEntries.forEach(function(entry) {
            toStack.add(entry.middleware, (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, entry));
        });
        relativeEntries.forEach(function(entry) {
            toStack.addRelativeTo(entry.middleware, (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, entry));
        });
        return toStack;
    };
    var expandRelativeMiddlewareList = function(from) {
        var expandedMiddlewareList = [];
        from.before.forEach(function(entry) {
            if (entry.before.length === 0 && entry.after.length === 0) expandedMiddlewareList.push(entry);
            else expandedMiddlewareList.push.apply(expandedMiddlewareList, (0, $5c96a02c592fcff1$export$1216008129fb82ed)([], (0, $5c96a02c592fcff1$export$8d051b38c9118094)(expandRelativeMiddlewareList(entry))));
        });
        expandedMiddlewareList.push(from);
        from.after.reverse().forEach(function(entry) {
            if (entry.before.length === 0 && entry.after.length === 0) expandedMiddlewareList.push(entry);
            else expandedMiddlewareList.push.apply(expandedMiddlewareList, (0, $5c96a02c592fcff1$export$1216008129fb82ed)([], (0, $5c96a02c592fcff1$export$8d051b38c9118094)(expandRelativeMiddlewareList(entry))));
        });
        return expandedMiddlewareList;
    };
    var getMiddlewareList = function() {
        var normalizedAbsoluteEntries = [];
        var normalizedRelativeEntries = [];
        var normalizedEntriesNameMap = {};
        absoluteEntries.forEach(function(entry) {
            var normalizedEntry = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, entry), {
                before: [],
                after: []
            });
            if (normalizedEntry.name) normalizedEntriesNameMap[normalizedEntry.name] = normalizedEntry;
            normalizedAbsoluteEntries.push(normalizedEntry);
        });
        relativeEntries.forEach(function(entry) {
            var normalizedEntry = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, entry), {
                before: [],
                after: []
            });
            if (normalizedEntry.name) normalizedEntriesNameMap[normalizedEntry.name] = normalizedEntry;
            normalizedRelativeEntries.push(normalizedEntry);
        });
        normalizedRelativeEntries.forEach(function(entry) {
            if (entry.toMiddleware) {
                var toMiddleware = normalizedEntriesNameMap[entry.toMiddleware];
                if (toMiddleware === undefined) throw new Error(entry.toMiddleware + " is not found when adding " + (entry.name || "anonymous") + " middleware " + entry.relation + " " + entry.toMiddleware);
                if (entry.relation === "after") toMiddleware.after.push(entry);
                if (entry.relation === "before") toMiddleware.before.push(entry);
            }
        });
        var mainChain = sort(normalizedAbsoluteEntries).map(expandRelativeMiddlewareList).reduce(function(wholeList, expendedMiddlewareList) {
            wholeList.push.apply(wholeList, (0, $5c96a02c592fcff1$export$1216008129fb82ed)([], (0, $5c96a02c592fcff1$export$8d051b38c9118094)(expendedMiddlewareList)));
            return wholeList;
        }, []);
        return mainChain.map(function(entry) {
            return entry.middleware;
        });
    };
    var stack = {
        add: function(middleware, options) {
            if (options === void 0) options = {};
            var name = options.name, override = options.override;
            var entry = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
                step: "initialize",
                priority: "normal",
                middleware: middleware
            }, options);
            if (name) {
                if (entriesNameSet.has(name)) {
                    if (!override) throw new Error("Duplicate middleware name '" + name + "'");
                    var toOverrideIndex = absoluteEntries.findIndex(function(entry) {
                        return entry.name === name;
                    });
                    var toOverride = absoluteEntries[toOverrideIndex];
                    if (toOverride.step !== entry.step || toOverride.priority !== entry.priority) throw new Error('"' + name + '" middleware with ' + toOverride.priority + " priority in " + toOverride.step + " step cannot be " + ("overridden by same-name middleware with " + entry.priority + " priority in " + entry.step + " step."));
                    absoluteEntries.splice(toOverrideIndex, 1);
                }
                entriesNameSet.add(name);
            }
            absoluteEntries.push(entry);
        },
        addRelativeTo: function(middleware, options) {
            var name = options.name, override = options.override;
            var entry = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
                middleware: middleware
            }, options);
            if (name) {
                if (entriesNameSet.has(name)) {
                    if (!override) throw new Error("Duplicate middleware name '" + name + "'");
                    var toOverrideIndex = relativeEntries.findIndex(function(entry) {
                        return entry.name === name;
                    });
                    var toOverride = relativeEntries[toOverrideIndex];
                    if (toOverride.toMiddleware !== entry.toMiddleware || toOverride.relation !== entry.relation) throw new Error('"' + name + '" middleware ' + toOverride.relation + ' "' + toOverride.toMiddleware + '" middleware cannot be overridden ' + ("by same-name middleware " + entry.relation + ' "' + entry.toMiddleware + '" middleware.'));
                    relativeEntries.splice(toOverrideIndex, 1);
                }
                entriesNameSet.add(name);
            }
            relativeEntries.push(entry);
        },
        clone: function() {
            return cloneTo($7aaf9f56bf651a48$export$73604a93307363d8());
        },
        use: function(plugin) {
            plugin.applyToStack(stack);
        },
        remove: function(toRemove) {
            if (typeof toRemove === "string") return removeByName(toRemove);
            else return removeByReference(toRemove);
        },
        removeByTag: function(toRemove) {
            var isRemoved = false;
            var filterCb = function(entry) {
                var tags = entry.tags, name = entry.name;
                if (tags && tags.includes(toRemove)) {
                    if (name) entriesNameSet.delete(name);
                    isRemoved = true;
                    return false;
                }
                return true;
            };
            absoluteEntries = absoluteEntries.filter(filterCb);
            relativeEntries = relativeEntries.filter(filterCb);
            return isRemoved;
        },
        concat: function(from) {
            var cloned = cloneTo($7aaf9f56bf651a48$export$73604a93307363d8());
            cloned.use(from);
            return cloned;
        },
        applyToStack: cloneTo,
        resolve: function(handler, context) {
            var e_1, _a;
            try {
                for(var _b = (0, $5c96a02c592fcff1$export$19a8beecd37a4c45)(getMiddlewareList().reverse()), _c = _b.next(); !_c.done; _c = _b.next()){
                    var middleware = _c.value;
                    handler = middleware(handler, context);
                }
            } catch (e_1_1) {
                e_1 = {
                    error: e_1_1
                };
            } finally{
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                } finally{
                    if (e_1) throw e_1.error;
                }
            }
            return handler;
        }
    };
    return stack;
};
var $7aaf9f56bf651a48$var$stepWeights = {
    initialize: 5,
    serialize: 4,
    build: 3,
    finalizeRequest: 2,
    deserialize: 1
};
var $7aaf9f56bf651a48$var$priorityWeights = {
    high: 3,
    normal: 2,
    low: 1
};




var $2afbf12425e4ac78$export$1f2bb630327ac4b6 = function() {
    function Client(config) {
        this.middlewareStack = (0, $7aaf9f56bf651a48$export$73604a93307363d8)();
        this.config = config;
    }
    Client.prototype.send = function(command, optionsOrCb, cb) {
        var options = typeof optionsOrCb !== "function" ? optionsOrCb : undefined;
        var callback = typeof optionsOrCb === "function" ? optionsOrCb : cb;
        var handler = command.resolveMiddleware(this.middlewareStack, this.config, options);
        if (callback) handler(command).then(function(result) {
            return callback(null, result.output);
        }, function(err) {
            return callback(err);
        }).catch(function() {});
        else return handler(command).then(function(result) {
            return result.output;
        });
    };
    Client.prototype.destroy = function() {
        if (this.config.requestHandler.destroy) this.config.requestHandler.destroy();
    };
    return Client;
}();



var $16f81f795382045c$export$cc7e12c76513e857 = function() {
    function Command() {
        this.middlewareStack = (0, $7aaf9f56bf651a48$export$73604a93307363d8)();
    }
    return Command;
}();


var $97fe842c45c6f001$export$17127055dc9ac067 = "***SensitiveInformation***";




var $326143e959bb2a25$export$3fb54149990fb5b5 = function(value) {
    switch(value){
        case "true":
            return true;
        case "false":
            return false;
        default:
            throw new Error('Unable to parse boolean value "' + value + '"');
    }
};
var $326143e959bb2a25$export$259b2ebfc29bf466 = function(value) {
    if (value === null || value === undefined) return undefined;
    if (typeof value === "boolean") return value;
    throw new TypeError("Expected boolean, got " + typeof value);
};
var $326143e959bb2a25$export$f3945e48fdb5f9a = function(value) {
    if (value === null || value === undefined) return undefined;
    if (typeof value === "number") return value;
    throw new TypeError("Expected number, got " + typeof value);
};
var $326143e959bb2a25$var$MAX_FLOAT = Math.ceil(Math.pow(2, 127) * (2 - Math.pow(2, -23)));
var $326143e959bb2a25$export$44880ec4d8d4909d = function(value) {
    var expected = $326143e959bb2a25$export$f3945e48fdb5f9a(value);
    if (expected !== undefined && !Number.isNaN(expected) && expected !== Infinity && expected !== -Infinity) {
        if (Math.abs(expected) > $326143e959bb2a25$var$MAX_FLOAT) throw new TypeError("Expected 32-bit float, got " + value);
    }
    return expected;
};
var $326143e959bb2a25$export$a883517a83c9c18 = function(value) {
    if (value === null || value === undefined) return undefined;
    if (Number.isInteger(value) && !Number.isNaN(value)) return value;
    throw new TypeError("Expected integer, got " + typeof value);
};
var $326143e959bb2a25$export$dbec7593c34ded08 = $326143e959bb2a25$export$a883517a83c9c18;
var $326143e959bb2a25$export$99c64e845cdac9c1 = function(value) {
    return $326143e959bb2a25$var$expectSizedInt(value, 32);
};
var $326143e959bb2a25$export$d4f903340b146129 = function(value) {
    return $326143e959bb2a25$var$expectSizedInt(value, 16);
};
var $326143e959bb2a25$export$3e4c4435b3b19562 = function(value) {
    return $326143e959bb2a25$var$expectSizedInt(value, 8);
};
var $326143e959bb2a25$var$expectSizedInt = function(value, size) {
    var expected = $326143e959bb2a25$export$a883517a83c9c18(value);
    if (expected !== undefined && $326143e959bb2a25$var$castInt(expected, size) !== expected) throw new TypeError("Expected " + size + "-bit integer, got " + value);
    return expected;
};
var $326143e959bb2a25$var$castInt = function(value, size) {
    switch(size){
        case 32:
            return Int32Array.of(value)[0];
        case 16:
            return Int16Array.of(value)[0];
        case 8:
            return Int8Array.of(value)[0];
    }
};
var $326143e959bb2a25$export$8413a63dbe548a49 = function(value, location) {
    if (value === null || value === undefined) {
        if (location) throw new TypeError("Expected a non-null value for " + location);
        throw new TypeError("Expected a non-null value");
    }
    return value;
};
var $326143e959bb2a25$export$cf825aadce530e7e = function(value) {
    if (value === null || value === undefined) return undefined;
    if (typeof value === "object" && !Array.isArray(value)) return value;
    throw new TypeError("Expected object, got " + typeof value);
};
var $326143e959bb2a25$export$7ed80f53fe336639 = function(value) {
    if (value === null || value === undefined) return undefined;
    if (typeof value === "string") return value;
    throw new TypeError("Expected string, got " + typeof value);
};
var $326143e959bb2a25$export$9ef77073e45b6301 = function(value) {
    if (value === null || value === undefined) return undefined;
    var asObject = $326143e959bb2a25$export$cf825aadce530e7e(value);
    var setKeys = Object.entries(asObject).filter(function(_a) {
        var _b = (0, $5c96a02c592fcff1$export$8d051b38c9118094)(_a, 2), _ = _b[0], v = _b[1];
        return v !== null && v !== undefined;
    }).map(function(_a) {
        var _b = (0, $5c96a02c592fcff1$export$8d051b38c9118094)(_a, 2), k = _b[0], _ = _b[1];
        return k;
    });
    if (setKeys.length === 0) throw new TypeError("Unions must have exactly one non-null member");
    if (setKeys.length > 1) throw new TypeError("Unions must have exactly one non-null member. Keys " + setKeys + " were not null.");
    return asObject;
};
var $326143e959bb2a25$export$89e17ed633a86621 = function(value) {
    if (typeof value == "string") return $326143e959bb2a25$export$f3945e48fdb5f9a($326143e959bb2a25$var$parseNumber(value));
    return $326143e959bb2a25$export$f3945e48fdb5f9a(value);
};
var $326143e959bb2a25$export$884f8e3b42a6cfbf = $326143e959bb2a25$export$89e17ed633a86621;
var $326143e959bb2a25$export$b15cbcea8b4c492f = function(value) {
    if (typeof value == "string") return $326143e959bb2a25$export$44880ec4d8d4909d($326143e959bb2a25$var$parseNumber(value));
    return $326143e959bb2a25$export$44880ec4d8d4909d(value);
};
var $326143e959bb2a25$var$NUMBER_REGEX = /(-?(?:0|[1-9]\d*)(?:\.\d+)?(?:[eE][+-]?\d+)?)|(-?Infinity)|(NaN)/g;
var $326143e959bb2a25$var$parseNumber = function(value) {
    var matches = value.match($326143e959bb2a25$var$NUMBER_REGEX);
    if (matches === null || matches[0].length !== value.length) throw new TypeError("Expected real number, got implicit NaN");
    return parseFloat(value);
};
var $326143e959bb2a25$export$11335e83c8af2784 = function(value) {
    if (typeof value == "string") return $326143e959bb2a25$var$parseFloatString(value);
    return $326143e959bb2a25$export$f3945e48fdb5f9a(value);
};
var $326143e959bb2a25$export$b6a7906d2e4b31df = $326143e959bb2a25$export$11335e83c8af2784;
var $326143e959bb2a25$export$50b04c19f942a079 = $326143e959bb2a25$export$11335e83c8af2784;
var $326143e959bb2a25$export$f14938f3036dd492 = function(value) {
    if (typeof value == "string") return $326143e959bb2a25$var$parseFloatString(value);
    return $326143e959bb2a25$export$44880ec4d8d4909d(value);
};
var $326143e959bb2a25$var$parseFloatString = function(value) {
    switch(value){
        case "NaN":
            return NaN;
        case "Infinity":
            return Infinity;
        case "-Infinity":
            return -Infinity;
        default:
            throw new Error("Unable to parse float value: " + value);
    }
};
var $326143e959bb2a25$export$f90617f39a736d36 = function(value) {
    if (typeof value === "string") return $326143e959bb2a25$export$a883517a83c9c18($326143e959bb2a25$var$parseNumber(value));
    return $326143e959bb2a25$export$a883517a83c9c18(value);
};
var $326143e959bb2a25$export$39b7be5d28a09fe1 = $326143e959bb2a25$export$f90617f39a736d36;
var $326143e959bb2a25$export$c3c2f00b115709e6 = function(value) {
    if (typeof value === "string") return $326143e959bb2a25$export$99c64e845cdac9c1($326143e959bb2a25$var$parseNumber(value));
    return $326143e959bb2a25$export$99c64e845cdac9c1(value);
};
var $326143e959bb2a25$export$813d4a13f25c6b38 = function(value) {
    if (typeof value === "string") return $326143e959bb2a25$export$d4f903340b146129($326143e959bb2a25$var$parseNumber(value));
    return $326143e959bb2a25$export$d4f903340b146129(value);
};
var $326143e959bb2a25$export$f18d20ea3b6b353 = function(value) {
    if (typeof value === "string") return $326143e959bb2a25$export$3e4c4435b3b19562($326143e959bb2a25$var$parseNumber(value));
    return $326143e959bb2a25$export$3e4c4435b3b19562(value);
};


var $e742001d39531b4d$var$DAYS = [
    "Sun",
    "Mon",
    "Tue",
    "Wed",
    "Thu",
    "Fri",
    "Sat"
];
var $e742001d39531b4d$var$MONTHS = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
];
function $e742001d39531b4d$export$5b50865171ed23a9(date) {
    var year = date.getUTCFullYear();
    var month = date.getUTCMonth();
    var dayOfWeek = date.getUTCDay();
    var dayOfMonthInt = date.getUTCDate();
    var hoursInt = date.getUTCHours();
    var minutesInt = date.getUTCMinutes();
    var secondsInt = date.getUTCSeconds();
    var dayOfMonthString = dayOfMonthInt < 10 ? "0" + dayOfMonthInt : "" + dayOfMonthInt;
    var hoursString = hoursInt < 10 ? "0" + hoursInt : "" + hoursInt;
    var minutesString = minutesInt < 10 ? "0" + minutesInt : "" + minutesInt;
    var secondsString = secondsInt < 10 ? "0" + secondsInt : "" + secondsInt;
    return $e742001d39531b4d$var$DAYS[dayOfWeek] + ", " + dayOfMonthString + " " + $e742001d39531b4d$var$MONTHS[month] + " " + year + " " + hoursString + ":" + minutesString + ":" + secondsString + " GMT";
}
var $e742001d39531b4d$var$RFC3339 = new RegExp(/^(\d{4})-(\d{2})-(\d{2})[tT](\d{2}):(\d{2}):(\d{2})(?:\.(\d+))?[zZ]$/);
var $e742001d39531b4d$export$202e14f4d6038b6c = function(value) {
    if (value === null || value === undefined) return undefined;
    if (typeof value !== "string") throw new TypeError("RFC-3339 date-times must be expressed as strings");
    var match = $e742001d39531b4d$var$RFC3339.exec(value);
    if (!match) throw new TypeError("Invalid RFC-3339 date-time value");
    var _a = (0, $5c96a02c592fcff1$export$8d051b38c9118094)(match, 8), _ = _a[0], yearStr = _a[1], monthStr = _a[2], dayStr = _a[3], hours = _a[4], minutes = _a[5], seconds = _a[6], fractionalMilliseconds = _a[7];
    var year = (0, $326143e959bb2a25$export$813d4a13f25c6b38)($e742001d39531b4d$var$stripLeadingZeroes(yearStr));
    var month = $e742001d39531b4d$var$parseDateValue(monthStr, "month", 1, 12);
    var day = $e742001d39531b4d$var$parseDateValue(dayStr, "day", 1, 31);
    return $e742001d39531b4d$var$buildDate(year, month, day, {
        hours: hours,
        minutes: minutes,
        seconds: seconds,
        fractionalMilliseconds: fractionalMilliseconds
    });
};
var $e742001d39531b4d$var$IMF_FIXDATE = new RegExp(/^(?:Mon|Tue|Wed|Thu|Fri|Sat|Sun), (\d{2}) (Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec) (\d{4}) (\d{2}):(\d{2}):(\d{2})(?:\.(\d+))? GMT$/);
var $e742001d39531b4d$var$RFC_850_DATE = new RegExp(/^(?:Monday|Tuesday|Wednesday|Thursday|Friday|Saturday|Sunday), (\d{2})-(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)-(\d{2}) (\d{2}):(\d{2}):(\d{2})(?:\.(\d+))? GMT$/);
var $e742001d39531b4d$var$ASC_TIME = new RegExp(/^(?:Mon|Tue|Wed|Thu|Fri|Sat|Sun) (Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec) ( [1-9]|\d{2}) (\d{2}):(\d{2}):(\d{2})(?:\.(\d+))? (\d{4})$/);
var $e742001d39531b4d$export$cf3a566289648a1e = function(value) {
    if (value === null || value === undefined) return undefined;
    if (typeof value !== "string") throw new TypeError("RFC-7231 date-times must be expressed as strings");
    var match = $e742001d39531b4d$var$IMF_FIXDATE.exec(value);
    if (match) {
        var _a = (0, $5c96a02c592fcff1$export$8d051b38c9118094)(match, 8), _1 = _a[0], dayStr = _a[1], monthStr = _a[2], yearStr = _a[3], hours = _a[4], minutes = _a[5], seconds = _a[6], fractionalMilliseconds = _a[7];
        return $e742001d39531b4d$var$buildDate((0, $326143e959bb2a25$export$813d4a13f25c6b38)($e742001d39531b4d$var$stripLeadingZeroes(yearStr)), $e742001d39531b4d$var$parseMonthByShortName(monthStr), $e742001d39531b4d$var$parseDateValue(dayStr, "day", 1, 31), {
            hours: hours,
            minutes: minutes,
            seconds: seconds,
            fractionalMilliseconds: fractionalMilliseconds
        });
    }
    match = $e742001d39531b4d$var$RFC_850_DATE.exec(value);
    if (match) {
        var _b = (0, $5c96a02c592fcff1$export$8d051b38c9118094)(match, 8), _2 = _b[0], dayStr = _b[1], monthStr = _b[2], yearStr = _b[3], hours = _b[4], minutes = _b[5], seconds = _b[6], fractionalMilliseconds = _b[7];
        return $e742001d39531b4d$var$adjustRfc850Year($e742001d39531b4d$var$buildDate($e742001d39531b4d$var$parseTwoDigitYear(yearStr), $e742001d39531b4d$var$parseMonthByShortName(monthStr), $e742001d39531b4d$var$parseDateValue(dayStr, "day", 1, 31), {
            hours: hours,
            minutes: minutes,
            seconds: seconds,
            fractionalMilliseconds: fractionalMilliseconds
        }));
    }
    match = $e742001d39531b4d$var$ASC_TIME.exec(value);
    if (match) {
        var _c = (0, $5c96a02c592fcff1$export$8d051b38c9118094)(match, 8), _3 = _c[0], monthStr = _c[1], dayStr = _c[2], hours = _c[3], minutes = _c[4], seconds = _c[5], fractionalMilliseconds = _c[6], yearStr = _c[7];
        return $e742001d39531b4d$var$buildDate((0, $326143e959bb2a25$export$813d4a13f25c6b38)($e742001d39531b4d$var$stripLeadingZeroes(yearStr)), $e742001d39531b4d$var$parseMonthByShortName(monthStr), $e742001d39531b4d$var$parseDateValue(dayStr.trimLeft(), "day", 1, 31), {
            hours: hours,
            minutes: minutes,
            seconds: seconds,
            fractionalMilliseconds: fractionalMilliseconds
        });
    }
    throw new TypeError("Invalid RFC-7231 date-time value");
};
var $e742001d39531b4d$export$685da212e4e79e10 = function(value) {
    if (value === null || value === undefined) return undefined;
    var valueAsDouble;
    if (typeof value === "number") valueAsDouble = value;
    else if (typeof value === "string") valueAsDouble = (0, $326143e959bb2a25$export$89e17ed633a86621)(value);
    else throw new TypeError("Epoch timestamps must be expressed as floating point numbers or their string representation");
    if (Number.isNaN(valueAsDouble) || valueAsDouble === Infinity || valueAsDouble === -Infinity) throw new TypeError("Epoch timestamps must be valid, non-Infinite, non-NaN numerics");
    return new Date(Math.round(valueAsDouble * 1000));
};
var $e742001d39531b4d$var$buildDate = function(year, month, day, time) {
    var adjustedMonth = month - 1;
    $e742001d39531b4d$var$validateDayOfMonth(year, adjustedMonth, day);
    return new Date(Date.UTC(year, adjustedMonth, day, $e742001d39531b4d$var$parseDateValue(time.hours, "hour", 0, 23), $e742001d39531b4d$var$parseDateValue(time.minutes, "minute", 0, 59), $e742001d39531b4d$var$parseDateValue(time.seconds, "seconds", 0, 60), $e742001d39531b4d$var$parseMilliseconds(time.fractionalMilliseconds)));
};
var $e742001d39531b4d$var$parseTwoDigitYear = function(value) {
    var thisYear = new Date().getUTCFullYear();
    var valueInThisCentury = Math.floor(thisYear / 100) * 100 + (0, $326143e959bb2a25$export$813d4a13f25c6b38)($e742001d39531b4d$var$stripLeadingZeroes(value));
    if (valueInThisCentury < thisYear) return valueInThisCentury + 100;
    return valueInThisCentury;
};
var $e742001d39531b4d$var$FIFTY_YEARS_IN_MILLIS = 1576800000000;
var $e742001d39531b4d$var$adjustRfc850Year = function(input) {
    if (input.getTime() - new Date().getTime() > $e742001d39531b4d$var$FIFTY_YEARS_IN_MILLIS) return new Date(Date.UTC(input.getUTCFullYear() - 100, input.getUTCMonth(), input.getUTCDate(), input.getUTCHours(), input.getUTCMinutes(), input.getUTCSeconds(), input.getUTCMilliseconds()));
    return input;
};
var $e742001d39531b4d$var$parseMonthByShortName = function(value) {
    var monthIdx = $e742001d39531b4d$var$MONTHS.indexOf(value);
    if (monthIdx < 0) throw new TypeError("Invalid month: " + value);
    return monthIdx + 1;
};
var $e742001d39531b4d$var$DAYS_IN_MONTH = [
    31,
    28,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
var $e742001d39531b4d$var$validateDayOfMonth = function(year, month, day) {
    var maxDays = $e742001d39531b4d$var$DAYS_IN_MONTH[month];
    if (month === 1 && $e742001d39531b4d$var$isLeapYear(year)) maxDays = 29;
    if (day > maxDays) throw new TypeError("Invalid day for " + $e742001d39531b4d$var$MONTHS[month] + " in " + year + ": " + day);
};
var $e742001d39531b4d$var$isLeapYear = function(year) {
    return year % 4 === 0 && (year % 100 !== 0 || year % 400 === 0);
};
var $e742001d39531b4d$var$parseDateValue = function(value, type, lower, upper) {
    var dateVal = (0, $326143e959bb2a25$export$f18d20ea3b6b353)($e742001d39531b4d$var$stripLeadingZeroes(value));
    if (dateVal < lower || dateVal > upper) throw new TypeError(type + " must be between " + lower + " and " + upper + ", inclusive");
    return dateVal;
};
var $e742001d39531b4d$var$parseMilliseconds = function(value) {
    if (value === null || value === undefined) return 0;
    return (0, $326143e959bb2a25$export$b15cbcea8b4c492f)("0." + value) * 1000;
};
var $e742001d39531b4d$var$stripLeadingZeroes = function(value) {
    var idx = 0;
    while(idx < value.length - 1 && value.charAt(idx) === "0")idx++;
    if (idx === 0) return value;
    return value.slice(idx);
};


var $1344bf813bb1cae5$export$b6e2b46631b45a92 = function(mode) {
    switch(mode){
        case "standard":
            return {
                retryMode: "standard",
                connectionTimeout: 3100
            };
        case "in-region":
            return {
                retryMode: "standard",
                connectionTimeout: 1100
            };
        case "cross-region":
            return {
                retryMode: "standard",
                connectionTimeout: 3100
            };
        case "mobile":
            return {
                retryMode: "standard",
                connectionTimeout: 30000
            };
        default:
            return {};
    }
};


var $cfae44f0dfdf62c0$exports = {};
// shim for using process in browser
var $cfae44f0dfdf62c0$var$process = $cfae44f0dfdf62c0$exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $cfae44f0dfdf62c0$var$cachedSetTimeout;
var $cfae44f0dfdf62c0$var$cachedClearTimeout;
function $cfae44f0dfdf62c0$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $cfae44f0dfdf62c0$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $cfae44f0dfdf62c0$var$cachedSetTimeout = setTimeout;
        else $cfae44f0dfdf62c0$var$cachedSetTimeout = $cfae44f0dfdf62c0$var$defaultSetTimout;
    } catch (e) {
        $cfae44f0dfdf62c0$var$cachedSetTimeout = $cfae44f0dfdf62c0$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $cfae44f0dfdf62c0$var$cachedClearTimeout = clearTimeout;
        else $cfae44f0dfdf62c0$var$cachedClearTimeout = $cfae44f0dfdf62c0$var$defaultClearTimeout;
    } catch (e) {
        $cfae44f0dfdf62c0$var$cachedClearTimeout = $cfae44f0dfdf62c0$var$defaultClearTimeout;
    }
})();
function $cfae44f0dfdf62c0$var$runTimeout(fun) {
    if ($cfae44f0dfdf62c0$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($cfae44f0dfdf62c0$var$cachedSetTimeout === $cfae44f0dfdf62c0$var$defaultSetTimout || !$cfae44f0dfdf62c0$var$cachedSetTimeout) && setTimeout) {
        $cfae44f0dfdf62c0$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $cfae44f0dfdf62c0$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $cfae44f0dfdf62c0$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $cfae44f0dfdf62c0$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $cfae44f0dfdf62c0$var$runClearTimeout(marker) {
    if ($cfae44f0dfdf62c0$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($cfae44f0dfdf62c0$var$cachedClearTimeout === $cfae44f0dfdf62c0$var$defaultClearTimeout || !$cfae44f0dfdf62c0$var$cachedClearTimeout) && clearTimeout) {
        $cfae44f0dfdf62c0$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $cfae44f0dfdf62c0$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $cfae44f0dfdf62c0$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $cfae44f0dfdf62c0$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $cfae44f0dfdf62c0$var$queue = [];
var $cfae44f0dfdf62c0$var$draining = false;
var $cfae44f0dfdf62c0$var$currentQueue;
var $cfae44f0dfdf62c0$var$queueIndex = -1;
function $cfae44f0dfdf62c0$var$cleanUpNextTick() {
    if (!$cfae44f0dfdf62c0$var$draining || !$cfae44f0dfdf62c0$var$currentQueue) return;
    $cfae44f0dfdf62c0$var$draining = false;
    if ($cfae44f0dfdf62c0$var$currentQueue.length) $cfae44f0dfdf62c0$var$queue = $cfae44f0dfdf62c0$var$currentQueue.concat($cfae44f0dfdf62c0$var$queue);
    else $cfae44f0dfdf62c0$var$queueIndex = -1;
    if ($cfae44f0dfdf62c0$var$queue.length) $cfae44f0dfdf62c0$var$drainQueue();
}
function $cfae44f0dfdf62c0$var$drainQueue() {
    if ($cfae44f0dfdf62c0$var$draining) return;
    var timeout = $cfae44f0dfdf62c0$var$runTimeout($cfae44f0dfdf62c0$var$cleanUpNextTick);
    $cfae44f0dfdf62c0$var$draining = true;
    var len = $cfae44f0dfdf62c0$var$queue.length;
    while(len){
        $cfae44f0dfdf62c0$var$currentQueue = $cfae44f0dfdf62c0$var$queue;
        $cfae44f0dfdf62c0$var$queue = [];
        while(++$cfae44f0dfdf62c0$var$queueIndex < len)if ($cfae44f0dfdf62c0$var$currentQueue) $cfae44f0dfdf62c0$var$currentQueue[$cfae44f0dfdf62c0$var$queueIndex].run();
        $cfae44f0dfdf62c0$var$queueIndex = -1;
        len = $cfae44f0dfdf62c0$var$queue.length;
    }
    $cfae44f0dfdf62c0$var$currentQueue = null;
    $cfae44f0dfdf62c0$var$draining = false;
    $cfae44f0dfdf62c0$var$runClearTimeout(timeout);
}
$cfae44f0dfdf62c0$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $cfae44f0dfdf62c0$var$queue.push(new $cfae44f0dfdf62c0$var$Item(fun, args));
    if ($cfae44f0dfdf62c0$var$queue.length === 1 && !$cfae44f0dfdf62c0$var$draining) $cfae44f0dfdf62c0$var$runTimeout($cfae44f0dfdf62c0$var$drainQueue);
};
// v8 likes predictible objects
function $cfae44f0dfdf62c0$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$cfae44f0dfdf62c0$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$cfae44f0dfdf62c0$var$process.title = "browser";
$cfae44f0dfdf62c0$var$process.browser = true;
$cfae44f0dfdf62c0$var$process.env = {};
$cfae44f0dfdf62c0$var$process.argv = [];
$cfae44f0dfdf62c0$var$process.version = ""; // empty string to avoid regexp issues
$cfae44f0dfdf62c0$var$process.versions = {};
function $cfae44f0dfdf62c0$var$noop() {}
$cfae44f0dfdf62c0$var$process.on = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.addListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.once = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.off = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.removeListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.removeAllListeners = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.emit = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.prependListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.prependOnceListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.listeners = function(name) {
    return [];
};
$cfae44f0dfdf62c0$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$cfae44f0dfdf62c0$var$process.cwd = function() {
    return "/";
};
$cfae44f0dfdf62c0$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$cfae44f0dfdf62c0$var$process.umask = function() {
    return 0;
};


var $578a9395a30f2e58$var$warningEmitted = false;
var $578a9395a30f2e58$export$96550b8fa3e6f65a = function(version) {
    if (version && !$578a9395a30f2e58$var$warningEmitted && parseInt(version.substring(1, version.indexOf("."))) < 12) {
        $578a9395a30f2e58$var$warningEmitted = true;
        $cfae44f0dfdf62c0$exports.emitWarning("The AWS SDK for JavaScript (v3) will\n" + ("no longer support Node.js " + version + " as of January 1, 2022.\n") + "To continue receiving updates to AWS services, bug fixes, and security\n" + "updates please upgrade to Node.js 12.x or later.\n\n" + "More information can be found at: https://a.co/1l6FLnu", "NodeDeprecationWarning");
    }
};



var $a08c2c31e27e9e11$export$29647f3b4097d3c0 = function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(ServiceException, _super);
    function ServiceException(options) {
        var _this = _super.call(this, options.message) || this;
        Object.setPrototypeOf(_this, ServiceException.prototype);
        _this.name = options.name;
        _this.$fault = options.$fault;
        _this.$metadata = options.$metadata;
        return _this;
    }
    return ServiceException;
}(Error);
var $a08c2c31e27e9e11$export$db01f0c43e877a50 = function(exception, additions) {
    if (additions === void 0) additions = {};
    Object.entries(additions).filter(function(_a) {
        var _b = (0, $5c96a02c592fcff1$export$8d051b38c9118094)(_a, 2), v = _b[1];
        return v !== undefined;
    }).forEach(function(_a) {
        var _b = (0, $5c96a02c592fcff1$export$8d051b38c9118094)(_a, 2), k = _b[0], v = _b[1];
        if (exception[k] == undefined || exception[k] === "") exception[k] = v;
    });
    var message = exception.message || exception.Message || "UnknownError";
    exception.message = message;
    delete exception.Message;
    return exception;
};


function $9a4acc0a52030ed1$export$7640f3c16fe7f54b(str) {
    return encodeURIComponent(str).replace(/[!'()*]/g, function(c) {
        return "%" + c.charCodeAt(0).toString(16).toUpperCase();
    });
}


var $69c7ed9058be69af$export$52272e038712c64e = function(mayBeArray) {
    return Array.isArray(mayBeArray) ? mayBeArray : [
        mayBeArray
    ];
};


var $75214256965cbf42$export$113d90026b452881 = function(obj) {
    var textNodeName = "#text";
    for(var key in obj){
        if (obj.hasOwnProperty(key) && obj[key][textNodeName] !== undefined) obj[key] = obj[key][textNodeName];
        else if (typeof obj[key] === "object" && obj[key] !== null) obj[key] = $75214256965cbf42$export$113d90026b452881(obj[key]);
    }
    return obj;
};



var $03f7cf654f4767cf$export$40e2db4f1ce24b10 = function() {
    var Class = Object.getPrototypeOf(this).constructor;
    var Constructor = Function.bind.apply(String, (0, $5c96a02c592fcff1$export$1216008129fb82ed)([
        null
    ], (0, $5c96a02c592fcff1$export$8d051b38c9118094)(arguments)));
    var instance = new Constructor();
    Object.setPrototypeOf(instance, Class.prototype);
    return instance;
};
$03f7cf654f4767cf$export$40e2db4f1ce24b10.prototype = Object.create(String.prototype, {
    constructor: {
        value: $03f7cf654f4767cf$export$40e2db4f1ce24b10,
        enumerable: false,
        writable: true,
        configurable: true
    }
});
Object.setPrototypeOf($03f7cf654f4767cf$export$40e2db4f1ce24b10, String);
var $03f7cf654f4767cf$export$494ed5148690ecaf = function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(LazyJsonString, _super);
    function LazyJsonString() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    LazyJsonString.prototype.deserializeJSON = function() {
        return JSON.parse(_super.prototype.toString.call(this));
    };
    LazyJsonString.prototype.toJSON = function() {
        return _super.prototype.toString.call(this);
    };
    LazyJsonString.fromObject = function(object) {
        if (object instanceof LazyJsonString) return object;
        else if (object instanceof String || typeof object === "string") return new LazyJsonString(object);
        return new LazyJsonString(JSON.stringify(object));
    };
    return LazyJsonString;
}($03f7cf654f4767cf$export$40e2db4f1ce24b10);



var $effabbffc25aabc8$export$4a2bea4ecaa09ba7 = function(value) {
    if (value !== value) return "NaN";
    switch(value){
        case Infinity:
            return "Infinity";
        case -Infinity:
            return "-Infinity";
        default:
            return value;
    }
};


function $b97b3db187df6c4a$export$b0cd0cd33296db41(value, delimiter, numDelimiters) {
    if (numDelimiters <= 0 || !Number.isInteger(numDelimiters)) throw new Error("Invalid number of delimiters (" + numDelimiters + ") for splitEvery.");
    var segments = value.split(delimiter);
    if (numDelimiters === 1) return segments;
    var compoundSegments = [];
    var currentSegment = "";
    for(var i = 0; i < segments.length; i++){
        if (currentSegment === "") currentSegment = segments[i];
        else currentSegment += delimiter + segments[i];
        if ((i + 1) % numDelimiters === 0) {
            compoundSegments.push(currentSegment);
            currentSegment = "";
        }
    }
    if (currentSegment !== "") compoundSegments.push(currentSegment);
    return compoundSegments;
}







var $411eb8c425b27262$export$6ce7aba8257a989c = function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(SNSServiceException, _super);
    function SNSServiceException(options) {
        var _this = _super.call(this, options) || this;
        Object.setPrototypeOf(_this, SNSServiceException.prototype);
        return _this;
    }
    return SNSServiceException;
}((0, $a08c2c31e27e9e11$export$29647f3b4097d3c0));


var $267a5477e1e57441$export$9136a0012e5da707;
(function(AddPermissionInput) {
    AddPermissionInput.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($267a5477e1e57441$export$9136a0012e5da707 || ($267a5477e1e57441$export$9136a0012e5da707 = {}));
var $267a5477e1e57441$export$d912356501f9a666 = function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(AuthorizationErrorException, _super);
    function AuthorizationErrorException(opts) {
        var _this = _super.call(this, (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
            name: "AuthorizationErrorException",
            $fault: "client"
        }, opts)) || this;
        _this.name = "AuthorizationErrorException";
        _this.$fault = "client";
        Object.setPrototypeOf(_this, AuthorizationErrorException.prototype);
        return _this;
    }
    return AuthorizationErrorException;
}((0, $411eb8c425b27262$export$6ce7aba8257a989c));
var $267a5477e1e57441$export$8b0f706f4df56c63 = function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(InternalErrorException, _super);
    function InternalErrorException(opts) {
        var _this = _super.call(this, (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
            name: "InternalErrorException",
            $fault: "server"
        }, opts)) || this;
        _this.name = "InternalErrorException";
        _this.$fault = "server";
        Object.setPrototypeOf(_this, InternalErrorException.prototype);
        return _this;
    }
    return InternalErrorException;
}((0, $411eb8c425b27262$export$6ce7aba8257a989c));
var $267a5477e1e57441$export$fa781b52e13bf866 = function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(InvalidParameterException, _super);
    function InvalidParameterException(opts) {
        var _this = _super.call(this, (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
            name: "InvalidParameterException",
            $fault: "client"
        }, opts)) || this;
        _this.name = "InvalidParameterException";
        _this.$fault = "client";
        Object.setPrototypeOf(_this, InvalidParameterException.prototype);
        return _this;
    }
    return InvalidParameterException;
}((0, $411eb8c425b27262$export$6ce7aba8257a989c));
var $267a5477e1e57441$export$32cc081a9594a58d = function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(NotFoundException, _super);
    function NotFoundException(opts) {
        var _this = _super.call(this, (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
            name: "NotFoundException",
            $fault: "client"
        }, opts)) || this;
        _this.name = "NotFoundException";
        _this.$fault = "client";
        Object.setPrototypeOf(_this, NotFoundException.prototype);
        return _this;
    }
    return NotFoundException;
}((0, $411eb8c425b27262$export$6ce7aba8257a989c));
var $267a5477e1e57441$export$a5b61dfcd78cc02b;
(function(CheckIfPhoneNumberIsOptedOutInput) {
    CheckIfPhoneNumberIsOptedOutInput.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($267a5477e1e57441$export$a5b61dfcd78cc02b || ($267a5477e1e57441$export$a5b61dfcd78cc02b = {}));
var $267a5477e1e57441$export$6c13075ad3f63a;
(function(CheckIfPhoneNumberIsOptedOutResponse) {
    CheckIfPhoneNumberIsOptedOutResponse.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($267a5477e1e57441$export$6c13075ad3f63a || ($267a5477e1e57441$export$6c13075ad3f63a = {}));
var $267a5477e1e57441$export$ecd24e243f135e95 = function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(ThrottledException, _super);
    function ThrottledException(opts) {
        var _this = _super.call(this, (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
            name: "ThrottledException",
            $fault: "client"
        }, opts)) || this;
        _this.name = "ThrottledException";
        _this.$fault = "client";
        Object.setPrototypeOf(_this, ThrottledException.prototype);
        return _this;
    }
    return ThrottledException;
}((0, $411eb8c425b27262$export$6ce7aba8257a989c));
var $267a5477e1e57441$export$6eafb32df91302c5;
(function(ConfirmSubscriptionInput) {
    ConfirmSubscriptionInput.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($267a5477e1e57441$export$6eafb32df91302c5 || ($267a5477e1e57441$export$6eafb32df91302c5 = {}));
var $267a5477e1e57441$export$5498bd7c70fe932;
(function(ConfirmSubscriptionResponse) {
    ConfirmSubscriptionResponse.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($267a5477e1e57441$export$5498bd7c70fe932 || ($267a5477e1e57441$export$5498bd7c70fe932 = {}));
var $267a5477e1e57441$export$59b231b54ab1db1f = function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(FilterPolicyLimitExceededException, _super);
    function FilterPolicyLimitExceededException(opts) {
        var _this = _super.call(this, (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
            name: "FilterPolicyLimitExceededException",
            $fault: "client"
        }, opts)) || this;
        _this.name = "FilterPolicyLimitExceededException";
        _this.$fault = "client";
        Object.setPrototypeOf(_this, FilterPolicyLimitExceededException.prototype);
        return _this;
    }
    return FilterPolicyLimitExceededException;
}((0, $411eb8c425b27262$export$6ce7aba8257a989c));
var $267a5477e1e57441$export$950b6523cccf42ca = function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(SubscriptionLimitExceededException, _super);
    function SubscriptionLimitExceededException(opts) {
        var _this = _super.call(this, (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
            name: "SubscriptionLimitExceededException",
            $fault: "client"
        }, opts)) || this;
        _this.name = "SubscriptionLimitExceededException";
        _this.$fault = "client";
        Object.setPrototypeOf(_this, SubscriptionLimitExceededException.prototype);
        return _this;
    }
    return SubscriptionLimitExceededException;
}((0, $411eb8c425b27262$export$6ce7aba8257a989c));
var $267a5477e1e57441$export$54877f1e9b371b4c;
(function(CreatePlatformApplicationInput) {
    CreatePlatformApplicationInput.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($267a5477e1e57441$export$54877f1e9b371b4c || ($267a5477e1e57441$export$54877f1e9b371b4c = {}));
var $267a5477e1e57441$export$db2b4d5b9b8fc2a8;
(function(CreatePlatformApplicationResponse) {
    CreatePlatformApplicationResponse.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($267a5477e1e57441$export$db2b4d5b9b8fc2a8 || ($267a5477e1e57441$export$db2b4d5b9b8fc2a8 = {}));
var $267a5477e1e57441$export$e2360e86f544d325;
(function(CreateEndpointResponse) {
    CreateEndpointResponse.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($267a5477e1e57441$export$e2360e86f544d325 || ($267a5477e1e57441$export$e2360e86f544d325 = {}));
var $267a5477e1e57441$export$b97d1fc14bfccb1a;
(function(CreatePlatformEndpointInput) {
    CreatePlatformEndpointInput.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($267a5477e1e57441$export$b97d1fc14bfccb1a || ($267a5477e1e57441$export$b97d1fc14bfccb1a = {}));
var $267a5477e1e57441$export$8bed521234a8ec93;
(function(LanguageCodeString) {
    LanguageCodeString["de_DE"] = "de-DE";
    LanguageCodeString["en_GB"] = "en-GB";
    LanguageCodeString["en_US"] = "en-US";
    LanguageCodeString["es_419"] = "es-419";
    LanguageCodeString["es_ES"] = "es-ES";
    LanguageCodeString["fr_CA"] = "fr-CA";
    LanguageCodeString["fr_FR"] = "fr-FR";
    LanguageCodeString["it_IT"] = "it-IT";
    LanguageCodeString["jp_JP"] = "ja-JP";
    LanguageCodeString["kr_KR"] = "kr-KR";
    LanguageCodeString["pt_BR"] = "pt-BR";
    LanguageCodeString["zh_CN"] = "zh-CN";
    LanguageCodeString["zh_TW"] = "zh-TW";
})($267a5477e1e57441$export$8bed521234a8ec93 || ($267a5477e1e57441$export$8bed521234a8ec93 = {}));
var $267a5477e1e57441$export$46ea4f7da62a60af;
(function(CreateSMSSandboxPhoneNumberInput) {
    CreateSMSSandboxPhoneNumberInput.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($267a5477e1e57441$export$46ea4f7da62a60af || ($267a5477e1e57441$export$46ea4f7da62a60af = {}));
var $267a5477e1e57441$export$4e4ed418e0c2c37d;
(function(CreateSMSSandboxPhoneNumberResult) {
    CreateSMSSandboxPhoneNumberResult.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($267a5477e1e57441$export$4e4ed418e0c2c37d || ($267a5477e1e57441$export$4e4ed418e0c2c37d = {}));
var $267a5477e1e57441$export$ad37e326ac954b51 = function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(OptedOutException, _super);
    function OptedOutException(opts) {
        var _this = _super.call(this, (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
            name: "OptedOutException",
            $fault: "client"
        }, opts)) || this;
        _this.name = "OptedOutException";
        _this.$fault = "client";
        Object.setPrototypeOf(_this, OptedOutException.prototype);
        return _this;
    }
    return OptedOutException;
}((0, $411eb8c425b27262$export$6ce7aba8257a989c));
var $267a5477e1e57441$export$795017c7272512f4 = function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(UserErrorException, _super);
    function UserErrorException(opts) {
        var _this = _super.call(this, (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
            name: "UserErrorException",
            $fault: "client"
        }, opts)) || this;
        _this.name = "UserErrorException";
        _this.$fault = "client";
        Object.setPrototypeOf(_this, UserErrorException.prototype);
        return _this;
    }
    return UserErrorException;
}((0, $411eb8c425b27262$export$6ce7aba8257a989c));
var $267a5477e1e57441$export$f9b664e19df1b4c5 = function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(ConcurrentAccessException, _super);
    function ConcurrentAccessException(opts) {
        var _this = _super.call(this, (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
            name: "ConcurrentAccessException",
            $fault: "client"
        }, opts)) || this;
        _this.name = "ConcurrentAccessException";
        _this.$fault = "client";
        Object.setPrototypeOf(_this, ConcurrentAccessException.prototype);
        return _this;
    }
    return ConcurrentAccessException;
}((0, $411eb8c425b27262$export$6ce7aba8257a989c));
var $267a5477e1e57441$export$3288d34c523a1192;
(function(Tag) {
    Tag.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($267a5477e1e57441$export$3288d34c523a1192 || ($267a5477e1e57441$export$3288d34c523a1192 = {}));
var $267a5477e1e57441$export$94f3f2c0c33cd27e;
(function(CreateTopicInput) {
    CreateTopicInput.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($267a5477e1e57441$export$94f3f2c0c33cd27e || ($267a5477e1e57441$export$94f3f2c0c33cd27e = {}));
var $267a5477e1e57441$export$120fbe4e6666a51;
(function(CreateTopicResponse) {
    CreateTopicResponse.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($267a5477e1e57441$export$120fbe4e6666a51 || ($267a5477e1e57441$export$120fbe4e6666a51 = {}));
var $267a5477e1e57441$export$7cf5bde9ac6b75ab = function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(InvalidSecurityException, _super);
    function InvalidSecurityException(opts) {
        var _this = _super.call(this, (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
            name: "InvalidSecurityException",
            $fault: "client"
        }, opts)) || this;
        _this.name = "InvalidSecurityException";
        _this.$fault = "client";
        Object.setPrototypeOf(_this, InvalidSecurityException.prototype);
        return _this;
    }
    return InvalidSecurityException;
}((0, $411eb8c425b27262$export$6ce7aba8257a989c));
var $267a5477e1e57441$export$2a8546160994da50 = function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(StaleTagException, _super);
    function StaleTagException(opts) {
        var _this = _super.call(this, (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
            name: "StaleTagException",
            $fault: "client"
        }, opts)) || this;
        _this.name = "StaleTagException";
        _this.$fault = "client";
        Object.setPrototypeOf(_this, StaleTagException.prototype);
        return _this;
    }
    return StaleTagException;
}((0, $411eb8c425b27262$export$6ce7aba8257a989c));
var $267a5477e1e57441$export$27b07a8f2616d8bf = function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(TagLimitExceededException, _super);
    function TagLimitExceededException(opts) {
        var _this = _super.call(this, (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
            name: "TagLimitExceededException",
            $fault: "client"
        }, opts)) || this;
        _this.name = "TagLimitExceededException";
        _this.$fault = "client";
        Object.setPrototypeOf(_this, TagLimitExceededException.prototype);
        return _this;
    }
    return TagLimitExceededException;
}((0, $411eb8c425b27262$export$6ce7aba8257a989c));
var $267a5477e1e57441$export$85a2e341180e2619 = function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(TagPolicyException, _super);
    function TagPolicyException(opts) {
        var _this = _super.call(this, (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
            name: "TagPolicyException",
            $fault: "client"
        }, opts)) || this;
        _this.name = "TagPolicyException";
        _this.$fault = "client";
        Object.setPrototypeOf(_this, TagPolicyException.prototype);
        return _this;
    }
    return TagPolicyException;
}((0, $411eb8c425b27262$export$6ce7aba8257a989c));
var $267a5477e1e57441$export$5a83f7e2f73a45a = function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(TopicLimitExceededException, _super);
    function TopicLimitExceededException(opts) {
        var _this = _super.call(this, (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
            name: "TopicLimitExceededException",
            $fault: "client"
        }, opts)) || this;
        _this.name = "TopicLimitExceededException";
        _this.$fault = "client";
        Object.setPrototypeOf(_this, TopicLimitExceededException.prototype);
        return _this;
    }
    return TopicLimitExceededException;
}((0, $411eb8c425b27262$export$6ce7aba8257a989c));
var $267a5477e1e57441$export$10a3126cd7381e02;
(function(DeleteEndpointInput) {
    DeleteEndpointInput.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($267a5477e1e57441$export$10a3126cd7381e02 || ($267a5477e1e57441$export$10a3126cd7381e02 = {}));
var $267a5477e1e57441$export$8151ad6eee8f5064;
(function(DeletePlatformApplicationInput) {
    DeletePlatformApplicationInput.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($267a5477e1e57441$export$8151ad6eee8f5064 || ($267a5477e1e57441$export$8151ad6eee8f5064 = {}));
var $267a5477e1e57441$export$8f7b210b44d8fea9;
(function(DeleteSMSSandboxPhoneNumberInput) {
    DeleteSMSSandboxPhoneNumberInput.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($267a5477e1e57441$export$8f7b210b44d8fea9 || ($267a5477e1e57441$export$8f7b210b44d8fea9 = {}));
var $267a5477e1e57441$export$af62966cbf30b9ca;
(function(DeleteSMSSandboxPhoneNumberResult) {
    DeleteSMSSandboxPhoneNumberResult.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($267a5477e1e57441$export$af62966cbf30b9ca || ($267a5477e1e57441$export$af62966cbf30b9ca = {}));
var $267a5477e1e57441$export$ecba565262f8bb2 = function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(ResourceNotFoundException, _super);
    function ResourceNotFoundException(opts) {
        var _this = _super.call(this, (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
            name: "ResourceNotFoundException",
            $fault: "client"
        }, opts)) || this;
        _this.name = "ResourceNotFoundException";
        _this.$fault = "client";
        Object.setPrototypeOf(_this, ResourceNotFoundException.prototype);
        return _this;
    }
    return ResourceNotFoundException;
}((0, $411eb8c425b27262$export$6ce7aba8257a989c));
var $267a5477e1e57441$export$f6fea221a9c244d4;
(function(DeleteTopicInput) {
    DeleteTopicInput.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($267a5477e1e57441$export$f6fea221a9c244d4 || ($267a5477e1e57441$export$f6fea221a9c244d4 = {}));
var $267a5477e1e57441$export$1163cccf3919e1a0;
(function(GetEndpointAttributesInput) {
    GetEndpointAttributesInput.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($267a5477e1e57441$export$1163cccf3919e1a0 || ($267a5477e1e57441$export$1163cccf3919e1a0 = {}));
var $267a5477e1e57441$export$5e4194f998d31cbb;
(function(GetEndpointAttributesResponse) {
    GetEndpointAttributesResponse.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($267a5477e1e57441$export$5e4194f998d31cbb || ($267a5477e1e57441$export$5e4194f998d31cbb = {}));
var $267a5477e1e57441$export$3acb8372ab14ced4;
(function(GetPlatformApplicationAttributesInput) {
    GetPlatformApplicationAttributesInput.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($267a5477e1e57441$export$3acb8372ab14ced4 || ($267a5477e1e57441$export$3acb8372ab14ced4 = {}));
var $267a5477e1e57441$export$f65f8b48a0d4ad67;
(function(GetPlatformApplicationAttributesResponse) {
    GetPlatformApplicationAttributesResponse.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($267a5477e1e57441$export$f65f8b48a0d4ad67 || ($267a5477e1e57441$export$f65f8b48a0d4ad67 = {}));
var $267a5477e1e57441$export$cdcc50e9e7ca1ee;
(function(GetSMSAttributesInput) {
    GetSMSAttributesInput.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($267a5477e1e57441$export$cdcc50e9e7ca1ee || ($267a5477e1e57441$export$cdcc50e9e7ca1ee = {}));
var $267a5477e1e57441$export$d5521270aa0857e9;
(function(GetSMSAttributesResponse) {
    GetSMSAttributesResponse.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($267a5477e1e57441$export$d5521270aa0857e9 || ($267a5477e1e57441$export$d5521270aa0857e9 = {}));
var $267a5477e1e57441$export$3e2a999111c4a455;
(function(GetSMSSandboxAccountStatusInput) {
    GetSMSSandboxAccountStatusInput.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($267a5477e1e57441$export$3e2a999111c4a455 || ($267a5477e1e57441$export$3e2a999111c4a455 = {}));
var $267a5477e1e57441$export$55117603711722f5;
(function(GetSMSSandboxAccountStatusResult) {
    GetSMSSandboxAccountStatusResult.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($267a5477e1e57441$export$55117603711722f5 || ($267a5477e1e57441$export$55117603711722f5 = {}));
var $267a5477e1e57441$export$4bceda3259c211fc;
(function(GetSubscriptionAttributesInput) {
    GetSubscriptionAttributesInput.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($267a5477e1e57441$export$4bceda3259c211fc || ($267a5477e1e57441$export$4bceda3259c211fc = {}));
var $267a5477e1e57441$export$4d7979f1bc3aab46;
(function(GetSubscriptionAttributesResponse) {
    GetSubscriptionAttributesResponse.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($267a5477e1e57441$export$4d7979f1bc3aab46 || ($267a5477e1e57441$export$4d7979f1bc3aab46 = {}));
var $267a5477e1e57441$export$74cc08291e0869db;
(function(GetTopicAttributesInput) {
    GetTopicAttributesInput.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($267a5477e1e57441$export$74cc08291e0869db || ($267a5477e1e57441$export$74cc08291e0869db = {}));
var $267a5477e1e57441$export$b9e250cc6bb14161;
(function(GetTopicAttributesResponse) {
    GetTopicAttributesResponse.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($267a5477e1e57441$export$b9e250cc6bb14161 || ($267a5477e1e57441$export$b9e250cc6bb14161 = {}));
var $267a5477e1e57441$export$36648dbe59b7d3bd;
(function(ListEndpointsByPlatformApplicationInput) {
    ListEndpointsByPlatformApplicationInput.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($267a5477e1e57441$export$36648dbe59b7d3bd || ($267a5477e1e57441$export$36648dbe59b7d3bd = {}));
var $267a5477e1e57441$export$ca3bb03eef24f110;
(function(Endpoint) {
    Endpoint.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($267a5477e1e57441$export$ca3bb03eef24f110 || ($267a5477e1e57441$export$ca3bb03eef24f110 = {}));
var $267a5477e1e57441$export$404124bf64c9c331;
(function(ListEndpointsByPlatformApplicationResponse) {
    ListEndpointsByPlatformApplicationResponse.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($267a5477e1e57441$export$404124bf64c9c331 || ($267a5477e1e57441$export$404124bf64c9c331 = {}));
var $267a5477e1e57441$export$92f1ddc65f9de846;
(function(ListOriginationNumbersRequest) {
    ListOriginationNumbersRequest.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($267a5477e1e57441$export$92f1ddc65f9de846 || ($267a5477e1e57441$export$92f1ddc65f9de846 = {}));
var $267a5477e1e57441$export$7ff7857c0b6cdf9f;
(function(NumberCapability) {
    NumberCapability["MMS"] = "MMS";
    NumberCapability["SMS"] = "SMS";
    NumberCapability["VOICE"] = "VOICE";
})($267a5477e1e57441$export$7ff7857c0b6cdf9f || ($267a5477e1e57441$export$7ff7857c0b6cdf9f = {}));
var $267a5477e1e57441$export$66e64af4f138f50f;
(function(RouteType) {
    RouteType["Premium"] = "Premium";
    RouteType["Promotional"] = "Promotional";
    RouteType["Transactional"] = "Transactional";
})($267a5477e1e57441$export$66e64af4f138f50f || ($267a5477e1e57441$export$66e64af4f138f50f = {}));
var $267a5477e1e57441$export$8de54ee332c4a5f8;
(function(PhoneNumberInformation) {
    PhoneNumberInformation.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($267a5477e1e57441$export$8de54ee332c4a5f8 || ($267a5477e1e57441$export$8de54ee332c4a5f8 = {}));
var $267a5477e1e57441$export$61932ca875dbfc1e;
(function(ListOriginationNumbersResult) {
    ListOriginationNumbersResult.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($267a5477e1e57441$export$61932ca875dbfc1e || ($267a5477e1e57441$export$61932ca875dbfc1e = {}));
var $267a5477e1e57441$export$1dbb1718e06c41be = function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(ValidationException, _super);
    function ValidationException(opts) {
        var _this = _super.call(this, (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
            name: "ValidationException",
            $fault: "client"
        }, opts)) || this;
        _this.name = "ValidationException";
        _this.$fault = "client";
        Object.setPrototypeOf(_this, ValidationException.prototype);
        _this.Message = opts.Message;
        return _this;
    }
    return ValidationException;
}((0, $411eb8c425b27262$export$6ce7aba8257a989c));
var $267a5477e1e57441$export$cb1b58e224699b05;
(function(ListPhoneNumbersOptedOutInput) {
    ListPhoneNumbersOptedOutInput.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($267a5477e1e57441$export$cb1b58e224699b05 || ($267a5477e1e57441$export$cb1b58e224699b05 = {}));
var $267a5477e1e57441$export$d645dab0d3cbf85f;
(function(ListPhoneNumbersOptedOutResponse) {
    ListPhoneNumbersOptedOutResponse.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($267a5477e1e57441$export$d645dab0d3cbf85f || ($267a5477e1e57441$export$d645dab0d3cbf85f = {}));
var $267a5477e1e57441$export$1a943179279c4a60;
(function(ListPlatformApplicationsInput) {
    ListPlatformApplicationsInput.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($267a5477e1e57441$export$1a943179279c4a60 || ($267a5477e1e57441$export$1a943179279c4a60 = {}));
var $267a5477e1e57441$export$4cae447e27c29aef;
(function(PlatformApplication) {
    PlatformApplication.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($267a5477e1e57441$export$4cae447e27c29aef || ($267a5477e1e57441$export$4cae447e27c29aef = {}));
var $267a5477e1e57441$export$15e7c543e61c3093;
(function(ListPlatformApplicationsResponse) {
    ListPlatformApplicationsResponse.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($267a5477e1e57441$export$15e7c543e61c3093 || ($267a5477e1e57441$export$15e7c543e61c3093 = {}));
var $267a5477e1e57441$export$19dd488bffc7b512;
(function(ListSMSSandboxPhoneNumbersInput) {
    ListSMSSandboxPhoneNumbersInput.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($267a5477e1e57441$export$19dd488bffc7b512 || ($267a5477e1e57441$export$19dd488bffc7b512 = {}));
var $267a5477e1e57441$export$f74d6f0f2de2f808;
(function(SMSSandboxPhoneNumberVerificationStatus) {
    SMSSandboxPhoneNumberVerificationStatus["Pending"] = "Pending";
    SMSSandboxPhoneNumberVerificationStatus["Verified"] = "Verified";
})($267a5477e1e57441$export$f74d6f0f2de2f808 || ($267a5477e1e57441$export$f74d6f0f2de2f808 = {}));
var $267a5477e1e57441$export$752ce6cea49a373e;
(function(SMSSandboxPhoneNumber) {
    SMSSandboxPhoneNumber.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($267a5477e1e57441$export$752ce6cea49a373e || ($267a5477e1e57441$export$752ce6cea49a373e = {}));
var $267a5477e1e57441$export$5ef1d392257450f1;
(function(ListSMSSandboxPhoneNumbersResult) {
    ListSMSSandboxPhoneNumbersResult.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($267a5477e1e57441$export$5ef1d392257450f1 || ($267a5477e1e57441$export$5ef1d392257450f1 = {}));
var $267a5477e1e57441$export$98695784c1da717f;
(function(ListSubscriptionsInput) {
    ListSubscriptionsInput.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($267a5477e1e57441$export$98695784c1da717f || ($267a5477e1e57441$export$98695784c1da717f = {}));
var $267a5477e1e57441$export$f55210826850c514;
(function(Subscription) {
    Subscription.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($267a5477e1e57441$export$f55210826850c514 || ($267a5477e1e57441$export$f55210826850c514 = {}));
var $267a5477e1e57441$export$4c253d417fca902d;
(function(ListSubscriptionsResponse) {
    ListSubscriptionsResponse.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($267a5477e1e57441$export$4c253d417fca902d || ($267a5477e1e57441$export$4c253d417fca902d = {}));
var $267a5477e1e57441$export$a25a8fda1b4600e5;
(function(ListSubscriptionsByTopicInput) {
    ListSubscriptionsByTopicInput.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($267a5477e1e57441$export$a25a8fda1b4600e5 || ($267a5477e1e57441$export$a25a8fda1b4600e5 = {}));
var $267a5477e1e57441$export$734710b3013b0780;
(function(ListSubscriptionsByTopicResponse) {
    ListSubscriptionsByTopicResponse.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($267a5477e1e57441$export$734710b3013b0780 || ($267a5477e1e57441$export$734710b3013b0780 = {}));
var $267a5477e1e57441$export$2ed123238b2d9c3e;
(function(ListTagsForResourceRequest) {
    ListTagsForResourceRequest.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($267a5477e1e57441$export$2ed123238b2d9c3e || ($267a5477e1e57441$export$2ed123238b2d9c3e = {}));
var $267a5477e1e57441$export$6db0c8c0f26e7fec;
(function(ListTagsForResourceResponse) {
    ListTagsForResourceResponse.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($267a5477e1e57441$export$6db0c8c0f26e7fec || ($267a5477e1e57441$export$6db0c8c0f26e7fec = {}));
var $267a5477e1e57441$export$4557435503dee499;
(function(ListTopicsInput) {
    ListTopicsInput.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($267a5477e1e57441$export$4557435503dee499 || ($267a5477e1e57441$export$4557435503dee499 = {}));
var $267a5477e1e57441$export$f3c7ddd8e2c178b5;
(function(Topic) {
    Topic.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($267a5477e1e57441$export$f3c7ddd8e2c178b5 || ($267a5477e1e57441$export$f3c7ddd8e2c178b5 = {}));
var $267a5477e1e57441$export$ac869905fd7551d6;
(function(ListTopicsResponse) {
    ListTopicsResponse.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($267a5477e1e57441$export$ac869905fd7551d6 || ($267a5477e1e57441$export$ac869905fd7551d6 = {}));
var $267a5477e1e57441$export$1d22f8e86df54e14;
(function(OptInPhoneNumberInput) {
    OptInPhoneNumberInput.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($267a5477e1e57441$export$1d22f8e86df54e14 || ($267a5477e1e57441$export$1d22f8e86df54e14 = {}));
var $267a5477e1e57441$export$b19780a6663cb45c;
(function(OptInPhoneNumberResponse) {
    OptInPhoneNumberResponse.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($267a5477e1e57441$export$b19780a6663cb45c || ($267a5477e1e57441$export$b19780a6663cb45c = {}));
var $267a5477e1e57441$export$6419aca88c7742c4 = function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(EndpointDisabledException, _super);
    function EndpointDisabledException(opts) {
        var _this = _super.call(this, (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
            name: "EndpointDisabledException",
            $fault: "client"
        }, opts)) || this;
        _this.name = "EndpointDisabledException";
        _this.$fault = "client";
        Object.setPrototypeOf(_this, EndpointDisabledException.prototype);
        return _this;
    }
    return EndpointDisabledException;
}((0, $411eb8c425b27262$export$6ce7aba8257a989c));
var $267a5477e1e57441$export$dc68e798006b2b42 = function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(InvalidParameterValueException, _super);
    function InvalidParameterValueException(opts) {
        var _this = _super.call(this, (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
            name: "InvalidParameterValueException",
            $fault: "client"
        }, opts)) || this;
        _this.name = "InvalidParameterValueException";
        _this.$fault = "client";
        Object.setPrototypeOf(_this, InvalidParameterValueException.prototype);
        return _this;
    }
    return InvalidParameterValueException;
}((0, $411eb8c425b27262$export$6ce7aba8257a989c));
var $267a5477e1e57441$export$94ad5f879b39c8eb = function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(KMSAccessDeniedException, _super);
    function KMSAccessDeniedException(opts) {
        var _this = _super.call(this, (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
            name: "KMSAccessDeniedException",
            $fault: "client"
        }, opts)) || this;
        _this.name = "KMSAccessDeniedException";
        _this.$fault = "client";
        Object.setPrototypeOf(_this, KMSAccessDeniedException.prototype);
        return _this;
    }
    return KMSAccessDeniedException;
}((0, $411eb8c425b27262$export$6ce7aba8257a989c));
var $267a5477e1e57441$export$bc1172aa6ec4fb7b = function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(KMSDisabledException, _super);
    function KMSDisabledException(opts) {
        var _this = _super.call(this, (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
            name: "KMSDisabledException",
            $fault: "client"
        }, opts)) || this;
        _this.name = "KMSDisabledException";
        _this.$fault = "client";
        Object.setPrototypeOf(_this, KMSDisabledException.prototype);
        return _this;
    }
    return KMSDisabledException;
}((0, $411eb8c425b27262$export$6ce7aba8257a989c));
var $267a5477e1e57441$export$16b76627a54694a8 = function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(KMSInvalidStateException, _super);
    function KMSInvalidStateException(opts) {
        var _this = _super.call(this, (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
            name: "KMSInvalidStateException",
            $fault: "client"
        }, opts)) || this;
        _this.name = "KMSInvalidStateException";
        _this.$fault = "client";
        Object.setPrototypeOf(_this, KMSInvalidStateException.prototype);
        return _this;
    }
    return KMSInvalidStateException;
}((0, $411eb8c425b27262$export$6ce7aba8257a989c));
var $267a5477e1e57441$export$38af9cf22646c616 = function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(KMSNotFoundException, _super);
    function KMSNotFoundException(opts) {
        var _this = _super.call(this, (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
            name: "KMSNotFoundException",
            $fault: "client"
        }, opts)) || this;
        _this.name = "KMSNotFoundException";
        _this.$fault = "client";
        Object.setPrototypeOf(_this, KMSNotFoundException.prototype);
        return _this;
    }
    return KMSNotFoundException;
}((0, $411eb8c425b27262$export$6ce7aba8257a989c));
var $267a5477e1e57441$export$c7451d555b19eb91 = function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(KMSOptInRequired, _super);
    function KMSOptInRequired(opts) {
        var _this = _super.call(this, (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
            name: "KMSOptInRequired",
            $fault: "client"
        }, opts)) || this;
        _this.name = "KMSOptInRequired";
        _this.$fault = "client";
        Object.setPrototypeOf(_this, KMSOptInRequired.prototype);
        return _this;
    }
    return KMSOptInRequired;
}((0, $411eb8c425b27262$export$6ce7aba8257a989c));
var $267a5477e1e57441$export$30e0c54ebe285f2a = function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(KMSThrottlingException, _super);
    function KMSThrottlingException(opts) {
        var _this = _super.call(this, (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
            name: "KMSThrottlingException",
            $fault: "client"
        }, opts)) || this;
        _this.name = "KMSThrottlingException";
        _this.$fault = "client";
        Object.setPrototypeOf(_this, KMSThrottlingException.prototype);
        return _this;
    }
    return KMSThrottlingException;
}((0, $411eb8c425b27262$export$6ce7aba8257a989c));
var $267a5477e1e57441$export$6fd5bb9509c41695 = function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(PlatformApplicationDisabledException, _super);
    function PlatformApplicationDisabledException(opts) {
        var _this = _super.call(this, (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
            name: "PlatformApplicationDisabledException",
            $fault: "client"
        }, opts)) || this;
        _this.name = "PlatformApplicationDisabledException";
        _this.$fault = "client";
        Object.setPrototypeOf(_this, PlatformApplicationDisabledException.prototype);
        return _this;
    }
    return PlatformApplicationDisabledException;
}((0, $411eb8c425b27262$export$6ce7aba8257a989c));
var $267a5477e1e57441$export$51a2e42036247620;
(function(MessageAttributeValue) {
    MessageAttributeValue.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($267a5477e1e57441$export$51a2e42036247620 || ($267a5477e1e57441$export$51a2e42036247620 = {}));
var $267a5477e1e57441$export$12ae5868ee61662b;
(function(PublishInput) {
    PublishInput.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($267a5477e1e57441$export$12ae5868ee61662b || ($267a5477e1e57441$export$12ae5868ee61662b = {}));
var $267a5477e1e57441$export$864d9a059c4e9a2;
(function(PublishResponse) {
    PublishResponse.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($267a5477e1e57441$export$864d9a059c4e9a2 || ($267a5477e1e57441$export$864d9a059c4e9a2 = {}));
var $267a5477e1e57441$export$ddc67a9a76e1039f = function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(BatchEntryIdsNotDistinctException, _super);
    function BatchEntryIdsNotDistinctException(opts) {
        var _this = _super.call(this, (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
            name: "BatchEntryIdsNotDistinctException",
            $fault: "client"
        }, opts)) || this;
        _this.name = "BatchEntryIdsNotDistinctException";
        _this.$fault = "client";
        Object.setPrototypeOf(_this, BatchEntryIdsNotDistinctException.prototype);
        return _this;
    }
    return BatchEntryIdsNotDistinctException;
}((0, $411eb8c425b27262$export$6ce7aba8257a989c));
var $267a5477e1e57441$export$e9c098864c3a08f = function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(BatchRequestTooLongException, _super);
    function BatchRequestTooLongException(opts) {
        var _this = _super.call(this, (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
            name: "BatchRequestTooLongException",
            $fault: "client"
        }, opts)) || this;
        _this.name = "BatchRequestTooLongException";
        _this.$fault = "client";
        Object.setPrototypeOf(_this, BatchRequestTooLongException.prototype);
        return _this;
    }
    return BatchRequestTooLongException;
}((0, $411eb8c425b27262$export$6ce7aba8257a989c));
var $267a5477e1e57441$export$fe808316dada89f2 = function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(EmptyBatchRequestException, _super);
    function EmptyBatchRequestException(opts) {
        var _this = _super.call(this, (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
            name: "EmptyBatchRequestException",
            $fault: "client"
        }, opts)) || this;
        _this.name = "EmptyBatchRequestException";
        _this.$fault = "client";
        Object.setPrototypeOf(_this, EmptyBatchRequestException.prototype);
        return _this;
    }
    return EmptyBatchRequestException;
}((0, $411eb8c425b27262$export$6ce7aba8257a989c));
var $267a5477e1e57441$export$8cceaab6fa396dbb = function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(InvalidBatchEntryIdException, _super);
    function InvalidBatchEntryIdException(opts) {
        var _this = _super.call(this, (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
            name: "InvalidBatchEntryIdException",
            $fault: "client"
        }, opts)) || this;
        _this.name = "InvalidBatchEntryIdException";
        _this.$fault = "client";
        Object.setPrototypeOf(_this, InvalidBatchEntryIdException.prototype);
        return _this;
    }
    return InvalidBatchEntryIdException;
}((0, $411eb8c425b27262$export$6ce7aba8257a989c));
var $267a5477e1e57441$export$4328b314dd68a1e;
(function(PublishBatchRequestEntry) {
    PublishBatchRequestEntry.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($267a5477e1e57441$export$4328b314dd68a1e || ($267a5477e1e57441$export$4328b314dd68a1e = {}));
var $267a5477e1e57441$export$769838603a60ddbc;
(function(PublishBatchInput) {
    PublishBatchInput.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($267a5477e1e57441$export$769838603a60ddbc || ($267a5477e1e57441$export$769838603a60ddbc = {}));
var $267a5477e1e57441$export$5feef207b3617d61;
(function(BatchResultErrorEntry) {
    BatchResultErrorEntry.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($267a5477e1e57441$export$5feef207b3617d61 || ($267a5477e1e57441$export$5feef207b3617d61 = {}));
var $267a5477e1e57441$export$39de47c86f888ab2;
(function(PublishBatchResultEntry) {
    PublishBatchResultEntry.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($267a5477e1e57441$export$39de47c86f888ab2 || ($267a5477e1e57441$export$39de47c86f888ab2 = {}));
var $267a5477e1e57441$export$93ee6c3edb569609;
(function(PublishBatchResponse) {
    PublishBatchResponse.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($267a5477e1e57441$export$93ee6c3edb569609 || ($267a5477e1e57441$export$93ee6c3edb569609 = {}));
var $267a5477e1e57441$export$4340120a6f76d3c7 = function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(TooManyEntriesInBatchRequestException, _super);
    function TooManyEntriesInBatchRequestException(opts) {
        var _this = _super.call(this, (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
            name: "TooManyEntriesInBatchRequestException",
            $fault: "client"
        }, opts)) || this;
        _this.name = "TooManyEntriesInBatchRequestException";
        _this.$fault = "client";
        Object.setPrototypeOf(_this, TooManyEntriesInBatchRequestException.prototype);
        return _this;
    }
    return TooManyEntriesInBatchRequestException;
}((0, $411eb8c425b27262$export$6ce7aba8257a989c));
var $267a5477e1e57441$export$4dd701bd95564294;
(function(RemovePermissionInput) {
    RemovePermissionInput.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($267a5477e1e57441$export$4dd701bd95564294 || ($267a5477e1e57441$export$4dd701bd95564294 = {}));
var $267a5477e1e57441$export$3d3d3d8cabd02784;
(function(SetEndpointAttributesInput) {
    SetEndpointAttributesInput.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($267a5477e1e57441$export$3d3d3d8cabd02784 || ($267a5477e1e57441$export$3d3d3d8cabd02784 = {}));
var $267a5477e1e57441$export$75354baa0d3cb55a;
(function(SetPlatformApplicationAttributesInput) {
    SetPlatformApplicationAttributesInput.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($267a5477e1e57441$export$75354baa0d3cb55a || ($267a5477e1e57441$export$75354baa0d3cb55a = {}));
var $267a5477e1e57441$export$5423b9ef2bcc260a;
(function(SetSMSAttributesInput) {
    SetSMSAttributesInput.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($267a5477e1e57441$export$5423b9ef2bcc260a || ($267a5477e1e57441$export$5423b9ef2bcc260a = {}));
var $267a5477e1e57441$export$dfa260f056a3f55f;
(function(SetSMSAttributesResponse) {
    SetSMSAttributesResponse.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($267a5477e1e57441$export$dfa260f056a3f55f || ($267a5477e1e57441$export$dfa260f056a3f55f = {}));
var $267a5477e1e57441$export$d4f287cc3b09b07a;
(function(SetSubscriptionAttributesInput) {
    SetSubscriptionAttributesInput.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($267a5477e1e57441$export$d4f287cc3b09b07a || ($267a5477e1e57441$export$d4f287cc3b09b07a = {}));
var $267a5477e1e57441$export$a3a47f710fa039f;
(function(SetTopicAttributesInput) {
    SetTopicAttributesInput.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($267a5477e1e57441$export$a3a47f710fa039f || ($267a5477e1e57441$export$a3a47f710fa039f = {}));
var $267a5477e1e57441$export$562f5b3030674ef5;
(function(SubscribeInput) {
    SubscribeInput.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($267a5477e1e57441$export$562f5b3030674ef5 || ($267a5477e1e57441$export$562f5b3030674ef5 = {}));
var $267a5477e1e57441$export$89425a92d6d4fba3;
(function(SubscribeResponse) {
    SubscribeResponse.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($267a5477e1e57441$export$89425a92d6d4fba3 || ($267a5477e1e57441$export$89425a92d6d4fba3 = {}));
var $267a5477e1e57441$export$bf890a678e449fc2;
(function(TagResourceRequest) {
    TagResourceRequest.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($267a5477e1e57441$export$bf890a678e449fc2 || ($267a5477e1e57441$export$bf890a678e449fc2 = {}));
var $267a5477e1e57441$export$2d5279802486e8b0;
(function(TagResourceResponse) {
    TagResourceResponse.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($267a5477e1e57441$export$2d5279802486e8b0 || ($267a5477e1e57441$export$2d5279802486e8b0 = {}));
var $267a5477e1e57441$export$6e9469a884a5522;
(function(UnsubscribeInput) {
    UnsubscribeInput.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($267a5477e1e57441$export$6e9469a884a5522 || ($267a5477e1e57441$export$6e9469a884a5522 = {}));
var $267a5477e1e57441$export$7ebb14554e37eb78;
(function(UntagResourceRequest) {
    UntagResourceRequest.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($267a5477e1e57441$export$7ebb14554e37eb78 || ($267a5477e1e57441$export$7ebb14554e37eb78 = {}));
var $267a5477e1e57441$export$2128f49a7cd2e47f;
(function(UntagResourceResponse) {
    UntagResourceResponse.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($267a5477e1e57441$export$2128f49a7cd2e47f || ($267a5477e1e57441$export$2128f49a7cd2e47f = {}));
var $267a5477e1e57441$export$e94d56aa2c3e58d6 = function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(VerificationException, _super);
    function VerificationException(opts) {
        var _this = _super.call(this, (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
            name: "VerificationException",
            $fault: "client"
        }, opts)) || this;
        _this.name = "VerificationException";
        _this.$fault = "client";
        Object.setPrototypeOf(_this, VerificationException.prototype);
        _this.Message = opts.Message;
        _this.Status = opts.Status;
        return _this;
    }
    return VerificationException;
}((0, $411eb8c425b27262$export$6ce7aba8257a989c));
var $267a5477e1e57441$export$ee23fd185bd6b393;
(function(VerifySMSSandboxPhoneNumberInput) {
    VerifySMSSandboxPhoneNumberInput.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($267a5477e1e57441$export$ee23fd185bd6b393 || ($267a5477e1e57441$export$ee23fd185bd6b393 = {}));
var $267a5477e1e57441$export$1c4b3b44e8a6bd9a;
(function(VerifySMSSandboxPhoneNumberResult) {
    VerifySMSSandboxPhoneNumberResult.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($267a5477e1e57441$export$1c4b3b44e8a6bd9a || ($267a5477e1e57441$export$1c4b3b44e8a6bd9a = {}));






var $f5162dd3bdb0d175$export$7587955500404ec3 = function() {
    function HttpRequest(options) {
        this.method = options.method || "GET";
        this.hostname = options.hostname || "localhost";
        this.port = options.port;
        this.query = options.query || {};
        this.headers = options.headers || {};
        this.body = options.body;
        this.protocol = options.protocol ? options.protocol.substr(-1) !== ":" ? options.protocol + ":" : options.protocol : "https:";
        this.path = options.path ? options.path.charAt(0) !== "/" ? "/" + options.path : options.path : "/";
    }
    HttpRequest.isInstance = function(request) {
        if (!request) return false;
        var req = request;
        return "method" in req && "protocol" in req && "hostname" in req && "path" in req && typeof req["query"] === "object" && typeof req["headers"] === "object";
    };
    HttpRequest.prototype.clone = function() {
        var cloned = new HttpRequest((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, this), {
            headers: (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, this.headers)
        }));
        if (cloned.query) cloned.query = $f5162dd3bdb0d175$var$cloneQuery(cloned.query);
        return cloned;
    };
    return HttpRequest;
}();
function $f5162dd3bdb0d175$var$cloneQuery(query) {
    return Object.keys(query).reduce(function(carry, paramName) {
        var _a;
        var param = query[paramName];
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, carry), (_a = {}, _a[paramName] = Array.isArray(param) ? (0, $5c96a02c592fcff1$export$1216008129fb82ed)([], (0, $5c96a02c592fcff1$export$8d051b38c9118094)(param)) : param, _a));
    }, {});
}


var $563c3f2e6f334247$export$1d94dfe0d9d1f1e7 = function() {
    function HttpResponse(options) {
        this.statusCode = options.statusCode;
        this.headers = options.headers || {};
        this.body = options.body;
    }
    HttpResponse.isInstance = function(response) {
        if (!response) return false;
        var resp = response;
        return typeof resp.statusCode === "number" && typeof resp.headers === "object";
    };
    return HttpResponse;
}();


function $dadd312191a94bc2$export$e024c793399bdd01(hostname) {
    var hostPattern = /^[a-z0-9][a-z0-9\.\-]*[a-z0-9]$/;
    return hostPattern.test(hostname);
}





var $5f6deb2c0735ac56$exports = {};
"use strict";
Object.defineProperty($5f6deb2c0735ac56$exports, "__esModule", {
    value: true
});
$5f6deb2c0735ac56$exports.decodeXMLStrict = $5f6deb2c0735ac56$exports.decodeHTML5Strict = $5f6deb2c0735ac56$exports.decodeHTML4Strict = $5f6deb2c0735ac56$exports.decodeHTML5 = $5f6deb2c0735ac56$exports.decodeHTML4 = $5f6deb2c0735ac56$exports.decodeHTMLStrict = $5f6deb2c0735ac56$exports.decodeHTML = $5f6deb2c0735ac56$exports.decodeXML = $5f6deb2c0735ac56$exports.encodeHTML5 = $5f6deb2c0735ac56$exports.encodeHTML4 = $5f6deb2c0735ac56$exports.escapeUTF8 = $5f6deb2c0735ac56$exports.escape = $5f6deb2c0735ac56$exports.encodeNonAsciiHTML = $5f6deb2c0735ac56$exports.encodeHTML = $5f6deb2c0735ac56$exports.encodeXML = $5f6deb2c0735ac56$exports.encode = $5f6deb2c0735ac56$exports.decodeStrict = $5f6deb2c0735ac56$exports.decode = void 0;
var $f51833765089d558$exports = {};
"use strict";
var $f51833765089d558$var$__importDefault = $f51833765089d558$exports && $f51833765089d558$exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty($f51833765089d558$exports, "__esModule", {
    value: true
});
$f51833765089d558$exports.decodeHTML = $f51833765089d558$exports.decodeHTMLStrict = $f51833765089d558$exports.decodeXML = void 0;

var $f51833765089d558$var$entities_json_1 = $f51833765089d558$var$__importDefault((parcelRequire("e7LDe")));

var $f51833765089d558$var$legacy_json_1 = $f51833765089d558$var$__importDefault((parcelRequire("fYhBh")));

var $f51833765089d558$var$xml_json_1 = $f51833765089d558$var$__importDefault((parcelRequire("bXxzr")));

var $f51833765089d558$var$decode_codepoint_1 = $f51833765089d558$var$__importDefault((parcelRequire("jAuaA")));
var $f51833765089d558$var$strictEntityRe = /&(?:[a-zA-Z0-9]+|#[xX][\da-fA-F]+|#\d+);/g;
$f51833765089d558$exports.decodeXML = $f51833765089d558$var$getStrictDecoder($f51833765089d558$var$xml_json_1.default);
$f51833765089d558$exports.decodeHTMLStrict = $f51833765089d558$var$getStrictDecoder($f51833765089d558$var$entities_json_1.default);
function $f51833765089d558$var$getStrictDecoder(map) {
    var replace = $f51833765089d558$var$getReplacer(map);
    return function(str) {
        return String(str).replace($f51833765089d558$var$strictEntityRe, replace);
    };
}
var $f51833765089d558$var$sorter = function(a, b) {
    return a < b ? 1 : -1;
};
$f51833765089d558$exports.decodeHTML = function() {
    var legacy = Object.keys($f51833765089d558$var$legacy_json_1.default).sort($f51833765089d558$var$sorter);
    var keys = Object.keys($f51833765089d558$var$entities_json_1.default).sort($f51833765089d558$var$sorter);
    for(var i = 0, j = 0; i < keys.length; i++)if (legacy[j] === keys[i]) {
        keys[i] += ";?";
        j++;
    } else keys[i] += ";";
    var re = new RegExp("&(?:" + keys.join("|") + "|#[xX][\\da-fA-F]+;?|#\\d+;?)", "g");
    var replace = $f51833765089d558$var$getReplacer($f51833765089d558$var$entities_json_1.default);
    function replacer(str) {
        if (str.substr(-1) !== ";") str += ";";
        return replace(str);
    }
    // TODO consider creating a merged map
    return function(str) {
        return String(str).replace(re, replacer);
    };
}();
function $f51833765089d558$var$getReplacer(map) {
    return function replace(str) {
        if (str.charAt(1) === "#") {
            var secondChar = str.charAt(2);
            if (secondChar === "X" || secondChar === "x") return $f51833765089d558$var$decode_codepoint_1.default(parseInt(str.substr(3), 16));
            return $f51833765089d558$var$decode_codepoint_1.default(parseInt(str.substr(2), 10));
        }
        // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
        return map[str.slice(1, -1)] || str;
    };
}


var $555e85e43773c407$exports = {};
"use strict";
var $555e85e43773c407$var$__importDefault = $555e85e43773c407$exports && $555e85e43773c407$exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty($555e85e43773c407$exports, "__esModule", {
    value: true
});
$555e85e43773c407$exports.escapeUTF8 = $555e85e43773c407$exports.escape = $555e85e43773c407$exports.encodeNonAsciiHTML = $555e85e43773c407$exports.encodeHTML = $555e85e43773c407$exports.encodeXML = void 0;

var $555e85e43773c407$var$xml_json_1 = $555e85e43773c407$var$__importDefault((parcelRequire("bXxzr")));
var $555e85e43773c407$var$inverseXML = $555e85e43773c407$var$getInverseObj($555e85e43773c407$var$xml_json_1.default);
var $555e85e43773c407$var$xmlReplacer = $555e85e43773c407$var$getInverseReplacer($555e85e43773c407$var$inverseXML);
/**
 * Encodes all non-ASCII characters, as well as characters not valid in XML
 * documents using XML entities.
 *
 * If a character has no equivalent entity, a
 * numeric hexadecimal reference (eg. `&#xfc;`) will be used.
 */ $555e85e43773c407$exports.encodeXML = $555e85e43773c407$var$getASCIIEncoder($555e85e43773c407$var$inverseXML);

var $555e85e43773c407$var$entities_json_1 = $555e85e43773c407$var$__importDefault((parcelRequire("e7LDe")));
var $555e85e43773c407$var$inverseHTML = $555e85e43773c407$var$getInverseObj($555e85e43773c407$var$entities_json_1.default);
var $555e85e43773c407$var$htmlReplacer = $555e85e43773c407$var$getInverseReplacer($555e85e43773c407$var$inverseHTML);
/**
 * Encodes all entities and non-ASCII characters in the input.
 *
 * This includes characters that are valid ASCII characters in HTML documents.
 * For example `#` will be encoded as `&num;`. To get a more compact output,
 * consider using the `encodeNonAsciiHTML` function.
 *
 * If a character has no equivalent entity, a
 * numeric hexadecimal reference (eg. `&#xfc;`) will be used.
 */ $555e85e43773c407$exports.encodeHTML = $555e85e43773c407$var$getInverse($555e85e43773c407$var$inverseHTML, $555e85e43773c407$var$htmlReplacer);
/**
 * Encodes all non-ASCII characters, as well as characters not valid in HTML
 * documents using HTML entities.
 *
 * If a character has no equivalent entity, a
 * numeric hexadecimal reference (eg. `&#xfc;`) will be used.
 */ $555e85e43773c407$exports.encodeNonAsciiHTML = $555e85e43773c407$var$getASCIIEncoder($555e85e43773c407$var$inverseHTML);
function $555e85e43773c407$var$getInverseObj(obj) {
    return Object.keys(obj).sort().reduce(function(inverse, name) {
        inverse[obj[name]] = "&" + name + ";";
        return inverse;
    }, {});
}
function $555e85e43773c407$var$getInverseReplacer(inverse) {
    var single = [];
    var multiple = [];
    for(var _i = 0, _a = Object.keys(inverse); _i < _a.length; _i++){
        var k = _a[_i];
        if (k.length === 1) // Add value to single array
        single.push("\\" + k);
        else // Add value to multiple array
        multiple.push(k);
    }
    // Add ranges to single characters.
    single.sort();
    for(var start = 0; start < single.length - 1; start++){
        // Find the end of a run of characters
        var end = start;
        while(end < single.length - 1 && single[end].charCodeAt(1) + 1 === single[end + 1].charCodeAt(1))end += 1;
        var count = 1 + end - start;
        // We want to replace at least three characters
        if (count < 3) continue;
        single.splice(start, count, single[start] + "-" + single[end]);
    }
    multiple.unshift("[" + single.join("") + "]");
    return new RegExp(multiple.join("|"), "g");
}
// /[^\0-\x7F]/gu
var $555e85e43773c407$var$reNonASCII = /(?:[\x80-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])/g;
var $555e85e43773c407$var$getCodePoint = // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
String.prototype.codePointAt != null ? function(str) {
    return str.codePointAt(0);
} : function(c) {
    return (c.charCodeAt(0) - 0xd800) * 0x400 + c.charCodeAt(1) - 0xdc00 + 0x10000;
};
function $555e85e43773c407$var$singleCharReplacer(c) {
    return "&#x" + (c.length > 1 ? $555e85e43773c407$var$getCodePoint(c) : c.charCodeAt(0)).toString(16).toUpperCase() + ";";
}
function $555e85e43773c407$var$getInverse(inverse, re) {
    return function(data) {
        return data.replace(re, function(name) {
            return inverse[name];
        }).replace($555e85e43773c407$var$reNonASCII, $555e85e43773c407$var$singleCharReplacer);
    };
}
var $555e85e43773c407$var$reEscapeChars = new RegExp($555e85e43773c407$var$xmlReplacer.source + "|" + $555e85e43773c407$var$reNonASCII.source, "g");
/**
 * Encodes all non-ASCII characters, as well as characters not valid in XML
 * documents using numeric hexadecimal reference (eg. `&#xfc;`).
 *
 * Have a look at `escapeUTF8` if you want a more concise output at the expense
 * of reduced transportability.
 *
 * @param data String to escape.
 */ function $555e85e43773c407$var$escape(data) {
    return data.replace($555e85e43773c407$var$reEscapeChars, $555e85e43773c407$var$singleCharReplacer);
}
$555e85e43773c407$exports.escape = $555e85e43773c407$var$escape;
/**
 * Encodes all characters not valid in XML documents using numeric hexadecimal
 * reference (eg. `&#xfc;`).
 *
 * Note that the output will be character-set dependent.
 *
 * @param data String to escape.
 */ function $555e85e43773c407$var$escapeUTF8(data) {
    return data.replace($555e85e43773c407$var$xmlReplacer, $555e85e43773c407$var$singleCharReplacer);
}
$555e85e43773c407$exports.escapeUTF8 = $555e85e43773c407$var$escapeUTF8;
function $555e85e43773c407$var$getASCIIEncoder(obj) {
    return function(data) {
        return data.replace($555e85e43773c407$var$reEscapeChars, function(c) {
            return obj[c] || $555e85e43773c407$var$singleCharReplacer(c);
        });
    };
}


/**
 * Decodes a string with entities.
 *
 * @param data String to decode.
 * @param level Optional level to decode at. 0 = XML, 1 = HTML. Default is 0.
 * @deprecated Use `decodeXML` or `decodeHTML` directly.
 */ function $5f6deb2c0735ac56$var$decode(data, level) {
    return (!level || level <= 0 ? $f51833765089d558$exports.decodeXML : $f51833765089d558$exports.decodeHTML)(data);
}
$5f6deb2c0735ac56$exports.decode = $5f6deb2c0735ac56$var$decode;
/**
 * Decodes a string with entities. Does not allow missing trailing semicolons for entities.
 *
 * @param data String to decode.
 * @param level Optional level to decode at. 0 = XML, 1 = HTML. Default is 0.
 * @deprecated Use `decodeHTMLStrict` or `decodeXML` directly.
 */ function $5f6deb2c0735ac56$var$decodeStrict(data, level) {
    return (!level || level <= 0 ? $f51833765089d558$exports.decodeXML : $f51833765089d558$exports.decodeHTMLStrict)(data);
}
$5f6deb2c0735ac56$exports.decodeStrict = $5f6deb2c0735ac56$var$decodeStrict;
/**
 * Encodes a string with entities.
 *
 * @param data String to encode.
 * @param level Optional level to encode at. 0 = XML, 1 = HTML. Default is 0.
 * @deprecated Use `encodeHTML`, `encodeXML` or `encodeNonAsciiHTML` directly.
 */ function $5f6deb2c0735ac56$var$encode(data, level) {
    return (!level || level <= 0 ? $555e85e43773c407$exports.encodeXML : $555e85e43773c407$exports.encodeHTML)(data);
}
$5f6deb2c0735ac56$exports.encode = $5f6deb2c0735ac56$var$encode;

Object.defineProperty($5f6deb2c0735ac56$exports, "encodeXML", {
    enumerable: true,
    get: function() {
        return $555e85e43773c407$exports.encodeXML;
    }
});
Object.defineProperty($5f6deb2c0735ac56$exports, "encodeHTML", {
    enumerable: true,
    get: function() {
        return $555e85e43773c407$exports.encodeHTML;
    }
});
Object.defineProperty($5f6deb2c0735ac56$exports, "encodeNonAsciiHTML", {
    enumerable: true,
    get: function() {
        return $555e85e43773c407$exports.encodeNonAsciiHTML;
    }
});
Object.defineProperty($5f6deb2c0735ac56$exports, "escape", {
    enumerable: true,
    get: function() {
        return $555e85e43773c407$exports.escape;
    }
});
Object.defineProperty($5f6deb2c0735ac56$exports, "escapeUTF8", {
    enumerable: true,
    get: function() {
        return $555e85e43773c407$exports.escapeUTF8;
    }
});
// Legacy aliases (deprecated)
Object.defineProperty($5f6deb2c0735ac56$exports, "encodeHTML4", {
    enumerable: true,
    get: function() {
        return $555e85e43773c407$exports.encodeHTML;
    }
});
Object.defineProperty($5f6deb2c0735ac56$exports, "encodeHTML5", {
    enumerable: true,
    get: function() {
        return $555e85e43773c407$exports.encodeHTML;
    }
});

Object.defineProperty($5f6deb2c0735ac56$exports, "decodeXML", {
    enumerable: true,
    get: function() {
        return $f51833765089d558$exports.decodeXML;
    }
});
Object.defineProperty($5f6deb2c0735ac56$exports, "decodeHTML", {
    enumerable: true,
    get: function() {
        return $f51833765089d558$exports.decodeHTML;
    }
});
Object.defineProperty($5f6deb2c0735ac56$exports, "decodeHTMLStrict", {
    enumerable: true,
    get: function() {
        return $f51833765089d558$exports.decodeHTMLStrict;
    }
});
// Legacy aliases (deprecated)
Object.defineProperty($5f6deb2c0735ac56$exports, "decodeHTML4", {
    enumerable: true,
    get: function() {
        return $f51833765089d558$exports.decodeHTML;
    }
});
Object.defineProperty($5f6deb2c0735ac56$exports, "decodeHTML5", {
    enumerable: true,
    get: function() {
        return $f51833765089d558$exports.decodeHTML;
    }
});
Object.defineProperty($5f6deb2c0735ac56$exports, "decodeHTML4Strict", {
    enumerable: true,
    get: function() {
        return $f51833765089d558$exports.decodeHTMLStrict;
    }
});
Object.defineProperty($5f6deb2c0735ac56$exports, "decodeHTML5Strict", {
    enumerable: true,
    get: function() {
        return $f51833765089d558$exports.decodeHTMLStrict;
    }
});
Object.defineProperty($5f6deb2c0735ac56$exports, "decodeXMLStrict", {
    enumerable: true,
    get: function() {
        return $f51833765089d558$exports.decodeXML;
    }
});


var $3519767cfc6fdeeb$export$98e6a39c04603d36;
var $3519767cfc6fdeeb$export$e4f0b40d01c251ab;
var $3519767cfc6fdeeb$export$2ca3eb0a2f8a693a;
var $3519767cfc6fdeeb$export$e31c2b05678acf26;
var $3519767cfc6fdeeb$export$54ffaacfc0931fb0;
var $3519767cfc6fdeeb$export$a22775fa5e2eebd9;
var $3519767cfc6fdeeb$export$30384b60aedf98a5;
var $3519767cfc6fdeeb$export$3a5cfc971f52ee31;
"use strict";
var $ef0918dddd13d48e$export$e31c2b05678acf26;
"use strict";

var $l8rQG = parcelRequire("l8rQG");
const $ef0918dddd13d48e$var$convertToJson = function(node, options, parentTagName) {
    const jObj = {};
    // when no child node or attr is present
    if ((!node.child || $l8rQG.isEmptyObject(node.child)) && (!node.attrsMap || $l8rQG.isEmptyObject(node.attrsMap))) return $l8rQG.isExist(node.val) ? node.val : "";
    // otherwise create a textnode if node has some text
    if ($l8rQG.isExist(node.val) && !(typeof node.val === "string" && (node.val === "" || node.val === options.cdataPositionChar))) {
        const asArray = $l8rQG.isTagNameInArrayMode(node.tagname, options.arrayMode, parentTagName);
        jObj[options.textNodeName] = asArray ? [
            node.val
        ] : node.val;
    }
    $l8rQG.merge(jObj, node.attrsMap, options.arrayMode);
    const keys = Object.keys(node.child);
    for(let index = 0; index < keys.length; index++){
        const tagName = keys[index];
        if (node.child[tagName] && node.child[tagName].length > 1) {
            jObj[tagName] = [];
            for(let tag in node.child[tagName])if (node.child[tagName].hasOwnProperty(tag)) jObj[tagName].push($ef0918dddd13d48e$var$convertToJson(node.child[tagName][tag], options, tagName));
        } else {
            const result = $ef0918dddd13d48e$var$convertToJson(node.child[tagName][0], options, tagName);
            const asArray = options.arrayMode === true && typeof result === "object" || $l8rQG.isTagNameInArrayMode(tagName, options.arrayMode, parentTagName);
            jObj[tagName] = asArray ? [
                result
            ] : result;
        }
    }
    //add value
    return jObj;
};
$ef0918dddd13d48e$export$e31c2b05678acf26 = $ef0918dddd13d48e$var$convertToJson;



var $21YsA = parcelRequire("21YsA");

var $21YsA = parcelRequire("21YsA");

var $l8rQG = parcelRequire("l8rQG");
var $3519767cfc6fdeeb$require$buildOptions = $l8rQG.buildOptions;
//const tagsPattern = new RegExp("<\\/?([\\w:\\-_\.]+)\\s*\/?>","g");
var $e6697f46f4a0942a$export$a22775fa5e2eebd9;
"use strict";

var $l8rQG = parcelRequire("l8rQG");
const $e6697f46f4a0942a$var$defaultOptions = {
    allowBooleanAttributes: false
};
const $e6697f46f4a0942a$var$props = [
    "allowBooleanAttributes"
];
$e6697f46f4a0942a$export$a22775fa5e2eebd9 = function(xmlData, options) {
    options = $l8rQG.buildOptions(options, $e6697f46f4a0942a$var$defaultOptions, $e6697f46f4a0942a$var$props);
    //xmlData = xmlData.replace(/(\r\n|\n|\r)/gm,"");//make it single line
    //xmlData = xmlData.replace(/(^\s*<\?xml.*?\?>)/g,"");//Remove XML starting tag
    //xmlData = xmlData.replace(/(<!DOCTYPE[\s\w\"\.\/\-\:]+(\[.*\])*\s*>)/g,"");//Remove DOCTYPE
    const tags = [];
    let tagFound = false;
    //indicates that the root tag has been closed (aka. depth 0 has been reached)
    let reachedRoot = false;
    if (xmlData[0] === "\uFEFF") // check for byte order mark (BOM)
    xmlData = xmlData.substr(1);
    for(let i = 0; i < xmlData.length; i++){
        if (xmlData[i] === "<" && xmlData[i + 1] === "?") {
            i += 2;
            i = $e6697f46f4a0942a$var$readPI(xmlData, i);
            if (i.err) return i;
        } else if (xmlData[i] === "<") {
            //starting of tag
            //read until you reach to '>' avoiding any '>' in attribute value
            i++;
            if (xmlData[i] === "!") {
                i = $e6697f46f4a0942a$var$readCommentAndCDATA(xmlData, i);
                continue;
            } else {
                let closingTag = false;
                if (xmlData[i] === "/") {
                    //closing tag
                    closingTag = true;
                    i++;
                }
                //read tagname
                let tagName = "";
                for(; i < xmlData.length && xmlData[i] !== ">" && xmlData[i] !== " " && xmlData[i] !== "	" && xmlData[i] !== "\n" && xmlData[i] !== "\r"; i++)tagName += xmlData[i];
                tagName = tagName.trim();
                //console.log(tagName);
                if (tagName[tagName.length - 1] === "/") {
                    //self closing tag without attributes
                    tagName = tagName.substring(0, tagName.length - 1);
                    //continue;
                    i--;
                }
                if (!$e6697f46f4a0942a$var$validateTagName(tagName)) {
                    let msg;
                    if (tagName.trim().length === 0) msg = "There is an unnecessary space between tag name and backward slash '</ ..'.";
                    else msg = "Tag '" + tagName + "' is an invalid name.";
                    return $e6697f46f4a0942a$var$getErrorObject("InvalidTag", msg, $e6697f46f4a0942a$var$getLineNumberForPosition(xmlData, i));
                }
                const result = $e6697f46f4a0942a$var$readAttributeStr(xmlData, i);
                if (result === false) return $e6697f46f4a0942a$var$getErrorObject("InvalidAttr", "Attributes for '" + tagName + "' have open quote.", $e6697f46f4a0942a$var$getLineNumberForPosition(xmlData, i));
                let attrStr = result.value;
                i = result.index;
                if (attrStr[attrStr.length - 1] === "/") {
                    //self closing tag
                    attrStr = attrStr.substring(0, attrStr.length - 1);
                    const isValid = $e6697f46f4a0942a$var$validateAttributeString(attrStr, options);
                    if (isValid === true) tagFound = true;
                    else //the result from the nested function returns the position of the error within the attribute
                    //in order to get the 'true' error line, we need to calculate the position where the attribute begins (i - attrStr.length) and then add the position within the attribute
                    //this gives us the absolute index in the entire xml, which we can use to find the line at last
                    return $e6697f46f4a0942a$var$getErrorObject(isValid.err.code, isValid.err.msg, $e6697f46f4a0942a$var$getLineNumberForPosition(xmlData, i - attrStr.length + isValid.err.line));
                } else if (closingTag) {
                    if (!result.tagClosed) return $e6697f46f4a0942a$var$getErrorObject("InvalidTag", "Closing tag '" + tagName + "' doesn't have proper closing.", $e6697f46f4a0942a$var$getLineNumberForPosition(xmlData, i));
                    else if (attrStr.trim().length > 0) return $e6697f46f4a0942a$var$getErrorObject("InvalidTag", "Closing tag '" + tagName + "' can't have attributes or invalid starting.", $e6697f46f4a0942a$var$getLineNumberForPosition(xmlData, i));
                    else {
                        const otg = tags.pop();
                        if (tagName !== otg) return $e6697f46f4a0942a$var$getErrorObject("InvalidTag", "Closing tag '" + otg + "' is expected inplace of '" + tagName + "'.", $e6697f46f4a0942a$var$getLineNumberForPosition(xmlData, i));
                        //when there are no more tags, we reached the root level.
                        if (tags.length == 0) reachedRoot = true;
                    }
                } else {
                    const isValid = $e6697f46f4a0942a$var$validateAttributeString(attrStr, options);
                    if (isValid !== true) //the result from the nested function returns the position of the error within the attribute
                    //in order to get the 'true' error line, we need to calculate the position where the attribute begins (i - attrStr.length) and then add the position within the attribute
                    //this gives us the absolute index in the entire xml, which we can use to find the line at last
                    return $e6697f46f4a0942a$var$getErrorObject(isValid.err.code, isValid.err.msg, $e6697f46f4a0942a$var$getLineNumberForPosition(xmlData, i - attrStr.length + isValid.err.line));
                    //if the root level has been reached before ...
                    if (reachedRoot === true) return $e6697f46f4a0942a$var$getErrorObject("InvalidXml", "Multiple possible root nodes found.", $e6697f46f4a0942a$var$getLineNumberForPosition(xmlData, i));
                    else tags.push(tagName);
                    tagFound = true;
                }
                //skip tag text value
                //It may include comments and CDATA value
                for(i++; i < xmlData.length; i++){
                    if (xmlData[i] === "<") {
                        if (xmlData[i + 1] === "!") {
                            //comment or CADATA
                            i++;
                            i = $e6697f46f4a0942a$var$readCommentAndCDATA(xmlData, i);
                            continue;
                        } else if (xmlData[i + 1] === "?") {
                            i = $e6697f46f4a0942a$var$readPI(xmlData, ++i);
                            if (i.err) return i;
                        } else break;
                    } else if (xmlData[i] === "&") {
                        const afterAmp = $e6697f46f4a0942a$var$validateAmpersand(xmlData, i);
                        if (afterAmp == -1) return $e6697f46f4a0942a$var$getErrorObject("InvalidChar", "char '&' is not expected.", $e6697f46f4a0942a$var$getLineNumberForPosition(xmlData, i));
                        i = afterAmp;
                    }
                } //end of reading tag text value
                if (xmlData[i] === "<") i--;
            }
        } else {
            if (xmlData[i] === " " || xmlData[i] === "	" || xmlData[i] === "\n" || xmlData[i] === "\r") continue;
            return $e6697f46f4a0942a$var$getErrorObject("InvalidChar", "char '" + xmlData[i] + "' is not expected.", $e6697f46f4a0942a$var$getLineNumberForPosition(xmlData, i));
        }
    }
    if (!tagFound) return $e6697f46f4a0942a$var$getErrorObject("InvalidXml", "Start tag expected.", 1);
    else if (tags.length > 0) return $e6697f46f4a0942a$var$getErrorObject("InvalidXml", "Invalid '" + JSON.stringify(tags, null, 4).replace(/\r?\n/g, "") + "' found.", 1);
    return true;
};
/**
 * Read Processing insstructions and skip
 * @param {*} xmlData
 * @param {*} i
 */ function $e6697f46f4a0942a$var$readPI(xmlData, i) {
    var start = i;
    for(; i < xmlData.length; i++)if (xmlData[i] == "?" || xmlData[i] == " ") {
        //tagname
        var tagname = xmlData.substr(start, i - start);
        if (i > 5 && tagname === "xml") return $e6697f46f4a0942a$var$getErrorObject("InvalidXml", "XML declaration allowed only at the start of the document.", $e6697f46f4a0942a$var$getLineNumberForPosition(xmlData, i));
        else if (xmlData[i] == "?" && xmlData[i + 1] == ">") {
            //check if valid attribut string
            i++;
            break;
        } else continue;
    }
    return i;
}
function $e6697f46f4a0942a$var$readCommentAndCDATA(xmlData, i) {
    if (xmlData.length > i + 5 && xmlData[i + 1] === "-" && xmlData[i + 2] === "-") {
        //comment
        for(i += 3; i < xmlData.length; i++)if (xmlData[i] === "-" && xmlData[i + 1] === "-" && xmlData[i + 2] === ">") {
            i += 2;
            break;
        }
    } else if (xmlData.length > i + 8 && xmlData[i + 1] === "D" && xmlData[i + 2] === "O" && xmlData[i + 3] === "C" && xmlData[i + 4] === "T" && xmlData[i + 5] === "Y" && xmlData[i + 6] === "P" && xmlData[i + 7] === "E") {
        let angleBracketsCount = 1;
        for(i += 8; i < xmlData.length; i++){
            if (xmlData[i] === "<") angleBracketsCount++;
            else if (xmlData[i] === ">") {
                angleBracketsCount--;
                if (angleBracketsCount === 0) break;
            }
        }
    } else if (xmlData.length > i + 9 && xmlData[i + 1] === "[" && xmlData[i + 2] === "C" && xmlData[i + 3] === "D" && xmlData[i + 4] === "A" && xmlData[i + 5] === "T" && xmlData[i + 6] === "A" && xmlData[i + 7] === "[") {
        for(i += 8; i < xmlData.length; i++)if (xmlData[i] === "]" && xmlData[i + 1] === "]" && xmlData[i + 2] === ">") {
            i += 2;
            break;
        }
    }
    return i;
}
var $e6697f46f4a0942a$var$doubleQuote = '"';
var $e6697f46f4a0942a$var$singleQuote = "'";
/**
 * Keep reading xmlData until '<' is found outside the attribute value.
 * @param {string} xmlData
 * @param {number} i
 */ function $e6697f46f4a0942a$var$readAttributeStr(xmlData, i) {
    let attrStr = "";
    let startChar = "";
    let tagClosed = false;
    for(; i < xmlData.length; i++){
        if (xmlData[i] === $e6697f46f4a0942a$var$doubleQuote || xmlData[i] === $e6697f46f4a0942a$var$singleQuote) {
            if (startChar === "") startChar = xmlData[i];
            else if (startChar !== xmlData[i]) continue;
            else startChar = "";
        } else if (xmlData[i] === ">") {
            if (startChar === "") {
                tagClosed = true;
                break;
            }
        }
        attrStr += xmlData[i];
    }
    if (startChar !== "") return false;
    return {
        value: attrStr,
        index: i,
        tagClosed: tagClosed
    };
}
/**
 * Select all the attributes whether valid or invalid.
 */ const $e6697f46f4a0942a$var$validAttrStrRegxp = new RegExp("(\\s*)([^\\s=]+)(\\s*=)?(\\s*(['\"])(([\\s\\S])*?)\\5)?", "g");
//attr, ="sd", a="amit's", a="sd"b="saf", ab  cd=""
function $e6697f46f4a0942a$var$validateAttributeString(attrStr, options) {
    //console.log("start:"+attrStr+":end");
    //if(attrStr.trim().length === 0) return true; //empty string
    const matches = $l8rQG.getAllMatches(attrStr, $e6697f46f4a0942a$var$validAttrStrRegxp);
    const attrNames = {};
    for(let i = 0; i < matches.length; i++){
        if (matches[i][1].length === 0) //nospace before attribute name: a="sd"b="saf"
        return $e6697f46f4a0942a$var$getErrorObject("InvalidAttr", "Attribute '" + matches[i][2] + "' has no space in starting.", $e6697f46f4a0942a$var$getPositionFromMatch(attrStr, matches[i][0]));
        else if (matches[i][3] === undefined && !options.allowBooleanAttributes) //independent attribute: ab
        return $e6697f46f4a0942a$var$getErrorObject("InvalidAttr", "boolean attribute '" + matches[i][2] + "' is not allowed.", $e6697f46f4a0942a$var$getPositionFromMatch(attrStr, matches[i][0]));
        /* else if(matches[i][6] === undefined){//attribute without value: ab=
                    return { err: { code:"InvalidAttr",msg:"attribute " + matches[i][2] + " has no value assigned."}};
                } */ const attrName = matches[i][2];
        if (!$e6697f46f4a0942a$var$validateAttrName(attrName)) return $e6697f46f4a0942a$var$getErrorObject("InvalidAttr", "Attribute '" + attrName + "' is an invalid name.", $e6697f46f4a0942a$var$getPositionFromMatch(attrStr, matches[i][0]));
        if (!attrNames.hasOwnProperty(attrName)) //check for duplicate attribute.
        attrNames[attrName] = 1;
        else return $e6697f46f4a0942a$var$getErrorObject("InvalidAttr", "Attribute '" + attrName + "' is repeated.", $e6697f46f4a0942a$var$getPositionFromMatch(attrStr, matches[i][0]));
    }
    return true;
}
function $e6697f46f4a0942a$var$validateNumberAmpersand(xmlData, i) {
    let re = /\d/;
    if (xmlData[i] === "x") {
        i++;
        re = /[\da-fA-F]/;
    }
    for(; i < xmlData.length; i++){
        if (xmlData[i] === ";") return i;
        if (!xmlData[i].match(re)) break;
    }
    return -1;
}
function $e6697f46f4a0942a$var$validateAmpersand(xmlData, i) {
    // https://www.w3.org/TR/xml/#dt-charref
    i++;
    if (xmlData[i] === ";") return -1;
    if (xmlData[i] === "#") {
        i++;
        return $e6697f46f4a0942a$var$validateNumberAmpersand(xmlData, i);
    }
    let count = 0;
    for(; i < xmlData.length; i++, count++){
        if (xmlData[i].match(/\w/) && count < 20) continue;
        if (xmlData[i] === ";") break;
        return -1;
    }
    return i;
}
function $e6697f46f4a0942a$var$getErrorObject(code, message, lineNumber) {
    return {
        err: {
            code: code,
            msg: message,
            line: lineNumber
        }
    };
}
function $e6697f46f4a0942a$var$validateAttrName(attrName) {
    return $l8rQG.isName(attrName);
}
// const startsWithXML = /^xml/i;
function $e6697f46f4a0942a$var$validateTagName(tagname) {
    return $l8rQG.isName(tagname) /* && !tagname.match(startsWithXML) */ ;
}
//this function returns the line number for the character at the given index
function $e6697f46f4a0942a$var$getLineNumberForPosition(xmlData, index) {
    var lines = xmlData.substring(0, index).split(/\r?\n/);
    return lines.length;
}
//this function returns the position of the last character of match within attrStr
function $e6697f46f4a0942a$var$getPositionFromMatch(attrStr, match) {
    return attrStr.indexOf(match) + match.length;
}


$3519767cfc6fdeeb$export$98e6a39c04603d36 = function(xmlData, options, validationOption) {
    if (validationOption) {
        if (validationOption === true) validationOption = {};
        const result = $e6697f46f4a0942a$export$a22775fa5e2eebd9(xmlData, validationOption);
        if (result !== true) throw Error(result.err.msg);
    }
    options = $3519767cfc6fdeeb$require$buildOptions(options, $21YsA.defaultOptions, $21YsA.props);
    const traversableObj = $21YsA.getTraversalObj(xmlData, options);
    //print(traversableObj, "  ");
    return $ef0918dddd13d48e$export$e31c2b05678acf26(traversableObj, options);
};

$3519767cfc6fdeeb$export$e4f0b40d01c251ab = (parcelRequire("9CiNR")).convert2nimn;
$3519767cfc6fdeeb$export$2ca3eb0a2f8a693a = $21YsA.getTraversalObj;
$3519767cfc6fdeeb$export$e31c2b05678acf26 = $ef0918dddd13d48e$export$e31c2b05678acf26;

$3519767cfc6fdeeb$export$54ffaacfc0931fb0 = (parcelRequire("ajMmB")).convertToJsonString;
$3519767cfc6fdeeb$export$a22775fa5e2eebd9 = $e6697f46f4a0942a$export$a22775fa5e2eebd9;

$3519767cfc6fdeeb$export$30384b60aedf98a5 = (parcelRequire("gnljR"));
$3519767cfc6fdeeb$export$3a5cfc971f52ee31 = function(xmlData, schema, options) {
    return $3519767cfc6fdeeb$export$e4f0b40d01c251ab($3519767cfc6fdeeb$export$2ca3eb0a2f8a693a(xmlData, options), schema, options);
};
function $3519767cfc6fdeeb$var$print(xmlNode, indentation) {
    if (xmlNode) {
        console.log(indentation + "{");
        console.log(indentation + '  "tagName": "' + xmlNode.tagname + '", ');
        if (xmlNode.parent) console.log(indentation + '  "parent": "' + xmlNode.parent.tagname + '", ');
        console.log(indentation + '  "val": "' + xmlNode.val + '", ');
        console.log(indentation + '  "attrs": ' + JSON.stringify(xmlNode.attrsMap, null, 4) + ", ");
        if (xmlNode.child) {
            console.log(indentation + '"child": {');
            const indentation2 = indentation + indentation;
            Object.keys(xmlNode.child).forEach(function(key) {
                const node = xmlNode.child[key];
                if (Array.isArray(node)) {
                    console.log(indentation + '"' + key + '" :[');
                    node.forEach(function(item, index) {
                        //console.log(indentation + " \""+index+"\" : [")
                        $3519767cfc6fdeeb$var$print(item, indentation2);
                    });
                    console.log(indentation + "],");
                } else {
                    console.log(indentation + ' "' + key + '" : {');
                    $3519767cfc6fdeeb$var$print(node, indentation2);
                    console.log(indentation + "},");
                }
            });
            console.log(indentation + "},");
        }
        console.log(indentation + "},");
    }
}




var $e1011dd782da33d8$export$5e1c701bcca9e239 = function(input, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            headers = {
                "content-type": "application/x-www-form-urlencoded"
            };
            body = $e1011dd782da33d8$var$buildFormUrlencodedString((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, $e1011dd782da33d8$var$serializeAws_queryAddPermissionInput(input, context)), {
                Action: "AddPermission",
                Version: "2010-03-31"
            }));
            return [
                2,
                $e1011dd782da33d8$var$buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var $e1011dd782da33d8$export$8e572143947888e9 = function(input, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            headers = {
                "content-type": "application/x-www-form-urlencoded"
            };
            body = $e1011dd782da33d8$var$buildFormUrlencodedString((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, $e1011dd782da33d8$var$serializeAws_queryCheckIfPhoneNumberIsOptedOutInput(input, context)), {
                Action: "CheckIfPhoneNumberIsOptedOut",
                Version: "2010-03-31"
            }));
            return [
                2,
                $e1011dd782da33d8$var$buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var $e1011dd782da33d8$export$36248b73c92dc131 = function(input, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            headers = {
                "content-type": "application/x-www-form-urlencoded"
            };
            body = $e1011dd782da33d8$var$buildFormUrlencodedString((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, $e1011dd782da33d8$var$serializeAws_queryConfirmSubscriptionInput(input, context)), {
                Action: "ConfirmSubscription",
                Version: "2010-03-31"
            }));
            return [
                2,
                $e1011dd782da33d8$var$buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var $e1011dd782da33d8$export$189381df5dfb557 = function(input, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            headers = {
                "content-type": "application/x-www-form-urlencoded"
            };
            body = $e1011dd782da33d8$var$buildFormUrlencodedString((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, $e1011dd782da33d8$var$serializeAws_queryCreatePlatformApplicationInput(input, context)), {
                Action: "CreatePlatformApplication",
                Version: "2010-03-31"
            }));
            return [
                2,
                $e1011dd782da33d8$var$buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var $e1011dd782da33d8$export$85bb5182f82a0beb = function(input, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            headers = {
                "content-type": "application/x-www-form-urlencoded"
            };
            body = $e1011dd782da33d8$var$buildFormUrlencodedString((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, $e1011dd782da33d8$var$serializeAws_queryCreatePlatformEndpointInput(input, context)), {
                Action: "CreatePlatformEndpoint",
                Version: "2010-03-31"
            }));
            return [
                2,
                $e1011dd782da33d8$var$buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var $e1011dd782da33d8$export$36f7e76321242dee = function(input, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            headers = {
                "content-type": "application/x-www-form-urlencoded"
            };
            body = $e1011dd782da33d8$var$buildFormUrlencodedString((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, $e1011dd782da33d8$var$serializeAws_queryCreateSMSSandboxPhoneNumberInput(input, context)), {
                Action: "CreateSMSSandboxPhoneNumber",
                Version: "2010-03-31"
            }));
            return [
                2,
                $e1011dd782da33d8$var$buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var $e1011dd782da33d8$export$3b955ea642276a57 = function(input, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            headers = {
                "content-type": "application/x-www-form-urlencoded"
            };
            body = $e1011dd782da33d8$var$buildFormUrlencodedString((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, $e1011dd782da33d8$var$serializeAws_queryCreateTopicInput(input, context)), {
                Action: "CreateTopic",
                Version: "2010-03-31"
            }));
            return [
                2,
                $e1011dd782da33d8$var$buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var $e1011dd782da33d8$export$aa1f6077aee195d9 = function(input, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            headers = {
                "content-type": "application/x-www-form-urlencoded"
            };
            body = $e1011dd782da33d8$var$buildFormUrlencodedString((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, $e1011dd782da33d8$var$serializeAws_queryDeleteEndpointInput(input, context)), {
                Action: "DeleteEndpoint",
                Version: "2010-03-31"
            }));
            return [
                2,
                $e1011dd782da33d8$var$buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var $e1011dd782da33d8$export$298f6dfe21b347c0 = function(input, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            headers = {
                "content-type": "application/x-www-form-urlencoded"
            };
            body = $e1011dd782da33d8$var$buildFormUrlencodedString((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, $e1011dd782da33d8$var$serializeAws_queryDeletePlatformApplicationInput(input, context)), {
                Action: "DeletePlatformApplication",
                Version: "2010-03-31"
            }));
            return [
                2,
                $e1011dd782da33d8$var$buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var $e1011dd782da33d8$export$9f6ad976976e3ebb = function(input, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            headers = {
                "content-type": "application/x-www-form-urlencoded"
            };
            body = $e1011dd782da33d8$var$buildFormUrlencodedString((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, $e1011dd782da33d8$var$serializeAws_queryDeleteSMSSandboxPhoneNumberInput(input, context)), {
                Action: "DeleteSMSSandboxPhoneNumber",
                Version: "2010-03-31"
            }));
            return [
                2,
                $e1011dd782da33d8$var$buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var $e1011dd782da33d8$export$87b7aee880eed12b = function(input, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            headers = {
                "content-type": "application/x-www-form-urlencoded"
            };
            body = $e1011dd782da33d8$var$buildFormUrlencodedString((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, $e1011dd782da33d8$var$serializeAws_queryDeleteTopicInput(input, context)), {
                Action: "DeleteTopic",
                Version: "2010-03-31"
            }));
            return [
                2,
                $e1011dd782da33d8$var$buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var $e1011dd782da33d8$export$bf67789d098d8da8 = function(input, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            headers = {
                "content-type": "application/x-www-form-urlencoded"
            };
            body = $e1011dd782da33d8$var$buildFormUrlencodedString((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, $e1011dd782da33d8$var$serializeAws_queryGetEndpointAttributesInput(input, context)), {
                Action: "GetEndpointAttributes",
                Version: "2010-03-31"
            }));
            return [
                2,
                $e1011dd782da33d8$var$buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var $e1011dd782da33d8$export$7eb35af7f91727b4 = function(input, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            headers = {
                "content-type": "application/x-www-form-urlencoded"
            };
            body = $e1011dd782da33d8$var$buildFormUrlencodedString((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, $e1011dd782da33d8$var$serializeAws_queryGetPlatformApplicationAttributesInput(input, context)), {
                Action: "GetPlatformApplicationAttributes",
                Version: "2010-03-31"
            }));
            return [
                2,
                $e1011dd782da33d8$var$buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var $e1011dd782da33d8$export$de78a9916adcb865 = function(input, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            headers = {
                "content-type": "application/x-www-form-urlencoded"
            };
            body = $e1011dd782da33d8$var$buildFormUrlencodedString((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, $e1011dd782da33d8$var$serializeAws_queryGetSMSAttributesInput(input, context)), {
                Action: "GetSMSAttributes",
                Version: "2010-03-31"
            }));
            return [
                2,
                $e1011dd782da33d8$var$buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var $e1011dd782da33d8$export$9db0492333a3f388 = function(input, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            headers = {
                "content-type": "application/x-www-form-urlencoded"
            };
            body = $e1011dd782da33d8$var$buildFormUrlencodedString((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, $e1011dd782da33d8$var$serializeAws_queryGetSMSSandboxAccountStatusInput(input, context)), {
                Action: "GetSMSSandboxAccountStatus",
                Version: "2010-03-31"
            }));
            return [
                2,
                $e1011dd782da33d8$var$buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var $e1011dd782da33d8$export$ec2413734c4ef75b = function(input, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            headers = {
                "content-type": "application/x-www-form-urlencoded"
            };
            body = $e1011dd782da33d8$var$buildFormUrlencodedString((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, $e1011dd782da33d8$var$serializeAws_queryGetSubscriptionAttributesInput(input, context)), {
                Action: "GetSubscriptionAttributes",
                Version: "2010-03-31"
            }));
            return [
                2,
                $e1011dd782da33d8$var$buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var $e1011dd782da33d8$export$ff293c7b127a82e1 = function(input, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            headers = {
                "content-type": "application/x-www-form-urlencoded"
            };
            body = $e1011dd782da33d8$var$buildFormUrlencodedString((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, $e1011dd782da33d8$var$serializeAws_queryGetTopicAttributesInput(input, context)), {
                Action: "GetTopicAttributes",
                Version: "2010-03-31"
            }));
            return [
                2,
                $e1011dd782da33d8$var$buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var $e1011dd782da33d8$export$b7741ffc59ab5e72 = function(input, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            headers = {
                "content-type": "application/x-www-form-urlencoded"
            };
            body = $e1011dd782da33d8$var$buildFormUrlencodedString((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, $e1011dd782da33d8$var$serializeAws_queryListEndpointsByPlatformApplicationInput(input, context)), {
                Action: "ListEndpointsByPlatformApplication",
                Version: "2010-03-31"
            }));
            return [
                2,
                $e1011dd782da33d8$var$buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var $e1011dd782da33d8$export$22340840b6685dab = function(input, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            headers = {
                "content-type": "application/x-www-form-urlencoded"
            };
            body = $e1011dd782da33d8$var$buildFormUrlencodedString((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, $e1011dd782da33d8$var$serializeAws_queryListOriginationNumbersRequest(input, context)), {
                Action: "ListOriginationNumbers",
                Version: "2010-03-31"
            }));
            return [
                2,
                $e1011dd782da33d8$var$buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var $e1011dd782da33d8$export$5024944f877eea0 = function(input, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            headers = {
                "content-type": "application/x-www-form-urlencoded"
            };
            body = $e1011dd782da33d8$var$buildFormUrlencodedString((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, $e1011dd782da33d8$var$serializeAws_queryListPhoneNumbersOptedOutInput(input, context)), {
                Action: "ListPhoneNumbersOptedOut",
                Version: "2010-03-31"
            }));
            return [
                2,
                $e1011dd782da33d8$var$buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var $e1011dd782da33d8$export$5593b4c672fcc45e = function(input, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            headers = {
                "content-type": "application/x-www-form-urlencoded"
            };
            body = $e1011dd782da33d8$var$buildFormUrlencodedString((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, $e1011dd782da33d8$var$serializeAws_queryListPlatformApplicationsInput(input, context)), {
                Action: "ListPlatformApplications",
                Version: "2010-03-31"
            }));
            return [
                2,
                $e1011dd782da33d8$var$buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var $e1011dd782da33d8$export$3861d43a8341e3d6 = function(input, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            headers = {
                "content-type": "application/x-www-form-urlencoded"
            };
            body = $e1011dd782da33d8$var$buildFormUrlencodedString((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, $e1011dd782da33d8$var$serializeAws_queryListSMSSandboxPhoneNumbersInput(input, context)), {
                Action: "ListSMSSandboxPhoneNumbers",
                Version: "2010-03-31"
            }));
            return [
                2,
                $e1011dd782da33d8$var$buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var $e1011dd782da33d8$export$6c161147dd523549 = function(input, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            headers = {
                "content-type": "application/x-www-form-urlencoded"
            };
            body = $e1011dd782da33d8$var$buildFormUrlencodedString((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, $e1011dd782da33d8$var$serializeAws_queryListSubscriptionsInput(input, context)), {
                Action: "ListSubscriptions",
                Version: "2010-03-31"
            }));
            return [
                2,
                $e1011dd782da33d8$var$buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var $e1011dd782da33d8$export$d067eed485abd23b = function(input, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            headers = {
                "content-type": "application/x-www-form-urlencoded"
            };
            body = $e1011dd782da33d8$var$buildFormUrlencodedString((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, $e1011dd782da33d8$var$serializeAws_queryListSubscriptionsByTopicInput(input, context)), {
                Action: "ListSubscriptionsByTopic",
                Version: "2010-03-31"
            }));
            return [
                2,
                $e1011dd782da33d8$var$buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var $e1011dd782da33d8$export$83cb143d8d0818d0 = function(input, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            headers = {
                "content-type": "application/x-www-form-urlencoded"
            };
            body = $e1011dd782da33d8$var$buildFormUrlencodedString((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, $e1011dd782da33d8$var$serializeAws_queryListTagsForResourceRequest(input, context)), {
                Action: "ListTagsForResource",
                Version: "2010-03-31"
            }));
            return [
                2,
                $e1011dd782da33d8$var$buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var $e1011dd782da33d8$export$736cde842d73f28e = function(input, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            headers = {
                "content-type": "application/x-www-form-urlencoded"
            };
            body = $e1011dd782da33d8$var$buildFormUrlencodedString((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, $e1011dd782da33d8$var$serializeAws_queryListTopicsInput(input, context)), {
                Action: "ListTopics",
                Version: "2010-03-31"
            }));
            return [
                2,
                $e1011dd782da33d8$var$buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var $e1011dd782da33d8$export$7cc4f2fe4eb4e6a0 = function(input, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            headers = {
                "content-type": "application/x-www-form-urlencoded"
            };
            body = $e1011dd782da33d8$var$buildFormUrlencodedString((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, $e1011dd782da33d8$var$serializeAws_queryOptInPhoneNumberInput(input, context)), {
                Action: "OptInPhoneNumber",
                Version: "2010-03-31"
            }));
            return [
                2,
                $e1011dd782da33d8$var$buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var $e1011dd782da33d8$export$c930eaec46d8a919 = function(input, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            headers = {
                "content-type": "application/x-www-form-urlencoded"
            };
            body = $e1011dd782da33d8$var$buildFormUrlencodedString((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, $e1011dd782da33d8$var$serializeAws_queryPublishInput(input, context)), {
                Action: "Publish",
                Version: "2010-03-31"
            }));
            return [
                2,
                $e1011dd782da33d8$var$buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var $e1011dd782da33d8$export$2d3c59d0b4e6f509 = function(input, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            headers = {
                "content-type": "application/x-www-form-urlencoded"
            };
            body = $e1011dd782da33d8$var$buildFormUrlencodedString((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, $e1011dd782da33d8$var$serializeAws_queryPublishBatchInput(input, context)), {
                Action: "PublishBatch",
                Version: "2010-03-31"
            }));
            return [
                2,
                $e1011dd782da33d8$var$buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var $e1011dd782da33d8$export$2b6f84ef5cd90da9 = function(input, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            headers = {
                "content-type": "application/x-www-form-urlencoded"
            };
            body = $e1011dd782da33d8$var$buildFormUrlencodedString((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, $e1011dd782da33d8$var$serializeAws_queryRemovePermissionInput(input, context)), {
                Action: "RemovePermission",
                Version: "2010-03-31"
            }));
            return [
                2,
                $e1011dd782da33d8$var$buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var $e1011dd782da33d8$export$998a009e0fc64c9 = function(input, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            headers = {
                "content-type": "application/x-www-form-urlencoded"
            };
            body = $e1011dd782da33d8$var$buildFormUrlencodedString((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, $e1011dd782da33d8$var$serializeAws_querySetEndpointAttributesInput(input, context)), {
                Action: "SetEndpointAttributes",
                Version: "2010-03-31"
            }));
            return [
                2,
                $e1011dd782da33d8$var$buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var $e1011dd782da33d8$export$cccac62f9da99ce5 = function(input, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            headers = {
                "content-type": "application/x-www-form-urlencoded"
            };
            body = $e1011dd782da33d8$var$buildFormUrlencodedString((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, $e1011dd782da33d8$var$serializeAws_querySetPlatformApplicationAttributesInput(input, context)), {
                Action: "SetPlatformApplicationAttributes",
                Version: "2010-03-31"
            }));
            return [
                2,
                $e1011dd782da33d8$var$buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var $e1011dd782da33d8$export$5e838ded65853ab0 = function(input, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            headers = {
                "content-type": "application/x-www-form-urlencoded"
            };
            body = $e1011dd782da33d8$var$buildFormUrlencodedString((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, $e1011dd782da33d8$var$serializeAws_querySetSMSAttributesInput(input, context)), {
                Action: "SetSMSAttributes",
                Version: "2010-03-31"
            }));
            return [
                2,
                $e1011dd782da33d8$var$buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var $e1011dd782da33d8$export$2a130e9e3af77e3c = function(input, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            headers = {
                "content-type": "application/x-www-form-urlencoded"
            };
            body = $e1011dd782da33d8$var$buildFormUrlencodedString((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, $e1011dd782da33d8$var$serializeAws_querySetSubscriptionAttributesInput(input, context)), {
                Action: "SetSubscriptionAttributes",
                Version: "2010-03-31"
            }));
            return [
                2,
                $e1011dd782da33d8$var$buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var $e1011dd782da33d8$export$2b38af771a758c1f = function(input, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            headers = {
                "content-type": "application/x-www-form-urlencoded"
            };
            body = $e1011dd782da33d8$var$buildFormUrlencodedString((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, $e1011dd782da33d8$var$serializeAws_querySetTopicAttributesInput(input, context)), {
                Action: "SetTopicAttributes",
                Version: "2010-03-31"
            }));
            return [
                2,
                $e1011dd782da33d8$var$buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var $e1011dd782da33d8$export$173ec7fde6458173 = function(input, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            headers = {
                "content-type": "application/x-www-form-urlencoded"
            };
            body = $e1011dd782da33d8$var$buildFormUrlencodedString((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, $e1011dd782da33d8$var$serializeAws_querySubscribeInput(input, context)), {
                Action: "Subscribe",
                Version: "2010-03-31"
            }));
            return [
                2,
                $e1011dd782da33d8$var$buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var $e1011dd782da33d8$export$323bd4786cabb3cd = function(input, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            headers = {
                "content-type": "application/x-www-form-urlencoded"
            };
            body = $e1011dd782da33d8$var$buildFormUrlencodedString((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, $e1011dd782da33d8$var$serializeAws_queryTagResourceRequest(input, context)), {
                Action: "TagResource",
                Version: "2010-03-31"
            }));
            return [
                2,
                $e1011dd782da33d8$var$buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var $e1011dd782da33d8$export$89501b717322844b = function(input, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            headers = {
                "content-type": "application/x-www-form-urlencoded"
            };
            body = $e1011dd782da33d8$var$buildFormUrlencodedString((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, $e1011dd782da33d8$var$serializeAws_queryUnsubscribeInput(input, context)), {
                Action: "Unsubscribe",
                Version: "2010-03-31"
            }));
            return [
                2,
                $e1011dd782da33d8$var$buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var $e1011dd782da33d8$export$16230cfe527563f3 = function(input, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            headers = {
                "content-type": "application/x-www-form-urlencoded"
            };
            body = $e1011dd782da33d8$var$buildFormUrlencodedString((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, $e1011dd782da33d8$var$serializeAws_queryUntagResourceRequest(input, context)), {
                Action: "UntagResource",
                Version: "2010-03-31"
            }));
            return [
                2,
                $e1011dd782da33d8$var$buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var $e1011dd782da33d8$export$593eb61d8f68059f = function(input, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            headers = {
                "content-type": "application/x-www-form-urlencoded"
            };
            body = $e1011dd782da33d8$var$buildFormUrlencodedString((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, $e1011dd782da33d8$var$serializeAws_queryVerifySMSSandboxPhoneNumberInput(input, context)), {
                Action: "VerifySMSSandboxPhoneNumber",
                Version: "2010-03-31"
            }));
            return [
                2,
                $e1011dd782da33d8$var$buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var $e1011dd782da33d8$export$ea55d58cc182ce71 = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var response;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2,
                        $e1011dd782da33d8$var$deserializeAws_queryAddPermissionCommandError(output, context)
                    ];
                    return [
                        4,
                        $e1011dd782da33d8$var$collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    response = {
                        $metadata: $e1011dd782da33d8$var$deserializeMetadata(output)
                    };
                    return [
                        2,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var $e1011dd782da33d8$var$deserializeAws_queryAddPermissionCommandError = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, parsedBody;
        var _c;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_d) {
            switch(_d.label){
                case 0:
                    _a = [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, output)
                    ];
                    _c = {};
                    return [
                        4,
                        $e1011dd782da33d8$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_c.body = _d.sent(), _c)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $e1011dd782da33d8$var$loadQueryErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "AuthorizationErrorException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.sns#AuthorizationErrorException":
                            return [
                                3,
                                2
                            ];
                        case "InternalErrorException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.sns#InternalErrorException":
                            return [
                                3,
                                4
                            ];
                        case "InvalidParameterException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.sns#InvalidParameterException":
                            return [
                                3,
                                6
                            ];
                        case "NotFoundException":
                            return [
                                3,
                                8
                            ];
                        case "com.amazonaws.sns#NotFoundException":
                            return [
                                3,
                                8
                            ];
                    }
                    return [
                        3,
                        10
                    ];
                case 2:
                    return [
                        4,
                        $e1011dd782da33d8$var$deserializeAws_queryAuthorizationErrorExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    throw _d.sent();
                case 4:
                    return [
                        4,
                        $e1011dd782da33d8$var$deserializeAws_queryInternalErrorExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    throw _d.sent();
                case 6:
                    return [
                        4,
                        $e1011dd782da33d8$var$deserializeAws_queryInvalidParameterExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    throw _d.sent();
                case 8:
                    return [
                        4,
                        $e1011dd782da33d8$var$deserializeAws_queryNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    throw _d.sent();
                case 10:
                    parsedBody = parsedOutput.body;
                    response = new (0, $411eb8c425b27262$export$6ce7aba8257a989c)({
                        name: parsedBody.Error.code || parsedBody.Error.Code || errorCode,
                        $fault: "client",
                        $metadata: $e1011dd782da33d8$var$deserializeMetadata(output)
                    });
                    throw (0, $a08c2c31e27e9e11$export$db01f0c43e877a50)(response, parsedBody.Error);
            }
        });
    });
};
var $e1011dd782da33d8$export$8073c2d8de3e2bae = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2,
                        $e1011dd782da33d8$var$deserializeAws_queryCheckIfPhoneNumberIsOptedOutCommandError(output, context)
                    ];
                    return [
                        4,
                        $e1011dd782da33d8$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = $e1011dd782da33d8$var$deserializeAws_queryCheckIfPhoneNumberIsOptedOutResponse(data.CheckIfPhoneNumberIsOptedOutResult, context);
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
                        $metadata: $e1011dd782da33d8$var$deserializeMetadata(output)
                    }, contents);
                    return [
                        2,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var $e1011dd782da33d8$var$deserializeAws_queryCheckIfPhoneNumberIsOptedOutCommandError = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, parsedBody;
        var _c;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_d) {
            switch(_d.label){
                case 0:
                    _a = [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, output)
                    ];
                    _c = {};
                    return [
                        4,
                        $e1011dd782da33d8$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_c.body = _d.sent(), _c)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $e1011dd782da33d8$var$loadQueryErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "AuthorizationErrorException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.sns#AuthorizationErrorException":
                            return [
                                3,
                                2
                            ];
                        case "InternalErrorException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.sns#InternalErrorException":
                            return [
                                3,
                                4
                            ];
                        case "InvalidParameterException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.sns#InvalidParameterException":
                            return [
                                3,
                                6
                            ];
                        case "ThrottledException":
                            return [
                                3,
                                8
                            ];
                        case "com.amazonaws.sns#ThrottledException":
                            return [
                                3,
                                8
                            ];
                    }
                    return [
                        3,
                        10
                    ];
                case 2:
                    return [
                        4,
                        $e1011dd782da33d8$var$deserializeAws_queryAuthorizationErrorExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    throw _d.sent();
                case 4:
                    return [
                        4,
                        $e1011dd782da33d8$var$deserializeAws_queryInternalErrorExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    throw _d.sent();
                case 6:
                    return [
                        4,
                        $e1011dd782da33d8$var$deserializeAws_queryInvalidParameterExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    throw _d.sent();
                case 8:
                    return [
                        4,
                        $e1011dd782da33d8$var$deserializeAws_queryThrottledExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    throw _d.sent();
                case 10:
                    parsedBody = parsedOutput.body;
                    response = new (0, $411eb8c425b27262$export$6ce7aba8257a989c)({
                        name: parsedBody.Error.code || parsedBody.Error.Code || errorCode,
                        $fault: "client",
                        $metadata: $e1011dd782da33d8$var$deserializeMetadata(output)
                    });
                    throw (0, $a08c2c31e27e9e11$export$db01f0c43e877a50)(response, parsedBody.Error);
            }
        });
    });
};
var $e1011dd782da33d8$export$b001bf31a04763ef = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2,
                        $e1011dd782da33d8$var$deserializeAws_queryConfirmSubscriptionCommandError(output, context)
                    ];
                    return [
                        4,
                        $e1011dd782da33d8$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = $e1011dd782da33d8$var$deserializeAws_queryConfirmSubscriptionResponse(data.ConfirmSubscriptionResult, context);
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
                        $metadata: $e1011dd782da33d8$var$deserializeMetadata(output)
                    }, contents);
                    return [
                        2,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var $e1011dd782da33d8$var$deserializeAws_queryConfirmSubscriptionCommandError = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, parsedBody;
        var _c;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_d) {
            switch(_d.label){
                case 0:
                    _a = [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, output)
                    ];
                    _c = {};
                    return [
                        4,
                        $e1011dd782da33d8$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_c.body = _d.sent(), _c)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $e1011dd782da33d8$var$loadQueryErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "AuthorizationErrorException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.sns#AuthorizationErrorException":
                            return [
                                3,
                                2
                            ];
                        case "FilterPolicyLimitExceededException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.sns#FilterPolicyLimitExceededException":
                            return [
                                3,
                                4
                            ];
                        case "InternalErrorException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.sns#InternalErrorException":
                            return [
                                3,
                                6
                            ];
                        case "InvalidParameterException":
                            return [
                                3,
                                8
                            ];
                        case "com.amazonaws.sns#InvalidParameterException":
                            return [
                                3,
                                8
                            ];
                        case "NotFoundException":
                            return [
                                3,
                                10
                            ];
                        case "com.amazonaws.sns#NotFoundException":
                            return [
                                3,
                                10
                            ];
                        case "SubscriptionLimitExceededException":
                            return [
                                3,
                                12
                            ];
                        case "com.amazonaws.sns#SubscriptionLimitExceededException":
                            return [
                                3,
                                12
                            ];
                    }
                    return [
                        3,
                        14
                    ];
                case 2:
                    return [
                        4,
                        $e1011dd782da33d8$var$deserializeAws_queryAuthorizationErrorExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    throw _d.sent();
                case 4:
                    return [
                        4,
                        $e1011dd782da33d8$var$deserializeAws_queryFilterPolicyLimitExceededExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    throw _d.sent();
                case 6:
                    return [
                        4,
                        $e1011dd782da33d8$var$deserializeAws_queryInternalErrorExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    throw _d.sent();
                case 8:
                    return [
                        4,
                        $e1011dd782da33d8$var$deserializeAws_queryInvalidParameterExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    throw _d.sent();
                case 10:
                    return [
                        4,
                        $e1011dd782da33d8$var$deserializeAws_queryNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    throw _d.sent();
                case 12:
                    return [
                        4,
                        $e1011dd782da33d8$var$deserializeAws_querySubscriptionLimitExceededExceptionResponse(parsedOutput, context)
                    ];
                case 13:
                    throw _d.sent();
                case 14:
                    parsedBody = parsedOutput.body;
                    response = new (0, $411eb8c425b27262$export$6ce7aba8257a989c)({
                        name: parsedBody.Error.code || parsedBody.Error.Code || errorCode,
                        $fault: "client",
                        $metadata: $e1011dd782da33d8$var$deserializeMetadata(output)
                    });
                    throw (0, $a08c2c31e27e9e11$export$db01f0c43e877a50)(response, parsedBody.Error);
            }
        });
    });
};
var $e1011dd782da33d8$export$3e206c9d482a2d62 = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2,
                        $e1011dd782da33d8$var$deserializeAws_queryCreatePlatformApplicationCommandError(output, context)
                    ];
                    return [
                        4,
                        $e1011dd782da33d8$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = $e1011dd782da33d8$var$deserializeAws_queryCreatePlatformApplicationResponse(data.CreatePlatformApplicationResult, context);
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
                        $metadata: $e1011dd782da33d8$var$deserializeMetadata(output)
                    }, contents);
                    return [
                        2,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var $e1011dd782da33d8$var$deserializeAws_queryCreatePlatformApplicationCommandError = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, parsedBody;
        var _c;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_d) {
            switch(_d.label){
                case 0:
                    _a = [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, output)
                    ];
                    _c = {};
                    return [
                        4,
                        $e1011dd782da33d8$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_c.body = _d.sent(), _c)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $e1011dd782da33d8$var$loadQueryErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "AuthorizationErrorException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.sns#AuthorizationErrorException":
                            return [
                                3,
                                2
                            ];
                        case "InternalErrorException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.sns#InternalErrorException":
                            return [
                                3,
                                4
                            ];
                        case "InvalidParameterException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.sns#InvalidParameterException":
                            return [
                                3,
                                6
                            ];
                    }
                    return [
                        3,
                        8
                    ];
                case 2:
                    return [
                        4,
                        $e1011dd782da33d8$var$deserializeAws_queryAuthorizationErrorExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    throw _d.sent();
                case 4:
                    return [
                        4,
                        $e1011dd782da33d8$var$deserializeAws_queryInternalErrorExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    throw _d.sent();
                case 6:
                    return [
                        4,
                        $e1011dd782da33d8$var$deserializeAws_queryInvalidParameterExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    throw _d.sent();
                case 8:
                    parsedBody = parsedOutput.body;
                    response = new (0, $411eb8c425b27262$export$6ce7aba8257a989c)({
                        name: parsedBody.Error.code || parsedBody.Error.Code || errorCode,
                        $fault: "client",
                        $metadata: $e1011dd782da33d8$var$deserializeMetadata(output)
                    });
                    throw (0, $a08c2c31e27e9e11$export$db01f0c43e877a50)(response, parsedBody.Error);
            }
        });
    });
};
var $e1011dd782da33d8$export$5ddbe2995927146d = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2,
                        $e1011dd782da33d8$var$deserializeAws_queryCreatePlatformEndpointCommandError(output, context)
                    ];
                    return [
                        4,
                        $e1011dd782da33d8$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = $e1011dd782da33d8$var$deserializeAws_queryCreateEndpointResponse(data.CreatePlatformEndpointResult, context);
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
                        $metadata: $e1011dd782da33d8$var$deserializeMetadata(output)
                    }, contents);
                    return [
                        2,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var $e1011dd782da33d8$var$deserializeAws_queryCreatePlatformEndpointCommandError = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, parsedBody;
        var _c;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_d) {
            switch(_d.label){
                case 0:
                    _a = [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, output)
                    ];
                    _c = {};
                    return [
                        4,
                        $e1011dd782da33d8$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_c.body = _d.sent(), _c)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $e1011dd782da33d8$var$loadQueryErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "AuthorizationErrorException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.sns#AuthorizationErrorException":
                            return [
                                3,
                                2
                            ];
                        case "InternalErrorException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.sns#InternalErrorException":
                            return [
                                3,
                                4
                            ];
                        case "InvalidParameterException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.sns#InvalidParameterException":
                            return [
                                3,
                                6
                            ];
                        case "NotFoundException":
                            return [
                                3,
                                8
                            ];
                        case "com.amazonaws.sns#NotFoundException":
                            return [
                                3,
                                8
                            ];
                    }
                    return [
                        3,
                        10
                    ];
                case 2:
                    return [
                        4,
                        $e1011dd782da33d8$var$deserializeAws_queryAuthorizationErrorExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    throw _d.sent();
                case 4:
                    return [
                        4,
                        $e1011dd782da33d8$var$deserializeAws_queryInternalErrorExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    throw _d.sent();
                case 6:
                    return [
                        4,
                        $e1011dd782da33d8$var$deserializeAws_queryInvalidParameterExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    throw _d.sent();
                case 8:
                    return [
                        4,
                        $e1011dd782da33d8$var$deserializeAws_queryNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    throw _d.sent();
                case 10:
                    parsedBody = parsedOutput.body;
                    response = new (0, $411eb8c425b27262$export$6ce7aba8257a989c)({
                        name: parsedBody.Error.code || parsedBody.Error.Code || errorCode,
                        $fault: "client",
                        $metadata: $e1011dd782da33d8$var$deserializeMetadata(output)
                    });
                    throw (0, $a08c2c31e27e9e11$export$db01f0c43e877a50)(response, parsedBody.Error);
            }
        });
    });
};
var $e1011dd782da33d8$export$7e9f9d0992eb5c01 = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2,
                        $e1011dd782da33d8$var$deserializeAws_queryCreateSMSSandboxPhoneNumberCommandError(output, context)
                    ];
                    return [
                        4,
                        $e1011dd782da33d8$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = $e1011dd782da33d8$var$deserializeAws_queryCreateSMSSandboxPhoneNumberResult(data.CreateSMSSandboxPhoneNumberResult, context);
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
                        $metadata: $e1011dd782da33d8$var$deserializeMetadata(output)
                    }, contents);
                    return [
                        2,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var $e1011dd782da33d8$var$deserializeAws_queryCreateSMSSandboxPhoneNumberCommandError = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, parsedBody;
        var _c;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_d) {
            switch(_d.label){
                case 0:
                    _a = [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, output)
                    ];
                    _c = {};
                    return [
                        4,
                        $e1011dd782da33d8$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_c.body = _d.sent(), _c)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $e1011dd782da33d8$var$loadQueryErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "AuthorizationErrorException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.sns#AuthorizationErrorException":
                            return [
                                3,
                                2
                            ];
                        case "InternalErrorException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.sns#InternalErrorException":
                            return [
                                3,
                                4
                            ];
                        case "InvalidParameterException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.sns#InvalidParameterException":
                            return [
                                3,
                                6
                            ];
                        case "OptedOutException":
                            return [
                                3,
                                8
                            ];
                        case "com.amazonaws.sns#OptedOutException":
                            return [
                                3,
                                8
                            ];
                        case "ThrottledException":
                            return [
                                3,
                                10
                            ];
                        case "com.amazonaws.sns#ThrottledException":
                            return [
                                3,
                                10
                            ];
                        case "UserErrorException":
                            return [
                                3,
                                12
                            ];
                        case "com.amazonaws.sns#UserErrorException":
                            return [
                                3,
                                12
                            ];
                    }
                    return [
                        3,
                        14
                    ];
                case 2:
                    return [
                        4,
                        $e1011dd782da33d8$var$deserializeAws_queryAuthorizationErrorExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    throw _d.sent();
                case 4:
                    return [
                        4,
                        $e1011dd782da33d8$var$deserializeAws_queryInternalErrorExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    throw _d.sent();
                case 6:
                    return [
                        4,
                        $e1011dd782da33d8$var$deserializeAws_queryInvalidParameterExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    throw _d.sent();
                case 8:
                    return [
                        4,
                        $e1011dd782da33d8$var$deserializeAws_queryOptedOutExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    throw _d.sent();
                case 10:
                    return [
                        4,
                        $e1011dd782da33d8$var$deserializeAws_queryThrottledExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    throw _d.sent();
                case 12:
                    return [
                        4,
                        $e1011dd782da33d8$var$deserializeAws_queryUserErrorExceptionResponse(parsedOutput, context)
                    ];
                case 13:
                    throw _d.sent();
                case 14:
                    parsedBody = parsedOutput.body;
                    response = new (0, $411eb8c425b27262$export$6ce7aba8257a989c)({
                        name: parsedBody.Error.code || parsedBody.Error.Code || errorCode,
                        $fault: "client",
                        $metadata: $e1011dd782da33d8$var$deserializeMetadata(output)
                    });
                    throw (0, $a08c2c31e27e9e11$export$db01f0c43e877a50)(response, parsedBody.Error);
            }
        });
    });
};
var $e1011dd782da33d8$export$dc7c2f931d3ffa05 = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2,
                        $e1011dd782da33d8$var$deserializeAws_queryCreateTopicCommandError(output, context)
                    ];
                    return [
                        4,
                        $e1011dd782da33d8$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = $e1011dd782da33d8$var$deserializeAws_queryCreateTopicResponse(data.CreateTopicResult, context);
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
                        $metadata: $e1011dd782da33d8$var$deserializeMetadata(output)
                    }, contents);
                    return [
                        2,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var $e1011dd782da33d8$var$deserializeAws_queryCreateTopicCommandError = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, parsedBody;
        var _c;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_d) {
            switch(_d.label){
                case 0:
                    _a = [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, output)
                    ];
                    _c = {};
                    return [
                        4,
                        $e1011dd782da33d8$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_c.body = _d.sent(), _c)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $e1011dd782da33d8$var$loadQueryErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "AuthorizationErrorException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.sns#AuthorizationErrorException":
                            return [
                                3,
                                2
                            ];
                        case "ConcurrentAccessException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.sns#ConcurrentAccessException":
                            return [
                                3,
                                4
                            ];
                        case "InternalErrorException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.sns#InternalErrorException":
                            return [
                                3,
                                6
                            ];
                        case "InvalidParameterException":
                            return [
                                3,
                                8
                            ];
                        case "com.amazonaws.sns#InvalidParameterException":
                            return [
                                3,
                                8
                            ];
                        case "InvalidSecurityException":
                            return [
                                3,
                                10
                            ];
                        case "com.amazonaws.sns#InvalidSecurityException":
                            return [
                                3,
                                10
                            ];
                        case "StaleTagException":
                            return [
                                3,
                                12
                            ];
                        case "com.amazonaws.sns#StaleTagException":
                            return [
                                3,
                                12
                            ];
                        case "TagLimitExceededException":
                            return [
                                3,
                                14
                            ];
                        case "com.amazonaws.sns#TagLimitExceededException":
                            return [
                                3,
                                14
                            ];
                        case "TagPolicyException":
                            return [
                                3,
                                16
                            ];
                        case "com.amazonaws.sns#TagPolicyException":
                            return [
                                3,
                                16
                            ];
                        case "TopicLimitExceededException":
                            return [
                                3,
                                18
                            ];
                        case "com.amazonaws.sns#TopicLimitExceededException":
                            return [
                                3,
                                18
                            ];
                    }
                    return [
                        3,
                        20
                    ];
                case 2:
                    return [
                        4,
                        $e1011dd782da33d8$var$deserializeAws_queryAuthorizationErrorExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    throw _d.sent();
                case 4:
                    return [
                        4,
                        $e1011dd782da33d8$var$deserializeAws_queryConcurrentAccessExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    throw _d.sent();
                case 6:
                    return [
                        4,
                        $e1011dd782da33d8$var$deserializeAws_queryInternalErrorExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    throw _d.sent();
                case 8:
                    return [
                        4,
                        $e1011dd782da33d8$var$deserializeAws_queryInvalidParameterExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    throw _d.sent();
                case 10:
                    return [
                        4,
                        $e1011dd782da33d8$var$deserializeAws_queryInvalidSecurityExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    throw _d.sent();
                case 12:
                    return [
                        4,
                        $e1011dd782da33d8$var$deserializeAws_queryStaleTagExceptionResponse(parsedOutput, context)
                    ];
                case 13:
                    throw _d.sent();
                case 14:
                    return [
                        4,
                        $e1011dd782da33d8$var$deserializeAws_queryTagLimitExceededExceptionResponse(parsedOutput, context)
                    ];
                case 15:
                    throw _d.sent();
                case 16:
                    return [
                        4,
                        $e1011dd782da33d8$var$deserializeAws_queryTagPolicyExceptionResponse(parsedOutput, context)
                    ];
                case 17:
                    throw _d.sent();
                case 18:
                    return [
                        4,
                        $e1011dd782da33d8$var$deserializeAws_queryTopicLimitExceededExceptionResponse(parsedOutput, context)
                    ];
                case 19:
                    throw _d.sent();
                case 20:
                    parsedBody = parsedOutput.body;
                    response = new (0, $411eb8c425b27262$export$6ce7aba8257a989c)({
                        name: parsedBody.Error.code || parsedBody.Error.Code || errorCode,
                        $fault: "client",
                        $metadata: $e1011dd782da33d8$var$deserializeMetadata(output)
                    });
                    throw (0, $a08c2c31e27e9e11$export$db01f0c43e877a50)(response, parsedBody.Error);
            }
        });
    });
};
var $e1011dd782da33d8$export$241fdf71b91a4cdc = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var response;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2,
                        $e1011dd782da33d8$var$deserializeAws_queryDeleteEndpointCommandError(output, context)
                    ];
                    return [
                        4,
                        $e1011dd782da33d8$var$collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    response = {
                        $metadata: $e1011dd782da33d8$var$deserializeMetadata(output)
                    };
                    return [
                        2,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var $e1011dd782da33d8$var$deserializeAws_queryDeleteEndpointCommandError = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, parsedBody;
        var _c;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_d) {
            switch(_d.label){
                case 0:
                    _a = [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, output)
                    ];
                    _c = {};
                    return [
                        4,
                        $e1011dd782da33d8$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_c.body = _d.sent(), _c)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $e1011dd782da33d8$var$loadQueryErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "AuthorizationErrorException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.sns#AuthorizationErrorException":
                            return [
                                3,
                                2
                            ];
                        case "InternalErrorException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.sns#InternalErrorException":
                            return [
                                3,
                                4
                            ];
                        case "InvalidParameterException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.sns#InvalidParameterException":
                            return [
                                3,
                                6
                            ];
                    }
                    return [
                        3,
                        8
                    ];
                case 2:
                    return [
                        4,
                        $e1011dd782da33d8$var$deserializeAws_queryAuthorizationErrorExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    throw _d.sent();
                case 4:
                    return [
                        4,
                        $e1011dd782da33d8$var$deserializeAws_queryInternalErrorExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    throw _d.sent();
                case 6:
                    return [
                        4,
                        $e1011dd782da33d8$var$deserializeAws_queryInvalidParameterExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    throw _d.sent();
                case 8:
                    parsedBody = parsedOutput.body;
                    response = new (0, $411eb8c425b27262$export$6ce7aba8257a989c)({
                        name: parsedBody.Error.code || parsedBody.Error.Code || errorCode,
                        $fault: "client",
                        $metadata: $e1011dd782da33d8$var$deserializeMetadata(output)
                    });
                    throw (0, $a08c2c31e27e9e11$export$db01f0c43e877a50)(response, parsedBody.Error);
            }
        });
    });
};
var $e1011dd782da33d8$export$6b6810e4a5d44f1a = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var response;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2,
                        $e1011dd782da33d8$var$deserializeAws_queryDeletePlatformApplicationCommandError(output, context)
                    ];
                    return [
                        4,
                        $e1011dd782da33d8$var$collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    response = {
                        $metadata: $e1011dd782da33d8$var$deserializeMetadata(output)
                    };
                    return [
                        2,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var $e1011dd782da33d8$var$deserializeAws_queryDeletePlatformApplicationCommandError = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, parsedBody;
        var _c;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_d) {
            switch(_d.label){
                case 0:
                    _a = [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, output)
                    ];
                    _c = {};
                    return [
                        4,
                        $e1011dd782da33d8$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_c.body = _d.sent(), _c)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $e1011dd782da33d8$var$loadQueryErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "AuthorizationErrorException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.sns#AuthorizationErrorException":
                            return [
                                3,
                                2
                            ];
                        case "InternalErrorException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.sns#InternalErrorException":
                            return [
                                3,
                                4
                            ];
                        case "InvalidParameterException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.sns#InvalidParameterException":
                            return [
                                3,
                                6
                            ];
                    }
                    return [
                        3,
                        8
                    ];
                case 2:
                    return [
                        4,
                        $e1011dd782da33d8$var$deserializeAws_queryAuthorizationErrorExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    throw _d.sent();
                case 4:
                    return [
                        4,
                        $e1011dd782da33d8$var$deserializeAws_queryInternalErrorExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    throw _d.sent();
                case 6:
                    return [
                        4,
                        $e1011dd782da33d8$var$deserializeAws_queryInvalidParameterExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    throw _d.sent();
                case 8:
                    parsedBody = parsedOutput.body;
                    response = new (0, $411eb8c425b27262$export$6ce7aba8257a989c)({
                        name: parsedBody.Error.code || parsedBody.Error.Code || errorCode,
                        $fault: "client",
                        $metadata: $e1011dd782da33d8$var$deserializeMetadata(output)
                    });
                    throw (0, $a08c2c31e27e9e11$export$db01f0c43e877a50)(response, parsedBody.Error);
            }
        });
    });
};
var $e1011dd782da33d8$export$3fbb2ea6c873e501 = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2,
                        $e1011dd782da33d8$var$deserializeAws_queryDeleteSMSSandboxPhoneNumberCommandError(output, context)
                    ];
                    return [
                        4,
                        $e1011dd782da33d8$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = $e1011dd782da33d8$var$deserializeAws_queryDeleteSMSSandboxPhoneNumberResult(data.DeleteSMSSandboxPhoneNumberResult, context);
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
                        $metadata: $e1011dd782da33d8$var$deserializeMetadata(output)
                    }, contents);
                    return [
                        2,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var $e1011dd782da33d8$var$deserializeAws_queryDeleteSMSSandboxPhoneNumberCommandError = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, parsedBody;
        var _c;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_d) {
            switch(_d.label){
                case 0:
                    _a = [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, output)
                    ];
                    _c = {};
                    return [
                        4,
                        $e1011dd782da33d8$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_c.body = _d.sent(), _c)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $e1011dd782da33d8$var$loadQueryErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "AuthorizationErrorException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.sns#AuthorizationErrorException":
                            return [
                                3,
                                2
                            ];
                        case "InternalErrorException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.sns#InternalErrorException":
                            return [
                                3,
                                4
                            ];
                        case "InvalidParameterException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.sns#InvalidParameterException":
                            return [
                                3,
                                6
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3,
                                8
                            ];
                        case "com.amazonaws.sns#ResourceNotFoundException":
                            return [
                                3,
                                8
                            ];
                        case "ThrottledException":
                            return [
                                3,
                                10
                            ];
                        case "com.amazonaws.sns#ThrottledException":
                            return [
                                3,
                                10
                            ];
                        case "UserErrorException":
                            return [
                                3,
                                12
                            ];
                        case "com.amazonaws.sns#UserErrorException":
                            return [
                                3,
                                12
                            ];
                    }
                    return [
                        3,
                        14
                    ];
                case 2:
                    return [
                        4,
                        $e1011dd782da33d8$var$deserializeAws_queryAuthorizationErrorExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    throw _d.sent();
                case 4:
                    return [
                        4,
                        $e1011dd782da33d8$var$deserializeAws_queryInternalErrorExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    throw _d.sent();
                case 6:
                    return [
                        4,
                        $e1011dd782da33d8$var$deserializeAws_queryInvalidParameterExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    throw _d.sent();
                case 8:
                    return [
                        4,
                        $e1011dd782da33d8$var$deserializeAws_queryResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    throw _d.sent();
                case 10:
                    return [
                        4,
                        $e1011dd782da33d8$var$deserializeAws_queryThrottledExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    throw _d.sent();
                case 12:
                    return [
                        4,
                        $e1011dd782da33d8$var$deserializeAws_queryUserErrorExceptionResponse(parsedOutput, context)
                    ];
                case 13:
                    throw _d.sent();
                case 14:
                    parsedBody = parsedOutput.body;
                    response = new (0, $411eb8c425b27262$export$6ce7aba8257a989c)({
                        name: parsedBody.Error.code || parsedBody.Error.Code || errorCode,
                        $fault: "client",
                        $metadata: $e1011dd782da33d8$var$deserializeMetadata(output)
                    });
                    throw (0, $a08c2c31e27e9e11$export$db01f0c43e877a50)(response, parsedBody.Error);
            }
        });
    });
};
var $e1011dd782da33d8$export$9a02a2a888a23786 = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var response;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2,
                        $e1011dd782da33d8$var$deserializeAws_queryDeleteTopicCommandError(output, context)
                    ];
                    return [
                        4,
                        $e1011dd782da33d8$var$collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    response = {
                        $metadata: $e1011dd782da33d8$var$deserializeMetadata(output)
                    };
                    return [
                        2,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var $e1011dd782da33d8$var$deserializeAws_queryDeleteTopicCommandError = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, parsedBody;
        var _c;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_d) {
            switch(_d.label){
                case 0:
                    _a = [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, output)
                    ];
                    _c = {};
                    return [
                        4,
                        $e1011dd782da33d8$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_c.body = _d.sent(), _c)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $e1011dd782da33d8$var$loadQueryErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "AuthorizationErrorException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.sns#AuthorizationErrorException":
                            return [
                                3,
                                2
                            ];
                        case "ConcurrentAccessException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.sns#ConcurrentAccessException":
                            return [
                                3,
                                4
                            ];
                        case "InternalErrorException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.sns#InternalErrorException":
                            return [
                                3,
                                6
                            ];
                        case "InvalidParameterException":
                            return [
                                3,
                                8
                            ];
                        case "com.amazonaws.sns#InvalidParameterException":
                            return [
                                3,
                                8
                            ];
                        case "NotFoundException":
                            return [
                                3,
                                10
                            ];
                        case "com.amazonaws.sns#NotFoundException":
                            return [
                                3,
                                10
                            ];
                        case "StaleTagException":
                            return [
                                3,
                                12
                            ];
                        case "com.amazonaws.sns#StaleTagException":
                            return [
                                3,
                                12
                            ];
                        case "TagPolicyException":
                            return [
                                3,
                                14
                            ];
                        case "com.amazonaws.sns#TagPolicyException":
                            return [
                                3,
                                14
                            ];
                    }
                    return [
                        3,
                        16
                    ];
                case 2:
                    return [
                        4,
                        $e1011dd782da33d8$var$deserializeAws_queryAuthorizationErrorExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    throw _d.sent();
                case 4:
                    return [
                        4,
                        $e1011dd782da33d8$var$deserializeAws_queryConcurrentAccessExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    throw _d.sent();
                case 6:
                    return [
                        4,
                        $e1011dd782da33d8$var$deserializeAws_queryInternalErrorExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    throw _d.sent();
                case 8:
                    return [
                        4,
                        $e1011dd782da33d8$var$deserializeAws_queryInvalidParameterExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    throw _d.sent();
                case 10:
                    return [
                        4,
                        $e1011dd782da33d8$var$deserializeAws_queryNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    throw _d.sent();
                case 12:
                    return [
                        4,
                        $e1011dd782da33d8$var$deserializeAws_queryStaleTagExceptionResponse(parsedOutput, context)
                    ];
                case 13:
                    throw _d.sent();
                case 14:
                    return [
                        4,
                        $e1011dd782da33d8$var$deserializeAws_queryTagPolicyExceptionResponse(parsedOutput, context)
                    ];
                case 15:
                    throw _d.sent();
                case 16:
                    parsedBody = parsedOutput.body;
                    response = new (0, $411eb8c425b27262$export$6ce7aba8257a989c)({
                        name: parsedBody.Error.code || parsedBody.Error.Code || errorCode,
                        $fault: "client",
                        $metadata: $e1011dd782da33d8$var$deserializeMetadata(output)
                    });
                    throw (0, $a08c2c31e27e9e11$export$db01f0c43e877a50)(response, parsedBody.Error);
            }
        });
    });
};
var $e1011dd782da33d8$export$4a88c575f40334f0 = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2,
                        $e1011dd782da33d8$var$deserializeAws_queryGetEndpointAttributesCommandError(output, context)
                    ];
                    return [
                        4,
                        $e1011dd782da33d8$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = $e1011dd782da33d8$var$deserializeAws_queryGetEndpointAttributesResponse(data.GetEndpointAttributesResult, context);
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
                        $metadata: $e1011dd782da33d8$var$deserializeMetadata(output)
                    }, contents);
                    return [
                        2,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var $e1011dd782da33d8$var$deserializeAws_queryGetEndpointAttributesCommandError = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, parsedBody;
        var _c;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_d) {
            switch(_d.label){
                case 0:
                    _a = [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, output)
                    ];
                    _c = {};
                    return [
                        4,
                        $e1011dd782da33d8$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_c.body = _d.sent(), _c)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $e1011dd782da33d8$var$loadQueryErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "AuthorizationErrorException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.sns#AuthorizationErrorException":
                            return [
                                3,
                                2
                            ];
                        case "InternalErrorException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.sns#InternalErrorException":
                            return [
                                3,
                                4
                            ];
                        case "InvalidParameterException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.sns#InvalidParameterException":
                            return [
                                3,
                                6
                            ];
                        case "NotFoundException":
                            return [
                                3,
                                8
                            ];
                        case "com.amazonaws.sns#NotFoundException":
                            return [
                                3,
                                8
                            ];
                    }
                    return [
                        3,
                        10
                    ];
                case 2:
                    return [
                        4,
                        $e1011dd782da33d8$var$deserializeAws_queryAuthorizationErrorExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    throw _d.sent();
                case 4:
                    return [
                        4,
                        $e1011dd782da33d8$var$deserializeAws_queryInternalErrorExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    throw _d.sent();
                case 6:
                    return [
                        4,
                        $e1011dd782da33d8$var$deserializeAws_queryInvalidParameterExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    throw _d.sent();
                case 8:
                    return [
                        4,
                        $e1011dd782da33d8$var$deserializeAws_queryNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    throw _d.sent();
                case 10:
                    parsedBody = parsedOutput.body;
                    response = new (0, $411eb8c425b27262$export$6ce7aba8257a989c)({
                        name: parsedBody.Error.code || parsedBody.Error.Code || errorCode,
                        $fault: "client",
                        $metadata: $e1011dd782da33d8$var$deserializeMetadata(output)
                    });
                    throw (0, $a08c2c31e27e9e11$export$db01f0c43e877a50)(response, parsedBody.Error);
            }
        });
    });
};
var $e1011dd782da33d8$export$1e516efec322355c = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2,
                        $e1011dd782da33d8$var$deserializeAws_queryGetPlatformApplicationAttributesCommandError(output, context)
                    ];
                    return [
                        4,
                        $e1011dd782da33d8$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = $e1011dd782da33d8$var$deserializeAws_queryGetPlatformApplicationAttributesResponse(data.GetPlatformApplicationAttributesResult, context);
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
                        $metadata: $e1011dd782da33d8$var$deserializeMetadata(output)
                    }, contents);
                    return [
                        2,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var $e1011dd782da33d8$var$deserializeAws_queryGetPlatformApplicationAttributesCommandError = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, parsedBody;
        var _c;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_d) {
            switch(_d.label){
                case 0:
                    _a = [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, output)
                    ];
                    _c = {};
                    return [
                        4,
                        $e1011dd782da33d8$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_c.body = _d.sent(), _c)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $e1011dd782da33d8$var$loadQueryErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "AuthorizationErrorException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.sns#AuthorizationErrorException":
                            return [
                                3,
                                2
                            ];
                        case "InternalErrorException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.sns#InternalErrorException":
                            return [
                                3,
                                4
                            ];
                        case "InvalidParameterException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.sns#InvalidParameterException":
                            return [
                                3,
                                6
                            ];
                        case "NotFoundException":
                            return [
                                3,
                                8
                            ];
                        case "com.amazonaws.sns#NotFoundException":
                            return [
                                3,
                                8
                            ];
                    }
                    return [
                        3,
                        10
                    ];
                case 2:
                    return [
                        4,
                        $e1011dd782da33d8$var$deserializeAws_queryAuthorizationErrorExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    throw _d.sent();
                case 4:
                    return [
                        4,
                        $e1011dd782da33d8$var$deserializeAws_queryInternalErrorExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    throw _d.sent();
                case 6:
                    return [
                        4,
                        $e1011dd782da33d8$var$deserializeAws_queryInvalidParameterExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    throw _d.sent();
                case 8:
                    return [
                        4,
                        $e1011dd782da33d8$var$deserializeAws_queryNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    throw _d.sent();
                case 10:
                    parsedBody = parsedOutput.body;
                    response = new (0, $411eb8c425b27262$export$6ce7aba8257a989c)({
                        name: parsedBody.Error.code || parsedBody.Error.Code || errorCode,
                        $fault: "client",
                        $metadata: $e1011dd782da33d8$var$deserializeMetadata(output)
                    });
                    throw (0, $a08c2c31e27e9e11$export$db01f0c43e877a50)(response, parsedBody.Error);
            }
        });
    });
};
var $e1011dd782da33d8$export$b0344c761363dcc4 = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2,
                        $e1011dd782da33d8$var$deserializeAws_queryGetSMSAttributesCommandError(output, context)
                    ];
                    return [
                        4,
                        $e1011dd782da33d8$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = $e1011dd782da33d8$var$deserializeAws_queryGetSMSAttributesResponse(data.GetSMSAttributesResult, context);
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
                        $metadata: $e1011dd782da33d8$var$deserializeMetadata(output)
                    }, contents);
                    return [
                        2,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var $e1011dd782da33d8$var$deserializeAws_queryGetSMSAttributesCommandError = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, parsedBody;
        var _c;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_d) {
            switch(_d.label){
                case 0:
                    _a = [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, output)
                    ];
                    _c = {};
                    return [
                        4,
                        $e1011dd782da33d8$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_c.body = _d.sent(), _c)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $e1011dd782da33d8$var$loadQueryErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "AuthorizationErrorException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.sns#AuthorizationErrorException":
                            return [
                                3,
                                2
                            ];
                        case "InternalErrorException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.sns#InternalErrorException":
                            return [
                                3,
                                4
                            ];
                        case "InvalidParameterException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.sns#InvalidParameterException":
                            return [
                                3,
                                6
                            ];
                        case "ThrottledException":
                            return [
                                3,
                                8
                            ];
                        case "com.amazonaws.sns#ThrottledException":
                            return [
                                3,
                                8
                            ];
                    }
                    return [
                        3,
                        10
                    ];
                case 2:
                    return [
                        4,
                        $e1011dd782da33d8$var$deserializeAws_queryAuthorizationErrorExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    throw _d.sent();
                case 4:
                    return [
                        4,
                        $e1011dd782da33d8$var$deserializeAws_queryInternalErrorExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    throw _d.sent();
                case 6:
                    return [
                        4,
                        $e1011dd782da33d8$var$deserializeAws_queryInvalidParameterExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    throw _d.sent();
                case 8:
                    return [
                        4,
                        $e1011dd782da33d8$var$deserializeAws_queryThrottledExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    throw _d.sent();
                case 10:
                    parsedBody = parsedOutput.body;
                    response = new (0, $411eb8c425b27262$export$6ce7aba8257a989c)({
                        name: parsedBody.Error.code || parsedBody.Error.Code || errorCode,
                        $fault: "client",
                        $metadata: $e1011dd782da33d8$var$deserializeMetadata(output)
                    });
                    throw (0, $a08c2c31e27e9e11$export$db01f0c43e877a50)(response, parsedBody.Error);
            }
        });
    });
};
var $e1011dd782da33d8$export$395ab9ee6248186d = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2,
                        $e1011dd782da33d8$var$deserializeAws_queryGetSMSSandboxAccountStatusCommandError(output, context)
                    ];
                    return [
                        4,
                        $e1011dd782da33d8$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = $e1011dd782da33d8$var$deserializeAws_queryGetSMSSandboxAccountStatusResult(data.GetSMSSandboxAccountStatusResult, context);
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
                        $metadata: $e1011dd782da33d8$var$deserializeMetadata(output)
                    }, contents);
                    return [
                        2,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var $e1011dd782da33d8$var$deserializeAws_queryGetSMSSandboxAccountStatusCommandError = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, parsedBody;
        var _c;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_d) {
            switch(_d.label){
                case 0:
                    _a = [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, output)
                    ];
                    _c = {};
                    return [
                        4,
                        $e1011dd782da33d8$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_c.body = _d.sent(), _c)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $e1011dd782da33d8$var$loadQueryErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "AuthorizationErrorException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.sns#AuthorizationErrorException":
                            return [
                                3,
                                2
                            ];
                        case "InternalErrorException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.sns#InternalErrorException":
                            return [
                                3,
                                4
                            ];
                        case "ThrottledException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.sns#ThrottledException":
                            return [
                                3,
                                6
                            ];
                    }
                    return [
                        3,
                        8
                    ];
                case 2:
                    return [
                        4,
                        $e1011dd782da33d8$var$deserializeAws_queryAuthorizationErrorExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    throw _d.sent();
                case 4:
                    return [
                        4,
                        $e1011dd782da33d8$var$deserializeAws_queryInternalErrorExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    throw _d.sent();
                case 6:
                    return [
                        4,
                        $e1011dd782da33d8$var$deserializeAws_queryThrottledExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    throw _d.sent();
                case 8:
                    parsedBody = parsedOutput.body;
                    response = new (0, $411eb8c425b27262$export$6ce7aba8257a989c)({
                        name: parsedBody.Error.code || parsedBody.Error.Code || errorCode,
                        $fault: "client",
                        $metadata: $e1011dd782da33d8$var$deserializeMetadata(output)
                    });
                    throw (0, $a08c2c31e27e9e11$export$db01f0c43e877a50)(response, parsedBody.Error);
            }
        });
    });
};
var $e1011dd782da33d8$export$8904fe36a77b487b = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2,
                        $e1011dd782da33d8$var$deserializeAws_queryGetSubscriptionAttributesCommandError(output, context)
                    ];
                    return [
                        4,
                        $e1011dd782da33d8$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = $e1011dd782da33d8$var$deserializeAws_queryGetSubscriptionAttributesResponse(data.GetSubscriptionAttributesResult, context);
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
                        $metadata: $e1011dd782da33d8$var$deserializeMetadata(output)
                    }, contents);
                    return [
                        2,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var $e1011dd782da33d8$var$deserializeAws_queryGetSubscriptionAttributesCommandError = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, parsedBody;
        var _c;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_d) {
            switch(_d.label){
                case 0:
                    _a = [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, output)
                    ];
                    _c = {};
                    return [
                        4,
                        $e1011dd782da33d8$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_c.body = _d.sent(), _c)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $e1011dd782da33d8$var$loadQueryErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "AuthorizationErrorException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.sns#AuthorizationErrorException":
                            return [
                                3,
                                2
                            ];
                        case "InternalErrorException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.sns#InternalErrorException":
                            return [
                                3,
                                4
                            ];
                        case "InvalidParameterException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.sns#InvalidParameterException":
                            return [
                                3,
                                6
                            ];
                        case "NotFoundException":
                            return [
                                3,
                                8
                            ];
                        case "com.amazonaws.sns#NotFoundException":
                            return [
                                3,
                                8
                            ];
                    }
                    return [
                        3,
                        10
                    ];
                case 2:
                    return [
                        4,
                        $e1011dd782da33d8$var$deserializeAws_queryAuthorizationErrorExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    throw _d.sent();
                case 4:
                    return [
                        4,
                        $e1011dd782da33d8$var$deserializeAws_queryInternalErrorExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    throw _d.sent();
                case 6:
                    return [
                        4,
                        $e1011dd782da33d8$var$deserializeAws_queryInvalidParameterExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    throw _d.sent();
                case 8:
                    return [
                        4,
                        $e1011dd782da33d8$var$deserializeAws_queryNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    throw _d.sent();
                case 10:
                    parsedBody = parsedOutput.body;
                    response = new (0, $411eb8c425b27262$export$6ce7aba8257a989c)({
                        name: parsedBody.Error.code || parsedBody.Error.Code || errorCode,
                        $fault: "client",
                        $metadata: $e1011dd782da33d8$var$deserializeMetadata(output)
                    });
                    throw (0, $a08c2c31e27e9e11$export$db01f0c43e877a50)(response, parsedBody.Error);
            }
        });
    });
};
var $e1011dd782da33d8$export$6052e97a6e7efe32 = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2,
                        $e1011dd782da33d8$var$deserializeAws_queryGetTopicAttributesCommandError(output, context)
                    ];
                    return [
                        4,
                        $e1011dd782da33d8$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = $e1011dd782da33d8$var$deserializeAws_queryGetTopicAttributesResponse(data.GetTopicAttributesResult, context);
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
                        $metadata: $e1011dd782da33d8$var$deserializeMetadata(output)
                    }, contents);
                    return [
                        2,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var $e1011dd782da33d8$var$deserializeAws_queryGetTopicAttributesCommandError = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, parsedBody;
        var _c;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_d) {
            switch(_d.label){
                case 0:
                    _a = [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, output)
                    ];
                    _c = {};
                    return [
                        4,
                        $e1011dd782da33d8$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_c.body = _d.sent(), _c)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $e1011dd782da33d8$var$loadQueryErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "AuthorizationErrorException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.sns#AuthorizationErrorException":
                            return [
                                3,
                                2
                            ];
                        case "InternalErrorException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.sns#InternalErrorException":
                            return [
                                3,
                                4
                            ];
                        case "InvalidParameterException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.sns#InvalidParameterException":
                            return [
                                3,
                                6
                            ];
                        case "InvalidSecurityException":
                            return [
                                3,
                                8
                            ];
                        case "com.amazonaws.sns#InvalidSecurityException":
                            return [
                                3,
                                8
                            ];
                        case "NotFoundException":
                            return [
                                3,
                                10
                            ];
                        case "com.amazonaws.sns#NotFoundException":
                            return [
                                3,
                                10
                            ];
                    }
                    return [
                        3,
                        12
                    ];
                case 2:
                    return [
                        4,
                        $e1011dd782da33d8$var$deserializeAws_queryAuthorizationErrorExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    throw _d.sent();
                case 4:
                    return [
                        4,
                        $e1011dd782da33d8$var$deserializeAws_queryInternalErrorExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    throw _d.sent();
                case 6:
                    return [
                        4,
                        $e1011dd782da33d8$var$deserializeAws_queryInvalidParameterExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    throw _d.sent();
                case 8:
                    return [
                        4,
                        $e1011dd782da33d8$var$deserializeAws_queryInvalidSecurityExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    throw _d.sent();
                case 10:
                    return [
                        4,
                        $e1011dd782da33d8$var$deserializeAws_queryNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    throw _d.sent();
                case 12:
                    parsedBody = parsedOutput.body;
                    response = new (0, $411eb8c425b27262$export$6ce7aba8257a989c)({
                        name: parsedBody.Error.code || parsedBody.Error.Code || errorCode,
                        $fault: "client",
                        $metadata: $e1011dd782da33d8$var$deserializeMetadata(output)
                    });
                    throw (0, $a08c2c31e27e9e11$export$db01f0c43e877a50)(response, parsedBody.Error);
            }
        });
    });
};
var $e1011dd782da33d8$export$e8fc2bc93ad338d = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2,
                        $e1011dd782da33d8$var$deserializeAws_queryListEndpointsByPlatformApplicationCommandError(output, context)
                    ];
                    return [
                        4,
                        $e1011dd782da33d8$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = $e1011dd782da33d8$var$deserializeAws_queryListEndpointsByPlatformApplicationResponse(data.ListEndpointsByPlatformApplicationResult, context);
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
                        $metadata: $e1011dd782da33d8$var$deserializeMetadata(output)
                    }, contents);
                    return [
                        2,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var $e1011dd782da33d8$var$deserializeAws_queryListEndpointsByPlatformApplicationCommandError = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, parsedBody;
        var _c;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_d) {
            switch(_d.label){
                case 0:
                    _a = [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, output)
                    ];
                    _c = {};
                    return [
                        4,
                        $e1011dd782da33d8$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_c.body = _d.sent(), _c)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $e1011dd782da33d8$var$loadQueryErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "AuthorizationErrorException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.sns#AuthorizationErrorException":
                            return [
                                3,
                                2
                            ];
                        case "InternalErrorException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.sns#InternalErrorException":
                            return [
                                3,
                                4
                            ];
                        case "InvalidParameterException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.sns#InvalidParameterException":
                            return [
                                3,
                                6
                            ];
                        case "NotFoundException":
                            return [
                                3,
                                8
                            ];
                        case "com.amazonaws.sns#NotFoundException":
                            return [
                                3,
                                8
                            ];
                    }
                    return [
                        3,
                        10
                    ];
                case 2:
                    return [
                        4,
                        $e1011dd782da33d8$var$deserializeAws_queryAuthorizationErrorExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    throw _d.sent();
                case 4:
                    return [
                        4,
                        $e1011dd782da33d8$var$deserializeAws_queryInternalErrorExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    throw _d.sent();
                case 6:
                    return [
                        4,
                        $e1011dd782da33d8$var$deserializeAws_queryInvalidParameterExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    throw _d.sent();
                case 8:
                    return [
                        4,
                        $e1011dd782da33d8$var$deserializeAws_queryNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    throw _d.sent();
                case 10:
                    parsedBody = parsedOutput.body;
                    response = new (0, $411eb8c425b27262$export$6ce7aba8257a989c)({
                        name: parsedBody.Error.code || parsedBody.Error.Code || errorCode,
                        $fault: "client",
                        $metadata: $e1011dd782da33d8$var$deserializeMetadata(output)
                    });
                    throw (0, $a08c2c31e27e9e11$export$db01f0c43e877a50)(response, parsedBody.Error);
            }
        });
    });
};
var $e1011dd782da33d8$export$b295ccba7787d5ae = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2,
                        $e1011dd782da33d8$var$deserializeAws_queryListOriginationNumbersCommandError(output, context)
                    ];
                    return [
                        4,
                        $e1011dd782da33d8$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = $e1011dd782da33d8$var$deserializeAws_queryListOriginationNumbersResult(data.ListOriginationNumbersResult, context);
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
                        $metadata: $e1011dd782da33d8$var$deserializeMetadata(output)
                    }, contents);
                    return [
                        2,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var $e1011dd782da33d8$var$deserializeAws_queryListOriginationNumbersCommandError = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, parsedBody;
        var _c;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_d) {
            switch(_d.label){
                case 0:
                    _a = [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, output)
                    ];
                    _c = {};
                    return [
                        4,
                        $e1011dd782da33d8$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_c.body = _d.sent(), _c)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $e1011dd782da33d8$var$loadQueryErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "AuthorizationErrorException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.sns#AuthorizationErrorException":
                            return [
                                3,
                                2
                            ];
                        case "InternalErrorException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.sns#InternalErrorException":
                            return [
                                3,
                                4
                            ];
                        case "InvalidParameterException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.sns#InvalidParameterException":
                            return [
                                3,
                                6
                            ];
                        case "ThrottledException":
                            return [
                                3,
                                8
                            ];
                        case "com.amazonaws.sns#ThrottledException":
                            return [
                                3,
                                8
                            ];
                        case "ValidationException":
                            return [
                                3,
                                10
                            ];
                        case "com.amazonaws.sns#ValidationException":
                            return [
                                3,
                                10
                            ];
                    }
                    return [
                        3,
                        12
                    ];
                case 2:
                    return [
                        4,
                        $e1011dd782da33d8$var$deserializeAws_queryAuthorizationErrorExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    throw _d.sent();
                case 4:
                    return [
                        4,
                        $e1011dd782da33d8$var$deserializeAws_queryInternalErrorExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    throw _d.sent();
                case 6:
                    return [
                        4,
                        $e1011dd782da33d8$var$deserializeAws_queryInvalidParameterExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    throw _d.sent();
                case 8:
                    return [
                        4,
                        $e1011dd782da33d8$var$deserializeAws_queryThrottledExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    throw _d.sent();
                case 10:
                    return [
                        4,
                        $e1011dd782da33d8$var$deserializeAws_queryValidationExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    throw _d.sent();
                case 12:
                    parsedBody = parsedOutput.body;
                    response = new (0, $411eb8c425b27262$export$6ce7aba8257a989c)({
                        name: parsedBody.Error.code || parsedBody.Error.Code || errorCode,
                        $fault: "client",
                        $metadata: $e1011dd782da33d8$var$deserializeMetadata(output)
                    });
                    throw (0, $a08c2c31e27e9e11$export$db01f0c43e877a50)(response, parsedBody.Error);
            }
        });
    });
};
var $e1011dd782da33d8$export$d35eb6bdd63dfce1 = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2,
                        $e1011dd782da33d8$var$deserializeAws_queryListPhoneNumbersOptedOutCommandError(output, context)
                    ];
                    return [
                        4,
                        $e1011dd782da33d8$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = $e1011dd782da33d8$var$deserializeAws_queryListPhoneNumbersOptedOutResponse(data.ListPhoneNumbersOptedOutResult, context);
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
                        $metadata: $e1011dd782da33d8$var$deserializeMetadata(output)
                    }, contents);
                    return [
                        2,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var $e1011dd782da33d8$var$deserializeAws_queryListPhoneNumbersOptedOutCommandError = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, parsedBody;
        var _c;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_d) {
            switch(_d.label){
                case 0:
                    _a = [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, output)
                    ];
                    _c = {};
                    return [
                        4,
                        $e1011dd782da33d8$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_c.body = _d.sent(), _c)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $e1011dd782da33d8$var$loadQueryErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "AuthorizationErrorException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.sns#AuthorizationErrorException":
                            return [
                                3,
                                2
                            ];
                        case "InternalErrorException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.sns#InternalErrorException":
                            return [
                                3,
                                4
                            ];
                        case "InvalidParameterException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.sns#InvalidParameterException":
                            return [
                                3,
                                6
                            ];
                        case "ThrottledException":
                            return [
                                3,
                                8
                            ];
                        case "com.amazonaws.sns#ThrottledException":
                            return [
                                3,
                                8
                            ];
                    }
                    return [
                        3,
                        10
                    ];
                case 2:
                    return [
                        4,
                        $e1011dd782da33d8$var$deserializeAws_queryAuthorizationErrorExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    throw _d.sent();
                case 4:
                    return [
                        4,
                        $e1011dd782da33d8$var$deserializeAws_queryInternalErrorExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    throw _d.sent();
                case 6:
                    return [
                        4,
                        $e1011dd782da33d8$var$deserializeAws_queryInvalidParameterExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    throw _d.sent();
                case 8:
                    return [
                        4,
                        $e1011dd782da33d8$var$deserializeAws_queryThrottledExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    throw _d.sent();
                case 10:
                    parsedBody = parsedOutput.body;
                    response = new (0, $411eb8c425b27262$export$6ce7aba8257a989c)({
                        name: parsedBody.Error.code || parsedBody.Error.Code || errorCode,
                        $fault: "client",
                        $metadata: $e1011dd782da33d8$var$deserializeMetadata(output)
                    });
                    throw (0, $a08c2c31e27e9e11$export$db01f0c43e877a50)(response, parsedBody.Error);
            }
        });
    });
};
var $e1011dd782da33d8$export$31a0057f48c661b4 = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2,
                        $e1011dd782da33d8$var$deserializeAws_queryListPlatformApplicationsCommandError(output, context)
                    ];
                    return [
                        4,
                        $e1011dd782da33d8$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = $e1011dd782da33d8$var$deserializeAws_queryListPlatformApplicationsResponse(data.ListPlatformApplicationsResult, context);
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
                        $metadata: $e1011dd782da33d8$var$deserializeMetadata(output)
                    }, contents);
                    return [
                        2,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var $e1011dd782da33d8$var$deserializeAws_queryListPlatformApplicationsCommandError = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, parsedBody;
        var _c;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_d) {
            switch(_d.label){
                case 0:
                    _a = [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, output)
                    ];
                    _c = {};
                    return [
                        4,
                        $e1011dd782da33d8$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_c.body = _d.sent(), _c)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $e1011dd782da33d8$var$loadQueryErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "AuthorizationErrorException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.sns#AuthorizationErrorException":
                            return [
                                3,
                                2
                            ];
                        case "InternalErrorException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.sns#InternalErrorException":
                            return [
                                3,
                                4
                            ];
                        case "InvalidParameterException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.sns#InvalidParameterException":
                            return [
                                3,
                                6
                            ];
                    }
                    return [
                        3,
                        8
                    ];
                case 2:
                    return [
                        4,
                        $e1011dd782da33d8$var$deserializeAws_queryAuthorizationErrorExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    throw _d.sent();
                case 4:
                    return [
                        4,
                        $e1011dd782da33d8$var$deserializeAws_queryInternalErrorExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    throw _d.sent();
                case 6:
                    return [
                        4,
                        $e1011dd782da33d8$var$deserializeAws_queryInvalidParameterExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    throw _d.sent();
                case 8:
                    parsedBody = parsedOutput.body;
                    response = new (0, $411eb8c425b27262$export$6ce7aba8257a989c)({
                        name: parsedBody.Error.code || parsedBody.Error.Code || errorCode,
                        $fault: "client",
                        $metadata: $e1011dd782da33d8$var$deserializeMetadata(output)
                    });
                    throw (0, $a08c2c31e27e9e11$export$db01f0c43e877a50)(response, parsedBody.Error);
            }
        });
    });
};
var $e1011dd782da33d8$export$efdd1ebc05c6cccf = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2,
                        $e1011dd782da33d8$var$deserializeAws_queryListSMSSandboxPhoneNumbersCommandError(output, context)
                    ];
                    return [
                        4,
                        $e1011dd782da33d8$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = $e1011dd782da33d8$var$deserializeAws_queryListSMSSandboxPhoneNumbersResult(data.ListSMSSandboxPhoneNumbersResult, context);
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
                        $metadata: $e1011dd782da33d8$var$deserializeMetadata(output)
                    }, contents);
                    return [
                        2,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var $e1011dd782da33d8$var$deserializeAws_queryListSMSSandboxPhoneNumbersCommandError = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, parsedBody;
        var _c;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_d) {
            switch(_d.label){
                case 0:
                    _a = [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, output)
                    ];
                    _c = {};
                    return [
                        4,
                        $e1011dd782da33d8$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_c.body = _d.sent(), _c)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $e1011dd782da33d8$var$loadQueryErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "AuthorizationErrorException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.sns#AuthorizationErrorException":
                            return [
                                3,
                                2
                            ];
                        case "InternalErrorException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.sns#InternalErrorException":
                            return [
                                3,
                                4
                            ];
                        case "InvalidParameterException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.sns#InvalidParameterException":
                            return [
                                3,
                                6
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3,
                                8
                            ];
                        case "com.amazonaws.sns#ResourceNotFoundException":
                            return [
                                3,
                                8
                            ];
                        case "ThrottledException":
                            return [
                                3,
                                10
                            ];
                        case "com.amazonaws.sns#ThrottledException":
                            return [
                                3,
                                10
                            ];
                    }
                    return [
                        3,
                        12
                    ];
                case 2:
                    return [
                        4,
                        $e1011dd782da33d8$var$deserializeAws_queryAuthorizationErrorExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    throw _d.sent();
                case 4:
                    return [
                        4,
                        $e1011dd782da33d8$var$deserializeAws_queryInternalErrorExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    throw _d.sent();
                case 6:
                    return [
                        4,
                        $e1011dd782da33d8$var$deserializeAws_queryInvalidParameterExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    throw _d.sent();
                case 8:
                    return [
                        4,
                        $e1011dd782da33d8$var$deserializeAws_queryResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    throw _d.sent();
                case 10:
                    return [
                        4,
                        $e1011dd782da33d8$var$deserializeAws_queryThrottledExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    throw _d.sent();
                case 12:
                    parsedBody = parsedOutput.body;
                    response = new (0, $411eb8c425b27262$export$6ce7aba8257a989c)({
                        name: parsedBody.Error.code || parsedBody.Error.Code || errorCode,
                        $fault: "client",
                        $metadata: $e1011dd782da33d8$var$deserializeMetadata(output)
                    });
                    throw (0, $a08c2c31e27e9e11$export$db01f0c43e877a50)(response, parsedBody.Error);
            }
        });
    });
};
var $e1011dd782da33d8$export$54dcd7e125e68945 = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2,
                        $e1011dd782da33d8$var$deserializeAws_queryListSubscriptionsCommandError(output, context)
                    ];
                    return [
                        4,
                        $e1011dd782da33d8$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = $e1011dd782da33d8$var$deserializeAws_queryListSubscriptionsResponse(data.ListSubscriptionsResult, context);
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
                        $metadata: $e1011dd782da33d8$var$deserializeMetadata(output)
                    }, contents);
                    return [
                        2,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var $e1011dd782da33d8$var$deserializeAws_queryListSubscriptionsCommandError = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, parsedBody;
        var _c;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_d) {
            switch(_d.label){
                case 0:
                    _a = [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, output)
                    ];
                    _c = {};
                    return [
                        4,
                        $e1011dd782da33d8$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_c.body = _d.sent(), _c)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $e1011dd782da33d8$var$loadQueryErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "AuthorizationErrorException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.sns#AuthorizationErrorException":
                            return [
                                3,
                                2
                            ];
                        case "InternalErrorException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.sns#InternalErrorException":
                            return [
                                3,
                                4
                            ];
                        case "InvalidParameterException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.sns#InvalidParameterException":
                            return [
                                3,
                                6
                            ];
                    }
                    return [
                        3,
                        8
                    ];
                case 2:
                    return [
                        4,
                        $e1011dd782da33d8$var$deserializeAws_queryAuthorizationErrorExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    throw _d.sent();
                case 4:
                    return [
                        4,
                        $e1011dd782da33d8$var$deserializeAws_queryInternalErrorExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    throw _d.sent();
                case 6:
                    return [
                        4,
                        $e1011dd782da33d8$var$deserializeAws_queryInvalidParameterExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    throw _d.sent();
                case 8:
                    parsedBody = parsedOutput.body;
                    response = new (0, $411eb8c425b27262$export$6ce7aba8257a989c)({
                        name: parsedBody.Error.code || parsedBody.Error.Code || errorCode,
                        $fault: "client",
                        $metadata: $e1011dd782da33d8$var$deserializeMetadata(output)
                    });
                    throw (0, $a08c2c31e27e9e11$export$db01f0c43e877a50)(response, parsedBody.Error);
            }
        });
    });
};
var $e1011dd782da33d8$export$33e15411e0fe3bdd = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2,
                        $e1011dd782da33d8$var$deserializeAws_queryListSubscriptionsByTopicCommandError(output, context)
                    ];
                    return [
                        4,
                        $e1011dd782da33d8$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = $e1011dd782da33d8$var$deserializeAws_queryListSubscriptionsByTopicResponse(data.ListSubscriptionsByTopicResult, context);
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
                        $metadata: $e1011dd782da33d8$var$deserializeMetadata(output)
                    }, contents);
                    return [
                        2,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var $e1011dd782da33d8$var$deserializeAws_queryListSubscriptionsByTopicCommandError = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, parsedBody;
        var _c;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_d) {
            switch(_d.label){
                case 0:
                    _a = [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, output)
                    ];
                    _c = {};
                    return [
                        4,
                        $e1011dd782da33d8$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_c.body = _d.sent(), _c)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $e1011dd782da33d8$var$loadQueryErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "AuthorizationErrorException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.sns#AuthorizationErrorException":
                            return [
                                3,
                                2
                            ];
                        case "InternalErrorException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.sns#InternalErrorException":
                            return [
                                3,
                                4
                            ];
                        case "InvalidParameterException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.sns#InvalidParameterException":
                            return [
                                3,
                                6
                            ];
                        case "NotFoundException":
                            return [
                                3,
                                8
                            ];
                        case "com.amazonaws.sns#NotFoundException":
                            return [
                                3,
                                8
                            ];
                    }
                    return [
                        3,
                        10
                    ];
                case 2:
                    return [
                        4,
                        $e1011dd782da33d8$var$deserializeAws_queryAuthorizationErrorExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    throw _d.sent();
                case 4:
                    return [
                        4,
                        $e1011dd782da33d8$var$deserializeAws_queryInternalErrorExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    throw _d.sent();
                case 6:
                    return [
                        4,
                        $e1011dd782da33d8$var$deserializeAws_queryInvalidParameterExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    throw _d.sent();
                case 8:
                    return [
                        4,
                        $e1011dd782da33d8$var$deserializeAws_queryNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    throw _d.sent();
                case 10:
                    parsedBody = parsedOutput.body;
                    response = new (0, $411eb8c425b27262$export$6ce7aba8257a989c)({
                        name: parsedBody.Error.code || parsedBody.Error.Code || errorCode,
                        $fault: "client",
                        $metadata: $e1011dd782da33d8$var$deserializeMetadata(output)
                    });
                    throw (0, $a08c2c31e27e9e11$export$db01f0c43e877a50)(response, parsedBody.Error);
            }
        });
    });
};
var $e1011dd782da33d8$export$6115e7270179c124 = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2,
                        $e1011dd782da33d8$var$deserializeAws_queryListTagsForResourceCommandError(output, context)
                    ];
                    return [
                        4,
                        $e1011dd782da33d8$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = $e1011dd782da33d8$var$deserializeAws_queryListTagsForResourceResponse(data.ListTagsForResourceResult, context);
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
                        $metadata: $e1011dd782da33d8$var$deserializeMetadata(output)
                    }, contents);
                    return [
                        2,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var $e1011dd782da33d8$var$deserializeAws_queryListTagsForResourceCommandError = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, parsedBody;
        var _c;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_d) {
            switch(_d.label){
                case 0:
                    _a = [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, output)
                    ];
                    _c = {};
                    return [
                        4,
                        $e1011dd782da33d8$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_c.body = _d.sent(), _c)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $e1011dd782da33d8$var$loadQueryErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "AuthorizationErrorException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.sns#AuthorizationErrorException":
                            return [
                                3,
                                2
                            ];
                        case "ConcurrentAccessException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.sns#ConcurrentAccessException":
                            return [
                                3,
                                4
                            ];
                        case "InvalidParameterException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.sns#InvalidParameterException":
                            return [
                                3,
                                6
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3,
                                8
                            ];
                        case "com.amazonaws.sns#ResourceNotFoundException":
                            return [
                                3,
                                8
                            ];
                        case "TagPolicyException":
                            return [
                                3,
                                10
                            ];
                        case "com.amazonaws.sns#TagPolicyException":
                            return [
                                3,
                                10
                            ];
                    }
                    return [
                        3,
                        12
                    ];
                case 2:
                    return [
                        4,
                        $e1011dd782da33d8$var$deserializeAws_queryAuthorizationErrorExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    throw _d.sent();
                case 4:
                    return [
                        4,
                        $e1011dd782da33d8$var$deserializeAws_queryConcurrentAccessExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    throw _d.sent();
                case 6:
                    return [
                        4,
                        $e1011dd782da33d8$var$deserializeAws_queryInvalidParameterExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    throw _d.sent();
                case 8:
                    return [
                        4,
                        $e1011dd782da33d8$var$deserializeAws_queryResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    throw _d.sent();
                case 10:
                    return [
                        4,
                        $e1011dd782da33d8$var$deserializeAws_queryTagPolicyExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    throw _d.sent();
                case 12:
                    parsedBody = parsedOutput.body;
                    response = new (0, $411eb8c425b27262$export$6ce7aba8257a989c)({
                        name: parsedBody.Error.code || parsedBody.Error.Code || errorCode,
                        $fault: "client",
                        $metadata: $e1011dd782da33d8$var$deserializeMetadata(output)
                    });
                    throw (0, $a08c2c31e27e9e11$export$db01f0c43e877a50)(response, parsedBody.Error);
            }
        });
    });
};
var $e1011dd782da33d8$export$c508171fc53318e7 = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2,
                        $e1011dd782da33d8$var$deserializeAws_queryListTopicsCommandError(output, context)
                    ];
                    return [
                        4,
                        $e1011dd782da33d8$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = $e1011dd782da33d8$var$deserializeAws_queryListTopicsResponse(data.ListTopicsResult, context);
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
                        $metadata: $e1011dd782da33d8$var$deserializeMetadata(output)
                    }, contents);
                    return [
                        2,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var $e1011dd782da33d8$var$deserializeAws_queryListTopicsCommandError = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, parsedBody;
        var _c;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_d) {
            switch(_d.label){
                case 0:
                    _a = [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, output)
                    ];
                    _c = {};
                    return [
                        4,
                        $e1011dd782da33d8$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_c.body = _d.sent(), _c)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $e1011dd782da33d8$var$loadQueryErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "AuthorizationErrorException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.sns#AuthorizationErrorException":
                            return [
                                3,
                                2
                            ];
                        case "InternalErrorException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.sns#InternalErrorException":
                            return [
                                3,
                                4
                            ];
                        case "InvalidParameterException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.sns#InvalidParameterException":
                            return [
                                3,
                                6
                            ];
                    }
                    return [
                        3,
                        8
                    ];
                case 2:
                    return [
                        4,
                        $e1011dd782da33d8$var$deserializeAws_queryAuthorizationErrorExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    throw _d.sent();
                case 4:
                    return [
                        4,
                        $e1011dd782da33d8$var$deserializeAws_queryInternalErrorExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    throw _d.sent();
                case 6:
                    return [
                        4,
                        $e1011dd782da33d8$var$deserializeAws_queryInvalidParameterExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    throw _d.sent();
                case 8:
                    parsedBody = parsedOutput.body;
                    response = new (0, $411eb8c425b27262$export$6ce7aba8257a989c)({
                        name: parsedBody.Error.code || parsedBody.Error.Code || errorCode,
                        $fault: "client",
                        $metadata: $e1011dd782da33d8$var$deserializeMetadata(output)
                    });
                    throw (0, $a08c2c31e27e9e11$export$db01f0c43e877a50)(response, parsedBody.Error);
            }
        });
    });
};
var $e1011dd782da33d8$export$780b983dba90b04a = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2,
                        $e1011dd782da33d8$var$deserializeAws_queryOptInPhoneNumberCommandError(output, context)
                    ];
                    return [
                        4,
                        $e1011dd782da33d8$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = $e1011dd782da33d8$var$deserializeAws_queryOptInPhoneNumberResponse(data.OptInPhoneNumberResult, context);
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
                        $metadata: $e1011dd782da33d8$var$deserializeMetadata(output)
                    }, contents);
                    return [
                        2,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var $e1011dd782da33d8$var$deserializeAws_queryOptInPhoneNumberCommandError = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, parsedBody;
        var _c;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_d) {
            switch(_d.label){
                case 0:
                    _a = [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, output)
                    ];
                    _c = {};
                    return [
                        4,
                        $e1011dd782da33d8$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_c.body = _d.sent(), _c)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $e1011dd782da33d8$var$loadQueryErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "AuthorizationErrorException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.sns#AuthorizationErrorException":
                            return [
                                3,
                                2
                            ];
                        case "InternalErrorException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.sns#InternalErrorException":
                            return [
                                3,
                                4
                            ];
                        case "InvalidParameterException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.sns#InvalidParameterException":
                            return [
                                3,
                                6
                            ];
                        case "ThrottledException":
                            return [
                                3,
                                8
                            ];
                        case "com.amazonaws.sns#ThrottledException":
                            return [
                                3,
                                8
                            ];
                    }
                    return [
                        3,
                        10
                    ];
                case 2:
                    return [
                        4,
                        $e1011dd782da33d8$var$deserializeAws_queryAuthorizationErrorExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    throw _d.sent();
                case 4:
                    return [
                        4,
                        $e1011dd782da33d8$var$deserializeAws_queryInternalErrorExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    throw _d.sent();
                case 6:
                    return [
                        4,
                        $e1011dd782da33d8$var$deserializeAws_queryInvalidParameterExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    throw _d.sent();
                case 8:
                    return [
                        4,
                        $e1011dd782da33d8$var$deserializeAws_queryThrottledExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    throw _d.sent();
                case 10:
                    parsedBody = parsedOutput.body;
                    response = new (0, $411eb8c425b27262$export$6ce7aba8257a989c)({
                        name: parsedBody.Error.code || parsedBody.Error.Code || errorCode,
                        $fault: "client",
                        $metadata: $e1011dd782da33d8$var$deserializeMetadata(output)
                    });
                    throw (0, $a08c2c31e27e9e11$export$db01f0c43e877a50)(response, parsedBody.Error);
            }
        });
    });
};
var $e1011dd782da33d8$export$17cc6fb72364aaa = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2,
                        $e1011dd782da33d8$var$deserializeAws_queryPublishCommandError(output, context)
                    ];
                    return [
                        4,
                        $e1011dd782da33d8$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = $e1011dd782da33d8$var$deserializeAws_queryPublishResponse(data.PublishResult, context);
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
                        $metadata: $e1011dd782da33d8$var$deserializeMetadata(output)
                    }, contents);
                    return [
                        2,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var $e1011dd782da33d8$var$deserializeAws_queryPublishCommandError = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, parsedBody;
        var _c;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_d) {
            switch(_d.label){
                case 0:
                    _a = [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, output)
                    ];
                    _c = {};
                    return [
                        4,
                        $e1011dd782da33d8$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_c.body = _d.sent(), _c)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $e1011dd782da33d8$var$loadQueryErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "AuthorizationErrorException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.sns#AuthorizationErrorException":
                            return [
                                3,
                                2
                            ];
                        case "EndpointDisabledException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.sns#EndpointDisabledException":
                            return [
                                3,
                                4
                            ];
                        case "InternalErrorException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.sns#InternalErrorException":
                            return [
                                3,
                                6
                            ];
                        case "InvalidParameterException":
                            return [
                                3,
                                8
                            ];
                        case "com.amazonaws.sns#InvalidParameterException":
                            return [
                                3,
                                8
                            ];
                        case "InvalidParameterValueException":
                            return [
                                3,
                                10
                            ];
                        case "com.amazonaws.sns#InvalidParameterValueException":
                            return [
                                3,
                                10
                            ];
                        case "InvalidSecurityException":
                            return [
                                3,
                                12
                            ];
                        case "com.amazonaws.sns#InvalidSecurityException":
                            return [
                                3,
                                12
                            ];
                        case "KMSAccessDeniedException":
                            return [
                                3,
                                14
                            ];
                        case "com.amazonaws.sns#KMSAccessDeniedException":
                            return [
                                3,
                                14
                            ];
                        case "KMSDisabledException":
                            return [
                                3,
                                16
                            ];
                        case "com.amazonaws.sns#KMSDisabledException":
                            return [
                                3,
                                16
                            ];
                        case "KMSInvalidStateException":
                            return [
                                3,
                                18
                            ];
                        case "com.amazonaws.sns#KMSInvalidStateException":
                            return [
                                3,
                                18
                            ];
                        case "KMSNotFoundException":
                            return [
                                3,
                                20
                            ];
                        case "com.amazonaws.sns#KMSNotFoundException":
                            return [
                                3,
                                20
                            ];
                        case "KMSOptInRequired":
                            return [
                                3,
                                22
                            ];
                        case "com.amazonaws.sns#KMSOptInRequired":
                            return [
                                3,
                                22
                            ];
                        case "KMSThrottlingException":
                            return [
                                3,
                                24
                            ];
                        case "com.amazonaws.sns#KMSThrottlingException":
                            return [
                                3,
                                24
                            ];
                        case "NotFoundException":
                            return [
                                3,
                                26
                            ];
                        case "com.amazonaws.sns#NotFoundException":
                            return [
                                3,
                                26
                            ];
                        case "PlatformApplicationDisabledException":
                            return [
                                3,
                                28
                            ];
                        case "com.amazonaws.sns#PlatformApplicationDisabledException":
                            return [
                                3,
                                28
                            ];
                    }
                    return [
                        3,
                        30
                    ];
                case 2:
                    return [
                        4,
                        $e1011dd782da33d8$var$deserializeAws_queryAuthorizationErrorExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    throw _d.sent();
                case 4:
                    return [
                        4,
                        $e1011dd782da33d8$var$deserializeAws_queryEndpointDisabledExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    throw _d.sent();
                case 6:
                    return [
                        4,
                        $e1011dd782da33d8$var$deserializeAws_queryInternalErrorExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    throw _d.sent();
                case 8:
                    return [
                        4,
                        $e1011dd782da33d8$var$deserializeAws_queryInvalidParameterExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    throw _d.sent();
                case 10:
                    return [
                        4,
                        $e1011dd782da33d8$var$deserializeAws_queryInvalidParameterValueExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    throw _d.sent();
                case 12:
                    return [
                        4,
                        $e1011dd782da33d8$var$deserializeAws_queryInvalidSecurityExceptionResponse(parsedOutput, context)
                    ];
                case 13:
                    throw _d.sent();
                case 14:
                    return [
                        4,
                        $e1011dd782da33d8$var$deserializeAws_queryKMSAccessDeniedExceptionResponse(parsedOutput, context)
                    ];
                case 15:
                    throw _d.sent();
                case 16:
                    return [
                        4,
                        $e1011dd782da33d8$var$deserializeAws_queryKMSDisabledExceptionResponse(parsedOutput, context)
                    ];
                case 17:
                    throw _d.sent();
                case 18:
                    return [
                        4,
                        $e1011dd782da33d8$var$deserializeAws_queryKMSInvalidStateExceptionResponse(parsedOutput, context)
                    ];
                case 19:
                    throw _d.sent();
                case 20:
                    return [
                        4,
                        $e1011dd782da33d8$var$deserializeAws_queryKMSNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 21:
                    throw _d.sent();
                case 22:
                    return [
                        4,
                        $e1011dd782da33d8$var$deserializeAws_queryKMSOptInRequiredResponse(parsedOutput, context)
                    ];
                case 23:
                    throw _d.sent();
                case 24:
                    return [
                        4,
                        $e1011dd782da33d8$var$deserializeAws_queryKMSThrottlingExceptionResponse(parsedOutput, context)
                    ];
                case 25:
                    throw _d.sent();
                case 26:
                    return [
                        4,
                        $e1011dd782da33d8$var$deserializeAws_queryNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 27:
                    throw _d.sent();
                case 28:
                    return [
                        4,
                        $e1011dd782da33d8$var$deserializeAws_queryPlatformApplicationDisabledExceptionResponse(parsedOutput, context)
                    ];
                case 29:
                    throw _d.sent();
                case 30:
                    parsedBody = parsedOutput.body;
                    response = new (0, $411eb8c425b27262$export$6ce7aba8257a989c)({
                        name: parsedBody.Error.code || parsedBody.Error.Code || errorCode,
                        $fault: "client",
                        $metadata: $e1011dd782da33d8$var$deserializeMetadata(output)
                    });
                    throw (0, $a08c2c31e27e9e11$export$db01f0c43e877a50)(response, parsedBody.Error);
            }
        });
    });
};
var $e1011dd782da33d8$export$973d558353e43bc4 = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2,
                        $e1011dd782da33d8$var$deserializeAws_queryPublishBatchCommandError(output, context)
                    ];
                    return [
                        4,
                        $e1011dd782da33d8$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = $e1011dd782da33d8$var$deserializeAws_queryPublishBatchResponse(data.PublishBatchResult, context);
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
                        $metadata: $e1011dd782da33d8$var$deserializeMetadata(output)
                    }, contents);
                    return [
                        2,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var $e1011dd782da33d8$var$deserializeAws_queryPublishBatchCommandError = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, parsedBody;
        var _c;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_d) {
            switch(_d.label){
                case 0:
                    _a = [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, output)
                    ];
                    _c = {};
                    return [
                        4,
                        $e1011dd782da33d8$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_c.body = _d.sent(), _c)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $e1011dd782da33d8$var$loadQueryErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "AuthorizationErrorException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.sns#AuthorizationErrorException":
                            return [
                                3,
                                2
                            ];
                        case "BatchEntryIdsNotDistinctException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.sns#BatchEntryIdsNotDistinctException":
                            return [
                                3,
                                4
                            ];
                        case "BatchRequestTooLongException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.sns#BatchRequestTooLongException":
                            return [
                                3,
                                6
                            ];
                        case "EmptyBatchRequestException":
                            return [
                                3,
                                8
                            ];
                        case "com.amazonaws.sns#EmptyBatchRequestException":
                            return [
                                3,
                                8
                            ];
                        case "EndpointDisabledException":
                            return [
                                3,
                                10
                            ];
                        case "com.amazonaws.sns#EndpointDisabledException":
                            return [
                                3,
                                10
                            ];
                        case "InternalErrorException":
                            return [
                                3,
                                12
                            ];
                        case "com.amazonaws.sns#InternalErrorException":
                            return [
                                3,
                                12
                            ];
                        case "InvalidBatchEntryIdException":
                            return [
                                3,
                                14
                            ];
                        case "com.amazonaws.sns#InvalidBatchEntryIdException":
                            return [
                                3,
                                14
                            ];
                        case "InvalidParameterException":
                            return [
                                3,
                                16
                            ];
                        case "com.amazonaws.sns#InvalidParameterException":
                            return [
                                3,
                                16
                            ];
                        case "InvalidParameterValueException":
                            return [
                                3,
                                18
                            ];
                        case "com.amazonaws.sns#InvalidParameterValueException":
                            return [
                                3,
                                18
                            ];
                        case "InvalidSecurityException":
                            return [
                                3,
                                20
                            ];
                        case "com.amazonaws.sns#InvalidSecurityException":
                            return [
                                3,
                                20
                            ];
                        case "KMSAccessDeniedException":
                            return [
                                3,
                                22
                            ];
                        case "com.amazonaws.sns#KMSAccessDeniedException":
                            return [
                                3,
                                22
                            ];
                        case "KMSDisabledException":
                            return [
                                3,
                                24
                            ];
                        case "com.amazonaws.sns#KMSDisabledException":
                            return [
                                3,
                                24
                            ];
                        case "KMSInvalidStateException":
                            return [
                                3,
                                26
                            ];
                        case "com.amazonaws.sns#KMSInvalidStateException":
                            return [
                                3,
                                26
                            ];
                        case "KMSNotFoundException":
                            return [
                                3,
                                28
                            ];
                        case "com.amazonaws.sns#KMSNotFoundException":
                            return [
                                3,
                                28
                            ];
                        case "KMSOptInRequired":
                            return [
                                3,
                                30
                            ];
                        case "com.amazonaws.sns#KMSOptInRequired":
                            return [
                                3,
                                30
                            ];
                        case "KMSThrottlingException":
                            return [
                                3,
                                32
                            ];
                        case "com.amazonaws.sns#KMSThrottlingException":
                            return [
                                3,
                                32
                            ];
                        case "NotFoundException":
                            return [
                                3,
                                34
                            ];
                        case "com.amazonaws.sns#NotFoundException":
                            return [
                                3,
                                34
                            ];
                        case "PlatformApplicationDisabledException":
                            return [
                                3,
                                36
                            ];
                        case "com.amazonaws.sns#PlatformApplicationDisabledException":
                            return [
                                3,
                                36
                            ];
                        case "TooManyEntriesInBatchRequestException":
                            return [
                                3,
                                38
                            ];
                        case "com.amazonaws.sns#TooManyEntriesInBatchRequestException":
                            return [
                                3,
                                38
                            ];
                    }
                    return [
                        3,
                        40
                    ];
                case 2:
                    return [
                        4,
                        $e1011dd782da33d8$var$deserializeAws_queryAuthorizationErrorExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    throw _d.sent();
                case 4:
                    return [
                        4,
                        $e1011dd782da33d8$var$deserializeAws_queryBatchEntryIdsNotDistinctExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    throw _d.sent();
                case 6:
                    return [
                        4,
                        $e1011dd782da33d8$var$deserializeAws_queryBatchRequestTooLongExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    throw _d.sent();
                case 8:
                    return [
                        4,
                        $e1011dd782da33d8$var$deserializeAws_queryEmptyBatchRequestExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    throw _d.sent();
                case 10:
                    return [
                        4,
                        $e1011dd782da33d8$var$deserializeAws_queryEndpointDisabledExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    throw _d.sent();
                case 12:
                    return [
                        4,
                        $e1011dd782da33d8$var$deserializeAws_queryInternalErrorExceptionResponse(parsedOutput, context)
                    ];
                case 13:
                    throw _d.sent();
                case 14:
                    return [
                        4,
                        $e1011dd782da33d8$var$deserializeAws_queryInvalidBatchEntryIdExceptionResponse(parsedOutput, context)
                    ];
                case 15:
                    throw _d.sent();
                case 16:
                    return [
                        4,
                        $e1011dd782da33d8$var$deserializeAws_queryInvalidParameterExceptionResponse(parsedOutput, context)
                    ];
                case 17:
                    throw _d.sent();
                case 18:
                    return [
                        4,
                        $e1011dd782da33d8$var$deserializeAws_queryInvalidParameterValueExceptionResponse(parsedOutput, context)
                    ];
                case 19:
                    throw _d.sent();
                case 20:
                    return [
                        4,
                        $e1011dd782da33d8$var$deserializeAws_queryInvalidSecurityExceptionResponse(parsedOutput, context)
                    ];
                case 21:
                    throw _d.sent();
                case 22:
                    return [
                        4,
                        $e1011dd782da33d8$var$deserializeAws_queryKMSAccessDeniedExceptionResponse(parsedOutput, context)
                    ];
                case 23:
                    throw _d.sent();
                case 24:
                    return [
                        4,
                        $e1011dd782da33d8$var$deserializeAws_queryKMSDisabledExceptionResponse(parsedOutput, context)
                    ];
                case 25:
                    throw _d.sent();
                case 26:
                    return [
                        4,
                        $e1011dd782da33d8$var$deserializeAws_queryKMSInvalidStateExceptionResponse(parsedOutput, context)
                    ];
                case 27:
                    throw _d.sent();
                case 28:
                    return [
                        4,
                        $e1011dd782da33d8$var$deserializeAws_queryKMSNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 29:
                    throw _d.sent();
                case 30:
                    return [
                        4,
                        $e1011dd782da33d8$var$deserializeAws_queryKMSOptInRequiredResponse(parsedOutput, context)
                    ];
                case 31:
                    throw _d.sent();
                case 32:
                    return [
                        4,
                        $e1011dd782da33d8$var$deserializeAws_queryKMSThrottlingExceptionResponse(parsedOutput, context)
                    ];
                case 33:
                    throw _d.sent();
                case 34:
                    return [
                        4,
                        $e1011dd782da33d8$var$deserializeAws_queryNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 35:
                    throw _d.sent();
                case 36:
                    return [
                        4,
                        $e1011dd782da33d8$var$deserializeAws_queryPlatformApplicationDisabledExceptionResponse(parsedOutput, context)
                    ];
                case 37:
                    throw _d.sent();
                case 38:
                    return [
                        4,
                        $e1011dd782da33d8$var$deserializeAws_queryTooManyEntriesInBatchRequestExceptionResponse(parsedOutput, context)
                    ];
                case 39:
                    throw _d.sent();
                case 40:
                    parsedBody = parsedOutput.body;
                    response = new (0, $411eb8c425b27262$export$6ce7aba8257a989c)({
                        name: parsedBody.Error.code || parsedBody.Error.Code || errorCode,
                        $fault: "client",
                        $metadata: $e1011dd782da33d8$var$deserializeMetadata(output)
                    });
                    throw (0, $a08c2c31e27e9e11$export$db01f0c43e877a50)(response, parsedBody.Error);
            }
        });
    });
};
var $e1011dd782da33d8$export$fc104a5b82ba1f95 = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var response;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2,
                        $e1011dd782da33d8$var$deserializeAws_queryRemovePermissionCommandError(output, context)
                    ];
                    return [
                        4,
                        $e1011dd782da33d8$var$collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    response = {
                        $metadata: $e1011dd782da33d8$var$deserializeMetadata(output)
                    };
                    return [
                        2,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var $e1011dd782da33d8$var$deserializeAws_queryRemovePermissionCommandError = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, parsedBody;
        var _c;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_d) {
            switch(_d.label){
                case 0:
                    _a = [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, output)
                    ];
                    _c = {};
                    return [
                        4,
                        $e1011dd782da33d8$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_c.body = _d.sent(), _c)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $e1011dd782da33d8$var$loadQueryErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "AuthorizationErrorException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.sns#AuthorizationErrorException":
                            return [
                                3,
                                2
                            ];
                        case "InternalErrorException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.sns#InternalErrorException":
                            return [
                                3,
                                4
                            ];
                        case "InvalidParameterException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.sns#InvalidParameterException":
                            return [
                                3,
                                6
                            ];
                        case "NotFoundException":
                            return [
                                3,
                                8
                            ];
                        case "com.amazonaws.sns#NotFoundException":
                            return [
                                3,
                                8
                            ];
                    }
                    return [
                        3,
                        10
                    ];
                case 2:
                    return [
                        4,
                        $e1011dd782da33d8$var$deserializeAws_queryAuthorizationErrorExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    throw _d.sent();
                case 4:
                    return [
                        4,
                        $e1011dd782da33d8$var$deserializeAws_queryInternalErrorExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    throw _d.sent();
                case 6:
                    return [
                        4,
                        $e1011dd782da33d8$var$deserializeAws_queryInvalidParameterExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    throw _d.sent();
                case 8:
                    return [
                        4,
                        $e1011dd782da33d8$var$deserializeAws_queryNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    throw _d.sent();
                case 10:
                    parsedBody = parsedOutput.body;
                    response = new (0, $411eb8c425b27262$export$6ce7aba8257a989c)({
                        name: parsedBody.Error.code || parsedBody.Error.Code || errorCode,
                        $fault: "client",
                        $metadata: $e1011dd782da33d8$var$deserializeMetadata(output)
                    });
                    throw (0, $a08c2c31e27e9e11$export$db01f0c43e877a50)(response, parsedBody.Error);
            }
        });
    });
};
var $e1011dd782da33d8$export$7e3bc03bf7233e1b = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var response;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2,
                        $e1011dd782da33d8$var$deserializeAws_querySetEndpointAttributesCommandError(output, context)
                    ];
                    return [
                        4,
                        $e1011dd782da33d8$var$collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    response = {
                        $metadata: $e1011dd782da33d8$var$deserializeMetadata(output)
                    };
                    return [
                        2,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var $e1011dd782da33d8$var$deserializeAws_querySetEndpointAttributesCommandError = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, parsedBody;
        var _c;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_d) {
            switch(_d.label){
                case 0:
                    _a = [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, output)
                    ];
                    _c = {};
                    return [
                        4,
                        $e1011dd782da33d8$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_c.body = _d.sent(), _c)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $e1011dd782da33d8$var$loadQueryErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "AuthorizationErrorException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.sns#AuthorizationErrorException":
                            return [
                                3,
                                2
                            ];
                        case "InternalErrorException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.sns#InternalErrorException":
                            return [
                                3,
                                4
                            ];
                        case "InvalidParameterException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.sns#InvalidParameterException":
                            return [
                                3,
                                6
                            ];
                        case "NotFoundException":
                            return [
                                3,
                                8
                            ];
                        case "com.amazonaws.sns#NotFoundException":
                            return [
                                3,
                                8
                            ];
                    }
                    return [
                        3,
                        10
                    ];
                case 2:
                    return [
                        4,
                        $e1011dd782da33d8$var$deserializeAws_queryAuthorizationErrorExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    throw _d.sent();
                case 4:
                    return [
                        4,
                        $e1011dd782da33d8$var$deserializeAws_queryInternalErrorExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    throw _d.sent();
                case 6:
                    return [
                        4,
                        $e1011dd782da33d8$var$deserializeAws_queryInvalidParameterExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    throw _d.sent();
                case 8:
                    return [
                        4,
                        $e1011dd782da33d8$var$deserializeAws_queryNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    throw _d.sent();
                case 10:
                    parsedBody = parsedOutput.body;
                    response = new (0, $411eb8c425b27262$export$6ce7aba8257a989c)({
                        name: parsedBody.Error.code || parsedBody.Error.Code || errorCode,
                        $fault: "client",
                        $metadata: $e1011dd782da33d8$var$deserializeMetadata(output)
                    });
                    throw (0, $a08c2c31e27e9e11$export$db01f0c43e877a50)(response, parsedBody.Error);
            }
        });
    });
};
var $e1011dd782da33d8$export$de5f1170428ccebf = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var response;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2,
                        $e1011dd782da33d8$var$deserializeAws_querySetPlatformApplicationAttributesCommandError(output, context)
                    ];
                    return [
                        4,
                        $e1011dd782da33d8$var$collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    response = {
                        $metadata: $e1011dd782da33d8$var$deserializeMetadata(output)
                    };
                    return [
                        2,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var $e1011dd782da33d8$var$deserializeAws_querySetPlatformApplicationAttributesCommandError = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, parsedBody;
        var _c;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_d) {
            switch(_d.label){
                case 0:
                    _a = [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, output)
                    ];
                    _c = {};
                    return [
                        4,
                        $e1011dd782da33d8$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_c.body = _d.sent(), _c)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $e1011dd782da33d8$var$loadQueryErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "AuthorizationErrorException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.sns#AuthorizationErrorException":
                            return [
                                3,
                                2
                            ];
                        case "InternalErrorException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.sns#InternalErrorException":
                            return [
                                3,
                                4
                            ];
                        case "InvalidParameterException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.sns#InvalidParameterException":
                            return [
                                3,
                                6
                            ];
                        case "NotFoundException":
                            return [
                                3,
                                8
                            ];
                        case "com.amazonaws.sns#NotFoundException":
                            return [
                                3,
                                8
                            ];
                    }
                    return [
                        3,
                        10
                    ];
                case 2:
                    return [
                        4,
                        $e1011dd782da33d8$var$deserializeAws_queryAuthorizationErrorExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    throw _d.sent();
                case 4:
                    return [
                        4,
                        $e1011dd782da33d8$var$deserializeAws_queryInternalErrorExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    throw _d.sent();
                case 6:
                    return [
                        4,
                        $e1011dd782da33d8$var$deserializeAws_queryInvalidParameterExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    throw _d.sent();
                case 8:
                    return [
                        4,
                        $e1011dd782da33d8$var$deserializeAws_queryNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    throw _d.sent();
                case 10:
                    parsedBody = parsedOutput.body;
                    response = new (0, $411eb8c425b27262$export$6ce7aba8257a989c)({
                        name: parsedBody.Error.code || parsedBody.Error.Code || errorCode,
                        $fault: "client",
                        $metadata: $e1011dd782da33d8$var$deserializeMetadata(output)
                    });
                    throw (0, $a08c2c31e27e9e11$export$db01f0c43e877a50)(response, parsedBody.Error);
            }
        });
    });
};
var $e1011dd782da33d8$export$4a576db3bcec840a = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2,
                        $e1011dd782da33d8$var$deserializeAws_querySetSMSAttributesCommandError(output, context)
                    ];
                    return [
                        4,
                        $e1011dd782da33d8$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = $e1011dd782da33d8$var$deserializeAws_querySetSMSAttributesResponse(data.SetSMSAttributesResult, context);
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
                        $metadata: $e1011dd782da33d8$var$deserializeMetadata(output)
                    }, contents);
                    return [
                        2,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var $e1011dd782da33d8$var$deserializeAws_querySetSMSAttributesCommandError = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, parsedBody;
        var _c;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_d) {
            switch(_d.label){
                case 0:
                    _a = [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, output)
                    ];
                    _c = {};
                    return [
                        4,
                        $e1011dd782da33d8$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_c.body = _d.sent(), _c)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $e1011dd782da33d8$var$loadQueryErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "AuthorizationErrorException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.sns#AuthorizationErrorException":
                            return [
                                3,
                                2
                            ];
                        case "InternalErrorException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.sns#InternalErrorException":
                            return [
                                3,
                                4
                            ];
                        case "InvalidParameterException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.sns#InvalidParameterException":
                            return [
                                3,
                                6
                            ];
                        case "ThrottledException":
                            return [
                                3,
                                8
                            ];
                        case "com.amazonaws.sns#ThrottledException":
                            return [
                                3,
                                8
                            ];
                    }
                    return [
                        3,
                        10
                    ];
                case 2:
                    return [
                        4,
                        $e1011dd782da33d8$var$deserializeAws_queryAuthorizationErrorExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    throw _d.sent();
                case 4:
                    return [
                        4,
                        $e1011dd782da33d8$var$deserializeAws_queryInternalErrorExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    throw _d.sent();
                case 6:
                    return [
                        4,
                        $e1011dd782da33d8$var$deserializeAws_queryInvalidParameterExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    throw _d.sent();
                case 8:
                    return [
                        4,
                        $e1011dd782da33d8$var$deserializeAws_queryThrottledExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    throw _d.sent();
                case 10:
                    parsedBody = parsedOutput.body;
                    response = new (0, $411eb8c425b27262$export$6ce7aba8257a989c)({
                        name: parsedBody.Error.code || parsedBody.Error.Code || errorCode,
                        $fault: "client",
                        $metadata: $e1011dd782da33d8$var$deserializeMetadata(output)
                    });
                    throw (0, $a08c2c31e27e9e11$export$db01f0c43e877a50)(response, parsedBody.Error);
            }
        });
    });
};
var $e1011dd782da33d8$export$d39a2ba82541b387 = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var response;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2,
                        $e1011dd782da33d8$var$deserializeAws_querySetSubscriptionAttributesCommandError(output, context)
                    ];
                    return [
                        4,
                        $e1011dd782da33d8$var$collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    response = {
                        $metadata: $e1011dd782da33d8$var$deserializeMetadata(output)
                    };
                    return [
                        2,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var $e1011dd782da33d8$var$deserializeAws_querySetSubscriptionAttributesCommandError = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, parsedBody;
        var _c;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_d) {
            switch(_d.label){
                case 0:
                    _a = [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, output)
                    ];
                    _c = {};
                    return [
                        4,
                        $e1011dd782da33d8$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_c.body = _d.sent(), _c)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $e1011dd782da33d8$var$loadQueryErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "AuthorizationErrorException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.sns#AuthorizationErrorException":
                            return [
                                3,
                                2
                            ];
                        case "FilterPolicyLimitExceededException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.sns#FilterPolicyLimitExceededException":
                            return [
                                3,
                                4
                            ];
                        case "InternalErrorException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.sns#InternalErrorException":
                            return [
                                3,
                                6
                            ];
                        case "InvalidParameterException":
                            return [
                                3,
                                8
                            ];
                        case "com.amazonaws.sns#InvalidParameterException":
                            return [
                                3,
                                8
                            ];
                        case "NotFoundException":
                            return [
                                3,
                                10
                            ];
                        case "com.amazonaws.sns#NotFoundException":
                            return [
                                3,
                                10
                            ];
                    }
                    return [
                        3,
                        12
                    ];
                case 2:
                    return [
                        4,
                        $e1011dd782da33d8$var$deserializeAws_queryAuthorizationErrorExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    throw _d.sent();
                case 4:
                    return [
                        4,
                        $e1011dd782da33d8$var$deserializeAws_queryFilterPolicyLimitExceededExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    throw _d.sent();
                case 6:
                    return [
                        4,
                        $e1011dd782da33d8$var$deserializeAws_queryInternalErrorExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    throw _d.sent();
                case 8:
                    return [
                        4,
                        $e1011dd782da33d8$var$deserializeAws_queryInvalidParameterExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    throw _d.sent();
                case 10:
                    return [
                        4,
                        $e1011dd782da33d8$var$deserializeAws_queryNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    throw _d.sent();
                case 12:
                    parsedBody = parsedOutput.body;
                    response = new (0, $411eb8c425b27262$export$6ce7aba8257a989c)({
                        name: parsedBody.Error.code || parsedBody.Error.Code || errorCode,
                        $fault: "client",
                        $metadata: $e1011dd782da33d8$var$deserializeMetadata(output)
                    });
                    throw (0, $a08c2c31e27e9e11$export$db01f0c43e877a50)(response, parsedBody.Error);
            }
        });
    });
};
var $e1011dd782da33d8$export$79e5102c248b978c = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var response;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2,
                        $e1011dd782da33d8$var$deserializeAws_querySetTopicAttributesCommandError(output, context)
                    ];
                    return [
                        4,
                        $e1011dd782da33d8$var$collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    response = {
                        $metadata: $e1011dd782da33d8$var$deserializeMetadata(output)
                    };
                    return [
                        2,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var $e1011dd782da33d8$var$deserializeAws_querySetTopicAttributesCommandError = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, parsedBody;
        var _c;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_d) {
            switch(_d.label){
                case 0:
                    _a = [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, output)
                    ];
                    _c = {};
                    return [
                        4,
                        $e1011dd782da33d8$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_c.body = _d.sent(), _c)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $e1011dd782da33d8$var$loadQueryErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "AuthorizationErrorException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.sns#AuthorizationErrorException":
                            return [
                                3,
                                2
                            ];
                        case "InternalErrorException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.sns#InternalErrorException":
                            return [
                                3,
                                4
                            ];
                        case "InvalidParameterException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.sns#InvalidParameterException":
                            return [
                                3,
                                6
                            ];
                        case "InvalidSecurityException":
                            return [
                                3,
                                8
                            ];
                        case "com.amazonaws.sns#InvalidSecurityException":
                            return [
                                3,
                                8
                            ];
                        case "NotFoundException":
                            return [
                                3,
                                10
                            ];
                        case "com.amazonaws.sns#NotFoundException":
                            return [
                                3,
                                10
                            ];
                    }
                    return [
                        3,
                        12
                    ];
                case 2:
                    return [
                        4,
                        $e1011dd782da33d8$var$deserializeAws_queryAuthorizationErrorExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    throw _d.sent();
                case 4:
                    return [
                        4,
                        $e1011dd782da33d8$var$deserializeAws_queryInternalErrorExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    throw _d.sent();
                case 6:
                    return [
                        4,
                        $e1011dd782da33d8$var$deserializeAws_queryInvalidParameterExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    throw _d.sent();
                case 8:
                    return [
                        4,
                        $e1011dd782da33d8$var$deserializeAws_queryInvalidSecurityExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    throw _d.sent();
                case 10:
                    return [
                        4,
                        $e1011dd782da33d8$var$deserializeAws_queryNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    throw _d.sent();
                case 12:
                    parsedBody = parsedOutput.body;
                    response = new (0, $411eb8c425b27262$export$6ce7aba8257a989c)({
                        name: parsedBody.Error.code || parsedBody.Error.Code || errorCode,
                        $fault: "client",
                        $metadata: $e1011dd782da33d8$var$deserializeMetadata(output)
                    });
                    throw (0, $a08c2c31e27e9e11$export$db01f0c43e877a50)(response, parsedBody.Error);
            }
        });
    });
};
var $e1011dd782da33d8$export$76e4af857c109789 = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2,
                        $e1011dd782da33d8$var$deserializeAws_querySubscribeCommandError(output, context)
                    ];
                    return [
                        4,
                        $e1011dd782da33d8$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = $e1011dd782da33d8$var$deserializeAws_querySubscribeResponse(data.SubscribeResult, context);
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
                        $metadata: $e1011dd782da33d8$var$deserializeMetadata(output)
                    }, contents);
                    return [
                        2,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var $e1011dd782da33d8$var$deserializeAws_querySubscribeCommandError = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, parsedBody;
        var _c;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_d) {
            switch(_d.label){
                case 0:
                    _a = [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, output)
                    ];
                    _c = {};
                    return [
                        4,
                        $e1011dd782da33d8$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_c.body = _d.sent(), _c)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $e1011dd782da33d8$var$loadQueryErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "AuthorizationErrorException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.sns#AuthorizationErrorException":
                            return [
                                3,
                                2
                            ];
                        case "FilterPolicyLimitExceededException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.sns#FilterPolicyLimitExceededException":
                            return [
                                3,
                                4
                            ];
                        case "InternalErrorException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.sns#InternalErrorException":
                            return [
                                3,
                                6
                            ];
                        case "InvalidParameterException":
                            return [
                                3,
                                8
                            ];
                        case "com.amazonaws.sns#InvalidParameterException":
                            return [
                                3,
                                8
                            ];
                        case "InvalidSecurityException":
                            return [
                                3,
                                10
                            ];
                        case "com.amazonaws.sns#InvalidSecurityException":
                            return [
                                3,
                                10
                            ];
                        case "NotFoundException":
                            return [
                                3,
                                12
                            ];
                        case "com.amazonaws.sns#NotFoundException":
                            return [
                                3,
                                12
                            ];
                        case "SubscriptionLimitExceededException":
                            return [
                                3,
                                14
                            ];
                        case "com.amazonaws.sns#SubscriptionLimitExceededException":
                            return [
                                3,
                                14
                            ];
                    }
                    return [
                        3,
                        16
                    ];
                case 2:
                    return [
                        4,
                        $e1011dd782da33d8$var$deserializeAws_queryAuthorizationErrorExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    throw _d.sent();
                case 4:
                    return [
                        4,
                        $e1011dd782da33d8$var$deserializeAws_queryFilterPolicyLimitExceededExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    throw _d.sent();
                case 6:
                    return [
                        4,
                        $e1011dd782da33d8$var$deserializeAws_queryInternalErrorExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    throw _d.sent();
                case 8:
                    return [
                        4,
                        $e1011dd782da33d8$var$deserializeAws_queryInvalidParameterExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    throw _d.sent();
                case 10:
                    return [
                        4,
                        $e1011dd782da33d8$var$deserializeAws_queryInvalidSecurityExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    throw _d.sent();
                case 12:
                    return [
                        4,
                        $e1011dd782da33d8$var$deserializeAws_queryNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 13:
                    throw _d.sent();
                case 14:
                    return [
                        4,
                        $e1011dd782da33d8$var$deserializeAws_querySubscriptionLimitExceededExceptionResponse(parsedOutput, context)
                    ];
                case 15:
                    throw _d.sent();
                case 16:
                    parsedBody = parsedOutput.body;
                    response = new (0, $411eb8c425b27262$export$6ce7aba8257a989c)({
                        name: parsedBody.Error.code || parsedBody.Error.Code || errorCode,
                        $fault: "client",
                        $metadata: $e1011dd782da33d8$var$deserializeMetadata(output)
                    });
                    throw (0, $a08c2c31e27e9e11$export$db01f0c43e877a50)(response, parsedBody.Error);
            }
        });
    });
};
var $e1011dd782da33d8$export$93c88e7e193a3f36 = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2,
                        $e1011dd782da33d8$var$deserializeAws_queryTagResourceCommandError(output, context)
                    ];
                    return [
                        4,
                        $e1011dd782da33d8$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = $e1011dd782da33d8$var$deserializeAws_queryTagResourceResponse(data.TagResourceResult, context);
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
                        $metadata: $e1011dd782da33d8$var$deserializeMetadata(output)
                    }, contents);
                    return [
                        2,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var $e1011dd782da33d8$var$deserializeAws_queryTagResourceCommandError = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, parsedBody;
        var _c;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_d) {
            switch(_d.label){
                case 0:
                    _a = [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, output)
                    ];
                    _c = {};
                    return [
                        4,
                        $e1011dd782da33d8$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_c.body = _d.sent(), _c)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $e1011dd782da33d8$var$loadQueryErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "AuthorizationErrorException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.sns#AuthorizationErrorException":
                            return [
                                3,
                                2
                            ];
                        case "ConcurrentAccessException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.sns#ConcurrentAccessException":
                            return [
                                3,
                                4
                            ];
                        case "InvalidParameterException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.sns#InvalidParameterException":
                            return [
                                3,
                                6
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3,
                                8
                            ];
                        case "com.amazonaws.sns#ResourceNotFoundException":
                            return [
                                3,
                                8
                            ];
                        case "StaleTagException":
                            return [
                                3,
                                10
                            ];
                        case "com.amazonaws.sns#StaleTagException":
                            return [
                                3,
                                10
                            ];
                        case "TagLimitExceededException":
                            return [
                                3,
                                12
                            ];
                        case "com.amazonaws.sns#TagLimitExceededException":
                            return [
                                3,
                                12
                            ];
                        case "TagPolicyException":
                            return [
                                3,
                                14
                            ];
                        case "com.amazonaws.sns#TagPolicyException":
                            return [
                                3,
                                14
                            ];
                    }
                    return [
                        3,
                        16
                    ];
                case 2:
                    return [
                        4,
                        $e1011dd782da33d8$var$deserializeAws_queryAuthorizationErrorExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    throw _d.sent();
                case 4:
                    return [
                        4,
                        $e1011dd782da33d8$var$deserializeAws_queryConcurrentAccessExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    throw _d.sent();
                case 6:
                    return [
                        4,
                        $e1011dd782da33d8$var$deserializeAws_queryInvalidParameterExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    throw _d.sent();
                case 8:
                    return [
                        4,
                        $e1011dd782da33d8$var$deserializeAws_queryResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    throw _d.sent();
                case 10:
                    return [
                        4,
                        $e1011dd782da33d8$var$deserializeAws_queryStaleTagExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    throw _d.sent();
                case 12:
                    return [
                        4,
                        $e1011dd782da33d8$var$deserializeAws_queryTagLimitExceededExceptionResponse(parsedOutput, context)
                    ];
                case 13:
                    throw _d.sent();
                case 14:
                    return [
                        4,
                        $e1011dd782da33d8$var$deserializeAws_queryTagPolicyExceptionResponse(parsedOutput, context)
                    ];
                case 15:
                    throw _d.sent();
                case 16:
                    parsedBody = parsedOutput.body;
                    response = new (0, $411eb8c425b27262$export$6ce7aba8257a989c)({
                        name: parsedBody.Error.code || parsedBody.Error.Code || errorCode,
                        $fault: "client",
                        $metadata: $e1011dd782da33d8$var$deserializeMetadata(output)
                    });
                    throw (0, $a08c2c31e27e9e11$export$db01f0c43e877a50)(response, parsedBody.Error);
            }
        });
    });
};
var $e1011dd782da33d8$export$d76c547cafc16b41 = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var response;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2,
                        $e1011dd782da33d8$var$deserializeAws_queryUnsubscribeCommandError(output, context)
                    ];
                    return [
                        4,
                        $e1011dd782da33d8$var$collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    response = {
                        $metadata: $e1011dd782da33d8$var$deserializeMetadata(output)
                    };
                    return [
                        2,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var $e1011dd782da33d8$var$deserializeAws_queryUnsubscribeCommandError = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, parsedBody;
        var _c;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_d) {
            switch(_d.label){
                case 0:
                    _a = [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, output)
                    ];
                    _c = {};
                    return [
                        4,
                        $e1011dd782da33d8$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_c.body = _d.sent(), _c)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $e1011dd782da33d8$var$loadQueryErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "AuthorizationErrorException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.sns#AuthorizationErrorException":
                            return [
                                3,
                                2
                            ];
                        case "InternalErrorException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.sns#InternalErrorException":
                            return [
                                3,
                                4
                            ];
                        case "InvalidParameterException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.sns#InvalidParameterException":
                            return [
                                3,
                                6
                            ];
                        case "InvalidSecurityException":
                            return [
                                3,
                                8
                            ];
                        case "com.amazonaws.sns#InvalidSecurityException":
                            return [
                                3,
                                8
                            ];
                        case "NotFoundException":
                            return [
                                3,
                                10
                            ];
                        case "com.amazonaws.sns#NotFoundException":
                            return [
                                3,
                                10
                            ];
                    }
                    return [
                        3,
                        12
                    ];
                case 2:
                    return [
                        4,
                        $e1011dd782da33d8$var$deserializeAws_queryAuthorizationErrorExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    throw _d.sent();
                case 4:
                    return [
                        4,
                        $e1011dd782da33d8$var$deserializeAws_queryInternalErrorExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    throw _d.sent();
                case 6:
                    return [
                        4,
                        $e1011dd782da33d8$var$deserializeAws_queryInvalidParameterExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    throw _d.sent();
                case 8:
                    return [
                        4,
                        $e1011dd782da33d8$var$deserializeAws_queryInvalidSecurityExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    throw _d.sent();
                case 10:
                    return [
                        4,
                        $e1011dd782da33d8$var$deserializeAws_queryNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    throw _d.sent();
                case 12:
                    parsedBody = parsedOutput.body;
                    response = new (0, $411eb8c425b27262$export$6ce7aba8257a989c)({
                        name: parsedBody.Error.code || parsedBody.Error.Code || errorCode,
                        $fault: "client",
                        $metadata: $e1011dd782da33d8$var$deserializeMetadata(output)
                    });
                    throw (0, $a08c2c31e27e9e11$export$db01f0c43e877a50)(response, parsedBody.Error);
            }
        });
    });
};
var $e1011dd782da33d8$export$c6b2400e5659c0ef = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2,
                        $e1011dd782da33d8$var$deserializeAws_queryUntagResourceCommandError(output, context)
                    ];
                    return [
                        4,
                        $e1011dd782da33d8$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = $e1011dd782da33d8$var$deserializeAws_queryUntagResourceResponse(data.UntagResourceResult, context);
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
                        $metadata: $e1011dd782da33d8$var$deserializeMetadata(output)
                    }, contents);
                    return [
                        2,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var $e1011dd782da33d8$var$deserializeAws_queryUntagResourceCommandError = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, parsedBody;
        var _c;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_d) {
            switch(_d.label){
                case 0:
                    _a = [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, output)
                    ];
                    _c = {};
                    return [
                        4,
                        $e1011dd782da33d8$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_c.body = _d.sent(), _c)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $e1011dd782da33d8$var$loadQueryErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "AuthorizationErrorException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.sns#AuthorizationErrorException":
                            return [
                                3,
                                2
                            ];
                        case "ConcurrentAccessException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.sns#ConcurrentAccessException":
                            return [
                                3,
                                4
                            ];
                        case "InvalidParameterException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.sns#InvalidParameterException":
                            return [
                                3,
                                6
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3,
                                8
                            ];
                        case "com.amazonaws.sns#ResourceNotFoundException":
                            return [
                                3,
                                8
                            ];
                        case "StaleTagException":
                            return [
                                3,
                                10
                            ];
                        case "com.amazonaws.sns#StaleTagException":
                            return [
                                3,
                                10
                            ];
                        case "TagLimitExceededException":
                            return [
                                3,
                                12
                            ];
                        case "com.amazonaws.sns#TagLimitExceededException":
                            return [
                                3,
                                12
                            ];
                        case "TagPolicyException":
                            return [
                                3,
                                14
                            ];
                        case "com.amazonaws.sns#TagPolicyException":
                            return [
                                3,
                                14
                            ];
                    }
                    return [
                        3,
                        16
                    ];
                case 2:
                    return [
                        4,
                        $e1011dd782da33d8$var$deserializeAws_queryAuthorizationErrorExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    throw _d.sent();
                case 4:
                    return [
                        4,
                        $e1011dd782da33d8$var$deserializeAws_queryConcurrentAccessExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    throw _d.sent();
                case 6:
                    return [
                        4,
                        $e1011dd782da33d8$var$deserializeAws_queryInvalidParameterExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    throw _d.sent();
                case 8:
                    return [
                        4,
                        $e1011dd782da33d8$var$deserializeAws_queryResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    throw _d.sent();
                case 10:
                    return [
                        4,
                        $e1011dd782da33d8$var$deserializeAws_queryStaleTagExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    throw _d.sent();
                case 12:
                    return [
                        4,
                        $e1011dd782da33d8$var$deserializeAws_queryTagLimitExceededExceptionResponse(parsedOutput, context)
                    ];
                case 13:
                    throw _d.sent();
                case 14:
                    return [
                        4,
                        $e1011dd782da33d8$var$deserializeAws_queryTagPolicyExceptionResponse(parsedOutput, context)
                    ];
                case 15:
                    throw _d.sent();
                case 16:
                    parsedBody = parsedOutput.body;
                    response = new (0, $411eb8c425b27262$export$6ce7aba8257a989c)({
                        name: parsedBody.Error.code || parsedBody.Error.Code || errorCode,
                        $fault: "client",
                        $metadata: $e1011dd782da33d8$var$deserializeMetadata(output)
                    });
                    throw (0, $a08c2c31e27e9e11$export$db01f0c43e877a50)(response, parsedBody.Error);
            }
        });
    });
};
var $e1011dd782da33d8$export$5a837e9bf674e686 = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2,
                        $e1011dd782da33d8$var$deserializeAws_queryVerifySMSSandboxPhoneNumberCommandError(output, context)
                    ];
                    return [
                        4,
                        $e1011dd782da33d8$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = $e1011dd782da33d8$var$deserializeAws_queryVerifySMSSandboxPhoneNumberResult(data.VerifySMSSandboxPhoneNumberResult, context);
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
                        $metadata: $e1011dd782da33d8$var$deserializeMetadata(output)
                    }, contents);
                    return [
                        2,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var $e1011dd782da33d8$var$deserializeAws_queryVerifySMSSandboxPhoneNumberCommandError = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, parsedBody;
        var _c;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_d) {
            switch(_d.label){
                case 0:
                    _a = [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, output)
                    ];
                    _c = {};
                    return [
                        4,
                        $e1011dd782da33d8$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_c.body = _d.sent(), _c)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $e1011dd782da33d8$var$loadQueryErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "AuthorizationErrorException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.sns#AuthorizationErrorException":
                            return [
                                3,
                                2
                            ];
                        case "InternalErrorException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.sns#InternalErrorException":
                            return [
                                3,
                                4
                            ];
                        case "InvalidParameterException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.sns#InvalidParameterException":
                            return [
                                3,
                                6
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3,
                                8
                            ];
                        case "com.amazonaws.sns#ResourceNotFoundException":
                            return [
                                3,
                                8
                            ];
                        case "ThrottledException":
                            return [
                                3,
                                10
                            ];
                        case "com.amazonaws.sns#ThrottledException":
                            return [
                                3,
                                10
                            ];
                        case "VerificationException":
                            return [
                                3,
                                12
                            ];
                        case "com.amazonaws.sns#VerificationException":
                            return [
                                3,
                                12
                            ];
                    }
                    return [
                        3,
                        14
                    ];
                case 2:
                    return [
                        4,
                        $e1011dd782da33d8$var$deserializeAws_queryAuthorizationErrorExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    throw _d.sent();
                case 4:
                    return [
                        4,
                        $e1011dd782da33d8$var$deserializeAws_queryInternalErrorExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    throw _d.sent();
                case 6:
                    return [
                        4,
                        $e1011dd782da33d8$var$deserializeAws_queryInvalidParameterExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    throw _d.sent();
                case 8:
                    return [
                        4,
                        $e1011dd782da33d8$var$deserializeAws_queryResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    throw _d.sent();
                case 10:
                    return [
                        4,
                        $e1011dd782da33d8$var$deserializeAws_queryThrottledExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    throw _d.sent();
                case 12:
                    return [
                        4,
                        $e1011dd782da33d8$var$deserializeAws_queryVerificationExceptionResponse(parsedOutput, context)
                    ];
                case 13:
                    throw _d.sent();
                case 14:
                    parsedBody = parsedOutput.body;
                    response = new (0, $411eb8c425b27262$export$6ce7aba8257a989c)({
                        name: parsedBody.Error.code || parsedBody.Error.Code || errorCode,
                        $fault: "client",
                        $metadata: $e1011dd782da33d8$var$deserializeMetadata(output)
                    });
                    throw (0, $a08c2c31e27e9e11$export$db01f0c43e877a50)(response, parsedBody.Error);
            }
        });
    });
};
var $e1011dd782da33d8$var$deserializeAws_queryAuthorizationErrorExceptionResponse = function(parsedOutput, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var body, deserialized, exception;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            body = parsedOutput.body;
            deserialized = $e1011dd782da33d8$var$deserializeAws_queryAuthorizationErrorException(body.Error, context);
            exception = new (0, $267a5477e1e57441$export$d912356501f9a666)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
                $metadata: $e1011dd782da33d8$var$deserializeMetadata(parsedOutput)
            }, deserialized));
            return [
                2,
                (0, $a08c2c31e27e9e11$export$db01f0c43e877a50)(exception, body)
            ];
        });
    });
};
var $e1011dd782da33d8$var$deserializeAws_queryBatchEntryIdsNotDistinctExceptionResponse = function(parsedOutput, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var body, deserialized, exception;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            body = parsedOutput.body;
            deserialized = $e1011dd782da33d8$var$deserializeAws_queryBatchEntryIdsNotDistinctException(body.Error, context);
            exception = new (0, $267a5477e1e57441$export$ddc67a9a76e1039f)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
                $metadata: $e1011dd782da33d8$var$deserializeMetadata(parsedOutput)
            }, deserialized));
            return [
                2,
                (0, $a08c2c31e27e9e11$export$db01f0c43e877a50)(exception, body)
            ];
        });
    });
};
var $e1011dd782da33d8$var$deserializeAws_queryBatchRequestTooLongExceptionResponse = function(parsedOutput, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var body, deserialized, exception;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            body = parsedOutput.body;
            deserialized = $e1011dd782da33d8$var$deserializeAws_queryBatchRequestTooLongException(body.Error, context);
            exception = new (0, $267a5477e1e57441$export$e9c098864c3a08f)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
                $metadata: $e1011dd782da33d8$var$deserializeMetadata(parsedOutput)
            }, deserialized));
            return [
                2,
                (0, $a08c2c31e27e9e11$export$db01f0c43e877a50)(exception, body)
            ];
        });
    });
};
var $e1011dd782da33d8$var$deserializeAws_queryConcurrentAccessExceptionResponse = function(parsedOutput, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var body, deserialized, exception;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            body = parsedOutput.body;
            deserialized = $e1011dd782da33d8$var$deserializeAws_queryConcurrentAccessException(body.Error, context);
            exception = new (0, $267a5477e1e57441$export$f9b664e19df1b4c5)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
                $metadata: $e1011dd782da33d8$var$deserializeMetadata(parsedOutput)
            }, deserialized));
            return [
                2,
                (0, $a08c2c31e27e9e11$export$db01f0c43e877a50)(exception, body)
            ];
        });
    });
};
var $e1011dd782da33d8$var$deserializeAws_queryEmptyBatchRequestExceptionResponse = function(parsedOutput, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var body, deserialized, exception;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            body = parsedOutput.body;
            deserialized = $e1011dd782da33d8$var$deserializeAws_queryEmptyBatchRequestException(body.Error, context);
            exception = new (0, $267a5477e1e57441$export$fe808316dada89f2)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
                $metadata: $e1011dd782da33d8$var$deserializeMetadata(parsedOutput)
            }, deserialized));
            return [
                2,
                (0, $a08c2c31e27e9e11$export$db01f0c43e877a50)(exception, body)
            ];
        });
    });
};
var $e1011dd782da33d8$var$deserializeAws_queryEndpointDisabledExceptionResponse = function(parsedOutput, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var body, deserialized, exception;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            body = parsedOutput.body;
            deserialized = $e1011dd782da33d8$var$deserializeAws_queryEndpointDisabledException(body.Error, context);
            exception = new (0, $267a5477e1e57441$export$6419aca88c7742c4)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
                $metadata: $e1011dd782da33d8$var$deserializeMetadata(parsedOutput)
            }, deserialized));
            return [
                2,
                (0, $a08c2c31e27e9e11$export$db01f0c43e877a50)(exception, body)
            ];
        });
    });
};
var $e1011dd782da33d8$var$deserializeAws_queryFilterPolicyLimitExceededExceptionResponse = function(parsedOutput, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var body, deserialized, exception;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            body = parsedOutput.body;
            deserialized = $e1011dd782da33d8$var$deserializeAws_queryFilterPolicyLimitExceededException(body.Error, context);
            exception = new (0, $267a5477e1e57441$export$59b231b54ab1db1f)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
                $metadata: $e1011dd782da33d8$var$deserializeMetadata(parsedOutput)
            }, deserialized));
            return [
                2,
                (0, $a08c2c31e27e9e11$export$db01f0c43e877a50)(exception, body)
            ];
        });
    });
};
var $e1011dd782da33d8$var$deserializeAws_queryInternalErrorExceptionResponse = function(parsedOutput, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var body, deserialized, exception;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            body = parsedOutput.body;
            deserialized = $e1011dd782da33d8$var$deserializeAws_queryInternalErrorException(body.Error, context);
            exception = new (0, $267a5477e1e57441$export$8b0f706f4df56c63)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
                $metadata: $e1011dd782da33d8$var$deserializeMetadata(parsedOutput)
            }, deserialized));
            return [
                2,
                (0, $a08c2c31e27e9e11$export$db01f0c43e877a50)(exception, body)
            ];
        });
    });
};
var $e1011dd782da33d8$var$deserializeAws_queryInvalidBatchEntryIdExceptionResponse = function(parsedOutput, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var body, deserialized, exception;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            body = parsedOutput.body;
            deserialized = $e1011dd782da33d8$var$deserializeAws_queryInvalidBatchEntryIdException(body.Error, context);
            exception = new (0, $267a5477e1e57441$export$8cceaab6fa396dbb)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
                $metadata: $e1011dd782da33d8$var$deserializeMetadata(parsedOutput)
            }, deserialized));
            return [
                2,
                (0, $a08c2c31e27e9e11$export$db01f0c43e877a50)(exception, body)
            ];
        });
    });
};
var $e1011dd782da33d8$var$deserializeAws_queryInvalidParameterExceptionResponse = function(parsedOutput, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var body, deserialized, exception;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            body = parsedOutput.body;
            deserialized = $e1011dd782da33d8$var$deserializeAws_queryInvalidParameterException(body.Error, context);
            exception = new (0, $267a5477e1e57441$export$fa781b52e13bf866)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
                $metadata: $e1011dd782da33d8$var$deserializeMetadata(parsedOutput)
            }, deserialized));
            return [
                2,
                (0, $a08c2c31e27e9e11$export$db01f0c43e877a50)(exception, body)
            ];
        });
    });
};
var $e1011dd782da33d8$var$deserializeAws_queryInvalidParameterValueExceptionResponse = function(parsedOutput, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var body, deserialized, exception;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            body = parsedOutput.body;
            deserialized = $e1011dd782da33d8$var$deserializeAws_queryInvalidParameterValueException(body.Error, context);
            exception = new (0, $267a5477e1e57441$export$dc68e798006b2b42)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
                $metadata: $e1011dd782da33d8$var$deserializeMetadata(parsedOutput)
            }, deserialized));
            return [
                2,
                (0, $a08c2c31e27e9e11$export$db01f0c43e877a50)(exception, body)
            ];
        });
    });
};
var $e1011dd782da33d8$var$deserializeAws_queryInvalidSecurityExceptionResponse = function(parsedOutput, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var body, deserialized, exception;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            body = parsedOutput.body;
            deserialized = $e1011dd782da33d8$var$deserializeAws_queryInvalidSecurityException(body.Error, context);
            exception = new (0, $267a5477e1e57441$export$7cf5bde9ac6b75ab)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
                $metadata: $e1011dd782da33d8$var$deserializeMetadata(parsedOutput)
            }, deserialized));
            return [
                2,
                (0, $a08c2c31e27e9e11$export$db01f0c43e877a50)(exception, body)
            ];
        });
    });
};
var $e1011dd782da33d8$var$deserializeAws_queryKMSAccessDeniedExceptionResponse = function(parsedOutput, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var body, deserialized, exception;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            body = parsedOutput.body;
            deserialized = $e1011dd782da33d8$var$deserializeAws_queryKMSAccessDeniedException(body.Error, context);
            exception = new (0, $267a5477e1e57441$export$94ad5f879b39c8eb)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
                $metadata: $e1011dd782da33d8$var$deserializeMetadata(parsedOutput)
            }, deserialized));
            return [
                2,
                (0, $a08c2c31e27e9e11$export$db01f0c43e877a50)(exception, body)
            ];
        });
    });
};
var $e1011dd782da33d8$var$deserializeAws_queryKMSDisabledExceptionResponse = function(parsedOutput, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var body, deserialized, exception;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            body = parsedOutput.body;
            deserialized = $e1011dd782da33d8$var$deserializeAws_queryKMSDisabledException(body.Error, context);
            exception = new (0, $267a5477e1e57441$export$bc1172aa6ec4fb7b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
                $metadata: $e1011dd782da33d8$var$deserializeMetadata(parsedOutput)
            }, deserialized));
            return [
                2,
                (0, $a08c2c31e27e9e11$export$db01f0c43e877a50)(exception, body)
            ];
        });
    });
};
var $e1011dd782da33d8$var$deserializeAws_queryKMSInvalidStateExceptionResponse = function(parsedOutput, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var body, deserialized, exception;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            body = parsedOutput.body;
            deserialized = $e1011dd782da33d8$var$deserializeAws_queryKMSInvalidStateException(body.Error, context);
            exception = new (0, $267a5477e1e57441$export$16b76627a54694a8)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
                $metadata: $e1011dd782da33d8$var$deserializeMetadata(parsedOutput)
            }, deserialized));
            return [
                2,
                (0, $a08c2c31e27e9e11$export$db01f0c43e877a50)(exception, body)
            ];
        });
    });
};
var $e1011dd782da33d8$var$deserializeAws_queryKMSNotFoundExceptionResponse = function(parsedOutput, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var body, deserialized, exception;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            body = parsedOutput.body;
            deserialized = $e1011dd782da33d8$var$deserializeAws_queryKMSNotFoundException(body.Error, context);
            exception = new (0, $267a5477e1e57441$export$38af9cf22646c616)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
                $metadata: $e1011dd782da33d8$var$deserializeMetadata(parsedOutput)
            }, deserialized));
            return [
                2,
                (0, $a08c2c31e27e9e11$export$db01f0c43e877a50)(exception, body)
            ];
        });
    });
};
var $e1011dd782da33d8$var$deserializeAws_queryKMSOptInRequiredResponse = function(parsedOutput, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var body, deserialized, exception;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            body = parsedOutput.body;
            deserialized = $e1011dd782da33d8$var$deserializeAws_queryKMSOptInRequired(body.Error, context);
            exception = new (0, $267a5477e1e57441$export$c7451d555b19eb91)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
                $metadata: $e1011dd782da33d8$var$deserializeMetadata(parsedOutput)
            }, deserialized));
            return [
                2,
                (0, $a08c2c31e27e9e11$export$db01f0c43e877a50)(exception, body)
            ];
        });
    });
};
var $e1011dd782da33d8$var$deserializeAws_queryKMSThrottlingExceptionResponse = function(parsedOutput, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var body, deserialized, exception;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            body = parsedOutput.body;
            deserialized = $e1011dd782da33d8$var$deserializeAws_queryKMSThrottlingException(body.Error, context);
            exception = new (0, $267a5477e1e57441$export$30e0c54ebe285f2a)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
                $metadata: $e1011dd782da33d8$var$deserializeMetadata(parsedOutput)
            }, deserialized));
            return [
                2,
                (0, $a08c2c31e27e9e11$export$db01f0c43e877a50)(exception, body)
            ];
        });
    });
};
var $e1011dd782da33d8$var$deserializeAws_queryNotFoundExceptionResponse = function(parsedOutput, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var body, deserialized, exception;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            body = parsedOutput.body;
            deserialized = $e1011dd782da33d8$var$deserializeAws_queryNotFoundException(body.Error, context);
            exception = new (0, $267a5477e1e57441$export$32cc081a9594a58d)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
                $metadata: $e1011dd782da33d8$var$deserializeMetadata(parsedOutput)
            }, deserialized));
            return [
                2,
                (0, $a08c2c31e27e9e11$export$db01f0c43e877a50)(exception, body)
            ];
        });
    });
};
var $e1011dd782da33d8$var$deserializeAws_queryOptedOutExceptionResponse = function(parsedOutput, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var body, deserialized, exception;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            body = parsedOutput.body;
            deserialized = $e1011dd782da33d8$var$deserializeAws_queryOptedOutException(body.Error, context);
            exception = new (0, $267a5477e1e57441$export$ad37e326ac954b51)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
                $metadata: $e1011dd782da33d8$var$deserializeMetadata(parsedOutput)
            }, deserialized));
            return [
                2,
                (0, $a08c2c31e27e9e11$export$db01f0c43e877a50)(exception, body)
            ];
        });
    });
};
var $e1011dd782da33d8$var$deserializeAws_queryPlatformApplicationDisabledExceptionResponse = function(parsedOutput, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var body, deserialized, exception;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            body = parsedOutput.body;
            deserialized = $e1011dd782da33d8$var$deserializeAws_queryPlatformApplicationDisabledException(body.Error, context);
            exception = new (0, $267a5477e1e57441$export$6fd5bb9509c41695)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
                $metadata: $e1011dd782da33d8$var$deserializeMetadata(parsedOutput)
            }, deserialized));
            return [
                2,
                (0, $a08c2c31e27e9e11$export$db01f0c43e877a50)(exception, body)
            ];
        });
    });
};
var $e1011dd782da33d8$var$deserializeAws_queryResourceNotFoundExceptionResponse = function(parsedOutput, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var body, deserialized, exception;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            body = parsedOutput.body;
            deserialized = $e1011dd782da33d8$var$deserializeAws_queryResourceNotFoundException(body.Error, context);
            exception = new (0, $267a5477e1e57441$export$ecba565262f8bb2)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
                $metadata: $e1011dd782da33d8$var$deserializeMetadata(parsedOutput)
            }, deserialized));
            return [
                2,
                (0, $a08c2c31e27e9e11$export$db01f0c43e877a50)(exception, body)
            ];
        });
    });
};
var $e1011dd782da33d8$var$deserializeAws_queryStaleTagExceptionResponse = function(parsedOutput, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var body, deserialized, exception;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            body = parsedOutput.body;
            deserialized = $e1011dd782da33d8$var$deserializeAws_queryStaleTagException(body.Error, context);
            exception = new (0, $267a5477e1e57441$export$2a8546160994da50)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
                $metadata: $e1011dd782da33d8$var$deserializeMetadata(parsedOutput)
            }, deserialized));
            return [
                2,
                (0, $a08c2c31e27e9e11$export$db01f0c43e877a50)(exception, body)
            ];
        });
    });
};
var $e1011dd782da33d8$var$deserializeAws_querySubscriptionLimitExceededExceptionResponse = function(parsedOutput, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var body, deserialized, exception;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            body = parsedOutput.body;
            deserialized = $e1011dd782da33d8$var$deserializeAws_querySubscriptionLimitExceededException(body.Error, context);
            exception = new (0, $267a5477e1e57441$export$950b6523cccf42ca)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
                $metadata: $e1011dd782da33d8$var$deserializeMetadata(parsedOutput)
            }, deserialized));
            return [
                2,
                (0, $a08c2c31e27e9e11$export$db01f0c43e877a50)(exception, body)
            ];
        });
    });
};
var $e1011dd782da33d8$var$deserializeAws_queryTagLimitExceededExceptionResponse = function(parsedOutput, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var body, deserialized, exception;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            body = parsedOutput.body;
            deserialized = $e1011dd782da33d8$var$deserializeAws_queryTagLimitExceededException(body.Error, context);
            exception = new (0, $267a5477e1e57441$export$27b07a8f2616d8bf)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
                $metadata: $e1011dd782da33d8$var$deserializeMetadata(parsedOutput)
            }, deserialized));
            return [
                2,
                (0, $a08c2c31e27e9e11$export$db01f0c43e877a50)(exception, body)
            ];
        });
    });
};
var $e1011dd782da33d8$var$deserializeAws_queryTagPolicyExceptionResponse = function(parsedOutput, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var body, deserialized, exception;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            body = parsedOutput.body;
            deserialized = $e1011dd782da33d8$var$deserializeAws_queryTagPolicyException(body.Error, context);
            exception = new (0, $267a5477e1e57441$export$85a2e341180e2619)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
                $metadata: $e1011dd782da33d8$var$deserializeMetadata(parsedOutput)
            }, deserialized));
            return [
                2,
                (0, $a08c2c31e27e9e11$export$db01f0c43e877a50)(exception, body)
            ];
        });
    });
};
var $e1011dd782da33d8$var$deserializeAws_queryThrottledExceptionResponse = function(parsedOutput, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var body, deserialized, exception;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            body = parsedOutput.body;
            deserialized = $e1011dd782da33d8$var$deserializeAws_queryThrottledException(body.Error, context);
            exception = new (0, $267a5477e1e57441$export$ecd24e243f135e95)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
                $metadata: $e1011dd782da33d8$var$deserializeMetadata(parsedOutput)
            }, deserialized));
            return [
                2,
                (0, $a08c2c31e27e9e11$export$db01f0c43e877a50)(exception, body)
            ];
        });
    });
};
var $e1011dd782da33d8$var$deserializeAws_queryTooManyEntriesInBatchRequestExceptionResponse = function(parsedOutput, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var body, deserialized, exception;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            body = parsedOutput.body;
            deserialized = $e1011dd782da33d8$var$deserializeAws_queryTooManyEntriesInBatchRequestException(body.Error, context);
            exception = new (0, $267a5477e1e57441$export$4340120a6f76d3c7)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
                $metadata: $e1011dd782da33d8$var$deserializeMetadata(parsedOutput)
            }, deserialized));
            return [
                2,
                (0, $a08c2c31e27e9e11$export$db01f0c43e877a50)(exception, body)
            ];
        });
    });
};
var $e1011dd782da33d8$var$deserializeAws_queryTopicLimitExceededExceptionResponse = function(parsedOutput, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var body, deserialized, exception;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            body = parsedOutput.body;
            deserialized = $e1011dd782da33d8$var$deserializeAws_queryTopicLimitExceededException(body.Error, context);
            exception = new (0, $267a5477e1e57441$export$5a83f7e2f73a45a)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
                $metadata: $e1011dd782da33d8$var$deserializeMetadata(parsedOutput)
            }, deserialized));
            return [
                2,
                (0, $a08c2c31e27e9e11$export$db01f0c43e877a50)(exception, body)
            ];
        });
    });
};
var $e1011dd782da33d8$var$deserializeAws_queryUserErrorExceptionResponse = function(parsedOutput, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var body, deserialized, exception;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            body = parsedOutput.body;
            deserialized = $e1011dd782da33d8$var$deserializeAws_queryUserErrorException(body.Error, context);
            exception = new (0, $267a5477e1e57441$export$795017c7272512f4)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
                $metadata: $e1011dd782da33d8$var$deserializeMetadata(parsedOutput)
            }, deserialized));
            return [
                2,
                (0, $a08c2c31e27e9e11$export$db01f0c43e877a50)(exception, body)
            ];
        });
    });
};
var $e1011dd782da33d8$var$deserializeAws_queryValidationExceptionResponse = function(parsedOutput, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var body, deserialized, exception;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            body = parsedOutput.body;
            deserialized = $e1011dd782da33d8$var$deserializeAws_queryValidationException(body.Error, context);
            exception = new (0, $267a5477e1e57441$export$1dbb1718e06c41be)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
                $metadata: $e1011dd782da33d8$var$deserializeMetadata(parsedOutput)
            }, deserialized));
            return [
                2,
                (0, $a08c2c31e27e9e11$export$db01f0c43e877a50)(exception, body)
            ];
        });
    });
};
var $e1011dd782da33d8$var$deserializeAws_queryVerificationExceptionResponse = function(parsedOutput, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var body, deserialized, exception;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            body = parsedOutput.body;
            deserialized = $e1011dd782da33d8$var$deserializeAws_queryVerificationException(body.Error, context);
            exception = new (0, $267a5477e1e57441$export$e94d56aa2c3e58d6)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
                $metadata: $e1011dd782da33d8$var$deserializeMetadata(parsedOutput)
            }, deserialized));
            return [
                2,
                (0, $a08c2c31e27e9e11$export$db01f0c43e877a50)(exception, body)
            ];
        });
    });
};
var $e1011dd782da33d8$var$serializeAws_queryActionsList = function(input, context) {
    var e_1, _a;
    var entries = {};
    var counter = 1;
    try {
        for(var input_1 = (0, $5c96a02c592fcff1$export$19a8beecd37a4c45)(input), input_1_1 = input_1.next(); !input_1_1.done; input_1_1 = input_1.next()){
            var entry = input_1_1.value;
            if (entry === null) continue;
            entries["member." + counter] = entry;
            counter++;
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (input_1_1 && !input_1_1.done && (_a = input_1.return)) _a.call(input_1);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
    return entries;
};
var $e1011dd782da33d8$var$serializeAws_queryAddPermissionInput = function(input, context) {
    var entries = {};
    if (input.TopicArn !== undefined && input.TopicArn !== null) entries["TopicArn"] = input.TopicArn;
    if (input.Label !== undefined && input.Label !== null) entries["Label"] = input.Label;
    if (input.AWSAccountId !== undefined && input.AWSAccountId !== null) {
        var memberEntries = $e1011dd782da33d8$var$serializeAws_queryDelegatesList(input.AWSAccountId, context);
        Object.entries(memberEntries).forEach(function(_a) {
            var _b = (0, $5c96a02c592fcff1$export$8d051b38c9118094)(_a, 2), key = _b[0], value = _b[1];
            var loc = "AWSAccountId." + key;
            entries[loc] = value;
        });
    }
    if (input.ActionName !== undefined && input.ActionName !== null) {
        var memberEntries = $e1011dd782da33d8$var$serializeAws_queryActionsList(input.ActionName, context);
        Object.entries(memberEntries).forEach(function(_a) {
            var _b = (0, $5c96a02c592fcff1$export$8d051b38c9118094)(_a, 2), key = _b[0], value = _b[1];
            var loc = "ActionName." + key;
            entries[loc] = value;
        });
    }
    return entries;
};
var $e1011dd782da33d8$var$serializeAws_queryCheckIfPhoneNumberIsOptedOutInput = function(input, context) {
    var entries = {};
    if (input.phoneNumber !== undefined && input.phoneNumber !== null) entries["phoneNumber"] = input.phoneNumber;
    return entries;
};
var $e1011dd782da33d8$var$serializeAws_queryConfirmSubscriptionInput = function(input, context) {
    var entries = {};
    if (input.TopicArn !== undefined && input.TopicArn !== null) entries["TopicArn"] = input.TopicArn;
    if (input.Token !== undefined && input.Token !== null) entries["Token"] = input.Token;
    if (input.AuthenticateOnUnsubscribe !== undefined && input.AuthenticateOnUnsubscribe !== null) entries["AuthenticateOnUnsubscribe"] = input.AuthenticateOnUnsubscribe;
    return entries;
};
var $e1011dd782da33d8$var$serializeAws_queryCreatePlatformApplicationInput = function(input, context) {
    var entries = {};
    if (input.Name !== undefined && input.Name !== null) entries["Name"] = input.Name;
    if (input.Platform !== undefined && input.Platform !== null) entries["Platform"] = input.Platform;
    if (input.Attributes !== undefined && input.Attributes !== null) {
        var memberEntries = $e1011dd782da33d8$var$serializeAws_queryMapStringToString(input.Attributes, context);
        Object.entries(memberEntries).forEach(function(_a) {
            var _b = (0, $5c96a02c592fcff1$export$8d051b38c9118094)(_a, 2), key = _b[0], value = _b[1];
            var loc = "Attributes." + key;
            entries[loc] = value;
        });
    }
    return entries;
};
var $e1011dd782da33d8$var$serializeAws_queryCreatePlatformEndpointInput = function(input, context) {
    var entries = {};
    if (input.PlatformApplicationArn !== undefined && input.PlatformApplicationArn !== null) entries["PlatformApplicationArn"] = input.PlatformApplicationArn;
    if (input.Token !== undefined && input.Token !== null) entries["Token"] = input.Token;
    if (input.CustomUserData !== undefined && input.CustomUserData !== null) entries["CustomUserData"] = input.CustomUserData;
    if (input.Attributes !== undefined && input.Attributes !== null) {
        var memberEntries = $e1011dd782da33d8$var$serializeAws_queryMapStringToString(input.Attributes, context);
        Object.entries(memberEntries).forEach(function(_a) {
            var _b = (0, $5c96a02c592fcff1$export$8d051b38c9118094)(_a, 2), key = _b[0], value = _b[1];
            var loc = "Attributes." + key;
            entries[loc] = value;
        });
    }
    return entries;
};
var $e1011dd782da33d8$var$serializeAws_queryCreateSMSSandboxPhoneNumberInput = function(input, context) {
    var entries = {};
    if (input.PhoneNumber !== undefined && input.PhoneNumber !== null) entries["PhoneNumber"] = input.PhoneNumber;
    if (input.LanguageCode !== undefined && input.LanguageCode !== null) entries["LanguageCode"] = input.LanguageCode;
    return entries;
};
var $e1011dd782da33d8$var$serializeAws_queryCreateTopicInput = function(input, context) {
    var entries = {};
    if (input.Name !== undefined && input.Name !== null) entries["Name"] = input.Name;
    if (input.Attributes !== undefined && input.Attributes !== null) {
        var memberEntries = $e1011dd782da33d8$var$serializeAws_queryTopicAttributesMap(input.Attributes, context);
        Object.entries(memberEntries).forEach(function(_a) {
            var _b = (0, $5c96a02c592fcff1$export$8d051b38c9118094)(_a, 2), key = _b[0], value = _b[1];
            var loc = "Attributes." + key;
            entries[loc] = value;
        });
    }
    if (input.Tags !== undefined && input.Tags !== null) {
        var memberEntries = $e1011dd782da33d8$var$serializeAws_queryTagList(input.Tags, context);
        Object.entries(memberEntries).forEach(function(_a) {
            var _b = (0, $5c96a02c592fcff1$export$8d051b38c9118094)(_a, 2), key = _b[0], value = _b[1];
            var loc = "Tags." + key;
            entries[loc] = value;
        });
    }
    return entries;
};
var $e1011dd782da33d8$var$serializeAws_queryDelegatesList = function(input, context) {
    var e_2, _a;
    var entries = {};
    var counter = 1;
    try {
        for(var input_2 = (0, $5c96a02c592fcff1$export$19a8beecd37a4c45)(input), input_2_1 = input_2.next(); !input_2_1.done; input_2_1 = input_2.next()){
            var entry = input_2_1.value;
            if (entry === null) continue;
            entries["member." + counter] = entry;
            counter++;
        }
    } catch (e_2_1) {
        e_2 = {
            error: e_2_1
        };
    } finally{
        try {
            if (input_2_1 && !input_2_1.done && (_a = input_2.return)) _a.call(input_2);
        } finally{
            if (e_2) throw e_2.error;
        }
    }
    return entries;
};
var $e1011dd782da33d8$var$serializeAws_queryDeleteEndpointInput = function(input, context) {
    var entries = {};
    if (input.EndpointArn !== undefined && input.EndpointArn !== null) entries["EndpointArn"] = input.EndpointArn;
    return entries;
};
var $e1011dd782da33d8$var$serializeAws_queryDeletePlatformApplicationInput = function(input, context) {
    var entries = {};
    if (input.PlatformApplicationArn !== undefined && input.PlatformApplicationArn !== null) entries["PlatformApplicationArn"] = input.PlatformApplicationArn;
    return entries;
};
var $e1011dd782da33d8$var$serializeAws_queryDeleteSMSSandboxPhoneNumberInput = function(input, context) {
    var entries = {};
    if (input.PhoneNumber !== undefined && input.PhoneNumber !== null) entries["PhoneNumber"] = input.PhoneNumber;
    return entries;
};
var $e1011dd782da33d8$var$serializeAws_queryDeleteTopicInput = function(input, context) {
    var entries = {};
    if (input.TopicArn !== undefined && input.TopicArn !== null) entries["TopicArn"] = input.TopicArn;
    return entries;
};
var $e1011dd782da33d8$var$serializeAws_queryGetEndpointAttributesInput = function(input, context) {
    var entries = {};
    if (input.EndpointArn !== undefined && input.EndpointArn !== null) entries["EndpointArn"] = input.EndpointArn;
    return entries;
};
var $e1011dd782da33d8$var$serializeAws_queryGetPlatformApplicationAttributesInput = function(input, context) {
    var entries = {};
    if (input.PlatformApplicationArn !== undefined && input.PlatformApplicationArn !== null) entries["PlatformApplicationArn"] = input.PlatformApplicationArn;
    return entries;
};
var $e1011dd782da33d8$var$serializeAws_queryGetSMSAttributesInput = function(input, context) {
    var entries = {};
    if (input.attributes !== undefined && input.attributes !== null) {
        var memberEntries = $e1011dd782da33d8$var$serializeAws_queryListString(input.attributes, context);
        Object.entries(memberEntries).forEach(function(_a) {
            var _b = (0, $5c96a02c592fcff1$export$8d051b38c9118094)(_a, 2), key = _b[0], value = _b[1];
            var loc = "attributes." + key;
            entries[loc] = value;
        });
    }
    return entries;
};
var $e1011dd782da33d8$var$serializeAws_queryGetSMSSandboxAccountStatusInput = function(input, context) {
    var entries = {};
    return entries;
};
var $e1011dd782da33d8$var$serializeAws_queryGetSubscriptionAttributesInput = function(input, context) {
    var entries = {};
    if (input.SubscriptionArn !== undefined && input.SubscriptionArn !== null) entries["SubscriptionArn"] = input.SubscriptionArn;
    return entries;
};
var $e1011dd782da33d8$var$serializeAws_queryGetTopicAttributesInput = function(input, context) {
    var entries = {};
    if (input.TopicArn !== undefined && input.TopicArn !== null) entries["TopicArn"] = input.TopicArn;
    return entries;
};
var $e1011dd782da33d8$var$serializeAws_queryListEndpointsByPlatformApplicationInput = function(input, context) {
    var entries = {};
    if (input.PlatformApplicationArn !== undefined && input.PlatformApplicationArn !== null) entries["PlatformApplicationArn"] = input.PlatformApplicationArn;
    if (input.NextToken !== undefined && input.NextToken !== null) entries["NextToken"] = input.NextToken;
    return entries;
};
var $e1011dd782da33d8$var$serializeAws_queryListOriginationNumbersRequest = function(input, context) {
    var entries = {};
    if (input.NextToken !== undefined && input.NextToken !== null) entries["NextToken"] = input.NextToken;
    if (input.MaxResults !== undefined && input.MaxResults !== null) entries["MaxResults"] = input.MaxResults;
    return entries;
};
var $e1011dd782da33d8$var$serializeAws_queryListPhoneNumbersOptedOutInput = function(input, context) {
    var entries = {};
    if (input.nextToken !== undefined && input.nextToken !== null) entries["nextToken"] = input.nextToken;
    return entries;
};
var $e1011dd782da33d8$var$serializeAws_queryListPlatformApplicationsInput = function(input, context) {
    var entries = {};
    if (input.NextToken !== undefined && input.NextToken !== null) entries["NextToken"] = input.NextToken;
    return entries;
};
var $e1011dd782da33d8$var$serializeAws_queryListSMSSandboxPhoneNumbersInput = function(input, context) {
    var entries = {};
    if (input.NextToken !== undefined && input.NextToken !== null) entries["NextToken"] = input.NextToken;
    if (input.MaxResults !== undefined && input.MaxResults !== null) entries["MaxResults"] = input.MaxResults;
    return entries;
};
var $e1011dd782da33d8$var$serializeAws_queryListString = function(input, context) {
    var e_3, _a;
    var entries = {};
    var counter = 1;
    try {
        for(var input_3 = (0, $5c96a02c592fcff1$export$19a8beecd37a4c45)(input), input_3_1 = input_3.next(); !input_3_1.done; input_3_1 = input_3.next()){
            var entry = input_3_1.value;
            if (entry === null) continue;
            entries["member." + counter] = entry;
            counter++;
        }
    } catch (e_3_1) {
        e_3 = {
            error: e_3_1
        };
    } finally{
        try {
            if (input_3_1 && !input_3_1.done && (_a = input_3.return)) _a.call(input_3);
        } finally{
            if (e_3) throw e_3.error;
        }
    }
    return entries;
};
var $e1011dd782da33d8$var$serializeAws_queryListSubscriptionsByTopicInput = function(input, context) {
    var entries = {};
    if (input.TopicArn !== undefined && input.TopicArn !== null) entries["TopicArn"] = input.TopicArn;
    if (input.NextToken !== undefined && input.NextToken !== null) entries["NextToken"] = input.NextToken;
    return entries;
};
var $e1011dd782da33d8$var$serializeAws_queryListSubscriptionsInput = function(input, context) {
    var entries = {};
    if (input.NextToken !== undefined && input.NextToken !== null) entries["NextToken"] = input.NextToken;
    return entries;
};
var $e1011dd782da33d8$var$serializeAws_queryListTagsForResourceRequest = function(input, context) {
    var entries = {};
    if (input.ResourceArn !== undefined && input.ResourceArn !== null) entries["ResourceArn"] = input.ResourceArn;
    return entries;
};
var $e1011dd782da33d8$var$serializeAws_queryListTopicsInput = function(input, context) {
    var entries = {};
    if (input.NextToken !== undefined && input.NextToken !== null) entries["NextToken"] = input.NextToken;
    return entries;
};
var $e1011dd782da33d8$var$serializeAws_queryMapStringToString = function(input, context) {
    var entries = {};
    var counter = 1;
    Object.keys(input).filter(function(key) {
        return input[key] != null;
    }).forEach(function(key) {
        entries["entry." + counter + ".key"] = key;
        entries["entry." + counter + ".value"] = input[key];
        counter++;
    });
    return entries;
};
var $e1011dd782da33d8$var$serializeAws_queryMessageAttributeMap = function(input, context) {
    var entries = {};
    var counter = 1;
    Object.keys(input).filter(function(key) {
        return input[key] != null;
    }).forEach(function(key) {
        entries["entry." + counter + ".Name"] = key;
        var memberEntries = $e1011dd782da33d8$var$serializeAws_queryMessageAttributeValue(input[key], context);
        Object.entries(memberEntries).forEach(function(_a) {
            var _b = (0, $5c96a02c592fcff1$export$8d051b38c9118094)(_a, 2), key = _b[0], value = _b[1];
            entries["entry." + counter + ".Value." + key] = value;
        });
        counter++;
    });
    return entries;
};
var $e1011dd782da33d8$var$serializeAws_queryMessageAttributeValue = function(input, context) {
    var entries = {};
    if (input.DataType !== undefined && input.DataType !== null) entries["DataType"] = input.DataType;
    if (input.StringValue !== undefined && input.StringValue !== null) entries["StringValue"] = input.StringValue;
    if (input.BinaryValue !== undefined && input.BinaryValue !== null) entries["BinaryValue"] = context.base64Encoder(input.BinaryValue);
    return entries;
};
var $e1011dd782da33d8$var$serializeAws_queryOptInPhoneNumberInput = function(input, context) {
    var entries = {};
    if (input.phoneNumber !== undefined && input.phoneNumber !== null) entries["phoneNumber"] = input.phoneNumber;
    return entries;
};
var $e1011dd782da33d8$var$serializeAws_queryPublishBatchInput = function(input, context) {
    var entries = {};
    if (input.TopicArn !== undefined && input.TopicArn !== null) entries["TopicArn"] = input.TopicArn;
    if (input.PublishBatchRequestEntries !== undefined && input.PublishBatchRequestEntries !== null) {
        var memberEntries = $e1011dd782da33d8$var$serializeAws_queryPublishBatchRequestEntryList(input.PublishBatchRequestEntries, context);
        Object.entries(memberEntries).forEach(function(_a) {
            var _b = (0, $5c96a02c592fcff1$export$8d051b38c9118094)(_a, 2), key = _b[0], value = _b[1];
            var loc = "PublishBatchRequestEntries." + key;
            entries[loc] = value;
        });
    }
    return entries;
};
var $e1011dd782da33d8$var$serializeAws_queryPublishBatchRequestEntry = function(input, context) {
    var entries = {};
    if (input.Id !== undefined && input.Id !== null) entries["Id"] = input.Id;
    if (input.Message !== undefined && input.Message !== null) entries["Message"] = input.Message;
    if (input.Subject !== undefined && input.Subject !== null) entries["Subject"] = input.Subject;
    if (input.MessageStructure !== undefined && input.MessageStructure !== null) entries["MessageStructure"] = input.MessageStructure;
    if (input.MessageAttributes !== undefined && input.MessageAttributes !== null) {
        var memberEntries = $e1011dd782da33d8$var$serializeAws_queryMessageAttributeMap(input.MessageAttributes, context);
        Object.entries(memberEntries).forEach(function(_a) {
            var _b = (0, $5c96a02c592fcff1$export$8d051b38c9118094)(_a, 2), key = _b[0], value = _b[1];
            var loc = "MessageAttributes." + key;
            entries[loc] = value;
        });
    }
    if (input.MessageDeduplicationId !== undefined && input.MessageDeduplicationId !== null) entries["MessageDeduplicationId"] = input.MessageDeduplicationId;
    if (input.MessageGroupId !== undefined && input.MessageGroupId !== null) entries["MessageGroupId"] = input.MessageGroupId;
    return entries;
};
var $e1011dd782da33d8$var$serializeAws_queryPublishBatchRequestEntryList = function(input, context) {
    var e_4, _a;
    var entries = {};
    var counter = 1;
    try {
        for(var input_4 = (0, $5c96a02c592fcff1$export$19a8beecd37a4c45)(input), input_4_1 = input_4.next(); !input_4_1.done; input_4_1 = input_4.next()){
            var entry = input_4_1.value;
            if (entry === null) continue;
            var memberEntries = $e1011dd782da33d8$var$serializeAws_queryPublishBatchRequestEntry(entry, context);
            Object.entries(memberEntries).forEach(function(_a) {
                var _b = (0, $5c96a02c592fcff1$export$8d051b38c9118094)(_a, 2), key = _b[0], value = _b[1];
                entries["member." + counter + "." + key] = value;
            });
            counter++;
        }
    } catch (e_4_1) {
        e_4 = {
            error: e_4_1
        };
    } finally{
        try {
            if (input_4_1 && !input_4_1.done && (_a = input_4.return)) _a.call(input_4);
        } finally{
            if (e_4) throw e_4.error;
        }
    }
    return entries;
};
var $e1011dd782da33d8$var$serializeAws_queryPublishInput = function(input, context) {
    var entries = {};
    if (input.TopicArn !== undefined && input.TopicArn !== null) entries["TopicArn"] = input.TopicArn;
    if (input.TargetArn !== undefined && input.TargetArn !== null) entries["TargetArn"] = input.TargetArn;
    if (input.PhoneNumber !== undefined && input.PhoneNumber !== null) entries["PhoneNumber"] = input.PhoneNumber;
    if (input.Message !== undefined && input.Message !== null) entries["Message"] = input.Message;
    if (input.Subject !== undefined && input.Subject !== null) entries["Subject"] = input.Subject;
    if (input.MessageStructure !== undefined && input.MessageStructure !== null) entries["MessageStructure"] = input.MessageStructure;
    if (input.MessageAttributes !== undefined && input.MessageAttributes !== null) {
        var memberEntries = $e1011dd782da33d8$var$serializeAws_queryMessageAttributeMap(input.MessageAttributes, context);
        Object.entries(memberEntries).forEach(function(_a) {
            var _b = (0, $5c96a02c592fcff1$export$8d051b38c9118094)(_a, 2), key = _b[0], value = _b[1];
            var loc = "MessageAttributes." + key;
            entries[loc] = value;
        });
    }
    if (input.MessageDeduplicationId !== undefined && input.MessageDeduplicationId !== null) entries["MessageDeduplicationId"] = input.MessageDeduplicationId;
    if (input.MessageGroupId !== undefined && input.MessageGroupId !== null) entries["MessageGroupId"] = input.MessageGroupId;
    return entries;
};
var $e1011dd782da33d8$var$serializeAws_queryRemovePermissionInput = function(input, context) {
    var entries = {};
    if (input.TopicArn !== undefined && input.TopicArn !== null) entries["TopicArn"] = input.TopicArn;
    if (input.Label !== undefined && input.Label !== null) entries["Label"] = input.Label;
    return entries;
};
var $e1011dd782da33d8$var$serializeAws_querySetEndpointAttributesInput = function(input, context) {
    var entries = {};
    if (input.EndpointArn !== undefined && input.EndpointArn !== null) entries["EndpointArn"] = input.EndpointArn;
    if (input.Attributes !== undefined && input.Attributes !== null) {
        var memberEntries = $e1011dd782da33d8$var$serializeAws_queryMapStringToString(input.Attributes, context);
        Object.entries(memberEntries).forEach(function(_a) {
            var _b = (0, $5c96a02c592fcff1$export$8d051b38c9118094)(_a, 2), key = _b[0], value = _b[1];
            var loc = "Attributes." + key;
            entries[loc] = value;
        });
    }
    return entries;
};
var $e1011dd782da33d8$var$serializeAws_querySetPlatformApplicationAttributesInput = function(input, context) {
    var entries = {};
    if (input.PlatformApplicationArn !== undefined && input.PlatformApplicationArn !== null) entries["PlatformApplicationArn"] = input.PlatformApplicationArn;
    if (input.Attributes !== undefined && input.Attributes !== null) {
        var memberEntries = $e1011dd782da33d8$var$serializeAws_queryMapStringToString(input.Attributes, context);
        Object.entries(memberEntries).forEach(function(_a) {
            var _b = (0, $5c96a02c592fcff1$export$8d051b38c9118094)(_a, 2), key = _b[0], value = _b[1];
            var loc = "Attributes." + key;
            entries[loc] = value;
        });
    }
    return entries;
};
var $e1011dd782da33d8$var$serializeAws_querySetSMSAttributesInput = function(input, context) {
    var entries = {};
    if (input.attributes !== undefined && input.attributes !== null) {
        var memberEntries = $e1011dd782da33d8$var$serializeAws_queryMapStringToString(input.attributes, context);
        Object.entries(memberEntries).forEach(function(_a) {
            var _b = (0, $5c96a02c592fcff1$export$8d051b38c9118094)(_a, 2), key = _b[0], value = _b[1];
            var loc = "attributes." + key;
            entries[loc] = value;
        });
    }
    return entries;
};
var $e1011dd782da33d8$var$serializeAws_querySetSubscriptionAttributesInput = function(input, context) {
    var entries = {};
    if (input.SubscriptionArn !== undefined && input.SubscriptionArn !== null) entries["SubscriptionArn"] = input.SubscriptionArn;
    if (input.AttributeName !== undefined && input.AttributeName !== null) entries["AttributeName"] = input.AttributeName;
    if (input.AttributeValue !== undefined && input.AttributeValue !== null) entries["AttributeValue"] = input.AttributeValue;
    return entries;
};
var $e1011dd782da33d8$var$serializeAws_querySetTopicAttributesInput = function(input, context) {
    var entries = {};
    if (input.TopicArn !== undefined && input.TopicArn !== null) entries["TopicArn"] = input.TopicArn;
    if (input.AttributeName !== undefined && input.AttributeName !== null) entries["AttributeName"] = input.AttributeName;
    if (input.AttributeValue !== undefined && input.AttributeValue !== null) entries["AttributeValue"] = input.AttributeValue;
    return entries;
};
var $e1011dd782da33d8$var$serializeAws_querySubscribeInput = function(input, context) {
    var entries = {};
    if (input.TopicArn !== undefined && input.TopicArn !== null) entries["TopicArn"] = input.TopicArn;
    if (input.Protocol !== undefined && input.Protocol !== null) entries["Protocol"] = input.Protocol;
    if (input.Endpoint !== undefined && input.Endpoint !== null) entries["Endpoint"] = input.Endpoint;
    if (input.Attributes !== undefined && input.Attributes !== null) {
        var memberEntries = $e1011dd782da33d8$var$serializeAws_querySubscriptionAttributesMap(input.Attributes, context);
        Object.entries(memberEntries).forEach(function(_a) {
            var _b = (0, $5c96a02c592fcff1$export$8d051b38c9118094)(_a, 2), key = _b[0], value = _b[1];
            var loc = "Attributes." + key;
            entries[loc] = value;
        });
    }
    if (input.ReturnSubscriptionArn !== undefined && input.ReturnSubscriptionArn !== null) entries["ReturnSubscriptionArn"] = input.ReturnSubscriptionArn;
    return entries;
};
var $e1011dd782da33d8$var$serializeAws_querySubscriptionAttributesMap = function(input, context) {
    var entries = {};
    var counter = 1;
    Object.keys(input).filter(function(key) {
        return input[key] != null;
    }).forEach(function(key) {
        entries["entry." + counter + ".key"] = key;
        entries["entry." + counter + ".value"] = input[key];
        counter++;
    });
    return entries;
};
var $e1011dd782da33d8$var$serializeAws_queryTag = function(input, context) {
    var entries = {};
    if (input.Key !== undefined && input.Key !== null) entries["Key"] = input.Key;
    if (input.Value !== undefined && input.Value !== null) entries["Value"] = input.Value;
    return entries;
};
var $e1011dd782da33d8$var$serializeAws_queryTagKeyList = function(input, context) {
    var e_5, _a;
    var entries = {};
    var counter = 1;
    try {
        for(var input_5 = (0, $5c96a02c592fcff1$export$19a8beecd37a4c45)(input), input_5_1 = input_5.next(); !input_5_1.done; input_5_1 = input_5.next()){
            var entry = input_5_1.value;
            if (entry === null) continue;
            entries["member." + counter] = entry;
            counter++;
        }
    } catch (e_5_1) {
        e_5 = {
            error: e_5_1
        };
    } finally{
        try {
            if (input_5_1 && !input_5_1.done && (_a = input_5.return)) _a.call(input_5);
        } finally{
            if (e_5) throw e_5.error;
        }
    }
    return entries;
};
var $e1011dd782da33d8$var$serializeAws_queryTagList = function(input, context) {
    var e_6, _a;
    var entries = {};
    var counter = 1;
    try {
        for(var input_6 = (0, $5c96a02c592fcff1$export$19a8beecd37a4c45)(input), input_6_1 = input_6.next(); !input_6_1.done; input_6_1 = input_6.next()){
            var entry = input_6_1.value;
            if (entry === null) continue;
            var memberEntries = $e1011dd782da33d8$var$serializeAws_queryTag(entry, context);
            Object.entries(memberEntries).forEach(function(_a) {
                var _b = (0, $5c96a02c592fcff1$export$8d051b38c9118094)(_a, 2), key = _b[0], value = _b[1];
                entries["member." + counter + "." + key] = value;
            });
            counter++;
        }
    } catch (e_6_1) {
        e_6 = {
            error: e_6_1
        };
    } finally{
        try {
            if (input_6_1 && !input_6_1.done && (_a = input_6.return)) _a.call(input_6);
        } finally{
            if (e_6) throw e_6.error;
        }
    }
    return entries;
};
var $e1011dd782da33d8$var$serializeAws_queryTagResourceRequest = function(input, context) {
    var entries = {};
    if (input.ResourceArn !== undefined && input.ResourceArn !== null) entries["ResourceArn"] = input.ResourceArn;
    if (input.Tags !== undefined && input.Tags !== null) {
        var memberEntries = $e1011dd782da33d8$var$serializeAws_queryTagList(input.Tags, context);
        Object.entries(memberEntries).forEach(function(_a) {
            var _b = (0, $5c96a02c592fcff1$export$8d051b38c9118094)(_a, 2), key = _b[0], value = _b[1];
            var loc = "Tags." + key;
            entries[loc] = value;
        });
    }
    return entries;
};
var $e1011dd782da33d8$var$serializeAws_queryTopicAttributesMap = function(input, context) {
    var entries = {};
    var counter = 1;
    Object.keys(input).filter(function(key) {
        return input[key] != null;
    }).forEach(function(key) {
        entries["entry." + counter + ".key"] = key;
        entries["entry." + counter + ".value"] = input[key];
        counter++;
    });
    return entries;
};
var $e1011dd782da33d8$var$serializeAws_queryUnsubscribeInput = function(input, context) {
    var entries = {};
    if (input.SubscriptionArn !== undefined && input.SubscriptionArn !== null) entries["SubscriptionArn"] = input.SubscriptionArn;
    return entries;
};
var $e1011dd782da33d8$var$serializeAws_queryUntagResourceRequest = function(input, context) {
    var entries = {};
    if (input.ResourceArn !== undefined && input.ResourceArn !== null) entries["ResourceArn"] = input.ResourceArn;
    if (input.TagKeys !== undefined && input.TagKeys !== null) {
        var memberEntries = $e1011dd782da33d8$var$serializeAws_queryTagKeyList(input.TagKeys, context);
        Object.entries(memberEntries).forEach(function(_a) {
            var _b = (0, $5c96a02c592fcff1$export$8d051b38c9118094)(_a, 2), key = _b[0], value = _b[1];
            var loc = "TagKeys." + key;
            entries[loc] = value;
        });
    }
    return entries;
};
var $e1011dd782da33d8$var$serializeAws_queryVerifySMSSandboxPhoneNumberInput = function(input, context) {
    var entries = {};
    if (input.PhoneNumber !== undefined && input.PhoneNumber !== null) entries["PhoneNumber"] = input.PhoneNumber;
    if (input.OneTimePassword !== undefined && input.OneTimePassword !== null) entries["OneTimePassword"] = input.OneTimePassword;
    return entries;
};
var $e1011dd782da33d8$var$deserializeAws_queryAuthorizationErrorException = function(output, context) {
    var contents = {
        message: undefined
    };
    if (output["message"] !== undefined) contents.message = (0, $326143e959bb2a25$export$7ed80f53fe336639)(output["message"]);
    return contents;
};
var $e1011dd782da33d8$var$deserializeAws_queryBatchEntryIdsNotDistinctException = function(output, context) {
    var contents = {
        message: undefined
    };
    if (output["message"] !== undefined) contents.message = (0, $326143e959bb2a25$export$7ed80f53fe336639)(output["message"]);
    return contents;
};
var $e1011dd782da33d8$var$deserializeAws_queryBatchRequestTooLongException = function(output, context) {
    var contents = {
        message: undefined
    };
    if (output["message"] !== undefined) contents.message = (0, $326143e959bb2a25$export$7ed80f53fe336639)(output["message"]);
    return contents;
};
var $e1011dd782da33d8$var$deserializeAws_queryBatchResultErrorEntry = function(output, context) {
    var contents = {
        Id: undefined,
        Code: undefined,
        Message: undefined,
        SenderFault: undefined
    };
    if (output["Id"] !== undefined) contents.Id = (0, $326143e959bb2a25$export$7ed80f53fe336639)(output["Id"]);
    if (output["Code"] !== undefined) contents.Code = (0, $326143e959bb2a25$export$7ed80f53fe336639)(output["Code"]);
    if (output["Message"] !== undefined) contents.Message = (0, $326143e959bb2a25$export$7ed80f53fe336639)(output["Message"]);
    if (output["SenderFault"] !== undefined) contents.SenderFault = (0, $326143e959bb2a25$export$3fb54149990fb5b5)(output["SenderFault"]);
    return contents;
};
var $e1011dd782da33d8$var$deserializeAws_queryBatchResultErrorEntryList = function(output, context) {
    return (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return $e1011dd782da33d8$var$deserializeAws_queryBatchResultErrorEntry(entry, context);
    });
};
var $e1011dd782da33d8$var$deserializeAws_queryCheckIfPhoneNumberIsOptedOutResponse = function(output, context) {
    var contents = {
        isOptedOut: undefined
    };
    if (output["isOptedOut"] !== undefined) contents.isOptedOut = (0, $326143e959bb2a25$export$3fb54149990fb5b5)(output["isOptedOut"]);
    return contents;
};
var $e1011dd782da33d8$var$deserializeAws_queryConcurrentAccessException = function(output, context) {
    var contents = {
        message: undefined
    };
    if (output["message"] !== undefined) contents.message = (0, $326143e959bb2a25$export$7ed80f53fe336639)(output["message"]);
    return contents;
};
var $e1011dd782da33d8$var$deserializeAws_queryConfirmSubscriptionResponse = function(output, context) {
    var contents = {
        SubscriptionArn: undefined
    };
    if (output["SubscriptionArn"] !== undefined) contents.SubscriptionArn = (0, $326143e959bb2a25$export$7ed80f53fe336639)(output["SubscriptionArn"]);
    return contents;
};
var $e1011dd782da33d8$var$deserializeAws_queryCreateEndpointResponse = function(output, context) {
    var contents = {
        EndpointArn: undefined
    };
    if (output["EndpointArn"] !== undefined) contents.EndpointArn = (0, $326143e959bb2a25$export$7ed80f53fe336639)(output["EndpointArn"]);
    return contents;
};
var $e1011dd782da33d8$var$deserializeAws_queryCreatePlatformApplicationResponse = function(output, context) {
    var contents = {
        PlatformApplicationArn: undefined
    };
    if (output["PlatformApplicationArn"] !== undefined) contents.PlatformApplicationArn = (0, $326143e959bb2a25$export$7ed80f53fe336639)(output["PlatformApplicationArn"]);
    return contents;
};
var $e1011dd782da33d8$var$deserializeAws_queryCreateSMSSandboxPhoneNumberResult = function(output, context) {
    var contents = {};
    return contents;
};
var $e1011dd782da33d8$var$deserializeAws_queryCreateTopicResponse = function(output, context) {
    var contents = {
        TopicArn: undefined
    };
    if (output["TopicArn"] !== undefined) contents.TopicArn = (0, $326143e959bb2a25$export$7ed80f53fe336639)(output["TopicArn"]);
    return contents;
};
var $e1011dd782da33d8$var$deserializeAws_queryDeleteSMSSandboxPhoneNumberResult = function(output, context) {
    var contents = {};
    return contents;
};
var $e1011dd782da33d8$var$deserializeAws_queryEmptyBatchRequestException = function(output, context) {
    var contents = {
        message: undefined
    };
    if (output["message"] !== undefined) contents.message = (0, $326143e959bb2a25$export$7ed80f53fe336639)(output["message"]);
    return contents;
};
var $e1011dd782da33d8$var$deserializeAws_queryEndpoint = function(output, context) {
    var contents = {
        EndpointArn: undefined,
        Attributes: undefined
    };
    if (output["EndpointArn"] !== undefined) contents.EndpointArn = (0, $326143e959bb2a25$export$7ed80f53fe336639)(output["EndpointArn"]);
    if (output.Attributes === "") contents.Attributes = {};
    if (output["Attributes"] !== undefined && output["Attributes"]["entry"] !== undefined) contents.Attributes = $e1011dd782da33d8$var$deserializeAws_queryMapStringToString((0, $69c7ed9058be69af$export$52272e038712c64e)(output["Attributes"]["entry"]), context);
    return contents;
};
var $e1011dd782da33d8$var$deserializeAws_queryEndpointDisabledException = function(output, context) {
    var contents = {
        message: undefined
    };
    if (output["message"] !== undefined) contents.message = (0, $326143e959bb2a25$export$7ed80f53fe336639)(output["message"]);
    return contents;
};
var $e1011dd782da33d8$var$deserializeAws_queryFilterPolicyLimitExceededException = function(output, context) {
    var contents = {
        message: undefined
    };
    if (output["message"] !== undefined) contents.message = (0, $326143e959bb2a25$export$7ed80f53fe336639)(output["message"]);
    return contents;
};
var $e1011dd782da33d8$var$deserializeAws_queryGetEndpointAttributesResponse = function(output, context) {
    var contents = {
        Attributes: undefined
    };
    if (output.Attributes === "") contents.Attributes = {};
    if (output["Attributes"] !== undefined && output["Attributes"]["entry"] !== undefined) contents.Attributes = $e1011dd782da33d8$var$deserializeAws_queryMapStringToString((0, $69c7ed9058be69af$export$52272e038712c64e)(output["Attributes"]["entry"]), context);
    return contents;
};
var $e1011dd782da33d8$var$deserializeAws_queryGetPlatformApplicationAttributesResponse = function(output, context) {
    var contents = {
        Attributes: undefined
    };
    if (output.Attributes === "") contents.Attributes = {};
    if (output["Attributes"] !== undefined && output["Attributes"]["entry"] !== undefined) contents.Attributes = $e1011dd782da33d8$var$deserializeAws_queryMapStringToString((0, $69c7ed9058be69af$export$52272e038712c64e)(output["Attributes"]["entry"]), context);
    return contents;
};
var $e1011dd782da33d8$var$deserializeAws_queryGetSMSAttributesResponse = function(output, context) {
    var contents = {
        attributes: undefined
    };
    if (output.attributes === "") contents.attributes = {};
    if (output["attributes"] !== undefined && output["attributes"]["entry"] !== undefined) contents.attributes = $e1011dd782da33d8$var$deserializeAws_queryMapStringToString((0, $69c7ed9058be69af$export$52272e038712c64e)(output["attributes"]["entry"]), context);
    return contents;
};
var $e1011dd782da33d8$var$deserializeAws_queryGetSMSSandboxAccountStatusResult = function(output, context) {
    var contents = {
        IsInSandbox: undefined
    };
    if (output["IsInSandbox"] !== undefined) contents.IsInSandbox = (0, $326143e959bb2a25$export$3fb54149990fb5b5)(output["IsInSandbox"]);
    return contents;
};
var $e1011dd782da33d8$var$deserializeAws_queryGetSubscriptionAttributesResponse = function(output, context) {
    var contents = {
        Attributes: undefined
    };
    if (output.Attributes === "") contents.Attributes = {};
    if (output["Attributes"] !== undefined && output["Attributes"]["entry"] !== undefined) contents.Attributes = $e1011dd782da33d8$var$deserializeAws_querySubscriptionAttributesMap((0, $69c7ed9058be69af$export$52272e038712c64e)(output["Attributes"]["entry"]), context);
    return contents;
};
var $e1011dd782da33d8$var$deserializeAws_queryGetTopicAttributesResponse = function(output, context) {
    var contents = {
        Attributes: undefined
    };
    if (output.Attributes === "") contents.Attributes = {};
    if (output["Attributes"] !== undefined && output["Attributes"]["entry"] !== undefined) contents.Attributes = $e1011dd782da33d8$var$deserializeAws_queryTopicAttributesMap((0, $69c7ed9058be69af$export$52272e038712c64e)(output["Attributes"]["entry"]), context);
    return contents;
};
var $e1011dd782da33d8$var$deserializeAws_queryInternalErrorException = function(output, context) {
    var contents = {
        message: undefined
    };
    if (output["message"] !== undefined) contents.message = (0, $326143e959bb2a25$export$7ed80f53fe336639)(output["message"]);
    return contents;
};
var $e1011dd782da33d8$var$deserializeAws_queryInvalidBatchEntryIdException = function(output, context) {
    var contents = {
        message: undefined
    };
    if (output["message"] !== undefined) contents.message = (0, $326143e959bb2a25$export$7ed80f53fe336639)(output["message"]);
    return contents;
};
var $e1011dd782da33d8$var$deserializeAws_queryInvalidParameterException = function(output, context) {
    var contents = {
        message: undefined
    };
    if (output["message"] !== undefined) contents.message = (0, $326143e959bb2a25$export$7ed80f53fe336639)(output["message"]);
    return contents;
};
var $e1011dd782da33d8$var$deserializeAws_queryInvalidParameterValueException = function(output, context) {
    var contents = {
        message: undefined
    };
    if (output["message"] !== undefined) contents.message = (0, $326143e959bb2a25$export$7ed80f53fe336639)(output["message"]);
    return contents;
};
var $e1011dd782da33d8$var$deserializeAws_queryInvalidSecurityException = function(output, context) {
    var contents = {
        message: undefined
    };
    if (output["message"] !== undefined) contents.message = (0, $326143e959bb2a25$export$7ed80f53fe336639)(output["message"]);
    return contents;
};
var $e1011dd782da33d8$var$deserializeAws_queryKMSAccessDeniedException = function(output, context) {
    var contents = {
        message: undefined
    };
    if (output["message"] !== undefined) contents.message = (0, $326143e959bb2a25$export$7ed80f53fe336639)(output["message"]);
    return contents;
};
var $e1011dd782da33d8$var$deserializeAws_queryKMSDisabledException = function(output, context) {
    var contents = {
        message: undefined
    };
    if (output["message"] !== undefined) contents.message = (0, $326143e959bb2a25$export$7ed80f53fe336639)(output["message"]);
    return contents;
};
var $e1011dd782da33d8$var$deserializeAws_queryKMSInvalidStateException = function(output, context) {
    var contents = {
        message: undefined
    };
    if (output["message"] !== undefined) contents.message = (0, $326143e959bb2a25$export$7ed80f53fe336639)(output["message"]);
    return contents;
};
var $e1011dd782da33d8$var$deserializeAws_queryKMSNotFoundException = function(output, context) {
    var contents = {
        message: undefined
    };
    if (output["message"] !== undefined) contents.message = (0, $326143e959bb2a25$export$7ed80f53fe336639)(output["message"]);
    return contents;
};
var $e1011dd782da33d8$var$deserializeAws_queryKMSOptInRequired = function(output, context) {
    var contents = {
        message: undefined
    };
    if (output["message"] !== undefined) contents.message = (0, $326143e959bb2a25$export$7ed80f53fe336639)(output["message"]);
    return contents;
};
var $e1011dd782da33d8$var$deserializeAws_queryKMSThrottlingException = function(output, context) {
    var contents = {
        message: undefined
    };
    if (output["message"] !== undefined) contents.message = (0, $326143e959bb2a25$export$7ed80f53fe336639)(output["message"]);
    return contents;
};
var $e1011dd782da33d8$var$deserializeAws_queryListEndpointsByPlatformApplicationResponse = function(output, context) {
    var contents = {
        Endpoints: undefined,
        NextToken: undefined
    };
    if (output.Endpoints === "") contents.Endpoints = [];
    if (output["Endpoints"] !== undefined && output["Endpoints"]["member"] !== undefined) contents.Endpoints = $e1011dd782da33d8$var$deserializeAws_queryListOfEndpoints((0, $69c7ed9058be69af$export$52272e038712c64e)(output["Endpoints"]["member"]), context);
    if (output["NextToken"] !== undefined) contents.NextToken = (0, $326143e959bb2a25$export$7ed80f53fe336639)(output["NextToken"]);
    return contents;
};
var $e1011dd782da33d8$var$deserializeAws_queryListOfEndpoints = function(output, context) {
    return (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return $e1011dd782da33d8$var$deserializeAws_queryEndpoint(entry, context);
    });
};
var $e1011dd782da33d8$var$deserializeAws_queryListOfPlatformApplications = function(output, context) {
    return (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return $e1011dd782da33d8$var$deserializeAws_queryPlatformApplication(entry, context);
    });
};
var $e1011dd782da33d8$var$deserializeAws_queryListOriginationNumbersResult = function(output, context) {
    var contents = {
        NextToken: undefined,
        PhoneNumbers: undefined
    };
    if (output["NextToken"] !== undefined) contents.NextToken = (0, $326143e959bb2a25$export$7ed80f53fe336639)(output["NextToken"]);
    if (output.PhoneNumbers === "") contents.PhoneNumbers = [];
    if (output["PhoneNumbers"] !== undefined && output["PhoneNumbers"]["member"] !== undefined) contents.PhoneNumbers = $e1011dd782da33d8$var$deserializeAws_queryPhoneNumberInformationList((0, $69c7ed9058be69af$export$52272e038712c64e)(output["PhoneNumbers"]["member"]), context);
    return contents;
};
var $e1011dd782da33d8$var$deserializeAws_queryListPhoneNumbersOptedOutResponse = function(output, context) {
    var contents = {
        phoneNumbers: undefined,
        nextToken: undefined
    };
    if (output.phoneNumbers === "") contents.phoneNumbers = [];
    if (output["phoneNumbers"] !== undefined && output["phoneNumbers"]["member"] !== undefined) contents.phoneNumbers = $e1011dd782da33d8$var$deserializeAws_queryPhoneNumberList((0, $69c7ed9058be69af$export$52272e038712c64e)(output["phoneNumbers"]["member"]), context);
    if (output["nextToken"] !== undefined) contents.nextToken = (0, $326143e959bb2a25$export$7ed80f53fe336639)(output["nextToken"]);
    return contents;
};
var $e1011dd782da33d8$var$deserializeAws_queryListPlatformApplicationsResponse = function(output, context) {
    var contents = {
        PlatformApplications: undefined,
        NextToken: undefined
    };
    if (output.PlatformApplications === "") contents.PlatformApplications = [];
    if (output["PlatformApplications"] !== undefined && output["PlatformApplications"]["member"] !== undefined) contents.PlatformApplications = $e1011dd782da33d8$var$deserializeAws_queryListOfPlatformApplications((0, $69c7ed9058be69af$export$52272e038712c64e)(output["PlatformApplications"]["member"]), context);
    if (output["NextToken"] !== undefined) contents.NextToken = (0, $326143e959bb2a25$export$7ed80f53fe336639)(output["NextToken"]);
    return contents;
};
var $e1011dd782da33d8$var$deserializeAws_queryListSMSSandboxPhoneNumbersResult = function(output, context) {
    var contents = {
        PhoneNumbers: undefined,
        NextToken: undefined
    };
    if (output.PhoneNumbers === "") contents.PhoneNumbers = [];
    if (output["PhoneNumbers"] !== undefined && output["PhoneNumbers"]["member"] !== undefined) contents.PhoneNumbers = $e1011dd782da33d8$var$deserializeAws_querySMSSandboxPhoneNumberList((0, $69c7ed9058be69af$export$52272e038712c64e)(output["PhoneNumbers"]["member"]), context);
    if (output["NextToken"] !== undefined) contents.NextToken = (0, $326143e959bb2a25$export$7ed80f53fe336639)(output["NextToken"]);
    return contents;
};
var $e1011dd782da33d8$var$deserializeAws_queryListSubscriptionsByTopicResponse = function(output, context) {
    var contents = {
        Subscriptions: undefined,
        NextToken: undefined
    };
    if (output.Subscriptions === "") contents.Subscriptions = [];
    if (output["Subscriptions"] !== undefined && output["Subscriptions"]["member"] !== undefined) contents.Subscriptions = $e1011dd782da33d8$var$deserializeAws_querySubscriptionsList((0, $69c7ed9058be69af$export$52272e038712c64e)(output["Subscriptions"]["member"]), context);
    if (output["NextToken"] !== undefined) contents.NextToken = (0, $326143e959bb2a25$export$7ed80f53fe336639)(output["NextToken"]);
    return contents;
};
var $e1011dd782da33d8$var$deserializeAws_queryListSubscriptionsResponse = function(output, context) {
    var contents = {
        Subscriptions: undefined,
        NextToken: undefined
    };
    if (output.Subscriptions === "") contents.Subscriptions = [];
    if (output["Subscriptions"] !== undefined && output["Subscriptions"]["member"] !== undefined) contents.Subscriptions = $e1011dd782da33d8$var$deserializeAws_querySubscriptionsList((0, $69c7ed9058be69af$export$52272e038712c64e)(output["Subscriptions"]["member"]), context);
    if (output["NextToken"] !== undefined) contents.NextToken = (0, $326143e959bb2a25$export$7ed80f53fe336639)(output["NextToken"]);
    return contents;
};
var $e1011dd782da33d8$var$deserializeAws_queryListTagsForResourceResponse = function(output, context) {
    var contents = {
        Tags: undefined
    };
    if (output.Tags === "") contents.Tags = [];
    if (output["Tags"] !== undefined && output["Tags"]["member"] !== undefined) contents.Tags = $e1011dd782da33d8$var$deserializeAws_queryTagList((0, $69c7ed9058be69af$export$52272e038712c64e)(output["Tags"]["member"]), context);
    return contents;
};
var $e1011dd782da33d8$var$deserializeAws_queryListTopicsResponse = function(output, context) {
    var contents = {
        Topics: undefined,
        NextToken: undefined
    };
    if (output.Topics === "") contents.Topics = [];
    if (output["Topics"] !== undefined && output["Topics"]["member"] !== undefined) contents.Topics = $e1011dd782da33d8$var$deserializeAws_queryTopicsList((0, $69c7ed9058be69af$export$52272e038712c64e)(output["Topics"]["member"]), context);
    if (output["NextToken"] !== undefined) contents.NextToken = (0, $326143e959bb2a25$export$7ed80f53fe336639)(output["NextToken"]);
    return contents;
};
var $e1011dd782da33d8$var$deserializeAws_queryMapStringToString = function(output, context) {
    return output.reduce(function(acc, pair) {
        var _a;
        if (pair["value"] === null) return acc;
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, acc), (_a = {}, _a[pair["key"]] = (0, $326143e959bb2a25$export$7ed80f53fe336639)(pair["value"]), _a));
    }, {});
};
var $e1011dd782da33d8$var$deserializeAws_queryNotFoundException = function(output, context) {
    var contents = {
        message: undefined
    };
    if (output["message"] !== undefined) contents.message = (0, $326143e959bb2a25$export$7ed80f53fe336639)(output["message"]);
    return contents;
};
var $e1011dd782da33d8$var$deserializeAws_queryNumberCapabilityList = function(output, context) {
    return (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return (0, $326143e959bb2a25$export$7ed80f53fe336639)(entry);
    });
};
var $e1011dd782da33d8$var$deserializeAws_queryOptedOutException = function(output, context) {
    var contents = {
        message: undefined
    };
    if (output["message"] !== undefined) contents.message = (0, $326143e959bb2a25$export$7ed80f53fe336639)(output["message"]);
    return contents;
};
var $e1011dd782da33d8$var$deserializeAws_queryOptInPhoneNumberResponse = function(output, context) {
    var contents = {};
    return contents;
};
var $e1011dd782da33d8$var$deserializeAws_queryPhoneNumberInformation = function(output, context) {
    var contents = {
        CreatedAt: undefined,
        PhoneNumber: undefined,
        Status: undefined,
        Iso2CountryCode: undefined,
        RouteType: undefined,
        NumberCapabilities: undefined
    };
    if (output["CreatedAt"] !== undefined) contents.CreatedAt = (0, $326143e959bb2a25$export$8413a63dbe548a49)((0, $e742001d39531b4d$export$202e14f4d6038b6c)(output["CreatedAt"]));
    if (output["PhoneNumber"] !== undefined) contents.PhoneNumber = (0, $326143e959bb2a25$export$7ed80f53fe336639)(output["PhoneNumber"]);
    if (output["Status"] !== undefined) contents.Status = (0, $326143e959bb2a25$export$7ed80f53fe336639)(output["Status"]);
    if (output["Iso2CountryCode"] !== undefined) contents.Iso2CountryCode = (0, $326143e959bb2a25$export$7ed80f53fe336639)(output["Iso2CountryCode"]);
    if (output["RouteType"] !== undefined) contents.RouteType = (0, $326143e959bb2a25$export$7ed80f53fe336639)(output["RouteType"]);
    if (output.NumberCapabilities === "") contents.NumberCapabilities = [];
    if (output["NumberCapabilities"] !== undefined && output["NumberCapabilities"]["member"] !== undefined) contents.NumberCapabilities = $e1011dd782da33d8$var$deserializeAws_queryNumberCapabilityList((0, $69c7ed9058be69af$export$52272e038712c64e)(output["NumberCapabilities"]["member"]), context);
    return contents;
};
var $e1011dd782da33d8$var$deserializeAws_queryPhoneNumberInformationList = function(output, context) {
    return (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return $e1011dd782da33d8$var$deserializeAws_queryPhoneNumberInformation(entry, context);
    });
};
var $e1011dd782da33d8$var$deserializeAws_queryPhoneNumberList = function(output, context) {
    return (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return (0, $326143e959bb2a25$export$7ed80f53fe336639)(entry);
    });
};
var $e1011dd782da33d8$var$deserializeAws_queryPlatformApplication = function(output, context) {
    var contents = {
        PlatformApplicationArn: undefined,
        Attributes: undefined
    };
    if (output["PlatformApplicationArn"] !== undefined) contents.PlatformApplicationArn = (0, $326143e959bb2a25$export$7ed80f53fe336639)(output["PlatformApplicationArn"]);
    if (output.Attributes === "") contents.Attributes = {};
    if (output["Attributes"] !== undefined && output["Attributes"]["entry"] !== undefined) contents.Attributes = $e1011dd782da33d8$var$deserializeAws_queryMapStringToString((0, $69c7ed9058be69af$export$52272e038712c64e)(output["Attributes"]["entry"]), context);
    return contents;
};
var $e1011dd782da33d8$var$deserializeAws_queryPlatformApplicationDisabledException = function(output, context) {
    var contents = {
        message: undefined
    };
    if (output["message"] !== undefined) contents.message = (0, $326143e959bb2a25$export$7ed80f53fe336639)(output["message"]);
    return contents;
};
var $e1011dd782da33d8$var$deserializeAws_queryPublishBatchResponse = function(output, context) {
    var contents = {
        Successful: undefined,
        Failed: undefined
    };
    if (output.Successful === "") contents.Successful = [];
    if (output["Successful"] !== undefined && output["Successful"]["member"] !== undefined) contents.Successful = $e1011dd782da33d8$var$deserializeAws_queryPublishBatchResultEntryList((0, $69c7ed9058be69af$export$52272e038712c64e)(output["Successful"]["member"]), context);
    if (output.Failed === "") contents.Failed = [];
    if (output["Failed"] !== undefined && output["Failed"]["member"] !== undefined) contents.Failed = $e1011dd782da33d8$var$deserializeAws_queryBatchResultErrorEntryList((0, $69c7ed9058be69af$export$52272e038712c64e)(output["Failed"]["member"]), context);
    return contents;
};
var $e1011dd782da33d8$var$deserializeAws_queryPublishBatchResultEntry = function(output, context) {
    var contents = {
        Id: undefined,
        MessageId: undefined,
        SequenceNumber: undefined
    };
    if (output["Id"] !== undefined) contents.Id = (0, $326143e959bb2a25$export$7ed80f53fe336639)(output["Id"]);
    if (output["MessageId"] !== undefined) contents.MessageId = (0, $326143e959bb2a25$export$7ed80f53fe336639)(output["MessageId"]);
    if (output["SequenceNumber"] !== undefined) contents.SequenceNumber = (0, $326143e959bb2a25$export$7ed80f53fe336639)(output["SequenceNumber"]);
    return contents;
};
var $e1011dd782da33d8$var$deserializeAws_queryPublishBatchResultEntryList = function(output, context) {
    return (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return $e1011dd782da33d8$var$deserializeAws_queryPublishBatchResultEntry(entry, context);
    });
};
var $e1011dd782da33d8$var$deserializeAws_queryPublishResponse = function(output, context) {
    var contents = {
        MessageId: undefined,
        SequenceNumber: undefined
    };
    if (output["MessageId"] !== undefined) contents.MessageId = (0, $326143e959bb2a25$export$7ed80f53fe336639)(output["MessageId"]);
    if (output["SequenceNumber"] !== undefined) contents.SequenceNumber = (0, $326143e959bb2a25$export$7ed80f53fe336639)(output["SequenceNumber"]);
    return contents;
};
var $e1011dd782da33d8$var$deserializeAws_queryResourceNotFoundException = function(output, context) {
    var contents = {
        message: undefined
    };
    if (output["message"] !== undefined) contents.message = (0, $326143e959bb2a25$export$7ed80f53fe336639)(output["message"]);
    return contents;
};
var $e1011dd782da33d8$var$deserializeAws_querySetSMSAttributesResponse = function(output, context) {
    var contents = {};
    return contents;
};
var $e1011dd782da33d8$var$deserializeAws_querySMSSandboxPhoneNumber = function(output, context) {
    var contents = {
        PhoneNumber: undefined,
        Status: undefined
    };
    if (output["PhoneNumber"] !== undefined) contents.PhoneNumber = (0, $326143e959bb2a25$export$7ed80f53fe336639)(output["PhoneNumber"]);
    if (output["Status"] !== undefined) contents.Status = (0, $326143e959bb2a25$export$7ed80f53fe336639)(output["Status"]);
    return contents;
};
var $e1011dd782da33d8$var$deserializeAws_querySMSSandboxPhoneNumberList = function(output, context) {
    return (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return $e1011dd782da33d8$var$deserializeAws_querySMSSandboxPhoneNumber(entry, context);
    });
};
var $e1011dd782da33d8$var$deserializeAws_queryStaleTagException = function(output, context) {
    var contents = {
        message: undefined
    };
    if (output["message"] !== undefined) contents.message = (0, $326143e959bb2a25$export$7ed80f53fe336639)(output["message"]);
    return contents;
};
var $e1011dd782da33d8$var$deserializeAws_querySubscribeResponse = function(output, context) {
    var contents = {
        SubscriptionArn: undefined
    };
    if (output["SubscriptionArn"] !== undefined) contents.SubscriptionArn = (0, $326143e959bb2a25$export$7ed80f53fe336639)(output["SubscriptionArn"]);
    return contents;
};
var $e1011dd782da33d8$var$deserializeAws_querySubscription = function(output, context) {
    var contents = {
        SubscriptionArn: undefined,
        Owner: undefined,
        Protocol: undefined,
        Endpoint: undefined,
        TopicArn: undefined
    };
    if (output["SubscriptionArn"] !== undefined) contents.SubscriptionArn = (0, $326143e959bb2a25$export$7ed80f53fe336639)(output["SubscriptionArn"]);
    if (output["Owner"] !== undefined) contents.Owner = (0, $326143e959bb2a25$export$7ed80f53fe336639)(output["Owner"]);
    if (output["Protocol"] !== undefined) contents.Protocol = (0, $326143e959bb2a25$export$7ed80f53fe336639)(output["Protocol"]);
    if (output["Endpoint"] !== undefined) contents.Endpoint = (0, $326143e959bb2a25$export$7ed80f53fe336639)(output["Endpoint"]);
    if (output["TopicArn"] !== undefined) contents.TopicArn = (0, $326143e959bb2a25$export$7ed80f53fe336639)(output["TopicArn"]);
    return contents;
};
var $e1011dd782da33d8$var$deserializeAws_querySubscriptionAttributesMap = function(output, context) {
    return output.reduce(function(acc, pair) {
        var _a;
        if (pair["value"] === null) return acc;
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, acc), (_a = {}, _a[pair["key"]] = (0, $326143e959bb2a25$export$7ed80f53fe336639)(pair["value"]), _a));
    }, {});
};
var $e1011dd782da33d8$var$deserializeAws_querySubscriptionLimitExceededException = function(output, context) {
    var contents = {
        message: undefined
    };
    if (output["message"] !== undefined) contents.message = (0, $326143e959bb2a25$export$7ed80f53fe336639)(output["message"]);
    return contents;
};
var $e1011dd782da33d8$var$deserializeAws_querySubscriptionsList = function(output, context) {
    return (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return $e1011dd782da33d8$var$deserializeAws_querySubscription(entry, context);
    });
};
var $e1011dd782da33d8$var$deserializeAws_queryTag = function(output, context) {
    var contents = {
        Key: undefined,
        Value: undefined
    };
    if (output["Key"] !== undefined) contents.Key = (0, $326143e959bb2a25$export$7ed80f53fe336639)(output["Key"]);
    if (output["Value"] !== undefined) contents.Value = (0, $326143e959bb2a25$export$7ed80f53fe336639)(output["Value"]);
    return contents;
};
var $e1011dd782da33d8$var$deserializeAws_queryTagLimitExceededException = function(output, context) {
    var contents = {
        message: undefined
    };
    if (output["message"] !== undefined) contents.message = (0, $326143e959bb2a25$export$7ed80f53fe336639)(output["message"]);
    return contents;
};
var $e1011dd782da33d8$var$deserializeAws_queryTagList = function(output, context) {
    return (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return $e1011dd782da33d8$var$deserializeAws_queryTag(entry, context);
    });
};
var $e1011dd782da33d8$var$deserializeAws_queryTagPolicyException = function(output, context) {
    var contents = {
        message: undefined
    };
    if (output["message"] !== undefined) contents.message = (0, $326143e959bb2a25$export$7ed80f53fe336639)(output["message"]);
    return contents;
};
var $e1011dd782da33d8$var$deserializeAws_queryTagResourceResponse = function(output, context) {
    var contents = {};
    return contents;
};
var $e1011dd782da33d8$var$deserializeAws_queryThrottledException = function(output, context) {
    var contents = {
        message: undefined
    };
    if (output["message"] !== undefined) contents.message = (0, $326143e959bb2a25$export$7ed80f53fe336639)(output["message"]);
    return contents;
};
var $e1011dd782da33d8$var$deserializeAws_queryTooManyEntriesInBatchRequestException = function(output, context) {
    var contents = {
        message: undefined
    };
    if (output["message"] !== undefined) contents.message = (0, $326143e959bb2a25$export$7ed80f53fe336639)(output["message"]);
    return contents;
};
var $e1011dd782da33d8$var$deserializeAws_queryTopic = function(output, context) {
    var contents = {
        TopicArn: undefined
    };
    if (output["TopicArn"] !== undefined) contents.TopicArn = (0, $326143e959bb2a25$export$7ed80f53fe336639)(output["TopicArn"]);
    return contents;
};
var $e1011dd782da33d8$var$deserializeAws_queryTopicAttributesMap = function(output, context) {
    return output.reduce(function(acc, pair) {
        var _a;
        if (pair["value"] === null) return acc;
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, acc), (_a = {}, _a[pair["key"]] = (0, $326143e959bb2a25$export$7ed80f53fe336639)(pair["value"]), _a));
    }, {});
};
var $e1011dd782da33d8$var$deserializeAws_queryTopicLimitExceededException = function(output, context) {
    var contents = {
        message: undefined
    };
    if (output["message"] !== undefined) contents.message = (0, $326143e959bb2a25$export$7ed80f53fe336639)(output["message"]);
    return contents;
};
var $e1011dd782da33d8$var$deserializeAws_queryTopicsList = function(output, context) {
    return (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return $e1011dd782da33d8$var$deserializeAws_queryTopic(entry, context);
    });
};
var $e1011dd782da33d8$var$deserializeAws_queryUntagResourceResponse = function(output, context) {
    var contents = {};
    return contents;
};
var $e1011dd782da33d8$var$deserializeAws_queryUserErrorException = function(output, context) {
    var contents = {
        message: undefined
    };
    if (output["message"] !== undefined) contents.message = (0, $326143e959bb2a25$export$7ed80f53fe336639)(output["message"]);
    return contents;
};
var $e1011dd782da33d8$var$deserializeAws_queryValidationException = function(output, context) {
    var contents = {
        Message: undefined
    };
    if (output["Message"] !== undefined) contents.Message = (0, $326143e959bb2a25$export$7ed80f53fe336639)(output["Message"]);
    return contents;
};
var $e1011dd782da33d8$var$deserializeAws_queryVerificationException = function(output, context) {
    var contents = {
        Message: undefined,
        Status: undefined
    };
    if (output["Message"] !== undefined) contents.Message = (0, $326143e959bb2a25$export$7ed80f53fe336639)(output["Message"]);
    if (output["Status"] !== undefined) contents.Status = (0, $326143e959bb2a25$export$7ed80f53fe336639)(output["Status"]);
    return contents;
};
var $e1011dd782da33d8$var$deserializeAws_queryVerifySMSSandboxPhoneNumberResult = function(output, context) {
    var contents = {};
    return contents;
};
var $e1011dd782da33d8$var$deserializeMetadata = function(output) {
    var _a;
    return {
        httpStatusCode: output.statusCode,
        requestId: (_a = output.headers["x-amzn-requestid"]) !== null && _a !== void 0 ? _a : output.headers["x-amzn-request-id"],
        extendedRequestId: output.headers["x-amz-id-2"],
        cfId: output.headers["x-amz-cf-id"]
    };
};
var $e1011dd782da33d8$var$collectBody = function(streamBody, context) {
    if (streamBody === void 0) streamBody = new Uint8Array();
    if (streamBody instanceof Uint8Array) return Promise.resolve(streamBody);
    return context.streamCollector(streamBody) || Promise.resolve(new Uint8Array());
};
var $e1011dd782da33d8$var$collectBodyString = function(streamBody, context) {
    return $e1011dd782da33d8$var$collectBody(streamBody, context).then(function(body) {
        return context.utf8Encoder(body);
    });
};
var $e1011dd782da33d8$var$buildHttpRpcRequest = function(context, headers, path, resolvedHostname, body) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var _a, hostname, _b, protocol, port, basePath, contents;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    return [
                        4,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                    contents = {
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "POST",
                        path: basePath.endsWith("/") ? basePath.slice(0, -1) + path : basePath + path,
                        headers: headers
                    };
                    if (resolvedHostname !== undefined) contents.hostname = resolvedHostname;
                    if (body !== undefined) contents.body = body;
                    return [
                        2,
                        new (0, $f5162dd3bdb0d175$export$7587955500404ec3)(contents)
                    ];
            }
        });
    });
};
var $e1011dd782da33d8$var$parseBody = function(streamBody, context) {
    return $e1011dd782da33d8$var$collectBodyString(streamBody, context).then(function(encoded) {
        if (encoded.length) {
            var parsedObj = (0, $3519767cfc6fdeeb$export$98e6a39c04603d36)(encoded, {
                attributeNamePrefix: "",
                ignoreAttributes: false,
                parseNodeValue: false,
                trimValues: false,
                tagValueProcessor: function(val) {
                    return val.trim() === "" && val.includes("\n") ? "" : (0, $5f6deb2c0735ac56$exports.decodeHTML)(val);
                }
            });
            var textNodeName = "#text";
            var key = Object.keys(parsedObj)[0];
            var parsedObjToReturn = parsedObj[key];
            if (parsedObjToReturn[textNodeName]) {
                parsedObjToReturn[key] = parsedObjToReturn[textNodeName];
                delete parsedObjToReturn[textNodeName];
            }
            return (0, $75214256965cbf42$export$113d90026b452881)(parsedObjToReturn);
        }
        return {};
    });
};
var $e1011dd782da33d8$var$buildFormUrlencodedString = function(formEntries) {
    return Object.entries(formEntries).map(function(_a) {
        var _b = (0, $5c96a02c592fcff1$export$8d051b38c9118094)(_a, 2), key = _b[0], value = _b[1];
        return (0, $9a4acc0a52030ed1$export$7640f3c16fe7f54b)(key) + "=" + (0, $9a4acc0a52030ed1$export$7640f3c16fe7f54b)(value);
    }).join("&");
};
var $e1011dd782da33d8$var$loadQueryErrorCode = function(output, data) {
    if (data.Error.Code !== undefined) return data.Error.Code;
    if (output.statusCode == 404) return "NotFound";
    return "";
};


var $96012f3c4ac8022e$export$493699ca2cf8254c = function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(PublishCommand, _super);
    function PublishCommand(input) {
        var _this = _super.call(this) || this;
        _this.input = input;
        return _this;
    }
    PublishCommand.prototype.resolveMiddleware = function(clientStack, configuration, options) {
        this.middlewareStack.use((0, $eefacaa18209bd27$export$53fdc69654553fd4)(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "SNSClient";
        var commandName = "PublishCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: (0, $267a5477e1e57441$export$12ae5868ee61662b).filterSensitiveLog,
            outputFilterSensitiveLog: (0, $267a5477e1e57441$export$864d9a059c4e9a2).filterSensitiveLog
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function(request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    PublishCommand.prototype.serialize = function(input, context) {
        return (0, $e1011dd782da33d8$export$c930eaec46d8a919)(input, context);
    };
    PublishCommand.prototype.deserialize = function(output, context) {
        return (0, $e1011dd782da33d8$export$17cc6fb72364aaa)(output, context);
    };
    return PublishCommand;
}((0, $16f81f795382045c$export$cc7e12c76513e857));


var $4fdb2e57ab91ad8c$export$4e8b093ec8dcab0d;
(function(SelectorType) {
    SelectorType["ENV"] = "env";
    SelectorType["CONFIG"] = "shared config entry";
})($4fdb2e57ab91ad8c$export$4e8b093ec8dcab0d || ($4fdb2e57ab91ad8c$export$4e8b093ec8dcab0d = {}));
var $4fdb2e57ab91ad8c$export$f8c4049184e0ac3f = function(obj, key, type) {
    if (!(key in obj)) return undefined;
    if (obj[key] === "true") return true;
    if (obj[key] === "false") return false;
    throw new Error("Cannot load " + type + ' "' + key + '". Expected "true" or "false", got ' + obj[key] + ".");
};




var $d2d9f00eb717cd34$export$eacd91361c129033 = "AWS_USE_DUALSTACK_ENDPOINT";
var $d2d9f00eb717cd34$export$71f82540e79c63bf = "use_dualstack_endpoint";
var $d2d9f00eb717cd34$export$beb01fae7626c427 = false;
var $d2d9f00eb717cd34$export$522137fc0ae615ab = {
    environmentVariableSelector: function(env) {
        return (0, $4fdb2e57ab91ad8c$export$f8c4049184e0ac3f)(env, $d2d9f00eb717cd34$export$eacd91361c129033, (0, $4fdb2e57ab91ad8c$export$4e8b093ec8dcab0d).ENV);
    },
    configFileSelector: function(profile) {
        return (0, $4fdb2e57ab91ad8c$export$f8c4049184e0ac3f)(profile, $d2d9f00eb717cd34$export$71f82540e79c63bf, (0, $4fdb2e57ab91ad8c$export$4e8b093ec8dcab0d).CONFIG);
    },
    default: false
};



var $c2135aab0e2702c2$export$b7eebc18f98c6d7f = "AWS_USE_FIPS_ENDPOINT";
var $c2135aab0e2702c2$export$30cf725f60d4be3e = "use_fips_endpoint";
var $c2135aab0e2702c2$export$5555deeca435a10b = false;
var $c2135aab0e2702c2$export$42f76cc8f259f4b8 = {
    environmentVariableSelector: function(env) {
        return (0, $4fdb2e57ab91ad8c$export$f8c4049184e0ac3f)(env, $c2135aab0e2702c2$export$b7eebc18f98c6d7f, (0, $4fdb2e57ab91ad8c$export$4e8b093ec8dcab0d).ENV);
    },
    configFileSelector: function(profile) {
        return (0, $4fdb2e57ab91ad8c$export$f8c4049184e0ac3f)(profile, $c2135aab0e2702c2$export$30cf725f60d4be3e, (0, $4fdb2e57ab91ad8c$export$4e8b093ec8dcab0d).CONFIG);
    },
    default: false
};



var $b734e959a2594a91$export$5571117cd09e479d = function(value) {
    if (typeof value === "boolean") {
        var promisified_1 = Promise.resolve(value);
        return function() {
            return promisified_1;
        };
    }
    return value;
};


var $9ffd8c73d1b0dd07$export$57470ceb5d0ada23 = function(_a) {
    var endpoint = _a.endpoint, urlParser = _a.urlParser;
    if (typeof endpoint === "string") {
        var promisified_1 = Promise.resolve(urlParser(endpoint));
        return function() {
            return promisified_1;
        };
    } else if (typeof endpoint === "object") {
        var promisified_2 = Promise.resolve(endpoint);
        return function() {
            return promisified_2;
        };
    }
    return endpoint;
};


var $cd2016e5553bc225$export$6cd750975e36686c = function(input) {
    var _a;
    return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, input), {
        tls: (_a = input.tls) !== null && _a !== void 0 ? _a : true,
        endpoint: (0, $9ffd8c73d1b0dd07$export$57470ceb5d0ada23)(input),
        isCustomEndpoint: true,
        useDualstackEndpoint: (0, $b734e959a2594a91$export$5571117cd09e479d)(input.useDualstackEndpoint)
    });
};




var $c011d29fcbafd2c8$export$c69bd155af41e6f1 = function(input) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var _a, tls, region, dnsHostRegex, useDualstackEndpoint, useFipsEndpoint, hostname;
        var _b;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = input.tls, tls = _a === void 0 ? true : _a;
                    return [
                        4,
                        input.region()
                    ];
                case 1:
                    region = _c.sent();
                    dnsHostRegex = new RegExp(/^([a-zA-Z0-9]|[a-zA-Z0-9][a-zA-Z0-9-]{0,61}[a-zA-Z0-9])$/);
                    if (!dnsHostRegex.test(region)) throw new Error("Invalid region in client config");
                    return [
                        4,
                        input.useDualstackEndpoint()
                    ];
                case 2:
                    useDualstackEndpoint = _c.sent();
                    return [
                        4,
                        input.useFipsEndpoint()
                    ];
                case 3:
                    useFipsEndpoint = _c.sent();
                    return [
                        4,
                        input.regionInfoProvider(region, {
                            useDualstackEndpoint: useDualstackEndpoint,
                            useFipsEndpoint: useFipsEndpoint
                        })
                    ];
                case 4:
                    hostname = ((_b = _c.sent()) !== null && _b !== void 0 ? _b : {}).hostname;
                    if (!hostname) throw new Error("Cannot resolve hostname from client config");
                    return [
                        2,
                        input.urlParser((tls ? "https:" : "http:") + "//" + hostname)
                    ];
            }
        });
    });
};




var $9521496f3f5d932d$export$24f352b1bd1e2f8b = function(input) {
    var _a;
    var useDualstackEndpoint = (0, $b734e959a2594a91$export$5571117cd09e479d)(input.useDualstackEndpoint);
    var endpoint = input.endpoint, useFipsEndpoint = input.useFipsEndpoint;
    return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, input), {
        tls: (_a = input.tls) !== null && _a !== void 0 ? _a : true,
        endpoint: endpoint ? (0, $9ffd8c73d1b0dd07$export$57470ceb5d0ada23)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, input), {
            endpoint: endpoint
        })) : function() {
            return (0, $c011d29fcbafd2c8$export$c69bd155af41e6f1)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, input), {
                useDualstackEndpoint: useDualstackEndpoint,
                useFipsEndpoint: useFipsEndpoint
            }));
        },
        isCustomEndpoint: endpoint ? true : false,
        useDualstackEndpoint: useDualstackEndpoint
    });
};




var $e04d7cc25f6020c7$export$26513716e2900bad = "AWS_REGION";
var $e04d7cc25f6020c7$export$8afb1c306a7d01b = "region";
var $e04d7cc25f6020c7$export$1509d3ea54119a08 = {
    environmentVariableSelector: function(env) {
        return env[$e04d7cc25f6020c7$export$26513716e2900bad];
    },
    configFileSelector: function(profile) {
        return profile[$e04d7cc25f6020c7$export$8afb1c306a7d01b];
    },
    default: function() {
        throw new Error("Region is missing");
    }
};
var $e04d7cc25f6020c7$export$9a37503ca194454d = {
    preferredFile: "credentials"
};



var $eebffce22a8537bb$export$cc893cb7e6a508dd = function(region) {
    return typeof region === "string" && (region.startsWith("fips-") || region.endsWith("-fips"));
};


var $be930d75288904d0$export$ecbdf004a8547a7f = function(region) {
    return (0, $eebffce22a8537bb$export$cc893cb7e6a508dd)(region) ? [
        "fips-aws-global",
        "aws-fips"
    ].includes(region) ? "us-east-1" : region.replace(/fips-(dkr-|prod-)?|-fips/, "") : region;
};



var $46315709cfe1dfb5$export$7696ef37558bd0ec = function(input) {
    var region = input.region, useFipsEndpoint = input.useFipsEndpoint;
    if (!region) throw new Error("Region is missing");
    return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, input), {
        region: function() {
            return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
                var providedRegion;
                return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            if (typeof region === "string") return [
                                2,
                                (0, $be930d75288904d0$export$ecbdf004a8547a7f)(region)
                            ];
                            return [
                                4,
                                region()
                            ];
                        case 1:
                            providedRegion = _a.sent();
                            return [
                                2,
                                (0, $be930d75288904d0$export$ecbdf004a8547a7f)(providedRegion)
                            ];
                    }
                });
            });
        },
        useFipsEndpoint: function() {
            return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
                var providedRegion, _a;
                return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_b) {
                    switch(_b.label){
                        case 0:
                            if (!(typeof region === "string")) return [
                                3,
                                1
                            ];
                            _a = region;
                            return [
                                3,
                                3
                            ];
                        case 1:
                            return [
                                4,
                                region()
                            ];
                        case 2:
                            _a = _b.sent();
                            _b.label = 3;
                        case 3:
                            providedRegion = _a;
                            if ((0, $eebffce22a8537bb$export$cc893cb7e6a508dd)(providedRegion)) return [
                                2,
                                true
                            ];
                            return [
                                2,
                                typeof useFipsEndpoint === "boolean" ? Promise.resolve(useFipsEndpoint) : useFipsEndpoint()
                            ];
                    }
                });
            });
        }
    });
};









var $b00c1bed9d1c77c1$export$75494cb913bf7ef6 = function(variants, _a) {
    var _b;
    if (variants === void 0) variants = [];
    var useFipsEndpoint = _a.useFipsEndpoint, useDualstackEndpoint = _a.useDualstackEndpoint;
    return (_b = variants.find(function(_a) {
        var tags = _a.tags;
        return useFipsEndpoint === tags.includes("fips") && useDualstackEndpoint === tags.includes("dualstack");
    })) === null || _b === void 0 ? void 0 : _b.hostname;
};


var $97f0c57d225afb7c$export$d062b2a57a5d579b = function(resolvedRegion, _a) {
    var regionHostname = _a.regionHostname, partitionHostname = _a.partitionHostname;
    return regionHostname ? regionHostname : partitionHostname ? partitionHostname.replace("{region}", resolvedRegion) : undefined;
};


var $6a8080bf3ea1821b$export$2ba1c8e181ae49f8 = function(region, _a) {
    var _b;
    var partitionHash = _a.partitionHash;
    return (_b = Object.keys(partitionHash || {}).find(function(key) {
        return partitionHash[key].regions.includes(region);
    })) !== null && _b !== void 0 ? _b : "aws";
};


var $941165c1ac8ac6e0$export$be75b39beeb48b5c = function(hostname, _a) {
    var signingRegion = _a.signingRegion, regionRegex = _a.regionRegex, useFipsEndpoint = _a.useFipsEndpoint;
    if (signingRegion) return signingRegion;
    else if (useFipsEndpoint) {
        var regionRegexJs = regionRegex.replace("\\\\", "\\").replace(/^\^/g, "\\.").replace(/\$$/g, "\\.");
        var regionRegexmatchArray = hostname.match(regionRegexJs);
        if (regionRegexmatchArray) return regionRegexmatchArray[0].slice(1, -1);
    }
};


var $4cfcc1fd369b922a$export$2b789d827caebed0 = function(region, _a) {
    var _b, _c, _d, _e, _f, _g;
    var _h = _a.useFipsEndpoint, useFipsEndpoint = _h === void 0 ? false : _h, _j = _a.useDualstackEndpoint, useDualstackEndpoint = _j === void 0 ? false : _j, signingService = _a.signingService, regionHash = _a.regionHash, partitionHash = _a.partitionHash;
    var partition = (0, $6a8080bf3ea1821b$export$2ba1c8e181ae49f8)(region, {
        partitionHash: partitionHash
    });
    var resolvedRegion = region in regionHash ? region : (_c = (_b = partitionHash[partition]) === null || _b === void 0 ? void 0 : _b.endpoint) !== null && _c !== void 0 ? _c : region;
    var hostnameOptions = {
        useFipsEndpoint: useFipsEndpoint,
        useDualstackEndpoint: useDualstackEndpoint
    };
    var regionHostname = (0, $b00c1bed9d1c77c1$export$75494cb913bf7ef6)((_d = regionHash[resolvedRegion]) === null || _d === void 0 ? void 0 : _d.variants, hostnameOptions);
    var partitionHostname = (0, $b00c1bed9d1c77c1$export$75494cb913bf7ef6)((_e = partitionHash[partition]) === null || _e === void 0 ? void 0 : _e.variants, hostnameOptions);
    var hostname = (0, $97f0c57d225afb7c$export$d062b2a57a5d579b)(resolvedRegion, {
        regionHostname: regionHostname,
        partitionHostname: partitionHostname
    });
    if (hostname === undefined) throw new Error("Endpoint resolution failed for: [object Object]");
    var signingRegion = (0, $941165c1ac8ac6e0$export$be75b39beeb48b5c)(hostname, {
        signingRegion: (_f = regionHash[resolvedRegion]) === null || _f === void 0 ? void 0 : _f.signingRegion,
        regionRegex: partitionHash[partition].regionRegex,
        useFipsEndpoint: useFipsEndpoint
    });
    return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
        partition: partition,
        signingService: signingService,
        hostname: hostname
    }, signingRegion && {
        signingRegion: signingRegion
    }), ((_g = regionHash[resolvedRegion]) === null || _g === void 0 ? void 0 : _g.signingService) && {
        signingService: regionHash[resolvedRegion].signingService
    });
};








var $71d8e7a5aab972a2$var$CONTENT_LENGTH_HEADER = "content-length";
function $71d8e7a5aab972a2$export$940b29eb2788b975(bodyLengthChecker) {
    var _this = this;
    return function(next) {
        return function(args) {
            return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(_this, void 0, void 0, function() {
                var request, body, headers, length;
                var _a;
                return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_b) {
                    request = args.request;
                    if ((0, $f5162dd3bdb0d175$export$7587955500404ec3).isInstance(request)) {
                        body = request.body, headers = request.headers;
                        if (body && Object.keys(headers).map(function(str) {
                            return str.toLowerCase();
                        }).indexOf($71d8e7a5aab972a2$var$CONTENT_LENGTH_HEADER) === -1) {
                            length = bodyLengthChecker(body);
                            if (length !== undefined) request.headers = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, request.headers), (_a = {}, _a[$71d8e7a5aab972a2$var$CONTENT_LENGTH_HEADER] = String(length), _a));
                        }
                    }
                    return [
                        2,
                        next((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, args), {
                            request: request
                        }))
                    ];
                });
            });
        };
    };
}
var $71d8e7a5aab972a2$export$1f7816f8f350b2f5 = {
    step: "build",
    tags: [
        "SET_CONTENT_LENGTH",
        "CONTENT_LENGTH"
    ],
    name: "contentLengthMiddleware",
    override: true
};
var $71d8e7a5aab972a2$export$7e6ddf9365a30fe9 = function(options) {
    return {
        applyToStack: function(clientStack) {
            clientStack.add($71d8e7a5aab972a2$export$940b29eb2788b975(options.bodyLengthChecker), $71d8e7a5aab972a2$export$1f7816f8f350b2f5);
        }
    };
};




function $88d2ee7e36f5c90f$export$c1625bf0b32b4481(input) {
    return input;
}
var $88d2ee7e36f5c90f$export$858685d7aeef192d = function(options) {
    return function(next) {
        return function(args) {
            return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
                var request, _a, handlerProtocol;
                return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_b) {
                    if (!(0, $f5162dd3bdb0d175$export$7587955500404ec3).isInstance(args.request)) return [
                        2,
                        next(args)
                    ];
                    request = args.request;
                    _a = (options.requestHandler.metadata || {}).handlerProtocol, handlerProtocol = _a === void 0 ? "" : _a;
                    if (handlerProtocol.indexOf("h2") >= 0 && !request.headers[":authority"]) {
                        delete request.headers["host"];
                        request.headers[":authority"] = "";
                    } else if (!request.headers["host"]) request.headers["host"] = request.hostname;
                    return [
                        2,
                        next(args)
                    ];
                });
            });
        };
    };
};
var $88d2ee7e36f5c90f$export$696d244ba96181e8 = {
    name: "hostHeaderMiddleware",
    step: "build",
    priority: "low",
    tags: [
        "HOST"
    ],
    override: true
};
var $88d2ee7e36f5c90f$export$23d3b647211be53a = function(options) {
    return {
        applyToStack: function(clientStack) {
            clientStack.add($88d2ee7e36f5c90f$export$858685d7aeef192d(options), $88d2ee7e36f5c90f$export$696d244ba96181e8);
        }
    };
};



var $8add791fe0d5d356$export$fe0e777ee4f58cde = function() {
    return function(next, context) {
        return function(args) {
            return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
                var clientName, commandName, inputFilterSensitiveLog, logger, outputFilterSensitiveLog, response, _a, $metadata, outputWithoutMetadata;
                return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_b) {
                    switch(_b.label){
                        case 0:
                            clientName = context.clientName, commandName = context.commandName, inputFilterSensitiveLog = context.inputFilterSensitiveLog, logger = context.logger, outputFilterSensitiveLog = context.outputFilterSensitiveLog;
                            return [
                                4,
                                next(args)
                            ];
                        case 1:
                            response = _b.sent();
                            if (!logger) return [
                                2,
                                response
                            ];
                            if (typeof logger.info === "function") {
                                _a = response.output, $metadata = _a.$metadata, outputWithoutMetadata = (0, $5c96a02c592fcff1$export$3c9a16f847548506)(_a, [
                                    "$metadata"
                                ]);
                                logger.info({
                                    clientName: clientName,
                                    commandName: commandName,
                                    input: inputFilterSensitiveLog(args.input),
                                    output: outputFilterSensitiveLog(outputWithoutMetadata),
                                    metadata: $metadata
                                });
                            }
                            return [
                                2,
                                response
                            ];
                    }
                });
            });
        };
    };
};
var $8add791fe0d5d356$export$877c148ab4ad0722 = {
    name: "loggerMiddleware",
    tags: [
        "LOGGER"
    ],
    step: "initialize",
    override: true
};
var $8add791fe0d5d356$export$f6ef65d7766fc255 = function(options) {
    return {
        applyToStack: function(clientStack) {
            clientStack.add($8add791fe0d5d356$export$fe0e777ee4f58cde(), $8add791fe0d5d356$export$877c148ab4ad0722);
        }
    };
};





var $53bf6756b7a43689$export$6842199fccd474d3;
(function(RETRY_MODES) {
    RETRY_MODES["STANDARD"] = "standard";
    RETRY_MODES["ADAPTIVE"] = "adaptive";
})($53bf6756b7a43689$export$6842199fccd474d3 || ($53bf6756b7a43689$export$6842199fccd474d3 = {}));
var $53bf6756b7a43689$export$2c7e51f38ba5a406 = 3;
var $53bf6756b7a43689$export$41315747b7c5d042 = $53bf6756b7a43689$export$6842199fccd474d3.STANDARD;



var $ae125ddd40ce6221$export$9fde012b8b2a10ca = [
    "AuthFailure",
    "InvalidSignatureException",
    "RequestExpired",
    "RequestInTheFuture",
    "RequestTimeTooSkewed",
    "SignatureDoesNotMatch"
];
var $ae125ddd40ce6221$export$89cd1b0ccfcb99d = [
    "BandwidthLimitExceeded",
    "EC2ThrottledException",
    "LimitExceededException",
    "PriorRequestNotComplete",
    "ProvisionedThroughputExceededException",
    "RequestLimitExceeded",
    "RequestThrottled",
    "RequestThrottledException",
    "SlowDown",
    "ThrottledException",
    "Throttling",
    "ThrottlingException",
    "TooManyRequestsException",
    "TransactionInProgressException"
];
var $ae125ddd40ce6221$export$18bd3bfe89ded398 = [
    "AbortError",
    "TimeoutError",
    "RequestTimeout",
    "RequestTimeoutException"
];
var $ae125ddd40ce6221$export$38bf589d26009e4f = [
    500,
    502,
    503,
    504
];


var $85e83ffd6500356c$export$46428803f4bd8a0c = function(error) {
    return error.$retryable !== undefined;
};
var $85e83ffd6500356c$export$7b87435661177a94 = function(error) {
    return (0, $ae125ddd40ce6221$export$9fde012b8b2a10ca).includes(error.name);
};
var $85e83ffd6500356c$export$cbecb89f6256ccc8 = function(error) {
    var _a, _b;
    return ((_a = error.$metadata) === null || _a === void 0 ? void 0 : _a.httpStatusCode) === 429 || (0, $ae125ddd40ce6221$export$89cd1b0ccfcb99d).includes(error.name) || ((_b = error.$retryable) === null || _b === void 0 ? void 0 : _b.throttling) == true;
};
var $85e83ffd6500356c$export$31778435da988512 = function(error) {
    var _a;
    return (0, $ae125ddd40ce6221$export$18bd3bfe89ded398).includes(error.name) || (0, $ae125ddd40ce6221$export$38bf589d26009e4f).includes(((_a = error.$metadata) === null || _a === void 0 ? void 0 : _a.httpStatusCode) || 0);
};


var $66c146bfdaf593ae$export$4d4bb1390e4746c4 = function() {
    function DefaultRateLimiter(options) {
        var _a, _b, _c, _d, _e;
        this.currentCapacity = 0;
        this.enabled = false;
        this.lastMaxRate = 0;
        this.measuredTxRate = 0;
        this.requestCount = 0;
        this.lastTimestamp = 0;
        this.timeWindow = 0;
        this.beta = (_a = options === null || options === void 0 ? void 0 : options.beta) !== null && _a !== void 0 ? _a : 0.7;
        this.minCapacity = (_b = options === null || options === void 0 ? void 0 : options.minCapacity) !== null && _b !== void 0 ? _b : 1;
        this.minFillRate = (_c = options === null || options === void 0 ? void 0 : options.minFillRate) !== null && _c !== void 0 ? _c : 0.5;
        this.scaleConstant = (_d = options === null || options === void 0 ? void 0 : options.scaleConstant) !== null && _d !== void 0 ? _d : 0.4;
        this.smooth = (_e = options === null || options === void 0 ? void 0 : options.smooth) !== null && _e !== void 0 ? _e : 0.8;
        var currentTimeInSeconds = this.getCurrentTimeInSeconds();
        this.lastThrottleTime = currentTimeInSeconds;
        this.lastTxRateBucket = Math.floor(this.getCurrentTimeInSeconds());
        this.fillRate = this.minFillRate;
        this.maxCapacity = this.minCapacity;
    }
    DefaultRateLimiter.prototype.getCurrentTimeInSeconds = function() {
        return Date.now() / 1000;
    };
    DefaultRateLimiter.prototype.getSendToken = function() {
        return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(this, void 0, void 0, function() {
            return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
                return [
                    2,
                    this.acquireTokenBucket(1)
                ];
            });
        });
    };
    DefaultRateLimiter.prototype.acquireTokenBucket = function(amount) {
        return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var delay_1;
            return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!this.enabled) return [
                            2
                        ];
                        this.refillTokenBucket();
                        if (!(amount > this.currentCapacity)) return [
                            3,
                            2
                        ];
                        delay_1 = (amount - this.currentCapacity) / this.fillRate * 1000;
                        return [
                            4,
                            new Promise(function(resolve) {
                                return setTimeout(resolve, delay_1);
                            })
                        ];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        this.currentCapacity = this.currentCapacity - amount;
                        return [
                            2
                        ];
                }
            });
        });
    };
    DefaultRateLimiter.prototype.refillTokenBucket = function() {
        var timestamp = this.getCurrentTimeInSeconds();
        if (!this.lastTimestamp) {
            this.lastTimestamp = timestamp;
            return;
        }
        var fillAmount = (timestamp - this.lastTimestamp) * this.fillRate;
        this.currentCapacity = Math.min(this.maxCapacity, this.currentCapacity + fillAmount);
        this.lastTimestamp = timestamp;
    };
    DefaultRateLimiter.prototype.updateClientSendingRate = function(response) {
        var calculatedRate;
        this.updateMeasuredRate();
        if ((0, $85e83ffd6500356c$export$cbecb89f6256ccc8)(response)) {
            var rateToUse = !this.enabled ? this.measuredTxRate : Math.min(this.measuredTxRate, this.fillRate);
            this.lastMaxRate = rateToUse;
            this.calculateTimeWindow();
            this.lastThrottleTime = this.getCurrentTimeInSeconds();
            calculatedRate = this.cubicThrottle(rateToUse);
            this.enableTokenBucket();
        } else {
            this.calculateTimeWindow();
            calculatedRate = this.cubicSuccess(this.getCurrentTimeInSeconds());
        }
        var newRate = Math.min(calculatedRate, 2 * this.measuredTxRate);
        this.updateTokenBucketRate(newRate);
    };
    DefaultRateLimiter.prototype.calculateTimeWindow = function() {
        this.timeWindow = this.getPrecise(Math.pow(this.lastMaxRate * (1 - this.beta) / this.scaleConstant, 1 / 3));
    };
    DefaultRateLimiter.prototype.cubicThrottle = function(rateToUse) {
        return this.getPrecise(rateToUse * this.beta);
    };
    DefaultRateLimiter.prototype.cubicSuccess = function(timestamp) {
        return this.getPrecise(this.scaleConstant * Math.pow(timestamp - this.lastThrottleTime - this.timeWindow, 3) + this.lastMaxRate);
    };
    DefaultRateLimiter.prototype.enableTokenBucket = function() {
        this.enabled = true;
    };
    DefaultRateLimiter.prototype.updateTokenBucketRate = function(newRate) {
        this.refillTokenBucket();
        this.fillRate = Math.max(newRate, this.minFillRate);
        this.maxCapacity = Math.max(newRate, this.minCapacity);
        this.currentCapacity = Math.min(this.currentCapacity, this.maxCapacity);
    };
    DefaultRateLimiter.prototype.updateMeasuredRate = function() {
        var t = this.getCurrentTimeInSeconds();
        var timeBucket = Math.floor(t * 2) / 2;
        this.requestCount++;
        if (timeBucket > this.lastTxRateBucket) {
            var currentRate = this.requestCount / (timeBucket - this.lastTxRateBucket);
            this.measuredTxRate = this.getPrecise(currentRate * this.smooth + this.measuredTxRate * (1 - this.smooth));
            this.requestCount = 0;
            this.lastTxRateBucket = timeBucket;
        }
    };
    DefaultRateLimiter.prototype.getPrecise = function(num) {
        return parseFloat(num.toFixed(8));
    };
    return DefaultRateLimiter;
}();





// Unique ID creation requires a high quality random # generator. In the browser we therefore
// require the crypto API and do not support built-in fallback to lower quality random number
// generators (like Math.random()).
var $568f4ee4022ba00e$var$getRandomValues;
var $568f4ee4022ba00e$var$rnds8 = new Uint8Array(16);
function $568f4ee4022ba00e$export$2e2bcd8739ae039() {
    // lazy load so that environments that need to polyfill have a chance to do so
    if (!$568f4ee4022ba00e$var$getRandomValues) {
        // getRandomValues needs to be invoked in a context where "this" is a Crypto implementation. Also,
        // find the complete implementation of crypto (msCrypto) on IE11.
        $568f4ee4022ba00e$var$getRandomValues = typeof crypto !== "undefined" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto !== "undefined" && typeof msCrypto.getRandomValues === "function" && msCrypto.getRandomValues.bind(msCrypto);
        if (!$568f4ee4022ba00e$var$getRandomValues) throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
    }
    return $568f4ee4022ba00e$var$getRandomValues($568f4ee4022ba00e$var$rnds8);
}


var $32c496bfb6c27b56$export$2e2bcd8739ae039 = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;


function $46d323206dcbf256$var$validate(uuid) {
    return typeof uuid === "string" && (0, $32c496bfb6c27b56$export$2e2bcd8739ae039).test(uuid);
}
var $46d323206dcbf256$export$2e2bcd8739ae039 = $46d323206dcbf256$var$validate;


/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */ var $1d0137947e8554ce$var$byteToHex = [];
for(var $1d0137947e8554ce$var$i = 0; $1d0137947e8554ce$var$i < 256; ++$1d0137947e8554ce$var$i)$1d0137947e8554ce$var$byteToHex.push(($1d0137947e8554ce$var$i + 0x100).toString(16).substr(1));
function $1d0137947e8554ce$var$stringify(arr) {
    var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    // Note: Be careful editing this code!  It's been tuned for performance
    // and works in ways you may not expect. See https://github.com/uuidjs/uuid/pull/434
    var uuid = ($1d0137947e8554ce$var$byteToHex[arr[offset + 0]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 1]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 2]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 3]] + "-" + $1d0137947e8554ce$var$byteToHex[arr[offset + 4]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 5]] + "-" + $1d0137947e8554ce$var$byteToHex[arr[offset + 6]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 7]] + "-" + $1d0137947e8554ce$var$byteToHex[arr[offset + 8]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 9]] + "-" + $1d0137947e8554ce$var$byteToHex[arr[offset + 10]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 11]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 12]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 13]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 14]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 15]]).toLowerCase(); // Consistency check for valid UUID.  If this throws, it's likely due to one
    // of the following:
    // - One or more input array values don't map to a hex octet (leading to
    // "undefined" in the uuid)
    // - Invalid input values for the RFC `version` or `variant` fields
    if (!(0, $46d323206dcbf256$export$2e2bcd8739ae039)(uuid)) throw TypeError("Stringified UUID is invalid");
    return uuid;
}
var $1d0137947e8554ce$export$2e2bcd8739ae039 = $1d0137947e8554ce$var$stringify;


function $3fa3ae484854b431$var$v4(options, buf, offset) {
    options = options || {};
    var rnds = options.random || (options.rng || (0, $568f4ee4022ba00e$export$2e2bcd8739ae039))(); // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80; // Copy bytes to buffer, if provided
    if (buf) {
        offset = offset || 0;
        for(var i = 0; i < 16; ++i)buf[offset + i] = rnds[i];
        return buf;
    }
    return (0, $1d0137947e8554ce$export$2e2bcd8739ae039)(rnds);
}
var $3fa3ae484854b431$export$2e2bcd8739ae039 = $3fa3ae484854b431$var$v4;



var $6a11360e1991ef60$export$7067ba90effbd789 = 100;
var $6a11360e1991ef60$export$2412c80d04e902c6 = 20000;
var $6a11360e1991ef60$export$4af31f8250b48e23 = 500;
var $6a11360e1991ef60$export$f8c3d11675a1153 = 500;
var $6a11360e1991ef60$export$797febae1136bc84 = 5;
var $6a11360e1991ef60$export$b643545eaf9af837 = 10;
var $6a11360e1991ef60$export$a25da3406dc148e4 = 1;
var $6a11360e1991ef60$export$197fd517bf66ccb2 = "amz-sdk-invocation-id";
var $6a11360e1991ef60$export$d4f764f0ec4f52f = "amz-sdk-request";



var $18fdd5a5c1ed282f$export$2ebe7988802fc284 = function(initialRetryTokens, options) {
    var _a, _b, _c;
    var MAX_CAPACITY = initialRetryTokens;
    var noRetryIncrement = (_a = options === null || options === void 0 ? void 0 : options.noRetryIncrement) !== null && _a !== void 0 ? _a : (0, $6a11360e1991ef60$export$a25da3406dc148e4);
    var retryCost = (_b = options === null || options === void 0 ? void 0 : options.retryCost) !== null && _b !== void 0 ? _b : (0, $6a11360e1991ef60$export$797febae1136bc84);
    var timeoutRetryCost = (_c = options === null || options === void 0 ? void 0 : options.timeoutRetryCost) !== null && _c !== void 0 ? _c : (0, $6a11360e1991ef60$export$b643545eaf9af837);
    var availableCapacity = initialRetryTokens;
    var getCapacityAmount = function(error) {
        return error.name === "TimeoutError" ? timeoutRetryCost : retryCost;
    };
    var hasRetryTokens = function(error) {
        return getCapacityAmount(error) <= availableCapacity;
    };
    var retrieveRetryTokens = function(error) {
        if (!hasRetryTokens(error)) throw new Error("No retry token available");
        var capacityAmount = getCapacityAmount(error);
        availableCapacity -= capacityAmount;
        return capacityAmount;
    };
    var releaseRetryTokens = function(capacityReleaseAmount) {
        availableCapacity += capacityReleaseAmount !== null && capacityReleaseAmount !== void 0 ? capacityReleaseAmount : noRetryIncrement;
        availableCapacity = Math.min(availableCapacity, MAX_CAPACITY);
    };
    return Object.freeze({
        hasRetryTokens: hasRetryTokens,
        retrieveRetryTokens: retrieveRetryTokens,
        releaseRetryTokens: releaseRetryTokens
    });
};



var $381c03a089c16e08$export$1cddd42598a3b1f6 = function(delayBase, attempts) {
    return Math.floor(Math.min((0, $6a11360e1991ef60$export$2412c80d04e902c6), Math.random() * Math.pow(2, attempts) * delayBase));
};



var $358d10788622749c$export$3839fd261f89ec2 = function(error) {
    if (!error) return false;
    return (0, $85e83ffd6500356c$export$46428803f4bd8a0c)(error) || (0, $85e83ffd6500356c$export$7b87435661177a94)(error) || (0, $85e83ffd6500356c$export$cbecb89f6256ccc8)(error) || (0, $85e83ffd6500356c$export$31778435da988512)(error);
};


var $0a328ffca561f659$export$64af437cce00eae8 = function() {
    function StandardRetryStrategy(maxAttemptsProvider, options) {
        var _a, _b, _c;
        this.maxAttemptsProvider = maxAttemptsProvider;
        this.mode = (0, $53bf6756b7a43689$export$6842199fccd474d3).STANDARD;
        this.retryDecider = (_a = options === null || options === void 0 ? void 0 : options.retryDecider) !== null && _a !== void 0 ? _a : (0, $358d10788622749c$export$3839fd261f89ec2);
        this.delayDecider = (_b = options === null || options === void 0 ? void 0 : options.delayDecider) !== null && _b !== void 0 ? _b : (0, $381c03a089c16e08$export$1cddd42598a3b1f6);
        this.retryQuota = (_c = options === null || options === void 0 ? void 0 : options.retryQuota) !== null && _c !== void 0 ? _c : (0, $18fdd5a5c1ed282f$export$2ebe7988802fc284)((0, $6a11360e1991ef60$export$f8c3d11675a1153));
    }
    StandardRetryStrategy.prototype.shouldRetry = function(error, attempts, maxAttempts) {
        return attempts < maxAttempts && this.retryDecider(error) && this.retryQuota.hasRetryTokens(error);
    };
    StandardRetryStrategy.prototype.getMaxAttempts = function() {
        return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var maxAttempts, error_1;
            return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        _a.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4,
                            this.maxAttemptsProvider()
                        ];
                    case 1:
                        maxAttempts = _a.sent();
                        return [
                            3,
                            3
                        ];
                    case 2:
                        error_1 = _a.sent();
                        maxAttempts = (0, $53bf6756b7a43689$export$2c7e51f38ba5a406);
                        return [
                            3,
                            3
                        ];
                    case 3:
                        return [
                            2,
                            maxAttempts
                        ];
                }
            });
        });
    };
    StandardRetryStrategy.prototype.retry = function(next, args, options) {
        return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var retryTokenAmount, attempts, totalDelay, maxAttempts, request, _loop_1, this_1, state_1;
            return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        attempts = 0;
                        totalDelay = 0;
                        return [
                            4,
                            this.getMaxAttempts()
                        ];
                    case 1:
                        maxAttempts = _a.sent();
                        request = args.request;
                        if ((0, $f5162dd3bdb0d175$export$7587955500404ec3).isInstance(request)) request.headers[0, $6a11360e1991ef60$export$197fd517bf66ccb2] = (0, $3fa3ae484854b431$export$2e2bcd8739ae039)();
                        _loop_1 = function() {
                            var _b, response, output, e_1, err, delay_1;
                            return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_c) {
                                switch(_c.label){
                                    case 0:
                                        _c.trys.push([
                                            0,
                                            4,
                                            ,
                                            7
                                        ]);
                                        if ((0, $f5162dd3bdb0d175$export$7587955500404ec3).isInstance(request)) request.headers[0, $6a11360e1991ef60$export$d4f764f0ec4f52f] = "attempt=" + (attempts + 1) + "; max=" + maxAttempts;
                                        if (!(options === null || options === void 0 ? void 0 : options.beforeRequest)) return [
                                            3,
                                            2
                                        ];
                                        return [
                                            4,
                                            options.beforeRequest()
                                        ];
                                    case 1:
                                        _c.sent();
                                        _c.label = 2;
                                    case 2:
                                        return [
                                            4,
                                            next(args)
                                        ];
                                    case 3:
                                        _b = _c.sent(), response = _b.response, output = _b.output;
                                        if (options === null || options === void 0 ? void 0 : options.afterRequest) options.afterRequest(response);
                                        this_1.retryQuota.releaseRetryTokens(retryTokenAmount);
                                        output.$metadata.attempts = attempts + 1;
                                        output.$metadata.totalRetryDelay = totalDelay;
                                        return [
                                            2,
                                            {
                                                value: {
                                                    response: response,
                                                    output: output
                                                }
                                            }
                                        ];
                                    case 4:
                                        e_1 = _c.sent();
                                        err = $0a328ffca561f659$var$asSdkError(e_1);
                                        attempts++;
                                        if (!this_1.shouldRetry(err, attempts, maxAttempts)) return [
                                            3,
                                            6
                                        ];
                                        retryTokenAmount = this_1.retryQuota.retrieveRetryTokens(err);
                                        delay_1 = this_1.delayDecider((0, $85e83ffd6500356c$export$cbecb89f6256ccc8)(err) ? (0, $6a11360e1991ef60$export$4af31f8250b48e23) : (0, $6a11360e1991ef60$export$7067ba90effbd789), attempts);
                                        totalDelay += delay_1;
                                        return [
                                            4,
                                            new Promise(function(resolve) {
                                                return setTimeout(resolve, delay_1);
                                            })
                                        ];
                                    case 5:
                                        _c.sent();
                                        return [
                                            2,
                                            "continue"
                                        ];
                                    case 6:
                                        if (!err.$metadata) err.$metadata = {};
                                        err.$metadata.attempts = attempts;
                                        err.$metadata.totalRetryDelay = totalDelay;
                                        throw err;
                                    case 7:
                                        return [
                                            2
                                        ];
                                }
                            });
                        };
                        this_1 = this;
                        _a.label = 2;
                    case 2:
                        return [
                            5,
                            _loop_1()
                        ];
                    case 3:
                        state_1 = _a.sent();
                        if (typeof state_1 === "object") return [
                            2,
                            state_1.value
                        ];
                        return [
                            3,
                            2
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
    };
    return StandardRetryStrategy;
}();
var $0a328ffca561f659$var$asSdkError = function(error) {
    if (error instanceof Error) return error;
    if (error instanceof Object) return Object.assign(new Error(), error);
    if (typeof error === "string") return new Error(error);
    return new Error("AWS SDK error wrapper for " + error);
};


var $7b1750ef96ad8b70$export$b6f3faf7501de8bc = function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(AdaptiveRetryStrategy, _super);
    function AdaptiveRetryStrategy(maxAttemptsProvider, options) {
        var _this = this;
        var _a = options !== null && options !== void 0 ? options : {}, rateLimiter = _a.rateLimiter, superOptions = (0, $5c96a02c592fcff1$export$3c9a16f847548506)(_a, [
            "rateLimiter"
        ]);
        _this = _super.call(this, maxAttemptsProvider, superOptions) || this;
        _this.rateLimiter = rateLimiter !== null && rateLimiter !== void 0 ? rateLimiter : new (0, $66c146bfdaf593ae$export$4d4bb1390e4746c4)();
        _this.mode = (0, $53bf6756b7a43689$export$6842199fccd474d3).ADAPTIVE;
        return _this;
    }
    AdaptiveRetryStrategy.prototype.retry = function(next, args) {
        return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var _this = this;
            return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
                return [
                    2,
                    _super.prototype.retry.call(this, next, args, {
                        beforeRequest: function() {
                            return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(_this, void 0, void 0, function() {
                                return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
                                    return [
                                        2,
                                        this.rateLimiter.getSendToken()
                                    ];
                                });
                            });
                        },
                        afterRequest: function(response) {
                            _this.rateLimiter.updateClientSendingRate(response);
                        }
                    })
                ];
            });
        });
    };
    return AdaptiveRetryStrategy;
}((0, $0a328ffca561f659$export$64af437cce00eae8));









var $42800a4d5c7187b8$export$a19952f9e421517c = "AWS_MAX_ATTEMPTS";
var $42800a4d5c7187b8$export$9ae8a04532f798bc = "max_attempts";
var $42800a4d5c7187b8$export$8023fdddb2ca30e0 = {
    environmentVariableSelector: function(env) {
        var value = env[$42800a4d5c7187b8$export$a19952f9e421517c];
        if (!value) return undefined;
        var maxAttempt = parseInt(value);
        if (Number.isNaN(maxAttempt)) throw new Error("Environment variable " + $42800a4d5c7187b8$export$a19952f9e421517c + ' mast be a number, got "' + value + '"');
        return maxAttempt;
    },
    configFileSelector: function(profile) {
        var value = profile[$42800a4d5c7187b8$export$9ae8a04532f798bc];
        if (!value) return undefined;
        var maxAttempt = parseInt(value);
        if (Number.isNaN(maxAttempt)) throw new Error("Shared config file entry " + $42800a4d5c7187b8$export$9ae8a04532f798bc + ' mast be a number, got "' + value + '"');
        return maxAttempt;
    },
    default: (0, $53bf6756b7a43689$export$2c7e51f38ba5a406)
};
var $42800a4d5c7187b8$export$ca7f6138f2c98476 = function(input) {
    var maxAttempts = $42800a4d5c7187b8$var$normalizeMaxAttempts(input.maxAttempts);
    return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, input), {
        maxAttempts: maxAttempts,
        retryStrategy: function() {
            return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
                var retryMode;
                return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            if (input.retryStrategy) return [
                                2,
                                input.retryStrategy
                            ];
                            return [
                                4,
                                $42800a4d5c7187b8$var$getRetryMode(input.retryMode)
                            ];
                        case 1:
                            retryMode = _a.sent();
                            if (retryMode === (0, $53bf6756b7a43689$export$6842199fccd474d3).ADAPTIVE) return [
                                2,
                                new (0, $7b1750ef96ad8b70$export$b6f3faf7501de8bc)(maxAttempts)
                            ];
                            return [
                                2,
                                new (0, $0a328ffca561f659$export$64af437cce00eae8)(maxAttempts)
                            ];
                    }
                });
            });
        }
    });
};
var $42800a4d5c7187b8$var$getRetryMode = function(retryMode) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (typeof retryMode === "string") return [
                        2,
                        retryMode
                    ];
                    return [
                        4,
                        retryMode()
                    ];
                case 1:
                    return [
                        2,
                        _a.sent()
                    ];
            }
        });
    });
};
var $42800a4d5c7187b8$var$normalizeMaxAttempts = function(maxAttempts) {
    if (maxAttempts === void 0) maxAttempts = (0, $53bf6756b7a43689$export$2c7e51f38ba5a406);
    if (typeof maxAttempts === "number") {
        var promisified_1 = Promise.resolve(maxAttempts);
        return function() {
            return promisified_1;
        };
    }
    return maxAttempts;
};
var $42800a4d5c7187b8$export$4728af91ff39ef3b = "AWS_RETRY_MODE";
var $42800a4d5c7187b8$export$c5c0171a17765aea = "retry_mode";
var $42800a4d5c7187b8$export$972bf2bb01959ff5 = {
    environmentVariableSelector: function(env) {
        return env[$42800a4d5c7187b8$export$4728af91ff39ef3b];
    },
    configFileSelector: function(profile) {
        return profile[$42800a4d5c7187b8$export$c5c0171a17765aea];
    },
    default: (0, $53bf6756b7a43689$export$41315747b7c5d042)
};






var $ebbfa92504cb4a9b$export$536b11ee0b9c4a95 = function() {
    return function(next) {
        return function(args) {
            return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
                var request;
                return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
                    request = args.request;
                    if ((0, $f5162dd3bdb0d175$export$7587955500404ec3).isInstance(request)) {
                        delete request.headers[0, $6a11360e1991ef60$export$197fd517bf66ccb2];
                        delete request.headers[0, $6a11360e1991ef60$export$d4f764f0ec4f52f];
                    }
                    return [
                        2,
                        next(args)
                    ];
                });
            });
        };
    };
};
var $ebbfa92504cb4a9b$export$3ec587d8f35e7a2c = {
    name: "omitRetryHeadersMiddleware",
    tags: [
        "RETRY",
        "HEADERS",
        "OMIT_RETRY_HEADERS"
    ],
    relation: "before",
    toMiddleware: "awsAuthMiddleware",
    override: true
};
var $ebbfa92504cb4a9b$export$fa165e6edc16c2a2 = function(options) {
    return {
        applyToStack: function(clientStack) {
            clientStack.addRelativeTo($ebbfa92504cb4a9b$export$536b11ee0b9c4a95(), $ebbfa92504cb4a9b$export$3ec587d8f35e7a2c);
        }
    };
};




var $0b1fbcc7312d8a59$export$a3922aa5f87bae85 = function(options) {
    return function(next, context) {
        return function(args) {
            return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
                var retryStrategy;
                return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            return [
                                4,
                                options.retryStrategy()
                            ];
                        case 1:
                            retryStrategy = _a.sent();
                            if (retryStrategy === null || retryStrategy === void 0 ? void 0 : retryStrategy.mode) context.userAgent = (0, $5c96a02c592fcff1$export$1216008129fb82ed)((0, $5c96a02c592fcff1$export$1216008129fb82ed)([], (0, $5c96a02c592fcff1$export$8d051b38c9118094)(context.userAgent || [])), [
                                [
                                    "cfg/retry-mode",
                                    retryStrategy.mode
                                ]
                            ]);
                            return [
                                2,
                                retryStrategy.retry(next, args)
                            ];
                    }
                });
            });
        };
    };
};
var $0b1fbcc7312d8a59$export$44d3d03587957ce9 = {
    name: "retryMiddleware",
    tags: [
        "RETRY"
    ],
    step: "finalizeRequest",
    priority: "high",
    override: true
};
var $0b1fbcc7312d8a59$export$c73199e2b1df9340 = function(options) {
    return {
        applyToStack: function(clientStack) {
            clientStack.add($0b1fbcc7312d8a59$export$a3922aa5f87bae85(options), $0b1fbcc7312d8a59$export$44d3d03587957ce9);
        }
    };
};








var $8305e5b5474397a4$export$478ec1fdae99aa79 = function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(ProviderError, _super);
    function ProviderError(message, tryNextLink) {
        if (tryNextLink === void 0) tryNextLink = true;
        var _this = _super.call(this, message) || this;
        _this.tryNextLink = tryNextLink;
        return _this;
    }
    ProviderError.from = function(error, tryNextLink) {
        if (tryNextLink === void 0) tryNextLink = true;
        Object.defineProperty(error, "tryNextLink", {
            value: tryNextLink,
            configurable: false,
            enumerable: false,
            writable: false
        });
        return error;
    };
    return ProviderError;
}(Error);
var $8305e5b5474397a4$export$921076535eff0df5 = function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(CredentialsProviderError, _super);
    function CredentialsProviderError(message, tryNextLink) {
        if (tryNextLink === void 0) tryNextLink = true;
        var _this = _super.call(this, message) || this;
        _this.tryNextLink = tryNextLink;
        _this.name = "CredentialsProviderError";
        return _this;
    }
    CredentialsProviderError.from = function(error, tryNextLink) {
        if (tryNextLink === void 0) tryNextLink = true;
        Object.defineProperty(error, "tryNextLink", {
            value: tryNextLink,
            configurable: false,
            enumerable: false,
            writable: false
        });
        return error;
    };
    return CredentialsProviderError;
}(Error);




function $5bd54fca9c3f4c60$export$e08e3b67e392101e() {
    var providers = [];
    for(var _i = 0; _i < arguments.length; _i++)providers[_i] = arguments[_i];
    return function() {
        var e_1, _a;
        var promise = Promise.reject(new (0, $8305e5b5474397a4$export$478ec1fdae99aa79)("No providers in chain"));
        var _loop_1 = function(provider) {
            promise = promise.catch(function(err) {
                if (err === null || err === void 0 ? void 0 : err.tryNextLink) return provider();
                throw err;
            });
        };
        try {
            for(var providers_1 = (0, $5c96a02c592fcff1$export$19a8beecd37a4c45)(providers), providers_1_1 = providers_1.next(); !providers_1_1.done; providers_1_1 = providers_1.next()){
                var provider = providers_1_1.value;
                _loop_1(provider);
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (providers_1_1 && !providers_1_1.done && (_a = providers_1.return)) _a.call(providers_1);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        return promise;
    };
}


var $0f4d26fb3a51b8a5$export$294ab423a8f4a426 = function(staticValue) {
    return function() {
        return Promise.resolve(staticValue);
    };
};



var $d99a93426bc19e29$export$fc10aeed3a532e2a = function(provider, isExpired, requiresRefresh) {
    var resolved;
    var pending;
    var hasResult;
    var coalesceProvider = function() {
        return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
            return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!pending) pending = provider();
                        _a.label = 1;
                    case 1:
                        _a.trys.push([
                            1,
                            ,
                            3,
                            4
                        ]);
                        return [
                            4,
                            pending
                        ];
                    case 2:
                        resolved = _a.sent();
                        hasResult = true;
                        return [
                            3,
                            4
                        ];
                    case 3:
                        pending = undefined;
                        return [
                            7
                        ];
                    case 4:
                        return [
                            2,
                            resolved
                        ];
                }
            });
        });
    };
    if (isExpired === undefined) return function() {
        return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
            return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!!hasResult) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            coalesceProvider()
                        ];
                    case 1:
                        resolved = _a.sent();
                        _a.label = 2;
                    case 2:
                        return [
                            2,
                            resolved
                        ];
                }
            });
        });
    };
    var isConstant = false;
    return function() {
        return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
            return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!!hasResult) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            coalesceProvider()
                        ];
                    case 1:
                        resolved = _a.sent();
                        _a.label = 2;
                    case 2:
                        if (isConstant) return [
                            2,
                            resolved
                        ];
                        if (requiresRefresh && !requiresRefresh(resolved)) {
                            isConstant = true;
                            return [
                                2,
                                resolved
                            ];
                        }
                        if (!isExpired(resolved)) return [
                            3,
                            4
                        ];
                        return [
                            4,
                            coalesceProvider()
                        ];
                    case 3:
                        _a.sent();
                        return [
                            2,
                            resolved
                        ];
                    case 4:
                        return [
                            2,
                            resolved
                        ];
                }
            });
        });
    };
};





var $bf5b342e1f787046$var$SHORT_TO_HEX = {};
var $bf5b342e1f787046$var$HEX_TO_SHORT = {};
for(var $bf5b342e1f787046$var$i = 0; $bf5b342e1f787046$var$i < 256; $bf5b342e1f787046$var$i++){
    var $bf5b342e1f787046$var$encodedByte = $bf5b342e1f787046$var$i.toString(16).toLowerCase();
    if ($bf5b342e1f787046$var$encodedByte.length === 1) $bf5b342e1f787046$var$encodedByte = "0" + $bf5b342e1f787046$var$encodedByte;
    $bf5b342e1f787046$var$SHORT_TO_HEX[$bf5b342e1f787046$var$i] = $bf5b342e1f787046$var$encodedByte;
    $bf5b342e1f787046$var$HEX_TO_SHORT[$bf5b342e1f787046$var$encodedByte] = $bf5b342e1f787046$var$i;
}
function $bf5b342e1f787046$export$1a8ceedbd5845648(encoded) {
    if (encoded.length % 2 !== 0) throw new Error("Hex encoded strings must have an even number length");
    var out = new Uint8Array(encoded.length / 2);
    for(var i = 0; i < encoded.length; i += 2){
        var encodedByte = encoded.substr(i, 2).toLowerCase();
        if (encodedByte in $bf5b342e1f787046$var$HEX_TO_SHORT) out[i / 2] = $bf5b342e1f787046$var$HEX_TO_SHORT[encodedByte];
        else throw new Error("Cannot decode unrecognized sequence " + encodedByte + " as hexadecimal");
    }
    return out;
}
function $bf5b342e1f787046$export$7ea66e3774a60b67(bytes) {
    var out = "";
    for(var i = 0; i < bytes.byteLength; i++)out += $bf5b342e1f787046$var$SHORT_TO_HEX[bytes[i]];
    return out;
}


var $26b45f466ca72082$export$186cd8495ba0377d = "X-Amz-Algorithm";
var $26b45f466ca72082$export$5c8e6dd7758f59d6 = "X-Amz-Credential";
var $26b45f466ca72082$export$6e114beec37430d7 = "X-Amz-Date";
var $26b45f466ca72082$export$2dcbb254f883c238 = "X-Amz-SignedHeaders";
var $26b45f466ca72082$export$a0afe6f3bbfaf76e = "X-Amz-Expires";
var $26b45f466ca72082$export$41ae838dc1e0f082 = "X-Amz-Signature";
var $26b45f466ca72082$export$8e1383b7eea7bee = "X-Amz-Security-Token";
var $26b45f466ca72082$export$296a4bada3fe6343 = "X-Amz-Region-Set";
var $26b45f466ca72082$export$9924a64a4b8b0d58 = "authorization";
var $26b45f466ca72082$export$acf4b8bdf24aab34 = $26b45f466ca72082$export$6e114beec37430d7.toLowerCase();
var $26b45f466ca72082$export$c65c8c9f514da472 = "date";
var $26b45f466ca72082$export$20d6a73fd0b10982 = [
    $26b45f466ca72082$export$9924a64a4b8b0d58,
    $26b45f466ca72082$export$acf4b8bdf24aab34,
    $26b45f466ca72082$export$c65c8c9f514da472
];
var $26b45f466ca72082$export$29961f34c719157e = $26b45f466ca72082$export$41ae838dc1e0f082.toLowerCase();
var $26b45f466ca72082$export$eaef12179141669a = "x-amz-content-sha256";
var $26b45f466ca72082$export$fdc81b663012a8d2 = $26b45f466ca72082$export$8e1383b7eea7bee.toLowerCase();
var $26b45f466ca72082$export$96307741595055fc = "host";
var $26b45f466ca72082$export$8ffdcd58c4092560 = {
    authorization: true,
    "cache-control": true,
    connection: true,
    expect: true,
    from: true,
    "keep-alive": true,
    "max-forwards": true,
    pragma: true,
    referer: true,
    te: true,
    trailer: true,
    "transfer-encoding": true,
    upgrade: true,
    "user-agent": true,
    "x-amzn-trace-id": true
};
var $26b45f466ca72082$export$8085db98abbe0597 = /^proxy-/;
var $26b45f466ca72082$export$758380400526c39 = /^sec-/;
var $26b45f466ca72082$export$94e2b626bfa803e0 = [
    /^proxy-/i,
    /^sec-/i
];
var $26b45f466ca72082$export$863a63fba5b2ddf5 = "AWS4-HMAC-SHA256";
var $26b45f466ca72082$export$7ad82ab3c556a776 = "AWS4-ECDSA-P256-SHA256";
var $26b45f466ca72082$export$9a1f6cf06ac56167 = "AWS4-HMAC-SHA256-PAYLOAD";
var $26b45f466ca72082$export$91f7321b40d9fd07 = "UNSIGNED-PAYLOAD";
var $26b45f466ca72082$export$bf665777b4a1722f = 50;
var $26b45f466ca72082$export$c4bf0942098f6bb = "aws4_request";
var $26b45f466ca72082$export$274df788bdcca184 = 604800;





var $75a481a7023508e0$var$signingKeyCache = {};
var $75a481a7023508e0$var$cacheQueue = [];
var $75a481a7023508e0$export$41a9651decfe2bde = function(shortDate, region, service) {
    return shortDate + "/" + region + "/" + service + "/" + (0, $26b45f466ca72082$export$c4bf0942098f6bb);
};
var $75a481a7023508e0$export$8b95a069d16dd783 = function(sha256Constructor, credentials, shortDate, region, service) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var credsHash, cacheKey, key, _a, _b, signable, e_1_1;
        var e_1, _c;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_d) {
            switch(_d.label){
                case 0:
                    return [
                        4,
                        $75a481a7023508e0$var$hmac(sha256Constructor, credentials.secretAccessKey, credentials.accessKeyId)
                    ];
                case 1:
                    credsHash = _d.sent();
                    cacheKey = shortDate + ":" + region + ":" + service + ":" + (0, $bf5b342e1f787046$export$7ea66e3774a60b67)(credsHash) + ":" + credentials.sessionToken;
                    if (cacheKey in $75a481a7023508e0$var$signingKeyCache) return [
                        2,
                        $75a481a7023508e0$var$signingKeyCache[cacheKey]
                    ];
                    $75a481a7023508e0$var$cacheQueue.push(cacheKey);
                    while($75a481a7023508e0$var$cacheQueue.length > (0, $26b45f466ca72082$export$bf665777b4a1722f))delete $75a481a7023508e0$var$signingKeyCache[$75a481a7023508e0$var$cacheQueue.shift()];
                    key = "AWS4" + credentials.secretAccessKey;
                    _d.label = 2;
                case 2:
                    _d.trys.push([
                        2,
                        7,
                        8,
                        9
                    ]);
                    _a = (0, $5c96a02c592fcff1$export$19a8beecd37a4c45)([
                        shortDate,
                        region,
                        service,
                        (0, $26b45f466ca72082$export$c4bf0942098f6bb)
                    ]), _b = _a.next();
                    _d.label = 3;
                case 3:
                    if (!!_b.done) return [
                        3,
                        6
                    ];
                    signable = _b.value;
                    return [
                        4,
                        $75a481a7023508e0$var$hmac(sha256Constructor, key, signable)
                    ];
                case 4:
                    key = _d.sent();
                    _d.label = 5;
                case 5:
                    _b = _a.next();
                    return [
                        3,
                        3
                    ];
                case 6:
                    return [
                        3,
                        9
                    ];
                case 7:
                    e_1_1 = _d.sent();
                    e_1 = {
                        error: e_1_1
                    };
                    return [
                        3,
                        9
                    ];
                case 8:
                    try {
                        if (_b && !_b.done && (_c = _a.return)) _c.call(_a);
                    } finally{
                        if (e_1) throw e_1.error;
                    }
                    return [
                        7
                    ];
                case 9:
                    return [
                        2,
                        $75a481a7023508e0$var$signingKeyCache[cacheKey] = key
                    ];
            }
        });
    });
};
var $75a481a7023508e0$export$a31b95746ea0a30a = function() {
    $75a481a7023508e0$var$cacheQueue.length = 0;
    Object.keys($75a481a7023508e0$var$signingKeyCache).forEach(function(cacheKey) {
        delete $75a481a7023508e0$var$signingKeyCache[cacheKey];
    });
};
var $75a481a7023508e0$var$hmac = function(ctor, secret, data) {
    var hash = new ctor(secret);
    hash.update(data);
    return hash.digest();
};




var $268f6c750d4d76cc$export$859d7f1bb55e2914 = function(_a, unsignableHeaders, signableHeaders) {
    var e_1, _b;
    var headers = _a.headers;
    var canonical = {};
    try {
        for(var _c = (0, $5c96a02c592fcff1$export$19a8beecd37a4c45)(Object.keys(headers).sort()), _d = _c.next(); !_d.done; _d = _c.next()){
            var headerName = _d.value;
            var canonicalHeaderName = headerName.toLowerCase();
            if (canonicalHeaderName in (0, $26b45f466ca72082$export$8ffdcd58c4092560) || (unsignableHeaders === null || unsignableHeaders === void 0 ? void 0 : unsignableHeaders.has(canonicalHeaderName)) || (0, $26b45f466ca72082$export$8085db98abbe0597).test(canonicalHeaderName) || (0, $26b45f466ca72082$export$758380400526c39).test(canonicalHeaderName)) {
                if (!signableHeaders || signableHeaders && !signableHeaders.has(canonicalHeaderName)) continue;
            }
            canonical[canonicalHeaderName] = headers[headerName].trim().replace(/\s+/g, " ");
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (_d && !_d.done && (_b = _c.return)) _b.call(_c);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
    return canonical;
};



var $2668319b2abedbfb$export$c3b4775ad75a73db = function(uri) {
    return encodeURIComponent(uri).replace(/[!'()*]/g, $2668319b2abedbfb$var$hexEncode);
};
var $2668319b2abedbfb$var$hexEncode = function(c) {
    return "%" + c.charCodeAt(0).toString(16).toUpperCase();
};



var $572d47a69c23039f$export$547c045505a754ef = function(uri) {
    return uri.split("/").map((0, $2668319b2abedbfb$export$c3b4775ad75a73db)).join("/");
};





var $7ab48b01e744eb47$export$8fea7e63ecd1ddbb = function(_a) {
    var e_1, _b;
    var _c = _a.query, query = _c === void 0 ? {} : _c;
    var keys = [];
    var serialized = {};
    var _loop_1 = function(key) {
        if (key.toLowerCase() === (0, $26b45f466ca72082$export$29961f34c719157e)) return "continue";
        keys.push(key);
        var value = query[key];
        if (typeof value === "string") serialized[key] = (0, $2668319b2abedbfb$export$c3b4775ad75a73db)(key) + "=" + (0, $2668319b2abedbfb$export$c3b4775ad75a73db)(value);
        else if (Array.isArray(value)) serialized[key] = value.slice(0).sort().reduce(function(encoded, value) {
            return encoded.concat([
                (0, $2668319b2abedbfb$export$c3b4775ad75a73db)(key) + "=" + (0, $2668319b2abedbfb$export$c3b4775ad75a73db)(value)
            ]);
        }, []).join("&");
    };
    try {
        for(var _d = (0, $5c96a02c592fcff1$export$19a8beecd37a4c45)(Object.keys(query).sort()), _e = _d.next(); !_e.done; _e = _d.next()){
            var key = _e.value;
            _loop_1(key);
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (_e && !_e.done && (_b = _d.return)) _b.call(_d);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
    return keys.map(function(key) {
        return serialized[key];
    }).filter(function(serialized) {
        return serialized;
    }).join("&");
};



var $b42f1ee2f8d6fc6e$export$9dd3754ae86f0017 = function(arg) {
    return typeof ArrayBuffer === "function" && arg instanceof ArrayBuffer || Object.prototype.toString.call(arg) === "[object ArrayBuffer]";
};




var $42678cd53d6036e0$export$a46a74202b0efd71 = function(_a, hashConstructor) {
    var headers = _a.headers, body = _a.body;
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var _b, _c, headerName, hashCtor, _d;
        var e_1, _e;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_f) {
            switch(_f.label){
                case 0:
                    try {
                        for(_b = (0, $5c96a02c592fcff1$export$19a8beecd37a4c45)(Object.keys(headers)), _c = _b.next(); !_c.done; _c = _b.next()){
                            headerName = _c.value;
                            if (headerName.toLowerCase() === (0, $26b45f466ca72082$export$eaef12179141669a)) return [
                                2,
                                headers[headerName]
                            ];
                        }
                    } catch (e_1_1) {
                        e_1 = {
                            error: e_1_1
                        };
                    } finally{
                        try {
                            if (_c && !_c.done && (_e = _b.return)) _e.call(_b);
                        } finally{
                            if (e_1) throw e_1.error;
                        }
                    }
                    if (!(body == undefined)) return [
                        3,
                        1
                    ];
                    return [
                        2,
                        "e3b0c44298fc1c149afbf4c8996fb92427ae41e4649b934ca495991b7852b855"
                    ];
                case 1:
                    if (!(typeof body === "string" || ArrayBuffer.isView(body) || (0, $b42f1ee2f8d6fc6e$export$9dd3754ae86f0017)(body))) return [
                        3,
                        3
                    ];
                    hashCtor = new hashConstructor();
                    hashCtor.update(body);
                    _d = (0, $bf5b342e1f787046$export$7ea66e3774a60b67);
                    return [
                        4,
                        hashCtor.digest()
                    ];
                case 2:
                    return [
                        2,
                        _d.apply(void 0, [
                            _f.sent()
                        ])
                    ];
                case 3:
                    return [
                        2,
                        (0, $26b45f466ca72082$export$91f7321b40d9fd07)
                    ];
            }
        });
    });
};



var $6166b9a6fc78cbb5$export$17944590be865217 = function(soughtHeader, headers) {
    var e_1, _a;
    soughtHeader = soughtHeader.toLowerCase();
    try {
        for(var _b = (0, $5c96a02c592fcff1$export$19a8beecd37a4c45)(Object.keys(headers)), _c = _b.next(); !_c.done; _c = _b.next()){
            var headerName = _c.value;
            if (soughtHeader === headerName.toLowerCase()) return true;
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
    return false;
};
var $6166b9a6fc78cbb5$export$149b1181d497cd = function(soughtHeader, headers) {
    var e_2, _a;
    soughtHeader = soughtHeader.toLowerCase();
    try {
        for(var _b = (0, $5c96a02c592fcff1$export$19a8beecd37a4c45)(Object.keys(headers)), _c = _b.next(); !_c.done; _c = _b.next()){
            var headerName = _c.value;
            if (soughtHeader === headerName.toLowerCase()) return headers[headerName];
        }
    } catch (e_2_1) {
        e_2 = {
            error: e_2_1
        };
    } finally{
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        } finally{
            if (e_2) throw e_2.error;
        }
    }
    return undefined;
};
var $6166b9a6fc78cbb5$export$d3408eaf94074c90 = function(soughtHeader, headers) {
    var e_3, _a;
    soughtHeader = soughtHeader.toLowerCase();
    try {
        for(var _b = (0, $5c96a02c592fcff1$export$19a8beecd37a4c45)(Object.keys(headers)), _c = _b.next(); !_c.done; _c = _b.next()){
            var headerName = _c.value;
            if (soughtHeader === headerName.toLowerCase()) delete headers[headerName];
        }
    } catch (e_3_1) {
        e_3 = {
            error: e_3_1
        };
    } finally{
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        } finally{
            if (e_3) throw e_3.error;
        }
    }
};




var $8977d00e863c37cb$export$d043aa0bf7223286 = function(_a) {
    var headers = _a.headers, query = _a.query, rest = (0, $5c96a02c592fcff1$export$3c9a16f847548506)(_a, [
        "headers",
        "query"
    ]);
    return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, rest), {
        headers: (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, headers),
        query: query ? $8977d00e863c37cb$export$4923819f93729b21(query) : undefined
    });
};
var $8977d00e863c37cb$export$4923819f93729b21 = function(query) {
    return Object.keys(query).reduce(function(carry, paramName) {
        var _a;
        var param = query[paramName];
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, carry), (_a = {}, _a[paramName] = Array.isArray(param) ? (0, $5c96a02c592fcff1$export$1216008129fb82ed)([], (0, $5c96a02c592fcff1$export$8d051b38c9118094)(param)) : param, _a));
    }, {});
};


var $7b787827fd332fb8$export$bfc08a76d4bd60f6 = function(request, options) {
    var e_1, _a;
    var _b;
    if (options === void 0) options = {};
    var _c = typeof request.clone === "function" ? request.clone() : (0, $8977d00e863c37cb$export$d043aa0bf7223286)(request), headers = _c.headers, _d = _c.query, query = _d === void 0 ? {} : _d;
    try {
        for(var _e = (0, $5c96a02c592fcff1$export$19a8beecd37a4c45)(Object.keys(headers)), _f = _e.next(); !_f.done; _f = _e.next()){
            var name = _f.value;
            var lname = name.toLowerCase();
            if (lname.substr(0, 6) === "x-amz-" && !((_b = options.unhoistableHeaders) === null || _b === void 0 ? void 0 : _b.has(lname))) {
                query[name] = headers[name];
                delete headers[name];
            }
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (_f && !_f.done && (_a = _e.return)) _a.call(_e);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
    return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, request), {
        headers: headers,
        query: query
    });
};


var $7139d3e3404bf7df$export$1bacfccae8c7ec22 = function(region) {
    if (typeof region === "string") {
        var promisified_1 = Promise.resolve(region);
        return function() {
            return promisified_1;
        };
    } else return region;
};
var $7139d3e3404bf7df$export$308dae6ab23ed7c9 = function(credentials) {
    if (typeof credentials === "object") {
        var promisified_2 = Promise.resolve(credentials);
        return function() {
            return promisified_2;
        };
    } else return credentials;
};





var $7a4496a1fd87e1ea$export$a7cfe9131aa06be4 = function(request) {
    var e_1, _a;
    request = typeof request.clone === "function" ? request.clone() : (0, $8977d00e863c37cb$export$d043aa0bf7223286)(request);
    try {
        for(var _b = (0, $5c96a02c592fcff1$export$19a8beecd37a4c45)(Object.keys(request.headers)), _c = _b.next(); !_c.done; _c = _b.next()){
            var headerName = _c.value;
            if ((0, $26b45f466ca72082$export$20d6a73fd0b10982).indexOf(headerName.toLowerCase()) > -1) delete request.headers[headerName];
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
    return request;
};


var $c8e536db6a602fad$export$b65d57190c224ef2 = function(time) {
    return $c8e536db6a602fad$export$e67a095c620b86fe(time).toISOString().replace(/\.\d{3}Z$/, "Z");
};
var $c8e536db6a602fad$export$e67a095c620b86fe = function(time) {
    if (typeof time === "number") return new Date(time * 1000);
    if (typeof time === "string") {
        if (Number(time)) return new Date(Number(time) * 1000);
        return new Date(time);
    }
    return time;
};


var $a039ad18a1672b65$export$20baf4d3f65eb30c = function() {
    function SignatureV4(_a) {
        var applyChecksum = _a.applyChecksum, credentials = _a.credentials, region = _a.region, service = _a.service, sha256 = _a.sha256, _b = _a.uriEscapePath, uriEscapePath = _b === void 0 ? true : _b;
        this.service = service;
        this.sha256 = sha256;
        this.uriEscapePath = uriEscapePath;
        this.applyChecksum = typeof applyChecksum === "boolean" ? applyChecksum : true;
        this.regionProvider = (0, $7139d3e3404bf7df$export$1bacfccae8c7ec22)(region);
        this.credentialProvider = (0, $7139d3e3404bf7df$export$308dae6ab23ed7c9)(credentials);
    }
    SignatureV4.prototype.presign = function(originalRequest, options) {
        if (options === void 0) options = {};
        return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var _a, signingDate, _b, expiresIn, unsignableHeaders, unhoistableHeaders, signableHeaders, signingRegion, signingService, credentials, region, _c, _d, longDate, shortDate, scope, request, canonicalHeaders, _e, _f, _g, _h, _j, _k;
            return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_l) {
                switch(_l.label){
                    case 0:
                        _a = options.signingDate, signingDate = _a === void 0 ? new Date() : _a, _b = options.expiresIn, expiresIn = _b === void 0 ? 3600 : _b, unsignableHeaders = options.unsignableHeaders, unhoistableHeaders = options.unhoistableHeaders, signableHeaders = options.signableHeaders, signingRegion = options.signingRegion, signingService = options.signingService;
                        return [
                            4,
                            this.credentialProvider()
                        ];
                    case 1:
                        credentials = _l.sent();
                        if (!(signingRegion !== null && signingRegion !== void 0)) return [
                            3,
                            2
                        ];
                        _c = signingRegion;
                        return [
                            3,
                            4
                        ];
                    case 2:
                        return [
                            4,
                            this.regionProvider()
                        ];
                    case 3:
                        _c = _l.sent();
                        _l.label = 4;
                    case 4:
                        region = _c;
                        _d = $a039ad18a1672b65$var$formatDate(signingDate), longDate = _d.longDate, shortDate = _d.shortDate;
                        if (expiresIn > (0, $26b45f466ca72082$export$274df788bdcca184)) return [
                            2,
                            Promise.reject("Signature version 4 presigned URLs must have an expiration date less than one week in the future")
                        ];
                        scope = (0, $75a481a7023508e0$export$41a9651decfe2bde)(shortDate, region, signingService !== null && signingService !== void 0 ? signingService : this.service);
                        request = (0, $7b787827fd332fb8$export$bfc08a76d4bd60f6)((0, $7a4496a1fd87e1ea$export$a7cfe9131aa06be4)(originalRequest), {
                            unhoistableHeaders: unhoistableHeaders
                        });
                        if (credentials.sessionToken) request.query[0, $26b45f466ca72082$export$8e1383b7eea7bee] = credentials.sessionToken;
                        request.query[0, $26b45f466ca72082$export$186cd8495ba0377d] = (0, $26b45f466ca72082$export$863a63fba5b2ddf5);
                        request.query[0, $26b45f466ca72082$export$5c8e6dd7758f59d6] = credentials.accessKeyId + "/" + scope;
                        request.query[0, $26b45f466ca72082$export$6e114beec37430d7] = longDate;
                        request.query[0, $26b45f466ca72082$export$a0afe6f3bbfaf76e] = expiresIn.toString(10);
                        canonicalHeaders = (0, $268f6c750d4d76cc$export$859d7f1bb55e2914)(request, unsignableHeaders, signableHeaders);
                        request.query[0, $26b45f466ca72082$export$2dcbb254f883c238] = $a039ad18a1672b65$var$getCanonicalHeaderList(canonicalHeaders);
                        _e = request.query;
                        _f = (0, $26b45f466ca72082$export$41ae838dc1e0f082);
                        _g = this.getSignature;
                        _h = [
                            longDate,
                            scope,
                            this.getSigningKey(credentials, region, shortDate, signingService)
                        ];
                        _j = this.createCanonicalRequest;
                        _k = [
                            request,
                            canonicalHeaders
                        ];
                        return [
                            4,
                            (0, $42678cd53d6036e0$export$a46a74202b0efd71)(originalRequest, this.sha256)
                        ];
                    case 5:
                        return [
                            4,
                            _g.apply(this, _h.concat([
                                _j.apply(this, _k.concat([
                                    _l.sent()
                                ]))
                            ]))
                        ];
                    case 6:
                        _e[_f] = _l.sent();
                        return [
                            2,
                            request
                        ];
                }
            });
        });
    };
    SignatureV4.prototype.sign = function(toSign, options) {
        return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(this, void 0, void 0, function() {
            return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
                if (typeof toSign === "string") return [
                    2,
                    this.signString(toSign, options)
                ];
                else if (toSign.headers && toSign.payload) return [
                    2,
                    this.signEvent(toSign, options)
                ];
                else return [
                    2,
                    this.signRequest(toSign, options)
                ];
                return [
                    2
                ];
            });
        });
    };
    SignatureV4.prototype.signEvent = function(_a, _b) {
        var headers = _a.headers, payload = _a.payload;
        var _c = _b.signingDate, signingDate = _c === void 0 ? new Date() : _c, priorSignature = _b.priorSignature, signingRegion = _b.signingRegion, signingService = _b.signingService;
        return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var region, _d, _e, shortDate, longDate, scope, hashedPayload, hash, hashedHeaders, _f, stringToSign;
            return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_g) {
                switch(_g.label){
                    case 0:
                        if (!(signingRegion !== null && signingRegion !== void 0)) return [
                            3,
                            1
                        ];
                        _d = signingRegion;
                        return [
                            3,
                            3
                        ];
                    case 1:
                        return [
                            4,
                            this.regionProvider()
                        ];
                    case 2:
                        _d = _g.sent();
                        _g.label = 3;
                    case 3:
                        region = _d;
                        _e = $a039ad18a1672b65$var$formatDate(signingDate), shortDate = _e.shortDate, longDate = _e.longDate;
                        scope = (0, $75a481a7023508e0$export$41a9651decfe2bde)(shortDate, region, signingService !== null && signingService !== void 0 ? signingService : this.service);
                        return [
                            4,
                            (0, $42678cd53d6036e0$export$a46a74202b0efd71)({
                                headers: {},
                                body: payload
                            }, this.sha256)
                        ];
                    case 4:
                        hashedPayload = _g.sent();
                        hash = new this.sha256();
                        hash.update(headers);
                        _f = (0, $bf5b342e1f787046$export$7ea66e3774a60b67);
                        return [
                            4,
                            hash.digest()
                        ];
                    case 5:
                        hashedHeaders = _f.apply(void 0, [
                            _g.sent()
                        ]);
                        stringToSign = [
                            (0, $26b45f466ca72082$export$9a1f6cf06ac56167),
                            longDate,
                            scope,
                            priorSignature,
                            hashedHeaders,
                            hashedPayload
                        ].join("\n");
                        return [
                            2,
                            this.signString(stringToSign, {
                                signingDate: signingDate,
                                signingRegion: region,
                                signingService: signingService
                            })
                        ];
                }
            });
        });
    };
    SignatureV4.prototype.signString = function(stringToSign, _a) {
        var _b = _a === void 0 ? {} : _a, _c = _b.signingDate, signingDate = _c === void 0 ? new Date() : _c, signingRegion = _b.signingRegion, signingService = _b.signingService;
        return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var credentials, region, _d, shortDate, hash, _e, _f, _g;
            return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_h) {
                switch(_h.label){
                    case 0:
                        return [
                            4,
                            this.credentialProvider()
                        ];
                    case 1:
                        credentials = _h.sent();
                        if (!(signingRegion !== null && signingRegion !== void 0)) return [
                            3,
                            2
                        ];
                        _d = signingRegion;
                        return [
                            3,
                            4
                        ];
                    case 2:
                        return [
                            4,
                            this.regionProvider()
                        ];
                    case 3:
                        _d = _h.sent();
                        _h.label = 4;
                    case 4:
                        region = _d;
                        shortDate = $a039ad18a1672b65$var$formatDate(signingDate).shortDate;
                        _f = (_e = this.sha256).bind;
                        return [
                            4,
                            this.getSigningKey(credentials, region, shortDate, signingService)
                        ];
                    case 5:
                        hash = new (_f.apply(_e, [
                            void 0,
                            _h.sent()
                        ]))();
                        hash.update(stringToSign);
                        _g = (0, $bf5b342e1f787046$export$7ea66e3774a60b67);
                        return [
                            4,
                            hash.digest()
                        ];
                    case 6:
                        return [
                            2,
                            _g.apply(void 0, [
                                _h.sent()
                            ])
                        ];
                }
            });
        });
    };
    SignatureV4.prototype.signRequest = function(requestToSign, _a) {
        var _b = _a === void 0 ? {} : _a, _c = _b.signingDate, signingDate = _c === void 0 ? new Date() : _c, signableHeaders = _b.signableHeaders, unsignableHeaders = _b.unsignableHeaders, signingRegion = _b.signingRegion, signingService = _b.signingService;
        return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var credentials, region, _d, request, _e, longDate, shortDate, scope, payloadHash, canonicalHeaders, signature;
            return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_f) {
                switch(_f.label){
                    case 0:
                        return [
                            4,
                            this.credentialProvider()
                        ];
                    case 1:
                        credentials = _f.sent();
                        if (!(signingRegion !== null && signingRegion !== void 0)) return [
                            3,
                            2
                        ];
                        _d = signingRegion;
                        return [
                            3,
                            4
                        ];
                    case 2:
                        return [
                            4,
                            this.regionProvider()
                        ];
                    case 3:
                        _d = _f.sent();
                        _f.label = 4;
                    case 4:
                        region = _d;
                        request = (0, $7a4496a1fd87e1ea$export$a7cfe9131aa06be4)(requestToSign);
                        _e = $a039ad18a1672b65$var$formatDate(signingDate), longDate = _e.longDate, shortDate = _e.shortDate;
                        scope = (0, $75a481a7023508e0$export$41a9651decfe2bde)(shortDate, region, signingService !== null && signingService !== void 0 ? signingService : this.service);
                        request.headers[0, $26b45f466ca72082$export$acf4b8bdf24aab34] = longDate;
                        if (credentials.sessionToken) request.headers[0, $26b45f466ca72082$export$fdc81b663012a8d2] = credentials.sessionToken;
                        return [
                            4,
                            (0, $42678cd53d6036e0$export$a46a74202b0efd71)(request, this.sha256)
                        ];
                    case 5:
                        payloadHash = _f.sent();
                        if (!(0, $6166b9a6fc78cbb5$export$17944590be865217)((0, $26b45f466ca72082$export$eaef12179141669a), request.headers) && this.applyChecksum) request.headers[0, $26b45f466ca72082$export$eaef12179141669a] = payloadHash;
                        canonicalHeaders = (0, $268f6c750d4d76cc$export$859d7f1bb55e2914)(request, unsignableHeaders, signableHeaders);
                        return [
                            4,
                            this.getSignature(longDate, scope, this.getSigningKey(credentials, region, shortDate, signingService), this.createCanonicalRequest(request, canonicalHeaders, payloadHash))
                        ];
                    case 6:
                        signature = _f.sent();
                        request.headers[0, $26b45f466ca72082$export$9924a64a4b8b0d58] = (0, $26b45f466ca72082$export$863a63fba5b2ddf5) + " " + ("Credential=" + credentials.accessKeyId + "/" + scope + ", ") + ("SignedHeaders=" + $a039ad18a1672b65$var$getCanonicalHeaderList(canonicalHeaders) + ", ") + ("Signature=" + signature);
                        return [
                            2,
                            request
                        ];
                }
            });
        });
    };
    SignatureV4.prototype.createCanonicalRequest = function(request, canonicalHeaders, payloadHash) {
        var sortedHeaders = Object.keys(canonicalHeaders).sort();
        return request.method + "\n" + this.getCanonicalPath(request) + "\n" + (0, $7ab48b01e744eb47$export$8fea7e63ecd1ddbb)(request) + "\n" + sortedHeaders.map(function(name) {
            return name + ":" + canonicalHeaders[name];
        }).join("\n") + "\n\n" + sortedHeaders.join(";") + "\n" + payloadHash;
    };
    SignatureV4.prototype.createStringToSign = function(longDate, credentialScope, canonicalRequest) {
        return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var hash, hashedRequest;
            return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        hash = new this.sha256();
                        hash.update(canonicalRequest);
                        return [
                            4,
                            hash.digest()
                        ];
                    case 1:
                        hashedRequest = _a.sent();
                        return [
                            2,
                            (0, $26b45f466ca72082$export$863a63fba5b2ddf5) + "\n" + longDate + "\n" + credentialScope + "\n" + (0, $bf5b342e1f787046$export$7ea66e3774a60b67)(hashedRequest)
                        ];
                }
            });
        });
    };
    SignatureV4.prototype.getCanonicalPath = function(_a) {
        var path = _a.path;
        if (this.uriEscapePath) {
            var doubleEncoded = encodeURIComponent(path.replace(/^\//, ""));
            return "/" + doubleEncoded.replace(/%2F/g, "/");
        }
        return path;
    };
    SignatureV4.prototype.getSignature = function(longDate, credentialScope, keyPromise, canonicalRequest) {
        return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var stringToSign, hash, _a, _b, _c;
            return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_d) {
                switch(_d.label){
                    case 0:
                        return [
                            4,
                            this.createStringToSign(longDate, credentialScope, canonicalRequest)
                        ];
                    case 1:
                        stringToSign = _d.sent();
                        _b = (_a = this.sha256).bind;
                        return [
                            4,
                            keyPromise
                        ];
                    case 2:
                        hash = new (_b.apply(_a, [
                            void 0,
                            _d.sent()
                        ]))();
                        hash.update(stringToSign);
                        _c = (0, $bf5b342e1f787046$export$7ea66e3774a60b67);
                        return [
                            4,
                            hash.digest()
                        ];
                    case 3:
                        return [
                            2,
                            _c.apply(void 0, [
                                _d.sent()
                            ])
                        ];
                }
            });
        });
    };
    SignatureV4.prototype.getSigningKey = function(credentials, region, shortDate, service) {
        return (0, $75a481a7023508e0$export$8b95a069d16dd783)(this.sha256, credentials, shortDate, region, service || this.service);
    };
    return SignatureV4;
}();
var $a039ad18a1672b65$var$formatDate = function(now) {
    var longDate = (0, $c8e536db6a602fad$export$b65d57190c224ef2)(now).replace(/[\-:]/g, "");
    return {
        longDate: longDate,
        shortDate: longDate.substr(0, 8)
    };
};
var $a039ad18a1672b65$var$getCanonicalHeaderList = function(headers) {
    return Object.keys(headers).sort().join(";");
};











var $a080e26d80c25280$var$CREDENTIAL_EXPIRE_WINDOW = 300000;
var $a080e26d80c25280$export$1dd62920de1feabb = function(input) {
    var normalizedCreds = input.credentials ? $a080e26d80c25280$var$normalizeCredentialProvider(input.credentials) : input.credentialDefaultProvider(input);
    var _a = input.signingEscapePath, signingEscapePath = _a === void 0 ? true : _a, _b = input.systemClockOffset, systemClockOffset = _b === void 0 ? input.systemClockOffset || 0 : _b, sha256 = input.sha256;
    var signer;
    if (input.signer) signer = $a080e26d80c25280$var$normalizeProvider(input.signer);
    else signer = function() {
        return $a080e26d80c25280$var$normalizeProvider(input.region)().then(function(region) {
            return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
                var _a, _b, _c;
                var _d;
                return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_e) {
                    switch(_e.label){
                        case 0:
                            _b = (_a = input).regionInfoProvider;
                            _c = [
                                region
                            ];
                            _d = {};
                            return [
                                4,
                                input.useFipsEndpoint()
                            ];
                        case 1:
                            _d.useFipsEndpoint = _e.sent();
                            return [
                                4,
                                input.useDualstackEndpoint()
                            ];
                        case 2:
                            return [
                                4,
                                _b.apply(_a, _c.concat([
                                    (_d.useDualstackEndpoint = _e.sent(), _d)
                                ]))
                            ];
                        case 3:
                            return [
                                2,
                                [
                                    _e.sent() || {},
                                    region
                                ]
                            ];
                    }
                });
            });
        }).then(function(_a) {
            var _b = (0, $5c96a02c592fcff1$export$8d051b38c9118094)(_a, 2), regionInfo = _b[0], region = _b[1];
            var signingRegion = regionInfo.signingRegion, signingService = regionInfo.signingService;
            input.signingRegion = input.signingRegion || signingRegion || region;
            input.signingName = input.signingName || signingService || input.serviceId;
            var params = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, input), {
                credentials: normalizedCreds,
                region: input.signingRegion,
                service: input.signingName,
                sha256: sha256,
                uriEscapePath: signingEscapePath
            });
            var signerConstructor = input.signerConstructor || (0, $a039ad18a1672b65$export$20baf4d3f65eb30c);
            return new signerConstructor(params);
        });
    };
    return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, input), {
        systemClockOffset: systemClockOffset,
        signingEscapePath: signingEscapePath,
        credentials: normalizedCreds,
        signer: signer
    });
};
var $a080e26d80c25280$export$578a43ebf7e4c675 = function(input) {
    var normalizedCreds = input.credentials ? $a080e26d80c25280$var$normalizeCredentialProvider(input.credentials) : input.credentialDefaultProvider(input);
    var _a = input.signingEscapePath, signingEscapePath = _a === void 0 ? true : _a, _b = input.systemClockOffset, systemClockOffset = _b === void 0 ? input.systemClockOffset || 0 : _b, sha256 = input.sha256;
    var signer;
    if (input.signer) signer = $a080e26d80c25280$var$normalizeProvider(input.signer);
    else signer = $a080e26d80c25280$var$normalizeProvider(new (0, $a039ad18a1672b65$export$20baf4d3f65eb30c)({
        credentials: normalizedCreds,
        region: input.region,
        service: input.signingName,
        sha256: sha256,
        uriEscapePath: signingEscapePath
    }));
    return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, input), {
        systemClockOffset: systemClockOffset,
        signingEscapePath: signingEscapePath,
        credentials: normalizedCreds,
        signer: signer
    });
};
var $a080e26d80c25280$var$normalizeProvider = function(input) {
    if (typeof input === "object") {
        var promisified_1 = Promise.resolve(input);
        return function() {
            return promisified_1;
        };
    }
    return input;
};
var $a080e26d80c25280$var$normalizeCredentialProvider = function(credentials) {
    if (typeof credentials === "function") return (0, $d99a93426bc19e29$export$fc10aeed3a532e2a)(credentials, function(credentials) {
        return credentials.expiration !== undefined && credentials.expiration.getTime() - Date.now() < $a080e26d80c25280$var$CREDENTIAL_EXPIRE_WINDOW;
    }, function(credentials) {
        return credentials.expiration !== undefined;
    });
    return $a080e26d80c25280$var$normalizeProvider(credentials);
};




var $bc4de7f388f1dec3$export$86d5c90340985ada = function(systemClockOffset) {
    return new Date(Date.now() + systemClockOffset);
};



var $18d5f3a588bf1837$export$c162a01d4a03ea6f = function(clockTime, systemClockOffset) {
    return Math.abs((0, $bc4de7f388f1dec3$export$86d5c90340985ada)(systemClockOffset).getTime() - clockTime) >= 300000;
};


var $3541a76fda0b82cb$export$1ed4d48b860b1348 = function(clockTime, currentSystemClockOffset) {
    var clockTimeInMs = Date.parse(clockTime);
    if ((0, $18d5f3a588bf1837$export$c162a01d4a03ea6f)(clockTimeInMs, currentSystemClockOffset)) return clockTimeInMs - Date.now();
    return currentSystemClockOffset;
};


var $0b14c01e1ba6aa35$export$78af9708f8cf3422 = function(options) {
    return function(next, context) {
        return function(args) {
            return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(this, void 0, void 0, function() {
                var signer, output, _a, _b, dateHeader;
                var _c;
                return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_d) {
                    switch(_d.label){
                        case 0:
                            if (!(0, $f5162dd3bdb0d175$export$7587955500404ec3).isInstance(args.request)) return [
                                2,
                                next(args)
                            ];
                            return [
                                4,
                                options.signer()
                            ];
                        case 1:
                            signer = _d.sent();
                            _a = next;
                            _b = [
                                (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, args)
                            ];
                            _c = {};
                            return [
                                4,
                                signer.sign(args.request, {
                                    signingDate: (0, $bc4de7f388f1dec3$export$86d5c90340985ada)(options.systemClockOffset),
                                    signingRegion: context["signing_region"],
                                    signingService: context["signing_service"]
                                })
                            ];
                        case 2:
                            return [
                                4,
                                _a.apply(void 0, [
                                    (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _b.concat([
                                        (_c.request = _d.sent(), _c)
                                    ]))
                                ]).catch(function(error) {
                                    var _a;
                                    var serverTime = (_a = error.ServerTime) !== null && _a !== void 0 ? _a : $0b14c01e1ba6aa35$var$getDateHeader(error.$response);
                                    if (serverTime) options.systemClockOffset = (0, $3541a76fda0b82cb$export$1ed4d48b860b1348)(serverTime, options.systemClockOffset);
                                    throw error;
                                })
                            ];
                        case 3:
                            output = _d.sent();
                            dateHeader = $0b14c01e1ba6aa35$var$getDateHeader(output.response);
                            if (dateHeader) options.systemClockOffset = (0, $3541a76fda0b82cb$export$1ed4d48b860b1348)(dateHeader, options.systemClockOffset);
                            return [
                                2,
                                output
                            ];
                    }
                });
            });
        };
    };
};
var $0b14c01e1ba6aa35$var$getDateHeader = function(response) {
    var _a, _b, _c;
    return (0, $563c3f2e6f334247$export$1d94dfe0d9d1f1e7).isInstance(response) ? (_b = (_a = response.headers) === null || _a === void 0 ? void 0 : _a.date) !== null && _b !== void 0 ? _b : (_c = response.headers) === null || _c === void 0 ? void 0 : _c.Date : undefined;
};
var $0b14c01e1ba6aa35$export$29f4b3a6e94017d3 = {
    name: "awsAuthMiddleware",
    tags: [
        "SIGNATURE",
        "AWSAUTH"
    ],
    relation: "after",
    toMiddleware: "retryMiddleware",
    override: true
};
var $0b14c01e1ba6aa35$export$59c2b7ad30ed4046 = function(options) {
    return {
        applyToStack: function(clientStack) {
            clientStack.addRelativeTo($0b14c01e1ba6aa35$export$78af9708f8cf3422(options), $0b14c01e1ba6aa35$export$29f4b3a6e94017d3);
        }
    };
};
var $0b14c01e1ba6aa35$export$6255ccc0b84310b8 = $0b14c01e1ba6aa35$export$59c2b7ad30ed4046;





function $754475b8730b53d4$export$ec9a2d5663958cb(input) {
    return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, input), {
        customUserAgent: typeof input.customUserAgent === "string" ? [
            [
                input.customUserAgent
            ]
        ] : input.customUserAgent
    });
}




var $0784beb967af4490$export$97a08a1bb7ee0545 = "user-agent";
var $0784beb967af4490$export$e010e3d6246262a3 = "x-amz-user-agent";
var $0784beb967af4490$export$27b7b95a5fde2b31 = " ";
var $0784beb967af4490$export$92df4a8c4ea32a70 = /[^\!\#\$\%\&\'\*\+\-\.\^\_\`\|\~\d\w]/g;


var $7b3c99e5173f4767$export$62c460923941c0b0 = function(options) {
    return function(next, context) {
        return function(args) {
            return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
                var request, headers, userAgent, defaultUserAgent, customUserAgent, sdkUserAgentValue, normalUAValue;
                var _a, _b;
                return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_c) {
                    switch(_c.label){
                        case 0:
                            request = args.request;
                            if (!(0, $f5162dd3bdb0d175$export$7587955500404ec3).isInstance(request)) return [
                                2,
                                next(args)
                            ];
                            headers = request.headers;
                            userAgent = ((_a = context === null || context === void 0 ? void 0 : context.userAgent) === null || _a === void 0 ? void 0 : _a.map($7b3c99e5173f4767$var$escapeUserAgent)) || [];
                            return [
                                4,
                                options.defaultUserAgentProvider()
                            ];
                        case 1:
                            defaultUserAgent = _c.sent().map($7b3c99e5173f4767$var$escapeUserAgent);
                            customUserAgent = ((_b = options === null || options === void 0 ? void 0 : options.customUserAgent) === null || _b === void 0 ? void 0 : _b.map($7b3c99e5173f4767$var$escapeUserAgent)) || [];
                            sdkUserAgentValue = (0, $5c96a02c592fcff1$export$1216008129fb82ed)((0, $5c96a02c592fcff1$export$1216008129fb82ed)((0, $5c96a02c592fcff1$export$1216008129fb82ed)([], (0, $5c96a02c592fcff1$export$8d051b38c9118094)(defaultUserAgent)), (0, $5c96a02c592fcff1$export$8d051b38c9118094)(userAgent)), (0, $5c96a02c592fcff1$export$8d051b38c9118094)(customUserAgent)).join((0, $0784beb967af4490$export$27b7b95a5fde2b31));
                            normalUAValue = (0, $5c96a02c592fcff1$export$1216008129fb82ed)((0, $5c96a02c592fcff1$export$1216008129fb82ed)([], (0, $5c96a02c592fcff1$export$8d051b38c9118094)(defaultUserAgent.filter(function(section) {
                                return section.startsWith("aws-sdk-");
                            }))), (0, $5c96a02c592fcff1$export$8d051b38c9118094)(customUserAgent)).join((0, $0784beb967af4490$export$27b7b95a5fde2b31));
                            if (options.runtime !== "browser") {
                                if (normalUAValue) headers[0, $0784beb967af4490$export$e010e3d6246262a3] = headers[0, $0784beb967af4490$export$e010e3d6246262a3] ? headers[0, $0784beb967af4490$export$97a08a1bb7ee0545] + " " + normalUAValue : normalUAValue;
                                headers[0, $0784beb967af4490$export$97a08a1bb7ee0545] = sdkUserAgentValue;
                            } else headers[0, $0784beb967af4490$export$e010e3d6246262a3] = sdkUserAgentValue;
                            return [
                                2,
                                next((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, args), {
                                    request: request
                                }))
                            ];
                    }
                });
            });
        };
    };
};
var $7b3c99e5173f4767$var$escapeUserAgent = function(_a) {
    var _b = (0, $5c96a02c592fcff1$export$8d051b38c9118094)(_a, 2), name = _b[0], version = _b[1];
    var prefixSeparatorIndex = name.indexOf("/");
    var prefix = name.substring(0, prefixSeparatorIndex);
    var uaName = name.substring(prefixSeparatorIndex + 1);
    if (prefix === "api") uaName = uaName.toLowerCase();
    return [
        prefix,
        uaName,
        version
    ].filter(function(item) {
        return item && item.length > 0;
    }).map(function(item) {
        return item === null || item === void 0 ? void 0 : item.replace((0, $0784beb967af4490$export$92df4a8c4ea32a70), "_");
    }).join("/");
};
var $7b3c99e5173f4767$export$29eb04da6afef73f = {
    name: "getUserAgentMiddleware",
    step: "build",
    priority: "low",
    tags: [
        "SET_USER_AGENT",
        "USER_AGENT"
    ],
    override: true
};
var $7b3c99e5173f4767$export$5393c0d2d7f4f5f0 = function(config) {
    return {
        applyToStack: function(clientStack) {
            clientStack.add($7b3c99e5173f4767$export$62c460923941c0b0(config), $7b3c99e5173f4767$export$29eb04da6afef73f);
        }
    };
};






var $26d472c005afc768$exports = {};
$26d472c005afc768$exports = JSON.parse('{"name":"@aws-sdk/client-sns","description":"AWS SDK for JavaScript Sns Client for Node.js, Browser and React Native","version":"3.53.0","scripts":{"build":"concurrently \'yarn:build:cjs\' \'yarn:build:es\' \'yarn:build:types\'","build:cjs":"tsc -p tsconfig.cjs.json","build:docs":"typedoc","build:es":"tsc -p tsconfig.es.json","build:types":"tsc -p tsconfig.types.json","build:types:downlevel":"downlevel-dts dist-types dist-types/ts3.4","clean":"rimraf ./dist-* && rimraf *.tsbuildinfo"},"main":"./dist-cjs/index.js","types":"./dist-types/index.d.ts","module":"./dist-es/index.js","sideEffects":false,"dependencies":{"@aws-crypto/sha256-browser":"2.0.0","@aws-crypto/sha256-js":"2.0.0","@aws-sdk/client-sts":"3.53.0","@aws-sdk/config-resolver":"3.53.0","@aws-sdk/credential-provider-node":"3.53.0","@aws-sdk/fetch-http-handler":"3.53.0","@aws-sdk/hash-node":"3.53.0","@aws-sdk/invalid-dependency":"3.53.0","@aws-sdk/middleware-content-length":"3.53.0","@aws-sdk/middleware-host-header":"3.53.0","@aws-sdk/middleware-logger":"3.53.0","@aws-sdk/middleware-retry":"3.53.0","@aws-sdk/middleware-serde":"3.53.0","@aws-sdk/middleware-signing":"3.53.0","@aws-sdk/middleware-stack":"3.53.0","@aws-sdk/middleware-user-agent":"3.53.0","@aws-sdk/node-config-provider":"3.53.0","@aws-sdk/node-http-handler":"3.53.0","@aws-sdk/protocol-http":"3.53.0","@aws-sdk/smithy-client":"3.53.0","@aws-sdk/types":"3.53.0","@aws-sdk/url-parser":"3.53.0","@aws-sdk/util-base64-browser":"3.52.0","@aws-sdk/util-base64-node":"3.52.0","@aws-sdk/util-body-length-browser":"3.52.0","@aws-sdk/util-body-length-node":"3.52.0","@aws-sdk/util-defaults-mode-browser":"3.53.0","@aws-sdk/util-defaults-mode-node":"3.53.0","@aws-sdk/util-user-agent-browser":"3.53.0","@aws-sdk/util-user-agent-node":"3.53.0","@aws-sdk/util-utf8-browser":"3.52.0","@aws-sdk/util-utf8-node":"3.52.0","entities":"2.2.0","fast-xml-parser":"3.19.0","tslib":"^2.3.0"},"devDependencies":{"@aws-sdk/service-client-documentation-generator":"3.52.0","@tsconfig/recommended":"1.0.1","@types/node":"^12.7.5","concurrently":"7.0.0","downlevel-dts":"0.7.0","rimraf":"3.0.2","typedoc":"0.19.2","typescript":"~4.3.5"},"engines":{"node":">=12.0.0"},"typesVersions":{"<4.0":{"dist-types/*":["dist-types/ts3.4/*"]}},"files":["dist-*"],"author":{"name":"AWS SDK for JavaScript Team","url":"https://aws.amazon.com/javascript/"},"license":"Apache-2.0","browser":{"./dist-es/runtimeConfig":"./dist-es/runtimeConfig.browser"},"react-native":{"./dist-es/runtimeConfig":"./dist-es/runtimeConfig.native"},"homepage":"https://github.com/aws/aws-sdk-js-v3/tree/main/clients/client-sns","repository":{"type":"git","url":"https://github.com/aws/aws-sdk-js-v3.git","directory":"clients/client-sns"}}');


var $3ce7992f05548527$exports = {};
"use strict";
Object.defineProperty($3ce7992f05548527$exports, "__esModule", {
    value: true
});
$3ce7992f05548527$exports.WebCryptoSha256 = $3ce7992f05548527$exports.Ie11Sha256 = void 0;
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $b34072d902a04152$var$extendStatics = function(d, b) {
    $b34072d902a04152$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $b34072d902a04152$var$extendStatics(d, b);
};
function $b34072d902a04152$export$a8ba968b8961cb8a(d, b) {
    $b34072d902a04152$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $b34072d902a04152$export$18ce0697a983be9b = function() {
    $b34072d902a04152$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $b34072d902a04152$export$18ce0697a983be9b.apply(this, arguments);
};
function $b34072d902a04152$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $b34072d902a04152$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $b34072d902a04152$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $b34072d902a04152$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $b34072d902a04152$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $b34072d902a04152$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function $b34072d902a04152$export$45d3717a4c69092e(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function $b34072d902a04152$export$f33643c0debef087(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function $b34072d902a04152$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $b34072d902a04152$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $b34072d902a04152$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($b34072d902a04152$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $b34072d902a04152$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $b34072d902a04152$export$10c90e4f7922046c(v) {
    return this instanceof $b34072d902a04152$export$10c90e4f7922046c ? (this.v = v, this) : new $b34072d902a04152$export$10c90e4f7922046c(v);
}
function $b34072d902a04152$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $b34072d902a04152$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $b34072d902a04152$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $b34072d902a04152$export$10c90e4f7922046c(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function $b34072d902a04152$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $b34072d902a04152$export$19a8beecd37a4c45 === "function" ? $b34072d902a04152$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $b34072d902a04152$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function $b34072d902a04152$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function $b34072d902a04152$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $b34072d902a04152$export$d5dcaf168c640c35(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function $b34072d902a04152$export$d40a35129aaff81f(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}



(0, $b34072d902a04152$export$f33643c0debef087)((parcelRequire("dZNvx")), $3ce7992f05548527$exports);

var $jLgwE = parcelRequire("jLgwE");
Object.defineProperty($3ce7992f05548527$exports, "Ie11Sha256", {
    enumerable: true,
    get: function() {
        return $jLgwE.Sha256;
    }
});

var $iS0p3 = parcelRequire("iS0p3");
Object.defineProperty($3ce7992f05548527$exports, "WebCryptoSha256", {
    enumerable: true,
    get: function() {
        return $iS0p3.Sha256;
    }
});







function $0170a6b410e22cc8$export$6b17a39e52c8ee53(query) {
    var e_1, _a;
    var parts = [];
    try {
        for(var _b = (0, $5c96a02c592fcff1$export$19a8beecd37a4c45)(Object.keys(query).sort()), _c = _b.next(); !_c.done; _c = _b.next()){
            var key = _c.value;
            var value = query[key];
            key = (0, $2668319b2abedbfb$export$c3b4775ad75a73db)(key);
            if (Array.isArray(value)) for(var i = 0, iLen = value.length; i < iLen; i++)parts.push(key + "=" + (0, $2668319b2abedbfb$export$c3b4775ad75a73db)(value[i]));
            else {
                var qsEntry = key;
                if (value || typeof value === "string") qsEntry += "=" + (0, $2668319b2abedbfb$export$c3b4775ad75a73db)(value);
                parts.push(qsEntry);
            }
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
    return parts.join("&");
}


function $93152bc0972a6833$export$363ac302bdbd807b(timeoutInMs) {
    if (timeoutInMs === void 0) timeoutInMs = 0;
    return new Promise(function(resolve, reject) {
        if (timeoutInMs) setTimeout(function() {
            var timeoutError = new Error("Request did not complete within " + timeoutInMs + " ms");
            timeoutError.name = "TimeoutError";
            reject(timeoutError);
        }, timeoutInMs);
    });
}


var $85f416940ae1eba2$export$83588b87edbfa7e0 = function() {
    function FetchHttpHandler(options) {
        var _this = this;
        if (typeof options === "function") this.configProvider = function() {
            return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(_this, void 0, void 0, function() {
                return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            return [
                                4,
                                options()
                            ];
                        case 1:
                            return [
                                2,
                                _a.sent() || {}
                            ];
                    }
                });
            });
        };
        else this.config = options !== null && options !== void 0 ? options : {};
    }
    FetchHttpHandler.prototype.destroy = function() {};
    FetchHttpHandler.prototype.handle = function(request, _a) {
        var _b = _a === void 0 ? {} : _a, abortSignal = _b.abortSignal;
        return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var _c, requestTimeoutInMs, abortError, path, queryString, port, method, url, body, requestOptions, fetchRequest, raceOfPromises;
            return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_d) {
                switch(_d.label){
                    case 0:
                        if (!(!this.config && this.configProvider)) return [
                            3,
                            2
                        ];
                        _c = this;
                        return [
                            4,
                            this.configProvider()
                        ];
                    case 1:
                        _c.config = _d.sent();
                        _d.label = 2;
                    case 2:
                        requestTimeoutInMs = this.config.requestTimeout;
                        if (abortSignal === null || abortSignal === void 0 ? void 0 : abortSignal.aborted) {
                            abortError = new Error("Request aborted");
                            abortError.name = "AbortError";
                            return [
                                2,
                                Promise.reject(abortError)
                            ];
                        }
                        path = request.path;
                        if (request.query) {
                            queryString = (0, $0170a6b410e22cc8$export$6b17a39e52c8ee53)(request.query);
                            if (queryString) path += "?" + queryString;
                        }
                        port = request.port, method = request.method;
                        url = request.protocol + "//" + request.hostname + (port ? ":" + port : "") + path;
                        body = method === "GET" || method === "HEAD" ? undefined : request.body;
                        requestOptions = {
                            body: body,
                            headers: new Headers(request.headers),
                            method: method
                        };
                        if (typeof AbortController !== "undefined") requestOptions["signal"] = abortSignal;
                        fetchRequest = new Request(url, requestOptions);
                        raceOfPromises = [
                            fetch(fetchRequest).then(function(response) {
                                var e_1, _a;
                                var fetchHeaders = response.headers;
                                var transformedHeaders = {};
                                try {
                                    for(var _b = (0, $5c96a02c592fcff1$export$19a8beecd37a4c45)(fetchHeaders.entries()), _c = _b.next(); !_c.done; _c = _b.next()){
                                        var pair = _c.value;
                                        transformedHeaders[pair[0]] = pair[1];
                                    }
                                } catch (e_1_1) {
                                    e_1 = {
                                        error: e_1_1
                                    };
                                } finally{
                                    try {
                                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                                    } finally{
                                        if (e_1) throw e_1.error;
                                    }
                                }
                                var hasReadableStream = response.body !== undefined;
                                if (!hasReadableStream) return response.blob().then(function(body) {
                                    return {
                                        response: new (0, $563c3f2e6f334247$export$1d94dfe0d9d1f1e7)({
                                            headers: transformedHeaders,
                                            statusCode: response.status,
                                            body: body
                                        })
                                    };
                                });
                                return {
                                    response: new (0, $563c3f2e6f334247$export$1d94dfe0d9d1f1e7)({
                                        headers: transformedHeaders,
                                        statusCode: response.status,
                                        body: response.body
                                    })
                                };
                            }),
                            (0, $93152bc0972a6833$export$363ac302bdbd807b)(requestTimeoutInMs)
                        ];
                        if (abortSignal) raceOfPromises.push(new Promise(function(resolve, reject) {
                            abortSignal.onabort = function() {
                                var abortError = new Error("Request aborted");
                                abortError.name = "AbortError";
                                reject(abortError);
                            };
                        }));
                        return [
                            2,
                            Promise.race(raceOfPromises)
                        ];
                }
            });
        });
    };
    return FetchHttpHandler;
}();



var $a57431ea344ba4b6$var$alphabetByEncoding = {};
var $a57431ea344ba4b6$var$alphabetByValue = new Array(64);
for(var $a57431ea344ba4b6$var$i = 0, $a57431ea344ba4b6$var$start = "A".charCodeAt(0), $a57431ea344ba4b6$var$limit = "Z".charCodeAt(0); $a57431ea344ba4b6$var$i + $a57431ea344ba4b6$var$start <= $a57431ea344ba4b6$var$limit; $a57431ea344ba4b6$var$i++){
    var $a57431ea344ba4b6$var$char = String.fromCharCode($a57431ea344ba4b6$var$i + $a57431ea344ba4b6$var$start);
    $a57431ea344ba4b6$var$alphabetByEncoding[$a57431ea344ba4b6$var$char] = $a57431ea344ba4b6$var$i;
    $a57431ea344ba4b6$var$alphabetByValue[$a57431ea344ba4b6$var$i] = $a57431ea344ba4b6$var$char;
}
for(var $a57431ea344ba4b6$var$i = 0, $a57431ea344ba4b6$var$start = "a".charCodeAt(0), $a57431ea344ba4b6$var$limit = "z".charCodeAt(0); $a57431ea344ba4b6$var$i + $a57431ea344ba4b6$var$start <= $a57431ea344ba4b6$var$limit; $a57431ea344ba4b6$var$i++){
    var $a57431ea344ba4b6$var$char = String.fromCharCode($a57431ea344ba4b6$var$i + $a57431ea344ba4b6$var$start);
    var $a57431ea344ba4b6$var$index = $a57431ea344ba4b6$var$i + 26;
    $a57431ea344ba4b6$var$alphabetByEncoding[$a57431ea344ba4b6$var$char] = $a57431ea344ba4b6$var$index;
    $a57431ea344ba4b6$var$alphabetByValue[$a57431ea344ba4b6$var$index] = $a57431ea344ba4b6$var$char;
}
for(var $a57431ea344ba4b6$var$i = 0; $a57431ea344ba4b6$var$i < 10; $a57431ea344ba4b6$var$i++){
    $a57431ea344ba4b6$var$alphabetByEncoding[$a57431ea344ba4b6$var$i.toString(10)] = $a57431ea344ba4b6$var$i + 52;
    var $a57431ea344ba4b6$var$char = $a57431ea344ba4b6$var$i.toString(10);
    var $a57431ea344ba4b6$var$index = $a57431ea344ba4b6$var$i + 52;
    $a57431ea344ba4b6$var$alphabetByEncoding[$a57431ea344ba4b6$var$char] = $a57431ea344ba4b6$var$index;
    $a57431ea344ba4b6$var$alphabetByValue[$a57431ea344ba4b6$var$index] = $a57431ea344ba4b6$var$char;
}
$a57431ea344ba4b6$var$alphabetByEncoding["+"] = 62;
$a57431ea344ba4b6$var$alphabetByValue[62] = "+";
$a57431ea344ba4b6$var$alphabetByEncoding["/"] = 63;
$a57431ea344ba4b6$var$alphabetByValue[63] = "/";
var $a57431ea344ba4b6$var$bitsPerLetter = 6;
var $a57431ea344ba4b6$var$bitsPerByte = 8;
var $a57431ea344ba4b6$var$maxLetterValue = 63;
function $a57431ea344ba4b6$export$c537b38001c583b7(input) {
    var totalByteLength = input.length / 4 * 3;
    if (input.substr(-2) === "==") totalByteLength -= 2;
    else if (input.substr(-1) === "=") totalByteLength--;
    var out = new ArrayBuffer(totalByteLength);
    var dataView = new DataView(out);
    for(var i = 0; i < input.length; i += 4){
        var bits = 0;
        var bitLength = 0;
        for(var j = i, limit = i + 3; j <= limit; j++)if (input[j] !== "=") {
            if (!(input[j] in $a57431ea344ba4b6$var$alphabetByEncoding)) throw new TypeError("Invalid character " + input[j] + " in base64 string.");
            bits |= $a57431ea344ba4b6$var$alphabetByEncoding[input[j]] << (limit - j) * $a57431ea344ba4b6$var$bitsPerLetter;
            bitLength += $a57431ea344ba4b6$var$bitsPerLetter;
        } else bits >>= $a57431ea344ba4b6$var$bitsPerLetter;
        var chunkOffset = i / 4 * 3;
        bits >>= bitLength % $a57431ea344ba4b6$var$bitsPerByte;
        var byteLength = Math.floor(bitLength / $a57431ea344ba4b6$var$bitsPerByte);
        for(var k = 0; k < byteLength; k++){
            var offset = (byteLength - k - 1) * $a57431ea344ba4b6$var$bitsPerByte;
            dataView.setUint8(chunkOffset + k, (bits & 255 << offset) >> offset);
        }
    }
    return new Uint8Array(out);
}
function $a57431ea344ba4b6$export$37cc283d8fbd3462(input) {
    var str = "";
    for(var i = 0; i < input.length; i += 3){
        var bits = 0;
        var bitLength = 0;
        for(var j = i, limit = Math.min(i + 3, input.length); j < limit; j++){
            bits |= input[j] << (limit - j - 1) * $a57431ea344ba4b6$var$bitsPerByte;
            bitLength += $a57431ea344ba4b6$var$bitsPerByte;
        }
        var bitClusterCount = Math.ceil(bitLength / $a57431ea344ba4b6$var$bitsPerLetter);
        bits <<= bitClusterCount * $a57431ea344ba4b6$var$bitsPerLetter - bitLength;
        for(var k = 1; k <= bitClusterCount; k++){
            var offset = (bitClusterCount - k) * $a57431ea344ba4b6$var$bitsPerLetter;
            str += $a57431ea344ba4b6$var$alphabetByValue[(bits & $a57431ea344ba4b6$var$maxLetterValue << offset) >> offset];
        }
        str += "==".slice(0, 4 - bitClusterCount);
    }
    return str;
}


var $227fd89517dde28d$export$17bf97b72e307d52 = function(stream) {
    if (typeof Blob === "function" && stream instanceof Blob) return $227fd89517dde28d$var$collectBlob(stream);
    return $227fd89517dde28d$var$collectStream(stream);
};
function $227fd89517dde28d$var$collectBlob(blob) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(this, void 0, void 0, function() {
        var base64, arrayBuffer;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    return [
                        4,
                        $227fd89517dde28d$var$readToBase64(blob)
                    ];
                case 1:
                    base64 = _a.sent();
                    arrayBuffer = (0, $a57431ea344ba4b6$export$c537b38001c583b7)(base64);
                    return [
                        2,
                        new Uint8Array(arrayBuffer)
                    ];
            }
        });
    });
}
function $227fd89517dde28d$var$collectStream(stream) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(this, void 0, void 0, function() {
        var res, reader, isDone, _a, done, value, prior;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_b) {
            switch(_b.label){
                case 0:
                    res = new Uint8Array(0);
                    reader = stream.getReader();
                    isDone = false;
                    _b.label = 1;
                case 1:
                    if (!!isDone) return [
                        3,
                        3
                    ];
                    return [
                        4,
                        reader.read()
                    ];
                case 2:
                    _a = _b.sent(), done = _a.done, value = _a.value;
                    if (value) {
                        prior = res;
                        res = new Uint8Array(prior.length + value.length);
                        res.set(prior);
                        res.set(value, prior.length);
                    }
                    isDone = done;
                    return [
                        3,
                        1
                    ];
                case 3:
                    return [
                        2,
                        res
                    ];
            }
        });
    });
}
function $227fd89517dde28d$var$readToBase64(blob) {
    return new Promise(function(resolve, reject) {
        var reader = new FileReader();
        reader.onloadend = function() {
            var _a;
            if (reader.readyState !== 2) return reject(new Error("Reader aborted too early"));
            var result = (_a = reader.result) !== null && _a !== void 0 ? _a : "";
            var commaIndex = result.indexOf(",");
            var dataOffset = commaIndex > -1 ? commaIndex + 1 : result.length;
            resolve(result.substring(dataOffset));
        };
        reader.onabort = function() {
            return reject(new Error("Read aborted"));
        };
        reader.onerror = function() {
            return reject(reader.error);
        };
        reader.readAsDataURL(blob);
    });
}




var $63bae070b4eb1267$export$8b6362171c4dfa64 = function(message) {
    return function() {
        throw new Error(message);
    };
};


var $9509d854c39a3d45$export$d59dd53963f8f3d5 = function(message) {
    return function() {
        return Promise.reject(message);
    };
};






function $ccfff7fe732bb712$export$967f3527bf233bc0(body) {
    if (typeof body === "string") {
        var len = body.length;
        for(var i = len - 1; i >= 0; i--){
            var code = body.charCodeAt(i);
            if (code > 0x7f && code <= 0x7ff) len++;
            else if (code > 0x7ff && code <= 0xffff) len += 2;
        }
        return len;
    } else if (typeof body.byteLength === "number") return body.byteLength;
    else if (typeof body.size === "number") return body.size;
}



var $03dc96944173e4d6$exports = {};
!function(e, t) {
    $03dc96944173e4d6$exports = t();
}($03dc96944173e4d6$exports, function() {
    return function(e) {
        var t = {};
        function r(n) {
            if (t[n]) return t[n].exports;
            var i = t[n] = {
                i: n,
                l: !1,
                exports: {}
            };
            return e[n].call(i.exports, i, i.exports, r), i.l = !0, i.exports;
        }
        return r.m = e, r.c = t, r.d = function(e, t, n) {
            r.o(e, t) || Object.defineProperty(e, t, {
                enumerable: !0,
                get: n
            });
        }, r.r = function(e) {
            "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
                value: "Module"
            }), Object.defineProperty(e, "__esModule", {
                value: !0
            });
        }, r.t = function(e, t) {
            if (1 & t && (e = r(e)), 8 & t) return e;
            if (4 & t && "object" == typeof e && e && e.__esModule) return e;
            var n = Object.create(null);
            if (r.r(n), Object.defineProperty(n, "default", {
                enumerable: !0,
                value: e
            }), 2 & t && "string" != typeof e) for(var i in e)r.d(n, i, (function(t) {
                return e[t];
            }).bind(null, i));
            return n;
        }, r.n = function(e) {
            var t = e && e.__esModule ? function() {
                return e.default;
            } : function() {
                return e;
            };
            return r.d(t, "a", t), t;
        }, r.o = function(e, t) {
            return Object.prototype.hasOwnProperty.call(e, t);
        }, r.p = "", r(r.s = 90);
    }({
        17: function(e, t, r) {
            "use strict";
            t.__esModule = !0, t.default = void 0;
            var n = r(18), i = function() {
                function e() {}
                return e.getFirstMatch = function(e, t) {
                    var r = t.match(e);
                    return r && r.length > 0 && r[1] || "";
                }, e.getSecondMatch = function(e, t) {
                    var r = t.match(e);
                    return r && r.length > 1 && r[2] || "";
                }, e.matchAndReturnConst = function(e, t, r) {
                    if (e.test(t)) return r;
                }, e.getWindowsVersionName = function(e) {
                    switch(e){
                        case "NT":
                            return "NT";
                        case "XP":
                            return "XP";
                        case "NT 5.0":
                            return "2000";
                        case "NT 5.1":
                            return "XP";
                        case "NT 5.2":
                            return "2003";
                        case "NT 6.0":
                            return "Vista";
                        case "NT 6.1":
                            return "7";
                        case "NT 6.2":
                            return "8";
                        case "NT 6.3":
                            return "8.1";
                        case "NT 10.0":
                            return "10";
                        default:
                            return;
                    }
                }, e.getMacOSVersionName = function(e) {
                    var t = e.split(".").splice(0, 2).map(function(e) {
                        return parseInt(e, 10) || 0;
                    });
                    if (t.push(0), 10 === t[0]) switch(t[1]){
                        case 5:
                            return "Leopard";
                        case 6:
                            return "Snow Leopard";
                        case 7:
                            return "Lion";
                        case 8:
                            return "Mountain Lion";
                        case 9:
                            return "Mavericks";
                        case 10:
                            return "Yosemite";
                        case 11:
                            return "El Capitan";
                        case 12:
                            return "Sierra";
                        case 13:
                            return "High Sierra";
                        case 14:
                            return "Mojave";
                        case 15:
                            return "Catalina";
                        default:
                            return;
                    }
                }, e.getAndroidVersionName = function(e) {
                    var t = e.split(".").splice(0, 2).map(function(e) {
                        return parseInt(e, 10) || 0;
                    });
                    if (t.push(0), !(1 === t[0] && t[1] < 5)) return 1 === t[0] && t[1] < 6 ? "Cupcake" : 1 === t[0] && t[1] >= 6 ? "Donut" : 2 === t[0] && t[1] < 2 ? "Eclair" : 2 === t[0] && 2 === t[1] ? "Froyo" : 2 === t[0] && t[1] > 2 ? "Gingerbread" : 3 === t[0] ? "Honeycomb" : 4 === t[0] && t[1] < 1 ? "Ice Cream Sandwich" : 4 === t[0] && t[1] < 4 ? "Jelly Bean" : 4 === t[0] && t[1] >= 4 ? "KitKat" : 5 === t[0] ? "Lollipop" : 6 === t[0] ? "Marshmallow" : 7 === t[0] ? "Nougat" : 8 === t[0] ? "Oreo" : 9 === t[0] ? "Pie" : void 0;
                }, e.getVersionPrecision = function(e) {
                    return e.split(".").length;
                }, e.compareVersions = function(t, r, n) {
                    void 0 === n && (n = !1);
                    var i = e.getVersionPrecision(t), s = e.getVersionPrecision(r), a = Math.max(i, s), o = 0, u = e.map([
                        t,
                        r
                    ], function(t) {
                        var r = a - e.getVersionPrecision(t), n = t + new Array(r + 1).join(".0");
                        return e.map(n.split("."), function(e) {
                            return new Array(20 - e.length).join("0") + e;
                        }).reverse();
                    });
                    for(n && (o = a - Math.min(i, s)), a -= 1; a >= o;){
                        if (u[0][a] > u[1][a]) return 1;
                        if (u[0][a] === u[1][a]) {
                            if (a === o) return 0;
                            a -= 1;
                        } else if (u[0][a] < u[1][a]) return -1;
                    }
                }, e.map = function(e, t) {
                    var r, n = [];
                    if (Array.prototype.map) return Array.prototype.map.call(e, t);
                    for(r = 0; r < e.length; r += 1)n.push(t(e[r]));
                    return n;
                }, e.find = function(e, t) {
                    var r, n;
                    if (Array.prototype.find) return Array.prototype.find.call(e, t);
                    for(r = 0, n = e.length; r < n; r += 1){
                        var i = e[r];
                        if (t(i, r)) return i;
                    }
                }, e.assign = function(e) {
                    for(var t, r, n = e, i = arguments.length, s = new Array(i > 1 ? i - 1 : 0), a = 1; a < i; a++)s[a - 1] = arguments[a];
                    if (Object.assign) return Object.assign.apply(Object, [
                        e
                    ].concat(s));
                    var o = function() {
                        var e = s[t];
                        "object" == typeof e && null !== e && Object.keys(e).forEach(function(t) {
                            n[t] = e[t];
                        });
                    };
                    for(t = 0, r = s.length; t < r; t += 1)o();
                    return e;
                }, e.getBrowserAlias = function(e) {
                    return n.BROWSER_ALIASES_MAP[e];
                }, e.getBrowserTypeByAlias = function(e) {
                    return n.BROWSER_MAP[e] || "";
                }, e;
            }();
            t.default = i, e.exports = t.default;
        },
        18: function(e, t, r) {
            "use strict";
            t.__esModule = !0, t.ENGINE_MAP = t.OS_MAP = t.PLATFORMS_MAP = t.BROWSER_MAP = t.BROWSER_ALIASES_MAP = void 0;
            t.BROWSER_ALIASES_MAP = {
                "Amazon Silk": "amazon_silk",
                "Android Browser": "android",
                Bada: "bada",
                BlackBerry: "blackberry",
                Chrome: "chrome",
                Chromium: "chromium",
                Electron: "electron",
                Epiphany: "epiphany",
                Firefox: "firefox",
                Focus: "focus",
                Generic: "generic",
                "Google Search": "google_search",
                Googlebot: "googlebot",
                "Internet Explorer": "ie",
                "K-Meleon": "k_meleon",
                Maxthon: "maxthon",
                "Microsoft Edge": "edge",
                "MZ Browser": "mz",
                "NAVER Whale Browser": "naver",
                Opera: "opera",
                "Opera Coast": "opera_coast",
                PhantomJS: "phantomjs",
                Puffin: "puffin",
                QupZilla: "qupzilla",
                QQ: "qq",
                QQLite: "qqlite",
                Safari: "safari",
                Sailfish: "sailfish",
                "Samsung Internet for Android": "samsung_internet",
                SeaMonkey: "seamonkey",
                Sleipnir: "sleipnir",
                Swing: "swing",
                Tizen: "tizen",
                "UC Browser": "uc",
                Vivaldi: "vivaldi",
                "WebOS Browser": "webos",
                WeChat: "wechat",
                "Yandex Browser": "yandex",
                Roku: "roku"
            };
            t.BROWSER_MAP = {
                amazon_silk: "Amazon Silk",
                android: "Android Browser",
                bada: "Bada",
                blackberry: "BlackBerry",
                chrome: "Chrome",
                chromium: "Chromium",
                electron: "Electron",
                epiphany: "Epiphany",
                firefox: "Firefox",
                focus: "Focus",
                generic: "Generic",
                googlebot: "Googlebot",
                google_search: "Google Search",
                ie: "Internet Explorer",
                k_meleon: "K-Meleon",
                maxthon: "Maxthon",
                edge: "Microsoft Edge",
                mz: "MZ Browser",
                naver: "NAVER Whale Browser",
                opera: "Opera",
                opera_coast: "Opera Coast",
                phantomjs: "PhantomJS",
                puffin: "Puffin",
                qupzilla: "QupZilla",
                qq: "QQ Browser",
                qqlite: "QQ Browser Lite",
                safari: "Safari",
                sailfish: "Sailfish",
                samsung_internet: "Samsung Internet for Android",
                seamonkey: "SeaMonkey",
                sleipnir: "Sleipnir",
                swing: "Swing",
                tizen: "Tizen",
                uc: "UC Browser",
                vivaldi: "Vivaldi",
                webos: "WebOS Browser",
                wechat: "WeChat",
                yandex: "Yandex Browser"
            };
            t.PLATFORMS_MAP = {
                tablet: "tablet",
                mobile: "mobile",
                desktop: "desktop",
                tv: "tv"
            };
            t.OS_MAP = {
                WindowsPhone: "Windows Phone",
                Windows: "Windows",
                MacOS: "macOS",
                iOS: "iOS",
                Android: "Android",
                WebOS: "WebOS",
                BlackBerry: "BlackBerry",
                Bada: "Bada",
                Tizen: "Tizen",
                Linux: "Linux",
                ChromeOS: "Chrome OS",
                PlayStation4: "PlayStation 4",
                Roku: "Roku"
            };
            t.ENGINE_MAP = {
                EdgeHTML: "EdgeHTML",
                Blink: "Blink",
                Trident: "Trident",
                Presto: "Presto",
                Gecko: "Gecko",
                WebKit: "WebKit"
            };
        },
        90: function(e, t, r) {
            "use strict";
            t.__esModule = !0, t.default = void 0;
            var n, i = (n = r(91)) && n.__esModule ? n : {
                default: n
            }, s = r(18);
            function a(e, t) {
                for(var r = 0; r < t.length; r++){
                    var n = t[r];
                    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
                }
            }
            var o = function() {
                function e() {}
                var t, r, n;
                return e.getParser = function(e, t) {
                    if (void 0 === t && (t = !1), "string" != typeof e) throw new Error("UserAgent should be a string");
                    return new i.default(e, t);
                }, e.parse = function(e) {
                    return new i.default(e).getResult();
                }, t = e, n = [
                    {
                        key: "BROWSER_MAP",
                        get: function() {
                            return s.BROWSER_MAP;
                        }
                    },
                    {
                        key: "ENGINE_MAP",
                        get: function() {
                            return s.ENGINE_MAP;
                        }
                    },
                    {
                        key: "OS_MAP",
                        get: function() {
                            return s.OS_MAP;
                        }
                    },
                    {
                        key: "PLATFORMS_MAP",
                        get: function() {
                            return s.PLATFORMS_MAP;
                        }
                    }
                ], r = null, n && a(t, n), e;
            }();
            t.default = o, e.exports = t.default;
        },
        91: function(e, t, r) {
            "use strict";
            t.__esModule = !0, t.default = void 0;
            var n = u(r(92)), i = u(r(93)), s = u(r(94)), a = u(r(95)), o = u(r(17));
            function u(e) {
                return e && e.__esModule ? e : {
                    default: e
                };
            }
            var d = function() {
                function e(e, t) {
                    if (void 0 === t && (t = !1), null == e || "" === e) throw new Error("UserAgent parameter can't be empty");
                    this._ua = e, this.parsedResult = {}, !0 !== t && this.parse();
                }
                var t = e.prototype;
                return t.getUA = function() {
                    return this._ua;
                }, t.test = function(e) {
                    return e.test(this._ua);
                }, t.parseBrowser = function() {
                    var e = this;
                    this.parsedResult.browser = {};
                    var t = o.default.find(n.default, function(t) {
                        if ("function" == typeof t.test) return t.test(e);
                        if (t.test instanceof Array) return t.test.some(function(t) {
                            return e.test(t);
                        });
                        throw new Error("Browser's test function is not valid");
                    });
                    return t && (this.parsedResult.browser = t.describe(this.getUA())), this.parsedResult.browser;
                }, t.getBrowser = function() {
                    return this.parsedResult.browser ? this.parsedResult.browser : this.parseBrowser();
                }, t.getBrowserName = function(e) {
                    return e ? String(this.getBrowser().name).toLowerCase() || "" : this.getBrowser().name || "";
                }, t.getBrowserVersion = function() {
                    return this.getBrowser().version;
                }, t.getOS = function() {
                    return this.parsedResult.os ? this.parsedResult.os : this.parseOS();
                }, t.parseOS = function() {
                    var e = this;
                    this.parsedResult.os = {};
                    var t = o.default.find(i.default, function(t) {
                        if ("function" == typeof t.test) return t.test(e);
                        if (t.test instanceof Array) return t.test.some(function(t) {
                            return e.test(t);
                        });
                        throw new Error("Browser's test function is not valid");
                    });
                    return t && (this.parsedResult.os = t.describe(this.getUA())), this.parsedResult.os;
                }, t.getOSName = function(e) {
                    var t = this.getOS().name;
                    return e ? String(t).toLowerCase() || "" : t || "";
                }, t.getOSVersion = function() {
                    return this.getOS().version;
                }, t.getPlatform = function() {
                    return this.parsedResult.platform ? this.parsedResult.platform : this.parsePlatform();
                }, t.getPlatformType = function(e) {
                    void 0 === e && (e = !1);
                    var t = this.getPlatform().type;
                    return e ? String(t).toLowerCase() || "" : t || "";
                }, t.parsePlatform = function() {
                    var e = this;
                    this.parsedResult.platform = {};
                    var t = o.default.find(s.default, function(t) {
                        if ("function" == typeof t.test) return t.test(e);
                        if (t.test instanceof Array) return t.test.some(function(t) {
                            return e.test(t);
                        });
                        throw new Error("Browser's test function is not valid");
                    });
                    return t && (this.parsedResult.platform = t.describe(this.getUA())), this.parsedResult.platform;
                }, t.getEngine = function() {
                    return this.parsedResult.engine ? this.parsedResult.engine : this.parseEngine();
                }, t.getEngineName = function(e) {
                    return e ? String(this.getEngine().name).toLowerCase() || "" : this.getEngine().name || "";
                }, t.parseEngine = function() {
                    var e = this;
                    this.parsedResult.engine = {};
                    var t = o.default.find(a.default, function(t) {
                        if ("function" == typeof t.test) return t.test(e);
                        if (t.test instanceof Array) return t.test.some(function(t) {
                            return e.test(t);
                        });
                        throw new Error("Browser's test function is not valid");
                    });
                    return t && (this.parsedResult.engine = t.describe(this.getUA())), this.parsedResult.engine;
                }, t.parse = function() {
                    return this.parseBrowser(), this.parseOS(), this.parsePlatform(), this.parseEngine(), this;
                }, t.getResult = function() {
                    return o.default.assign({}, this.parsedResult);
                }, t.satisfies = function(e) {
                    var t = this, r = {}, n = 0, i = {}, s = 0;
                    if (Object.keys(e).forEach(function(t) {
                        var a = e[t];
                        "string" == typeof a ? (i[t] = a, s += 1) : "object" == typeof a && (r[t] = a, n += 1);
                    }), n > 0) {
                        var a = Object.keys(r), u = o.default.find(a, function(e) {
                            return t.isOS(e);
                        });
                        if (u) {
                            var d = this.satisfies(r[u]);
                            if (void 0 !== d) return d;
                        }
                        var c = o.default.find(a, function(e) {
                            return t.isPlatform(e);
                        });
                        if (c) {
                            var f = this.satisfies(r[c]);
                            if (void 0 !== f) return f;
                        }
                    }
                    if (s > 0) {
                        var l = Object.keys(i), h = o.default.find(l, function(e) {
                            return t.isBrowser(e, !0);
                        });
                        if (void 0 !== h) return this.compareVersion(i[h]);
                    }
                }, t.isBrowser = function(e, t) {
                    void 0 === t && (t = !1);
                    var r = this.getBrowserName().toLowerCase(), n = e.toLowerCase(), i = o.default.getBrowserTypeByAlias(n);
                    return t && i && (n = i.toLowerCase()), n === r;
                }, t.compareVersion = function(e) {
                    var t = [
                        0
                    ], r = e, n = !1, i = this.getBrowserVersion();
                    if ("string" == typeof i) return ">" === e[0] || "<" === e[0] ? (r = e.substr(1), "=" === e[1] ? (n = !0, r = e.substr(2)) : t = [], ">" === e[0] ? t.push(1) : t.push(-1)) : "=" === e[0] ? r = e.substr(1) : "~" === e[0] && (n = !0, r = e.substr(1)), t.indexOf(o.default.compareVersions(i, r, n)) > -1;
                }, t.isOS = function(e) {
                    return this.getOSName(!0) === String(e).toLowerCase();
                }, t.isPlatform = function(e) {
                    return this.getPlatformType(!0) === String(e).toLowerCase();
                }, t.isEngine = function(e) {
                    return this.getEngineName(!0) === String(e).toLowerCase();
                }, t.is = function(e, t) {
                    return void 0 === t && (t = !1), this.isBrowser(e, t) || this.isOS(e) || this.isPlatform(e);
                }, t.some = function(e) {
                    var t = this;
                    return void 0 === e && (e = []), e.some(function(e) {
                        return t.is(e);
                    });
                }, e;
            }();
            t.default = d, e.exports = t.default;
        },
        92: function(e, t, r) {
            "use strict";
            t.__esModule = !0, t.default = void 0;
            var n, i = (n = r(17)) && n.__esModule ? n : {
                default: n
            };
            var s = /version\/(\d+(\.?_?\d+)+)/i, a = [
                {
                    test: [
                        /googlebot/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Googlebot"
                        }, r = i.default.getFirstMatch(/googlebot\/(\d+(\.\d+))/i, e) || i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /opera/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Opera"
                        }, r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/(?:opera)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /opr\/|opios/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Opera"
                        }, r = i.default.getFirstMatch(/(?:opr|opios)[\s/](\S+)/i, e) || i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /SamsungBrowser/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Samsung Internet for Android"
                        }, r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/(?:SamsungBrowser)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /Whale/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "NAVER Whale Browser"
                        }, r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/(?:whale)[\s/](\d+(?:\.\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /MZBrowser/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "MZ Browser"
                        }, r = i.default.getFirstMatch(/(?:MZBrowser)[\s/](\d+(?:\.\d+)+)/i, e) || i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /focus/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Focus"
                        }, r = i.default.getFirstMatch(/(?:focus)[\s/](\d+(?:\.\d+)+)/i, e) || i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /swing/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Swing"
                        }, r = i.default.getFirstMatch(/(?:swing)[\s/](\d+(?:\.\d+)+)/i, e) || i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /coast/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Opera Coast"
                        }, r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/(?:coast)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /opt\/\d+(?:.?_?\d+)+/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Opera Touch"
                        }, r = i.default.getFirstMatch(/(?:opt)[\s/](\d+(\.?_?\d+)+)/i, e) || i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /yabrowser/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Yandex Browser"
                        }, r = i.default.getFirstMatch(/(?:yabrowser)[\s/](\d+(\.?_?\d+)+)/i, e) || i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /ucbrowser/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "UC Browser"
                        }, r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/(?:ucbrowser)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /Maxthon|mxios/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Maxthon"
                        }, r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/(?:Maxthon|mxios)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /epiphany/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Epiphany"
                        }, r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/(?:epiphany)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /puffin/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Puffin"
                        }, r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/(?:puffin)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /sleipnir/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Sleipnir"
                        }, r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/(?:sleipnir)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /k-meleon/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "K-Meleon"
                        }, r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/(?:k-meleon)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /micromessenger/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "WeChat"
                        }, r = i.default.getFirstMatch(/(?:micromessenger)[\s/](\d+(\.?_?\d+)+)/i, e) || i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /qqbrowser/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: /qqbrowserlite/i.test(e) ? "QQ Browser Lite" : "QQ Browser"
                        }, r = i.default.getFirstMatch(/(?:qqbrowserlite|qqbrowser)[/](\d+(\.?_?\d+)+)/i, e) || i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /msie|trident/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Internet Explorer"
                        }, r = i.default.getFirstMatch(/(?:msie |rv:)(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /\sedg\//i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Microsoft Edge"
                        }, r = i.default.getFirstMatch(/\sedg\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /edg([ea]|ios)/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Microsoft Edge"
                        }, r = i.default.getSecondMatch(/edg([ea]|ios)\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /vivaldi/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Vivaldi"
                        }, r = i.default.getFirstMatch(/vivaldi\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /seamonkey/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "SeaMonkey"
                        }, r = i.default.getFirstMatch(/seamonkey\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /sailfish/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Sailfish"
                        }, r = i.default.getFirstMatch(/sailfish\s?browser\/(\d+(\.\d+)?)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /silk/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Amazon Silk"
                        }, r = i.default.getFirstMatch(/silk\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /phantom/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "PhantomJS"
                        }, r = i.default.getFirstMatch(/phantomjs\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /slimerjs/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "SlimerJS"
                        }, r = i.default.getFirstMatch(/slimerjs\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /blackberry|\bbb\d+/i,
                        /rim\stablet/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "BlackBerry"
                        }, r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/blackberry[\d]+\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /(web|hpw)[o0]s/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "WebOS Browser"
                        }, r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/w(?:eb)?[o0]sbrowser\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /bada/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Bada"
                        }, r = i.default.getFirstMatch(/dolfin\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /tizen/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Tizen"
                        }, r = i.default.getFirstMatch(/(?:tizen\s?)?browser\/(\d+(\.?_?\d+)+)/i, e) || i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /qupzilla/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "QupZilla"
                        }, r = i.default.getFirstMatch(/(?:qupzilla)[\s/](\d+(\.?_?\d+)+)/i, e) || i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /firefox|iceweasel|fxios/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Firefox"
                        }, r = i.default.getFirstMatch(/(?:firefox|iceweasel|fxios)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /electron/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Electron"
                        }, r = i.default.getFirstMatch(/(?:electron)\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /MiuiBrowser/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Miui"
                        }, r = i.default.getFirstMatch(/(?:MiuiBrowser)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /chromium/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Chromium"
                        }, r = i.default.getFirstMatch(/(?:chromium)[\s/](\d+(\.?_?\d+)+)/i, e) || i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /chrome|crios|crmo/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Chrome"
                        }, r = i.default.getFirstMatch(/(?:chrome|crios|crmo)\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /GSA/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Google Search"
                        }, r = i.default.getFirstMatch(/(?:GSA)\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: function(e) {
                        var t = !e.test(/like android/i), r = e.test(/android/i);
                        return t && r;
                    },
                    describe: function(e) {
                        var t = {
                            name: "Android Browser"
                        }, r = i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /playstation 4/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "PlayStation 4"
                        }, r = i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /safari|applewebkit/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Safari"
                        }, r = i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /.*/i
                    ],
                    describe: function(e) {
                        var t = -1 !== e.search("\\(") ? /^(.*)\/(.*)[ \t]\((.*)/ : /^(.*)\/(.*) /;
                        return {
                            name: i.default.getFirstMatch(t, e),
                            version: i.default.getSecondMatch(t, e)
                        };
                    }
                }
            ];
            t.default = a, e.exports = t.default;
        },
        93: function(e, t, r) {
            "use strict";
            t.__esModule = !0, t.default = void 0;
            var n, i = (n = r(17)) && n.__esModule ? n : {
                default: n
            }, s = r(18);
            var a = [
                {
                    test: [
                        /Roku\/DVP/
                    ],
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/Roku\/DVP-(\d+\.\d+)/i, e);
                        return {
                            name: s.OS_MAP.Roku,
                            version: t
                        };
                    }
                },
                {
                    test: [
                        /windows phone/i
                    ],
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/windows phone (?:os)?\s?(\d+(\.\d+)*)/i, e);
                        return {
                            name: s.OS_MAP.WindowsPhone,
                            version: t
                        };
                    }
                },
                {
                    test: [
                        /windows /i
                    ],
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/Windows ((NT|XP)( \d\d?.\d)?)/i, e), r = i.default.getWindowsVersionName(t);
                        return {
                            name: s.OS_MAP.Windows,
                            version: t,
                            versionName: r
                        };
                    }
                },
                {
                    test: [
                        /Macintosh(.*?) FxiOS(.*?)\//
                    ],
                    describe: function(e) {
                        var t = {
                            name: s.OS_MAP.iOS
                        }, r = i.default.getSecondMatch(/(Version\/)(\d[\d.]+)/, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /macintosh/i
                    ],
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/mac os x (\d+(\.?_?\d+)+)/i, e).replace(/[_\s]/g, "."), r = i.default.getMacOSVersionName(t), n = {
                            name: s.OS_MAP.MacOS,
                            version: t
                        };
                        return r && (n.versionName = r), n;
                    }
                },
                {
                    test: [
                        /(ipod|iphone|ipad)/i
                    ],
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/os (\d+([_\s]\d+)*) like mac os x/i, e).replace(/[_\s]/g, ".");
                        return {
                            name: s.OS_MAP.iOS,
                            version: t
                        };
                    }
                },
                {
                    test: function(e) {
                        var t = !e.test(/like android/i), r = e.test(/android/i);
                        return t && r;
                    },
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/android[\s/-](\d+(\.\d+)*)/i, e), r = i.default.getAndroidVersionName(t), n = {
                            name: s.OS_MAP.Android,
                            version: t
                        };
                        return r && (n.versionName = r), n;
                    }
                },
                {
                    test: [
                        /(web|hpw)[o0]s/i
                    ],
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/(?:web|hpw)[o0]s\/(\d+(\.\d+)*)/i, e), r = {
                            name: s.OS_MAP.WebOS
                        };
                        return t && t.length && (r.version = t), r;
                    }
                },
                {
                    test: [
                        /blackberry|\bbb\d+/i,
                        /rim\stablet/i
                    ],
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/rim\stablet\sos\s(\d+(\.\d+)*)/i, e) || i.default.getFirstMatch(/blackberry\d+\/(\d+([_\s]\d+)*)/i, e) || i.default.getFirstMatch(/\bbb(\d+)/i, e);
                        return {
                            name: s.OS_MAP.BlackBerry,
                            version: t
                        };
                    }
                },
                {
                    test: [
                        /bada/i
                    ],
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/bada\/(\d+(\.\d+)*)/i, e);
                        return {
                            name: s.OS_MAP.Bada,
                            version: t
                        };
                    }
                },
                {
                    test: [
                        /tizen/i
                    ],
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/tizen[/\s](\d+(\.\d+)*)/i, e);
                        return {
                            name: s.OS_MAP.Tizen,
                            version: t
                        };
                    }
                },
                {
                    test: [
                        /linux/i
                    ],
                    describe: function() {
                        return {
                            name: s.OS_MAP.Linux
                        };
                    }
                },
                {
                    test: [
                        /CrOS/
                    ],
                    describe: function() {
                        return {
                            name: s.OS_MAP.ChromeOS
                        };
                    }
                },
                {
                    test: [
                        /PlayStation 4/
                    ],
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/PlayStation 4[/\s](\d+(\.\d+)*)/i, e);
                        return {
                            name: s.OS_MAP.PlayStation4,
                            version: t
                        };
                    }
                }
            ];
            t.default = a, e.exports = t.default;
        },
        94: function(e, t, r) {
            "use strict";
            t.__esModule = !0, t.default = void 0;
            var n, i = (n = r(17)) && n.__esModule ? n : {
                default: n
            }, s = r(18);
            var a = [
                {
                    test: [
                        /googlebot/i
                    ],
                    describe: function() {
                        return {
                            type: "bot",
                            vendor: "Google"
                        };
                    }
                },
                {
                    test: [
                        /huawei/i
                    ],
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/(can-l01)/i, e) && "Nova", r = {
                            type: s.PLATFORMS_MAP.mobile,
                            vendor: "Huawei"
                        };
                        return t && (r.model = t), r;
                    }
                },
                {
                    test: [
                        /nexus\s*(?:7|8|9|10).*/i
                    ],
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.tablet,
                            vendor: "Nexus"
                        };
                    }
                },
                {
                    test: [
                        /ipad/i
                    ],
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.tablet,
                            vendor: "Apple",
                            model: "iPad"
                        };
                    }
                },
                {
                    test: [
                        /Macintosh(.*?) FxiOS(.*?)\//
                    ],
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.tablet,
                            vendor: "Apple",
                            model: "iPad"
                        };
                    }
                },
                {
                    test: [
                        /kftt build/i
                    ],
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.tablet,
                            vendor: "Amazon",
                            model: "Kindle Fire HD 7"
                        };
                    }
                },
                {
                    test: [
                        /silk/i
                    ],
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.tablet,
                            vendor: "Amazon"
                        };
                    }
                },
                {
                    test: [
                        /tablet(?! pc)/i
                    ],
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.tablet
                        };
                    }
                },
                {
                    test: function(e) {
                        var t = e.test(/ipod|iphone/i), r = e.test(/like (ipod|iphone)/i);
                        return t && !r;
                    },
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/(ipod|iphone)/i, e);
                        return {
                            type: s.PLATFORMS_MAP.mobile,
                            vendor: "Apple",
                            model: t
                        };
                    }
                },
                {
                    test: [
                        /nexus\s*[0-6].*/i,
                        /galaxy nexus/i
                    ],
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.mobile,
                            vendor: "Nexus"
                        };
                    }
                },
                {
                    test: [
                        /[^-]mobi/i
                    ],
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.mobile
                        };
                    }
                },
                {
                    test: function(e) {
                        return "blackberry" === e.getBrowserName(!0);
                    },
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.mobile,
                            vendor: "BlackBerry"
                        };
                    }
                },
                {
                    test: function(e) {
                        return "bada" === e.getBrowserName(!0);
                    },
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.mobile
                        };
                    }
                },
                {
                    test: function(e) {
                        return "windows phone" === e.getBrowserName();
                    },
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.mobile,
                            vendor: "Microsoft"
                        };
                    }
                },
                {
                    test: function(e) {
                        var t = Number(String(e.getOSVersion()).split(".")[0]);
                        return "android" === e.getOSName(!0) && t >= 3;
                    },
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.tablet
                        };
                    }
                },
                {
                    test: function(e) {
                        return "android" === e.getOSName(!0);
                    },
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.mobile
                        };
                    }
                },
                {
                    test: function(e) {
                        return "macos" === e.getOSName(!0);
                    },
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.desktop,
                            vendor: "Apple"
                        };
                    }
                },
                {
                    test: function(e) {
                        return "windows" === e.getOSName(!0);
                    },
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.desktop
                        };
                    }
                },
                {
                    test: function(e) {
                        return "linux" === e.getOSName(!0);
                    },
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.desktop
                        };
                    }
                },
                {
                    test: function(e) {
                        return "playstation 4" === e.getOSName(!0);
                    },
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.tv
                        };
                    }
                },
                {
                    test: function(e) {
                        return "roku" === e.getOSName(!0);
                    },
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.tv
                        };
                    }
                }
            ];
            t.default = a, e.exports = t.default;
        },
        95: function(e, t, r) {
            "use strict";
            t.__esModule = !0, t.default = void 0;
            var n, i = (n = r(17)) && n.__esModule ? n : {
                default: n
            }, s = r(18);
            var a = [
                {
                    test: function(e) {
                        return "microsoft edge" === e.getBrowserName(!0);
                    },
                    describe: function(e) {
                        if (/\sedg\//i.test(e)) return {
                            name: s.ENGINE_MAP.Blink
                        };
                        var t = i.default.getFirstMatch(/edge\/(\d+(\.?_?\d+)+)/i, e);
                        return {
                            name: s.ENGINE_MAP.EdgeHTML,
                            version: t
                        };
                    }
                },
                {
                    test: [
                        /trident/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: s.ENGINE_MAP.Trident
                        }, r = i.default.getFirstMatch(/trident\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: function(e) {
                        return e.test(/presto/i);
                    },
                    describe: function(e) {
                        var t = {
                            name: s.ENGINE_MAP.Presto
                        }, r = i.default.getFirstMatch(/presto\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: function(e) {
                        var t = e.test(/gecko/i), r = e.test(/like gecko/i);
                        return t && !r;
                    },
                    describe: function(e) {
                        var t = {
                            name: s.ENGINE_MAP.Gecko
                        }, r = i.default.getFirstMatch(/gecko\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /(apple)?webkit\/537\.36/i
                    ],
                    describe: function() {
                        return {
                            name: s.ENGINE_MAP.Blink
                        };
                    }
                },
                {
                    test: [
                        /(apple)?webkit/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: s.ENGINE_MAP.WebKit
                        }, r = i.default.getFirstMatch(/webkit\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                }
            ];
            t.default = a, e.exports = t.default;
        }
    });
});


var $36ab7aff4f97a5b5$export$69d579f32876892f = function(_a) {
    var serviceId = _a.serviceId, clientVersion = _a.clientVersion;
    return function() {
        return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
            var parsedUA, sections;
            var _a, _b, _c, _d, _e, _f, _g;
            return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_h) {
                parsedUA = typeof window !== "undefined" && ((_a = window === null || window === void 0 ? void 0 : window.navigator) === null || _a === void 0 ? void 0 : _a.userAgent) ? (0, (/*@__PURE__*/$parcel$interopDefault($03dc96944173e4d6$exports))).parse(window.navigator.userAgent) : undefined;
                sections = [
                    [
                        "aws-sdk-js",
                        clientVersion
                    ],
                    [
                        "os/" + (((_b = parsedUA === null || parsedUA === void 0 ? void 0 : parsedUA.os) === null || _b === void 0 ? void 0 : _b.name) || "other"),
                        (_c = parsedUA === null || parsedUA === void 0 ? void 0 : parsedUA.os) === null || _c === void 0 ? void 0 : _c.version
                    ],
                    [
                        "lang/js"
                    ],
                    [
                        "md/browser",
                        ((_e = (_d = parsedUA === null || parsedUA === void 0 ? void 0 : parsedUA.browser) === null || _d === void 0 ? void 0 : _d.name) !== null && _e !== void 0 ? _e : "unknown") + "_" + ((_g = (_f = parsedUA === null || parsedUA === void 0 ? void 0 : parsedUA.browser) === null || _f === void 0 ? void 0 : _f.version) !== null && _g !== void 0 ? _g : "unknown")
                    ]
                ];
                if (serviceId) sections.push([
                    "api/" + serviceId,
                    clientVersion
                ]);
                return [
                    2,
                    sections
                ];
            });
        });
    };
};



var $iqmfT = parcelRequire("iqmfT");

function $b3ea5e7fcf4d5f0f$export$66256f83798e5415(querystring) {
    var e_1, _a;
    var query = {};
    querystring = querystring.replace(/^\?/, "");
    if (querystring) try {
        for(var _b = (0, $5c96a02c592fcff1$export$19a8beecd37a4c45)(querystring.split("&")), _c = _b.next(); !_c.done; _c = _b.next()){
            var pair = _c.value;
            var _d = (0, $5c96a02c592fcff1$export$8d051b38c9118094)(pair.split("="), 2), key = _d[0], _e = _d[1], value = _e === void 0 ? null : _e;
            key = decodeURIComponent(key);
            if (value) value = decodeURIComponent(value);
            if (!(key in query)) query[key] = value;
            else if (Array.isArray(query[key])) query[key].push(value);
            else query[key] = [
                query[key],
                value
            ];
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
    return query;
}


var $8a02d3f42435f68f$export$7a5253c0f62e0150 = function(url) {
    var _a = new URL(url), hostname = _a.hostname, pathname = _a.pathname, port = _a.port, protocol = _a.protocol, search = _a.search;
    var query;
    if (search) query = (0, $b3ea5e7fcf4d5f0f$export$66256f83798e5415)(search);
    return {
        hostname: hostname,
        port: port ? parseInt(port) : undefined,
        protocol: protocol,
        path: pathname,
        query: query
    };
};




var $94380e939e70d6f4$var$regionHash = {
    "us-east-1": {
        variants: [
            {
                hostname: "sns-fips.us-east-1.amazonaws.com",
                tags: [
                    "fips"
                ]
            }
        ]
    },
    "us-east-2": {
        variants: [
            {
                hostname: "sns-fips.us-east-2.amazonaws.com",
                tags: [
                    "fips"
                ]
            }
        ]
    },
    "us-gov-east-1": {
        variants: [
            {
                hostname: "sns.us-gov-east-1.amazonaws.com",
                tags: []
            }
        ],
        signingRegion: "us-gov-east-1"
    },
    "us-gov-west-1": {
        variants: [
            {
                hostname: "sns.us-gov-west-1.amazonaws.com",
                tags: []
            }
        ],
        signingRegion: "us-gov-west-1"
    },
    "us-west-1": {
        variants: [
            {
                hostname: "sns-fips.us-west-1.amazonaws.com",
                tags: [
                    "fips"
                ]
            }
        ]
    },
    "us-west-2": {
        variants: [
            {
                hostname: "sns-fips.us-west-2.amazonaws.com",
                tags: [
                    "fips"
                ]
            }
        ]
    }
};
var $94380e939e70d6f4$var$partitionHash = {
    aws: {
        regions: [
            "af-south-1",
            "ap-east-1",
            "ap-northeast-1",
            "ap-northeast-2",
            "ap-northeast-3",
            "ap-south-1",
            "ap-southeast-1",
            "ap-southeast-2",
            "ap-southeast-3",
            "ca-central-1",
            "eu-central-1",
            "eu-north-1",
            "eu-south-1",
            "eu-west-1",
            "eu-west-2",
            "eu-west-3",
            "fips-us-east-1",
            "fips-us-east-2",
            "fips-us-west-1",
            "fips-us-west-2",
            "me-south-1",
            "sa-east-1",
            "us-east-1",
            "us-east-2",
            "us-west-1",
            "us-west-2"
        ],
        regionRegex: "^(us|eu|ap|sa|ca|me|af)\\-\\w+\\-\\d+$",
        variants: [
            {
                hostname: "sns.{region}.amazonaws.com",
                tags: []
            },
            {
                hostname: "sns-fips.{region}.amazonaws.com",
                tags: [
                    "fips"
                ]
            },
            {
                hostname: "sns-fips.{region}.api.aws",
                tags: [
                    "dualstack",
                    "fips"
                ]
            },
            {
                hostname: "sns.{region}.api.aws",
                tags: [
                    "dualstack"
                ]
            }
        ]
    },
    "aws-cn": {
        regions: [
            "cn-north-1",
            "cn-northwest-1"
        ],
        regionRegex: "^cn\\-\\w+\\-\\d+$",
        variants: [
            {
                hostname: "sns.{region}.amazonaws.com.cn",
                tags: []
            },
            {
                hostname: "sns-fips.{region}.amazonaws.com.cn",
                tags: [
                    "fips"
                ]
            },
            {
                hostname: "sns-fips.{region}.api.amazonwebservices.com.cn",
                tags: [
                    "dualstack",
                    "fips"
                ]
            },
            {
                hostname: "sns.{region}.api.amazonwebservices.com.cn",
                tags: [
                    "dualstack"
                ]
            }
        ]
    },
    "aws-iso": {
        regions: [
            "us-iso-east-1",
            "us-iso-west-1"
        ],
        regionRegex: "^us\\-iso\\-\\w+\\-\\d+$",
        variants: [
            {
                hostname: "sns.{region}.c2s.ic.gov",
                tags: []
            },
            {
                hostname: "sns-fips.{region}.c2s.ic.gov",
                tags: [
                    "fips"
                ]
            }
        ]
    },
    "aws-iso-b": {
        regions: [
            "us-isob-east-1"
        ],
        regionRegex: "^us\\-isob\\-\\w+\\-\\d+$",
        variants: [
            {
                hostname: "sns.{region}.sc2s.sgov.gov",
                tags: []
            },
            {
                hostname: "sns-fips.{region}.sc2s.sgov.gov",
                tags: [
                    "fips"
                ]
            }
        ]
    },
    "aws-us-gov": {
        regions: [
            "us-gov-east-1",
            "us-gov-west-1"
        ],
        regionRegex: "^us\\-gov\\-\\w+\\-\\d+$",
        variants: [
            {
                hostname: "sns.{region}.amazonaws.com",
                tags: []
            },
            {
                hostname: "sns-fips.{region}.amazonaws.com",
                tags: [
                    "fips"
                ]
            },
            {
                hostname: "sns-fips.{region}.api.aws",
                tags: [
                    "dualstack",
                    "fips"
                ]
            },
            {
                hostname: "sns.{region}.api.aws",
                tags: [
                    "dualstack"
                ]
            }
        ]
    }
};
var $94380e939e70d6f4$export$2e4318bf13462aa2 = function(region, options) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            return [
                2,
                (0, $4cfcc1fd369b922a$export$2b789d827caebed0)(region, (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, options), {
                    signingService: "sns",
                    regionHash: $94380e939e70d6f4$var$regionHash,
                    partitionHash: $94380e939e70d6f4$var$partitionHash
                }))
            ];
        });
    });
};


var $2b8d242f23c1d2f3$export$ad0966540b0e71e5 = function(config) {
    var _a, _b, _c, _d, _e;
    return {
        apiVersion: "2010-03-31",
        disableHostPrefix: (_a = config === null || config === void 0 ? void 0 : config.disableHostPrefix) !== null && _a !== void 0 ? _a : false,
        logger: (_b = config === null || config === void 0 ? void 0 : config.logger) !== null && _b !== void 0 ? _b : {},
        regionInfoProvider: (_c = config === null || config === void 0 ? void 0 : config.regionInfoProvider) !== null && _c !== void 0 ? _c : (0, $94380e939e70d6f4$export$2e4318bf13462aa2),
        serviceId: (_d = config === null || config === void 0 ? void 0 : config.serviceId) !== null && _d !== void 0 ? _d : "SNS",
        urlParser: (_e = config === null || config === void 0 ? void 0 : config.urlParser) !== null && _e !== void 0 ? _e : (0, $8a02d3f42435f68f$export$7a5253c0f62e0150)
    };
};






var $da286bbfec9a7218$export$32aeb2667d16f7c1 = [
    "in-region",
    "cross-region",
    "mobile",
    "standard",
    "legacy"
];


var $532477a51d430649$export$b146d618450007ac = function(_a) {
    var _b = _a === void 0 ? {} : _a, defaultsMode = _b.defaultsMode;
    return (0, $d99a93426bc19e29$export$fc10aeed3a532e2a)(function() {
        return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
            var mode, _a;
            return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        if (!(typeof defaultsMode === "function")) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            defaultsMode()
                        ];
                    case 1:
                        _a = _b.sent();
                        return [
                            3,
                            3
                        ];
                    case 2:
                        _a = defaultsMode;
                        _b.label = 3;
                    case 3:
                        mode = _a;
                        switch(mode === null || mode === void 0 ? void 0 : mode.toLowerCase()){
                            case "auto":
                                return [
                                    2,
                                    Promise.resolve($532477a51d430649$var$isMobileBrowser() ? "mobile" : "standard")
                                ];
                            case "mobile":
                            case "in-region":
                            case "cross-region":
                            case "standard":
                            case "legacy":
                                return [
                                    2,
                                    Promise.resolve(mode === null || mode === void 0 ? void 0 : mode.toLocaleLowerCase())
                                ];
                            case undefined:
                                return [
                                    2,
                                    Promise.resolve("legacy")
                                ];
                            default:
                                throw new Error('Invalid parameter for "defaultsMode", expect ' + (0, $da286bbfec9a7218$export$32aeb2667d16f7c1).join(", ") + ", got " + mode);
                        }
                        return [
                            2
                        ];
                }
            });
        });
    });
};
var $532477a51d430649$var$isMobileBrowser = function() {
    var _a, _b;
    var parsedUA = typeof window !== "undefined" && ((_a = window === null || window === void 0 ? void 0 : window.navigator) === null || _a === void 0 ? void 0 : _a.userAgent) ? (0, (/*@__PURE__*/$parcel$interopDefault($03dc96944173e4d6$exports))).parse(window.navigator.userAgent) : undefined;
    var platform = (_b = parsedUA === null || parsedUA === void 0 ? void 0 : parsedUA.platform) === null || _b === void 0 ? void 0 : _b.type;
    return platform === "tablet" || platform === "mobile";
};




var $b88602ce30cd5f21$export$ad0966540b0e71e5 = function(config) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q;
    var defaultsMode = (0, $532477a51d430649$export$b146d618450007ac)(config);
    var defaultConfigProvider = function() {
        return defaultsMode().then((0, $1344bf813bb1cae5$export$b6e2b46631b45a92));
    };
    var clientSharedValues = (0, $2b8d242f23c1d2f3$export$ad0966540b0e71e5)(config);
    return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, clientSharedValues), config), {
        runtime: "browser",
        defaultsMode: defaultsMode,
        base64Decoder: (_a = config === null || config === void 0 ? void 0 : config.base64Decoder) !== null && _a !== void 0 ? _a : (0, $a57431ea344ba4b6$export$c537b38001c583b7),
        base64Encoder: (_b = config === null || config === void 0 ? void 0 : config.base64Encoder) !== null && _b !== void 0 ? _b : (0, $a57431ea344ba4b6$export$37cc283d8fbd3462),
        bodyLengthChecker: (_c = config === null || config === void 0 ? void 0 : config.bodyLengthChecker) !== null && _c !== void 0 ? _c : (0, $ccfff7fe732bb712$export$967f3527bf233bc0),
        credentialDefaultProvider: (_d = config === null || config === void 0 ? void 0 : config.credentialDefaultProvider) !== null && _d !== void 0 ? _d : function(_) {
            return function() {
                return Promise.reject(new Error("Credential is missing"));
            };
        },
        defaultUserAgentProvider: (_e = config === null || config === void 0 ? void 0 : config.defaultUserAgentProvider) !== null && _e !== void 0 ? _e : (0, $36ab7aff4f97a5b5$export$69d579f32876892f)({
            serviceId: clientSharedValues.serviceId,
            clientVersion: (0, (/*@__PURE__*/$parcel$interopDefault($26d472c005afc768$exports))).version
        }),
        maxAttempts: (_f = config === null || config === void 0 ? void 0 : config.maxAttempts) !== null && _f !== void 0 ? _f : (0, $53bf6756b7a43689$export$2c7e51f38ba5a406),
        region: (_g = config === null || config === void 0 ? void 0 : config.region) !== null && _g !== void 0 ? _g : (0, $9509d854c39a3d45$export$d59dd53963f8f3d5)("Region is missing"),
        requestHandler: (_h = config === null || config === void 0 ? void 0 : config.requestHandler) !== null && _h !== void 0 ? _h : new (0, $85f416940ae1eba2$export$83588b87edbfa7e0)(defaultConfigProvider),
        retryMode: (_j = config === null || config === void 0 ? void 0 : config.retryMode) !== null && _j !== void 0 ? _j : function() {
            return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
                return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            return [
                                4,
                                defaultConfigProvider()
                            ];
                        case 1:
                            return [
                                2,
                                _a.sent().retryMode || (0, $53bf6756b7a43689$export$41315747b7c5d042)
                            ];
                    }
                });
            });
        },
        sha256: (_k = config === null || config === void 0 ? void 0 : config.sha256) !== null && _k !== void 0 ? _k : (0, $3ce7992f05548527$exports.Sha256),
        streamCollector: (_l = config === null || config === void 0 ? void 0 : config.streamCollector) !== null && _l !== void 0 ? _l : (0, $227fd89517dde28d$export$17bf97b72e307d52),
        useDualstackEndpoint: (_m = config === null || config === void 0 ? void 0 : config.useDualstackEndpoint) !== null && _m !== void 0 ? _m : function() {
            return Promise.resolve((0, $d2d9f00eb717cd34$export$beb01fae7626c427));
        },
        useFipsEndpoint: (_o = config === null || config === void 0 ? void 0 : config.useFipsEndpoint) !== null && _o !== void 0 ? _o : function() {
            return Promise.resolve((0, $c2135aab0e2702c2$export$5555deeca435a10b));
        },
        utf8Decoder: (_p = config === null || config === void 0 ? void 0 : config.utf8Decoder) !== null && _p !== void 0 ? _p : (0, $iqmfT.fromUtf8),
        utf8Encoder: (_q = config === null || config === void 0 ? void 0 : config.utf8Encoder) !== null && _q !== void 0 ? _q : (0, $iqmfT.toUtf8)
    });
};


var $508e2cccf97b518c$export$75bbeb40367748fc = function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(SNSClient, _super);
    function SNSClient(configuration) {
        var _this = this;
        var _config_0 = (0, $b88602ce30cd5f21$export$ad0966540b0e71e5)(configuration);
        var _config_1 = (0, $46315709cfe1dfb5$export$7696ef37558bd0ec)(_config_0);
        var _config_2 = (0, $9521496f3f5d932d$export$24f352b1bd1e2f8b)(_config_1);
        var _config_3 = (0, $42800a4d5c7187b8$export$ca7f6138f2c98476)(_config_2);
        var _config_4 = (0, $88d2ee7e36f5c90f$export$c1625bf0b32b4481)(_config_3);
        var _config_5 = (0, $a080e26d80c25280$export$1dd62920de1feabb)(_config_4);
        var _config_6 = (0, $754475b8730b53d4$export$ec9a2d5663958cb)(_config_5);
        _this = _super.call(this, _config_6) || this;
        _this.config = _config_6;
        _this.middlewareStack.use((0, $0b1fbcc7312d8a59$export$c73199e2b1df9340)(_this.config));
        _this.middlewareStack.use((0, $71d8e7a5aab972a2$export$7e6ddf9365a30fe9)(_this.config));
        _this.middlewareStack.use((0, $88d2ee7e36f5c90f$export$23d3b647211be53a)(_this.config));
        _this.middlewareStack.use((0, $8add791fe0d5d356$export$f6ef65d7766fc255)(_this.config));
        _this.middlewareStack.use((0, $0b14c01e1ba6aa35$export$59c2b7ad30ed4046)(_this.config));
        _this.middlewareStack.use((0, $7b3c99e5173f4767$export$5393c0d2d7f4f5f0)(_this.config));
        return _this;
    }
    SNSClient.prototype.destroy = function() {
        _super.prototype.destroy.call(this);
    };
    return SNSClient;
}((0, $2afbf12425e4ac78$export$1f2bb630327ac4b6));












var $92f584b221ed10a7$exports = {};
$92f584b221ed10a7$exports = JSON.parse('{"name":"@aws-sdk/client-cognito-identity","description":"AWS SDK for JavaScript Cognito Identity Client for Node.js, Browser and React Native","version":"3.53.0","scripts":{"build":"concurrently \'yarn:build:cjs\' \'yarn:build:es\' \'yarn:build:types\'","build:cjs":"tsc -p tsconfig.cjs.json","build:docs":"typedoc","build:es":"tsc -p tsconfig.es.json","build:types":"tsc -p tsconfig.types.json","build:types:downlevel":"downlevel-dts dist-types dist-types/ts3.4","clean":"rimraf ./dist-* && rimraf *.tsbuildinfo","test:e2e":"ts-mocha test/**/*.ispec.ts && karma start karma.conf.js"},"main":"./dist-cjs/index.js","types":"./dist-types/index.d.ts","module":"./dist-es/index.js","sideEffects":false,"dependencies":{"@aws-crypto/sha256-browser":"2.0.0","@aws-crypto/sha256-js":"2.0.0","@aws-sdk/client-sts":"3.53.0","@aws-sdk/config-resolver":"3.53.0","@aws-sdk/credential-provider-node":"3.53.0","@aws-sdk/fetch-http-handler":"3.53.0","@aws-sdk/hash-node":"3.53.0","@aws-sdk/invalid-dependency":"3.53.0","@aws-sdk/middleware-content-length":"3.53.0","@aws-sdk/middleware-host-header":"3.53.0","@aws-sdk/middleware-logger":"3.53.0","@aws-sdk/middleware-retry":"3.53.0","@aws-sdk/middleware-serde":"3.53.0","@aws-sdk/middleware-signing":"3.53.0","@aws-sdk/middleware-stack":"3.53.0","@aws-sdk/middleware-user-agent":"3.53.0","@aws-sdk/node-config-provider":"3.53.0","@aws-sdk/node-http-handler":"3.53.0","@aws-sdk/protocol-http":"3.53.0","@aws-sdk/smithy-client":"3.53.0","@aws-sdk/types":"3.53.0","@aws-sdk/url-parser":"3.53.0","@aws-sdk/util-base64-browser":"3.52.0","@aws-sdk/util-base64-node":"3.52.0","@aws-sdk/util-body-length-browser":"3.52.0","@aws-sdk/util-body-length-node":"3.52.0","@aws-sdk/util-defaults-mode-browser":"3.53.0","@aws-sdk/util-defaults-mode-node":"3.53.0","@aws-sdk/util-user-agent-browser":"3.53.0","@aws-sdk/util-user-agent-node":"3.53.0","@aws-sdk/util-utf8-browser":"3.52.0","@aws-sdk/util-utf8-node":"3.52.0","tslib":"^2.3.0"},"devDependencies":{"@aws-sdk/client-iam":"3.53.0","@aws-sdk/service-client-documentation-generator":"3.52.0","@tsconfig/recommended":"1.0.1","@types/chai":"^4.2.11","@types/mocha":"^8.0.4","@types/node":"^12.7.5","concurrently":"7.0.0","downlevel-dts":"0.7.0","rimraf":"3.0.2","typedoc":"0.19.2","typescript":"~4.3.5"},"engines":{"node":">=12.0.0"},"typesVersions":{"<4.0":{"dist-types/*":["dist-types/ts3.4/*"]}},"files":["dist-*"],"author":{"name":"AWS SDK for JavaScript Team","url":"https://aws.amazon.com/javascript/"},"license":"Apache-2.0","browser":{"./dist-es/runtimeConfig":"./dist-es/runtimeConfig.browser"},"react-native":{"./dist-es/runtimeConfig":"./dist-es/runtimeConfig.native"},"homepage":"https://github.com/aws/aws-sdk-js-v3/tree/main/clients/client-cognito-identity","repository":{"type":"git","url":"https://github.com/aws/aws-sdk-js-v3.git","directory":"clients/client-cognito-identity"}}');











var $iqmfT = parcelRequire("iqmfT");



var $e5b0ba726dd884e7$var$regionHash = {
    "us-east-1": {
        variants: [
            {
                hostname: "cognito-identity-fips.us-east-1.amazonaws.com",
                tags: [
                    "fips"
                ]
            }
        ]
    },
    "us-east-2": {
        variants: [
            {
                hostname: "cognito-identity-fips.us-east-2.amazonaws.com",
                tags: [
                    "fips"
                ]
            }
        ]
    },
    "us-gov-west-1": {
        variants: [
            {
                hostname: "cognito-identity-fips.us-gov-west-1.amazonaws.com",
                tags: [
                    "fips"
                ]
            }
        ]
    },
    "us-west-2": {
        variants: [
            {
                hostname: "cognito-identity-fips.us-west-2.amazonaws.com",
                tags: [
                    "fips"
                ]
            }
        ]
    }
};
var $e5b0ba726dd884e7$var$partitionHash = {
    aws: {
        regions: [
            "af-south-1",
            "ap-east-1",
            "ap-northeast-1",
            "ap-northeast-2",
            "ap-northeast-3",
            "ap-south-1",
            "ap-southeast-1",
            "ap-southeast-2",
            "ap-southeast-3",
            "ca-central-1",
            "eu-central-1",
            "eu-north-1",
            "eu-south-1",
            "eu-west-1",
            "eu-west-2",
            "eu-west-3",
            "fips-us-east-1",
            "fips-us-east-2",
            "fips-us-west-2",
            "me-south-1",
            "sa-east-1",
            "us-east-1",
            "us-east-2",
            "us-west-1",
            "us-west-2"
        ],
        regionRegex: "^(us|eu|ap|sa|ca|me|af)\\-\\w+\\-\\d+$",
        variants: [
            {
                hostname: "cognito-identity.{region}.amazonaws.com",
                tags: []
            },
            {
                hostname: "cognito-identity-fips.{region}.amazonaws.com",
                tags: [
                    "fips"
                ]
            },
            {
                hostname: "cognito-identity-fips.{region}.api.aws",
                tags: [
                    "dualstack",
                    "fips"
                ]
            },
            {
                hostname: "cognito-identity.{region}.api.aws",
                tags: [
                    "dualstack"
                ]
            }
        ]
    },
    "aws-cn": {
        regions: [
            "cn-north-1",
            "cn-northwest-1"
        ],
        regionRegex: "^cn\\-\\w+\\-\\d+$",
        variants: [
            {
                hostname: "cognito-identity.{region}.amazonaws.com.cn",
                tags: []
            },
            {
                hostname: "cognito-identity-fips.{region}.amazonaws.com.cn",
                tags: [
                    "fips"
                ]
            },
            {
                hostname: "cognito-identity-fips.{region}.api.amazonwebservices.com.cn",
                tags: [
                    "dualstack",
                    "fips"
                ]
            },
            {
                hostname: "cognito-identity.{region}.api.amazonwebservices.com.cn",
                tags: [
                    "dualstack"
                ]
            }
        ]
    },
    "aws-iso": {
        regions: [
            "us-iso-east-1",
            "us-iso-west-1"
        ],
        regionRegex: "^us\\-iso\\-\\w+\\-\\d+$",
        variants: [
            {
                hostname: "cognito-identity.{region}.c2s.ic.gov",
                tags: []
            },
            {
                hostname: "cognito-identity-fips.{region}.c2s.ic.gov",
                tags: [
                    "fips"
                ]
            }
        ]
    },
    "aws-iso-b": {
        regions: [
            "us-isob-east-1"
        ],
        regionRegex: "^us\\-isob\\-\\w+\\-\\d+$",
        variants: [
            {
                hostname: "cognito-identity.{region}.sc2s.sgov.gov",
                tags: []
            },
            {
                hostname: "cognito-identity-fips.{region}.sc2s.sgov.gov",
                tags: [
                    "fips"
                ]
            }
        ]
    },
    "aws-us-gov": {
        regions: [
            "fips-us-gov-west-1",
            "us-gov-east-1",
            "us-gov-west-1"
        ],
        regionRegex: "^us\\-gov\\-\\w+\\-\\d+$",
        variants: [
            {
                hostname: "cognito-identity.{region}.amazonaws.com",
                tags: []
            },
            {
                hostname: "cognito-identity-fips.{region}.amazonaws.com",
                tags: [
                    "fips"
                ]
            },
            {
                hostname: "cognito-identity-fips.{region}.api.aws",
                tags: [
                    "dualstack",
                    "fips"
                ]
            },
            {
                hostname: "cognito-identity.{region}.api.aws",
                tags: [
                    "dualstack"
                ]
            }
        ]
    }
};
var $e5b0ba726dd884e7$export$2e4318bf13462aa2 = function(region, options) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            return [
                2,
                (0, $4cfcc1fd369b922a$export$2b789d827caebed0)(region, (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, options), {
                    signingService: "cognito-identity",
                    regionHash: $e5b0ba726dd884e7$var$regionHash,
                    partitionHash: $e5b0ba726dd884e7$var$partitionHash
                }))
            ];
        });
    });
};


var $d7c5949fbe30528a$export$ad0966540b0e71e5 = function(config) {
    var _a, _b, _c, _d, _e;
    return {
        apiVersion: "2014-06-30",
        disableHostPrefix: (_a = config === null || config === void 0 ? void 0 : config.disableHostPrefix) !== null && _a !== void 0 ? _a : false,
        logger: (_b = config === null || config === void 0 ? void 0 : config.logger) !== null && _b !== void 0 ? _b : {},
        regionInfoProvider: (_c = config === null || config === void 0 ? void 0 : config.regionInfoProvider) !== null && _c !== void 0 ? _c : (0, $e5b0ba726dd884e7$export$2e4318bf13462aa2),
        serviceId: (_d = config === null || config === void 0 ? void 0 : config.serviceId) !== null && _d !== void 0 ? _d : "Cognito Identity",
        urlParser: (_e = config === null || config === void 0 ? void 0 : config.urlParser) !== null && _e !== void 0 ? _e : (0, $8a02d3f42435f68f$export$7a5253c0f62e0150)
    };
};




var $b5ca287011086ae7$export$ad0966540b0e71e5 = function(config) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q;
    var defaultsMode = (0, $532477a51d430649$export$b146d618450007ac)(config);
    var defaultConfigProvider = function() {
        return defaultsMode().then((0, $1344bf813bb1cae5$export$b6e2b46631b45a92));
    };
    var clientSharedValues = (0, $d7c5949fbe30528a$export$ad0966540b0e71e5)(config);
    return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, clientSharedValues), config), {
        runtime: "browser",
        defaultsMode: defaultsMode,
        base64Decoder: (_a = config === null || config === void 0 ? void 0 : config.base64Decoder) !== null && _a !== void 0 ? _a : (0, $a57431ea344ba4b6$export$c537b38001c583b7),
        base64Encoder: (_b = config === null || config === void 0 ? void 0 : config.base64Encoder) !== null && _b !== void 0 ? _b : (0, $a57431ea344ba4b6$export$37cc283d8fbd3462),
        bodyLengthChecker: (_c = config === null || config === void 0 ? void 0 : config.bodyLengthChecker) !== null && _c !== void 0 ? _c : (0, $ccfff7fe732bb712$export$967f3527bf233bc0),
        credentialDefaultProvider: (_d = config === null || config === void 0 ? void 0 : config.credentialDefaultProvider) !== null && _d !== void 0 ? _d : function(_) {
            return function() {
                return Promise.reject(new Error("Credential is missing"));
            };
        },
        defaultUserAgentProvider: (_e = config === null || config === void 0 ? void 0 : config.defaultUserAgentProvider) !== null && _e !== void 0 ? _e : (0, $36ab7aff4f97a5b5$export$69d579f32876892f)({
            serviceId: clientSharedValues.serviceId,
            clientVersion: (0, (/*@__PURE__*/$parcel$interopDefault($92f584b221ed10a7$exports))).version
        }),
        maxAttempts: (_f = config === null || config === void 0 ? void 0 : config.maxAttempts) !== null && _f !== void 0 ? _f : (0, $53bf6756b7a43689$export$2c7e51f38ba5a406),
        region: (_g = config === null || config === void 0 ? void 0 : config.region) !== null && _g !== void 0 ? _g : (0, $9509d854c39a3d45$export$d59dd53963f8f3d5)("Region is missing"),
        requestHandler: (_h = config === null || config === void 0 ? void 0 : config.requestHandler) !== null && _h !== void 0 ? _h : new (0, $85f416940ae1eba2$export$83588b87edbfa7e0)(defaultConfigProvider),
        retryMode: (_j = config === null || config === void 0 ? void 0 : config.retryMode) !== null && _j !== void 0 ? _j : function() {
            return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
                return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            return [
                                4,
                                defaultConfigProvider()
                            ];
                        case 1:
                            return [
                                2,
                                _a.sent().retryMode || (0, $53bf6756b7a43689$export$41315747b7c5d042)
                            ];
                    }
                });
            });
        },
        sha256: (_k = config === null || config === void 0 ? void 0 : config.sha256) !== null && _k !== void 0 ? _k : (0, $3ce7992f05548527$exports.Sha256),
        streamCollector: (_l = config === null || config === void 0 ? void 0 : config.streamCollector) !== null && _l !== void 0 ? _l : (0, $227fd89517dde28d$export$17bf97b72e307d52),
        useDualstackEndpoint: (_m = config === null || config === void 0 ? void 0 : config.useDualstackEndpoint) !== null && _m !== void 0 ? _m : function() {
            return Promise.resolve((0, $d2d9f00eb717cd34$export$beb01fae7626c427));
        },
        useFipsEndpoint: (_o = config === null || config === void 0 ? void 0 : config.useFipsEndpoint) !== null && _o !== void 0 ? _o : function() {
            return Promise.resolve((0, $c2135aab0e2702c2$export$5555deeca435a10b));
        },
        utf8Decoder: (_p = config === null || config === void 0 ? void 0 : config.utf8Decoder) !== null && _p !== void 0 ? _p : (0, $iqmfT.fromUtf8),
        utf8Encoder: (_q = config === null || config === void 0 ? void 0 : config.utf8Encoder) !== null && _q !== void 0 ? _q : (0, $iqmfT.toUtf8)
    });
};


var $f00bcaf3ba83febc$export$e576def690e850f7 = function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(CognitoIdentityClient, _super);
    function CognitoIdentityClient(configuration) {
        var _this = this;
        var _config_0 = (0, $b5ca287011086ae7$export$ad0966540b0e71e5)(configuration);
        var _config_1 = (0, $46315709cfe1dfb5$export$7696ef37558bd0ec)(_config_0);
        var _config_2 = (0, $9521496f3f5d932d$export$24f352b1bd1e2f8b)(_config_1);
        var _config_3 = (0, $42800a4d5c7187b8$export$ca7f6138f2c98476)(_config_2);
        var _config_4 = (0, $88d2ee7e36f5c90f$export$c1625bf0b32b4481)(_config_3);
        var _config_5 = (0, $a080e26d80c25280$export$1dd62920de1feabb)(_config_4);
        var _config_6 = (0, $754475b8730b53d4$export$ec9a2d5663958cb)(_config_5);
        _this = _super.call(this, _config_6) || this;
        _this.config = _config_6;
        _this.middlewareStack.use((0, $0b1fbcc7312d8a59$export$c73199e2b1df9340)(_this.config));
        _this.middlewareStack.use((0, $71d8e7a5aab972a2$export$7e6ddf9365a30fe9)(_this.config));
        _this.middlewareStack.use((0, $88d2ee7e36f5c90f$export$23d3b647211be53a)(_this.config));
        _this.middlewareStack.use((0, $8add791fe0d5d356$export$f6ef65d7766fc255)(_this.config));
        _this.middlewareStack.use((0, $7b3c99e5173f4767$export$5393c0d2d7f4f5f0)(_this.config));
        return _this;
    }
    CognitoIdentityClient.prototype.destroy = function() {
        _super.prototype.destroy.call(this);
    };
    return CognitoIdentityClient;
}((0, $2afbf12425e4ac78$export$1f2bb630327ac4b6));









var $4ea34e10cf9d5301$export$b83d40bae15eaefa = function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(CognitoIdentityServiceException, _super);
    function CognitoIdentityServiceException(options) {
        var _this = _super.call(this, options) || this;
        Object.setPrototypeOf(_this, CognitoIdentityServiceException.prototype);
        return _this;
    }
    return CognitoIdentityServiceException;
}((0, $a08c2c31e27e9e11$export$29647f3b4097d3c0));


var $5af132e3d8cbf992$export$dc00db384271fff6;
(function(AmbiguousRoleResolutionType) {
    AmbiguousRoleResolutionType["AUTHENTICATED_ROLE"] = "AuthenticatedRole";
    AmbiguousRoleResolutionType["DENY"] = "Deny";
})($5af132e3d8cbf992$export$dc00db384271fff6 || ($5af132e3d8cbf992$export$dc00db384271fff6 = {}));
var $5af132e3d8cbf992$export$8a7902a72d4cb6dd;
(function(CognitoIdentityProvider) {
    CognitoIdentityProvider.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($5af132e3d8cbf992$export$8a7902a72d4cb6dd || ($5af132e3d8cbf992$export$8a7902a72d4cb6dd = {}));
var $5af132e3d8cbf992$export$2d7512435854af72;
(function(CreateIdentityPoolInput) {
    CreateIdentityPoolInput.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($5af132e3d8cbf992$export$2d7512435854af72 || ($5af132e3d8cbf992$export$2d7512435854af72 = {}));
var $5af132e3d8cbf992$export$8d556ce24d00472;
(function(IdentityPool) {
    IdentityPool.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($5af132e3d8cbf992$export$8d556ce24d00472 || ($5af132e3d8cbf992$export$8d556ce24d00472 = {}));
var $5af132e3d8cbf992$export$8b0f706f4df56c63 = function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(InternalErrorException, _super);
    function InternalErrorException(opts) {
        var _this = _super.call(this, (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
            name: "InternalErrorException",
            $fault: "server"
        }, opts)) || this;
        _this.name = "InternalErrorException";
        _this.$fault = "server";
        Object.setPrototypeOf(_this, InternalErrorException.prototype);
        return _this;
    }
    return InternalErrorException;
}((0, $4ea34e10cf9d5301$export$b83d40bae15eaefa));
var $5af132e3d8cbf992$export$fa781b52e13bf866 = function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(InvalidParameterException, _super);
    function InvalidParameterException(opts) {
        var _this = _super.call(this, (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
            name: "InvalidParameterException",
            $fault: "client"
        }, opts)) || this;
        _this.name = "InvalidParameterException";
        _this.$fault = "client";
        Object.setPrototypeOf(_this, InvalidParameterException.prototype);
        return _this;
    }
    return InvalidParameterException;
}((0, $4ea34e10cf9d5301$export$b83d40bae15eaefa));
var $5af132e3d8cbf992$export$cd419aa7f32ec382 = function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(LimitExceededException, _super);
    function LimitExceededException(opts) {
        var _this = _super.call(this, (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
            name: "LimitExceededException",
            $fault: "client"
        }, opts)) || this;
        _this.name = "LimitExceededException";
        _this.$fault = "client";
        Object.setPrototypeOf(_this, LimitExceededException.prototype);
        return _this;
    }
    return LimitExceededException;
}((0, $4ea34e10cf9d5301$export$b83d40bae15eaefa));
var $5af132e3d8cbf992$export$82cff5e5a0a874dd = function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(NotAuthorizedException, _super);
    function NotAuthorizedException(opts) {
        var _this = _super.call(this, (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
            name: "NotAuthorizedException",
            $fault: "client"
        }, opts)) || this;
        _this.name = "NotAuthorizedException";
        _this.$fault = "client";
        Object.setPrototypeOf(_this, NotAuthorizedException.prototype);
        return _this;
    }
    return NotAuthorizedException;
}((0, $4ea34e10cf9d5301$export$b83d40bae15eaefa));
var $5af132e3d8cbf992$export$cbdaf31887dd0603 = function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(ResourceConflictException, _super);
    function ResourceConflictException(opts) {
        var _this = _super.call(this, (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
            name: "ResourceConflictException",
            $fault: "client"
        }, opts)) || this;
        _this.name = "ResourceConflictException";
        _this.$fault = "client";
        Object.setPrototypeOf(_this, ResourceConflictException.prototype);
        return _this;
    }
    return ResourceConflictException;
}((0, $4ea34e10cf9d5301$export$b83d40bae15eaefa));
var $5af132e3d8cbf992$export$4a67805ad445f61 = function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(TooManyRequestsException, _super);
    function TooManyRequestsException(opts) {
        var _this = _super.call(this, (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
            name: "TooManyRequestsException",
            $fault: "client"
        }, opts)) || this;
        _this.name = "TooManyRequestsException";
        _this.$fault = "client";
        Object.setPrototypeOf(_this, TooManyRequestsException.prototype);
        return _this;
    }
    return TooManyRequestsException;
}((0, $4ea34e10cf9d5301$export$b83d40bae15eaefa));
var $5af132e3d8cbf992$export$6ce299b58e0ab8fe;
(function(DeleteIdentitiesInput) {
    DeleteIdentitiesInput.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($5af132e3d8cbf992$export$6ce299b58e0ab8fe || ($5af132e3d8cbf992$export$6ce299b58e0ab8fe = {}));
var $5af132e3d8cbf992$export$d4e71bc0b80dc0fb;
(function(ErrorCode) {
    ErrorCode["ACCESS_DENIED"] = "AccessDenied";
    ErrorCode["INTERNAL_SERVER_ERROR"] = "InternalServerError";
})($5af132e3d8cbf992$export$d4e71bc0b80dc0fb || ($5af132e3d8cbf992$export$d4e71bc0b80dc0fb = {}));
var $5af132e3d8cbf992$export$7235a8ee19d2bee3;
(function(UnprocessedIdentityId) {
    UnprocessedIdentityId.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($5af132e3d8cbf992$export$7235a8ee19d2bee3 || ($5af132e3d8cbf992$export$7235a8ee19d2bee3 = {}));
var $5af132e3d8cbf992$export$2b5603236acc81d9;
(function(DeleteIdentitiesResponse) {
    DeleteIdentitiesResponse.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($5af132e3d8cbf992$export$2b5603236acc81d9 || ($5af132e3d8cbf992$export$2b5603236acc81d9 = {}));
var $5af132e3d8cbf992$export$cb6981b8f9a703c2;
(function(DeleteIdentityPoolInput) {
    DeleteIdentityPoolInput.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($5af132e3d8cbf992$export$cb6981b8f9a703c2 || ($5af132e3d8cbf992$export$cb6981b8f9a703c2 = {}));
var $5af132e3d8cbf992$export$ecba565262f8bb2 = function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(ResourceNotFoundException, _super);
    function ResourceNotFoundException(opts) {
        var _this = _super.call(this, (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
            name: "ResourceNotFoundException",
            $fault: "client"
        }, opts)) || this;
        _this.name = "ResourceNotFoundException";
        _this.$fault = "client";
        Object.setPrototypeOf(_this, ResourceNotFoundException.prototype);
        return _this;
    }
    return ResourceNotFoundException;
}((0, $4ea34e10cf9d5301$export$b83d40bae15eaefa));
var $5af132e3d8cbf992$export$46587acc7855d6e2;
(function(DescribeIdentityInput) {
    DescribeIdentityInput.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($5af132e3d8cbf992$export$46587acc7855d6e2 || ($5af132e3d8cbf992$export$46587acc7855d6e2 = {}));
var $5af132e3d8cbf992$export$16e1ea20d4f13fa7;
(function(IdentityDescription) {
    IdentityDescription.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($5af132e3d8cbf992$export$16e1ea20d4f13fa7 || ($5af132e3d8cbf992$export$16e1ea20d4f13fa7 = {}));
var $5af132e3d8cbf992$export$4b5909fe2abc147d;
(function(DescribeIdentityPoolInput) {
    DescribeIdentityPoolInput.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($5af132e3d8cbf992$export$4b5909fe2abc147d || ($5af132e3d8cbf992$export$4b5909fe2abc147d = {}));
var $5af132e3d8cbf992$export$cb77a58cb7dbb17 = function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(ExternalServiceException, _super);
    function ExternalServiceException(opts) {
        var _this = _super.call(this, (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
            name: "ExternalServiceException",
            $fault: "client"
        }, opts)) || this;
        _this.name = "ExternalServiceException";
        _this.$fault = "client";
        Object.setPrototypeOf(_this, ExternalServiceException.prototype);
        return _this;
    }
    return ExternalServiceException;
}((0, $4ea34e10cf9d5301$export$b83d40bae15eaefa));
var $5af132e3d8cbf992$export$bb51e43959182308;
(function(GetCredentialsForIdentityInput) {
    GetCredentialsForIdentityInput.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($5af132e3d8cbf992$export$bb51e43959182308 || ($5af132e3d8cbf992$export$bb51e43959182308 = {}));
var $5af132e3d8cbf992$export$a9627919734faa48;
(function(Credentials) {
    Credentials.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($5af132e3d8cbf992$export$a9627919734faa48 || ($5af132e3d8cbf992$export$a9627919734faa48 = {}));
var $5af132e3d8cbf992$export$ba56c4cb277a72f9;
(function(GetCredentialsForIdentityResponse) {
    GetCredentialsForIdentityResponse.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($5af132e3d8cbf992$export$ba56c4cb277a72f9 || ($5af132e3d8cbf992$export$ba56c4cb277a72f9 = {}));
var $5af132e3d8cbf992$export$90d12448d3766cda = function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(InvalidIdentityPoolConfigurationException, _super);
    function InvalidIdentityPoolConfigurationException(opts) {
        var _this = _super.call(this, (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
            name: "InvalidIdentityPoolConfigurationException",
            $fault: "client"
        }, opts)) || this;
        _this.name = "InvalidIdentityPoolConfigurationException";
        _this.$fault = "client";
        Object.setPrototypeOf(_this, InvalidIdentityPoolConfigurationException.prototype);
        return _this;
    }
    return InvalidIdentityPoolConfigurationException;
}((0, $4ea34e10cf9d5301$export$b83d40bae15eaefa));
var $5af132e3d8cbf992$export$badc3094716a9faa;
(function(GetIdInput) {
    GetIdInput.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($5af132e3d8cbf992$export$badc3094716a9faa || ($5af132e3d8cbf992$export$badc3094716a9faa = {}));
var $5af132e3d8cbf992$export$c3ec238968a6e7ac;
(function(GetIdResponse) {
    GetIdResponse.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($5af132e3d8cbf992$export$c3ec238968a6e7ac || ($5af132e3d8cbf992$export$c3ec238968a6e7ac = {}));
var $5af132e3d8cbf992$export$f5f529c0b4e5eb30;
(function(GetIdentityPoolRolesInput) {
    GetIdentityPoolRolesInput.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($5af132e3d8cbf992$export$f5f529c0b4e5eb30 || ($5af132e3d8cbf992$export$f5f529c0b4e5eb30 = {}));
var $5af132e3d8cbf992$export$819b5ceb37e06be;
(function(MappingRuleMatchType) {
    MappingRuleMatchType["CONTAINS"] = "Contains";
    MappingRuleMatchType["EQUALS"] = "Equals";
    MappingRuleMatchType["NOT_EQUAL"] = "NotEqual";
    MappingRuleMatchType["STARTS_WITH"] = "StartsWith";
})($5af132e3d8cbf992$export$819b5ceb37e06be || ($5af132e3d8cbf992$export$819b5ceb37e06be = {}));
var $5af132e3d8cbf992$export$3f8398961535c3a;
(function(MappingRule) {
    MappingRule.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($5af132e3d8cbf992$export$3f8398961535c3a || ($5af132e3d8cbf992$export$3f8398961535c3a = {}));
var $5af132e3d8cbf992$export$269dcf2519324984;
(function(RulesConfigurationType) {
    RulesConfigurationType.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($5af132e3d8cbf992$export$269dcf2519324984 || ($5af132e3d8cbf992$export$269dcf2519324984 = {}));
var $5af132e3d8cbf992$export$c726ef784882c23e;
(function(RoleMappingType) {
    RoleMappingType["RULES"] = "Rules";
    RoleMappingType["TOKEN"] = "Token";
})($5af132e3d8cbf992$export$c726ef784882c23e || ($5af132e3d8cbf992$export$c726ef784882c23e = {}));
var $5af132e3d8cbf992$export$c8be61b857de8364;
(function(RoleMapping) {
    RoleMapping.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($5af132e3d8cbf992$export$c8be61b857de8364 || ($5af132e3d8cbf992$export$c8be61b857de8364 = {}));
var $5af132e3d8cbf992$export$69a6cbc1a215fcdf;
(function(GetIdentityPoolRolesResponse) {
    GetIdentityPoolRolesResponse.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($5af132e3d8cbf992$export$69a6cbc1a215fcdf || ($5af132e3d8cbf992$export$69a6cbc1a215fcdf = {}));
var $5af132e3d8cbf992$export$e31993063e9290fd;
(function(GetOpenIdTokenInput) {
    GetOpenIdTokenInput.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($5af132e3d8cbf992$export$e31993063e9290fd || ($5af132e3d8cbf992$export$e31993063e9290fd = {}));
var $5af132e3d8cbf992$export$c2cdb3ad9240cf7d;
(function(GetOpenIdTokenResponse) {
    GetOpenIdTokenResponse.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($5af132e3d8cbf992$export$c2cdb3ad9240cf7d || ($5af132e3d8cbf992$export$c2cdb3ad9240cf7d = {}));
var $5af132e3d8cbf992$export$f9e8c5d2069aeea4 = function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(DeveloperUserAlreadyRegisteredException, _super);
    function DeveloperUserAlreadyRegisteredException(opts) {
        var _this = _super.call(this, (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
            name: "DeveloperUserAlreadyRegisteredException",
            $fault: "client"
        }, opts)) || this;
        _this.name = "DeveloperUserAlreadyRegisteredException";
        _this.$fault = "client";
        Object.setPrototypeOf(_this, DeveloperUserAlreadyRegisteredException.prototype);
        return _this;
    }
    return DeveloperUserAlreadyRegisteredException;
}((0, $4ea34e10cf9d5301$export$b83d40bae15eaefa));
var $5af132e3d8cbf992$export$b30c26022c4ccb98;
(function(GetOpenIdTokenForDeveloperIdentityInput) {
    GetOpenIdTokenForDeveloperIdentityInput.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($5af132e3d8cbf992$export$b30c26022c4ccb98 || ($5af132e3d8cbf992$export$b30c26022c4ccb98 = {}));
var $5af132e3d8cbf992$export$39b050249a579e7b;
(function(GetOpenIdTokenForDeveloperIdentityResponse) {
    GetOpenIdTokenForDeveloperIdentityResponse.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($5af132e3d8cbf992$export$39b050249a579e7b || ($5af132e3d8cbf992$export$39b050249a579e7b = {}));
var $5af132e3d8cbf992$export$383be1d45875ef03;
(function(GetPrincipalTagAttributeMapInput) {
    GetPrincipalTagAttributeMapInput.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($5af132e3d8cbf992$export$383be1d45875ef03 || ($5af132e3d8cbf992$export$383be1d45875ef03 = {}));
var $5af132e3d8cbf992$export$321f5c98d4a1e314;
(function(GetPrincipalTagAttributeMapResponse) {
    GetPrincipalTagAttributeMapResponse.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($5af132e3d8cbf992$export$321f5c98d4a1e314 || ($5af132e3d8cbf992$export$321f5c98d4a1e314 = {}));
var $5af132e3d8cbf992$export$8c1e5f4b8dc33aa1;
(function(ListIdentitiesInput) {
    ListIdentitiesInput.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($5af132e3d8cbf992$export$8c1e5f4b8dc33aa1 || ($5af132e3d8cbf992$export$8c1e5f4b8dc33aa1 = {}));
var $5af132e3d8cbf992$export$5270c3e17502575a;
(function(ListIdentitiesResponse) {
    ListIdentitiesResponse.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($5af132e3d8cbf992$export$5270c3e17502575a || ($5af132e3d8cbf992$export$5270c3e17502575a = {}));
var $5af132e3d8cbf992$export$1d38161f8b62ad;
(function(ListIdentityPoolsInput) {
    ListIdentityPoolsInput.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($5af132e3d8cbf992$export$1d38161f8b62ad || ($5af132e3d8cbf992$export$1d38161f8b62ad = {}));
var $5af132e3d8cbf992$export$5a7a0c97755dcf8e;
(function(IdentityPoolShortDescription) {
    IdentityPoolShortDescription.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($5af132e3d8cbf992$export$5a7a0c97755dcf8e || ($5af132e3d8cbf992$export$5a7a0c97755dcf8e = {}));
var $5af132e3d8cbf992$export$f862a07a4a7c6250;
(function(ListIdentityPoolsResponse) {
    ListIdentityPoolsResponse.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($5af132e3d8cbf992$export$f862a07a4a7c6250 || ($5af132e3d8cbf992$export$f862a07a4a7c6250 = {}));
var $5af132e3d8cbf992$export$8eb1e3f42ea35fee;
(function(ListTagsForResourceInput) {
    ListTagsForResourceInput.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($5af132e3d8cbf992$export$8eb1e3f42ea35fee || ($5af132e3d8cbf992$export$8eb1e3f42ea35fee = {}));
var $5af132e3d8cbf992$export$6db0c8c0f26e7fec;
(function(ListTagsForResourceResponse) {
    ListTagsForResourceResponse.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($5af132e3d8cbf992$export$6db0c8c0f26e7fec || ($5af132e3d8cbf992$export$6db0c8c0f26e7fec = {}));
var $5af132e3d8cbf992$export$1624698866821668;
(function(LookupDeveloperIdentityInput) {
    LookupDeveloperIdentityInput.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($5af132e3d8cbf992$export$1624698866821668 || ($5af132e3d8cbf992$export$1624698866821668 = {}));
var $5af132e3d8cbf992$export$fb0cf3531245501b;
(function(LookupDeveloperIdentityResponse) {
    LookupDeveloperIdentityResponse.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($5af132e3d8cbf992$export$fb0cf3531245501b || ($5af132e3d8cbf992$export$fb0cf3531245501b = {}));
var $5af132e3d8cbf992$export$8f282934b0cfbc4a;
(function(MergeDeveloperIdentitiesInput) {
    MergeDeveloperIdentitiesInput.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($5af132e3d8cbf992$export$8f282934b0cfbc4a || ($5af132e3d8cbf992$export$8f282934b0cfbc4a = {}));
var $5af132e3d8cbf992$export$13aa23992eef667b;
(function(MergeDeveloperIdentitiesResponse) {
    MergeDeveloperIdentitiesResponse.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($5af132e3d8cbf992$export$13aa23992eef667b || ($5af132e3d8cbf992$export$13aa23992eef667b = {}));
var $5af132e3d8cbf992$export$21f15e80c2bbca09 = function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(ConcurrentModificationException, _super);
    function ConcurrentModificationException(opts) {
        var _this = _super.call(this, (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
            name: "ConcurrentModificationException",
            $fault: "client"
        }, opts)) || this;
        _this.name = "ConcurrentModificationException";
        _this.$fault = "client";
        Object.setPrototypeOf(_this, ConcurrentModificationException.prototype);
        return _this;
    }
    return ConcurrentModificationException;
}((0, $4ea34e10cf9d5301$export$b83d40bae15eaefa));
var $5af132e3d8cbf992$export$20f43a93eb8d3b02;
(function(SetIdentityPoolRolesInput) {
    SetIdentityPoolRolesInput.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($5af132e3d8cbf992$export$20f43a93eb8d3b02 || ($5af132e3d8cbf992$export$20f43a93eb8d3b02 = {}));
var $5af132e3d8cbf992$export$c3ad366bdbcd115e;
(function(SetPrincipalTagAttributeMapInput) {
    SetPrincipalTagAttributeMapInput.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($5af132e3d8cbf992$export$c3ad366bdbcd115e || ($5af132e3d8cbf992$export$c3ad366bdbcd115e = {}));
var $5af132e3d8cbf992$export$2db9cf06e527cce8;
(function(SetPrincipalTagAttributeMapResponse) {
    SetPrincipalTagAttributeMapResponse.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($5af132e3d8cbf992$export$2db9cf06e527cce8 || ($5af132e3d8cbf992$export$2db9cf06e527cce8 = {}));
var $5af132e3d8cbf992$export$a5e7dff780e8dcb0;
(function(TagResourceInput) {
    TagResourceInput.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($5af132e3d8cbf992$export$a5e7dff780e8dcb0 || ($5af132e3d8cbf992$export$a5e7dff780e8dcb0 = {}));
var $5af132e3d8cbf992$export$2d5279802486e8b0;
(function(TagResourceResponse) {
    TagResourceResponse.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($5af132e3d8cbf992$export$2d5279802486e8b0 || ($5af132e3d8cbf992$export$2d5279802486e8b0 = {}));
var $5af132e3d8cbf992$export$b977eb1c8f754bfa;
(function(UnlinkDeveloperIdentityInput) {
    UnlinkDeveloperIdentityInput.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($5af132e3d8cbf992$export$b977eb1c8f754bfa || ($5af132e3d8cbf992$export$b977eb1c8f754bfa = {}));
var $5af132e3d8cbf992$export$2415026a66f5e70b;
(function(UnlinkIdentityInput) {
    UnlinkIdentityInput.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($5af132e3d8cbf992$export$2415026a66f5e70b || ($5af132e3d8cbf992$export$2415026a66f5e70b = {}));
var $5af132e3d8cbf992$export$4dbbd8ede80c9c36;
(function(UntagResourceInput) {
    UntagResourceInput.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($5af132e3d8cbf992$export$4dbbd8ede80c9c36 || ($5af132e3d8cbf992$export$4dbbd8ede80c9c36 = {}));
var $5af132e3d8cbf992$export$2128f49a7cd2e47f;
(function(UntagResourceResponse) {
    UntagResourceResponse.filterSensitiveLog = function(obj) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, obj);
    };
})($5af132e3d8cbf992$export$2128f49a7cd2e47f || ($5af132e3d8cbf992$export$2128f49a7cd2e47f = {}));







var $cfad410b8d5507c4$export$44d8caf684388429 = function(input, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "AWSCognitoIdentityService.CreateIdentityPool"
            };
            body = JSON.stringify($cfad410b8d5507c4$var$serializeAws_json1_1CreateIdentityPoolInput(input, context));
            return [
                2,
                $cfad410b8d5507c4$var$buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var $cfad410b8d5507c4$export$2f9133f6d812a2b4 = function(input, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "AWSCognitoIdentityService.DeleteIdentities"
            };
            body = JSON.stringify($cfad410b8d5507c4$var$serializeAws_json1_1DeleteIdentitiesInput(input, context));
            return [
                2,
                $cfad410b8d5507c4$var$buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var $cfad410b8d5507c4$export$900e66311faca63a = function(input, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "AWSCognitoIdentityService.DeleteIdentityPool"
            };
            body = JSON.stringify($cfad410b8d5507c4$var$serializeAws_json1_1DeleteIdentityPoolInput(input, context));
            return [
                2,
                $cfad410b8d5507c4$var$buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var $cfad410b8d5507c4$export$f0f695bb22170112 = function(input, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "AWSCognitoIdentityService.DescribeIdentity"
            };
            body = JSON.stringify($cfad410b8d5507c4$var$serializeAws_json1_1DescribeIdentityInput(input, context));
            return [
                2,
                $cfad410b8d5507c4$var$buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var $cfad410b8d5507c4$export$24669e6016ff61f7 = function(input, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "AWSCognitoIdentityService.DescribeIdentityPool"
            };
            body = JSON.stringify($cfad410b8d5507c4$var$serializeAws_json1_1DescribeIdentityPoolInput(input, context));
            return [
                2,
                $cfad410b8d5507c4$var$buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var $cfad410b8d5507c4$export$88af91ae17f8527c = function(input, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "AWSCognitoIdentityService.GetCredentialsForIdentity"
            };
            body = JSON.stringify($cfad410b8d5507c4$var$serializeAws_json1_1GetCredentialsForIdentityInput(input, context));
            return [
                2,
                $cfad410b8d5507c4$var$buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var $cfad410b8d5507c4$export$83083ba13837129b = function(input, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "AWSCognitoIdentityService.GetId"
            };
            body = JSON.stringify($cfad410b8d5507c4$var$serializeAws_json1_1GetIdInput(input, context));
            return [
                2,
                $cfad410b8d5507c4$var$buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var $cfad410b8d5507c4$export$291166950901964 = function(input, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "AWSCognitoIdentityService.GetIdentityPoolRoles"
            };
            body = JSON.stringify($cfad410b8d5507c4$var$serializeAws_json1_1GetIdentityPoolRolesInput(input, context));
            return [
                2,
                $cfad410b8d5507c4$var$buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var $cfad410b8d5507c4$export$32ecbc22cb6e2bd8 = function(input, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "AWSCognitoIdentityService.GetOpenIdToken"
            };
            body = JSON.stringify($cfad410b8d5507c4$var$serializeAws_json1_1GetOpenIdTokenInput(input, context));
            return [
                2,
                $cfad410b8d5507c4$var$buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var $cfad410b8d5507c4$export$ace1f9f6edceb0aa = function(input, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "AWSCognitoIdentityService.GetOpenIdTokenForDeveloperIdentity"
            };
            body = JSON.stringify($cfad410b8d5507c4$var$serializeAws_json1_1GetOpenIdTokenForDeveloperIdentityInput(input, context));
            return [
                2,
                $cfad410b8d5507c4$var$buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var $cfad410b8d5507c4$export$ab7f44541dfa215 = function(input, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "AWSCognitoIdentityService.GetPrincipalTagAttributeMap"
            };
            body = JSON.stringify($cfad410b8d5507c4$var$serializeAws_json1_1GetPrincipalTagAttributeMapInput(input, context));
            return [
                2,
                $cfad410b8d5507c4$var$buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var $cfad410b8d5507c4$export$dcc2b10f333c963c = function(input, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "AWSCognitoIdentityService.ListIdentities"
            };
            body = JSON.stringify($cfad410b8d5507c4$var$serializeAws_json1_1ListIdentitiesInput(input, context));
            return [
                2,
                $cfad410b8d5507c4$var$buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var $cfad410b8d5507c4$export$dfc0836148ba7f7b = function(input, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "AWSCognitoIdentityService.ListIdentityPools"
            };
            body = JSON.stringify($cfad410b8d5507c4$var$serializeAws_json1_1ListIdentityPoolsInput(input, context));
            return [
                2,
                $cfad410b8d5507c4$var$buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var $cfad410b8d5507c4$export$aea8c8426f72de9a = function(input, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "AWSCognitoIdentityService.ListTagsForResource"
            };
            body = JSON.stringify($cfad410b8d5507c4$var$serializeAws_json1_1ListTagsForResourceInput(input, context));
            return [
                2,
                $cfad410b8d5507c4$var$buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var $cfad410b8d5507c4$export$3ddf979554ffe001 = function(input, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "AWSCognitoIdentityService.LookupDeveloperIdentity"
            };
            body = JSON.stringify($cfad410b8d5507c4$var$serializeAws_json1_1LookupDeveloperIdentityInput(input, context));
            return [
                2,
                $cfad410b8d5507c4$var$buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var $cfad410b8d5507c4$export$5d3f7522269fe239 = function(input, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "AWSCognitoIdentityService.MergeDeveloperIdentities"
            };
            body = JSON.stringify($cfad410b8d5507c4$var$serializeAws_json1_1MergeDeveloperIdentitiesInput(input, context));
            return [
                2,
                $cfad410b8d5507c4$var$buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var $cfad410b8d5507c4$export$50298d3eb327ab40 = function(input, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "AWSCognitoIdentityService.SetIdentityPoolRoles"
            };
            body = JSON.stringify($cfad410b8d5507c4$var$serializeAws_json1_1SetIdentityPoolRolesInput(input, context));
            return [
                2,
                $cfad410b8d5507c4$var$buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var $cfad410b8d5507c4$export$294e7f3f8238d3d3 = function(input, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "AWSCognitoIdentityService.SetPrincipalTagAttributeMap"
            };
            body = JSON.stringify($cfad410b8d5507c4$var$serializeAws_json1_1SetPrincipalTagAttributeMapInput(input, context));
            return [
                2,
                $cfad410b8d5507c4$var$buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var $cfad410b8d5507c4$export$be03555111349623 = function(input, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "AWSCognitoIdentityService.TagResource"
            };
            body = JSON.stringify($cfad410b8d5507c4$var$serializeAws_json1_1TagResourceInput(input, context));
            return [
                2,
                $cfad410b8d5507c4$var$buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var $cfad410b8d5507c4$export$43e326e2b54f124a = function(input, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "AWSCognitoIdentityService.UnlinkDeveloperIdentity"
            };
            body = JSON.stringify($cfad410b8d5507c4$var$serializeAws_json1_1UnlinkDeveloperIdentityInput(input, context));
            return [
                2,
                $cfad410b8d5507c4$var$buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var $cfad410b8d5507c4$export$4ee03f1a7a9d5800 = function(input, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "AWSCognitoIdentityService.UnlinkIdentity"
            };
            body = JSON.stringify($cfad410b8d5507c4$var$serializeAws_json1_1UnlinkIdentityInput(input, context));
            return [
                2,
                $cfad410b8d5507c4$var$buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var $cfad410b8d5507c4$export$3f5f89d1d8515037 = function(input, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "AWSCognitoIdentityService.UntagResource"
            };
            body = JSON.stringify($cfad410b8d5507c4$var$serializeAws_json1_1UntagResourceInput(input, context));
            return [
                2,
                $cfad410b8d5507c4$var$buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var $cfad410b8d5507c4$export$7a962066e209647 = function(input, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "AWSCognitoIdentityService.UpdateIdentityPool"
            };
            body = JSON.stringify($cfad410b8d5507c4$var$serializeAws_json1_1IdentityPool(input, context));
            return [
                2,
                $cfad410b8d5507c4$var$buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var $cfad410b8d5507c4$export$2065e670c73ee068 = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2,
                        $cfad410b8d5507c4$var$deserializeAws_json1_1CreateIdentityPoolCommandError(output, context)
                    ];
                    return [
                        4,
                        $cfad410b8d5507c4$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = $cfad410b8d5507c4$var$deserializeAws_json1_1IdentityPool(data, context);
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
                        $metadata: $cfad410b8d5507c4$var$deserializeMetadata(output)
                    }, contents);
                    return [
                        2,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var $cfad410b8d5507c4$var$deserializeAws_json1_1CreateIdentityPoolCommandError = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, parsedBody;
        var _c;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_d) {
            switch(_d.label){
                case 0:
                    _a = [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, output)
                    ];
                    _c = {};
                    return [
                        4,
                        $cfad410b8d5507c4$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_c.body = _d.sent(), _c)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $cfad410b8d5507c4$var$loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InternalErrorException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.cognitoidentity#InternalErrorException":
                            return [
                                3,
                                2
                            ];
                        case "InvalidParameterException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.cognitoidentity#InvalidParameterException":
                            return [
                                3,
                                4
                            ];
                        case "LimitExceededException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.cognitoidentity#LimitExceededException":
                            return [
                                3,
                                6
                            ];
                        case "NotAuthorizedException":
                            return [
                                3,
                                8
                            ];
                        case "com.amazonaws.cognitoidentity#NotAuthorizedException":
                            return [
                                3,
                                8
                            ];
                        case "ResourceConflictException":
                            return [
                                3,
                                10
                            ];
                        case "com.amazonaws.cognitoidentity#ResourceConflictException":
                            return [
                                3,
                                10
                            ];
                        case "TooManyRequestsException":
                            return [
                                3,
                                12
                            ];
                        case "com.amazonaws.cognitoidentity#TooManyRequestsException":
                            return [
                                3,
                                12
                            ];
                    }
                    return [
                        3,
                        14
                    ];
                case 2:
                    return [
                        4,
                        $cfad410b8d5507c4$var$deserializeAws_json1_1InternalErrorExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    throw _d.sent();
                case 4:
                    return [
                        4,
                        $cfad410b8d5507c4$var$deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    throw _d.sent();
                case 6:
                    return [
                        4,
                        $cfad410b8d5507c4$var$deserializeAws_json1_1LimitExceededExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    throw _d.sent();
                case 8:
                    return [
                        4,
                        $cfad410b8d5507c4$var$deserializeAws_json1_1NotAuthorizedExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    throw _d.sent();
                case 10:
                    return [
                        4,
                        $cfad410b8d5507c4$var$deserializeAws_json1_1ResourceConflictExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    throw _d.sent();
                case 12:
                    return [
                        4,
                        $cfad410b8d5507c4$var$deserializeAws_json1_1TooManyRequestsExceptionResponse(parsedOutput, context)
                    ];
                case 13:
                    throw _d.sent();
                case 14:
                    parsedBody = parsedOutput.body;
                    response = new (0, $4ea34e10cf9d5301$export$b83d40bae15eaefa)({
                        name: parsedBody.code || parsedBody.Code || errorCode,
                        $fault: "client",
                        $metadata: $cfad410b8d5507c4$var$deserializeMetadata(output)
                    });
                    throw (0, $a08c2c31e27e9e11$export$db01f0c43e877a50)(response, parsedBody);
            }
        });
    });
};
var $cfad410b8d5507c4$export$a14663734e0f26e7 = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2,
                        $cfad410b8d5507c4$var$deserializeAws_json1_1DeleteIdentitiesCommandError(output, context)
                    ];
                    return [
                        4,
                        $cfad410b8d5507c4$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = $cfad410b8d5507c4$var$deserializeAws_json1_1DeleteIdentitiesResponse(data, context);
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
                        $metadata: $cfad410b8d5507c4$var$deserializeMetadata(output)
                    }, contents);
                    return [
                        2,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var $cfad410b8d5507c4$var$deserializeAws_json1_1DeleteIdentitiesCommandError = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, parsedBody;
        var _c;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_d) {
            switch(_d.label){
                case 0:
                    _a = [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, output)
                    ];
                    _c = {};
                    return [
                        4,
                        $cfad410b8d5507c4$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_c.body = _d.sent(), _c)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $cfad410b8d5507c4$var$loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InternalErrorException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.cognitoidentity#InternalErrorException":
                            return [
                                3,
                                2
                            ];
                        case "InvalidParameterException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.cognitoidentity#InvalidParameterException":
                            return [
                                3,
                                4
                            ];
                        case "TooManyRequestsException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.cognitoidentity#TooManyRequestsException":
                            return [
                                3,
                                6
                            ];
                    }
                    return [
                        3,
                        8
                    ];
                case 2:
                    return [
                        4,
                        $cfad410b8d5507c4$var$deserializeAws_json1_1InternalErrorExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    throw _d.sent();
                case 4:
                    return [
                        4,
                        $cfad410b8d5507c4$var$deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    throw _d.sent();
                case 6:
                    return [
                        4,
                        $cfad410b8d5507c4$var$deserializeAws_json1_1TooManyRequestsExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    throw _d.sent();
                case 8:
                    parsedBody = parsedOutput.body;
                    response = new (0, $4ea34e10cf9d5301$export$b83d40bae15eaefa)({
                        name: parsedBody.code || parsedBody.Code || errorCode,
                        $fault: "client",
                        $metadata: $cfad410b8d5507c4$var$deserializeMetadata(output)
                    });
                    throw (0, $a08c2c31e27e9e11$export$db01f0c43e877a50)(response, parsedBody);
            }
        });
    });
};
var $cfad410b8d5507c4$export$77baf36526f7cd7e = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var response;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2,
                        $cfad410b8d5507c4$var$deserializeAws_json1_1DeleteIdentityPoolCommandError(output, context)
                    ];
                    return [
                        4,
                        $cfad410b8d5507c4$var$collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    response = {
                        $metadata: $cfad410b8d5507c4$var$deserializeMetadata(output)
                    };
                    return [
                        2,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var $cfad410b8d5507c4$var$deserializeAws_json1_1DeleteIdentityPoolCommandError = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, parsedBody;
        var _c;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_d) {
            switch(_d.label){
                case 0:
                    _a = [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, output)
                    ];
                    _c = {};
                    return [
                        4,
                        $cfad410b8d5507c4$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_c.body = _d.sent(), _c)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $cfad410b8d5507c4$var$loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InternalErrorException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.cognitoidentity#InternalErrorException":
                            return [
                                3,
                                2
                            ];
                        case "InvalidParameterException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.cognitoidentity#InvalidParameterException":
                            return [
                                3,
                                4
                            ];
                        case "NotAuthorizedException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.cognitoidentity#NotAuthorizedException":
                            return [
                                3,
                                6
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3,
                                8
                            ];
                        case "com.amazonaws.cognitoidentity#ResourceNotFoundException":
                            return [
                                3,
                                8
                            ];
                        case "TooManyRequestsException":
                            return [
                                3,
                                10
                            ];
                        case "com.amazonaws.cognitoidentity#TooManyRequestsException":
                            return [
                                3,
                                10
                            ];
                    }
                    return [
                        3,
                        12
                    ];
                case 2:
                    return [
                        4,
                        $cfad410b8d5507c4$var$deserializeAws_json1_1InternalErrorExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    throw _d.sent();
                case 4:
                    return [
                        4,
                        $cfad410b8d5507c4$var$deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    throw _d.sent();
                case 6:
                    return [
                        4,
                        $cfad410b8d5507c4$var$deserializeAws_json1_1NotAuthorizedExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    throw _d.sent();
                case 8:
                    return [
                        4,
                        $cfad410b8d5507c4$var$deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    throw _d.sent();
                case 10:
                    return [
                        4,
                        $cfad410b8d5507c4$var$deserializeAws_json1_1TooManyRequestsExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    throw _d.sent();
                case 12:
                    parsedBody = parsedOutput.body;
                    response = new (0, $4ea34e10cf9d5301$export$b83d40bae15eaefa)({
                        name: parsedBody.code || parsedBody.Code || errorCode,
                        $fault: "client",
                        $metadata: $cfad410b8d5507c4$var$deserializeMetadata(output)
                    });
                    throw (0, $a08c2c31e27e9e11$export$db01f0c43e877a50)(response, parsedBody);
            }
        });
    });
};
var $cfad410b8d5507c4$export$1863cd4cff27fb2f = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2,
                        $cfad410b8d5507c4$var$deserializeAws_json1_1DescribeIdentityCommandError(output, context)
                    ];
                    return [
                        4,
                        $cfad410b8d5507c4$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = $cfad410b8d5507c4$var$deserializeAws_json1_1IdentityDescription(data, context);
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
                        $metadata: $cfad410b8d5507c4$var$deserializeMetadata(output)
                    }, contents);
                    return [
                        2,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var $cfad410b8d5507c4$var$deserializeAws_json1_1DescribeIdentityCommandError = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, parsedBody;
        var _c;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_d) {
            switch(_d.label){
                case 0:
                    _a = [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, output)
                    ];
                    _c = {};
                    return [
                        4,
                        $cfad410b8d5507c4$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_c.body = _d.sent(), _c)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $cfad410b8d5507c4$var$loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InternalErrorException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.cognitoidentity#InternalErrorException":
                            return [
                                3,
                                2
                            ];
                        case "InvalidParameterException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.cognitoidentity#InvalidParameterException":
                            return [
                                3,
                                4
                            ];
                        case "NotAuthorizedException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.cognitoidentity#NotAuthorizedException":
                            return [
                                3,
                                6
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3,
                                8
                            ];
                        case "com.amazonaws.cognitoidentity#ResourceNotFoundException":
                            return [
                                3,
                                8
                            ];
                        case "TooManyRequestsException":
                            return [
                                3,
                                10
                            ];
                        case "com.amazonaws.cognitoidentity#TooManyRequestsException":
                            return [
                                3,
                                10
                            ];
                    }
                    return [
                        3,
                        12
                    ];
                case 2:
                    return [
                        4,
                        $cfad410b8d5507c4$var$deserializeAws_json1_1InternalErrorExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    throw _d.sent();
                case 4:
                    return [
                        4,
                        $cfad410b8d5507c4$var$deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    throw _d.sent();
                case 6:
                    return [
                        4,
                        $cfad410b8d5507c4$var$deserializeAws_json1_1NotAuthorizedExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    throw _d.sent();
                case 8:
                    return [
                        4,
                        $cfad410b8d5507c4$var$deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    throw _d.sent();
                case 10:
                    return [
                        4,
                        $cfad410b8d5507c4$var$deserializeAws_json1_1TooManyRequestsExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    throw _d.sent();
                case 12:
                    parsedBody = parsedOutput.body;
                    response = new (0, $4ea34e10cf9d5301$export$b83d40bae15eaefa)({
                        name: parsedBody.code || parsedBody.Code || errorCode,
                        $fault: "client",
                        $metadata: $cfad410b8d5507c4$var$deserializeMetadata(output)
                    });
                    throw (0, $a08c2c31e27e9e11$export$db01f0c43e877a50)(response, parsedBody);
            }
        });
    });
};
var $cfad410b8d5507c4$export$1457f79b69c648d1 = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2,
                        $cfad410b8d5507c4$var$deserializeAws_json1_1DescribeIdentityPoolCommandError(output, context)
                    ];
                    return [
                        4,
                        $cfad410b8d5507c4$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = $cfad410b8d5507c4$var$deserializeAws_json1_1IdentityPool(data, context);
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
                        $metadata: $cfad410b8d5507c4$var$deserializeMetadata(output)
                    }, contents);
                    return [
                        2,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var $cfad410b8d5507c4$var$deserializeAws_json1_1DescribeIdentityPoolCommandError = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, parsedBody;
        var _c;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_d) {
            switch(_d.label){
                case 0:
                    _a = [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, output)
                    ];
                    _c = {};
                    return [
                        4,
                        $cfad410b8d5507c4$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_c.body = _d.sent(), _c)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $cfad410b8d5507c4$var$loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InternalErrorException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.cognitoidentity#InternalErrorException":
                            return [
                                3,
                                2
                            ];
                        case "InvalidParameterException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.cognitoidentity#InvalidParameterException":
                            return [
                                3,
                                4
                            ];
                        case "NotAuthorizedException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.cognitoidentity#NotAuthorizedException":
                            return [
                                3,
                                6
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3,
                                8
                            ];
                        case "com.amazonaws.cognitoidentity#ResourceNotFoundException":
                            return [
                                3,
                                8
                            ];
                        case "TooManyRequestsException":
                            return [
                                3,
                                10
                            ];
                        case "com.amazonaws.cognitoidentity#TooManyRequestsException":
                            return [
                                3,
                                10
                            ];
                    }
                    return [
                        3,
                        12
                    ];
                case 2:
                    return [
                        4,
                        $cfad410b8d5507c4$var$deserializeAws_json1_1InternalErrorExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    throw _d.sent();
                case 4:
                    return [
                        4,
                        $cfad410b8d5507c4$var$deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    throw _d.sent();
                case 6:
                    return [
                        4,
                        $cfad410b8d5507c4$var$deserializeAws_json1_1NotAuthorizedExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    throw _d.sent();
                case 8:
                    return [
                        4,
                        $cfad410b8d5507c4$var$deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    throw _d.sent();
                case 10:
                    return [
                        4,
                        $cfad410b8d5507c4$var$deserializeAws_json1_1TooManyRequestsExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    throw _d.sent();
                case 12:
                    parsedBody = parsedOutput.body;
                    response = new (0, $4ea34e10cf9d5301$export$b83d40bae15eaefa)({
                        name: parsedBody.code || parsedBody.Code || errorCode,
                        $fault: "client",
                        $metadata: $cfad410b8d5507c4$var$deserializeMetadata(output)
                    });
                    throw (0, $a08c2c31e27e9e11$export$db01f0c43e877a50)(response, parsedBody);
            }
        });
    });
};
var $cfad410b8d5507c4$export$ebea9103431f9a50 = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2,
                        $cfad410b8d5507c4$var$deserializeAws_json1_1GetCredentialsForIdentityCommandError(output, context)
                    ];
                    return [
                        4,
                        $cfad410b8d5507c4$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = $cfad410b8d5507c4$var$deserializeAws_json1_1GetCredentialsForIdentityResponse(data, context);
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
                        $metadata: $cfad410b8d5507c4$var$deserializeMetadata(output)
                    }, contents);
                    return [
                        2,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var $cfad410b8d5507c4$var$deserializeAws_json1_1GetCredentialsForIdentityCommandError = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, parsedBody;
        var _c;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_d) {
            switch(_d.label){
                case 0:
                    _a = [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, output)
                    ];
                    _c = {};
                    return [
                        4,
                        $cfad410b8d5507c4$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_c.body = _d.sent(), _c)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $cfad410b8d5507c4$var$loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "ExternalServiceException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.cognitoidentity#ExternalServiceException":
                            return [
                                3,
                                2
                            ];
                        case "InternalErrorException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.cognitoidentity#InternalErrorException":
                            return [
                                3,
                                4
                            ];
                        case "InvalidIdentityPoolConfigurationException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.cognitoidentity#InvalidIdentityPoolConfigurationException":
                            return [
                                3,
                                6
                            ];
                        case "InvalidParameterException":
                            return [
                                3,
                                8
                            ];
                        case "com.amazonaws.cognitoidentity#InvalidParameterException":
                            return [
                                3,
                                8
                            ];
                        case "NotAuthorizedException":
                            return [
                                3,
                                10
                            ];
                        case "com.amazonaws.cognitoidentity#NotAuthorizedException":
                            return [
                                3,
                                10
                            ];
                        case "ResourceConflictException":
                            return [
                                3,
                                12
                            ];
                        case "com.amazonaws.cognitoidentity#ResourceConflictException":
                            return [
                                3,
                                12
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3,
                                14
                            ];
                        case "com.amazonaws.cognitoidentity#ResourceNotFoundException":
                            return [
                                3,
                                14
                            ];
                        case "TooManyRequestsException":
                            return [
                                3,
                                16
                            ];
                        case "com.amazonaws.cognitoidentity#TooManyRequestsException":
                            return [
                                3,
                                16
                            ];
                    }
                    return [
                        3,
                        18
                    ];
                case 2:
                    return [
                        4,
                        $cfad410b8d5507c4$var$deserializeAws_json1_1ExternalServiceExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    throw _d.sent();
                case 4:
                    return [
                        4,
                        $cfad410b8d5507c4$var$deserializeAws_json1_1InternalErrorExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    throw _d.sent();
                case 6:
                    return [
                        4,
                        $cfad410b8d5507c4$var$deserializeAws_json1_1InvalidIdentityPoolConfigurationExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    throw _d.sent();
                case 8:
                    return [
                        4,
                        $cfad410b8d5507c4$var$deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    throw _d.sent();
                case 10:
                    return [
                        4,
                        $cfad410b8d5507c4$var$deserializeAws_json1_1NotAuthorizedExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    throw _d.sent();
                case 12:
                    return [
                        4,
                        $cfad410b8d5507c4$var$deserializeAws_json1_1ResourceConflictExceptionResponse(parsedOutput, context)
                    ];
                case 13:
                    throw _d.sent();
                case 14:
                    return [
                        4,
                        $cfad410b8d5507c4$var$deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 15:
                    throw _d.sent();
                case 16:
                    return [
                        4,
                        $cfad410b8d5507c4$var$deserializeAws_json1_1TooManyRequestsExceptionResponse(parsedOutput, context)
                    ];
                case 17:
                    throw _d.sent();
                case 18:
                    parsedBody = parsedOutput.body;
                    response = new (0, $4ea34e10cf9d5301$export$b83d40bae15eaefa)({
                        name: parsedBody.code || parsedBody.Code || errorCode,
                        $fault: "client",
                        $metadata: $cfad410b8d5507c4$var$deserializeMetadata(output)
                    });
                    throw (0, $a08c2c31e27e9e11$export$db01f0c43e877a50)(response, parsedBody);
            }
        });
    });
};
var $cfad410b8d5507c4$export$9f5769abdc93f0b4 = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2,
                        $cfad410b8d5507c4$var$deserializeAws_json1_1GetIdCommandError(output, context)
                    ];
                    return [
                        4,
                        $cfad410b8d5507c4$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = $cfad410b8d5507c4$var$deserializeAws_json1_1GetIdResponse(data, context);
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
                        $metadata: $cfad410b8d5507c4$var$deserializeMetadata(output)
                    }, contents);
                    return [
                        2,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var $cfad410b8d5507c4$var$deserializeAws_json1_1GetIdCommandError = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, parsedBody;
        var _c;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_d) {
            switch(_d.label){
                case 0:
                    _a = [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, output)
                    ];
                    _c = {};
                    return [
                        4,
                        $cfad410b8d5507c4$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_c.body = _d.sent(), _c)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $cfad410b8d5507c4$var$loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "ExternalServiceException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.cognitoidentity#ExternalServiceException":
                            return [
                                3,
                                2
                            ];
                        case "InternalErrorException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.cognitoidentity#InternalErrorException":
                            return [
                                3,
                                4
                            ];
                        case "InvalidParameterException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.cognitoidentity#InvalidParameterException":
                            return [
                                3,
                                6
                            ];
                        case "LimitExceededException":
                            return [
                                3,
                                8
                            ];
                        case "com.amazonaws.cognitoidentity#LimitExceededException":
                            return [
                                3,
                                8
                            ];
                        case "NotAuthorizedException":
                            return [
                                3,
                                10
                            ];
                        case "com.amazonaws.cognitoidentity#NotAuthorizedException":
                            return [
                                3,
                                10
                            ];
                        case "ResourceConflictException":
                            return [
                                3,
                                12
                            ];
                        case "com.amazonaws.cognitoidentity#ResourceConflictException":
                            return [
                                3,
                                12
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3,
                                14
                            ];
                        case "com.amazonaws.cognitoidentity#ResourceNotFoundException":
                            return [
                                3,
                                14
                            ];
                        case "TooManyRequestsException":
                            return [
                                3,
                                16
                            ];
                        case "com.amazonaws.cognitoidentity#TooManyRequestsException":
                            return [
                                3,
                                16
                            ];
                    }
                    return [
                        3,
                        18
                    ];
                case 2:
                    return [
                        4,
                        $cfad410b8d5507c4$var$deserializeAws_json1_1ExternalServiceExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    throw _d.sent();
                case 4:
                    return [
                        4,
                        $cfad410b8d5507c4$var$deserializeAws_json1_1InternalErrorExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    throw _d.sent();
                case 6:
                    return [
                        4,
                        $cfad410b8d5507c4$var$deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    throw _d.sent();
                case 8:
                    return [
                        4,
                        $cfad410b8d5507c4$var$deserializeAws_json1_1LimitExceededExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    throw _d.sent();
                case 10:
                    return [
                        4,
                        $cfad410b8d5507c4$var$deserializeAws_json1_1NotAuthorizedExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    throw _d.sent();
                case 12:
                    return [
                        4,
                        $cfad410b8d5507c4$var$deserializeAws_json1_1ResourceConflictExceptionResponse(parsedOutput, context)
                    ];
                case 13:
                    throw _d.sent();
                case 14:
                    return [
                        4,
                        $cfad410b8d5507c4$var$deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 15:
                    throw _d.sent();
                case 16:
                    return [
                        4,
                        $cfad410b8d5507c4$var$deserializeAws_json1_1TooManyRequestsExceptionResponse(parsedOutput, context)
                    ];
                case 17:
                    throw _d.sent();
                case 18:
                    parsedBody = parsedOutput.body;
                    response = new (0, $4ea34e10cf9d5301$export$b83d40bae15eaefa)({
                        name: parsedBody.code || parsedBody.Code || errorCode,
                        $fault: "client",
                        $metadata: $cfad410b8d5507c4$var$deserializeMetadata(output)
                    });
                    throw (0, $a08c2c31e27e9e11$export$db01f0c43e877a50)(response, parsedBody);
            }
        });
    });
};
var $cfad410b8d5507c4$export$731e618e28a38bab = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2,
                        $cfad410b8d5507c4$var$deserializeAws_json1_1GetIdentityPoolRolesCommandError(output, context)
                    ];
                    return [
                        4,
                        $cfad410b8d5507c4$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = $cfad410b8d5507c4$var$deserializeAws_json1_1GetIdentityPoolRolesResponse(data, context);
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
                        $metadata: $cfad410b8d5507c4$var$deserializeMetadata(output)
                    }, contents);
                    return [
                        2,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var $cfad410b8d5507c4$var$deserializeAws_json1_1GetIdentityPoolRolesCommandError = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, parsedBody;
        var _c;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_d) {
            switch(_d.label){
                case 0:
                    _a = [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, output)
                    ];
                    _c = {};
                    return [
                        4,
                        $cfad410b8d5507c4$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_c.body = _d.sent(), _c)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $cfad410b8d5507c4$var$loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InternalErrorException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.cognitoidentity#InternalErrorException":
                            return [
                                3,
                                2
                            ];
                        case "InvalidParameterException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.cognitoidentity#InvalidParameterException":
                            return [
                                3,
                                4
                            ];
                        case "NotAuthorizedException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.cognitoidentity#NotAuthorizedException":
                            return [
                                3,
                                6
                            ];
                        case "ResourceConflictException":
                            return [
                                3,
                                8
                            ];
                        case "com.amazonaws.cognitoidentity#ResourceConflictException":
                            return [
                                3,
                                8
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3,
                                10
                            ];
                        case "com.amazonaws.cognitoidentity#ResourceNotFoundException":
                            return [
                                3,
                                10
                            ];
                        case "TooManyRequestsException":
                            return [
                                3,
                                12
                            ];
                        case "com.amazonaws.cognitoidentity#TooManyRequestsException":
                            return [
                                3,
                                12
                            ];
                    }
                    return [
                        3,
                        14
                    ];
                case 2:
                    return [
                        4,
                        $cfad410b8d5507c4$var$deserializeAws_json1_1InternalErrorExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    throw _d.sent();
                case 4:
                    return [
                        4,
                        $cfad410b8d5507c4$var$deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    throw _d.sent();
                case 6:
                    return [
                        4,
                        $cfad410b8d5507c4$var$deserializeAws_json1_1NotAuthorizedExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    throw _d.sent();
                case 8:
                    return [
                        4,
                        $cfad410b8d5507c4$var$deserializeAws_json1_1ResourceConflictExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    throw _d.sent();
                case 10:
                    return [
                        4,
                        $cfad410b8d5507c4$var$deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    throw _d.sent();
                case 12:
                    return [
                        4,
                        $cfad410b8d5507c4$var$deserializeAws_json1_1TooManyRequestsExceptionResponse(parsedOutput, context)
                    ];
                case 13:
                    throw _d.sent();
                case 14:
                    parsedBody = parsedOutput.body;
                    response = new (0, $4ea34e10cf9d5301$export$b83d40bae15eaefa)({
                        name: parsedBody.code || parsedBody.Code || errorCode,
                        $fault: "client",
                        $metadata: $cfad410b8d5507c4$var$deserializeMetadata(output)
                    });
                    throw (0, $a08c2c31e27e9e11$export$db01f0c43e877a50)(response, parsedBody);
            }
        });
    });
};
var $cfad410b8d5507c4$export$ccfef68aa75a7c47 = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2,
                        $cfad410b8d5507c4$var$deserializeAws_json1_1GetOpenIdTokenCommandError(output, context)
                    ];
                    return [
                        4,
                        $cfad410b8d5507c4$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = $cfad410b8d5507c4$var$deserializeAws_json1_1GetOpenIdTokenResponse(data, context);
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
                        $metadata: $cfad410b8d5507c4$var$deserializeMetadata(output)
                    }, contents);
                    return [
                        2,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var $cfad410b8d5507c4$var$deserializeAws_json1_1GetOpenIdTokenCommandError = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, parsedBody;
        var _c;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_d) {
            switch(_d.label){
                case 0:
                    _a = [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, output)
                    ];
                    _c = {};
                    return [
                        4,
                        $cfad410b8d5507c4$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_c.body = _d.sent(), _c)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $cfad410b8d5507c4$var$loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "ExternalServiceException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.cognitoidentity#ExternalServiceException":
                            return [
                                3,
                                2
                            ];
                        case "InternalErrorException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.cognitoidentity#InternalErrorException":
                            return [
                                3,
                                4
                            ];
                        case "InvalidParameterException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.cognitoidentity#InvalidParameterException":
                            return [
                                3,
                                6
                            ];
                        case "NotAuthorizedException":
                            return [
                                3,
                                8
                            ];
                        case "com.amazonaws.cognitoidentity#NotAuthorizedException":
                            return [
                                3,
                                8
                            ];
                        case "ResourceConflictException":
                            return [
                                3,
                                10
                            ];
                        case "com.amazonaws.cognitoidentity#ResourceConflictException":
                            return [
                                3,
                                10
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3,
                                12
                            ];
                        case "com.amazonaws.cognitoidentity#ResourceNotFoundException":
                            return [
                                3,
                                12
                            ];
                        case "TooManyRequestsException":
                            return [
                                3,
                                14
                            ];
                        case "com.amazonaws.cognitoidentity#TooManyRequestsException":
                            return [
                                3,
                                14
                            ];
                    }
                    return [
                        3,
                        16
                    ];
                case 2:
                    return [
                        4,
                        $cfad410b8d5507c4$var$deserializeAws_json1_1ExternalServiceExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    throw _d.sent();
                case 4:
                    return [
                        4,
                        $cfad410b8d5507c4$var$deserializeAws_json1_1InternalErrorExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    throw _d.sent();
                case 6:
                    return [
                        4,
                        $cfad410b8d5507c4$var$deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    throw _d.sent();
                case 8:
                    return [
                        4,
                        $cfad410b8d5507c4$var$deserializeAws_json1_1NotAuthorizedExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    throw _d.sent();
                case 10:
                    return [
                        4,
                        $cfad410b8d5507c4$var$deserializeAws_json1_1ResourceConflictExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    throw _d.sent();
                case 12:
                    return [
                        4,
                        $cfad410b8d5507c4$var$deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 13:
                    throw _d.sent();
                case 14:
                    return [
                        4,
                        $cfad410b8d5507c4$var$deserializeAws_json1_1TooManyRequestsExceptionResponse(parsedOutput, context)
                    ];
                case 15:
                    throw _d.sent();
                case 16:
                    parsedBody = parsedOutput.body;
                    response = new (0, $4ea34e10cf9d5301$export$b83d40bae15eaefa)({
                        name: parsedBody.code || parsedBody.Code || errorCode,
                        $fault: "client",
                        $metadata: $cfad410b8d5507c4$var$deserializeMetadata(output)
                    });
                    throw (0, $a08c2c31e27e9e11$export$db01f0c43e877a50)(response, parsedBody);
            }
        });
    });
};
var $cfad410b8d5507c4$export$c7916ef0d543f5e3 = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2,
                        $cfad410b8d5507c4$var$deserializeAws_json1_1GetOpenIdTokenForDeveloperIdentityCommandError(output, context)
                    ];
                    return [
                        4,
                        $cfad410b8d5507c4$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = $cfad410b8d5507c4$var$deserializeAws_json1_1GetOpenIdTokenForDeveloperIdentityResponse(data, context);
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
                        $metadata: $cfad410b8d5507c4$var$deserializeMetadata(output)
                    }, contents);
                    return [
                        2,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var $cfad410b8d5507c4$var$deserializeAws_json1_1GetOpenIdTokenForDeveloperIdentityCommandError = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, parsedBody;
        var _c;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_d) {
            switch(_d.label){
                case 0:
                    _a = [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, output)
                    ];
                    _c = {};
                    return [
                        4,
                        $cfad410b8d5507c4$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_c.body = _d.sent(), _c)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $cfad410b8d5507c4$var$loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "DeveloperUserAlreadyRegisteredException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.cognitoidentity#DeveloperUserAlreadyRegisteredException":
                            return [
                                3,
                                2
                            ];
                        case "InternalErrorException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.cognitoidentity#InternalErrorException":
                            return [
                                3,
                                4
                            ];
                        case "InvalidParameterException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.cognitoidentity#InvalidParameterException":
                            return [
                                3,
                                6
                            ];
                        case "NotAuthorizedException":
                            return [
                                3,
                                8
                            ];
                        case "com.amazonaws.cognitoidentity#NotAuthorizedException":
                            return [
                                3,
                                8
                            ];
                        case "ResourceConflictException":
                            return [
                                3,
                                10
                            ];
                        case "com.amazonaws.cognitoidentity#ResourceConflictException":
                            return [
                                3,
                                10
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3,
                                12
                            ];
                        case "com.amazonaws.cognitoidentity#ResourceNotFoundException":
                            return [
                                3,
                                12
                            ];
                        case "TooManyRequestsException":
                            return [
                                3,
                                14
                            ];
                        case "com.amazonaws.cognitoidentity#TooManyRequestsException":
                            return [
                                3,
                                14
                            ];
                    }
                    return [
                        3,
                        16
                    ];
                case 2:
                    return [
                        4,
                        $cfad410b8d5507c4$var$deserializeAws_json1_1DeveloperUserAlreadyRegisteredExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    throw _d.sent();
                case 4:
                    return [
                        4,
                        $cfad410b8d5507c4$var$deserializeAws_json1_1InternalErrorExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    throw _d.sent();
                case 6:
                    return [
                        4,
                        $cfad410b8d5507c4$var$deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    throw _d.sent();
                case 8:
                    return [
                        4,
                        $cfad410b8d5507c4$var$deserializeAws_json1_1NotAuthorizedExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    throw _d.sent();
                case 10:
                    return [
                        4,
                        $cfad410b8d5507c4$var$deserializeAws_json1_1ResourceConflictExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    throw _d.sent();
                case 12:
                    return [
                        4,
                        $cfad410b8d5507c4$var$deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 13:
                    throw _d.sent();
                case 14:
                    return [
                        4,
                        $cfad410b8d5507c4$var$deserializeAws_json1_1TooManyRequestsExceptionResponse(parsedOutput, context)
                    ];
                case 15:
                    throw _d.sent();
                case 16:
                    parsedBody = parsedOutput.body;
                    response = new (0, $4ea34e10cf9d5301$export$b83d40bae15eaefa)({
                        name: parsedBody.code || parsedBody.Code || errorCode,
                        $fault: "client",
                        $metadata: $cfad410b8d5507c4$var$deserializeMetadata(output)
                    });
                    throw (0, $a08c2c31e27e9e11$export$db01f0c43e877a50)(response, parsedBody);
            }
        });
    });
};
var $cfad410b8d5507c4$export$1de5660d9b376223 = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2,
                        $cfad410b8d5507c4$var$deserializeAws_json1_1GetPrincipalTagAttributeMapCommandError(output, context)
                    ];
                    return [
                        4,
                        $cfad410b8d5507c4$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = $cfad410b8d5507c4$var$deserializeAws_json1_1GetPrincipalTagAttributeMapResponse(data, context);
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
                        $metadata: $cfad410b8d5507c4$var$deserializeMetadata(output)
                    }, contents);
                    return [
                        2,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var $cfad410b8d5507c4$var$deserializeAws_json1_1GetPrincipalTagAttributeMapCommandError = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, parsedBody;
        var _c;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_d) {
            switch(_d.label){
                case 0:
                    _a = [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, output)
                    ];
                    _c = {};
                    return [
                        4,
                        $cfad410b8d5507c4$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_c.body = _d.sent(), _c)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $cfad410b8d5507c4$var$loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InternalErrorException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.cognitoidentity#InternalErrorException":
                            return [
                                3,
                                2
                            ];
                        case "InvalidParameterException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.cognitoidentity#InvalidParameterException":
                            return [
                                3,
                                4
                            ];
                        case "NotAuthorizedException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.cognitoidentity#NotAuthorizedException":
                            return [
                                3,
                                6
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3,
                                8
                            ];
                        case "com.amazonaws.cognitoidentity#ResourceNotFoundException":
                            return [
                                3,
                                8
                            ];
                        case "TooManyRequestsException":
                            return [
                                3,
                                10
                            ];
                        case "com.amazonaws.cognitoidentity#TooManyRequestsException":
                            return [
                                3,
                                10
                            ];
                    }
                    return [
                        3,
                        12
                    ];
                case 2:
                    return [
                        4,
                        $cfad410b8d5507c4$var$deserializeAws_json1_1InternalErrorExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    throw _d.sent();
                case 4:
                    return [
                        4,
                        $cfad410b8d5507c4$var$deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    throw _d.sent();
                case 6:
                    return [
                        4,
                        $cfad410b8d5507c4$var$deserializeAws_json1_1NotAuthorizedExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    throw _d.sent();
                case 8:
                    return [
                        4,
                        $cfad410b8d5507c4$var$deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    throw _d.sent();
                case 10:
                    return [
                        4,
                        $cfad410b8d5507c4$var$deserializeAws_json1_1TooManyRequestsExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    throw _d.sent();
                case 12:
                    parsedBody = parsedOutput.body;
                    response = new (0, $4ea34e10cf9d5301$export$b83d40bae15eaefa)({
                        name: parsedBody.code || parsedBody.Code || errorCode,
                        $fault: "client",
                        $metadata: $cfad410b8d5507c4$var$deserializeMetadata(output)
                    });
                    throw (0, $a08c2c31e27e9e11$export$db01f0c43e877a50)(response, parsedBody);
            }
        });
    });
};
var $cfad410b8d5507c4$export$a2439911ac8089ba = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2,
                        $cfad410b8d5507c4$var$deserializeAws_json1_1ListIdentitiesCommandError(output, context)
                    ];
                    return [
                        4,
                        $cfad410b8d5507c4$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = $cfad410b8d5507c4$var$deserializeAws_json1_1ListIdentitiesResponse(data, context);
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
                        $metadata: $cfad410b8d5507c4$var$deserializeMetadata(output)
                    }, contents);
                    return [
                        2,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var $cfad410b8d5507c4$var$deserializeAws_json1_1ListIdentitiesCommandError = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, parsedBody;
        var _c;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_d) {
            switch(_d.label){
                case 0:
                    _a = [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, output)
                    ];
                    _c = {};
                    return [
                        4,
                        $cfad410b8d5507c4$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_c.body = _d.sent(), _c)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $cfad410b8d5507c4$var$loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InternalErrorException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.cognitoidentity#InternalErrorException":
                            return [
                                3,
                                2
                            ];
                        case "InvalidParameterException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.cognitoidentity#InvalidParameterException":
                            return [
                                3,
                                4
                            ];
                        case "NotAuthorizedException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.cognitoidentity#NotAuthorizedException":
                            return [
                                3,
                                6
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3,
                                8
                            ];
                        case "com.amazonaws.cognitoidentity#ResourceNotFoundException":
                            return [
                                3,
                                8
                            ];
                        case "TooManyRequestsException":
                            return [
                                3,
                                10
                            ];
                        case "com.amazonaws.cognitoidentity#TooManyRequestsException":
                            return [
                                3,
                                10
                            ];
                    }
                    return [
                        3,
                        12
                    ];
                case 2:
                    return [
                        4,
                        $cfad410b8d5507c4$var$deserializeAws_json1_1InternalErrorExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    throw _d.sent();
                case 4:
                    return [
                        4,
                        $cfad410b8d5507c4$var$deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    throw _d.sent();
                case 6:
                    return [
                        4,
                        $cfad410b8d5507c4$var$deserializeAws_json1_1NotAuthorizedExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    throw _d.sent();
                case 8:
                    return [
                        4,
                        $cfad410b8d5507c4$var$deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    throw _d.sent();
                case 10:
                    return [
                        4,
                        $cfad410b8d5507c4$var$deserializeAws_json1_1TooManyRequestsExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    throw _d.sent();
                case 12:
                    parsedBody = parsedOutput.body;
                    response = new (0, $4ea34e10cf9d5301$export$b83d40bae15eaefa)({
                        name: parsedBody.code || parsedBody.Code || errorCode,
                        $fault: "client",
                        $metadata: $cfad410b8d5507c4$var$deserializeMetadata(output)
                    });
                    throw (0, $a08c2c31e27e9e11$export$db01f0c43e877a50)(response, parsedBody);
            }
        });
    });
};
var $cfad410b8d5507c4$export$36b32c966a7eefbd = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2,
                        $cfad410b8d5507c4$var$deserializeAws_json1_1ListIdentityPoolsCommandError(output, context)
                    ];
                    return [
                        4,
                        $cfad410b8d5507c4$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = $cfad410b8d5507c4$var$deserializeAws_json1_1ListIdentityPoolsResponse(data, context);
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
                        $metadata: $cfad410b8d5507c4$var$deserializeMetadata(output)
                    }, contents);
                    return [
                        2,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var $cfad410b8d5507c4$var$deserializeAws_json1_1ListIdentityPoolsCommandError = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, parsedBody;
        var _c;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_d) {
            switch(_d.label){
                case 0:
                    _a = [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, output)
                    ];
                    _c = {};
                    return [
                        4,
                        $cfad410b8d5507c4$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_c.body = _d.sent(), _c)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $cfad410b8d5507c4$var$loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InternalErrorException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.cognitoidentity#InternalErrorException":
                            return [
                                3,
                                2
                            ];
                        case "InvalidParameterException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.cognitoidentity#InvalidParameterException":
                            return [
                                3,
                                4
                            ];
                        case "NotAuthorizedException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.cognitoidentity#NotAuthorizedException":
                            return [
                                3,
                                6
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3,
                                8
                            ];
                        case "com.amazonaws.cognitoidentity#ResourceNotFoundException":
                            return [
                                3,
                                8
                            ];
                        case "TooManyRequestsException":
                            return [
                                3,
                                10
                            ];
                        case "com.amazonaws.cognitoidentity#TooManyRequestsException":
                            return [
                                3,
                                10
                            ];
                    }
                    return [
                        3,
                        12
                    ];
                case 2:
                    return [
                        4,
                        $cfad410b8d5507c4$var$deserializeAws_json1_1InternalErrorExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    throw _d.sent();
                case 4:
                    return [
                        4,
                        $cfad410b8d5507c4$var$deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    throw _d.sent();
                case 6:
                    return [
                        4,
                        $cfad410b8d5507c4$var$deserializeAws_json1_1NotAuthorizedExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    throw _d.sent();
                case 8:
                    return [
                        4,
                        $cfad410b8d5507c4$var$deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    throw _d.sent();
                case 10:
                    return [
                        4,
                        $cfad410b8d5507c4$var$deserializeAws_json1_1TooManyRequestsExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    throw _d.sent();
                case 12:
                    parsedBody = parsedOutput.body;
                    response = new (0, $4ea34e10cf9d5301$export$b83d40bae15eaefa)({
                        name: parsedBody.code || parsedBody.Code || errorCode,
                        $fault: "client",
                        $metadata: $cfad410b8d5507c4$var$deserializeMetadata(output)
                    });
                    throw (0, $a08c2c31e27e9e11$export$db01f0c43e877a50)(response, parsedBody);
            }
        });
    });
};
var $cfad410b8d5507c4$export$efb57976dadbc12b = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2,
                        $cfad410b8d5507c4$var$deserializeAws_json1_1ListTagsForResourceCommandError(output, context)
                    ];
                    return [
                        4,
                        $cfad410b8d5507c4$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = $cfad410b8d5507c4$var$deserializeAws_json1_1ListTagsForResourceResponse(data, context);
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
                        $metadata: $cfad410b8d5507c4$var$deserializeMetadata(output)
                    }, contents);
                    return [
                        2,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var $cfad410b8d5507c4$var$deserializeAws_json1_1ListTagsForResourceCommandError = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, parsedBody;
        var _c;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_d) {
            switch(_d.label){
                case 0:
                    _a = [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, output)
                    ];
                    _c = {};
                    return [
                        4,
                        $cfad410b8d5507c4$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_c.body = _d.sent(), _c)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $cfad410b8d5507c4$var$loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InternalErrorException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.cognitoidentity#InternalErrorException":
                            return [
                                3,
                                2
                            ];
                        case "InvalidParameterException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.cognitoidentity#InvalidParameterException":
                            return [
                                3,
                                4
                            ];
                        case "NotAuthorizedException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.cognitoidentity#NotAuthorizedException":
                            return [
                                3,
                                6
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3,
                                8
                            ];
                        case "com.amazonaws.cognitoidentity#ResourceNotFoundException":
                            return [
                                3,
                                8
                            ];
                        case "TooManyRequestsException":
                            return [
                                3,
                                10
                            ];
                        case "com.amazonaws.cognitoidentity#TooManyRequestsException":
                            return [
                                3,
                                10
                            ];
                    }
                    return [
                        3,
                        12
                    ];
                case 2:
                    return [
                        4,
                        $cfad410b8d5507c4$var$deserializeAws_json1_1InternalErrorExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    throw _d.sent();
                case 4:
                    return [
                        4,
                        $cfad410b8d5507c4$var$deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    throw _d.sent();
                case 6:
                    return [
                        4,
                        $cfad410b8d5507c4$var$deserializeAws_json1_1NotAuthorizedExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    throw _d.sent();
                case 8:
                    return [
                        4,
                        $cfad410b8d5507c4$var$deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    throw _d.sent();
                case 10:
                    return [
                        4,
                        $cfad410b8d5507c4$var$deserializeAws_json1_1TooManyRequestsExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    throw _d.sent();
                case 12:
                    parsedBody = parsedOutput.body;
                    response = new (0, $4ea34e10cf9d5301$export$b83d40bae15eaefa)({
                        name: parsedBody.code || parsedBody.Code || errorCode,
                        $fault: "client",
                        $metadata: $cfad410b8d5507c4$var$deserializeMetadata(output)
                    });
                    throw (0, $a08c2c31e27e9e11$export$db01f0c43e877a50)(response, parsedBody);
            }
        });
    });
};
var $cfad410b8d5507c4$export$6476ab94d95217ab = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2,
                        $cfad410b8d5507c4$var$deserializeAws_json1_1LookupDeveloperIdentityCommandError(output, context)
                    ];
                    return [
                        4,
                        $cfad410b8d5507c4$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = $cfad410b8d5507c4$var$deserializeAws_json1_1LookupDeveloperIdentityResponse(data, context);
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
                        $metadata: $cfad410b8d5507c4$var$deserializeMetadata(output)
                    }, contents);
                    return [
                        2,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var $cfad410b8d5507c4$var$deserializeAws_json1_1LookupDeveloperIdentityCommandError = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, parsedBody;
        var _c;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_d) {
            switch(_d.label){
                case 0:
                    _a = [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, output)
                    ];
                    _c = {};
                    return [
                        4,
                        $cfad410b8d5507c4$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_c.body = _d.sent(), _c)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $cfad410b8d5507c4$var$loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InternalErrorException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.cognitoidentity#InternalErrorException":
                            return [
                                3,
                                2
                            ];
                        case "InvalidParameterException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.cognitoidentity#InvalidParameterException":
                            return [
                                3,
                                4
                            ];
                        case "NotAuthorizedException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.cognitoidentity#NotAuthorizedException":
                            return [
                                3,
                                6
                            ];
                        case "ResourceConflictException":
                            return [
                                3,
                                8
                            ];
                        case "com.amazonaws.cognitoidentity#ResourceConflictException":
                            return [
                                3,
                                8
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3,
                                10
                            ];
                        case "com.amazonaws.cognitoidentity#ResourceNotFoundException":
                            return [
                                3,
                                10
                            ];
                        case "TooManyRequestsException":
                            return [
                                3,
                                12
                            ];
                        case "com.amazonaws.cognitoidentity#TooManyRequestsException":
                            return [
                                3,
                                12
                            ];
                    }
                    return [
                        3,
                        14
                    ];
                case 2:
                    return [
                        4,
                        $cfad410b8d5507c4$var$deserializeAws_json1_1InternalErrorExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    throw _d.sent();
                case 4:
                    return [
                        4,
                        $cfad410b8d5507c4$var$deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    throw _d.sent();
                case 6:
                    return [
                        4,
                        $cfad410b8d5507c4$var$deserializeAws_json1_1NotAuthorizedExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    throw _d.sent();
                case 8:
                    return [
                        4,
                        $cfad410b8d5507c4$var$deserializeAws_json1_1ResourceConflictExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    throw _d.sent();
                case 10:
                    return [
                        4,
                        $cfad410b8d5507c4$var$deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    throw _d.sent();
                case 12:
                    return [
                        4,
                        $cfad410b8d5507c4$var$deserializeAws_json1_1TooManyRequestsExceptionResponse(parsedOutput, context)
                    ];
                case 13:
                    throw _d.sent();
                case 14:
                    parsedBody = parsedOutput.body;
                    response = new (0, $4ea34e10cf9d5301$export$b83d40bae15eaefa)({
                        name: parsedBody.code || parsedBody.Code || errorCode,
                        $fault: "client",
                        $metadata: $cfad410b8d5507c4$var$deserializeMetadata(output)
                    });
                    throw (0, $a08c2c31e27e9e11$export$db01f0c43e877a50)(response, parsedBody);
            }
        });
    });
};
var $cfad410b8d5507c4$export$73edba62ad60e9b9 = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2,
                        $cfad410b8d5507c4$var$deserializeAws_json1_1MergeDeveloperIdentitiesCommandError(output, context)
                    ];
                    return [
                        4,
                        $cfad410b8d5507c4$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = $cfad410b8d5507c4$var$deserializeAws_json1_1MergeDeveloperIdentitiesResponse(data, context);
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
                        $metadata: $cfad410b8d5507c4$var$deserializeMetadata(output)
                    }, contents);
                    return [
                        2,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var $cfad410b8d5507c4$var$deserializeAws_json1_1MergeDeveloperIdentitiesCommandError = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, parsedBody;
        var _c;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_d) {
            switch(_d.label){
                case 0:
                    _a = [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, output)
                    ];
                    _c = {};
                    return [
                        4,
                        $cfad410b8d5507c4$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_c.body = _d.sent(), _c)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $cfad410b8d5507c4$var$loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InternalErrorException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.cognitoidentity#InternalErrorException":
                            return [
                                3,
                                2
                            ];
                        case "InvalidParameterException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.cognitoidentity#InvalidParameterException":
                            return [
                                3,
                                4
                            ];
                        case "NotAuthorizedException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.cognitoidentity#NotAuthorizedException":
                            return [
                                3,
                                6
                            ];
                        case "ResourceConflictException":
                            return [
                                3,
                                8
                            ];
                        case "com.amazonaws.cognitoidentity#ResourceConflictException":
                            return [
                                3,
                                8
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3,
                                10
                            ];
                        case "com.amazonaws.cognitoidentity#ResourceNotFoundException":
                            return [
                                3,
                                10
                            ];
                        case "TooManyRequestsException":
                            return [
                                3,
                                12
                            ];
                        case "com.amazonaws.cognitoidentity#TooManyRequestsException":
                            return [
                                3,
                                12
                            ];
                    }
                    return [
                        3,
                        14
                    ];
                case 2:
                    return [
                        4,
                        $cfad410b8d5507c4$var$deserializeAws_json1_1InternalErrorExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    throw _d.sent();
                case 4:
                    return [
                        4,
                        $cfad410b8d5507c4$var$deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    throw _d.sent();
                case 6:
                    return [
                        4,
                        $cfad410b8d5507c4$var$deserializeAws_json1_1NotAuthorizedExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    throw _d.sent();
                case 8:
                    return [
                        4,
                        $cfad410b8d5507c4$var$deserializeAws_json1_1ResourceConflictExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    throw _d.sent();
                case 10:
                    return [
                        4,
                        $cfad410b8d5507c4$var$deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    throw _d.sent();
                case 12:
                    return [
                        4,
                        $cfad410b8d5507c4$var$deserializeAws_json1_1TooManyRequestsExceptionResponse(parsedOutput, context)
                    ];
                case 13:
                    throw _d.sent();
                case 14:
                    parsedBody = parsedOutput.body;
                    response = new (0, $4ea34e10cf9d5301$export$b83d40bae15eaefa)({
                        name: parsedBody.code || parsedBody.Code || errorCode,
                        $fault: "client",
                        $metadata: $cfad410b8d5507c4$var$deserializeMetadata(output)
                    });
                    throw (0, $a08c2c31e27e9e11$export$db01f0c43e877a50)(response, parsedBody);
            }
        });
    });
};
var $cfad410b8d5507c4$export$4d01436d85148f27 = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var response;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2,
                        $cfad410b8d5507c4$var$deserializeAws_json1_1SetIdentityPoolRolesCommandError(output, context)
                    ];
                    return [
                        4,
                        $cfad410b8d5507c4$var$collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    response = {
                        $metadata: $cfad410b8d5507c4$var$deserializeMetadata(output)
                    };
                    return [
                        2,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var $cfad410b8d5507c4$var$deserializeAws_json1_1SetIdentityPoolRolesCommandError = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, parsedBody;
        var _c;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_d) {
            switch(_d.label){
                case 0:
                    _a = [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, output)
                    ];
                    _c = {};
                    return [
                        4,
                        $cfad410b8d5507c4$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_c.body = _d.sent(), _c)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $cfad410b8d5507c4$var$loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "ConcurrentModificationException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.cognitoidentity#ConcurrentModificationException":
                            return [
                                3,
                                2
                            ];
                        case "InternalErrorException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.cognitoidentity#InternalErrorException":
                            return [
                                3,
                                4
                            ];
                        case "InvalidParameterException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.cognitoidentity#InvalidParameterException":
                            return [
                                3,
                                6
                            ];
                        case "NotAuthorizedException":
                            return [
                                3,
                                8
                            ];
                        case "com.amazonaws.cognitoidentity#NotAuthorizedException":
                            return [
                                3,
                                8
                            ];
                        case "ResourceConflictException":
                            return [
                                3,
                                10
                            ];
                        case "com.amazonaws.cognitoidentity#ResourceConflictException":
                            return [
                                3,
                                10
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3,
                                12
                            ];
                        case "com.amazonaws.cognitoidentity#ResourceNotFoundException":
                            return [
                                3,
                                12
                            ];
                        case "TooManyRequestsException":
                            return [
                                3,
                                14
                            ];
                        case "com.amazonaws.cognitoidentity#TooManyRequestsException":
                            return [
                                3,
                                14
                            ];
                    }
                    return [
                        3,
                        16
                    ];
                case 2:
                    return [
                        4,
                        $cfad410b8d5507c4$var$deserializeAws_json1_1ConcurrentModificationExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    throw _d.sent();
                case 4:
                    return [
                        4,
                        $cfad410b8d5507c4$var$deserializeAws_json1_1InternalErrorExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    throw _d.sent();
                case 6:
                    return [
                        4,
                        $cfad410b8d5507c4$var$deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    throw _d.sent();
                case 8:
                    return [
                        4,
                        $cfad410b8d5507c4$var$deserializeAws_json1_1NotAuthorizedExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    throw _d.sent();
                case 10:
                    return [
                        4,
                        $cfad410b8d5507c4$var$deserializeAws_json1_1ResourceConflictExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    throw _d.sent();
                case 12:
                    return [
                        4,
                        $cfad410b8d5507c4$var$deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 13:
                    throw _d.sent();
                case 14:
                    return [
                        4,
                        $cfad410b8d5507c4$var$deserializeAws_json1_1TooManyRequestsExceptionResponse(parsedOutput, context)
                    ];
                case 15:
                    throw _d.sent();
                case 16:
                    parsedBody = parsedOutput.body;
                    response = new (0, $4ea34e10cf9d5301$export$b83d40bae15eaefa)({
                        name: parsedBody.code || parsedBody.Code || errorCode,
                        $fault: "client",
                        $metadata: $cfad410b8d5507c4$var$deserializeMetadata(output)
                    });
                    throw (0, $a08c2c31e27e9e11$export$db01f0c43e877a50)(response, parsedBody);
            }
        });
    });
};
var $cfad410b8d5507c4$export$47edeb829fd0e9c2 = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2,
                        $cfad410b8d5507c4$var$deserializeAws_json1_1SetPrincipalTagAttributeMapCommandError(output, context)
                    ];
                    return [
                        4,
                        $cfad410b8d5507c4$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = $cfad410b8d5507c4$var$deserializeAws_json1_1SetPrincipalTagAttributeMapResponse(data, context);
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
                        $metadata: $cfad410b8d5507c4$var$deserializeMetadata(output)
                    }, contents);
                    return [
                        2,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var $cfad410b8d5507c4$var$deserializeAws_json1_1SetPrincipalTagAttributeMapCommandError = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, parsedBody;
        var _c;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_d) {
            switch(_d.label){
                case 0:
                    _a = [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, output)
                    ];
                    _c = {};
                    return [
                        4,
                        $cfad410b8d5507c4$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_c.body = _d.sent(), _c)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $cfad410b8d5507c4$var$loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InternalErrorException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.cognitoidentity#InternalErrorException":
                            return [
                                3,
                                2
                            ];
                        case "InvalidParameterException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.cognitoidentity#InvalidParameterException":
                            return [
                                3,
                                4
                            ];
                        case "NotAuthorizedException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.cognitoidentity#NotAuthorizedException":
                            return [
                                3,
                                6
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3,
                                8
                            ];
                        case "com.amazonaws.cognitoidentity#ResourceNotFoundException":
                            return [
                                3,
                                8
                            ];
                        case "TooManyRequestsException":
                            return [
                                3,
                                10
                            ];
                        case "com.amazonaws.cognitoidentity#TooManyRequestsException":
                            return [
                                3,
                                10
                            ];
                    }
                    return [
                        3,
                        12
                    ];
                case 2:
                    return [
                        4,
                        $cfad410b8d5507c4$var$deserializeAws_json1_1InternalErrorExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    throw _d.sent();
                case 4:
                    return [
                        4,
                        $cfad410b8d5507c4$var$deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    throw _d.sent();
                case 6:
                    return [
                        4,
                        $cfad410b8d5507c4$var$deserializeAws_json1_1NotAuthorizedExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    throw _d.sent();
                case 8:
                    return [
                        4,
                        $cfad410b8d5507c4$var$deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    throw _d.sent();
                case 10:
                    return [
                        4,
                        $cfad410b8d5507c4$var$deserializeAws_json1_1TooManyRequestsExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    throw _d.sent();
                case 12:
                    parsedBody = parsedOutput.body;
                    response = new (0, $4ea34e10cf9d5301$export$b83d40bae15eaefa)({
                        name: parsedBody.code || parsedBody.Code || errorCode,
                        $fault: "client",
                        $metadata: $cfad410b8d5507c4$var$deserializeMetadata(output)
                    });
                    throw (0, $a08c2c31e27e9e11$export$db01f0c43e877a50)(response, parsedBody);
            }
        });
    });
};
var $cfad410b8d5507c4$export$2bbf6fe70d6779a6 = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2,
                        $cfad410b8d5507c4$var$deserializeAws_json1_1TagResourceCommandError(output, context)
                    ];
                    return [
                        4,
                        $cfad410b8d5507c4$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = $cfad410b8d5507c4$var$deserializeAws_json1_1TagResourceResponse(data, context);
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
                        $metadata: $cfad410b8d5507c4$var$deserializeMetadata(output)
                    }, contents);
                    return [
                        2,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var $cfad410b8d5507c4$var$deserializeAws_json1_1TagResourceCommandError = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, parsedBody;
        var _c;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_d) {
            switch(_d.label){
                case 0:
                    _a = [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, output)
                    ];
                    _c = {};
                    return [
                        4,
                        $cfad410b8d5507c4$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_c.body = _d.sent(), _c)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $cfad410b8d5507c4$var$loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InternalErrorException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.cognitoidentity#InternalErrorException":
                            return [
                                3,
                                2
                            ];
                        case "InvalidParameterException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.cognitoidentity#InvalidParameterException":
                            return [
                                3,
                                4
                            ];
                        case "NotAuthorizedException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.cognitoidentity#NotAuthorizedException":
                            return [
                                3,
                                6
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3,
                                8
                            ];
                        case "com.amazonaws.cognitoidentity#ResourceNotFoundException":
                            return [
                                3,
                                8
                            ];
                        case "TooManyRequestsException":
                            return [
                                3,
                                10
                            ];
                        case "com.amazonaws.cognitoidentity#TooManyRequestsException":
                            return [
                                3,
                                10
                            ];
                    }
                    return [
                        3,
                        12
                    ];
                case 2:
                    return [
                        4,
                        $cfad410b8d5507c4$var$deserializeAws_json1_1InternalErrorExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    throw _d.sent();
                case 4:
                    return [
                        4,
                        $cfad410b8d5507c4$var$deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    throw _d.sent();
                case 6:
                    return [
                        4,
                        $cfad410b8d5507c4$var$deserializeAws_json1_1NotAuthorizedExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    throw _d.sent();
                case 8:
                    return [
                        4,
                        $cfad410b8d5507c4$var$deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    throw _d.sent();
                case 10:
                    return [
                        4,
                        $cfad410b8d5507c4$var$deserializeAws_json1_1TooManyRequestsExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    throw _d.sent();
                case 12:
                    parsedBody = parsedOutput.body;
                    response = new (0, $4ea34e10cf9d5301$export$b83d40bae15eaefa)({
                        name: parsedBody.code || parsedBody.Code || errorCode,
                        $fault: "client",
                        $metadata: $cfad410b8d5507c4$var$deserializeMetadata(output)
                    });
                    throw (0, $a08c2c31e27e9e11$export$db01f0c43e877a50)(response, parsedBody);
            }
        });
    });
};
var $cfad410b8d5507c4$export$d8ee329529310a85 = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var response;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2,
                        $cfad410b8d5507c4$var$deserializeAws_json1_1UnlinkDeveloperIdentityCommandError(output, context)
                    ];
                    return [
                        4,
                        $cfad410b8d5507c4$var$collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    response = {
                        $metadata: $cfad410b8d5507c4$var$deserializeMetadata(output)
                    };
                    return [
                        2,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var $cfad410b8d5507c4$var$deserializeAws_json1_1UnlinkDeveloperIdentityCommandError = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, parsedBody;
        var _c;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_d) {
            switch(_d.label){
                case 0:
                    _a = [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, output)
                    ];
                    _c = {};
                    return [
                        4,
                        $cfad410b8d5507c4$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_c.body = _d.sent(), _c)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $cfad410b8d5507c4$var$loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InternalErrorException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.cognitoidentity#InternalErrorException":
                            return [
                                3,
                                2
                            ];
                        case "InvalidParameterException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.cognitoidentity#InvalidParameterException":
                            return [
                                3,
                                4
                            ];
                        case "NotAuthorizedException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.cognitoidentity#NotAuthorizedException":
                            return [
                                3,
                                6
                            ];
                        case "ResourceConflictException":
                            return [
                                3,
                                8
                            ];
                        case "com.amazonaws.cognitoidentity#ResourceConflictException":
                            return [
                                3,
                                8
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3,
                                10
                            ];
                        case "com.amazonaws.cognitoidentity#ResourceNotFoundException":
                            return [
                                3,
                                10
                            ];
                        case "TooManyRequestsException":
                            return [
                                3,
                                12
                            ];
                        case "com.amazonaws.cognitoidentity#TooManyRequestsException":
                            return [
                                3,
                                12
                            ];
                    }
                    return [
                        3,
                        14
                    ];
                case 2:
                    return [
                        4,
                        $cfad410b8d5507c4$var$deserializeAws_json1_1InternalErrorExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    throw _d.sent();
                case 4:
                    return [
                        4,
                        $cfad410b8d5507c4$var$deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    throw _d.sent();
                case 6:
                    return [
                        4,
                        $cfad410b8d5507c4$var$deserializeAws_json1_1NotAuthorizedExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    throw _d.sent();
                case 8:
                    return [
                        4,
                        $cfad410b8d5507c4$var$deserializeAws_json1_1ResourceConflictExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    throw _d.sent();
                case 10:
                    return [
                        4,
                        $cfad410b8d5507c4$var$deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    throw _d.sent();
                case 12:
                    return [
                        4,
                        $cfad410b8d5507c4$var$deserializeAws_json1_1TooManyRequestsExceptionResponse(parsedOutput, context)
                    ];
                case 13:
                    throw _d.sent();
                case 14:
                    parsedBody = parsedOutput.body;
                    response = new (0, $4ea34e10cf9d5301$export$b83d40bae15eaefa)({
                        name: parsedBody.code || parsedBody.Code || errorCode,
                        $fault: "client",
                        $metadata: $cfad410b8d5507c4$var$deserializeMetadata(output)
                    });
                    throw (0, $a08c2c31e27e9e11$export$db01f0c43e877a50)(response, parsedBody);
            }
        });
    });
};
var $cfad410b8d5507c4$export$b3b4038b9cc6cf0c = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var response;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2,
                        $cfad410b8d5507c4$var$deserializeAws_json1_1UnlinkIdentityCommandError(output, context)
                    ];
                    return [
                        4,
                        $cfad410b8d5507c4$var$collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    response = {
                        $metadata: $cfad410b8d5507c4$var$deserializeMetadata(output)
                    };
                    return [
                        2,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var $cfad410b8d5507c4$var$deserializeAws_json1_1UnlinkIdentityCommandError = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, parsedBody;
        var _c;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_d) {
            switch(_d.label){
                case 0:
                    _a = [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, output)
                    ];
                    _c = {};
                    return [
                        4,
                        $cfad410b8d5507c4$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_c.body = _d.sent(), _c)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $cfad410b8d5507c4$var$loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "ExternalServiceException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.cognitoidentity#ExternalServiceException":
                            return [
                                3,
                                2
                            ];
                        case "InternalErrorException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.cognitoidentity#InternalErrorException":
                            return [
                                3,
                                4
                            ];
                        case "InvalidParameterException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.cognitoidentity#InvalidParameterException":
                            return [
                                3,
                                6
                            ];
                        case "NotAuthorizedException":
                            return [
                                3,
                                8
                            ];
                        case "com.amazonaws.cognitoidentity#NotAuthorizedException":
                            return [
                                3,
                                8
                            ];
                        case "ResourceConflictException":
                            return [
                                3,
                                10
                            ];
                        case "com.amazonaws.cognitoidentity#ResourceConflictException":
                            return [
                                3,
                                10
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3,
                                12
                            ];
                        case "com.amazonaws.cognitoidentity#ResourceNotFoundException":
                            return [
                                3,
                                12
                            ];
                        case "TooManyRequestsException":
                            return [
                                3,
                                14
                            ];
                        case "com.amazonaws.cognitoidentity#TooManyRequestsException":
                            return [
                                3,
                                14
                            ];
                    }
                    return [
                        3,
                        16
                    ];
                case 2:
                    return [
                        4,
                        $cfad410b8d5507c4$var$deserializeAws_json1_1ExternalServiceExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    throw _d.sent();
                case 4:
                    return [
                        4,
                        $cfad410b8d5507c4$var$deserializeAws_json1_1InternalErrorExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    throw _d.sent();
                case 6:
                    return [
                        4,
                        $cfad410b8d5507c4$var$deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    throw _d.sent();
                case 8:
                    return [
                        4,
                        $cfad410b8d5507c4$var$deserializeAws_json1_1NotAuthorizedExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    throw _d.sent();
                case 10:
                    return [
                        4,
                        $cfad410b8d5507c4$var$deserializeAws_json1_1ResourceConflictExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    throw _d.sent();
                case 12:
                    return [
                        4,
                        $cfad410b8d5507c4$var$deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 13:
                    throw _d.sent();
                case 14:
                    return [
                        4,
                        $cfad410b8d5507c4$var$deserializeAws_json1_1TooManyRequestsExceptionResponse(parsedOutput, context)
                    ];
                case 15:
                    throw _d.sent();
                case 16:
                    parsedBody = parsedOutput.body;
                    response = new (0, $4ea34e10cf9d5301$export$b83d40bae15eaefa)({
                        name: parsedBody.code || parsedBody.Code || errorCode,
                        $fault: "client",
                        $metadata: $cfad410b8d5507c4$var$deserializeMetadata(output)
                    });
                    throw (0, $a08c2c31e27e9e11$export$db01f0c43e877a50)(response, parsedBody);
            }
        });
    });
};
var $cfad410b8d5507c4$export$4e56caf614610ee8 = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2,
                        $cfad410b8d5507c4$var$deserializeAws_json1_1UntagResourceCommandError(output, context)
                    ];
                    return [
                        4,
                        $cfad410b8d5507c4$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = $cfad410b8d5507c4$var$deserializeAws_json1_1UntagResourceResponse(data, context);
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
                        $metadata: $cfad410b8d5507c4$var$deserializeMetadata(output)
                    }, contents);
                    return [
                        2,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var $cfad410b8d5507c4$var$deserializeAws_json1_1UntagResourceCommandError = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, parsedBody;
        var _c;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_d) {
            switch(_d.label){
                case 0:
                    _a = [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, output)
                    ];
                    _c = {};
                    return [
                        4,
                        $cfad410b8d5507c4$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_c.body = _d.sent(), _c)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $cfad410b8d5507c4$var$loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InternalErrorException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.cognitoidentity#InternalErrorException":
                            return [
                                3,
                                2
                            ];
                        case "InvalidParameterException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.cognitoidentity#InvalidParameterException":
                            return [
                                3,
                                4
                            ];
                        case "NotAuthorizedException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.cognitoidentity#NotAuthorizedException":
                            return [
                                3,
                                6
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3,
                                8
                            ];
                        case "com.amazonaws.cognitoidentity#ResourceNotFoundException":
                            return [
                                3,
                                8
                            ];
                        case "TooManyRequestsException":
                            return [
                                3,
                                10
                            ];
                        case "com.amazonaws.cognitoidentity#TooManyRequestsException":
                            return [
                                3,
                                10
                            ];
                    }
                    return [
                        3,
                        12
                    ];
                case 2:
                    return [
                        4,
                        $cfad410b8d5507c4$var$deserializeAws_json1_1InternalErrorExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    throw _d.sent();
                case 4:
                    return [
                        4,
                        $cfad410b8d5507c4$var$deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    throw _d.sent();
                case 6:
                    return [
                        4,
                        $cfad410b8d5507c4$var$deserializeAws_json1_1NotAuthorizedExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    throw _d.sent();
                case 8:
                    return [
                        4,
                        $cfad410b8d5507c4$var$deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    throw _d.sent();
                case 10:
                    return [
                        4,
                        $cfad410b8d5507c4$var$deserializeAws_json1_1TooManyRequestsExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    throw _d.sent();
                case 12:
                    parsedBody = parsedOutput.body;
                    response = new (0, $4ea34e10cf9d5301$export$b83d40bae15eaefa)({
                        name: parsedBody.code || parsedBody.Code || errorCode,
                        $fault: "client",
                        $metadata: $cfad410b8d5507c4$var$deserializeMetadata(output)
                    });
                    throw (0, $a08c2c31e27e9e11$export$db01f0c43e877a50)(response, parsedBody);
            }
        });
    });
};
var $cfad410b8d5507c4$export$e9cc2af0cb85eeaa = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2,
                        $cfad410b8d5507c4$var$deserializeAws_json1_1UpdateIdentityPoolCommandError(output, context)
                    ];
                    return [
                        4,
                        $cfad410b8d5507c4$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = $cfad410b8d5507c4$var$deserializeAws_json1_1IdentityPool(data, context);
                    response = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
                        $metadata: $cfad410b8d5507c4$var$deserializeMetadata(output)
                    }, contents);
                    return [
                        2,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var $cfad410b8d5507c4$var$deserializeAws_json1_1UpdateIdentityPoolCommandError = function(output, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, parsedBody;
        var _c;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_d) {
            switch(_d.label){
                case 0:
                    _a = [
                        (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, output)
                    ];
                    _c = {};
                    return [
                        4,
                        $cfad410b8d5507c4$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $5c96a02c592fcff1$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_c.body = _d.sent(), _c)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $cfad410b8d5507c4$var$loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "ConcurrentModificationException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.cognitoidentity#ConcurrentModificationException":
                            return [
                                3,
                                2
                            ];
                        case "InternalErrorException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.cognitoidentity#InternalErrorException":
                            return [
                                3,
                                4
                            ];
                        case "InvalidParameterException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.cognitoidentity#InvalidParameterException":
                            return [
                                3,
                                6
                            ];
                        case "LimitExceededException":
                            return [
                                3,
                                8
                            ];
                        case "com.amazonaws.cognitoidentity#LimitExceededException":
                            return [
                                3,
                                8
                            ];
                        case "NotAuthorizedException":
                            return [
                                3,
                                10
                            ];
                        case "com.amazonaws.cognitoidentity#NotAuthorizedException":
                            return [
                                3,
                                10
                            ];
                        case "ResourceConflictException":
                            return [
                                3,
                                12
                            ];
                        case "com.amazonaws.cognitoidentity#ResourceConflictException":
                            return [
                                3,
                                12
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3,
                                14
                            ];
                        case "com.amazonaws.cognitoidentity#ResourceNotFoundException":
                            return [
                                3,
                                14
                            ];
                        case "TooManyRequestsException":
                            return [
                                3,
                                16
                            ];
                        case "com.amazonaws.cognitoidentity#TooManyRequestsException":
                            return [
                                3,
                                16
                            ];
                    }
                    return [
                        3,
                        18
                    ];
                case 2:
                    return [
                        4,
                        $cfad410b8d5507c4$var$deserializeAws_json1_1ConcurrentModificationExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    throw _d.sent();
                case 4:
                    return [
                        4,
                        $cfad410b8d5507c4$var$deserializeAws_json1_1InternalErrorExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    throw _d.sent();
                case 6:
                    return [
                        4,
                        $cfad410b8d5507c4$var$deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    throw _d.sent();
                case 8:
                    return [
                        4,
                        $cfad410b8d5507c4$var$deserializeAws_json1_1LimitExceededExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    throw _d.sent();
                case 10:
                    return [
                        4,
                        $cfad410b8d5507c4$var$deserializeAws_json1_1NotAuthorizedExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    throw _d.sent();
                case 12:
                    return [
                        4,
                        $cfad410b8d5507c4$var$deserializeAws_json1_1ResourceConflictExceptionResponse(parsedOutput, context)
                    ];
                case 13:
                    throw _d.sent();
                case 14:
                    return [
                        4,
                        $cfad410b8d5507c4$var$deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 15:
                    throw _d.sent();
                case 16:
                    return [
                        4,
                        $cfad410b8d5507c4$var$deserializeAws_json1_1TooManyRequestsExceptionResponse(parsedOutput, context)
                    ];
                case 17:
                    throw _d.sent();
                case 18:
                    parsedBody = parsedOutput.body;
                    response = new (0, $4ea34e10cf9d5301$export$b83d40bae15eaefa)({
                        name: parsedBody.code || parsedBody.Code || errorCode,
                        $fault: "client",
                        $metadata: $cfad410b8d5507c4$var$deserializeMetadata(output)
                    });
                    throw (0, $a08c2c31e27e9e11$export$db01f0c43e877a50)(response, parsedBody);
            }
        });
    });
};
var $cfad410b8d5507c4$var$deserializeAws_json1_1ConcurrentModificationExceptionResponse = function(parsedOutput, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var body, deserialized, exception;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            body = parsedOutput.body;
            deserialized = $cfad410b8d5507c4$var$deserializeAws_json1_1ConcurrentModificationException(body, context);
            exception = new (0, $5af132e3d8cbf992$export$21f15e80c2bbca09)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
                $metadata: $cfad410b8d5507c4$var$deserializeMetadata(parsedOutput)
            }, deserialized));
            return [
                2,
                (0, $a08c2c31e27e9e11$export$db01f0c43e877a50)(exception, body)
            ];
        });
    });
};
var $cfad410b8d5507c4$var$deserializeAws_json1_1DeveloperUserAlreadyRegisteredExceptionResponse = function(parsedOutput, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var body, deserialized, exception;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            body = parsedOutput.body;
            deserialized = $cfad410b8d5507c4$var$deserializeAws_json1_1DeveloperUserAlreadyRegisteredException(body, context);
            exception = new (0, $5af132e3d8cbf992$export$f9e8c5d2069aeea4)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
                $metadata: $cfad410b8d5507c4$var$deserializeMetadata(parsedOutput)
            }, deserialized));
            return [
                2,
                (0, $a08c2c31e27e9e11$export$db01f0c43e877a50)(exception, body)
            ];
        });
    });
};
var $cfad410b8d5507c4$var$deserializeAws_json1_1ExternalServiceExceptionResponse = function(parsedOutput, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var body, deserialized, exception;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            body = parsedOutput.body;
            deserialized = $cfad410b8d5507c4$var$deserializeAws_json1_1ExternalServiceException(body, context);
            exception = new (0, $5af132e3d8cbf992$export$cb77a58cb7dbb17)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
                $metadata: $cfad410b8d5507c4$var$deserializeMetadata(parsedOutput)
            }, deserialized));
            return [
                2,
                (0, $a08c2c31e27e9e11$export$db01f0c43e877a50)(exception, body)
            ];
        });
    });
};
var $cfad410b8d5507c4$var$deserializeAws_json1_1InternalErrorExceptionResponse = function(parsedOutput, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var body, deserialized, exception;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            body = parsedOutput.body;
            deserialized = $cfad410b8d5507c4$var$deserializeAws_json1_1InternalErrorException(body, context);
            exception = new (0, $5af132e3d8cbf992$export$8b0f706f4df56c63)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
                $metadata: $cfad410b8d5507c4$var$deserializeMetadata(parsedOutput)
            }, deserialized));
            return [
                2,
                (0, $a08c2c31e27e9e11$export$db01f0c43e877a50)(exception, body)
            ];
        });
    });
};
var $cfad410b8d5507c4$var$deserializeAws_json1_1InvalidIdentityPoolConfigurationExceptionResponse = function(parsedOutput, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var body, deserialized, exception;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            body = parsedOutput.body;
            deserialized = $cfad410b8d5507c4$var$deserializeAws_json1_1InvalidIdentityPoolConfigurationException(body, context);
            exception = new (0, $5af132e3d8cbf992$export$90d12448d3766cda)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
                $metadata: $cfad410b8d5507c4$var$deserializeMetadata(parsedOutput)
            }, deserialized));
            return [
                2,
                (0, $a08c2c31e27e9e11$export$db01f0c43e877a50)(exception, body)
            ];
        });
    });
};
var $cfad410b8d5507c4$var$deserializeAws_json1_1InvalidParameterExceptionResponse = function(parsedOutput, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var body, deserialized, exception;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            body = parsedOutput.body;
            deserialized = $cfad410b8d5507c4$var$deserializeAws_json1_1InvalidParameterException(body, context);
            exception = new (0, $5af132e3d8cbf992$export$fa781b52e13bf866)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
                $metadata: $cfad410b8d5507c4$var$deserializeMetadata(parsedOutput)
            }, deserialized));
            return [
                2,
                (0, $a08c2c31e27e9e11$export$db01f0c43e877a50)(exception, body)
            ];
        });
    });
};
var $cfad410b8d5507c4$var$deserializeAws_json1_1LimitExceededExceptionResponse = function(parsedOutput, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var body, deserialized, exception;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            body = parsedOutput.body;
            deserialized = $cfad410b8d5507c4$var$deserializeAws_json1_1LimitExceededException(body, context);
            exception = new (0, $5af132e3d8cbf992$export$cd419aa7f32ec382)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
                $metadata: $cfad410b8d5507c4$var$deserializeMetadata(parsedOutput)
            }, deserialized));
            return [
                2,
                (0, $a08c2c31e27e9e11$export$db01f0c43e877a50)(exception, body)
            ];
        });
    });
};
var $cfad410b8d5507c4$var$deserializeAws_json1_1NotAuthorizedExceptionResponse = function(parsedOutput, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var body, deserialized, exception;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            body = parsedOutput.body;
            deserialized = $cfad410b8d5507c4$var$deserializeAws_json1_1NotAuthorizedException(body, context);
            exception = new (0, $5af132e3d8cbf992$export$82cff5e5a0a874dd)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
                $metadata: $cfad410b8d5507c4$var$deserializeMetadata(parsedOutput)
            }, deserialized));
            return [
                2,
                (0, $a08c2c31e27e9e11$export$db01f0c43e877a50)(exception, body)
            ];
        });
    });
};
var $cfad410b8d5507c4$var$deserializeAws_json1_1ResourceConflictExceptionResponse = function(parsedOutput, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var body, deserialized, exception;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            body = parsedOutput.body;
            deserialized = $cfad410b8d5507c4$var$deserializeAws_json1_1ResourceConflictException(body, context);
            exception = new (0, $5af132e3d8cbf992$export$cbdaf31887dd0603)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
                $metadata: $cfad410b8d5507c4$var$deserializeMetadata(parsedOutput)
            }, deserialized));
            return [
                2,
                (0, $a08c2c31e27e9e11$export$db01f0c43e877a50)(exception, body)
            ];
        });
    });
};
var $cfad410b8d5507c4$var$deserializeAws_json1_1ResourceNotFoundExceptionResponse = function(parsedOutput, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var body, deserialized, exception;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            body = parsedOutput.body;
            deserialized = $cfad410b8d5507c4$var$deserializeAws_json1_1ResourceNotFoundException(body, context);
            exception = new (0, $5af132e3d8cbf992$export$ecba565262f8bb2)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
                $metadata: $cfad410b8d5507c4$var$deserializeMetadata(parsedOutput)
            }, deserialized));
            return [
                2,
                (0, $a08c2c31e27e9e11$export$db01f0c43e877a50)(exception, body)
            ];
        });
    });
};
var $cfad410b8d5507c4$var$deserializeAws_json1_1TooManyRequestsExceptionResponse = function(parsedOutput, context) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var body, deserialized, exception;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            body = parsedOutput.body;
            deserialized = $cfad410b8d5507c4$var$deserializeAws_json1_1TooManyRequestsException(body, context);
            exception = new (0, $5af132e3d8cbf992$export$4a67805ad445f61)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
                $metadata: $cfad410b8d5507c4$var$deserializeMetadata(parsedOutput)
            }, deserialized));
            return [
                2,
                (0, $a08c2c31e27e9e11$export$db01f0c43e877a50)(exception, body)
            ];
        });
    });
};
var $cfad410b8d5507c4$var$serializeAws_json1_1CognitoIdentityProvider = function(input, context) {
    return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, input.ClientId !== undefined && input.ClientId !== null && {
        ClientId: input.ClientId
    }), input.ProviderName !== undefined && input.ProviderName !== null && {
        ProviderName: input.ProviderName
    }), input.ServerSideTokenCheck !== undefined && input.ServerSideTokenCheck !== null && {
        ServerSideTokenCheck: input.ServerSideTokenCheck
    });
};
var $cfad410b8d5507c4$var$serializeAws_json1_1CognitoIdentityProviderList = function(input, context) {
    return input.filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return $cfad410b8d5507c4$var$serializeAws_json1_1CognitoIdentityProvider(entry, context);
    });
};
var $cfad410b8d5507c4$var$serializeAws_json1_1CreateIdentityPoolInput = function(input, context) {
    return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, input.AllowClassicFlow !== undefined && input.AllowClassicFlow !== null && {
        AllowClassicFlow: input.AllowClassicFlow
    }), input.AllowUnauthenticatedIdentities !== undefined && input.AllowUnauthenticatedIdentities !== null && {
        AllowUnauthenticatedIdentities: input.AllowUnauthenticatedIdentities
    }), input.CognitoIdentityProviders !== undefined && input.CognitoIdentityProviders !== null && {
        CognitoIdentityProviders: $cfad410b8d5507c4$var$serializeAws_json1_1CognitoIdentityProviderList(input.CognitoIdentityProviders, context)
    }), input.DeveloperProviderName !== undefined && input.DeveloperProviderName !== null && {
        DeveloperProviderName: input.DeveloperProviderName
    }), input.IdentityPoolName !== undefined && input.IdentityPoolName !== null && {
        IdentityPoolName: input.IdentityPoolName
    }), input.IdentityPoolTags !== undefined && input.IdentityPoolTags !== null && {
        IdentityPoolTags: $cfad410b8d5507c4$var$serializeAws_json1_1IdentityPoolTagsType(input.IdentityPoolTags, context)
    }), input.OpenIdConnectProviderARNs !== undefined && input.OpenIdConnectProviderARNs !== null && {
        OpenIdConnectProviderARNs: $cfad410b8d5507c4$var$serializeAws_json1_1OIDCProviderList(input.OpenIdConnectProviderARNs, context)
    }), input.SamlProviderARNs !== undefined && input.SamlProviderARNs !== null && {
        SamlProviderARNs: $cfad410b8d5507c4$var$serializeAws_json1_1SAMLProviderList(input.SamlProviderARNs, context)
    }), input.SupportedLoginProviders !== undefined && input.SupportedLoginProviders !== null && {
        SupportedLoginProviders: $cfad410b8d5507c4$var$serializeAws_json1_1IdentityProviders(input.SupportedLoginProviders, context)
    });
};
var $cfad410b8d5507c4$var$serializeAws_json1_1DeleteIdentitiesInput = function(input, context) {
    return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, input.IdentityIdsToDelete !== undefined && input.IdentityIdsToDelete !== null && {
        IdentityIdsToDelete: $cfad410b8d5507c4$var$serializeAws_json1_1IdentityIdList(input.IdentityIdsToDelete, context)
    });
};
var $cfad410b8d5507c4$var$serializeAws_json1_1DeleteIdentityPoolInput = function(input, context) {
    return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, input.IdentityPoolId !== undefined && input.IdentityPoolId !== null && {
        IdentityPoolId: input.IdentityPoolId
    });
};
var $cfad410b8d5507c4$var$serializeAws_json1_1DescribeIdentityInput = function(input, context) {
    return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, input.IdentityId !== undefined && input.IdentityId !== null && {
        IdentityId: input.IdentityId
    });
};
var $cfad410b8d5507c4$var$serializeAws_json1_1DescribeIdentityPoolInput = function(input, context) {
    return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, input.IdentityPoolId !== undefined && input.IdentityPoolId !== null && {
        IdentityPoolId: input.IdentityPoolId
    });
};
var $cfad410b8d5507c4$var$serializeAws_json1_1GetCredentialsForIdentityInput = function(input, context) {
    return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, input.CustomRoleArn !== undefined && input.CustomRoleArn !== null && {
        CustomRoleArn: input.CustomRoleArn
    }), input.IdentityId !== undefined && input.IdentityId !== null && {
        IdentityId: input.IdentityId
    }), input.Logins !== undefined && input.Logins !== null && {
        Logins: $cfad410b8d5507c4$var$serializeAws_json1_1LoginsMap(input.Logins, context)
    });
};
var $cfad410b8d5507c4$var$serializeAws_json1_1GetIdentityPoolRolesInput = function(input, context) {
    return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, input.IdentityPoolId !== undefined && input.IdentityPoolId !== null && {
        IdentityPoolId: input.IdentityPoolId
    });
};
var $cfad410b8d5507c4$var$serializeAws_json1_1GetIdInput = function(input, context) {
    return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, input.AccountId !== undefined && input.AccountId !== null && {
        AccountId: input.AccountId
    }), input.IdentityPoolId !== undefined && input.IdentityPoolId !== null && {
        IdentityPoolId: input.IdentityPoolId
    }), input.Logins !== undefined && input.Logins !== null && {
        Logins: $cfad410b8d5507c4$var$serializeAws_json1_1LoginsMap(input.Logins, context)
    });
};
var $cfad410b8d5507c4$var$serializeAws_json1_1GetOpenIdTokenForDeveloperIdentityInput = function(input, context) {
    return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, input.IdentityId !== undefined && input.IdentityId !== null && {
        IdentityId: input.IdentityId
    }), input.IdentityPoolId !== undefined && input.IdentityPoolId !== null && {
        IdentityPoolId: input.IdentityPoolId
    }), input.Logins !== undefined && input.Logins !== null && {
        Logins: $cfad410b8d5507c4$var$serializeAws_json1_1LoginsMap(input.Logins, context)
    }), input.PrincipalTags !== undefined && input.PrincipalTags !== null && {
        PrincipalTags: $cfad410b8d5507c4$var$serializeAws_json1_1PrincipalTags(input.PrincipalTags, context)
    }), input.TokenDuration !== undefined && input.TokenDuration !== null && {
        TokenDuration: input.TokenDuration
    });
};
var $cfad410b8d5507c4$var$serializeAws_json1_1GetOpenIdTokenInput = function(input, context) {
    return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, input.IdentityId !== undefined && input.IdentityId !== null && {
        IdentityId: input.IdentityId
    }), input.Logins !== undefined && input.Logins !== null && {
        Logins: $cfad410b8d5507c4$var$serializeAws_json1_1LoginsMap(input.Logins, context)
    });
};
var $cfad410b8d5507c4$var$serializeAws_json1_1GetPrincipalTagAttributeMapInput = function(input, context) {
    return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, input.IdentityPoolId !== undefined && input.IdentityPoolId !== null && {
        IdentityPoolId: input.IdentityPoolId
    }), input.IdentityProviderName !== undefined && input.IdentityProviderName !== null && {
        IdentityProviderName: input.IdentityProviderName
    });
};
var $cfad410b8d5507c4$var$serializeAws_json1_1IdentityIdList = function(input, context) {
    return input.filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return entry;
    });
};
var $cfad410b8d5507c4$var$serializeAws_json1_1IdentityPool = function(input, context) {
    return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, input.AllowClassicFlow !== undefined && input.AllowClassicFlow !== null && {
        AllowClassicFlow: input.AllowClassicFlow
    }), input.AllowUnauthenticatedIdentities !== undefined && input.AllowUnauthenticatedIdentities !== null && {
        AllowUnauthenticatedIdentities: input.AllowUnauthenticatedIdentities
    }), input.CognitoIdentityProviders !== undefined && input.CognitoIdentityProviders !== null && {
        CognitoIdentityProviders: $cfad410b8d5507c4$var$serializeAws_json1_1CognitoIdentityProviderList(input.CognitoIdentityProviders, context)
    }), input.DeveloperProviderName !== undefined && input.DeveloperProviderName !== null && {
        DeveloperProviderName: input.DeveloperProviderName
    }), input.IdentityPoolId !== undefined && input.IdentityPoolId !== null && {
        IdentityPoolId: input.IdentityPoolId
    }), input.IdentityPoolName !== undefined && input.IdentityPoolName !== null && {
        IdentityPoolName: input.IdentityPoolName
    }), input.IdentityPoolTags !== undefined && input.IdentityPoolTags !== null && {
        IdentityPoolTags: $cfad410b8d5507c4$var$serializeAws_json1_1IdentityPoolTagsType(input.IdentityPoolTags, context)
    }), input.OpenIdConnectProviderARNs !== undefined && input.OpenIdConnectProviderARNs !== null && {
        OpenIdConnectProviderARNs: $cfad410b8d5507c4$var$serializeAws_json1_1OIDCProviderList(input.OpenIdConnectProviderARNs, context)
    }), input.SamlProviderARNs !== undefined && input.SamlProviderARNs !== null && {
        SamlProviderARNs: $cfad410b8d5507c4$var$serializeAws_json1_1SAMLProviderList(input.SamlProviderARNs, context)
    }), input.SupportedLoginProviders !== undefined && input.SupportedLoginProviders !== null && {
        SupportedLoginProviders: $cfad410b8d5507c4$var$serializeAws_json1_1IdentityProviders(input.SupportedLoginProviders, context)
    });
};
var $cfad410b8d5507c4$var$serializeAws_json1_1IdentityPoolTagsListType = function(input, context) {
    return input.filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return entry;
    });
};
var $cfad410b8d5507c4$var$serializeAws_json1_1IdentityPoolTagsType = function(input, context) {
    return Object.entries(input).reduce(function(acc, _a) {
        var _b;
        var _c = (0, $5c96a02c592fcff1$export$8d051b38c9118094)(_a, 2), key = _c[0], value = _c[1];
        if (value === null) return acc;
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, acc), (_b = {}, _b[key] = value, _b));
    }, {});
};
var $cfad410b8d5507c4$var$serializeAws_json1_1IdentityProviders = function(input, context) {
    return Object.entries(input).reduce(function(acc, _a) {
        var _b;
        var _c = (0, $5c96a02c592fcff1$export$8d051b38c9118094)(_a, 2), key = _c[0], value = _c[1];
        if (value === null) return acc;
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, acc), (_b = {}, _b[key] = value, _b));
    }, {});
};
var $cfad410b8d5507c4$var$serializeAws_json1_1ListIdentitiesInput = function(input, context) {
    return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, input.HideDisabled !== undefined && input.HideDisabled !== null && {
        HideDisabled: input.HideDisabled
    }), input.IdentityPoolId !== undefined && input.IdentityPoolId !== null && {
        IdentityPoolId: input.IdentityPoolId
    }), input.MaxResults !== undefined && input.MaxResults !== null && {
        MaxResults: input.MaxResults
    }), input.NextToken !== undefined && input.NextToken !== null && {
        NextToken: input.NextToken
    });
};
var $cfad410b8d5507c4$var$serializeAws_json1_1ListIdentityPoolsInput = function(input, context) {
    return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, input.MaxResults !== undefined && input.MaxResults !== null && {
        MaxResults: input.MaxResults
    }), input.NextToken !== undefined && input.NextToken !== null && {
        NextToken: input.NextToken
    });
};
var $cfad410b8d5507c4$var$serializeAws_json1_1ListTagsForResourceInput = function(input, context) {
    return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, input.ResourceArn !== undefined && input.ResourceArn !== null && {
        ResourceArn: input.ResourceArn
    });
};
var $cfad410b8d5507c4$var$serializeAws_json1_1LoginsList = function(input, context) {
    return input.filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return entry;
    });
};
var $cfad410b8d5507c4$var$serializeAws_json1_1LoginsMap = function(input, context) {
    return Object.entries(input).reduce(function(acc, _a) {
        var _b;
        var _c = (0, $5c96a02c592fcff1$export$8d051b38c9118094)(_a, 2), key = _c[0], value = _c[1];
        if (value === null) return acc;
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, acc), (_b = {}, _b[key] = value, _b));
    }, {});
};
var $cfad410b8d5507c4$var$serializeAws_json1_1LookupDeveloperIdentityInput = function(input, context) {
    return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, input.DeveloperUserIdentifier !== undefined && input.DeveloperUserIdentifier !== null && {
        DeveloperUserIdentifier: input.DeveloperUserIdentifier
    }), input.IdentityId !== undefined && input.IdentityId !== null && {
        IdentityId: input.IdentityId
    }), input.IdentityPoolId !== undefined && input.IdentityPoolId !== null && {
        IdentityPoolId: input.IdentityPoolId
    }), input.MaxResults !== undefined && input.MaxResults !== null && {
        MaxResults: input.MaxResults
    }), input.NextToken !== undefined && input.NextToken !== null && {
        NextToken: input.NextToken
    });
};
var $cfad410b8d5507c4$var$serializeAws_json1_1MappingRule = function(input, context) {
    return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, input.Claim !== undefined && input.Claim !== null && {
        Claim: input.Claim
    }), input.MatchType !== undefined && input.MatchType !== null && {
        MatchType: input.MatchType
    }), input.RoleARN !== undefined && input.RoleARN !== null && {
        RoleARN: input.RoleARN
    }), input.Value !== undefined && input.Value !== null && {
        Value: input.Value
    });
};
var $cfad410b8d5507c4$var$serializeAws_json1_1MappingRulesList = function(input, context) {
    return input.filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return $cfad410b8d5507c4$var$serializeAws_json1_1MappingRule(entry, context);
    });
};
var $cfad410b8d5507c4$var$serializeAws_json1_1MergeDeveloperIdentitiesInput = function(input, context) {
    return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, input.DestinationUserIdentifier !== undefined && input.DestinationUserIdentifier !== null && {
        DestinationUserIdentifier: input.DestinationUserIdentifier
    }), input.DeveloperProviderName !== undefined && input.DeveloperProviderName !== null && {
        DeveloperProviderName: input.DeveloperProviderName
    }), input.IdentityPoolId !== undefined && input.IdentityPoolId !== null && {
        IdentityPoolId: input.IdentityPoolId
    }), input.SourceUserIdentifier !== undefined && input.SourceUserIdentifier !== null && {
        SourceUserIdentifier: input.SourceUserIdentifier
    });
};
var $cfad410b8d5507c4$var$serializeAws_json1_1OIDCProviderList = function(input, context) {
    return input.filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return entry;
    });
};
var $cfad410b8d5507c4$var$serializeAws_json1_1PrincipalTags = function(input, context) {
    return Object.entries(input).reduce(function(acc, _a) {
        var _b;
        var _c = (0, $5c96a02c592fcff1$export$8d051b38c9118094)(_a, 2), key = _c[0], value = _c[1];
        if (value === null) return acc;
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, acc), (_b = {}, _b[key] = value, _b));
    }, {});
};
var $cfad410b8d5507c4$var$serializeAws_json1_1RoleMapping = function(input, context) {
    return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, input.AmbiguousRoleResolution !== undefined && input.AmbiguousRoleResolution !== null && {
        AmbiguousRoleResolution: input.AmbiguousRoleResolution
    }), input.RulesConfiguration !== undefined && input.RulesConfiguration !== null && {
        RulesConfiguration: $cfad410b8d5507c4$var$serializeAws_json1_1RulesConfigurationType(input.RulesConfiguration, context)
    }), input.Type !== undefined && input.Type !== null && {
        Type: input.Type
    });
};
var $cfad410b8d5507c4$var$serializeAws_json1_1RoleMappingMap = function(input, context) {
    return Object.entries(input).reduce(function(acc, _a) {
        var _b;
        var _c = (0, $5c96a02c592fcff1$export$8d051b38c9118094)(_a, 2), key = _c[0], value = _c[1];
        if (value === null) return acc;
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, acc), (_b = {}, _b[key] = $cfad410b8d5507c4$var$serializeAws_json1_1RoleMapping(value, context), _b));
    }, {});
};
var $cfad410b8d5507c4$var$serializeAws_json1_1RolesMap = function(input, context) {
    return Object.entries(input).reduce(function(acc, _a) {
        var _b;
        var _c = (0, $5c96a02c592fcff1$export$8d051b38c9118094)(_a, 2), key = _c[0], value = _c[1];
        if (value === null) return acc;
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, acc), (_b = {}, _b[key] = value, _b));
    }, {});
};
var $cfad410b8d5507c4$var$serializeAws_json1_1RulesConfigurationType = function(input, context) {
    return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, input.Rules !== undefined && input.Rules !== null && {
        Rules: $cfad410b8d5507c4$var$serializeAws_json1_1MappingRulesList(input.Rules, context)
    });
};
var $cfad410b8d5507c4$var$serializeAws_json1_1SAMLProviderList = function(input, context) {
    return input.filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return entry;
    });
};
var $cfad410b8d5507c4$var$serializeAws_json1_1SetIdentityPoolRolesInput = function(input, context) {
    return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, input.IdentityPoolId !== undefined && input.IdentityPoolId !== null && {
        IdentityPoolId: input.IdentityPoolId
    }), input.RoleMappings !== undefined && input.RoleMappings !== null && {
        RoleMappings: $cfad410b8d5507c4$var$serializeAws_json1_1RoleMappingMap(input.RoleMappings, context)
    }), input.Roles !== undefined && input.Roles !== null && {
        Roles: $cfad410b8d5507c4$var$serializeAws_json1_1RolesMap(input.Roles, context)
    });
};
var $cfad410b8d5507c4$var$serializeAws_json1_1SetPrincipalTagAttributeMapInput = function(input, context) {
    return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, input.IdentityPoolId !== undefined && input.IdentityPoolId !== null && {
        IdentityPoolId: input.IdentityPoolId
    }), input.IdentityProviderName !== undefined && input.IdentityProviderName !== null && {
        IdentityProviderName: input.IdentityProviderName
    }), input.PrincipalTags !== undefined && input.PrincipalTags !== null && {
        PrincipalTags: $cfad410b8d5507c4$var$serializeAws_json1_1PrincipalTags(input.PrincipalTags, context)
    }), input.UseDefaults !== undefined && input.UseDefaults !== null && {
        UseDefaults: input.UseDefaults
    });
};
var $cfad410b8d5507c4$var$serializeAws_json1_1TagResourceInput = function(input, context) {
    return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, input.ResourceArn !== undefined && input.ResourceArn !== null && {
        ResourceArn: input.ResourceArn
    }), input.Tags !== undefined && input.Tags !== null && {
        Tags: $cfad410b8d5507c4$var$serializeAws_json1_1IdentityPoolTagsType(input.Tags, context)
    });
};
var $cfad410b8d5507c4$var$serializeAws_json1_1UnlinkDeveloperIdentityInput = function(input, context) {
    return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, input.DeveloperProviderName !== undefined && input.DeveloperProviderName !== null && {
        DeveloperProviderName: input.DeveloperProviderName
    }), input.DeveloperUserIdentifier !== undefined && input.DeveloperUserIdentifier !== null && {
        DeveloperUserIdentifier: input.DeveloperUserIdentifier
    }), input.IdentityId !== undefined && input.IdentityId !== null && {
        IdentityId: input.IdentityId
    }), input.IdentityPoolId !== undefined && input.IdentityPoolId !== null && {
        IdentityPoolId: input.IdentityPoolId
    });
};
var $cfad410b8d5507c4$var$serializeAws_json1_1UnlinkIdentityInput = function(input, context) {
    return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, input.IdentityId !== undefined && input.IdentityId !== null && {
        IdentityId: input.IdentityId
    }), input.Logins !== undefined && input.Logins !== null && {
        Logins: $cfad410b8d5507c4$var$serializeAws_json1_1LoginsMap(input.Logins, context)
    }), input.LoginsToRemove !== undefined && input.LoginsToRemove !== null && {
        LoginsToRemove: $cfad410b8d5507c4$var$serializeAws_json1_1LoginsList(input.LoginsToRemove, context)
    });
};
var $cfad410b8d5507c4$var$serializeAws_json1_1UntagResourceInput = function(input, context) {
    return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, input.ResourceArn !== undefined && input.ResourceArn !== null && {
        ResourceArn: input.ResourceArn
    }), input.TagKeys !== undefined && input.TagKeys !== null && {
        TagKeys: $cfad410b8d5507c4$var$serializeAws_json1_1IdentityPoolTagsListType(input.TagKeys, context)
    });
};
var $cfad410b8d5507c4$var$deserializeAws_json1_1CognitoIdentityProvider = function(output, context) {
    return {
        ClientId: (0, $326143e959bb2a25$export$7ed80f53fe336639)(output.ClientId),
        ProviderName: (0, $326143e959bb2a25$export$7ed80f53fe336639)(output.ProviderName),
        ServerSideTokenCheck: (0, $326143e959bb2a25$export$259b2ebfc29bf466)(output.ServerSideTokenCheck)
    };
};
var $cfad410b8d5507c4$var$deserializeAws_json1_1CognitoIdentityProviderList = function(output, context) {
    var retVal = (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return $cfad410b8d5507c4$var$deserializeAws_json1_1CognitoIdentityProvider(entry, context);
    });
    return retVal;
};
var $cfad410b8d5507c4$var$deserializeAws_json1_1ConcurrentModificationException = function(output, context) {
    return {
        message: (0, $326143e959bb2a25$export$7ed80f53fe336639)(output.message)
    };
};
var $cfad410b8d5507c4$var$deserializeAws_json1_1Credentials = function(output, context) {
    return {
        AccessKeyId: (0, $326143e959bb2a25$export$7ed80f53fe336639)(output.AccessKeyId),
        Expiration: output.Expiration !== undefined && output.Expiration !== null ? (0, $326143e959bb2a25$export$8413a63dbe548a49)((0, $e742001d39531b4d$export$685da212e4e79e10)((0, $326143e959bb2a25$export$f3945e48fdb5f9a)(output.Expiration))) : undefined,
        SecretKey: (0, $326143e959bb2a25$export$7ed80f53fe336639)(output.SecretKey),
        SessionToken: (0, $326143e959bb2a25$export$7ed80f53fe336639)(output.SessionToken)
    };
};
var $cfad410b8d5507c4$var$deserializeAws_json1_1DeleteIdentitiesResponse = function(output, context) {
    return {
        UnprocessedIdentityIds: output.UnprocessedIdentityIds !== undefined && output.UnprocessedIdentityIds !== null ? $cfad410b8d5507c4$var$deserializeAws_json1_1UnprocessedIdentityIdList(output.UnprocessedIdentityIds, context) : undefined
    };
};
var $cfad410b8d5507c4$var$deserializeAws_json1_1DeveloperUserAlreadyRegisteredException = function(output, context) {
    return {
        message: (0, $326143e959bb2a25$export$7ed80f53fe336639)(output.message)
    };
};
var $cfad410b8d5507c4$var$deserializeAws_json1_1DeveloperUserIdentifierList = function(output, context) {
    var retVal = (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return (0, $326143e959bb2a25$export$7ed80f53fe336639)(entry);
    });
    return retVal;
};
var $cfad410b8d5507c4$var$deserializeAws_json1_1ExternalServiceException = function(output, context) {
    return {
        message: (0, $326143e959bb2a25$export$7ed80f53fe336639)(output.message)
    };
};
var $cfad410b8d5507c4$var$deserializeAws_json1_1GetCredentialsForIdentityResponse = function(output, context) {
    return {
        Credentials: output.Credentials !== undefined && output.Credentials !== null ? $cfad410b8d5507c4$var$deserializeAws_json1_1Credentials(output.Credentials, context) : undefined,
        IdentityId: (0, $326143e959bb2a25$export$7ed80f53fe336639)(output.IdentityId)
    };
};
var $cfad410b8d5507c4$var$deserializeAws_json1_1GetIdentityPoolRolesResponse = function(output, context) {
    return {
        IdentityPoolId: (0, $326143e959bb2a25$export$7ed80f53fe336639)(output.IdentityPoolId),
        RoleMappings: output.RoleMappings !== undefined && output.RoleMappings !== null ? $cfad410b8d5507c4$var$deserializeAws_json1_1RoleMappingMap(output.RoleMappings, context) : undefined,
        Roles: output.Roles !== undefined && output.Roles !== null ? $cfad410b8d5507c4$var$deserializeAws_json1_1RolesMap(output.Roles, context) : undefined
    };
};
var $cfad410b8d5507c4$var$deserializeAws_json1_1GetIdResponse = function(output, context) {
    return {
        IdentityId: (0, $326143e959bb2a25$export$7ed80f53fe336639)(output.IdentityId)
    };
};
var $cfad410b8d5507c4$var$deserializeAws_json1_1GetOpenIdTokenForDeveloperIdentityResponse = function(output, context) {
    return {
        IdentityId: (0, $326143e959bb2a25$export$7ed80f53fe336639)(output.IdentityId),
        Token: (0, $326143e959bb2a25$export$7ed80f53fe336639)(output.Token)
    };
};
var $cfad410b8d5507c4$var$deserializeAws_json1_1GetOpenIdTokenResponse = function(output, context) {
    return {
        IdentityId: (0, $326143e959bb2a25$export$7ed80f53fe336639)(output.IdentityId),
        Token: (0, $326143e959bb2a25$export$7ed80f53fe336639)(output.Token)
    };
};
var $cfad410b8d5507c4$var$deserializeAws_json1_1GetPrincipalTagAttributeMapResponse = function(output, context) {
    return {
        IdentityPoolId: (0, $326143e959bb2a25$export$7ed80f53fe336639)(output.IdentityPoolId),
        IdentityProviderName: (0, $326143e959bb2a25$export$7ed80f53fe336639)(output.IdentityProviderName),
        PrincipalTags: output.PrincipalTags !== undefined && output.PrincipalTags !== null ? $cfad410b8d5507c4$var$deserializeAws_json1_1PrincipalTags(output.PrincipalTags, context) : undefined,
        UseDefaults: (0, $326143e959bb2a25$export$259b2ebfc29bf466)(output.UseDefaults)
    };
};
var $cfad410b8d5507c4$var$deserializeAws_json1_1IdentitiesList = function(output, context) {
    var retVal = (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return $cfad410b8d5507c4$var$deserializeAws_json1_1IdentityDescription(entry, context);
    });
    return retVal;
};
var $cfad410b8d5507c4$var$deserializeAws_json1_1IdentityDescription = function(output, context) {
    return {
        CreationDate: output.CreationDate !== undefined && output.CreationDate !== null ? (0, $326143e959bb2a25$export$8413a63dbe548a49)((0, $e742001d39531b4d$export$685da212e4e79e10)((0, $326143e959bb2a25$export$f3945e48fdb5f9a)(output.CreationDate))) : undefined,
        IdentityId: (0, $326143e959bb2a25$export$7ed80f53fe336639)(output.IdentityId),
        LastModifiedDate: output.LastModifiedDate !== undefined && output.LastModifiedDate !== null ? (0, $326143e959bb2a25$export$8413a63dbe548a49)((0, $e742001d39531b4d$export$685da212e4e79e10)((0, $326143e959bb2a25$export$f3945e48fdb5f9a)(output.LastModifiedDate))) : undefined,
        Logins: output.Logins !== undefined && output.Logins !== null ? $cfad410b8d5507c4$var$deserializeAws_json1_1LoginsList(output.Logins, context) : undefined
    };
};
var $cfad410b8d5507c4$var$deserializeAws_json1_1IdentityPool = function(output, context) {
    return {
        AllowClassicFlow: (0, $326143e959bb2a25$export$259b2ebfc29bf466)(output.AllowClassicFlow),
        AllowUnauthenticatedIdentities: (0, $326143e959bb2a25$export$259b2ebfc29bf466)(output.AllowUnauthenticatedIdentities),
        CognitoIdentityProviders: output.CognitoIdentityProviders !== undefined && output.CognitoIdentityProviders !== null ? $cfad410b8d5507c4$var$deserializeAws_json1_1CognitoIdentityProviderList(output.CognitoIdentityProviders, context) : undefined,
        DeveloperProviderName: (0, $326143e959bb2a25$export$7ed80f53fe336639)(output.DeveloperProviderName),
        IdentityPoolId: (0, $326143e959bb2a25$export$7ed80f53fe336639)(output.IdentityPoolId),
        IdentityPoolName: (0, $326143e959bb2a25$export$7ed80f53fe336639)(output.IdentityPoolName),
        IdentityPoolTags: output.IdentityPoolTags !== undefined && output.IdentityPoolTags !== null ? $cfad410b8d5507c4$var$deserializeAws_json1_1IdentityPoolTagsType(output.IdentityPoolTags, context) : undefined,
        OpenIdConnectProviderARNs: output.OpenIdConnectProviderARNs !== undefined && output.OpenIdConnectProviderARNs !== null ? $cfad410b8d5507c4$var$deserializeAws_json1_1OIDCProviderList(output.OpenIdConnectProviderARNs, context) : undefined,
        SamlProviderARNs: output.SamlProviderARNs !== undefined && output.SamlProviderARNs !== null ? $cfad410b8d5507c4$var$deserializeAws_json1_1SAMLProviderList(output.SamlProviderARNs, context) : undefined,
        SupportedLoginProviders: output.SupportedLoginProviders !== undefined && output.SupportedLoginProviders !== null ? $cfad410b8d5507c4$var$deserializeAws_json1_1IdentityProviders(output.SupportedLoginProviders, context) : undefined
    };
};
var $cfad410b8d5507c4$var$deserializeAws_json1_1IdentityPoolShortDescription = function(output, context) {
    return {
        IdentityPoolId: (0, $326143e959bb2a25$export$7ed80f53fe336639)(output.IdentityPoolId),
        IdentityPoolName: (0, $326143e959bb2a25$export$7ed80f53fe336639)(output.IdentityPoolName)
    };
};
var $cfad410b8d5507c4$var$deserializeAws_json1_1IdentityPoolsList = function(output, context) {
    var retVal = (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return $cfad410b8d5507c4$var$deserializeAws_json1_1IdentityPoolShortDescription(entry, context);
    });
    return retVal;
};
var $cfad410b8d5507c4$var$deserializeAws_json1_1IdentityPoolTagsType = function(output, context) {
    return Object.entries(output).reduce(function(acc, _a) {
        var _b;
        var _c = (0, $5c96a02c592fcff1$export$8d051b38c9118094)(_a, 2), key = _c[0], value = _c[1];
        if (value === null) return acc;
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, acc), (_b = {}, _b[key] = (0, $326143e959bb2a25$export$7ed80f53fe336639)(value), _b));
    }, {});
};
var $cfad410b8d5507c4$var$deserializeAws_json1_1IdentityProviders = function(output, context) {
    return Object.entries(output).reduce(function(acc, _a) {
        var _b;
        var _c = (0, $5c96a02c592fcff1$export$8d051b38c9118094)(_a, 2), key = _c[0], value = _c[1];
        if (value === null) return acc;
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, acc), (_b = {}, _b[key] = (0, $326143e959bb2a25$export$7ed80f53fe336639)(value), _b));
    }, {});
};
var $cfad410b8d5507c4$var$deserializeAws_json1_1InternalErrorException = function(output, context) {
    return {
        message: (0, $326143e959bb2a25$export$7ed80f53fe336639)(output.message)
    };
};
var $cfad410b8d5507c4$var$deserializeAws_json1_1InvalidIdentityPoolConfigurationException = function(output, context) {
    return {
        message: (0, $326143e959bb2a25$export$7ed80f53fe336639)(output.message)
    };
};
var $cfad410b8d5507c4$var$deserializeAws_json1_1InvalidParameterException = function(output, context) {
    return {
        message: (0, $326143e959bb2a25$export$7ed80f53fe336639)(output.message)
    };
};
var $cfad410b8d5507c4$var$deserializeAws_json1_1LimitExceededException = function(output, context) {
    return {
        message: (0, $326143e959bb2a25$export$7ed80f53fe336639)(output.message)
    };
};
var $cfad410b8d5507c4$var$deserializeAws_json1_1ListIdentitiesResponse = function(output, context) {
    return {
        Identities: output.Identities !== undefined && output.Identities !== null ? $cfad410b8d5507c4$var$deserializeAws_json1_1IdentitiesList(output.Identities, context) : undefined,
        IdentityPoolId: (0, $326143e959bb2a25$export$7ed80f53fe336639)(output.IdentityPoolId),
        NextToken: (0, $326143e959bb2a25$export$7ed80f53fe336639)(output.NextToken)
    };
};
var $cfad410b8d5507c4$var$deserializeAws_json1_1ListIdentityPoolsResponse = function(output, context) {
    return {
        IdentityPools: output.IdentityPools !== undefined && output.IdentityPools !== null ? $cfad410b8d5507c4$var$deserializeAws_json1_1IdentityPoolsList(output.IdentityPools, context) : undefined,
        NextToken: (0, $326143e959bb2a25$export$7ed80f53fe336639)(output.NextToken)
    };
};
var $cfad410b8d5507c4$var$deserializeAws_json1_1ListTagsForResourceResponse = function(output, context) {
    return {
        Tags: output.Tags !== undefined && output.Tags !== null ? $cfad410b8d5507c4$var$deserializeAws_json1_1IdentityPoolTagsType(output.Tags, context) : undefined
    };
};
var $cfad410b8d5507c4$var$deserializeAws_json1_1LoginsList = function(output, context) {
    var retVal = (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return (0, $326143e959bb2a25$export$7ed80f53fe336639)(entry);
    });
    return retVal;
};
var $cfad410b8d5507c4$var$deserializeAws_json1_1LookupDeveloperIdentityResponse = function(output, context) {
    return {
        DeveloperUserIdentifierList: output.DeveloperUserIdentifierList !== undefined && output.DeveloperUserIdentifierList !== null ? $cfad410b8d5507c4$var$deserializeAws_json1_1DeveloperUserIdentifierList(output.DeveloperUserIdentifierList, context) : undefined,
        IdentityId: (0, $326143e959bb2a25$export$7ed80f53fe336639)(output.IdentityId),
        NextToken: (0, $326143e959bb2a25$export$7ed80f53fe336639)(output.NextToken)
    };
};
var $cfad410b8d5507c4$var$deserializeAws_json1_1MappingRule = function(output, context) {
    return {
        Claim: (0, $326143e959bb2a25$export$7ed80f53fe336639)(output.Claim),
        MatchType: (0, $326143e959bb2a25$export$7ed80f53fe336639)(output.MatchType),
        RoleARN: (0, $326143e959bb2a25$export$7ed80f53fe336639)(output.RoleARN),
        Value: (0, $326143e959bb2a25$export$7ed80f53fe336639)(output.Value)
    };
};
var $cfad410b8d5507c4$var$deserializeAws_json1_1MappingRulesList = function(output, context) {
    var retVal = (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return $cfad410b8d5507c4$var$deserializeAws_json1_1MappingRule(entry, context);
    });
    return retVal;
};
var $cfad410b8d5507c4$var$deserializeAws_json1_1MergeDeveloperIdentitiesResponse = function(output, context) {
    return {
        IdentityId: (0, $326143e959bb2a25$export$7ed80f53fe336639)(output.IdentityId)
    };
};
var $cfad410b8d5507c4$var$deserializeAws_json1_1NotAuthorizedException = function(output, context) {
    return {
        message: (0, $326143e959bb2a25$export$7ed80f53fe336639)(output.message)
    };
};
var $cfad410b8d5507c4$var$deserializeAws_json1_1OIDCProviderList = function(output, context) {
    var retVal = (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return (0, $326143e959bb2a25$export$7ed80f53fe336639)(entry);
    });
    return retVal;
};
var $cfad410b8d5507c4$var$deserializeAws_json1_1PrincipalTags = function(output, context) {
    return Object.entries(output).reduce(function(acc, _a) {
        var _b;
        var _c = (0, $5c96a02c592fcff1$export$8d051b38c9118094)(_a, 2), key = _c[0], value = _c[1];
        if (value === null) return acc;
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, acc), (_b = {}, _b[key] = (0, $326143e959bb2a25$export$7ed80f53fe336639)(value), _b));
    }, {});
};
var $cfad410b8d5507c4$var$deserializeAws_json1_1ResourceConflictException = function(output, context) {
    return {
        message: (0, $326143e959bb2a25$export$7ed80f53fe336639)(output.message)
    };
};
var $cfad410b8d5507c4$var$deserializeAws_json1_1ResourceNotFoundException = function(output, context) {
    return {
        message: (0, $326143e959bb2a25$export$7ed80f53fe336639)(output.message)
    };
};
var $cfad410b8d5507c4$var$deserializeAws_json1_1RoleMapping = function(output, context) {
    return {
        AmbiguousRoleResolution: (0, $326143e959bb2a25$export$7ed80f53fe336639)(output.AmbiguousRoleResolution),
        RulesConfiguration: output.RulesConfiguration !== undefined && output.RulesConfiguration !== null ? $cfad410b8d5507c4$var$deserializeAws_json1_1RulesConfigurationType(output.RulesConfiguration, context) : undefined,
        Type: (0, $326143e959bb2a25$export$7ed80f53fe336639)(output.Type)
    };
};
var $cfad410b8d5507c4$var$deserializeAws_json1_1RoleMappingMap = function(output, context) {
    return Object.entries(output).reduce(function(acc, _a) {
        var _b;
        var _c = (0, $5c96a02c592fcff1$export$8d051b38c9118094)(_a, 2), key = _c[0], value = _c[1];
        if (value === null) return acc;
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, acc), (_b = {}, _b[key] = $cfad410b8d5507c4$var$deserializeAws_json1_1RoleMapping(value, context), _b));
    }, {});
};
var $cfad410b8d5507c4$var$deserializeAws_json1_1RolesMap = function(output, context) {
    return Object.entries(output).reduce(function(acc, _a) {
        var _b;
        var _c = (0, $5c96a02c592fcff1$export$8d051b38c9118094)(_a, 2), key = _c[0], value = _c[1];
        if (value === null) return acc;
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, acc), (_b = {}, _b[key] = (0, $326143e959bb2a25$export$7ed80f53fe336639)(value), _b));
    }, {});
};
var $cfad410b8d5507c4$var$deserializeAws_json1_1RulesConfigurationType = function(output, context) {
    return {
        Rules: output.Rules !== undefined && output.Rules !== null ? $cfad410b8d5507c4$var$deserializeAws_json1_1MappingRulesList(output.Rules, context) : undefined
    };
};
var $cfad410b8d5507c4$var$deserializeAws_json1_1SAMLProviderList = function(output, context) {
    var retVal = (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return (0, $326143e959bb2a25$export$7ed80f53fe336639)(entry);
    });
    return retVal;
};
var $cfad410b8d5507c4$var$deserializeAws_json1_1SetPrincipalTagAttributeMapResponse = function(output, context) {
    return {
        IdentityPoolId: (0, $326143e959bb2a25$export$7ed80f53fe336639)(output.IdentityPoolId),
        IdentityProviderName: (0, $326143e959bb2a25$export$7ed80f53fe336639)(output.IdentityProviderName),
        PrincipalTags: output.PrincipalTags !== undefined && output.PrincipalTags !== null ? $cfad410b8d5507c4$var$deserializeAws_json1_1PrincipalTags(output.PrincipalTags, context) : undefined,
        UseDefaults: (0, $326143e959bb2a25$export$259b2ebfc29bf466)(output.UseDefaults)
    };
};
var $cfad410b8d5507c4$var$deserializeAws_json1_1TagResourceResponse = function(output, context) {
    return {};
};
var $cfad410b8d5507c4$var$deserializeAws_json1_1TooManyRequestsException = function(output, context) {
    return {
        message: (0, $326143e959bb2a25$export$7ed80f53fe336639)(output.message)
    };
};
var $cfad410b8d5507c4$var$deserializeAws_json1_1UnprocessedIdentityId = function(output, context) {
    return {
        ErrorCode: (0, $326143e959bb2a25$export$7ed80f53fe336639)(output.ErrorCode),
        IdentityId: (0, $326143e959bb2a25$export$7ed80f53fe336639)(output.IdentityId)
    };
};
var $cfad410b8d5507c4$var$deserializeAws_json1_1UnprocessedIdentityIdList = function(output, context) {
    var retVal = (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return $cfad410b8d5507c4$var$deserializeAws_json1_1UnprocessedIdentityId(entry, context);
    });
    return retVal;
};
var $cfad410b8d5507c4$var$deserializeAws_json1_1UntagResourceResponse = function(output, context) {
    return {};
};
var $cfad410b8d5507c4$var$deserializeMetadata = function(output) {
    var _a;
    return {
        httpStatusCode: output.statusCode,
        requestId: (_a = output.headers["x-amzn-requestid"]) !== null && _a !== void 0 ? _a : output.headers["x-amzn-request-id"],
        extendedRequestId: output.headers["x-amz-id-2"],
        cfId: output.headers["x-amz-cf-id"]
    };
};
var $cfad410b8d5507c4$var$collectBody = function(streamBody, context) {
    if (streamBody === void 0) streamBody = new Uint8Array();
    if (streamBody instanceof Uint8Array) return Promise.resolve(streamBody);
    return context.streamCollector(streamBody) || Promise.resolve(new Uint8Array());
};
var $cfad410b8d5507c4$var$collectBodyString = function(streamBody, context) {
    return $cfad410b8d5507c4$var$collectBody(streamBody, context).then(function(body) {
        return context.utf8Encoder(body);
    });
};
var $cfad410b8d5507c4$var$buildHttpRpcRequest = function(context, headers, path, resolvedHostname, body) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var _a, hostname, _b, protocol, port, basePath, contents;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    return [
                        4,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                    contents = {
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "POST",
                        path: basePath.endsWith("/") ? basePath.slice(0, -1) + path : basePath + path,
                        headers: headers
                    };
                    if (resolvedHostname !== undefined) contents.hostname = resolvedHostname;
                    if (body !== undefined) contents.body = body;
                    return [
                        2,
                        new (0, $f5162dd3bdb0d175$export$7587955500404ec3)(contents)
                    ];
            }
        });
    });
};
var $cfad410b8d5507c4$var$parseBody = function(streamBody, context) {
    return $cfad410b8d5507c4$var$collectBodyString(streamBody, context).then(function(encoded) {
        if (encoded.length) return JSON.parse(encoded);
        return {};
    });
};
var $cfad410b8d5507c4$var$loadRestJsonErrorCode = function(output, data) {
    var findKey = function(object, key) {
        return Object.keys(object).find(function(k) {
            return k.toLowerCase() === key.toLowerCase();
        });
    };
    var sanitizeErrorCode = function(rawValue) {
        var cleanValue = rawValue;
        if (cleanValue.indexOf(":") >= 0) cleanValue = cleanValue.split(":")[0];
        if (cleanValue.indexOf("#") >= 0) cleanValue = cleanValue.split("#")[1];
        return cleanValue;
    };
    var headerKey = findKey(output.headers, "x-amzn-errortype");
    if (headerKey !== undefined) return sanitizeErrorCode(output.headers[headerKey]);
    if (data.code !== undefined) return sanitizeErrorCode(data.code);
    if (data["__type"] !== undefined) return sanitizeErrorCode(data["__type"]);
    return "";
};


var $db24def6e4715ab2$export$41ceb4ced4f97a44 = function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(GetIdCommand, _super);
    function GetIdCommand(input) {
        var _this = _super.call(this) || this;
        _this.input = input;
        return _this;
    }
    GetIdCommand.prototype.resolveMiddleware = function(clientStack, configuration, options) {
        this.middlewareStack.use((0, $eefacaa18209bd27$export$53fdc69654553fd4)(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "CognitoIdentityClient";
        var commandName = "GetIdCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: (0, $5af132e3d8cbf992$export$badc3094716a9faa).filterSensitiveLog,
            outputFilterSensitiveLog: (0, $5af132e3d8cbf992$export$c3ec238968a6e7ac).filterSensitiveLog
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function(request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    GetIdCommand.prototype.serialize = function(input, context) {
        return (0, $cfad410b8d5507c4$export$83083ba13837129b)(input, context);
    };
    GetIdCommand.prototype.deserialize = function(output, context) {
        return (0, $cfad410b8d5507c4$export$9f5769abdc93f0b4)(output, context);
    };
    return GetIdCommand;
}((0, $16f81f795382045c$export$cc7e12c76513e857));









var $3c92876a0fae5050$export$e08b3308c36761ec = function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(GetCredentialsForIdentityCommand, _super);
    function GetCredentialsForIdentityCommand(input) {
        var _this = _super.call(this) || this;
        _this.input = input;
        return _this;
    }
    GetCredentialsForIdentityCommand.prototype.resolveMiddleware = function(clientStack, configuration, options) {
        this.middlewareStack.use((0, $eefacaa18209bd27$export$53fdc69654553fd4)(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "CognitoIdentityClient";
        var commandName = "GetCredentialsForIdentityCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: (0, $5af132e3d8cbf992$export$bb51e43959182308).filterSensitiveLog,
            outputFilterSensitiveLog: (0, $5af132e3d8cbf992$export$ba56c4cb277a72f9).filterSensitiveLog
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function(request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    GetCredentialsForIdentityCommand.prototype.serialize = function(input, context) {
        return (0, $cfad410b8d5507c4$export$88af91ae17f8527c)(input, context);
    };
    GetCredentialsForIdentityCommand.prototype.deserialize = function(output, context) {
        return (0, $cfad410b8d5507c4$export$ebea9103431f9a50)(output, context);
    };
    return GetCredentialsForIdentityCommand;
}((0, $16f81f795382045c$export$cc7e12c76513e857));




function $ac46d88a0640756e$export$fb1e896f6704b6a6(logins) {
    return Promise.all(Object.keys(logins).reduce(function(arr, name) {
        var tokenOrProvider = logins[name];
        if (typeof tokenOrProvider === "string") arr.push([
            name,
            tokenOrProvider
        ]);
        else arr.push(tokenOrProvider().then(function(token) {
            return [
                name,
                token
            ];
        }));
        return arr;
    }, [])).then(function(resolvedPairs) {
        return resolvedPairs.reduce(function(logins, _a) {
            var _b = (0, $5c96a02c592fcff1$export$8d051b38c9118094)(_a, 2), key = _b[0], value = _b[1];
            logins[key] = value;
            return logins;
        }, {});
    });
}


function $ae6c81320172ffb3$export$4d624d71eb462130(parameters) {
    var _this = this;
    return function() {
        return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(_this, void 0, void 0, function() {
            var _a, _b, _c, AccessKeyId, Expiration, _d, SecretKey, SessionToken, _e, _f, _g, _h;
            var _j;
            return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_k) {
                switch(_k.label){
                    case 0:
                        _f = (_e = parameters.client).send;
                        _g = (0, $3c92876a0fae5050$export$e08b3308c36761ec).bind;
                        _j = {
                            CustomRoleArn: parameters.customRoleArn,
                            IdentityId: parameters.identityId
                        };
                        if (!parameters.logins) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            (0, $ac46d88a0640756e$export$fb1e896f6704b6a6)(parameters.logins)
                        ];
                    case 1:
                        _h = _k.sent();
                        return [
                            3,
                            3
                        ];
                    case 2:
                        _h = undefined;
                        _k.label = 3;
                    case 3:
                        return [
                            4,
                            _f.apply(_e, [
                                new (_g.apply((0, $3c92876a0fae5050$export$e08b3308c36761ec), [
                                    void 0,
                                    (_j.Logins = _h, _j)
                                ]))()
                            ])
                        ];
                    case 4:
                        _a = _k.sent().Credentials, _b = _a === void 0 ? $ae6c81320172ffb3$var$throwOnMissingCredentials() : _a, _c = _b.AccessKeyId, AccessKeyId = _c === void 0 ? $ae6c81320172ffb3$var$throwOnMissingAccessKeyId() : _c, Expiration = _b.Expiration, _d = _b.SecretKey, SecretKey = _d === void 0 ? $ae6c81320172ffb3$var$throwOnMissingSecretKey() : _d, SessionToken = _b.SessionToken;
                        return [
                            2,
                            {
                                identityId: parameters.identityId,
                                accessKeyId: AccessKeyId,
                                secretAccessKey: SecretKey,
                                sessionToken: SessionToken,
                                expiration: Expiration
                            }
                        ];
                }
            });
        });
    };
}
function $ae6c81320172ffb3$var$throwOnMissingAccessKeyId() {
    throw new (0, $8305e5b5474397a4$export$921076535eff0df5)("Response from Amazon Cognito contained no access key ID");
}
function $ae6c81320172ffb3$var$throwOnMissingCredentials() {
    throw new (0, $8305e5b5474397a4$export$921076535eff0df5)("Response from Amazon Cognito contained no credentials");
}
function $ae6c81320172ffb3$var$throwOnMissingSecretKey() {
    throw new (0, $8305e5b5474397a4$export$921076535eff0df5)("Response from Amazon Cognito contained no secret key");
}


var $247ad35f9b38e509$var$STORE_NAME = "IdentityIds";
var $247ad35f9b38e509$export$55d38e5384f402 = function() {
    function IndexedDbStorage(dbName) {
        if (dbName === void 0) dbName = "aws:cognito-identity-ids";
        this.dbName = dbName;
    }
    IndexedDbStorage.prototype.getItem = function(key) {
        return this.withObjectStore("readonly", function(store) {
            var req = store.get(key);
            return new Promise(function(resolve) {
                req.onerror = function() {
                    return resolve(null);
                };
                req.onsuccess = function() {
                    return resolve(req.result ? req.result.value : null);
                };
            });
        }).catch(function() {
            return null;
        });
    };
    IndexedDbStorage.prototype.removeItem = function(key) {
        return this.withObjectStore("readwrite", function(store) {
            var req = store.delete(key);
            return new Promise(function(resolve, reject) {
                req.onerror = function() {
                    return reject(req.error);
                };
                req.onsuccess = function() {
                    return resolve();
                };
            });
        });
    };
    IndexedDbStorage.prototype.setItem = function(id, value) {
        return this.withObjectStore("readwrite", function(store) {
            var req = store.put({
                id: id,
                value: value
            });
            return new Promise(function(resolve, reject) {
                req.onerror = function() {
                    return reject(req.error);
                };
                req.onsuccess = function() {
                    return resolve();
                };
            });
        });
    };
    IndexedDbStorage.prototype.getDb = function() {
        var openDbRequest = self.indexedDB.open(this.dbName, 1);
        return new Promise(function(resolve, reject) {
            openDbRequest.onsuccess = function() {
                resolve(openDbRequest.result);
            };
            openDbRequest.onerror = function() {
                reject(openDbRequest.error);
            };
            openDbRequest.onblocked = function() {
                reject(new Error("Unable to access DB"));
            };
            openDbRequest.onupgradeneeded = function() {
                var db = openDbRequest.result;
                db.onerror = function() {
                    reject(new Error("Failed to create object store"));
                };
                db.createObjectStore($247ad35f9b38e509$var$STORE_NAME, {
                    keyPath: "id"
                });
            };
        });
    };
    IndexedDbStorage.prototype.withObjectStore = function(mode, action) {
        return this.getDb().then(function(db) {
            var tx = db.transaction($247ad35f9b38e509$var$STORE_NAME, mode);
            tx.oncomplete = function() {
                return db.close();
            };
            return new Promise(function(resolve, reject) {
                tx.onerror = function() {
                    return reject(tx.error);
                };
                resolve(action(tx.objectStore($247ad35f9b38e509$var$STORE_NAME)));
            }).catch(function(err) {
                db.close();
                throw err;
            });
        });
    };
    return IndexedDbStorage;
}();


var $3d7491c03d6399c0$export$e4315e25b840a0ea = function() {
    function InMemoryStorage(store) {
        if (store === void 0) store = {};
        this.store = store;
    }
    InMemoryStorage.prototype.getItem = function(key) {
        if (key in this.store) return this.store[key];
        return null;
    };
    InMemoryStorage.prototype.removeItem = function(key) {
        delete this.store[key];
    };
    InMemoryStorage.prototype.setItem = function(key, value) {
        this.store[key] = value;
    };
    return InMemoryStorage;
}();


var $904bef45e8baf440$var$inMemoryStorage = new (0, $3d7491c03d6399c0$export$e4315e25b840a0ea)();
function $904bef45e8baf440$export$c2ed3351cac403d1() {
    if (typeof self === "object" && self.indexedDB) return new (0, $247ad35f9b38e509$export$55d38e5384f402)();
    if (typeof window === "object" && window.localStorage) return window.localStorage;
    return $904bef45e8baf440$var$inMemoryStorage;
}



function $1ef4a7e32f56801a$export$6c7d622e9507a2e(_a) {
    var _this = this;
    var accountId = _a.accountId, _b = _a.cache, cache = _b === void 0 ? (0, $904bef45e8baf440$export$c2ed3351cac403d1)() : _b, client = _a.client, customRoleArn = _a.customRoleArn, identityPoolId = _a.identityPoolId, logins = _a.logins, _c = _a.userIdentifier, userIdentifier = _c === void 0 ? !logins || Object.keys(logins).length === 0 ? "ANONYMOUS" : undefined : _c;
    var cacheKey = userIdentifier ? "aws:cognito-identity-credentials:" + identityPoolId + ":" + userIdentifier : undefined;
    var provider = function() {
        return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(_this, void 0, void 0, function() {
            var identityId, _a, _b, IdentityId, _c, _d, _e, _f;
            var _g;
            return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_h) {
                switch(_h.label){
                    case 0:
                        _a = cacheKey;
                        if (!_a) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            cache.getItem(cacheKey)
                        ];
                    case 1:
                        _a = _h.sent();
                        _h.label = 2;
                    case 2:
                        identityId = _a;
                        if (!!identityId) return [
                            3,
                            7
                        ];
                        _d = (_c = client).send;
                        _e = (0, $db24def6e4715ab2$export$41ceb4ced4f97a44).bind;
                        _g = {
                            AccountId: accountId,
                            IdentityPoolId: identityPoolId
                        };
                        if (!logins) return [
                            3,
                            4
                        ];
                        return [
                            4,
                            (0, $ac46d88a0640756e$export$fb1e896f6704b6a6)(logins)
                        ];
                    case 3:
                        _f = _h.sent();
                        return [
                            3,
                            5
                        ];
                    case 4:
                        _f = undefined;
                        _h.label = 5;
                    case 5:
                        return [
                            4,
                            _d.apply(_c, [
                                new (_e.apply((0, $db24def6e4715ab2$export$41ceb4ced4f97a44), [
                                    void 0,
                                    (_g.Logins = _f, _g)
                                ]))()
                            ])
                        ];
                    case 6:
                        _b = _h.sent().IdentityId, IdentityId = _b === void 0 ? $1ef4a7e32f56801a$var$throwOnMissingId() : _b;
                        identityId = IdentityId;
                        if (cacheKey) Promise.resolve(cache.setItem(cacheKey, identityId)).catch(function() {});
                        _h.label = 7;
                    case 7:
                        provider = (0, $ae6c81320172ffb3$export$4d624d71eb462130)({
                            client: client,
                            customRoleArn: customRoleArn,
                            logins: logins,
                            identityId: identityId
                        });
                        return [
                            2,
                            provider()
                        ];
                }
            });
        });
    };
    return function() {
        return provider().catch(function(err) {
            return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(_this, void 0, void 0, function() {
                return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
                    if (cacheKey) Promise.resolve(cache.removeItem(cacheKey)).catch(function() {});
                    throw err;
                });
            });
        });
    };
}
function $1ef4a7e32f56801a$var$throwOnMissingId() {
    throw new (0, $8305e5b5474397a4$export$921076535eff0df5)("Response from Amazon Cognito contained no identity ID");
}


const $86c9daca98c02fa6$var$RECIPIENTS = {
    "contactform": "arn:aws:sns:eu-west-1:590877988961:com-website-contact-form",
    "registerform": "arn:aws:sns:eu-west-1:590877988961:com-website-course-application"
};
class $86c9daca98c02fa6$export$52ccfc8a7ebbe38a {
    constructor(){
        const credentials = (0, $1ef4a7e32f56801a$export$6c7d622e9507a2e)({
            client: new (0, $f00bcaf3ba83febc$export$e576def690e850f7)({
                region: "eu-west-1"
            }),
            identityPoolId: "eu-west-1:93c29a9f-97a6-4497-b71e-0dae75743ddd"
        });
        this.snsClient = new (0, $508e2cccf97b518c$export$75bbeb40367748fc)({
            credentials: credentials,
            region: "eu-west-1"
        });
    }
    async sendEmail(recipient, subject, message) {
        let topic = $86c9daca98c02fa6$var$RECIPIENTS[recipient];
        if (!topic) throw new Error("Invalid recipient");
        else await this.snsClient.send(new (0, $96012f3c4ac8022e$export$493699ca2cf8254c)({
            Message: message,
            Subject: subject,
            TopicArn: topic
        }));
    }
}


window.addEventListener("DOMContentLoaded", ()=>{
    const emailService = new (0, $86c9daca98c02fa6$export$52ccfc8a7ebbe38a)();
    const contactForm = document.querySelector("#contact-form form");
    contactForm.addEventListener("submit", async (event)=>{
        event.preventDefault();
        let email = document.querySelector("#contact-form-email").value;
        let message = document.querySelector("#contact-form-message").value;
        let subject = `[Eyevinn Contact Form] <${email}> sent you a message`;
        let mailBody = "";
        mailBody += `From: ${email}\n`;
        mailBody += `User Agent: ${window.navigator.userAgent}\n`;
        mailBody += "\n";
        mailBody += `Message: ${message}\n`;
        const userFeedback = document.querySelector("#contact-form-user-feedback");
        try {
            await emailService.sendEmail("contactform", subject, mailBody);
        } catch (err) {
            console.error(err);
            userFeedback.innerHTML = "There was an issue sending your message, contact webmaster@eyevinn.se if the problem persists.";
        } finally{
            userFeedback.innerHTML = "Message has been sent. We will get back to you shortly";
            contactForm.reset();
        }
    });
    const contactFormContainer = document.querySelector("#contact-form");
    const contactFormButtonClose = document.querySelector("#contact-form-button-close");
    const contactFormButtonOpen = document.querySelector("#contact-form-button-open");
    contactFormButtonClose.addEventListener("click", ()=>{
        contactFormContainer.className = "collapsed";
        contactForm.style.display = "none";
        contactFormButtonOpen.style.display = "block";
    });
    contactFormButtonOpen.addEventListener("click", ()=>{
        contactFormContainer.className = "expanded";
        contactForm.style.display = "block";
        contactFormButtonOpen.style.display = "none";
    });
    contactFormContainer.className = "collapsed";
    contactForm.style.display = "none";
    contactFormButtonOpen.style.display = "block";
});


//# sourceMappingURL=index.1f9f37d2.js.map
